import { T as Vh, c as ds, j as w, G as ib, i as Ml, o as l, s as Uh, a as Gh, e as us, _ as q, b as A, d as Y, f as ab, g as V, h as io, k as sb, r as qh, l as _a, m as lb, D as cb, n as he, p as fe, q as Ii, t as In, u as db, v as co, w as ub, x as Fd, y as uo, z as Sc, C as Kh, A as At, B as ue, E as ge, F as pb, H, I as Pe, J as wo, K as zr, L as hb, M as gt, N as Tc, O as _t, P as Dn, Q as _d, R as fb, S as gb, U as mb, V as wt, W as Ct, X as ua, Y as bb } from "./createSvgIcon-CU4sOtbo.js";
import { Z as eD } from "./createSvgIcon-CU4sOtbo.js";
import * as R from "react";
import hr, { isValidElement as Pa, cloneElement as Ma, Children as xb, createElement as vb, useRef as Ea, useEffect as $a } from "react";
import * as yb from "react-dom";
import pa from "react-dom";
import { useSelected as wb, useFocused as Cb, Slate as kb, Editable as Sb } from "slate-react";
import { Node as Tb, Editor as Ab } from "slate";
function Ob(r) {
  return Object.keys(r).length === 0;
}
function ps(r = null) {
  const e = R.useContext(Vh);
  return !e || Ob(e) ? r : e;
}
const Rb = ds();
function hs(r = Rb) {
  return ps(r);
}
function js(r) {
  const e = Ml(r);
  return r !== e && e.styles ? (e.styles.match(/^@layer\s+[^{]*$/) || (e.styles = `@layer global{${e.styles}}`), e) : r;
}
function Ac({
  styles: r,
  themeId: e,
  defaultTheme: t = {}
}) {
  const n = hs(t), o = e && n[e] || n;
  let i = typeof r == "function" ? r(o) : r;
  return o.modularCssLayers && (Array.isArray(i) ? i = i.map((a) => js(typeof a == "function" ? a(o) : a)) : i = js(i)), /* @__PURE__ */ w.jsx(ib, {
    styles: i
  });
}
process.env.NODE_ENV !== "production" && (Ac.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: l.object,
  /**
   * @ignore
   */
  styles: l.oneOfType([l.array, l.func, l.number, l.object, l.string, l.bool]),
  /**
   * @ignore
   */
  themeId: l.string
});
const Pb = ["className", "component"];
function Mb(r = {}) {
  const {
    themeId: e,
    defaultTheme: t,
    defaultClassName: n = "MuiBox-root",
    generateClassName: o
  } = r, i = Uh("div", {
    shouldForwardProp: (s) => s !== "theme" && s !== "sx" && s !== "as"
  })(Gh);
  return /* @__PURE__ */ R.forwardRef(function(c, d) {
    const u = hs(t), p = us(c), {
      className: h,
      component: f = "div"
    } = p, m = q(p, Pb);
    return /* @__PURE__ */ w.jsx(i, A({
      as: f,
      ref: d,
      className: Y(h, o ? o(n) : n),
      theme: e && u[e] || u
    }, m));
  });
}
const Eb = ["ownerState"], Ib = ["variants"], Nb = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function Lb(r) {
  return Object.keys(r).length === 0;
}
function jb(r) {
  return typeof r == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  r.charCodeAt(0) > 96;
}
function Ds(r) {
  return r !== "ownerState" && r !== "theme" && r !== "sx" && r !== "as";
}
function $d(r, e) {
  return e && r && typeof r == "object" && r.styles && !r.styles.startsWith("@layer") && (r.styles = `@layer ${e}{${String(r.styles)}}`), r;
}
const Db = ds(), Wd = (r) => r && r.charAt(0).toLowerCase() + r.slice(1);
function ha({
  defaultTheme: r,
  theme: e,
  themeId: t
}) {
  return Lb(e) ? r : e[t] || e;
}
function zb(r) {
  return r ? (e, t) => t[r] : null;
}
function Ia(r, e, t) {
  let {
    ownerState: n
  } = e, o = q(e, Eb);
  const i = typeof r == "function" ? r(A({
    ownerState: n
  }, o)) : r;
  if (Array.isArray(i))
    return i.flatMap((a) => Ia(a, A({
      ownerState: n
    }, o), t));
  if (i && typeof i == "object" && Array.isArray(i.variants)) {
    const {
      variants: a = []
    } = i;
    let c = q(i, Ib);
    return a.forEach((d) => {
      let u = !0;
      if (typeof d.props == "function" ? u = d.props(A({
        ownerState: n
      }, o, n)) : Object.keys(d.props).forEach((p) => {
        n?.[p] !== d.props[p] && o[p] !== d.props[p] && (u = !1);
      }), u) {
        Array.isArray(c) || (c = [c]);
        const p = typeof d.style == "function" ? d.style(A({
          ownerState: n
        }, o, n)) : d.style;
        c.push(t ? $d(Ml(p), t) : p);
      }
    }), c;
  }
  return t ? $d(Ml(i), t) : i;
}
function Bb(r = {}) {
  const {
    themeId: e,
    defaultTheme: t = Db,
    rootShouldForwardProp: n = Ds,
    slotShouldForwardProp: o = Ds
  } = r, i = (a) => Gh(A({}, a, {
    theme: ha(A({}, a, {
      defaultTheme: t,
      themeId: e
    }))
  }));
  return i.__mui_systemSx = !0, (a, s = {}) => {
    ab(a, (T) => T.filter((S) => !(S != null && S.__mui_systemSx)));
    const {
      name: c,
      slot: d,
      skipVariantsResolver: u,
      skipSx: p,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: h = zb(Wd(d))
    } = s, f = q(s, Nb), m = c && c.startsWith("Mui") || d ? "components" : "custom", g = u !== void 0 ? u : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      d && d !== "Root" && d !== "root" || !1
    ), b = p || !1;
    let x;
    process.env.NODE_ENV !== "production" && c && (x = `${c}-${Wd(d || "Root")}`);
    let v = Ds;
    d === "Root" || d === "root" ? v = n : d ? v = o : jb(a) && (v = void 0);
    const y = Uh(a, A({
      shouldForwardProp: v,
      label: x
    }, f)), C = (T) => typeof T == "function" && T.__emotion_real !== T || sb(T) ? (S) => {
      const O = ha({
        theme: S.theme,
        defaultTheme: t,
        themeId: e
      });
      return Ia(T, A({}, S, {
        theme: O
      }), O.modularCssLayers ? m : void 0);
    } : T, k = (T, ...S) => {
      let O = C(T);
      const P = S ? S.map(C) : [];
      c && h && P.push((E) => {
        const N = ha(A({}, E, {
          defaultTheme: t,
          themeId: e
        }));
        if (!N.components || !N.components[c] || !N.components[c].styleOverrides)
          return null;
        const L = N.components[c].styleOverrides, z = {};
        return Object.entries(L).forEach(([F, B]) => {
          z[F] = Ia(B, A({}, E, {
            theme: N
          }), N.modularCssLayers ? "theme" : void 0);
        }), h(E, z);
      }), c && !g && P.push((E) => {
        var N;
        const L = ha(A({}, E, {
          defaultTheme: t,
          themeId: e
        })), z = L == null || (N = L.components) == null || (N = N[c]) == null ? void 0 : N.variants;
        return Ia({
          variants: z
        }, A({}, E, {
          theme: L
        }), L.modularCssLayers ? "theme" : void 0);
      }), b || P.push(i);
      const M = P.length - S.length;
      if (Array.isArray(T) && M > 0) {
        const E = new Array(M).fill("");
        O = [...T, ...E], O.raw = [...T.raw, ...E];
      }
      const I = y(O, ...P);
      if (process.env.NODE_ENV !== "production") {
        let E;
        c && (E = `${c}${V(d || "")}`), E === void 0 && (E = `Styled(${io(a)})`), I.displayName = E;
      }
      return a.muiName && (I.muiName = a.muiName), I;
    };
    return y.withConfig && (k.withConfig = y.withConfig), k;
  };
}
const Zh = Bb();
function Jh(r) {
  const {
    theme: e,
    name: t,
    props: n
  } = r;
  return !e || !e.components || !e.components[t] || !e.components[t].defaultProps ? n : qh(e.components[t].defaultProps, n);
}
function Oc({
  props: r,
  name: e,
  defaultTheme: t,
  themeId: n
}) {
  let o = hs(t);
  return n && (o = o[n] || o), Jh({
    theme: o,
    name: e,
    props: r
  });
}
const qt = typeof window < "u" ? R.useLayoutEffect : R.useEffect;
function Fb(r, e, t, n, o) {
  const [i, a] = R.useState(() => o && t ? t(r).matches : n ? n(r).matches : e);
  return qt(() => {
    let s = !0;
    if (!t)
      return;
    const c = t(r), d = () => {
      s && a(c.matches);
    };
    return d(), c.addListener(d), () => {
      s = !1, c.removeListener(d);
    };
  }, [r, t]), i;
}
const Qh = R.useSyncExternalStore;
function _b(r, e, t, n, o) {
  const i = R.useCallback(() => e, [e]), a = R.useMemo(() => {
    if (o && t)
      return () => t(r).matches;
    if (n !== null) {
      const {
        matches: u
      } = n(r);
      return () => u;
    }
    return i;
  }, [i, r, n, o, t]), [s, c] = R.useMemo(() => {
    if (t === null)
      return [i, () => () => {
      }];
    const u = t(r);
    return [() => u.matches, (p) => (u.addListener(p), () => {
      u.removeListener(p);
    })];
  }, [i, t, r]);
  return Qh(c, s, a);
}
function $b(r, e = {}) {
  const t = ps(), n = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: o = !1,
    matchMedia: i = n ? window.matchMedia : null,
    ssrMatchMedia: a = null,
    noSsr: s = !1
  } = Jh({
    name: "MuiUseMediaQuery",
    props: e,
    theme: t
  });
  process.env.NODE_ENV !== "production" && typeof r == "function" && t === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let c = typeof r == "function" ? r(t) : r;
  c = c.replace(/^@media( ?)/m, "");
  const u = (Qh !== void 0 ? _b : Fb)(c, o, i, a, s);
  return process.env.NODE_ENV !== "production" && R.useDebugValue({
    query: c,
    match: u
  }), u;
}
function Wb(r, e = 0, t = 1) {
  return process.env.NODE_ENV !== "production" && (r < e || r > t) && console.error(`MUI: The value provided ${r} is out of range [${e}, ${t}].`), lb(r, e, t);
}
function Hb(r) {
  r = r.slice(1);
  const e = new RegExp(`.{1,${r.length >= 6 ? 2 : 1}}`, "g");
  let t = r.match(e);
  return t && t[0].length === 1 && (t = t.map((n) => n + n)), t ? `rgb${t.length === 4 ? "a" : ""}(${t.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function ef(r) {
  if (r.type)
    return r;
  if (r.charAt(0) === "#")
    return ef(Hb(r));
  const e = r.indexOf("("), t = r.substring(0, e);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(t) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${r}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : _a(9, r));
  let n = r.substring(e + 1, r.length - 1), o;
  if (t === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(o) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : _a(10, o));
  } else
    n = n.split(",");
  return n = n.map((i) => parseFloat(i)), {
    type: t,
    values: n,
    colorSpace: o
  };
}
function Yb(r) {
  const {
    type: e,
    colorSpace: t
  } = r;
  let {
    values: n
  } = r;
  return e.indexOf("rgb") !== -1 ? n = n.map((o, i) => i < 3 ? parseInt(o, 10) : o) : e.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), e.indexOf("color") !== -1 ? n = `${t} ${n.join(" ")}` : n = `${n.join(", ")}`, `${e}(${n})`;
}
function Xb(r, e) {
  return r = ef(r), e = Wb(e), (r.type === "rgb" || r.type === "hsl") && (r.type += "a"), r.type === "color" ? r.values[3] = `/${e}` : r.values[3] = e, Yb(r);
}
function Ft(r, e) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return r(...n) || e(...n);
  };
}
function Vb(r) {
  const {
    prototype: e = {}
  } = r;
  return !!e.isReactComponent;
}
function tf(r, e, t, n, o) {
  const i = r[e], a = o || e;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let s;
  const c = i.type;
  return typeof c == "function" && !Vb(c) && (s = "Did you accidentally use a plain function component for an element instead?"), s !== void 0 ? new Error(`Invalid ${n} \`${a}\` supplied to \`${t}\`. Expected an element that can hold a ref. ${s} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const hn = Ft(l.element, tf);
hn.isRequired = Ft(l.element.isRequired, tf);
function Ub(r) {
  const {
    prototype: e = {}
  } = r;
  return !!e.isReactComponent;
}
function Gb(r, e, t, n, o) {
  const i = r[e], a = o || e;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let s;
  return typeof i == "function" && !Ub(i) && (s = "Did you accidentally provide a plain function component instead?"), s !== void 0 ? new Error(`Invalid ${n} \`${a}\` supplied to \`${t}\`. Expected an element type that can hold a ref. ${s} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Co = Ft(l.elementType, Gb), qb = "exact-prop: ​";
function ko(r) {
  return process.env.NODE_ENV === "production" ? r : A({}, r, {
    [qb]: (e) => {
      const t = Object.keys(e).filter((n) => !r.hasOwnProperty(n));
      return t.length > 0 ? new Error(`The following props are not supported: ${t.map((n) => `\`${n}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function jr(r, e, t, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = r[e], a = o || e;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${n} \`${a}\` supplied to \`${t}\`. Expected an HTMLElement.`) : null;
}
const $t = l.oneOfType([l.func, l.object]);
function Wa(...r) {
  return r.reduce((e, t) => t == null ? e : function(...o) {
    e.apply(this, o), t.apply(this, o);
  }, () => {
  });
}
function So(r, e = 166) {
  let t;
  function n(...o) {
    const i = () => {
      r.apply(this, o);
    };
    clearTimeout(t), t = setTimeout(i, e);
  }
  return n.clear = () => {
    clearTimeout(t);
  }, n;
}
function Kb(r, e) {
  return process.env.NODE_ENV === "production" ? () => null : (t, n, o, i, a) => {
    const s = o || "<<anonymous>>", c = a || n;
    return typeof t[n] < "u" ? new Error(`The ${i} \`${c}\` of \`${s}\` is deprecated. ${e}`) : null;
  };
}
function ao(r, e) {
  var t, n;
  return /* @__PURE__ */ R.isValidElement(r) && e.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (t = r.type.muiName) != null ? t : (n = r.type) == null || (n = n._payload) == null || (n = n.value) == null ? void 0 : n.muiName
  ) !== -1;
}
function Rt(r) {
  return r && r.ownerDocument || document;
}
function br(r) {
  return Rt(r).defaultView || window;
}
function rf(r, e) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const t = e ? A({}, e.propTypes) : null;
  return (o) => (i, a, s, c, d, ...u) => {
    const p = d || a, h = t?.[p];
    if (h) {
      const f = h(i, a, s, c, d, ...u);
      if (f)
        return f;
    }
    return typeof i[a] < "u" && !i[o] ? new Error(`The prop \`${p}\` of \`${r}\` can only be used together with the \`${o}\` prop.`) : null;
  };
}
function Ni(r, e) {
  typeof r == "function" ? r(e) : r && (r.current = e);
}
let Hd = 0;
function Zb(r) {
  const [e, t] = R.useState(r), n = r || e;
  return R.useEffect(() => {
    e == null && (Hd += 1, t(`mui-${Hd}`));
  }, [e]), n;
}
const Yd = R.useId;
function Yr(r) {
  if (Yd !== void 0) {
    const e = Yd();
    return r ?? e;
  }
  return Zb(r);
}
function Rc(r, e, t, n, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = o || e;
  return typeof r[e] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function Rr({
  controlled: r,
  default: e,
  name: t,
  state: n = "value"
}) {
  const {
    current: o
  } = R.useRef(r !== void 0), [i, a] = R.useState(e), s = o ? r : i;
  if (process.env.NODE_ENV !== "production") {
    R.useEffect(() => {
      o !== (r !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${n} state of ${t} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${t} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [n, t, r]);
    const {
      current: d
    } = R.useRef(e);
    R.useEffect(() => {
      !o && !Object.is(d, e) && console.error([`MUI: A component is changing the default ${n} state of an uncontrolled ${t} after being initialized. To suppress this warning opt to use a controlled ${t}.`].join(`
`));
    }, [JSON.stringify(e)]);
  }
  const c = R.useCallback((d) => {
    o || a(d);
  }, []);
  return [s, c];
}
function Lt(r) {
  const e = R.useRef(r);
  return qt(() => {
    e.current = r;
  }), R.useRef((...t) => (
    // @ts-expect-error hide `this`
    (0, e.current)(...t)
  )).current;
}
function ut(...r) {
  return R.useMemo(() => r.every((e) => e == null) ? null : (e) => {
    r.forEach((t) => {
      Ni(t, e);
    });
  }, r);
}
const Xd = {};
function Jb(r, e) {
  const t = R.useRef(Xd);
  return t.current === Xd && (t.current = r(e)), t;
}
const Qb = [];
function ex(r) {
  R.useEffect(r, Qb);
}
class qi {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new qi();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(e, t) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, t();
    }, e);
  }
}
function On() {
  const r = Jb(qi.create).current;
  return ex(r.disposeEffect), r;
}
let fs = !0, El = !1;
const tx = new qi(), rx = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function nx(r) {
  const {
    type: e,
    tagName: t
  } = r;
  return !!(t === "INPUT" && rx[e] && !r.readOnly || t === "TEXTAREA" && !r.readOnly || r.isContentEditable);
}
function ox(r) {
  r.metaKey || r.altKey || r.ctrlKey || (fs = !0);
}
function zs() {
  fs = !1;
}
function ix() {
  this.visibilityState === "hidden" && El && (fs = !0);
}
function ax(r) {
  r.addEventListener("keydown", ox, !0), r.addEventListener("mousedown", zs, !0), r.addEventListener("pointerdown", zs, !0), r.addEventListener("touchstart", zs, !0), r.addEventListener("visibilitychange", ix, !0);
}
function sx(r) {
  const {
    target: e
  } = r;
  try {
    return e.matches(":focus-visible");
  } catch {
  }
  return fs || nx(e);
}
function gs() {
  const r = R.useCallback((o) => {
    o != null && ax(o.ownerDocument);
  }, []), e = R.useRef(!1);
  function t() {
    return e.current ? (El = !0, tx.start(100, () => {
      El = !1;
    }), e.current = !1, !0) : !1;
  }
  function n(o) {
    return sx(o) ? (e.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: e,
    onFocus: n,
    onBlur: t,
    ref: r
  };
}
function nf(r) {
  const e = r.documentElement.clientWidth;
  return Math.abs(window.innerWidth - e);
}
let Xn;
function of() {
  if (Xn)
    return Xn;
  const r = document.createElement("div"), e = document.createElement("div");
  return e.style.width = "10px", e.style.height = "1px", r.appendChild(e), r.dir = "rtl", r.style.fontSize = "14px", r.style.width = "4px", r.style.height = "1px", r.style.position = "absolute", r.style.top = "-1000px", r.style.overflow = "scroll", document.body.appendChild(r), Xn = "reverse", r.scrollLeft > 0 ? Xn = "default" : (r.scrollLeft = 1, r.scrollLeft === 0 && (Xn = "negative")), document.body.removeChild(r), Xn;
}
function lx(r, e) {
  const t = r.scrollLeft;
  if (e !== "rtl")
    return t;
  switch (of()) {
    case "negative":
      return r.scrollWidth - r.clientWidth + t;
    case "reverse":
      return r.scrollWidth - r.clientWidth - t;
    default:
      return t;
  }
}
const Pc = (r) => {
  const e = R.useRef({});
  return R.useEffect(() => {
    e.current = r;
  }), e.current;
};
function cx(r) {
  const e = typeof r;
  switch (e) {
    case "number":
      return Number.isNaN(r) ? "NaN" : Number.isFinite(r) ? r !== Math.floor(r) ? "float" : "number" : "Infinity";
    case "object":
      return r === null ? "null" : r.constructor.name;
    default:
      return e;
  }
}
function dx(r) {
  return typeof r == "number" && isFinite(r) && Math.floor(r) === r;
}
const ux = Number.isInteger || dx;
function af(r, e, t, n) {
  const o = r[e];
  if (o == null || !ux(o)) {
    const i = cx(o);
    return new RangeError(`Invalid ${n} \`${e}\` of type \`${i}\` supplied to \`${t}\`, expected \`integer\`.`);
  }
  return null;
}
function sf(r, e, ...t) {
  return r[e] === void 0 ? null : af(r, e, ...t);
}
function Il() {
  return null;
}
sf.isRequired = af;
Il.isRequired = Il;
const Ut = process.env.NODE_ENV === "production" ? Il : sf;
function zn(r) {
  return typeof r == "string";
}
function to(r, e, t) {
  return r === void 0 || zn(r) ? e : A({}, e, {
    ownerState: A({}, e.ownerState, t)
  });
}
function lf(r, e = []) {
  if (r === void 0)
    return {};
  const t = {};
  return Object.keys(r).filter((n) => n.match(/^on[A-Z]/) && typeof r[n] == "function" && !e.includes(n)).forEach((n) => {
    t[n] = r[n];
  }), t;
}
function Vd(r) {
  if (r === void 0)
    return {};
  const e = {};
  return Object.keys(r).filter((t) => !(t.match(/^on[A-Z]/) && typeof r[t] == "function")).forEach((t) => {
    e[t] = r[t];
  }), e;
}
function cf(r) {
  const {
    getSlotProps: e,
    additionalProps: t,
    externalSlotProps: n,
    externalForwardedProps: o,
    className: i
  } = r;
  if (!e) {
    const f = Y(t?.className, i, o?.className, n?.className), m = A({}, t?.style, o?.style, n?.style), g = A({}, t, o, n);
    return f.length > 0 && (g.className = f), Object.keys(m).length > 0 && (g.style = m), {
      props: g,
      internalRef: void 0
    };
  }
  const a = lf(A({}, o, n)), s = Vd(n), c = Vd(o), d = e(a), u = Y(d?.className, t?.className, i, o?.className, n?.className), p = A({}, d?.style, t?.style, o?.style, n?.style), h = A({}, d, t, c, s);
  return u.length > 0 && (h.className = u), Object.keys(p).length > 0 && (h.style = p), {
    props: h,
    internalRef: d.ref
  };
}
function df(r, e, t) {
  return typeof r == "function" ? r(e, t) : r;
}
const px = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function tr(r) {
  var e;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: o,
    skipResolvingSlotProps: i = !1
  } = r, a = q(r, px), s = i ? {} : df(n, o), {
    props: c,
    internalRef: d
  } = cf(A({}, a, {
    externalSlotProps: s
  })), u = ut(d, s?.ref, (e = r.additionalProps) == null ? void 0 : e.ref);
  return to(t, A({}, c, {
    ref: u
  }), o);
}
function fn(r) {
  if (parseInt(R.version, 10) >= 19) {
    var e;
    return (r == null || (e = r.props) == null ? void 0 : e.ref) || null;
  }
  return r?.ref || null;
}
const Mc = /* @__PURE__ */ R.createContext(null);
process.env.NODE_ENV !== "production" && (Mc.displayName = "ThemeContext");
function Ec() {
  const r = R.useContext(Mc);
  return process.env.NODE_ENV !== "production" && R.useDebugValue(r), r;
}
const hx = typeof Symbol == "function" && Symbol.for, uf = hx ? /* @__PURE__ */ Symbol.for("mui.nested") : "__THEME_NESTED__";
function fx(r, e) {
  if (typeof e == "function") {
    const t = e(r);
    return process.env.NODE_ENV !== "production" && (t || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), t;
  }
  return A({}, r, e);
}
function Ha(r) {
  const {
    children: e,
    theme: t
  } = r, n = Ec();
  process.env.NODE_ENV !== "production" && n === null && typeof t == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const o = R.useMemo(() => {
    const i = n === null ? t : fx(n, t);
    return i != null && (i[uf] = n !== null), i;
  }, [t, n]);
  return /* @__PURE__ */ w.jsx(Mc.Provider, {
    value: o,
    children: e
  });
}
process.env.NODE_ENV !== "production" && (Ha.propTypes = {
  /**
   * Your component tree.
   */
  children: l.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: l.oneOfType([l.object, l.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Ha.propTypes = ko(Ha.propTypes));
const gx = ["value"], pf = /* @__PURE__ */ R.createContext();
function hf(r) {
  let {
    value: e
  } = r, t = q(r, gx);
  return /* @__PURE__ */ w.jsx(pf.Provider, A({
    value: e ?? !0
  }, t));
}
process.env.NODE_ENV !== "production" && (hf.propTypes = {
  children: l.node,
  value: l.bool
});
const gn = () => {
  const r = R.useContext(pf);
  return r ?? !1;
};
function mx(r) {
  const e = ps(), t = Yr() || "", {
    modularCssLayers: n
  } = r;
  let o = "mui.global, mui.components, mui.theme, mui.custom, mui.sx";
  return !n || e !== null ? o = "" : typeof n == "string" ? o = n.replace(/mui(?!\.)/g, o) : o = `@layer ${o};`, qt(() => {
    const i = document.querySelector("head");
    if (!i)
      return;
    const a = i.firstChild;
    if (o) {
      var s;
      if (a && (s = a.hasAttribute) != null && s.call(a, "data-mui-layer-order") && a.getAttribute("data-mui-layer-order") === t)
        return;
      const d = document.createElement("style");
      d.setAttribute("data-mui-layer-order", t), d.textContent = o, i.prepend(d);
    } else {
      var c;
      (c = i.querySelector(`style[data-mui-layer-order="${t}"]`)) == null || c.remove();
    }
  }, [o, t]), o ? /* @__PURE__ */ w.jsx(Ac, {
    styles: o
  }) : null;
}
const Ud = {};
function Gd(r, e, t, n = !1) {
  return R.useMemo(() => {
    const o = r && e[r] || e;
    if (typeof t == "function") {
      const i = t(o), a = r ? A({}, e, {
        [r]: i
      }) : i;
      return n ? () => a : a;
    }
    return r ? A({}, e, {
      [r]: t
    }) : A({}, e, t);
  }, [r, e, t, n]);
}
function Ya(r) {
  const {
    children: e,
    theme: t,
    themeId: n
  } = r, o = ps(Ud), i = Ec() || Ud;
  process.env.NODE_ENV !== "production" && (o === null && typeof t == "function" || n && o && !o[n] && typeof t == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const a = Gd(n, o, t), s = Gd(n, i, t, !0), c = a.direction === "rtl", d = mx(a);
  return /* @__PURE__ */ w.jsx(Ha, {
    theme: s,
    children: /* @__PURE__ */ w.jsx(Vh.Provider, {
      value: a,
      children: /* @__PURE__ */ w.jsx(hf, {
        value: c,
        children: /* @__PURE__ */ w.jsxs(cb, {
          value: a?.components,
          children: [d, e]
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (Ya.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: l.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: l.oneOfType([l.func, l.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: l.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Ya.propTypes = ko(Ya.propTypes));
function Li(r) {
  "@babel/helpers - typeof";
  return Li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Li(r);
}
function bx(r, e) {
  if (Li(r) != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (Li(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
function xx(r) {
  var e = bx(r, "string");
  return Li(e) == "symbol" ? e : e + "";
}
const vx = ["className", "component", "disableGutters", "fixed", "maxWidth", "classes"], yx = ds(), wx = Zh("div", {
  name: "MuiContainer",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[`maxWidth${V(String(t.maxWidth))}`], t.fixed && e.fixed, t.disableGutters && e.disableGutters];
  }
}), Cx = (r) => Oc({
  props: r,
  name: "MuiContainer",
  defaultTheme: yx
}), kx = (r, e) => {
  const t = (c) => fe(e, c), {
    classes: n,
    fixed: o,
    disableGutters: i,
    maxWidth: a
  } = r, s = {
    root: ["root", a && `maxWidth${V(String(a))}`, o && "fixed", i && "disableGutters"]
  };
  return he(s, t, n);
};
function Sx(r = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: e = wx,
    useThemeProps: t = Cx,
    componentName: n = "MuiContainer"
  } = r, o = e(({
    theme: a,
    ownerState: s
  }) => A({
    width: "100%",
    marginLeft: "auto",
    boxSizing: "border-box",
    marginRight: "auto",
    display: "block"
  }, !s.disableGutters && {
    paddingLeft: a.spacing(2),
    paddingRight: a.spacing(2),
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [a.breakpoints.up("sm")]: {
      paddingLeft: a.spacing(3),
      paddingRight: a.spacing(3)
    }
  }), ({
    theme: a,
    ownerState: s
  }) => s.fixed && Object.keys(a.breakpoints.values).reduce((c, d) => {
    const u = d, p = a.breakpoints.values[u];
    return p !== 0 && (c[a.breakpoints.up(u)] = {
      maxWidth: `${p}${a.breakpoints.unit}`
    }), c;
  }, {}), ({
    theme: a,
    ownerState: s
  }) => A({}, s.maxWidth === "xs" && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [a.breakpoints.up("xs")]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: Math.max(a.breakpoints.values.xs, 444)
    }
  }, s.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
  s.maxWidth !== "xs" && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [a.breakpoints.up(s.maxWidth)]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: `${a.breakpoints.values[s.maxWidth]}${a.breakpoints.unit}`
    }
  })), i = /* @__PURE__ */ R.forwardRef(function(s, c) {
    const d = t(s), {
      className: u,
      component: p = "div",
      disableGutters: h = !1,
      fixed: f = !1,
      maxWidth: m = "lg"
    } = d, g = q(d, vx), b = A({}, d, {
      component: p,
      disableGutters: h,
      fixed: f,
      maxWidth: m
    }), x = kx(b, n);
    return (
      // @ts-ignore theme is injected by the styled util
      /* @__PURE__ */ w.jsx(o, A({
        as: p,
        ownerState: b,
        className: Y(x.root, u),
        ref: c
      }, g))
    );
  });
  return process.env.NODE_ENV !== "production" && (i.propTypes = {
    children: l.node,
    classes: l.object,
    className: l.string,
    component: l.elementType,
    disableGutters: l.bool,
    fixed: l.bool,
    maxWidth: l.oneOfType([l.oneOf(["xs", "sm", "md", "lg", "xl", !1]), l.string]),
    sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
  }), i;
}
const Tx = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], Ax = ds(), Ox = Zh("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (r, e) => e.root
});
function Rx(r) {
  return Oc({
    props: r,
    name: "MuiStack",
    defaultTheme: Ax
  });
}
function Px(r, e) {
  const t = R.Children.toArray(r).filter(Boolean);
  return t.reduce((n, o, i) => (n.push(o), i < t.length - 1 && n.push(/* @__PURE__ */ R.cloneElement(e, {
    key: `separator-${i}`
  })), n), []);
}
const Mx = (r) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[r], Ex = ({
  ownerState: r,
  theme: e
}) => {
  let t = A({
    display: "flex",
    flexDirection: "column"
  }, Ii({
    theme: e
  }, In({
    values: r.direction,
    breakpoints: e.breakpoints.values
  }), (n) => ({
    flexDirection: n
  })));
  if (r.spacing) {
    const n = db(e), o = Object.keys(e.breakpoints.values).reduce((c, d) => ((typeof r.spacing == "object" && r.spacing[d] != null || typeof r.direction == "object" && r.direction[d] != null) && (c[d] = !0), c), {}), i = In({
      values: r.direction,
      base: o
    }), a = In({
      values: r.spacing,
      base: o
    });
    typeof i == "object" && Object.keys(i).forEach((c, d, u) => {
      if (!i[c]) {
        const h = d > 0 ? i[u[d - 1]] : "column";
        i[c] = h;
      }
    }), t = co(t, Ii({
      theme: e
    }, a, (c, d) => r.useFlexGap ? {
      gap: Fd(n, c)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${Mx(d ? i[d] : r.direction)}`]: Fd(n, c)
      }
    }));
  }
  return t = ub(e.breakpoints, t), t;
};
function Ix(r = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: e = Ox,
    useThemeProps: t = Rx,
    componentName: n = "MuiStack"
  } = r, o = () => he({
    root: ["root"]
  }, (c) => fe(n, c), {}), i = e(Ex), a = /* @__PURE__ */ R.forwardRef(function(c, d) {
    const u = t(c), p = us(u), {
      component: h = "div",
      direction: f = "column",
      spacing: m = 0,
      divider: g,
      children: b,
      className: x,
      useFlexGap: v = !1
    } = p, y = q(p, Tx), C = {
      direction: f,
      spacing: m,
      useFlexGap: v
    }, k = o();
    return /* @__PURE__ */ w.jsx(i, A({
      as: h,
      ownerState: C,
      ref: d,
      className: Y(k.root, x)
    }, y, {
      children: g ? Px(b, g) : b
    }));
  });
  return process.env.NODE_ENV !== "production" && (a.propTypes = {
    children: l.node,
    direction: l.oneOfType([l.oneOf(["column-reverse", "column", "row-reverse", "row"]), l.arrayOf(l.oneOf(["column-reverse", "column", "row-reverse", "row"])), l.object]),
    divider: l.node,
    spacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
    sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
  }), a;
}
function Nx(r) {
  return String(r).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function Lx(r) {
  return parseFloat(r);
}
function yr() {
  const r = hs(Sc);
  return process.env.NODE_ENV !== "production" && R.useDebugValue(r), r[uo] || r;
}
function jx({
  props: r,
  name: e
}) {
  return Oc({
    props: r,
    name: e,
    defaultTheme: Sc,
    themeId: uo
  });
}
const Dx = ["theme"];
function zx(r) {
  let {
    theme: e
  } = r, t = q(r, Dx);
  const n = e[uo];
  let o = n || e;
  return typeof e != "function" && (n && !n.vars ? o = A({}, n, {
    vars: null
  }) : e && !e.vars && (o = A({}, e, {
    vars: null
  }))), /* @__PURE__ */ w.jsx(Ya, A({}, t, {
    themeId: n ? uo : void 0,
    theme: o
  }));
}
process.env.NODE_ENV !== "production" && (zx.propTypes = {
  /**
   * Your component tree.
   */
  children: l.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: l.oneOfType([l.object, l.func]).isRequired
});
const qd = (r) => {
  let e;
  return r < 1 ? e = 5.11916 * r ** 2 : e = 4.5 * Math.log(r + 1) + 2, (e / 100).toFixed(2);
}, Bx = {
  configure: (r) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), Kh.configure(r);
  }
}, Fx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: V,
  createChainedFunction: Wa,
  createSvgIcon: At,
  debounce: So,
  deprecatedPropType: Kb,
  isMuiElement: ao,
  ownerDocument: Rt,
  ownerWindow: br,
  requirePropFactory: rf,
  setRef: Ni,
  unstable_ClassNameGenerator: Bx,
  unstable_useEnhancedEffect: qt,
  unstable_useId: Yr,
  unsupportedProp: Rc,
  useControlled: Rr,
  useEventCallback: Lt,
  useForkRef: ut,
  useIsFocusVisible: gs
}, Symbol.toStringTag, { value: "Module" }));
function Nl(r, e) {
  return Nl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, Nl(r, e);
}
function ms(r, e) {
  r.prototype = Object.create(e.prototype), r.prototype.constructor = r, Nl(r, e);
}
const Kd = {
  disabled: !1
};
var _x = process.env.NODE_ENV !== "production" ? l.oneOfType([l.number, l.shape({
  enter: l.number,
  exit: l.number,
  appear: l.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && l.oneOfType([l.string, l.shape({
  enter: l.string,
  exit: l.string,
  active: l.string
}), l.shape({
  enter: l.string,
  enterDone: l.string,
  enterActive: l.string,
  exit: l.string,
  exitDone: l.string,
  exitActive: l.string
})]);
const Xa = hr.createContext(null);
var $x = function(e) {
  return e.scrollTop;
}, mi = "unmounted", vn = "exited", yn = "entering", Qn = "entered", Ll = "exiting", wr = /* @__PURE__ */ (function(r) {
  ms(e, r);
  function e(n, o) {
    var i;
    i = r.call(this, n, o) || this;
    var a = o, s = a && !a.isMounting ? n.enter : n.appear, c;
    return i.appearStatus = null, n.in ? s ? (c = vn, i.appearStatus = yn) : c = Qn : n.unmountOnExit || n.mountOnEnter ? c = mi : c = vn, i.state = {
      status: c
    }, i.nextCallback = null, i;
  }
  e.getDerivedStateFromProps = function(o, i) {
    var a = o.in;
    return a && i.status === mi ? {
      status: vn
    } : null;
  };
  var t = e.prototype;
  return t.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, t.componentDidUpdate = function(o) {
    var i = null;
    if (o !== this.props) {
      var a = this.state.status;
      this.props.in ? a !== yn && a !== Qn && (i = yn) : (a === yn || a === Qn) && (i = Ll);
    }
    this.updateStatus(!1, i);
  }, t.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, t.getTimeouts = function() {
    var o = this.props.timeout, i, a, s;
    return i = a = s = o, o != null && typeof o != "number" && (i = o.exit, a = o.enter, s = o.appear !== void 0 ? o.appear : a), {
      exit: i,
      enter: a,
      appear: s
    };
  }, t.updateStatus = function(o, i) {
    if (o === void 0 && (o = !1), i !== null)
      if (this.cancelNextCallback(), i === yn) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var a = this.props.nodeRef ? this.props.nodeRef.current : pa.findDOMNode(this);
          a && $x(a);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === vn && this.setState({
      status: mi
    });
  }, t.performEnter = function(o) {
    var i = this, a = this.props.enter, s = this.context ? this.context.isMounting : o, c = this.props.nodeRef ? [s] : [pa.findDOMNode(this), s], d = c[0], u = c[1], p = this.getTimeouts(), h = s ? p.appear : p.enter;
    if (!o && !a || Kd.disabled) {
      this.safeSetState({
        status: Qn
      }, function() {
        i.props.onEntered(d);
      });
      return;
    }
    this.props.onEnter(d, u), this.safeSetState({
      status: yn
    }, function() {
      i.props.onEntering(d, u), i.onTransitionEnd(h, function() {
        i.safeSetState({
          status: Qn
        }, function() {
          i.props.onEntered(d, u);
        });
      });
    });
  }, t.performExit = function() {
    var o = this, i = this.props.exit, a = this.getTimeouts(), s = this.props.nodeRef ? void 0 : pa.findDOMNode(this);
    if (!i || Kd.disabled) {
      this.safeSetState({
        status: vn
      }, function() {
        o.props.onExited(s);
      });
      return;
    }
    this.props.onExit(s), this.safeSetState({
      status: Ll
    }, function() {
      o.props.onExiting(s), o.onTransitionEnd(a.exit, function() {
        o.safeSetState({
          status: vn
        }, function() {
          o.props.onExited(s);
        });
      });
    });
  }, t.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, t.safeSetState = function(o, i) {
    i = this.setNextCallback(i), this.setState(o, i);
  }, t.setNextCallback = function(o) {
    var i = this, a = !0;
    return this.nextCallback = function(s) {
      a && (a = !1, i.nextCallback = null, o(s));
    }, this.nextCallback.cancel = function() {
      a = !1;
    }, this.nextCallback;
  }, t.onTransitionEnd = function(o, i) {
    this.setNextCallback(i);
    var a = this.props.nodeRef ? this.props.nodeRef.current : pa.findDOMNode(this), s = o == null && !this.props.addEndListener;
    if (!a || s) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var c = this.props.nodeRef ? [this.nextCallback] : [a, this.nextCallback], d = c[0], u = c[1];
      this.props.addEndListener(d, u);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, t.render = function() {
    var o = this.state.status;
    if (o === mi)
      return null;
    var i = this.props, a = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var s = q(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ hr.createElement(Xa.Provider, {
        value: null
      }, typeof a == "function" ? a(o, s) : hr.cloneElement(hr.Children.only(a), s))
    );
  }, e;
})(hr.Component);
wr.contextType = Xa;
wr.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: l.shape({
    current: typeof Element > "u" ? l.any : function(r, e, t, n, o, i) {
      var a = r[e];
      return l.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(r, e, t, n, o, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: l.oneOfType([l.func.isRequired, l.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: l.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: l.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: l.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: l.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: l.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: l.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(e) {
    var t = _x;
    e.addEndListener || (t = t.isRequired);
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      o[i - 1] = arguments[i];
    return t.apply(void 0, [e].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: l.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: l.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: l.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: l.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: l.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: l.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: l.func
} : {};
function Vn() {
}
wr.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Vn,
  onEntering: Vn,
  onEntered: Vn,
  onExit: Vn,
  onExiting: Vn,
  onExited: Vn
};
wr.UNMOUNTED = mi;
wr.EXITED = vn;
wr.ENTERING = yn;
wr.ENTERED = Qn;
wr.EXITING = Ll;
function jl(r) {
  if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Ic(r, e) {
  var t = function(i) {
    return e && Pa(i) ? e(i) : i;
  }, n = /* @__PURE__ */ Object.create(null);
  return r && xb.map(r, function(o) {
    return o;
  }).forEach(function(o) {
    n[o.key] = t(o);
  }), n;
}
function Wx(r, e) {
  r = r || {}, e = e || {};
  function t(u) {
    return u in e ? e[u] : r[u];
  }
  var n = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in r)
    i in e ? o.length && (n[i] = o, o = []) : o.push(i);
  var a, s = {};
  for (var c in e) {
    if (n[c])
      for (a = 0; a < n[c].length; a++) {
        var d = n[c][a];
        s[n[c][a]] = t(d);
      }
    s[c] = t(c);
  }
  for (a = 0; a < o.length; a++)
    s[o[a]] = t(o[a]);
  return s;
}
function Rn(r, e, t) {
  return t[e] != null ? t[e] : r.props[e];
}
function Hx(r, e) {
  return Ic(r.children, function(t) {
    return Ma(t, {
      onExited: e.bind(null, t),
      in: !0,
      appear: Rn(t, "appear", r),
      enter: Rn(t, "enter", r),
      exit: Rn(t, "exit", r)
    });
  });
}
function Yx(r, e, t) {
  var n = Ic(r.children), o = Wx(e, n);
  return Object.keys(o).forEach(function(i) {
    var a = o[i];
    if (Pa(a)) {
      var s = i in e, c = i in n, d = e[i], u = Pa(d) && !d.props.in;
      c && (!s || u) ? o[i] = Ma(a, {
        onExited: t.bind(null, a),
        in: !0,
        exit: Rn(a, "exit", r),
        enter: Rn(a, "enter", r)
      }) : !c && s && !u ? o[i] = Ma(a, {
        in: !1
      }) : c && s && Pa(d) && (o[i] = Ma(a, {
        onExited: t.bind(null, a),
        in: d.props.in,
        exit: Rn(a, "exit", r),
        enter: Rn(a, "enter", r)
      }));
    }
  }), o;
}
var Xx = Object.values || function(r) {
  return Object.keys(r).map(function(e) {
    return r[e];
  });
}, Vx = {
  component: "div",
  childFactory: function(e) {
    return e;
  }
}, Nc = /* @__PURE__ */ (function(r) {
  ms(e, r);
  function e(n, o) {
    var i;
    i = r.call(this, n, o) || this;
    var a = i.handleExited.bind(jl(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, i;
  }
  var t = e.prototype;
  return t.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, t.componentWillUnmount = function() {
    this.mounted = !1;
  }, e.getDerivedStateFromProps = function(o, i) {
    var a = i.children, s = i.handleExited, c = i.firstRender;
    return {
      children: c ? Hx(o, s) : Yx(o, a, s),
      firstRender: !1
    };
  }, t.handleExited = function(o, i) {
    var a = Ic(this.props.children);
    o.key in a || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(s) {
      var c = A({}, s.children);
      return delete c[o.key], {
        children: c
      };
    }));
  }, t.render = function() {
    var o = this.props, i = o.component, a = o.childFactory, s = q(o, ["component", "childFactory"]), c = this.state.contextValue, d = Xx(this.state.children).map(a);
    return delete s.appear, delete s.enter, delete s.exit, i === null ? /* @__PURE__ */ hr.createElement(Xa.Provider, {
      value: c
    }, d) : /* @__PURE__ */ hr.createElement(Xa.Provider, {
      value: c
    }, /* @__PURE__ */ hr.createElement(i, s, d));
  }, e;
})(hr.Component);
Nc.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: l.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: l.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: l.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: l.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: l.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: l.func
} : {};
Nc.defaultProps = Vx;
const Lc = (r) => r.scrollTop;
function ln(r, e) {
  var t, n;
  const {
    timeout: o,
    easing: i,
    style: a = {}
  } = r;
  return {
    duration: (t = a.transitionDuration) != null ? t : typeof o == "number" ? o : o[e.mode] || 0,
    easing: (n = a.transitionTimingFunction) != null ? n : typeof i == "object" ? i[e.mode] : i,
    delay: a.transitionDelay
  };
}
function Ux(r) {
  return fe("MuiCollapse", r);
}
ue("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const Gx = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], qx = (r) => {
  const {
    orientation: e,
    classes: t
  } = r, n = {
    root: ["root", `${e}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${e}`],
    wrapperInner: ["wrapperInner", `${e}`]
  };
  return he(n, Ux, t);
}, Kx = H("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[t.orientation], t.state === "entered" && e.entered, t.state === "exited" && !t.in && t.collapsedSize === "0px" && e.hidden];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  height: 0,
  overflow: "hidden",
  transition: r.transitions.create("height")
}, e.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: r.transitions.create("width")
}, e.state === "entered" && A({
  height: "auto",
  overflow: "visible"
}, e.orientation === "horizontal" && {
  width: "auto"
}), e.state === "exited" && !e.in && e.collapsedSize === "0px" && {
  visibility: "hidden"
})), Zx = H("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (r, e) => e.wrapper
})(({
  ownerState: r
}) => A({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, r.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), Jx = H("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (r, e) => e.wrapperInner
})(({
  ownerState: r
}) => A({
  width: "100%"
}, r.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), jc = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiCollapse"
  }), {
    addEndListener: o,
    children: i,
    className: a,
    collapsedSize: s = "0px",
    component: c,
    easing: d,
    in: u,
    onEnter: p,
    onEntered: h,
    onEntering: f,
    onExit: m,
    onExited: g,
    onExiting: b,
    orientation: x = "vertical",
    style: v,
    timeout: y = pb.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: C = wr
  } = n, k = q(n, Gx), T = A({}, n, {
    orientation: x,
    collapsedSize: s
  }), S = qx(T), O = yr(), P = On(), M = R.useRef(null), I = R.useRef(), E = typeof s == "number" ? `${s}px` : s, N = x === "horizontal", L = N ? "width" : "height", z = R.useRef(null), F = ut(t, z), B = (K) => (le) => {
    if (K) {
      const Q = z.current;
      le === void 0 ? K(Q) : K(Q, le);
    }
  }, D = () => M.current ? M.current[N ? "clientWidth" : "clientHeight"] : 0, W = B((K, le) => {
    M.current && N && (M.current.style.position = "absolute"), K.style[L] = E, p && p(K, le);
  }), G = B((K, le) => {
    const Q = D();
    M.current && N && (M.current.style.position = "");
    const {
      duration: se,
      easing: Re
    } = ln({
      style: v,
      timeout: y,
      easing: d
    }, {
      mode: "enter"
    });
    if (y === "auto") {
      const be = O.transitions.getAutoHeightDuration(Q);
      K.style.transitionDuration = `${be}ms`, I.current = be;
    } else
      K.style.transitionDuration = typeof se == "string" ? se : `${se}ms`;
    K.style[L] = `${Q}px`, K.style.transitionTimingFunction = Re, f && f(K, le);
  }), re = B((K, le) => {
    K.style[L] = "auto", h && h(K, le);
  }), ce = B((K) => {
    K.style[L] = `${D()}px`, m && m(K);
  }), Ce = B(g), ne = B((K) => {
    const le = D(), {
      duration: Q,
      easing: se
    } = ln({
      style: v,
      timeout: y,
      easing: d
    }, {
      mode: "exit"
    });
    if (y === "auto") {
      const Re = O.transitions.getAutoHeightDuration(le);
      K.style.transitionDuration = `${Re}ms`, I.current = Re;
    } else
      K.style.transitionDuration = typeof Q == "string" ? Q : `${Q}ms`;
    K.style[L] = E, K.style.transitionTimingFunction = se, b && b(K);
  }), pe = (K) => {
    y === "auto" && P.start(I.current || 0, K), o && o(z.current, K);
  };
  return /* @__PURE__ */ w.jsx(C, A({
    in: u,
    onEnter: W,
    onEntered: re,
    onEntering: G,
    onExit: ce,
    onExited: Ce,
    onExiting: ne,
    addEndListener: pe,
    nodeRef: z,
    timeout: y === "auto" ? null : y
  }, k, {
    children: (K, le) => /* @__PURE__ */ w.jsx(Kx, A({
      as: c,
      className: Y(S.root, a, {
        entered: S.entered,
        exited: !u && E === "0px" && S.hidden
      }[K]),
      style: A({
        [N ? "minWidth" : "minHeight"]: E
      }, v),
      ref: F
    }, le, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: A({}, T, {
        state: K
      }),
      children: /* @__PURE__ */ w.jsx(Zx, {
        ownerState: A({}, T, {
          state: K
        }),
        className: S.wrapper,
        ref: M,
        children: /* @__PURE__ */ w.jsx(Jx, {
          ownerState: A({}, T, {
            state: K
          }),
          className: S.wrapperInner,
          children: i
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (jc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: l.func,
  /**
   * The content node to be collapsed.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: l.oneOfType([l.number, l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Co,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: l.oneOfType([l.shape({
    enter: l.string,
    exit: l.string
  }), l.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: l.bool,
  /**
   * @ignore
   */
  onEnter: l.func,
  /**
   * @ignore
   */
  onEntered: l.func,
  /**
   * @ignore
   */
  onEntering: l.func,
  /**
   * @ignore
   */
  onExit: l.func,
  /**
   * @ignore
   */
  onExited: l.func,
  /**
   * @ignore
   */
  onExiting: l.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
jc.muiSupportAuto = !0;
function Qx(r) {
  return fe("MuiPaper", r);
}
ue("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const ev = ["className", "component", "elevation", "square", "variant"], tv = (r) => {
  const {
    square: e,
    elevation: t,
    variant: n,
    classes: o
  } = r, i = {
    root: ["root", n, !e && "rounded", n === "elevation" && `elevation${t}`]
  };
  return he(i, Qx, o);
}, rv = H("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[t.variant], !t.square && e.rounded, t.variant === "elevation" && e[`elevation${t.elevation}`]];
  }
})(({
  theme: r,
  ownerState: e
}) => {
  var t;
  return A({
    backgroundColor: (r.vars || r).palette.background.paper,
    color: (r.vars || r).palette.text.primary,
    transition: r.transitions.create("box-shadow")
  }, !e.square && {
    borderRadius: r.shape.borderRadius
  }, e.variant === "outlined" && {
    border: `1px solid ${(r.vars || r).palette.divider}`
  }, e.variant === "elevation" && A({
    boxShadow: (r.vars || r).shadows[e.elevation]
  }, !r.vars && r.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${Pe.alpha("#fff", qd(e.elevation))}, ${Pe.alpha("#fff", qd(e.elevation))})`
  }, r.vars && {
    backgroundImage: (t = r.vars.overlays) == null ? void 0 : t[e.elevation]
  }));
}), Wt = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiPaper"
  }), {
    className: o,
    component: i = "div",
    elevation: a = 1,
    square: s = !1,
    variant: c = "elevation"
  } = n, d = q(n, ev), u = A({}, n, {
    component: i,
    elevation: a,
    square: s,
    variant: c
  }), p = tv(u);
  return process.env.NODE_ENV !== "production" && yr().shadows[a] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${a}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${a}]\` is defined.`].join(`
`)), /* @__PURE__ */ w.jsx(rv, A({
    as: i,
    ownerState: u,
    className: Y(p.root, o),
    ref: t
  }, d));
});
process.env.NODE_ENV !== "production" && (Wt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: Ft(Ut, (r) => {
    const {
      elevation: e,
      variant: t
    } = r;
    return e > 0 && t === "outlined" ? new Error(`MUI: Combining \`elevation={${e}}\` with \`variant="${t}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: l.oneOfType([l.oneOf(["elevation", "outlined"]), l.string])
});
const Dc = /* @__PURE__ */ R.createContext({});
process.env.NODE_ENV !== "production" && (Dc.displayName = "AccordionContext");
const nv = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"], ov = ["component", "slots", "slotProps"], iv = ["component"];
function Va(r, e) {
  const {
    className: t,
    elementType: n,
    ownerState: o,
    externalForwardedProps: i,
    getSlotOwnerState: a,
    internalForwardedProps: s
  } = e, c = q(e, nv), {
    component: d,
    slots: u = {
      [r]: void 0
    },
    slotProps: p = {
      [r]: void 0
    }
  } = i, h = q(i, ov), f = u[r] || n, m = df(p[r], o), g = cf(A({
    className: t
  }, c, {
    externalForwardedProps: r === "root" ? h : void 0,
    externalSlotProps: m
  })), {
    props: {
      component: b
    },
    internalRef: x
  } = g, v = q(g.props, iv), y = ut(x, m?.ref, e.ref), C = a ? a(v) : {}, k = A({}, o, C), T = r === "root" ? b || d : b, S = to(f, A({}, r === "root" && !d && !u[r] && s, r !== "root" && !u[r] && s, v, T && {
    as: T
  }, {
    ref: y
  }), k);
  return Object.keys(C).forEach((O) => {
    delete S[O];
  }), [f, S];
}
function av(r) {
  return fe("MuiAccordion", r);
}
const fa = ue("MuiAccordion", ["root", "rounded", "expanded", "disabled", "gutters", "region"]), sv = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "slots", "slotProps", "TransitionComponent", "TransitionProps"], lv = (r) => {
  const {
    classes: e,
    square: t,
    expanded: n,
    disabled: o,
    disableGutters: i
  } = r;
  return he({
    root: ["root", !t && "rounded", n && "expanded", o && "disabled", !i && "gutters"],
    region: ["region"]
  }, av, e);
}, cv = H(Wt, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [{
      [`& .${fa.region}`]: e.region
    }, e.root, !t.square && e.rounded, !t.disableGutters && e.gutters];
  }
})(({
  theme: r
}) => {
  const e = {
    duration: r.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: r.transitions.create(["margin"], e),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (r.vars || r).palette.divider,
      transition: r.transitions.create(["opacity", "background-color"], e)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${fa.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${fa.disabled}`]: {
      backgroundColor: (r.vars || r).palette.action.disabledBackground
    }
  };
}, ({
  theme: r
}) => ({
  variants: [{
    props: (e) => !e.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (r.vars || r).shape.borderRadius,
        borderTopRightRadius: (r.vars || r).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (r.vars || r).shape.borderRadius,
        borderBottomRightRadius: (r.vars || r).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (e) => !e.disableGutters,
    style: {
      [`&.${fa.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
})), ff = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiAccordion"
  }), {
    children: o,
    className: i,
    defaultExpanded: a = !1,
    disabled: s = !1,
    disableGutters: c = !1,
    expanded: d,
    onChange: u,
    square: p = !1,
    slots: h = {},
    slotProps: f = {},
    TransitionComponent: m,
    TransitionProps: g
  } = n, b = q(n, sv), [x, v] = Rr({
    controlled: d,
    default: a,
    name: "Accordion",
    state: "expanded"
  }), y = R.useCallback((N) => {
    v(!x), u && u(N, !x);
  }, [x, u, v]), [C, ...k] = R.Children.toArray(o), T = R.useMemo(() => ({
    expanded: x,
    disabled: s,
    disableGutters: c,
    toggle: y
  }), [x, s, c, y]), S = A({}, n, {
    square: p,
    disabled: s,
    disableGutters: c,
    expanded: x
  }), O = lv(S), P = A({
    transition: m
  }, h), M = A({
    transition: g
  }, f), [I, E] = Va("transition", {
    elementType: jc,
    externalForwardedProps: {
      slots: P,
      slotProps: M
    },
    ownerState: S
  });
  return /* @__PURE__ */ w.jsxs(cv, A({
    className: Y(O.root, i),
    ref: t,
    ownerState: S,
    square: p
  }, b, {
    children: [/* @__PURE__ */ w.jsx(Dc.Provider, {
      value: T,
      children: C
    }), /* @__PURE__ */ w.jsx(I, A({
      in: x,
      timeout: "auto"
    }, E, {
      children: /* @__PURE__ */ w.jsx("div", {
        "aria-labelledby": C.props.id,
        id: C.props["aria-controls"],
        role: "region",
        className: O.region,
        children: k
      })
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (ff.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: Ft(l.node.isRequired, (r) => {
    const e = R.Children.toArray(r.children)[0];
    return wo.isFragment(e) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : /* @__PURE__ */ R.isValidElement(e) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: l.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: l.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    transition: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    transition: l.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionComponent: l.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionProps: l.object
});
function dv(r) {
  return fe("MuiAccordionDetails", r);
}
ue("MuiAccordionDetails", ["root"]);
const uv = ["className"], pv = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, dv, e);
}, hv = H("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})(({
  theme: r
}) => ({
  padding: r.spacing(1, 2, 2)
})), gf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiAccordionDetails"
  }), {
    className: o
  } = n, i = q(n, uv), a = n, s = pv(a);
  return /* @__PURE__ */ w.jsx(hv, A({
    className: Y(s.root, o),
    ref: t,
    ownerState: a
  }, i));
});
process.env.NODE_ENV !== "production" && (gf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function mf(r) {
  const {
    className: e,
    classes: t,
    pulsate: n = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: a,
    in: s,
    onExited: c,
    timeout: d
  } = r, [u, p] = R.useState(!1), h = Y(e, t.ripple, t.rippleVisible, n && t.ripplePulsate), f = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + o
  }, m = Y(t.child, u && t.childLeaving, n && t.childPulsate);
  return !s && !u && p(!0), R.useEffect(() => {
    if (!s && c != null) {
      const g = setTimeout(c, d);
      return () => {
        clearTimeout(g);
      };
    }
  }, [c, s, d]), /* @__PURE__ */ w.jsx("span", {
    className: h,
    style: f,
    children: /* @__PURE__ */ w.jsx("span", {
      className: m
    })
  });
}
process.env.NODE_ENV !== "production" && (mf.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object.isRequired,
  className: l.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: l.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: l.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: l.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: l.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: l.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: l.number,
  /**
   * exit delay
   */
  timeout: l.number.isRequired
});
const ur = ue("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), fv = ["center", "classes", "className"];
let bs = (r) => r, Zd, Jd, Qd, eu;
const Dl = 550, gv = 80, mv = zr(Zd || (Zd = bs`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), bv = zr(Jd || (Jd = bs`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), xv = zr(Qd || (Qd = bs`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), vv = H("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), yv = H(mf, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(eu || (eu = bs`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), ur.rippleVisible, mv, Dl, ({
  theme: r
}) => r.transitions.easing.easeInOut, ur.ripplePulsate, ({
  theme: r
}) => r.transitions.duration.shorter, ur.child, ur.childLeaving, bv, Dl, ({
  theme: r
}) => r.transitions.easing.easeInOut, ur.childPulsate, xv, ({
  theme: r
}) => r.transitions.easing.easeInOut), bf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: i = {},
    className: a
  } = n, s = q(n, fv), [c, d] = R.useState([]), u = R.useRef(0), p = R.useRef(null);
  R.useEffect(() => {
    p.current && (p.current(), p.current = null);
  }, [c]);
  const h = R.useRef(!1), f = On(), m = R.useRef(null), g = R.useRef(null), b = R.useCallback((C) => {
    const {
      pulsate: k,
      rippleX: T,
      rippleY: S,
      rippleSize: O,
      cb: P
    } = C;
    d((M) => [...M, /* @__PURE__ */ w.jsx(yv, {
      classes: {
        ripple: Y(i.ripple, ur.ripple),
        rippleVisible: Y(i.rippleVisible, ur.rippleVisible),
        ripplePulsate: Y(i.ripplePulsate, ur.ripplePulsate),
        child: Y(i.child, ur.child),
        childLeaving: Y(i.childLeaving, ur.childLeaving),
        childPulsate: Y(i.childPulsate, ur.childPulsate)
      },
      timeout: Dl,
      pulsate: k,
      rippleX: T,
      rippleY: S,
      rippleSize: O
    }, u.current)]), u.current += 1, p.current = P;
  }, [i]), x = R.useCallback((C = {}, k = {}, T = () => {
  }) => {
    const {
      pulsate: S = !1,
      center: O = o || k.pulsate,
      fakeElement: P = !1
      // For test purposes
    } = k;
    if (C?.type === "mousedown" && h.current) {
      h.current = !1;
      return;
    }
    C?.type === "touchstart" && (h.current = !0);
    const M = P ? null : g.current, I = M ? M.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let E, N, L;
    if (O || C === void 0 || C.clientX === 0 && C.clientY === 0 || !C.clientX && !C.touches)
      E = Math.round(I.width / 2), N = Math.round(I.height / 2);
    else {
      const {
        clientX: z,
        clientY: F
      } = C.touches && C.touches.length > 0 ? C.touches[0] : C;
      E = Math.round(z - I.left), N = Math.round(F - I.top);
    }
    if (O)
      L = Math.sqrt((2 * I.width ** 2 + I.height ** 2) / 3), L % 2 === 0 && (L += 1);
    else {
      const z = Math.max(Math.abs((M ? M.clientWidth : 0) - E), E) * 2 + 2, F = Math.max(Math.abs((M ? M.clientHeight : 0) - N), N) * 2 + 2;
      L = Math.sqrt(z ** 2 + F ** 2);
    }
    C != null && C.touches ? m.current === null && (m.current = () => {
      b({
        pulsate: S,
        rippleX: E,
        rippleY: N,
        rippleSize: L,
        cb: T
      });
    }, f.start(gv, () => {
      m.current && (m.current(), m.current = null);
    })) : b({
      pulsate: S,
      rippleX: E,
      rippleY: N,
      rippleSize: L,
      cb: T
    });
  }, [o, b, f]), v = R.useCallback(() => {
    x({}, {
      pulsate: !0
    });
  }, [x]), y = R.useCallback((C, k) => {
    if (f.clear(), C?.type === "touchend" && m.current) {
      m.current(), m.current = null, f.start(0, () => {
        y(C, k);
      });
      return;
    }
    m.current = null, d((T) => T.length > 0 ? T.slice(1) : T), p.current = k;
  }, [f]);
  return R.useImperativeHandle(t, () => ({
    pulsate: v,
    start: x,
    stop: y
  }), [v, x, y]), /* @__PURE__ */ w.jsx(vv, A({
    className: Y(ur.root, i.root, a),
    ref: g
  }, s, {
    children: /* @__PURE__ */ w.jsx(Nc, {
      component: null,
      exit: !0,
      children: c
    })
  }));
});
process.env.NODE_ENV !== "production" && (bf.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string
});
function wv(r) {
  return fe("MuiButtonBase", r);
}
const Cv = ue("MuiButtonBase", ["root", "disabled", "focusVisible"]), kv = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], Sv = (r) => {
  const {
    disabled: e,
    focusVisible: t,
    focusVisibleClassName: n,
    classes: o
  } = r, a = he({
    root: ["root", e && "disabled", t && "focusVisible"]
  }, wv, o);
  return t && n && (a.root += ` ${n}`), a;
}, Tv = H("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${Cv.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Kt = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: i = !1,
    children: a,
    className: s,
    component: c = "button",
    disabled: d = !1,
    disableRipple: u = !1,
    disableTouchRipple: p = !1,
    focusRipple: h = !1,
    LinkComponent: f = "a",
    onBlur: m,
    onClick: g,
    onContextMenu: b,
    onDragLeave: x,
    onFocus: v,
    onFocusVisible: y,
    onKeyDown: C,
    onKeyUp: k,
    onMouseDown: T,
    onMouseLeave: S,
    onMouseUp: O,
    onTouchEnd: P,
    onTouchMove: M,
    onTouchStart: I,
    tabIndex: E = 0,
    TouchRippleProps: N,
    touchRippleRef: L,
    type: z
  } = n, F = q(n, kv), B = R.useRef(null), D = R.useRef(null), W = ut(D, L), {
    isFocusVisibleRef: G,
    onFocus: re,
    onBlur: ce,
    ref: Ce
  } = gs(), [ne, pe] = R.useState(!1);
  d && ne && pe(!1), R.useImperativeHandle(o, () => ({
    focusVisible: () => {
      pe(!0), B.current.focus();
    }
  }), []);
  const [K, le] = R.useState(!1);
  R.useEffect(() => {
    le(!0);
  }, []);
  const Q = K && !u && !d;
  R.useEffect(() => {
    ne && h && !u && K && D.current.pulsate();
  }, [u, h, ne, K]);
  function se(de, Ve, vt = p) {
    return Lt((yt) => (Ve && Ve(yt), !vt && D.current && D.current[de](yt), !0));
  }
  const Re = se("start", T), be = se("stop", b), Ne = se("stop", x), ke = se("stop", O), Oe = se("stop", (de) => {
    ne && de.preventDefault(), S && S(de);
  }), Te = se("start", I), me = se("stop", P), tt = se("stop", M), Se = se("stop", (de) => {
    ce(de), G.current === !1 && pe(!1), m && m(de);
  }, !1), Ke = Lt((de) => {
    B.current || (B.current = de.currentTarget), re(de), G.current === !0 && (pe(!0), y && y(de)), v && v(de);
  }), He = () => {
    const de = B.current;
    return c && c !== "button" && !(de.tagName === "A" && de.href);
  }, _e = R.useRef(!1), Qe = Lt((de) => {
    h && !_e.current && ne && D.current && de.key === " " && (_e.current = !0, D.current.stop(de, () => {
      D.current.start(de);
    })), de.target === de.currentTarget && He() && de.key === " " && de.preventDefault(), C && C(de), de.target === de.currentTarget && He() && de.key === "Enter" && !d && (de.preventDefault(), g && g(de));
  }), Ue = Lt((de) => {
    h && de.key === " " && D.current && ne && !de.defaultPrevented && (_e.current = !1, D.current.stop(de, () => {
      D.current.pulsate(de);
    })), k && k(de), g && de.target === de.currentTarget && He() && de.key === " " && !de.defaultPrevented && g(de);
  });
  let Ye = c;
  Ye === "button" && (F.href || F.to) && (Ye = f);
  const ht = {};
  Ye === "button" ? (ht.type = z === void 0 ? "button" : z, ht.disabled = d) : (!F.href && !F.to && (ht.role = "button"), d && (ht["aria-disabled"] = d));
  const bt = ut(t, Ce, B);
  process.env.NODE_ENV !== "production" && R.useEffect(() => {
    Q && !D.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [Q]);
  const mt = A({}, n, {
    centerRipple: i,
    component: c,
    disabled: d,
    disableRipple: u,
    disableTouchRipple: p,
    focusRipple: h,
    tabIndex: E,
    focusVisible: ne
  }), Ie = Sv(mt);
  return /* @__PURE__ */ w.jsxs(Tv, A({
    as: Ye,
    className: Y(Ie.root, s),
    ownerState: mt,
    onBlur: Se,
    onClick: g,
    onContextMenu: be,
    onFocus: Ke,
    onKeyDown: Qe,
    onKeyUp: Ue,
    onMouseDown: Re,
    onMouseLeave: Oe,
    onMouseUp: ke,
    onDragLeave: Ne,
    onTouchEnd: me,
    onTouchMove: tt,
    onTouchStart: Te,
    ref: bt,
    tabIndex: d ? -1 : E,
    type: z
  }, ht, F, {
    children: [a, Q ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ w.jsx(bf, A({
        ref: W,
        center: i
      }, N))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Kt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: $t,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Co,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: l.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: l.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  /**
   * @ignore
   */
  href: l.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: l.elementType,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * @ignore
   */
  onContextMenu: l.func,
  /**
   * @ignore
   */
  onDragLeave: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * @ignore
   */
  onKeyUp: l.func,
  /**
   * @ignore
   */
  onMouseDown: l.func,
  /**
   * @ignore
   */
  onMouseLeave: l.func,
  /**
   * @ignore
   */
  onMouseUp: l.func,
  /**
   * @ignore
   */
  onTouchEnd: l.func,
  /**
   * @ignore
   */
  onTouchMove: l.func,
  /**
   * @ignore
   */
  onTouchStart: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @default 0
   */
  tabIndex: l.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: l.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: l.oneOfType([l.func, l.shape({
    current: l.shape({
      pulsate: l.func.isRequired,
      start: l.func.isRequired,
      stop: l.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: l.oneOfType([l.oneOf(["button", "reset", "submit"]), l.string])
});
function Av(r) {
  return fe("MuiAccordionSummary", r);
}
const ro = ue("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), Ov = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"], Rv = (r) => {
  const {
    classes: e,
    expanded: t,
    disabled: n,
    disableGutters: o
  } = r;
  return he({
    root: ["root", t && "expanded", n && "disabled", !o && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", t && "expanded", !o && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", t && "expanded"]
  }, Av, e);
}, Pv = H(Kt, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})(({
  theme: r
}) => {
  const e = {
    duration: r.transitions.duration.shortest
  };
  return {
    display: "flex",
    minHeight: 48,
    padding: r.spacing(0, 2),
    transition: r.transitions.create(["min-height", "background-color"], e),
    [`&.${ro.focusVisible}`]: {
      backgroundColor: (r.vars || r).palette.action.focus
    },
    [`&.${ro.disabled}`]: {
      opacity: (r.vars || r).palette.action.disabledOpacity
    },
    [`&:hover:not(.${ro.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (t) => !t.disableGutters,
      style: {
        [`&.${ro.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
}), Mv = H("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (r, e) => e.content
})(({
  theme: r
}) => ({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (e) => !e.disableGutters,
    style: {
      transition: r.transitions.create(["margin"], {
        duration: r.transitions.duration.shortest
      }),
      [`&.${ro.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
})), Ev = H("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (r, e) => e.expandIconWrapper
})(({
  theme: r
}) => ({
  display: "flex",
  color: (r.vars || r).palette.action.active,
  transform: "rotate(0deg)",
  transition: r.transitions.create("transform", {
    duration: r.transitions.duration.shortest
  }),
  [`&.${ro.expanded}`]: {
    transform: "rotate(180deg)"
  }
})), xf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiAccordionSummary"
  }), {
    children: o,
    className: i,
    expandIcon: a,
    focusVisibleClassName: s,
    onClick: c
  } = n, d = q(n, Ov), {
    disabled: u = !1,
    disableGutters: p,
    expanded: h,
    toggle: f
  } = R.useContext(Dc), m = (x) => {
    f && f(x), c && c(x);
  }, g = A({}, n, {
    expanded: h,
    disabled: u,
    disableGutters: p
  }), b = Rv(g);
  return /* @__PURE__ */ w.jsxs(Pv, A({
    focusRipple: !1,
    disableRipple: !0,
    disabled: u,
    component: "div",
    "aria-expanded": h,
    className: Y(b.root, i),
    focusVisibleClassName: Y(b.focusVisible, s),
    onClick: m,
    ref: t,
    ownerState: g
  }, d, {
    children: [/* @__PURE__ */ w.jsx(Mv, {
      className: b.content,
      ownerState: g,
      children: o
    }), a && /* @__PURE__ */ w.jsx(Ev, {
      className: b.expandIconWrapper,
      ownerState: g,
      children: a
    })]
  }));
});
process.env.NODE_ENV !== "production" && (xf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: l.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function Iv(r) {
  return fe("MuiAlert", r);
}
const tu = ue("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
function Nv(r) {
  return fe("MuiIconButton", r);
}
const Lv = ue("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), jv = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], Dv = (r) => {
  const {
    classes: e,
    disabled: t,
    color: n,
    edge: o,
    size: i
  } = r, a = {
    root: ["root", t && "disabled", n !== "default" && `color${V(n)}`, o && `edge${V(o)}`, `size${V(i)}`]
  };
  return he(a, Nv, e);
}, zv = H(Kt, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.color !== "default" && e[`color${V(t.color)}`], t.edge && e[`edge${V(t.edge)}`], e[`size${V(t.size)}`]];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: r.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (r.vars || r).palette.action.active,
  transition: r.transitions.create("background-color", {
    duration: r.transitions.duration.shortest
  })
}, !e.disableRipple && {
  "&:hover": {
    backgroundColor: r.vars ? `rgba(${r.vars.palette.action.activeChannel} / ${r.vars.palette.action.hoverOpacity})` : Pe.alpha(r.palette.action.active, r.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
}), ({
  theme: r,
  ownerState: e
}) => {
  var t;
  const n = (t = (r.vars || r).palette) == null ? void 0 : t[e.color];
  return A({}, e.color === "inherit" && {
    color: "inherit"
  }, e.color !== "inherit" && e.color !== "default" && A({
    color: n?.main
  }, !e.disableRipple && {
    "&:hover": A({}, n && {
      backgroundColor: r.vars ? `rgba(${n.mainChannel} / ${r.vars.palette.action.hoverOpacity})` : Pe.alpha(n.main, r.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), e.size === "small" && {
    padding: 5,
    fontSize: r.typography.pxToRem(18)
  }, e.size === "large" && {
    padding: 12,
    fontSize: r.typography.pxToRem(28)
  }, {
    [`&.${Lv.disabled}`]: {
      backgroundColor: "transparent",
      color: (r.vars || r).palette.action.disabled
    }
  });
}), jt = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiIconButton"
  }), {
    edge: o = !1,
    children: i,
    className: a,
    color: s = "default",
    disabled: c = !1,
    disableFocusRipple: d = !1,
    size: u = "medium"
  } = n, p = q(n, jv), h = A({}, n, {
    edge: o,
    color: s,
    disabled: c,
    disableFocusRipple: d,
    size: u
  }), f = Dv(h);
  return /* @__PURE__ */ w.jsx(zv, A({
    className: Y(f.root, a),
    centerRipple: !0,
    focusRipple: !d,
    disabled: c,
    ref: t
  }, p, {
    ownerState: h,
    children: i
  }));
});
process.env.NODE_ENV !== "production" && (jt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: Ft(l.node, (r) => R.Children.toArray(r.children).some((t) => /* @__PURE__ */ R.isValidElement(t) && t.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: l.oneOfType([l.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: l.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const Bv = At(/* @__PURE__ */ w.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), Fv = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), _v = At(/* @__PURE__ */ w.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), $v = At(/* @__PURE__ */ w.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), vf = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), Wv = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"], Hv = (r) => {
  const {
    variant: e,
    color: t,
    severity: n,
    classes: o
  } = r, i = {
    root: ["root", `color${V(t || n)}`, `${e}${V(t || n)}`, `${e}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return he(i, Iv, o);
}, Yv = H(Wt, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[t.variant], e[`${t.variant}${V(t.color || t.severity)}`]];
  }
})(({
  theme: r
}) => {
  const e = r.palette.mode === "light" ? Pe.darken : Pe.lighten, t = r.palette.mode === "light" ? Pe.lighten : Pe.darken;
  return A({}, r.typography.body2, {
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(r.palette).filter(([, n]) => n.main && n.light).map(([n]) => ({
      props: {
        colorSeverity: n,
        variant: "standard"
      },
      style: {
        color: r.vars ? r.vars.palette.Alert[`${n}Color`] : e(r.palette[n].light, 0.6),
        backgroundColor: r.vars ? r.vars.palette.Alert[`${n}StandardBg`] : t(r.palette[n].light, 0.9),
        [`& .${tu.icon}`]: r.vars ? {
          color: r.vars.palette.Alert[`${n}IconColor`]
        } : {
          color: r.palette[n].main
        }
      }
    })), ...Object.entries(r.palette).filter(([, n]) => n.main && n.light).map(([n]) => ({
      props: {
        colorSeverity: n,
        variant: "outlined"
      },
      style: {
        color: r.vars ? r.vars.palette.Alert[`${n}Color`] : e(r.palette[n].light, 0.6),
        border: `1px solid ${(r.vars || r).palette[n].light}`,
        [`& .${tu.icon}`]: r.vars ? {
          color: r.vars.palette.Alert[`${n}IconColor`]
        } : {
          color: r.palette[n].main
        }
      }
    })), ...Object.entries(r.palette).filter(([, n]) => n.main && n.dark).map(([n]) => ({
      props: {
        colorSeverity: n,
        variant: "filled"
      },
      style: A({
        fontWeight: r.typography.fontWeightMedium
      }, r.vars ? {
        color: r.vars.palette.Alert[`${n}FilledColor`],
        backgroundColor: r.vars.palette.Alert[`${n}FilledBg`]
      } : {
        backgroundColor: r.palette.mode === "dark" ? r.palette[n].dark : r.palette[n].main,
        color: r.palette.getContrastText(r.palette[n].main)
      })
    }))]
  });
}), Xv = H("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (r, e) => e.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), Vv = H("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (r, e) => e.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), ru = H("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (r, e) => e.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), nu = {
  success: /* @__PURE__ */ w.jsx(Bv, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ w.jsx(Fv, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ w.jsx(_v, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ w.jsx($v, {
    fontSize: "inherit"
  })
}, yf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiAlert"
  }), {
    action: o,
    children: i,
    className: a,
    closeText: s = "Close",
    color: c,
    components: d = {},
    componentsProps: u = {},
    icon: p,
    iconMapping: h = nu,
    onClose: f,
    role: m = "alert",
    severity: g = "success",
    slotProps: b = {},
    slots: x = {},
    variant: v = "standard"
  } = n, y = q(n, Wv), C = A({}, n, {
    color: c,
    severity: g,
    variant: v,
    colorSeverity: c || g
  }), k = Hv(C), T = {
    slots: A({
      closeButton: d.CloseButton,
      closeIcon: d.CloseIcon
    }, x),
    slotProps: A({}, u, b)
  }, [S, O] = Va("closeButton", {
    elementType: jt,
    externalForwardedProps: T,
    ownerState: C
  }), [P, M] = Va("closeIcon", {
    elementType: vf,
    externalForwardedProps: T,
    ownerState: C
  });
  return /* @__PURE__ */ w.jsxs(Yv, A({
    role: m,
    elevation: 0,
    ownerState: C,
    className: Y(k.root, a),
    ref: t
  }, y, {
    children: [p !== !1 ? /* @__PURE__ */ w.jsx(Xv, {
      ownerState: C,
      className: k.icon,
      children: p || h[g] || nu[g]
    }) : null, /* @__PURE__ */ w.jsx(Vv, {
      ownerState: C,
      className: k.message,
      children: i
    }), o != null ? /* @__PURE__ */ w.jsx(ru, {
      ownerState: C,
      className: k.action,
      children: o
    }) : null, o == null && f ? /* @__PURE__ */ w.jsx(ru, {
      ownerState: C,
      className: k.action,
      children: /* @__PURE__ */ w.jsx(S, A({
        size: "small",
        "aria-label": s,
        title: s,
        color: "inherit",
        onClick: f
      }, O, {
        children: /* @__PURE__ */ w.jsx(P, A({
          fontSize: "small"
        }, M))
      }))
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (yf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: l.node,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: l.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: l.oneOfType([l.oneOf(["error", "info", "success", "warning"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  components: l.shape({
    CloseButton: l.elementType,
    CloseIcon: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  componentsProps: l.shape({
    closeButton: l.object,
    closeIcon: l.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: l.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: l.shape({
    error: l.node,
    info: l.node,
    success: l.node,
    warning: l.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: l.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: l.oneOfType([l.oneOf(["error", "info", "success", "warning"]), l.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    closeButton: l.oneOfType([l.func, l.object]),
    closeIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    closeButton: l.elementType,
    closeIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: l.oneOfType([l.oneOf(["filled", "outlined", "standard"]), l.string])
});
function Uv(r) {
  return fe("MuiTypography", r);
}
ue("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const Gv = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], qv = (r) => {
  const {
    align: e,
    gutterBottom: t,
    noWrap: n,
    paragraph: o,
    variant: i,
    classes: a
  } = r, s = {
    root: ["root", i, r.align !== "inherit" && `align${V(e)}`, t && "gutterBottom", n && "noWrap", o && "paragraph"]
  };
  return he(s, Uv, a);
}, Kv = H("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.variant && e[t.variant], t.align !== "inherit" && e[`align${V(t.align)}`], t.noWrap && e.noWrap, t.gutterBottom && e.gutterBottom, t.paragraph && e.paragraph];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  margin: 0
}, e.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, e.variant !== "inherit" && r.typography[e.variant], e.align !== "inherit" && {
  textAlign: e.align
}, e.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, e.gutterBottom && {
  marginBottom: "0.35em"
}, e.paragraph && {
  marginBottom: 16
})), ou = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Zv = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, Jv = (r) => Zv[r] || r, We = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTypography"
  }), o = Jv(n.color), i = us(A({}, n, {
    color: o
  })), {
    align: a = "inherit",
    className: s,
    component: c,
    gutterBottom: d = !1,
    noWrap: u = !1,
    paragraph: p = !1,
    variant: h = "body1",
    variantMapping: f = ou
  } = i, m = q(i, Gv), g = A({}, i, {
    align: a,
    color: o,
    className: s,
    component: c,
    gutterBottom: d,
    noWrap: u,
    paragraph: p,
    variant: h,
    variantMapping: f
  }), b = c || (p ? "p" : f[h] || ou[h]) || "span", x = qv(g);
  return /* @__PURE__ */ w.jsx(Kv, A({
    as: b,
    ref: t,
    ownerState: g,
    className: Y(x.root, s)
  }, m));
});
process.env.NODE_ENV !== "production" && (We.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: l.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: l.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: l.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: l.oneOfType([l.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), l.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: l.object
});
function Qv(r) {
  return fe("MuiAlertTitle", r);
}
ue("MuiAlertTitle", ["root"]);
const ey = ["className"], ty = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, Qv, e);
}, ry = H(We, {
  name: "MuiAlertTitle",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})(({
  theme: r
}) => ({
  fontWeight: r.typography.fontWeightMedium,
  marginTop: -2
})), wf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiAlertTitle"
  }), {
    className: o
  } = n, i = q(n, ey), a = n, s = ty(a);
  return /* @__PURE__ */ w.jsx(ry, A({
    gutterBottom: !0,
    component: "div",
    ownerState: a,
    ref: t,
    className: Y(s.root, o)
  }, i));
});
process.env.NODE_ENV !== "production" && (wf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function ny(r) {
  return fe("MuiAppBar", r);
}
ue("MuiAppBar", ["root", "positionFixed", "positionAbsolute", "positionSticky", "positionStatic", "positionRelative", "colorDefault", "colorPrimary", "colorSecondary", "colorInherit", "colorTransparent", "colorError", "colorInfo", "colorSuccess", "colorWarning"]);
const oy = ["className", "color", "enableColorOnDark", "position"], iy = (r) => {
  const {
    color: e,
    position: t,
    classes: n
  } = r, o = {
    root: ["root", `color${V(e)}`, `position${V(t)}`]
  };
  return he(o, ny, n);
}, ga = (r, e) => r ? `${r?.replace(")", "")}, ${e})` : e, ay = H(Wt, {
  name: "MuiAppBar",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[`position${V(t.position)}`], e[`color${V(t.color)}`]];
  }
})(({
  theme: r,
  ownerState: e
}) => {
  const t = r.palette.mode === "light" ? r.palette.grey[100] : r.palette.grey[900];
  return A({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxSizing: "border-box",
    // Prevent padding issue with the Modal and fixed positioned AppBar.
    flexShrink: 0
  }, e.position === "fixed" && {
    position: "fixed",
    zIndex: (r.vars || r).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0,
    "@media print": {
      // Prevent the app bar to be visible on each printed page.
      position: "absolute"
    }
  }, e.position === "absolute" && {
    position: "absolute",
    zIndex: (r.vars || r).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0
  }, e.position === "sticky" && {
    // ⚠️ sticky is not supported by IE11.
    position: "sticky",
    zIndex: (r.vars || r).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0
  }, e.position === "static" && {
    position: "static"
  }, e.position === "relative" && {
    position: "relative"
  }, !r.vars && A({}, e.color === "default" && {
    backgroundColor: t,
    color: r.palette.getContrastText(t)
  }, e.color && e.color !== "default" && e.color !== "inherit" && e.color !== "transparent" && {
    backgroundColor: r.palette[e.color].main,
    color: r.palette[e.color].contrastText
  }, e.color === "inherit" && {
    color: "inherit"
  }, r.palette.mode === "dark" && !e.enableColorOnDark && {
    backgroundColor: null,
    color: null
  }, e.color === "transparent" && A({
    backgroundColor: "transparent",
    color: "inherit"
  }, r.palette.mode === "dark" && {
    backgroundImage: "none"
  })), r.vars && A({}, e.color === "default" && {
    "--AppBar-background": e.enableColorOnDark ? r.vars.palette.AppBar.defaultBg : ga(r.vars.palette.AppBar.darkBg, r.vars.palette.AppBar.defaultBg),
    "--AppBar-color": e.enableColorOnDark ? r.vars.palette.text.primary : ga(r.vars.palette.AppBar.darkColor, r.vars.palette.text.primary)
  }, e.color && !e.color.match(/^(default|inherit|transparent)$/) && {
    "--AppBar-background": e.enableColorOnDark ? r.vars.palette[e.color].main : ga(r.vars.palette.AppBar.darkBg, r.vars.palette[e.color].main),
    "--AppBar-color": e.enableColorOnDark ? r.vars.palette[e.color].contrastText : ga(r.vars.palette.AppBar.darkColor, r.vars.palette[e.color].contrastText)
  }, !["inherit", "transparent"].includes(e.color) && {
    backgroundColor: "var(--AppBar-background)"
  }, {
    color: e.color === "inherit" ? "inherit" : "var(--AppBar-color)"
  }, e.color === "transparent" && {
    backgroundImage: "none",
    backgroundColor: "transparent",
    color: "inherit"
  }));
}), sy = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiAppBar"
  }), {
    className: o,
    color: i = "primary",
    enableColorOnDark: a = !1,
    position: s = "fixed"
  } = n, c = q(n, oy), d = A({}, n, {
    color: i,
    position: s,
    enableColorOnDark: a
  }), u = iy(d);
  return /* @__PURE__ */ w.jsx(ay, A({
    square: !0,
    component: "header",
    ownerState: d,
    elevation: 4,
    className: Y(u.root, o, s === "fixed" && "mui-fixed"),
    ref: t
  }, c));
});
process.env.NODE_ENV !== "production" && (sy.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["default", "inherit", "primary", "secondary", "transparent", "error", "info", "success", "warning"]), l.string]),
  /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */
  enableColorOnDark: l.bool,
  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */
  position: l.oneOf(["absolute", "fixed", "relative", "static", "sticky"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function iu(r) {
  return typeof r.normalize < "u" ? r.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : r;
}
function Cf(r = {}) {
  const {
    ignoreAccents: e = !0,
    ignoreCase: t = !0,
    limit: n,
    matchFrom: o = "any",
    stringify: i,
    trim: a = !1
  } = r;
  return (s, {
    inputValue: c,
    getOptionLabel: d
  }) => {
    let u = a ? c.trim() : c;
    t && (u = u.toLowerCase()), e && (u = iu(u));
    const p = u ? s.filter((h) => {
      let f = (i || d)(h);
      return t && (f = f.toLowerCase()), e && (f = iu(f)), o === "start" ? f.indexOf(u) === 0 : f.indexOf(u) > -1;
    }) : s;
    return typeof n == "number" ? p.slice(0, n) : p;
  };
}
function ma(r, e) {
  for (let t = 0; t < r.length; t += 1)
    if (e(r[t]))
      return t;
  return -1;
}
const ly = Cf(), au = 5, cy = (r) => {
  var e;
  return r.current !== null && ((e = r.current.parentElement) == null ? void 0 : e.contains(document.activeElement));
}, dy = [];
function uy(r) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: e = cy,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: t = "Mui",
    autoComplete: n = !1,
    autoHighlight: o = !1,
    autoSelect: i = !1,
    blurOnSelect: a = !1,
    clearOnBlur: s = !r.freeSolo,
    clearOnEscape: c = !1,
    componentName: d = "useAutocomplete",
    defaultValue: u = r.multiple ? dy : null,
    disableClearable: p = !1,
    disableCloseOnSelect: h = !1,
    disabled: f,
    disabledItemsFocusable: m = !1,
    disableListWrap: g = !1,
    filterOptions: b = ly,
    filterSelectedOptions: x = !1,
    freeSolo: v = !1,
    getOptionDisabled: y,
    getOptionKey: C,
    getOptionLabel: k = (Z) => {
      var X;
      return (X = Z.label) != null ? X : Z;
    },
    groupBy: T,
    handleHomeEndKeys: S = !r.freeSolo,
    id: O,
    includeInputInList: P = !1,
    inputValue: M,
    isOptionEqualToValue: I = (Z, X) => Z === X,
    multiple: E = !1,
    onChange: N,
    onClose: L,
    onHighlightChange: z,
    onInputChange: F,
    onOpen: B,
    open: D,
    openOnFocus: W = !1,
    options: G,
    readOnly: re = !1,
    selectOnFocus: ce = !r.freeSolo,
    value: Ce
  } = r, ne = Yr(O);
  let pe = k;
  pe = (Z) => {
    const X = k(Z);
    if (typeof X != "string") {
      if (process.env.NODE_ENV !== "production") {
        const ae = X === void 0 ? "undefined" : `${typeof X} (${X})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${d} returned ${ae} instead of a string for ${JSON.stringify(Z)}.`);
      }
      return String(X);
    }
    return X;
  };
  const K = R.useRef(!1), le = R.useRef(!0), Q = R.useRef(null), se = R.useRef(null), [Re, be] = R.useState(null), [Ne, ke] = R.useState(-1), Oe = o ? 0 : -1, Te = R.useRef(Oe), [me, tt] = Rr({
    controlled: Ce,
    default: u,
    name: d
  }), [Se, Ke] = Rr({
    controlled: M,
    default: "",
    name: d,
    state: "inputValue"
  }), [He, _e] = R.useState(!1), Qe = R.useCallback((Z, X) => {
    if (!(E ? me.length < X.length : X !== null) && !s)
      return;
    let Me;
    if (E)
      Me = "";
    else if (X == null)
      Me = "";
    else {
      const ze = pe(X);
      Me = typeof ze == "string" ? ze : "";
    }
    Se !== Me && (Ke(Me), F && F(Z, Me, "reset"));
  }, [pe, Se, E, F, Ke, s, me]), [Ue, Ye] = Rr({
    controlled: D,
    default: !1,
    name: d,
    state: "open"
  }), [ht, bt] = R.useState(!0), mt = !E && me != null && Se === pe(me), Ie = Ue && !re, de = Ie ? b(
    G.filter((Z) => !(x && (E ? me : [me]).some((X) => X !== null && I(Z, X)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: mt && ht ? "" : Se,
      getOptionLabel: pe
    }
  ) : [], Ve = Pc({
    filteredOptions: de,
    value: me,
    inputValue: Se
  });
  R.useEffect(() => {
    const Z = me !== Ve.value;
    He && !Z || v && !Z || Qe(null, me);
  }, [me, Qe, He, Ve.value, v]);
  const vt = Ue && de.length > 0 && !re;
  if (process.env.NODE_ENV !== "production" && me !== null && !v && G.length > 0) {
    const Z = (E ? me : [me]).filter((X) => !G.some((ae) => I(ae, X)));
    Z.length > 0 && console.warn([`MUI: The value provided to ${d} is invalid.`, `None of the options match with \`${Z.length > 1 ? JSON.stringify(Z) : JSON.stringify(Z[0])}\`.`, "You can use the `isOptionEqualToValue` prop to customize the equality test."].join(`
`));
  }
  const yt = Lt((Z) => {
    Z === -1 ? Q.current.focus() : Re.querySelector(`[data-tag-index="${Z}"]`).focus();
  });
  R.useEffect(() => {
    E && Ne > me.length - 1 && (ke(-1), yt(-1));
  }, [me, E, Ne, yt]);
  function Ot(Z, X) {
    if (!se.current || Z < 0 || Z >= de.length)
      return -1;
    let ae = Z;
    for (; ; ) {
      const Me = se.current.querySelector(`[data-option-index="${ae}"]`), ze = m ? !1 : !Me || Me.disabled || Me.getAttribute("aria-disabled") === "true";
      if (Me && Me.hasAttribute("tabindex") && !ze)
        return ae;
      if (X === "next" ? ae = (ae + 1) % de.length : ae = (ae - 1 + de.length) % de.length, ae === Z)
        return -1;
    }
  }
  const ye = Lt(({
    event: Z,
    index: X,
    reason: ae = "auto"
  }) => {
    if (Te.current = X, X === -1 ? Q.current.removeAttribute("aria-activedescendant") : Q.current.setAttribute("aria-activedescendant", `${ne}-option-${X}`), z && z(Z, X === -1 ? null : de[X], ae), !se.current)
      return;
    const Me = se.current.querySelector(`[role="option"].${t}-focused`);
    Me && (Me.classList.remove(`${t}-focused`), Me.classList.remove(`${t}-focusVisible`));
    let ze = se.current;
    if (se.current.getAttribute("role") !== "listbox" && (ze = se.current.parentElement.querySelector('[role="listbox"]')), !ze)
      return;
    if (X === -1) {
      ze.scrollTop = 0;
      return;
    }
    const we = se.current.querySelector(`[data-option-index="${X}"]`);
    if (we && (we.classList.add(`${t}-focused`), ae === "keyboard" && we.classList.add(`${t}-focusVisible`), ze.scrollHeight > ze.clientHeight && ae !== "mouse" && ae !== "touch")) {
      const Ge = we, nr = ze.clientHeight + ze.scrollTop, da = Ge.offsetTop + Ge.offsetHeight;
      da > nr ? ze.scrollTop = da - ze.clientHeight : Ge.offsetTop - Ge.offsetHeight * (T ? 1.3 : 0) < ze.scrollTop && (ze.scrollTop = Ge.offsetTop - Ge.offsetHeight * (T ? 1.3 : 0));
    }
  }), te = Lt(({
    event: Z,
    diff: X,
    direction: ae = "next",
    reason: Me = "auto"
  }) => {
    if (!Ie)
      return;
    const we = Ot((() => {
      const Ge = de.length - 1;
      if (X === "reset")
        return Oe;
      if (X === "start")
        return 0;
      if (X === "end")
        return Ge;
      const nr = Te.current + X;
      return nr < 0 ? nr === -1 && P ? -1 : g && Te.current !== -1 || Math.abs(X) > 1 ? 0 : Ge : nr > Ge ? nr === Ge + 1 && P ? -1 : g || Math.abs(X) > 1 ? Ge : 0 : nr;
    })(), ae);
    if (ye({
      index: we,
      reason: Me,
      event: Z
    }), n && X !== "reset")
      if (we === -1)
        Q.current.value = Se;
      else {
        const Ge = pe(de[we]);
        Q.current.value = Ge, Ge.toLowerCase().indexOf(Se.toLowerCase()) === 0 && Se.length > 0 && Q.current.setSelectionRange(Se.length, Ge.length);
      }
  }), _ = () => {
    const Z = (X, ae) => {
      const Me = X ? pe(X) : "", ze = ae ? pe(ae) : "";
      return Me === ze;
    };
    if (Te.current !== -1 && Ve.filteredOptions && Ve.filteredOptions.length !== de.length && Ve.inputValue === Se && (E ? me.length === Ve.value.length && Ve.value.every((X, ae) => pe(me[ae]) === pe(X)) : Z(Ve.value, me))) {
      const X = Ve.filteredOptions[Te.current];
      if (X)
        return ma(de, (ae) => pe(ae) === pe(X));
    }
    return -1;
  }, U = R.useCallback(() => {
    if (!Ie)
      return;
    const Z = _();
    if (Z !== -1) {
      Te.current = Z;
      return;
    }
    const X = E ? me[0] : me;
    if (de.length === 0 || X == null) {
      te({
        diff: "reset"
      });
      return;
    }
    if (se.current) {
      if (X != null) {
        const ae = de[Te.current];
        if (E && ae && ma(me, (ze) => I(ae, ze)) !== -1)
          return;
        const Me = ma(de, (ze) => I(ze, X));
        Me === -1 ? te({
          diff: "reset"
        }) : ye({
          index: Me
        });
        return;
      }
      if (Te.current >= de.length - 1) {
        ye({
          index: de.length - 1
        });
        return;
      }
      ye({
        index: Te.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    de.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    E ? !1 : me,
    x,
    te,
    ye,
    Ie,
    Se,
    E
  ]), oe = Lt((Z) => {
    Ni(se, Z), Z && U();
  });
  process.env.NODE_ENV !== "production" && R.useEffect(() => {
    (!Q.current || Q.current.nodeName !== "INPUT") && (Q.current && Q.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${d} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${Q.current} while an HTMLInputElement was expected.`, `Instead, ${d} expects an input element.`, "", d === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [d]), R.useEffect(() => {
    U();
  }, [U]);
  const Ae = (Z) => {
    Ue || (Ye(!0), bt(!0), B && B(Z));
  }, et = (Z, X) => {
    Ue && (Ye(!1), L && L(Z, X));
  }, st = (Z, X, ae, Me) => {
    if (E) {
      if (me.length === X.length && me.every((ze, we) => ze === X[we]))
        return;
    } else if (me === X)
      return;
    N && N(Z, X, ae, Me), tt(X);
  }, Et = R.useRef(!1), Pt = (Z, X, ae = "selectOption", Me = "options") => {
    let ze = ae, we = X;
    if (E) {
      if (we = Array.isArray(me) ? me.slice() : [], process.env.NODE_ENV !== "production") {
        const nr = we.filter((da) => I(X, da));
        nr.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${d} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${nr.length} matches.`].join(`
`));
      }
      const Ge = ma(we, (nr) => I(X, nr));
      Ge === -1 ? we.push(X) : Me !== "freeSolo" && (we.splice(Ge, 1), ze = "removeOption");
    }
    Qe(Z, we), st(Z, we, ze, {
      option: X
    }), !h && (!Z || !Z.ctrlKey && !Z.metaKey) && et(Z, ze), (a === !0 || a === "touch" && Et.current || a === "mouse" && !Et.current) && Q.current.blur();
  };
  function kr(Z, X) {
    if (Z === -1)
      return -1;
    let ae = Z;
    for (; ; ) {
      if (X === "next" && ae === me.length || X === "previous" && ae === -1)
        return -1;
      const Me = Re.querySelector(`[data-tag-index="${ae}"]`);
      if (!Me || !Me.hasAttribute("tabindex") || Me.disabled || Me.getAttribute("aria-disabled") === "true")
        ae += X === "next" ? 1 : -1;
      else
        return ae;
    }
  }
  const xn = (Z, X) => {
    if (!E)
      return;
    Se === "" && et(Z, "toggleInput");
    let ae = Ne;
    Ne === -1 ? Se === "" && X === "previous" && (ae = me.length - 1) : (ae += X === "next" ? 1 : -1, ae < 0 && (ae = 0), ae === me.length && (ae = -1)), ae = kr(ae, X), ke(ae), yt(ae);
  }, Yn = (Z) => {
    K.current = !0, Ke(""), F && F(Z, "", "clear"), st(Z, E ? [] : null, "clear");
  }, No = (Z) => (X) => {
    if (Z.onKeyDown && Z.onKeyDown(X), !X.defaultMuiPrevented && (Ne !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(X.key) === -1 && (ke(-1), yt(-1)), X.which !== 229))
      switch (X.key) {
        case "Home":
          Ie && S && (X.preventDefault(), te({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: X
          }));
          break;
        case "End":
          Ie && S && (X.preventDefault(), te({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: X
          }));
          break;
        case "PageUp":
          X.preventDefault(), te({
            diff: -au,
            direction: "previous",
            reason: "keyboard",
            event: X
          }), Ae(X);
          break;
        case "PageDown":
          X.preventDefault(), te({
            diff: au,
            direction: "next",
            reason: "keyboard",
            event: X
          }), Ae(X);
          break;
        case "ArrowDown":
          X.preventDefault(), te({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: X
          }), Ae(X);
          break;
        case "ArrowUp":
          X.preventDefault(), te({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: X
          }), Ae(X);
          break;
        case "ArrowLeft":
          xn(X, "previous");
          break;
        case "ArrowRight":
          xn(X, "next");
          break;
        case "Enter":
          if (Te.current !== -1 && Ie) {
            const ae = de[Te.current], Me = y ? y(ae) : !1;
            if (X.preventDefault(), Me)
              return;
            Pt(X, ae, "selectOption"), n && Q.current.setSelectionRange(Q.current.value.length, Q.current.value.length);
          } else v && Se !== "" && mt === !1 && (E && X.preventDefault(), Pt(X, Se, "createOption", "freeSolo"));
          break;
        case "Escape":
          Ie ? (X.preventDefault(), X.stopPropagation(), et(X, "escape")) : c && (Se !== "" || E && me.length > 0) && (X.preventDefault(), X.stopPropagation(), Yn(X));
          break;
        case "Backspace":
          if (E && !re && Se === "" && me.length > 0) {
            const ae = Ne === -1 ? me.length - 1 : Ne, Me = me.slice();
            Me.splice(ae, 1), st(X, Me, "removeOption", {
              option: me[ae]
            });
          }
          break;
        case "Delete":
          if (E && !re && Se === "" && me.length > 0 && Ne !== -1) {
            const ae = Ne, Me = me.slice();
            Me.splice(ae, 1), st(X, Me, "removeOption", {
              option: me[ae]
            });
          }
          break;
      }
  }, ca = (Z) => {
    _e(!0), W && !K.current && Ae(Z);
  }, Mr = (Z) => {
    if (e(se)) {
      Q.current.focus();
      return;
    }
    _e(!1), le.current = !0, K.current = !1, i && Te.current !== -1 && Ie ? Pt(Z, de[Te.current], "blur") : i && v && Se !== "" ? Pt(Z, Se, "blur", "freeSolo") : s && Qe(Z, me), et(Z, "blur");
  }, It = (Z) => {
    const X = Z.target.value;
    Se !== X && (Ke(X), bt(!1), F && F(Z, X, "input")), X === "" ? !p && !E && st(Z, null, "clear") : Ae(Z);
  }, xt = (Z) => {
    const X = Number(Z.currentTarget.getAttribute("data-option-index"));
    Te.current !== X && ye({
      event: Z,
      index: X,
      reason: "mouse"
    });
  }, Ht = (Z) => {
    ye({
      event: Z,
      index: Number(Z.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), Et.current = !0;
  }, Yt = (Z) => {
    const X = Number(Z.currentTarget.getAttribute("data-option-index"));
    Pt(Z, de[X], "selectOption"), Et.current = !1;
  }, Fr = (Z) => (X) => {
    const ae = me.slice();
    ae.splice(Z, 1), st(X, ae, "removeOption", {
      option: me[Z]
    });
  }, Lo = (Z) => {
    Ue ? et(Z, "toggleInput") : Ae(Z);
  }, _r = (Z) => {
    Z.currentTarget.contains(Z.target) && Z.target.getAttribute("id") !== ne && Z.preventDefault();
  }, qr = (Z) => {
    Z.currentTarget.contains(Z.target) && (Q.current.focus(), ce && le.current && Q.current.selectionEnd - Q.current.selectionStart === 0 && Q.current.select(), le.current = !1);
  }, Kr = (Z) => {
    !f && (Se === "" || !Ue) && Lo(Z);
  };
  let Er = v && Se.length > 0;
  Er = Er || (E ? me.length > 0 : me !== null);
  let $r = de;
  if (T) {
    const Z = /* @__PURE__ */ new Map();
    let X = !1;
    $r = de.reduce((ae, Me, ze) => {
      const we = T(Me);
      return ae.length > 0 && ae[ae.length - 1].group === we ? ae[ae.length - 1].options.push(Me) : (process.env.NODE_ENV !== "production" && (Z.get(we) && !X && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${d} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), X = !0), Z.set(we, !0)), ae.push({
        key: ze,
        index: ze,
        group: we,
        options: [Me]
      })), ae;
    }, []);
  }
  return f && He && Mr(), {
    getRootProps: (Z = {}) => A({
      "aria-owns": vt ? `${ne}-listbox` : null
    }, Z, {
      onKeyDown: No(Z),
      onMouseDown: _r,
      onClick: qr
    }),
    getInputLabelProps: () => ({
      id: `${ne}-label`,
      htmlFor: ne
    }),
    getInputProps: () => ({
      id: ne,
      value: Se,
      onBlur: Mr,
      onFocus: ca,
      onChange: It,
      onMouseDown: Kr,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Ie ? "" : null,
      "aria-autocomplete": n ? "both" : "list",
      "aria-controls": vt ? `${ne}-listbox` : void 0,
      "aria-expanded": vt,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: Q,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: f
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Yn
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Lo
    }),
    getTagProps: ({
      index: Z
    }) => A({
      key: Z,
      "data-tag-index": Z,
      tabIndex: -1
    }, !re && {
      onDelete: Fr(Z)
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${ne}-listbox`,
      "aria-labelledby": `${ne}-label`,
      ref: oe,
      onMouseDown: (Z) => {
        Z.preventDefault();
      }
    }),
    getOptionProps: ({
      index: Z,
      option: X
    }) => {
      var ae;
      const Me = (E ? me : [me]).some((we) => we != null && I(X, we)), ze = y ? y(X) : !1;
      return {
        key: (ae = C?.(X)) != null ? ae : pe(X),
        tabIndex: -1,
        role: "option",
        id: `${ne}-option-${Z}`,
        onMouseMove: xt,
        onClick: Yt,
        onTouchStart: Ht,
        "data-option-index": Z,
        "aria-disabled": ze,
        "aria-selected": Me
      };
    },
    id: ne,
    inputValue: Se,
    value: me,
    dirty: Er,
    expanded: Ie && Re,
    popupOpen: Ie,
    focused: He || Ne !== -1,
    anchorEl: Re,
    setAnchorEl: be,
    focusedTag: Ne,
    groupedOptions: $r
  };
}
var jo = {}, su;
function py() {
  if (su) return jo;
  su = 1, Object.defineProperty(jo, "__esModule", {
    value: !0
  }), jo.default = void 0;
  var r = n(hr), e = hb;
  function t(a) {
    if (typeof WeakMap != "function") return null;
    var s = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
    return (t = function(d) {
      return d ? c : s;
    })(a);
  }
  function n(a, s) {
    if (a && a.__esModule) return a;
    if (a === null || typeof a != "object" && typeof a != "function") return { default: a };
    var c = t(s);
    if (c && c.has(a)) return c.get(a);
    var d = { __proto__: null }, u = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var p in a) if (p !== "default" && Object.prototype.hasOwnProperty.call(a, p)) {
      var h = u ? Object.getOwnPropertyDescriptor(a, p) : null;
      h && (h.get || h.set) ? Object.defineProperty(d, p, h) : d[p] = a[p];
    }
    return d.default = a, c && c.set(a, d), d;
  }
  function o(a) {
    return Object.keys(a).length === 0;
  }
  function i(a = null) {
    const s = r.useContext(e.ThemeContext);
    return !s || o(s) ? a : s;
  }
  return jo.default = i, jo;
}
var hy = /* @__PURE__ */ py();
const fy = /* @__PURE__ */ gt(hy);
var Qt = "top", xr = "bottom", vr = "right", er = "left", zc = "auto", Ki = [Qt, xr, vr, er], po = "start", ji = "end", gy = "clippingParents", kf = "viewport", Do = "popper", my = "reference", lu = /* @__PURE__ */ Ki.reduce(function(r, e) {
  return r.concat([e + "-" + po, e + "-" + ji]);
}, []), Sf = /* @__PURE__ */ [].concat(Ki, [zc]).reduce(function(r, e) {
  return r.concat([e, e + "-" + po, e + "-" + ji]);
}, []), by = "beforeRead", xy = "read", vy = "afterRead", yy = "beforeMain", wy = "main", Cy = "afterMain", ky = "beforeWrite", Sy = "write", Ty = "afterWrite", Ay = [by, xy, vy, yy, wy, Cy, ky, Sy, Ty];
function Dr(r) {
  return r ? (r.nodeName || "").toLowerCase() : null;
}
function sr(r) {
  if (r == null)
    return window;
  if (r.toString() !== "[object Window]") {
    var e = r.ownerDocument;
    return e && e.defaultView || window;
  }
  return r;
}
function Bn(r) {
  var e = sr(r).Element;
  return r instanceof e || r instanceof Element;
}
function gr(r) {
  var e = sr(r).HTMLElement;
  return r instanceof e || r instanceof HTMLElement;
}
function Bc(r) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = sr(r).ShadowRoot;
  return r instanceof e || r instanceof ShadowRoot;
}
function Oy(r) {
  var e = r.state;
  Object.keys(e.elements).forEach(function(t) {
    var n = e.styles[t] || {}, o = e.attributes[t] || {}, i = e.elements[t];
    !gr(i) || !Dr(i) || (Object.assign(i.style, n), Object.keys(o).forEach(function(a) {
      var s = o[a];
      s === !1 ? i.removeAttribute(a) : i.setAttribute(a, s === !0 ? "" : s);
    }));
  });
}
function Ry(r) {
  var e = r.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.styles = t, e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(n) {
      var o = e.elements[n], i = e.attributes[n] || {}, a = Object.keys(e.styles.hasOwnProperty(n) ? e.styles[n] : t[n]), s = a.reduce(function(c, d) {
        return c[d] = "", c;
      }, {});
      !gr(o) || !Dr(o) || (Object.assign(o.style, s), Object.keys(i).forEach(function(c) {
        o.removeAttribute(c);
      }));
    });
  };
}
const Py = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Oy,
  effect: Ry,
  requires: ["computeStyles"]
};
function Lr(r) {
  return r.split("-")[0];
}
var Nn = Math.max, Ua = Math.min, ho = Math.round;
function zl() {
  var r = navigator.userAgentData;
  return r != null && r.brands && Array.isArray(r.brands) ? r.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function Tf() {
  return !/^((?!chrome|android).)*safari/i.test(zl());
}
function fo(r, e, t) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  var n = r.getBoundingClientRect(), o = 1, i = 1;
  e && gr(r) && (o = r.offsetWidth > 0 && ho(n.width) / r.offsetWidth || 1, i = r.offsetHeight > 0 && ho(n.height) / r.offsetHeight || 1);
  var a = Bn(r) ? sr(r) : window, s = a.visualViewport, c = !Tf() && t, d = (n.left + (c && s ? s.offsetLeft : 0)) / o, u = (n.top + (c && s ? s.offsetTop : 0)) / i, p = n.width / o, h = n.height / i;
  return {
    width: p,
    height: h,
    top: u,
    right: d + p,
    bottom: u + h,
    left: d,
    x: d,
    y: u
  };
}
function Fc(r) {
  var e = fo(r), t = r.offsetWidth, n = r.offsetHeight;
  return Math.abs(e.width - t) <= 1 && (t = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
    x: r.offsetLeft,
    y: r.offsetTop,
    width: t,
    height: n
  };
}
function Af(r, e) {
  var t = e.getRootNode && e.getRootNode();
  if (r.contains(e))
    return !0;
  if (t && Bc(t)) {
    var n = e;
    do {
      if (n && r.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Xr(r) {
  return sr(r).getComputedStyle(r);
}
function My(r) {
  return ["table", "td", "th"].indexOf(Dr(r)) >= 0;
}
function mn(r) {
  return ((Bn(r) ? r.ownerDocument : (
    // $FlowFixMe[prop-missing]
    r.document
  )) || window.document).documentElement;
}
function xs(r) {
  return Dr(r) === "html" ? r : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    r.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    r.parentNode || // DOM Element detected
    (Bc(r) ? r.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    mn(r)
  );
}
function cu(r) {
  return !gr(r) || // https://github.com/popperjs/popper-core/issues/837
  Xr(r).position === "fixed" ? null : r.offsetParent;
}
function Ey(r) {
  var e = /firefox/i.test(zl()), t = /Trident/i.test(zl());
  if (t && gr(r)) {
    var n = Xr(r);
    if (n.position === "fixed")
      return null;
  }
  var o = xs(r);
  for (Bc(o) && (o = o.host); gr(o) && ["html", "body"].indexOf(Dr(o)) < 0; ) {
    var i = Xr(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Zi(r) {
  for (var e = sr(r), t = cu(r); t && My(t) && Xr(t).position === "static"; )
    t = cu(t);
  return t && (Dr(t) === "html" || Dr(t) === "body" && Xr(t).position === "static") ? e : t || Ey(r) || e;
}
function _c(r) {
  return ["top", "bottom"].indexOf(r) >= 0 ? "x" : "y";
}
function ki(r, e, t) {
  return Nn(r, Ua(e, t));
}
function Iy(r, e, t) {
  var n = ki(r, e, t);
  return n > t ? t : n;
}
function Of() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Rf(r) {
  return Object.assign({}, Of(), r);
}
function Pf(r, e) {
  return e.reduce(function(t, n) {
    return t[n] = r, t;
  }, {});
}
var Ny = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, Rf(typeof e != "number" ? e : Pf(e, Ki));
};
function Ly(r) {
  var e, t = r.state, n = r.name, o = r.options, i = t.elements.arrow, a = t.modifiersData.popperOffsets, s = Lr(t.placement), c = _c(s), d = [er, vr].indexOf(s) >= 0, u = d ? "height" : "width";
  if (!(!i || !a)) {
    var p = Ny(o.padding, t), h = Fc(i), f = c === "y" ? Qt : er, m = c === "y" ? xr : vr, g = t.rects.reference[u] + t.rects.reference[c] - a[c] - t.rects.popper[u], b = a[c] - t.rects.reference[c], x = Zi(i), v = x ? c === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, y = g / 2 - b / 2, C = p[f], k = v - h[u] - p[m], T = v / 2 - h[u] / 2 + y, S = ki(C, T, k), O = c;
    t.modifiersData[n] = (e = {}, e[O] = S, e.centerOffset = S - T, e);
  }
}
function jy(r) {
  var e = r.state, t = r.options, n = t.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = e.elements.popper.querySelector(o), !o) || Af(e.elements.popper, o) && (e.elements.arrow = o));
}
const Dy = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Ly,
  effect: jy,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function go(r) {
  return r.split("-")[1];
}
var zy = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function By(r, e) {
  var t = r.x, n = r.y, o = e.devicePixelRatio || 1;
  return {
    x: ho(t * o) / o || 0,
    y: ho(n * o) / o || 0
  };
}
function du(r) {
  var e, t = r.popper, n = r.popperRect, o = r.placement, i = r.variation, a = r.offsets, s = r.position, c = r.gpuAcceleration, d = r.adaptive, u = r.roundOffsets, p = r.isFixed, h = a.x, f = h === void 0 ? 0 : h, m = a.y, g = m === void 0 ? 0 : m, b = typeof u == "function" ? u({
    x: f,
    y: g
  }) : {
    x: f,
    y: g
  };
  f = b.x, g = b.y;
  var x = a.hasOwnProperty("x"), v = a.hasOwnProperty("y"), y = er, C = Qt, k = window;
  if (d) {
    var T = Zi(t), S = "clientHeight", O = "clientWidth";
    if (T === sr(t) && (T = mn(t), Xr(T).position !== "static" && s === "absolute" && (S = "scrollHeight", O = "scrollWidth")), T = T, o === Qt || (o === er || o === vr) && i === ji) {
      C = xr;
      var P = p && T === k && k.visualViewport ? k.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        T[S]
      );
      g -= P - n.height, g *= c ? 1 : -1;
    }
    if (o === er || (o === Qt || o === xr) && i === ji) {
      y = vr;
      var M = p && T === k && k.visualViewport ? k.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        T[O]
      );
      f -= M - n.width, f *= c ? 1 : -1;
    }
  }
  var I = Object.assign({
    position: s
  }, d && zy), E = u === !0 ? By({
    x: f,
    y: g
  }, sr(t)) : {
    x: f,
    y: g
  };
  if (f = E.x, g = E.y, c) {
    var N;
    return Object.assign({}, I, (N = {}, N[C] = v ? "0" : "", N[y] = x ? "0" : "", N.transform = (k.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + g + "px)" : "translate3d(" + f + "px, " + g + "px, 0)", N));
  }
  return Object.assign({}, I, (e = {}, e[C] = v ? g + "px" : "", e[y] = x ? f + "px" : "", e.transform = "", e));
}
function Fy(r) {
  var e = r.state, t = r.options, n = t.gpuAcceleration, o = n === void 0 ? !0 : n, i = t.adaptive, a = i === void 0 ? !0 : i, s = t.roundOffsets, c = s === void 0 ? !0 : s, d = {
    placement: Lr(e.placement),
    variation: go(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, du(Object.assign({}, d, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: a,
    roundOffsets: c
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, du(Object.assign({}, d, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const _y = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Fy,
  data: {}
};
var ba = {
  passive: !0
};
function $y(r) {
  var e = r.state, t = r.instance, n = r.options, o = n.scroll, i = o === void 0 ? !0 : o, a = n.resize, s = a === void 0 ? !0 : a, c = sr(e.elements.popper), d = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && d.forEach(function(u) {
    u.addEventListener("scroll", t.update, ba);
  }), s && c.addEventListener("resize", t.update, ba), function() {
    i && d.forEach(function(u) {
      u.removeEventListener("scroll", t.update, ba);
    }), s && c.removeEventListener("resize", t.update, ba);
  };
}
const Wy = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: $y,
  data: {}
};
var Hy = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Na(r) {
  return r.replace(/left|right|bottom|top/g, function(e) {
    return Hy[e];
  });
}
var Yy = {
  start: "end",
  end: "start"
};
function uu(r) {
  return r.replace(/start|end/g, function(e) {
    return Yy[e];
  });
}
function $c(r) {
  var e = sr(r), t = e.pageXOffset, n = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: n
  };
}
function Wc(r) {
  return fo(mn(r)).left + $c(r).scrollLeft;
}
function Xy(r, e) {
  var t = sr(r), n = mn(r), o = t.visualViewport, i = n.clientWidth, a = n.clientHeight, s = 0, c = 0;
  if (o) {
    i = o.width, a = o.height;
    var d = Tf();
    (d || !d && e === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s + Wc(r),
    y: c
  };
}
function Vy(r) {
  var e, t = mn(r), n = $c(r), o = (e = r.ownerDocument) == null ? void 0 : e.body, i = Nn(t.scrollWidth, t.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = Nn(t.scrollHeight, t.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -n.scrollLeft + Wc(r), c = -n.scrollTop;
  return Xr(o || t).direction === "rtl" && (s += Nn(t.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: s,
    y: c
  };
}
function Hc(r) {
  var e = Xr(r), t = e.overflow, n = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + o + n);
}
function Mf(r) {
  return ["html", "body", "#document"].indexOf(Dr(r)) >= 0 ? r.ownerDocument.body : gr(r) && Hc(r) ? r : Mf(xs(r));
}
function Si(r, e) {
  var t;
  e === void 0 && (e = []);
  var n = Mf(r), o = n === ((t = r.ownerDocument) == null ? void 0 : t.body), i = sr(n), a = o ? [i].concat(i.visualViewport || [], Hc(n) ? n : []) : n, s = e.concat(a);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Si(xs(a)))
  );
}
function Bl(r) {
  return Object.assign({}, r, {
    left: r.x,
    top: r.y,
    right: r.x + r.width,
    bottom: r.y + r.height
  });
}
function Uy(r, e) {
  var t = fo(r, !1, e === "fixed");
  return t.top = t.top + r.clientTop, t.left = t.left + r.clientLeft, t.bottom = t.top + r.clientHeight, t.right = t.left + r.clientWidth, t.width = r.clientWidth, t.height = r.clientHeight, t.x = t.left, t.y = t.top, t;
}
function pu(r, e, t) {
  return e === kf ? Bl(Xy(r, t)) : Bn(e) ? Uy(e, t) : Bl(Vy(mn(r)));
}
function Gy(r) {
  var e = Si(xs(r)), t = ["absolute", "fixed"].indexOf(Xr(r).position) >= 0, n = t && gr(r) ? Zi(r) : r;
  return Bn(n) ? e.filter(function(o) {
    return Bn(o) && Af(o, n) && Dr(o) !== "body";
  }) : [];
}
function qy(r, e, t, n) {
  var o = e === "clippingParents" ? Gy(r) : [].concat(e), i = [].concat(o, [t]), a = i[0], s = i.reduce(function(c, d) {
    var u = pu(r, d, n);
    return c.top = Nn(u.top, c.top), c.right = Ua(u.right, c.right), c.bottom = Ua(u.bottom, c.bottom), c.left = Nn(u.left, c.left), c;
  }, pu(r, a, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Ef(r) {
  var e = r.reference, t = r.element, n = r.placement, o = n ? Lr(n) : null, i = n ? go(n) : null, a = e.x + e.width / 2 - t.width / 2, s = e.y + e.height / 2 - t.height / 2, c;
  switch (o) {
    case Qt:
      c = {
        x: a,
        y: e.y - t.height
      };
      break;
    case xr:
      c = {
        x: a,
        y: e.y + e.height
      };
      break;
    case vr:
      c = {
        x: e.x + e.width,
        y: s
      };
      break;
    case er:
      c = {
        x: e.x - t.width,
        y: s
      };
      break;
    default:
      c = {
        x: e.x,
        y: e.y
      };
  }
  var d = o ? _c(o) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (i) {
      case po:
        c[d] = c[d] - (e[u] / 2 - t[u] / 2);
        break;
      case ji:
        c[d] = c[d] + (e[u] / 2 - t[u] / 2);
        break;
    }
  }
  return c;
}
function Di(r, e) {
  e === void 0 && (e = {});
  var t = e, n = t.placement, o = n === void 0 ? r.placement : n, i = t.strategy, a = i === void 0 ? r.strategy : i, s = t.boundary, c = s === void 0 ? gy : s, d = t.rootBoundary, u = d === void 0 ? kf : d, p = t.elementContext, h = p === void 0 ? Do : p, f = t.altBoundary, m = f === void 0 ? !1 : f, g = t.padding, b = g === void 0 ? 0 : g, x = Rf(typeof b != "number" ? b : Pf(b, Ki)), v = h === Do ? my : Do, y = r.rects.popper, C = r.elements[m ? v : h], k = qy(Bn(C) ? C : C.contextElement || mn(r.elements.popper), c, u, a), T = fo(r.elements.reference), S = Ef({
    reference: T,
    element: y,
    placement: o
  }), O = Bl(Object.assign({}, y, S)), P = h === Do ? O : T, M = {
    top: k.top - P.top + x.top,
    bottom: P.bottom - k.bottom + x.bottom,
    left: k.left - P.left + x.left,
    right: P.right - k.right + x.right
  }, I = r.modifiersData.offset;
  if (h === Do && I) {
    var E = I[o];
    Object.keys(M).forEach(function(N) {
      var L = [vr, xr].indexOf(N) >= 0 ? 1 : -1, z = [Qt, xr].indexOf(N) >= 0 ? "y" : "x";
      M[N] += E[z] * L;
    });
  }
  return M;
}
function Ky(r, e) {
  e === void 0 && (e = {});
  var t = e, n = t.placement, o = t.boundary, i = t.rootBoundary, a = t.padding, s = t.flipVariations, c = t.allowedAutoPlacements, d = c === void 0 ? Sf : c, u = go(n), p = u ? s ? lu : lu.filter(function(m) {
    return go(m) === u;
  }) : Ki, h = p.filter(function(m) {
    return d.indexOf(m) >= 0;
  });
  h.length === 0 && (h = p);
  var f = h.reduce(function(m, g) {
    return m[g] = Di(r, {
      placement: g,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[Lr(g)], m;
  }, {});
  return Object.keys(f).sort(function(m, g) {
    return f[m] - f[g];
  });
}
function Zy(r) {
  if (Lr(r) === zc)
    return [];
  var e = Na(r);
  return [uu(r), e, uu(e)];
}
function Jy(r) {
  var e = r.state, t = r.options, n = r.name;
  if (!e.modifiersData[n]._skip) {
    for (var o = t.mainAxis, i = o === void 0 ? !0 : o, a = t.altAxis, s = a === void 0 ? !0 : a, c = t.fallbackPlacements, d = t.padding, u = t.boundary, p = t.rootBoundary, h = t.altBoundary, f = t.flipVariations, m = f === void 0 ? !0 : f, g = t.allowedAutoPlacements, b = e.options.placement, x = Lr(b), v = x === b, y = c || (v || !m ? [Na(b)] : Zy(b)), C = [b].concat(y).reduce(function(ne, pe) {
      return ne.concat(Lr(pe) === zc ? Ky(e, {
        placement: pe,
        boundary: u,
        rootBoundary: p,
        padding: d,
        flipVariations: m,
        allowedAutoPlacements: g
      }) : pe);
    }, []), k = e.rects.reference, T = e.rects.popper, S = /* @__PURE__ */ new Map(), O = !0, P = C[0], M = 0; M < C.length; M++) {
      var I = C[M], E = Lr(I), N = go(I) === po, L = [Qt, xr].indexOf(E) >= 0, z = L ? "width" : "height", F = Di(e, {
        placement: I,
        boundary: u,
        rootBoundary: p,
        altBoundary: h,
        padding: d
      }), B = L ? N ? vr : er : N ? xr : Qt;
      k[z] > T[z] && (B = Na(B));
      var D = Na(B), W = [];
      if (i && W.push(F[E] <= 0), s && W.push(F[B] <= 0, F[D] <= 0), W.every(function(ne) {
        return ne;
      })) {
        P = I, O = !1;
        break;
      }
      S.set(I, W);
    }
    if (O)
      for (var G = m ? 3 : 1, re = function(pe) {
        var K = C.find(function(le) {
          var Q = S.get(le);
          if (Q)
            return Q.slice(0, pe).every(function(se) {
              return se;
            });
        });
        if (K)
          return P = K, "break";
      }, ce = G; ce > 0; ce--) {
        var Ce = re(ce);
        if (Ce === "break") break;
      }
    e.placement !== P && (e.modifiersData[n]._skip = !0, e.placement = P, e.reset = !0);
  }
}
const Qy = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Jy,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function hu(r, e, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: r.top - e.height - t.y,
    right: r.right - e.width + t.x,
    bottom: r.bottom - e.height + t.y,
    left: r.left - e.width - t.x
  };
}
function fu(r) {
  return [Qt, vr, xr, er].some(function(e) {
    return r[e] >= 0;
  });
}
function e0(r) {
  var e = r.state, t = r.name, n = e.rects.reference, o = e.rects.popper, i = e.modifiersData.preventOverflow, a = Di(e, {
    elementContext: "reference"
  }), s = Di(e, {
    altBoundary: !0
  }), c = hu(a, n), d = hu(s, o, i), u = fu(c), p = fu(d);
  e.modifiersData[t] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: p
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": p
  });
}
const t0 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: e0
};
function r0(r, e, t) {
  var n = Lr(r), o = [er, Qt].indexOf(n) >= 0 ? -1 : 1, i = typeof t == "function" ? t(Object.assign({}, e, {
    placement: r
  })) : t, a = i[0], s = i[1];
  return a = a || 0, s = (s || 0) * o, [er, vr].indexOf(n) >= 0 ? {
    x: s,
    y: a
  } : {
    x: a,
    y: s
  };
}
function n0(r) {
  var e = r.state, t = r.options, n = r.name, o = t.offset, i = o === void 0 ? [0, 0] : o, a = Sf.reduce(function(u, p) {
    return u[p] = r0(p, e.rects, i), u;
  }, {}), s = a[e.placement], c = s.x, d = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += c, e.modifiersData.popperOffsets.y += d), e.modifiersData[n] = a;
}
const o0 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: n0
};
function i0(r) {
  var e = r.state, t = r.name;
  e.modifiersData[t] = Ef({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const a0 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: i0,
  data: {}
};
function s0(r) {
  return r === "x" ? "y" : "x";
}
function l0(r) {
  var e = r.state, t = r.options, n = r.name, o = t.mainAxis, i = o === void 0 ? !0 : o, a = t.altAxis, s = a === void 0 ? !1 : a, c = t.boundary, d = t.rootBoundary, u = t.altBoundary, p = t.padding, h = t.tether, f = h === void 0 ? !0 : h, m = t.tetherOffset, g = m === void 0 ? 0 : m, b = Di(e, {
    boundary: c,
    rootBoundary: d,
    padding: p,
    altBoundary: u
  }), x = Lr(e.placement), v = go(e.placement), y = !v, C = _c(x), k = s0(C), T = e.modifiersData.popperOffsets, S = e.rects.reference, O = e.rects.popper, P = typeof g == "function" ? g(Object.assign({}, e.rects, {
    placement: e.placement
  })) : g, M = typeof P == "number" ? {
    mainAxis: P,
    altAxis: P
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, P), I = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, E = {
    x: 0,
    y: 0
  };
  if (T) {
    if (i) {
      var N, L = C === "y" ? Qt : er, z = C === "y" ? xr : vr, F = C === "y" ? "height" : "width", B = T[C], D = B + b[L], W = B - b[z], G = f ? -O[F] / 2 : 0, re = v === po ? S[F] : O[F], ce = v === po ? -O[F] : -S[F], Ce = e.elements.arrow, ne = f && Ce ? Fc(Ce) : {
        width: 0,
        height: 0
      }, pe = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Of(), K = pe[L], le = pe[z], Q = ki(0, S[F], ne[F]), se = y ? S[F] / 2 - G - Q - K - M.mainAxis : re - Q - K - M.mainAxis, Re = y ? -S[F] / 2 + G + Q + le + M.mainAxis : ce + Q + le + M.mainAxis, be = e.elements.arrow && Zi(e.elements.arrow), Ne = be ? C === "y" ? be.clientTop || 0 : be.clientLeft || 0 : 0, ke = (N = I?.[C]) != null ? N : 0, Oe = B + se - ke - Ne, Te = B + Re - ke, me = ki(f ? Ua(D, Oe) : D, B, f ? Nn(W, Te) : W);
      T[C] = me, E[C] = me - B;
    }
    if (s) {
      var tt, Se = C === "x" ? Qt : er, Ke = C === "x" ? xr : vr, He = T[k], _e = k === "y" ? "height" : "width", Qe = He + b[Se], Ue = He - b[Ke], Ye = [Qt, er].indexOf(x) !== -1, ht = (tt = I?.[k]) != null ? tt : 0, bt = Ye ? Qe : He - S[_e] - O[_e] - ht + M.altAxis, mt = Ye ? He + S[_e] + O[_e] - ht - M.altAxis : Ue, Ie = f && Ye ? Iy(bt, He, mt) : ki(f ? bt : Qe, He, f ? mt : Ue);
      T[k] = Ie, E[k] = Ie - He;
    }
    e.modifiersData[n] = E;
  }
}
const c0 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: l0,
  requiresIfExists: ["offset"]
};
function d0(r) {
  return {
    scrollLeft: r.scrollLeft,
    scrollTop: r.scrollTop
  };
}
function u0(r) {
  return r === sr(r) || !gr(r) ? $c(r) : d0(r);
}
function p0(r) {
  var e = r.getBoundingClientRect(), t = ho(e.width) / r.offsetWidth || 1, n = ho(e.height) / r.offsetHeight || 1;
  return t !== 1 || n !== 1;
}
function h0(r, e, t) {
  t === void 0 && (t = !1);
  var n = gr(e), o = gr(e) && p0(e), i = mn(e), a = fo(r, o, t), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (n || !n && !t) && ((Dr(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Hc(i)) && (s = u0(e)), gr(e) ? (c = fo(e, !0), c.x += e.clientLeft, c.y += e.clientTop) : i && (c.x = Wc(i))), {
    x: a.left + s.scrollLeft - c.x,
    y: a.top + s.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function f0(r) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = [];
  r.forEach(function(i) {
    e.set(i.name, i);
  });
  function o(i) {
    t.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(s) {
      if (!t.has(s)) {
        var c = e.get(s);
        c && o(c);
      }
    }), n.push(i);
  }
  return r.forEach(function(i) {
    t.has(i.name) || o(i);
  }), n;
}
function g0(r) {
  var e = f0(r);
  return Ay.reduce(function(t, n) {
    return t.concat(e.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function m0(r) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(r());
      });
    })), e;
  };
}
function b0(r) {
  var e = r.reduce(function(t, n) {
    var o = t[n.name];
    return t[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
var gu = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function mu() {
  for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  return !e.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function x0(r) {
  r === void 0 && (r = {});
  var e = r, t = e.defaultModifiers, n = t === void 0 ? [] : t, o = e.defaultOptions, i = o === void 0 ? gu : o;
  return function(s, c, d) {
    d === void 0 && (d = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, gu, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: c
      },
      attributes: {},
      styles: {}
    }, p = [], h = !1, f = {
      state: u,
      setOptions: function(x) {
        var v = typeof x == "function" ? x(u.options) : x;
        g(), u.options = Object.assign({}, i, u.options, v), u.scrollParents = {
          reference: Bn(s) ? Si(s) : s.contextElement ? Si(s.contextElement) : [],
          popper: Si(c)
        };
        var y = g0(b0([].concat(n, u.options.modifiers)));
        return u.orderedModifiers = y.filter(function(C) {
          return C.enabled;
        }), m(), f.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var x = u.elements, v = x.reference, y = x.popper;
          if (mu(v, y)) {
            u.rects = {
              reference: h0(v, Zi(y), u.options.strategy === "fixed"),
              popper: Fc(y)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(M) {
              return u.modifiersData[M.name] = Object.assign({}, M.data);
            });
            for (var C = 0; C < u.orderedModifiers.length; C++) {
              if (u.reset === !0) {
                u.reset = !1, C = -1;
                continue;
              }
              var k = u.orderedModifiers[C], T = k.fn, S = k.options, O = S === void 0 ? {} : S, P = k.name;
              typeof T == "function" && (u = T({
                state: u,
                options: O,
                name: P,
                instance: f
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: m0(function() {
        return new Promise(function(b) {
          f.forceUpdate(), b(u);
        });
      }),
      destroy: function() {
        g(), h = !0;
      }
    };
    if (!mu(s, c))
      return f;
    f.setOptions(d).then(function(b) {
      !h && d.onFirstUpdate && d.onFirstUpdate(b);
    });
    function m() {
      u.orderedModifiers.forEach(function(b) {
        var x = b.name, v = b.options, y = v === void 0 ? {} : v, C = b.effect;
        if (typeof C == "function") {
          var k = C({
            state: u,
            name: x,
            instance: f,
            options: y
          }), T = function() {
          };
          p.push(k || T);
        }
      });
    }
    function g() {
      p.forEach(function(b) {
        return b();
      }), p = [];
    }
    return f;
  };
}
var v0 = [Wy, a0, _y, Py, o0, Qy, c0, Dy, t0], y0 = /* @__PURE__ */ x0({
  defaultModifiers: v0
});
function w0(r) {
  return typeof r == "function" ? r() : r;
}
const zi = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const {
    children: n,
    container: o,
    disablePortal: i = !1
  } = e, [a, s] = R.useState(null), c = ut(/* @__PURE__ */ R.isValidElement(n) ? fn(n) : null, t);
  if (qt(() => {
    i || s(w0(o) || document.body);
  }, [o, i]), qt(() => {
    if (a && !i)
      return Ni(t, a), () => {
        Ni(t, null);
      };
  }, [t, a, i]), i) {
    if (/* @__PURE__ */ R.isValidElement(n)) {
      const d = {
        ref: c
      };
      return /* @__PURE__ */ R.cloneElement(n, d);
    }
    return /* @__PURE__ */ w.jsx(R.Fragment, {
      children: n
    });
  }
  return /* @__PURE__ */ w.jsx(R.Fragment, {
    children: a && /* @__PURE__ */ yb.createPortal(n, a)
  });
});
process.env.NODE_ENV !== "production" && (zi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: l.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([jr, l.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool
});
process.env.NODE_ENV !== "production" && (zi.propTypes = ko(zi.propTypes));
function C0(r) {
  return fe("MuiPopper", r);
}
ue("MuiPopper", ["root"]);
const k0 = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], S0 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function T0(r, e) {
  if (e === "ltr")
    return r;
  switch (r) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return r;
  }
}
function Ga(r) {
  return typeof r == "function" ? r() : r;
}
function vs(r) {
  return r.nodeType !== void 0;
}
function A0(r) {
  return !vs(r);
}
const O0 = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, C0, e);
}, R0 = {}, P0 = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n;
  const {
    anchorEl: o,
    children: i,
    direction: a,
    disablePortal: s,
    modifiers: c,
    open: d,
    placement: u,
    popperOptions: p,
    popperRef: h,
    slotProps: f = {},
    slots: m = {},
    TransitionProps: g
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = e, b = q(e, k0), x = R.useRef(null), v = ut(x, t), y = R.useRef(null), C = ut(y, h), k = R.useRef(C);
  qt(() => {
    k.current = C;
  }, [C]), R.useImperativeHandle(h, () => y.current, []);
  const T = T0(u, a), [S, O] = R.useState(T), [P, M] = R.useState(Ga(o));
  R.useEffect(() => {
    y.current && y.current.forceUpdate();
  }), R.useEffect(() => {
    o && M(Ga(o));
  }, [o]), qt(() => {
    if (!P || !d)
      return;
    const z = (D) => {
      O(D.placement);
    };
    if (process.env.NODE_ENV !== "production" && P && vs(P) && P.nodeType === 1) {
      const D = P.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && D.top === 0 && D.left === 0 && D.right === 0 && D.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let F = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: D
      }) => {
        z(D);
      }
    }];
    c != null && (F = F.concat(c)), p && p.modifiers != null && (F = F.concat(p.modifiers));
    const B = y0(P, x.current, A({
      placement: T
    }, p, {
      modifiers: F
    }));
    return k.current(B), () => {
      B.destroy(), k.current(null);
    };
  }, [P, s, c, d, p, T]);
  const I = {
    placement: S
  };
  g !== null && (I.TransitionProps = g);
  const E = O0(e), N = (n = m.root) != null ? n : "div", L = tr({
    elementType: N,
    externalSlotProps: f.root,
    externalForwardedProps: b,
    additionalProps: {
      role: "tooltip",
      ref: v
    },
    ownerState: e,
    className: E.root
  });
  return /* @__PURE__ */ w.jsx(N, A({}, L, {
    children: typeof i == "function" ? i(I) : i
  }));
}), If = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const {
    anchorEl: n,
    children: o,
    container: i,
    direction: a = "ltr",
    disablePortal: s = !1,
    keepMounted: c = !1,
    modifiers: d,
    open: u,
    placement: p = "bottom",
    popperOptions: h = R0,
    popperRef: f,
    style: m,
    transition: g = !1,
    slotProps: b = {},
    slots: x = {}
  } = e, v = q(e, S0), [y, C] = R.useState(!0), k = () => {
    C(!1);
  }, T = () => {
    C(!0);
  };
  if (!c && !u && (!g || y))
    return null;
  let S;
  if (i)
    S = i;
  else if (n) {
    const M = Ga(n);
    S = M && vs(M) ? Rt(M).body : Rt(null).body;
  }
  const O = !u && c && (!g || y) ? "none" : void 0, P = g ? {
    in: u,
    onEnter: k,
    onExited: T
  } : void 0;
  return /* @__PURE__ */ w.jsx(zi, {
    disablePortal: s,
    container: S,
    children: /* @__PURE__ */ w.jsx(P0, A({
      anchorEl: n,
      direction: a,
      disablePortal: s,
      modifiers: d,
      ref: t,
      open: g ? !y : u,
      placement: p,
      popperOptions: h,
      popperRef: f,
      slotProps: b,
      slots: x
    }, v, {
      style: A({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: O
      }, m),
      TransitionProps: P,
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (If.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: Ft(l.oneOfType([jr, l.object, l.func]), (r) => {
    if (r.open) {
      const e = Ga(r.anchorEl);
      if (e && vs(e) && e.nodeType === 1) {
        const t = e.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && t.top === 0 && t.left === 0 && t.right === 0 && t.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!e || typeof e.getBoundingClientRect != "function" || A0(e) && e.contextElement != null && e.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: l.oneOfType([l.node, l.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([jr, l.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: l.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: l.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: l.arrayOf(l.shape({
    data: l.object,
    effect: l.func,
    enabled: l.bool,
    fn: l.func,
    name: l.any,
    options: l.object,
    phase: l.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: l.arrayOf(l.string),
    requiresIfExists: l.arrayOf(l.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: l.shape({
    modifiers: l.array,
    onFirstUpdate: l.func,
    placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: l.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: $t,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: l.shape({
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: l.bool
});
const M0 = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], E0 = H(If, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({}), Ji = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n;
  const o = fy(), i = ge({
    props: e,
    name: "MuiPopper"
  }), {
    anchorEl: a,
    component: s,
    components: c,
    componentsProps: d,
    container: u,
    disablePortal: p,
    keepMounted: h,
    modifiers: f,
    open: m,
    placement: g,
    popperOptions: b,
    popperRef: x,
    transition: v,
    slots: y,
    slotProps: C
  } = i, k = q(i, M0), T = (n = y?.root) != null ? n : c?.Root, S = A({
    anchorEl: a,
    container: u,
    disablePortal: p,
    keepMounted: h,
    modifiers: f,
    open: m,
    placement: g,
    popperOptions: b,
    popperRef: x,
    transition: v
  }, k);
  return /* @__PURE__ */ w.jsx(E0, A({
    as: s,
    direction: o?.direction,
    slots: {
      root: T
    },
    slotProps: C ?? d
  }, S, {
    ref: t
  }));
});
process.env.NODE_ENV !== "production" && (Ji.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: l.oneOfType([jr, l.object, l.func]),
  /**
   * Popper render function or node.
   */
  children: l.oneOfType([l.node, l.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: l.shape({
    Root: l.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: l.shape({
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([jr, l.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: l.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: l.arrayOf(l.shape({
    data: l.object,
    effect: l.func,
    enabled: l.bool,
    fn: l.func,
    name: l.any,
    options: l.object,
    phase: l.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: l.arrayOf(l.string),
    requiresIfExists: l.arrayOf(l.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: l.shape({
    modifiers: l.array,
    onFirstUpdate: l.func,
    placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: l.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: $t,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: l.shape({
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: l.bool
});
function I0(r) {
  return fe("MuiListSubheader", r);
}
ue("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const N0 = ["className", "color", "component", "disableGutters", "disableSticky", "inset"], L0 = (r) => {
  const {
    classes: e,
    color: t,
    disableGutters: n,
    inset: o,
    disableSticky: i
  } = r, a = {
    root: ["root", t !== "default" && `color${V(t)}`, !n && "gutters", o && "inset", !i && "sticky"]
  };
  return he(a, I0, e);
}, j0 = H("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.color !== "default" && e[`color${V(t.color)}`], !t.disableGutters && e.gutters, t.inset && e.inset, !t.disableSticky && e.sticky];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (r.vars || r).palette.text.secondary,
  fontFamily: r.typography.fontFamily,
  fontWeight: r.typography.fontWeightMedium,
  fontSize: r.typography.pxToRem(14)
}, e.color === "primary" && {
  color: (r.vars || r).palette.primary.main
}, e.color === "inherit" && {
  color: "inherit"
}, !e.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, e.inset && {
  paddingLeft: 72
}, !e.disableSticky && {
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: (r.vars || r).palette.background.paper
})), Yc = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiListSubheader"
  }), {
    className: o,
    color: i = "default",
    component: a = "li",
    disableGutters: s = !1,
    disableSticky: c = !1,
    inset: d = !1
  } = n, u = q(n, N0), p = A({}, n, {
    color: i,
    component: a,
    disableGutters: s,
    disableSticky: c,
    inset: d
  }), h = L0(p);
  return /* @__PURE__ */ w.jsx(j0, A({
    as: a,
    className: Y(h.root, o),
    ref: t,
    ownerState: p
  }, u));
});
Yc.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (Yc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: l.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: l.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const D0 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function z0(r) {
  return fe("MuiChip", r);
}
const rt = ue("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), B0 = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], F0 = (r) => {
  const {
    classes: e,
    disabled: t,
    size: n,
    color: o,
    iconColor: i,
    onDelete: a,
    clickable: s,
    variant: c
  } = r, d = {
    root: ["root", c, t && "disabled", `size${V(n)}`, `color${V(o)}`, s && "clickable", s && `clickableColor${V(o)}`, a && "deletable", a && `deletableColor${V(o)}`, `${c}${V(o)}`],
    label: ["label", `label${V(n)}`],
    avatar: ["avatar", `avatar${V(n)}`, `avatarColor${V(o)}`],
    icon: ["icon", `icon${V(n)}`, `iconColor${V(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${V(n)}`, `deleteIconColor${V(o)}`, `deleteIcon${V(c)}Color${V(o)}`]
  };
  return he(d, z0, e);
}, _0 = H("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r, {
      color: n,
      iconColor: o,
      clickable: i,
      onDelete: a,
      size: s,
      variant: c
    } = t;
    return [{
      [`& .${rt.avatar}`]: e.avatar
    }, {
      [`& .${rt.avatar}`]: e[`avatar${V(s)}`]
    }, {
      [`& .${rt.avatar}`]: e[`avatarColor${V(n)}`]
    }, {
      [`& .${rt.icon}`]: e.icon
    }, {
      [`& .${rt.icon}`]: e[`icon${V(s)}`]
    }, {
      [`& .${rt.icon}`]: e[`iconColor${V(o)}`]
    }, {
      [`& .${rt.deleteIcon}`]: e.deleteIcon
    }, {
      [`& .${rt.deleteIcon}`]: e[`deleteIcon${V(s)}`]
    }, {
      [`& .${rt.deleteIcon}`]: e[`deleteIconColor${V(n)}`]
    }, {
      [`& .${rt.deleteIcon}`]: e[`deleteIcon${V(c)}Color${V(n)}`]
    }, e.root, e[`size${V(s)}`], e[`color${V(n)}`], i && e.clickable, i && n !== "default" && e[`clickableColor${V(n)})`], a && e.deletable, a && n !== "default" && e[`deletableColor${V(n)}`], e[c], e[`${c}${V(n)}`]];
  }
})(({
  theme: r,
  ownerState: e
}) => {
  const t = r.palette.mode === "light" ? r.palette.grey[700] : r.palette.grey[300];
  return A({
    maxWidth: "100%",
    fontFamily: r.typography.fontFamily,
    fontSize: r.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (r.vars || r).palette.text.primary,
    backgroundColor: (r.vars || r).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: r.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${rt.disabled}`]: {
      opacity: (r.vars || r).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${rt.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: r.vars ? r.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: r.typography.pxToRem(12)
    },
    [`& .${rt.avatarColorPrimary}`]: {
      color: (r.vars || r).palette.primary.contrastText,
      backgroundColor: (r.vars || r).palette.primary.dark
    },
    [`& .${rt.avatarColorSecondary}`]: {
      color: (r.vars || r).palette.secondary.contrastText,
      backgroundColor: (r.vars || r).palette.secondary.dark
    },
    [`& .${rt.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: r.typography.pxToRem(10)
    },
    [`& .${rt.icon}`]: A({
      marginLeft: 5,
      marginRight: -6
    }, e.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, e.iconColor === e.color && A({
      color: r.vars ? r.vars.palette.Chip.defaultIconColor : t
    }, e.color !== "default" && {
      color: "inherit"
    })),
    [`& .${rt.deleteIcon}`]: A({
      WebkitTapHighlightColor: "transparent",
      color: r.vars ? `rgba(${r.vars.palette.text.primaryChannel} / 0.26)` : Pe.alpha(r.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: r.vars ? `rgba(${r.vars.palette.text.primaryChannel} / 0.4)` : Pe.alpha(r.palette.text.primary, 0.4)
      }
    }, e.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, e.color !== "default" && {
      color: r.vars ? `rgba(${r.vars.palette[e.color].contrastTextChannel} / 0.7)` : Pe.alpha(r.palette[e.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (r.vars || r).palette[e.color].contrastText
      }
    })
  }, e.size === "small" && {
    height: 24
  }, e.color !== "default" && {
    backgroundColor: (r.vars || r).palette[e.color].main,
    color: (r.vars || r).palette[e.color].contrastText
  }, e.onDelete && {
    [`&.${rt.focusVisible}`]: {
      backgroundColor: r.vars ? `rgba(${r.vars.palette.action.selectedChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.focusOpacity}))` : Pe.alpha(r.palette.action.selected, r.palette.action.selectedOpacity + r.palette.action.focusOpacity)
    }
  }, e.onDelete && e.color !== "default" && {
    [`&.${rt.focusVisible}`]: {
      backgroundColor: (r.vars || r).palette[e.color].dark
    }
  });
}, ({
  theme: r,
  ownerState: e
}) => A({}, e.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: r.vars ? `rgba(${r.vars.palette.action.selectedChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.hoverOpacity}))` : Pe.alpha(r.palette.action.selected, r.palette.action.selectedOpacity + r.palette.action.hoverOpacity)
  },
  [`&.${rt.focusVisible}`]: {
    backgroundColor: r.vars ? `rgba(${r.vars.palette.action.selectedChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.focusOpacity}))` : Pe.alpha(r.palette.action.selected, r.palette.action.selectedOpacity + r.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (r.vars || r).shadows[1]
  }
}, e.clickable && e.color !== "default" && {
  [`&:hover, &.${rt.focusVisible}`]: {
    backgroundColor: (r.vars || r).palette[e.color].dark
  }
}), ({
  theme: r,
  ownerState: e
}) => A({}, e.variant === "outlined" && {
  backgroundColor: "transparent",
  border: r.vars ? `1px solid ${r.vars.palette.Chip.defaultBorder}` : `1px solid ${r.palette.mode === "light" ? r.palette.grey[400] : r.palette.grey[700]}`,
  [`&.${rt.clickable}:hover`]: {
    backgroundColor: (r.vars || r).palette.action.hover
  },
  [`&.${rt.focusVisible}`]: {
    backgroundColor: (r.vars || r).palette.action.focus
  },
  [`& .${rt.avatar}`]: {
    marginLeft: 4
  },
  [`& .${rt.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${rt.icon}`]: {
    marginLeft: 4
  },
  [`& .${rt.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${rt.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${rt.deleteIconSmall}`]: {
    marginRight: 3
  }
}, e.variant === "outlined" && e.color !== "default" && {
  color: (r.vars || r).palette[e.color].main,
  border: `1px solid ${r.vars ? `rgba(${r.vars.palette[e.color].mainChannel} / 0.7)` : Pe.alpha(r.palette[e.color].main, 0.7)}`,
  [`&.${rt.clickable}:hover`]: {
    backgroundColor: r.vars ? `rgba(${r.vars.palette[e.color].mainChannel} / ${r.vars.palette.action.hoverOpacity})` : Pe.alpha(r.palette[e.color].main, r.palette.action.hoverOpacity)
  },
  [`&.${rt.focusVisible}`]: {
    backgroundColor: r.vars ? `rgba(${r.vars.palette[e.color].mainChannel} / ${r.vars.palette.action.focusOpacity})` : Pe.alpha(r.palette[e.color].main, r.palette.action.focusOpacity)
  },
  [`& .${rt.deleteIcon}`]: {
    color: r.vars ? `rgba(${r.vars.palette[e.color].mainChannel} / 0.7)` : Pe.alpha(r.palette[e.color].main, 0.7),
    "&:hover, &:active": {
      color: (r.vars || r).palette[e.color].main
    }
  }
})), $0 = H("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r, {
      size: n
    } = t;
    return [e.label, e[`label${V(n)}`]];
  }
})(({
  ownerState: r
}) => A({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, r.variant === "outlined" && {
  paddingLeft: 11,
  paddingRight: 11
}, r.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}, r.size === "small" && r.variant === "outlined" && {
  paddingLeft: 7,
  paddingRight: 7
}));
function bu(r) {
  return r.key === "Backspace" || r.key === "Delete";
}
const ys = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiChip"
  }), {
    avatar: o,
    className: i,
    clickable: a,
    color: s = "default",
    component: c,
    deleteIcon: d,
    disabled: u = !1,
    icon: p,
    label: h,
    onClick: f,
    onDelete: m,
    onKeyDown: g,
    onKeyUp: b,
    size: x = "medium",
    variant: v = "filled",
    tabIndex: y,
    skipFocusWhenDisabled: C = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = n, k = q(n, B0), T = R.useRef(null), S = ut(T, t), O = (W) => {
    W.stopPropagation(), m && m(W);
  }, P = (W) => {
    W.currentTarget === W.target && bu(W) && W.preventDefault(), g && g(W);
  }, M = (W) => {
    W.currentTarget === W.target && (m && bu(W) ? m(W) : W.key === "Escape" && T.current && T.current.blur()), b && b(W);
  }, I = a !== !1 && f ? !0 : a, E = I || m ? Kt : c || "div", N = A({}, n, {
    component: E,
    disabled: u,
    size: x,
    color: s,
    iconColor: /* @__PURE__ */ R.isValidElement(p) && p.props.color || s,
    onDelete: !!m,
    clickable: I,
    variant: v
  }), L = F0(N), z = E === Kt ? A({
    component: c || "div",
    focusVisibleClassName: L.focusVisible
  }, m && {
    disableRipple: !0
  }) : {};
  let F = null;
  m && (F = d && /* @__PURE__ */ R.isValidElement(d) ? /* @__PURE__ */ R.cloneElement(d, {
    className: Y(d.props.className, L.deleteIcon),
    onClick: O
  }) : /* @__PURE__ */ w.jsx(D0, {
    className: Y(L.deleteIcon),
    onClick: O
  }));
  let B = null;
  o && /* @__PURE__ */ R.isValidElement(o) && (B = /* @__PURE__ */ R.cloneElement(o, {
    className: Y(L.avatar, o.props.className)
  }));
  let D = null;
  return p && /* @__PURE__ */ R.isValidElement(p) && (D = /* @__PURE__ */ R.cloneElement(p, {
    className: Y(L.icon, p.props.className)
  })), process.env.NODE_ENV !== "production" && B && D && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ w.jsxs(_0, A({
    as: E,
    className: Y(L.root, i),
    disabled: I && u ? !0 : void 0,
    onClick: f,
    onKeyDown: P,
    onKeyUp: M,
    ref: S,
    tabIndex: C && u ? -1 : y,
    ownerState: N
  }, z, k, {
    children: [B || D, /* @__PURE__ */ w.jsx($0, {
      className: Y(L.label),
      ownerState: N,
      children: h
    }), F]
  }));
});
process.env.NODE_ENV !== "production" && (ys.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: l.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: Rc,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: l.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: l.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * Icon element.
   */
  icon: l.element,
  /**
   * The content of the component.
   */
  label: l.node,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * @ignore
   */
  onKeyUp: l.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @ignore
   */
  tabIndex: l.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: l.oneOfType([l.oneOf(["filled", "outlined"]), l.string])
});
const W0 = ["onChange", "maxRows", "minRows", "style", "value"];
function xa(r) {
  return parseInt(r, 10) || 0;
}
const H0 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function Y0(r) {
  for (const e in r)
    return !1;
  return !0;
}
function xu(r) {
  return Y0(r) || r.outerHeightStyle === 0 && !r.overflowing;
}
const Nf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const {
    onChange: n,
    maxRows: o,
    minRows: i = 1,
    style: a,
    value: s
  } = e, c = q(e, W0), {
    current: d
  } = R.useRef(s != null), u = R.useRef(null), p = ut(t, u), h = R.useRef(null), f = R.useRef(null), m = R.useCallback(() => {
    const y = u.current, C = f.current;
    if (!y || !C)
      return;
    const T = br(y).getComputedStyle(y);
    if (T.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    C.style.width = T.width, C.value = y.value || e.placeholder || "x", C.value.slice(-1) === `
` && (C.value += " ");
    const S = T.boxSizing, O = xa(T.paddingBottom) + xa(T.paddingTop), P = xa(T.borderBottomWidth) + xa(T.borderTopWidth), M = C.scrollHeight;
    C.value = "x";
    const I = C.scrollHeight;
    let E = M;
    i && (E = Math.max(Number(i) * I, E)), o && (E = Math.min(Number(o) * I, E)), E = Math.max(E, I);
    const N = E + (S === "border-box" ? O + P : 0), L = Math.abs(E - M) <= 1;
    return {
      outerHeightStyle: N,
      overflowing: L
    };
  }, [o, i, e.placeholder]), g = Lt(() => {
    const y = u.current, C = m();
    if (!y || !C || xu(C))
      return !1;
    const k = C.outerHeightStyle;
    return h.current != null && h.current !== k;
  }), b = R.useCallback(() => {
    const y = u.current, C = m();
    if (!y || !C || xu(C))
      return;
    const k = C.outerHeightStyle;
    h.current !== k && (h.current = k, y.style.height = `${k}px`), y.style.overflow = C.overflowing ? "hidden" : "";
  }, [m]), x = R.useRef(-1);
  qt(() => {
    const y = So(b), C = u?.current;
    if (!C)
      return;
    const k = br(C);
    k.addEventListener("resize", y);
    let T;
    return typeof ResizeObserver < "u" && (T = new ResizeObserver(() => {
      g() && (T.unobserve(C), cancelAnimationFrame(x.current), b(), x.current = requestAnimationFrame(() => {
        T.observe(C);
      }));
    }), T.observe(C)), () => {
      y.clear(), cancelAnimationFrame(x.current), k.removeEventListener("resize", y), T && T.disconnect();
    };
  }, [m, b, g]), qt(() => {
    b();
  });
  const v = (y) => {
    d || b(), n && n(y);
  };
  return /* @__PURE__ */ w.jsxs(R.Fragment, {
    children: [/* @__PURE__ */ w.jsx("textarea", A({
      value: s,
      onChange: v,
      ref: p,
      rows: i,
      style: a
    }, c)), /* @__PURE__ */ w.jsx("textarea", {
      "aria-hidden": !0,
      className: e.className,
      readOnly: !0,
      ref: f,
      tabIndex: -1,
      style: A({}, H0.shadow, a, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Nf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * @ignore
   */
  onChange: l.func,
  /**
   * @ignore
   */
  placeholder: l.string,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * @ignore
   */
  value: l.oneOfType([l.arrayOf(l.string), l.number, l.string])
});
function bn({
  props: r,
  states: e,
  muiFormControl: t
}) {
  return e.reduce((n, o) => (n[o] = r[o], t && typeof r[o] > "u" && (n[o] = t[o]), n), {});
}
const Qi = /* @__PURE__ */ R.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qi.displayName = "FormControlContext");
function Br() {
  return R.useContext(Qi);
}
function Xc(r) {
  return /* @__PURE__ */ w.jsx(Ac, A({}, r, {
    defaultTheme: Sc,
    themeId: uo
  }));
}
process.env.NODE_ENV !== "production" && (Xc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: l.oneOfType([l.array, l.func, l.number, l.object, l.string, l.bool])
});
function vu(r) {
  return r != null && !(Array.isArray(r) && r.length === 0);
}
function qa(r, e = !1) {
  return r && (vu(r.value) && r.value !== "" || e && vu(r.defaultValue) && r.defaultValue !== "");
}
function X0(r) {
  return r.startAdornment;
}
function V0(r) {
  return fe("MuiInputBase", r);
}
const or = ue("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), U0 = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], ws = (r, e) => {
  const {
    ownerState: t
  } = r;
  return [e.root, t.formControl && e.formControl, t.startAdornment && e.adornedStart, t.endAdornment && e.adornedEnd, t.error && e.error, t.size === "small" && e.sizeSmall, t.multiline && e.multiline, t.color && e[`color${V(t.color)}`], t.fullWidth && e.fullWidth, t.hiddenLabel && e.hiddenLabel];
}, Cs = (r, e) => {
  const {
    ownerState: t
  } = r;
  return [e.input, t.size === "small" && e.inputSizeSmall, t.multiline && e.inputMultiline, t.type === "search" && e.inputTypeSearch, t.startAdornment && e.inputAdornedStart, t.endAdornment && e.inputAdornedEnd, t.hiddenLabel && e.inputHiddenLabel];
}, G0 = (r) => {
  const {
    classes: e,
    color: t,
    disabled: n,
    error: o,
    endAdornment: i,
    focused: a,
    formControl: s,
    fullWidth: c,
    hiddenLabel: d,
    multiline: u,
    readOnly: p,
    size: h,
    startAdornment: f,
    type: m
  } = r, g = {
    root: ["root", `color${V(t)}`, n && "disabled", o && "error", c && "fullWidth", a && "focused", s && "formControl", h && h !== "medium" && `size${V(h)}`, u && "multiline", f && "adornedStart", i && "adornedEnd", d && "hiddenLabel", p && "readOnly"],
    input: ["input", n && "disabled", m === "search" && "inputTypeSearch", u && "inputMultiline", h === "small" && "inputSizeSmall", d && "inputHiddenLabel", f && "inputAdornedStart", i && "inputAdornedEnd", p && "readOnly"]
  };
  return he(g, V0, e);
}, ks = H("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: ws
})(({
  theme: r,
  ownerState: e
}) => A({}, r.typography.body1, {
  color: (r.vars || r).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${or.disabled}`]: {
    color: (r.vars || r).palette.text.disabled,
    cursor: "default"
  }
}, e.multiline && A({
  padding: "4px 0 5px"
}, e.size === "small" && {
  paddingTop: 1
}), e.fullWidth && {
  width: "100%"
})), Ss = H("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: Cs
})(({
  theme: r,
  ownerState: e
}) => {
  const t = r.palette.mode === "light", n = A({
    color: "currentColor"
  }, r.vars ? {
    opacity: r.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  }, {
    transition: r.transitions.create("opacity", {
      duration: r.transitions.duration.shorter
    })
  }), o = {
    opacity: "0 !important"
  }, i = r.vars ? {
    opacity: r.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return A({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&:-ms-input-placeholder": n,
    // IE11
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${or.formControl} &`]: {
      "&::-webkit-input-placeholder": o,
      "&::-moz-placeholder": o,
      // Firefox 19+
      "&:-ms-input-placeholder": o,
      // IE11
      "&::-ms-input-placeholder": o,
      // Edge
      "&:focus::-webkit-input-placeholder": i,
      "&:focus::-moz-placeholder": i,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": i,
      // IE11
      "&:focus::-ms-input-placeholder": i
      // Edge
    },
    [`&.${or.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (r.vars || r).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, e.size === "small" && {
    paddingTop: 1
  }, e.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, e.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), q0 = /* @__PURE__ */ w.jsx(Xc, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), ea = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n;
  const o = ge({
    props: e,
    name: "MuiInputBase"
  }), {
    "aria-describedby": i,
    autoComplete: a,
    autoFocus: s,
    className: c,
    components: d = {},
    componentsProps: u = {},
    defaultValue: p,
    disabled: h,
    disableInjectingGlobalStyles: f,
    endAdornment: m,
    fullWidth: g = !1,
    id: b,
    inputComponent: x = "input",
    inputProps: v = {},
    inputRef: y,
    maxRows: C,
    minRows: k,
    multiline: T = !1,
    name: S,
    onBlur: O,
    onChange: P,
    onClick: M,
    onFocus: I,
    onKeyDown: E,
    onKeyUp: N,
    placeholder: L,
    readOnly: z,
    renderSuffix: F,
    rows: B,
    slotProps: D = {},
    slots: W = {},
    startAdornment: G,
    type: re = "text",
    value: ce
  } = o, Ce = q(o, U0), ne = v.value != null ? v.value : ce, {
    current: pe
  } = R.useRef(ne != null), K = R.useRef(), le = R.useCallback((Ie) => {
    process.env.NODE_ENV !== "production" && Ie && Ie.nodeName !== "INPUT" && !Ie.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), Q = ut(K, y, v.ref, le), [se, Re] = R.useState(!1), be = Br();
  process.env.NODE_ENV !== "production" && R.useEffect(() => {
    if (be)
      return be.registerEffect();
  }, [be]);
  const Ne = bn({
    props: o,
    muiFormControl: be,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Ne.focused = be ? be.focused : se, R.useEffect(() => {
    !be && h && se && (Re(!1), O && O());
  }, [be, h, se, O]);
  const ke = be && be.onFilled, Oe = be && be.onEmpty, Te = R.useCallback((Ie) => {
    qa(Ie) ? ke && ke() : Oe && Oe();
  }, [ke, Oe]);
  qt(() => {
    pe && Te({
      value: ne
    });
  }, [ne, Te, pe]);
  const me = (Ie) => {
    if (Ne.disabled) {
      Ie.stopPropagation();
      return;
    }
    I && I(Ie), v.onFocus && v.onFocus(Ie), be && be.onFocus ? be.onFocus(Ie) : Re(!0);
  }, tt = (Ie) => {
    O && O(Ie), v.onBlur && v.onBlur(Ie), be && be.onBlur ? be.onBlur(Ie) : Re(!1);
  }, Se = (Ie, ...de) => {
    if (!pe) {
      const Ve = Ie.target || K.current;
      if (Ve == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : _a(1));
      Te({
        value: Ve.value
      });
    }
    v.onChange && v.onChange(Ie, ...de), P && P(Ie, ...de);
  };
  R.useEffect(() => {
    Te(K.current);
  }, []);
  const Ke = (Ie) => {
    K.current && Ie.currentTarget === Ie.target && K.current.focus(), M && M(Ie);
  };
  let He = x, _e = v;
  T && He === "input" && (B ? (process.env.NODE_ENV !== "production" && (k || C) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), _e = A({
    type: void 0,
    minRows: B,
    maxRows: B
  }, _e)) : _e = A({
    type: void 0,
    maxRows: C,
    minRows: k
  }, _e), He = Nf);
  const Qe = (Ie) => {
    Te(Ie.animationName === "mui-auto-fill-cancel" ? K.current : {
      value: "x"
    });
  };
  R.useEffect(() => {
    be && be.setAdornedStart(!!G);
  }, [be, G]);
  const Ue = A({}, o, {
    color: Ne.color || "primary",
    disabled: Ne.disabled,
    endAdornment: m,
    error: Ne.error,
    focused: Ne.focused,
    formControl: be,
    fullWidth: g,
    hiddenLabel: Ne.hiddenLabel,
    multiline: T,
    size: Ne.size,
    startAdornment: G,
    type: re
  }), Ye = G0(Ue), ht = W.root || d.Root || ks, bt = D.root || u.root || {}, mt = W.input || d.Input || Ss;
  return _e = A({}, _e, (n = D.input) != null ? n : u.input), /* @__PURE__ */ w.jsxs(R.Fragment, {
    children: [!f && q0, /* @__PURE__ */ w.jsxs(ht, A({}, bt, !zn(ht) && {
      ownerState: A({}, Ue, bt.ownerState)
    }, {
      ref: t,
      onClick: Ke
    }, Ce, {
      className: Y(Ye.root, bt.className, c, z && "MuiInputBase-readOnly"),
      children: [G, /* @__PURE__ */ w.jsx(Qi.Provider, {
        value: null,
        children: /* @__PURE__ */ w.jsx(mt, A({
          ownerState: Ue,
          "aria-invalid": Ne.error,
          "aria-describedby": i,
          autoComplete: a,
          autoFocus: s,
          defaultValue: p,
          disabled: Ne.disabled,
          id: b,
          onAnimationStart: Qe,
          name: S,
          placeholder: L,
          readOnly: z,
          required: Ne.required,
          rows: B,
          value: ne,
          onKeyDown: E,
          onKeyUp: N,
          type: re
        }, _e, !zn(mt) && {
          as: He,
          ownerState: A({}, Ue, _e.ownerState)
        }, {
          ref: Q,
          className: Y(Ye.input, _e.className, z && "MuiInputBase-readOnly"),
          onBlur: tt,
          onChange: Se,
          onFocus: me
        }))
      }), m, F ? F(A({}, Ne, {
        startAdornment: G
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (ea.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": l.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: Co,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $t,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: l.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * @ignore
   */
  onKeyUp: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * @ignore
   */
  renderSuffix: l.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The size of the component.
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
function K0(r) {
  return fe("MuiInput", r);
}
const rn = A({}, or, ue("MuiInput", ["root", "underline", "input"]));
function Z0(r) {
  return fe("MuiOutlinedInput", r);
}
const Ir = A({}, or, ue("MuiOutlinedInput", ["root", "notchedOutline", "input"]));
function J0(r) {
  return fe("MuiFilledInput", r);
}
const ir = A({}, or, ue("MuiFilledInput", ["root", "underline", "input"])), Lf = At(/* @__PURE__ */ w.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function Q0(r) {
  return fe("MuiAutocomplete", r);
}
const Xe = ue("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var yu, wu;
const ew = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionKey", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"], tw = ["ref"], rw = ["key"], nw = ["key"], ow = (r) => {
  const {
    classes: e,
    disablePortal: t,
    expanded: n,
    focused: o,
    fullWidth: i,
    hasClearIcon: a,
    hasPopupIcon: s,
    inputFocused: c,
    popupOpen: d,
    size: u
  } = r, p = {
    root: ["root", n && "expanded", o && "focused", i && "fullWidth", a && "hasClearIcon", s && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", c && "inputFocused"],
    tag: ["tag", `tagSize${V(u)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", d && "popupIndicatorOpen"],
    popper: ["popper", t && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return he(p, Q0, e);
}, iw = H("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r, {
      fullWidth: n,
      hasClearIcon: o,
      hasPopupIcon: i,
      inputFocused: a,
      size: s
    } = t;
    return [{
      [`& .${Xe.tag}`]: e.tag
    }, {
      [`& .${Xe.tag}`]: e[`tagSize${V(s)}`]
    }, {
      [`& .${Xe.inputRoot}`]: e.inputRoot
    }, {
      [`& .${Xe.input}`]: e.input
    }, {
      [`& .${Xe.input}`]: a && e.inputFocused
    }, e.root, n && e.fullWidth, i && e.hasPopupIcon, o && e.hasClearIcon];
  }
})({
  [`&.${Xe.focused} .${Xe.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${Xe.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${Xe.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${Xe.inputRoot}`]: {
    [`.${Xe.hasPopupIcon}&, .${Xe.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${Xe.hasPopupIcon}.${Xe.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${Xe.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${rn.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${rn.root}.${or.sizeSmall}`]: {
    [`& .${rn.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${Ir.root}`]: {
    padding: 9,
    [`.${Xe.hasPopupIcon}&, .${Xe.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Xe.hasPopupIcon}.${Xe.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Xe.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${Xe.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Ir.root}.${or.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${Xe.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${ir.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${Xe.hasPopupIcon}&, .${Xe.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Xe.hasPopupIcon}.${Xe.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${ir.input}`]: {
      padding: "7px 4px"
    },
    [`& .${Xe.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${ir.root}.${or.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${ir.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${or.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${ir.root}.${or.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${Xe.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${ir.root}.${or.hiddenLabel}.${or.sizeSmall}`]: {
    [`& .${Xe.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${Xe.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${Xe.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${Xe.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${Xe.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), aw = H("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (r, e) => e.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), sw = H(jt, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (r, e) => e.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), lw = H(jt, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: ({
    ownerState: r
  }, e) => A({}, e.popupIndicator, r.popupOpen && e.popupIndicatorOpen)
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), cw = H(Ji, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [{
      [`& .${Xe.option}`]: e.option
    }, e.popper, t.disablePortal && e.popperDisablePortal];
  }
})(({
  theme: r
}) => ({
  zIndex: (r.vars || r).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
})), dw = H(Wt, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (r, e) => e.paper
})(({
  theme: r
}) => A({}, r.typography.body1, {
  overflow: "auto"
})), uw = H("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (r, e) => e.loading
})(({
  theme: r
}) => ({
  color: (r.vars || r).palette.text.secondary,
  padding: "14px 16px"
})), pw = H("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (r, e) => e.noOptions
})(({
  theme: r
}) => ({
  color: (r.vars || r).palette.text.secondary,
  padding: "14px 16px"
})), hw = H("div", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (r, e) => e.listbox
})(({
  theme: r
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${Xe.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [r.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${Xe.focused}`]: {
      backgroundColor: (r.vars || r).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (r.vars || r).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${Xe.focusVisible}`]: {
      backgroundColor: (r.vars || r).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / ${r.vars.palette.action.selectedOpacity})` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity),
      [`&.${Xe.focused}`]: {
        backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.hoverOpacity}))` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity + r.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (r.vars || r).palette.action.selected
        }
      },
      [`&.${Xe.focusVisible}`]: {
        backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.focusOpacity}))` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity + r.palette.action.focusOpacity)
      }
    }
  }
})), fw = H(Yc, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (r, e) => e.groupLabel
})(({
  theme: r
}) => ({
  backgroundColor: (r.vars || r).palette.background.paper,
  top: -8
})), gw = H("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (r, e) => e.groupUl
})({
  padding: 0,
  [`& .${Xe.option}`]: {
    paddingLeft: 24
  }
}), jf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o, i, a;
  const s = ge({
    props: e,
    name: "MuiAutocomplete"
  }), {
    autoComplete: c = !1,
    autoHighlight: d = !1,
    autoSelect: u = !1,
    blurOnSelect: p = !1,
    ChipProps: h,
    className: f,
    clearIcon: m = yu || (yu = /* @__PURE__ */ w.jsx(vf, {
      fontSize: "small"
    })),
    clearOnBlur: g = !s.freeSolo,
    clearOnEscape: b = !1,
    clearText: x = "Clear",
    closeText: v = "Close",
    componentsProps: y = {},
    defaultValue: C = s.multiple ? [] : null,
    disableClearable: k = !1,
    disableCloseOnSelect: T = !1,
    disabled: S = !1,
    disabledItemsFocusable: O = !1,
    disableListWrap: P = !1,
    disablePortal: M = !1,
    filterSelectedOptions: I = !1,
    forcePopupIcon: E = "auto",
    freeSolo: N = !1,
    fullWidth: L = !1,
    getLimitTagsText: z = (X) => `+${X}`,
    getOptionLabel: F,
    groupBy: B,
    handleHomeEndKeys: D = !s.freeSolo,
    includeInputInList: W = !1,
    limitTags: G = -1,
    ListboxComponent: re = "ul",
    ListboxProps: ce,
    loading: Ce = !1,
    loadingText: ne = "Loading…",
    multiple: pe = !1,
    noOptionsText: K = "No options",
    openOnFocus: le = !1,
    openText: Q = "Open",
    PaperComponent: se = Wt,
    PopperComponent: Re = Ji,
    popupIcon: be = wu || (wu = /* @__PURE__ */ w.jsx(Lf, {})),
    readOnly: Ne = !1,
    renderGroup: ke,
    renderInput: Oe,
    renderOption: Te,
    renderTags: me,
    selectOnFocus: tt = !s.freeSolo,
    size: Se = "medium",
    slotProps: Ke = {}
  } = s, He = q(s, ew), {
    getRootProps: _e,
    getInputProps: Qe,
    getInputLabelProps: Ue,
    getPopupIndicatorProps: Ye,
    getClearProps: ht,
    getTagProps: bt,
    getListboxProps: mt,
    getOptionProps: Ie,
    value: de,
    dirty: Ve,
    expanded: vt,
    id: yt,
    popupOpen: Ot,
    focused: ye,
    focusedTag: te,
    anchorEl: _,
    setAnchorEl: U,
    inputValue: oe,
    groupedOptions: Ae
  } = uy(A({}, s, {
    componentName: "Autocomplete"
  })), et = !k && !S && Ve && !Ne, st = (!N || E === !0) && E !== !1, {
    onMouseDown: Et
  } = Qe(), {
    ref: Pt
  } = ce ?? {}, kr = mt(), {
    ref: xn
  } = kr, Yn = q(kr, tw), No = ut(xn, Pt), Mr = F || ((X) => {
    var ae;
    return (ae = X.label) != null ? ae : X;
  }), It = A({}, s, {
    disablePortal: M,
    expanded: vt,
    focused: ye,
    fullWidth: L,
    getOptionLabel: Mr,
    hasClearIcon: et,
    hasPopupIcon: st,
    inputFocused: te === -1,
    popupOpen: Ot,
    size: Se
  }), xt = ow(It);
  let Ht;
  if (pe && de.length > 0) {
    const X = (ae) => A({
      className: xt.tag,
      disabled: S
    }, bt(ae));
    me ? Ht = me(de, X, It) : Ht = de.map((ae, Me) => {
      const ze = X({
        index: Me
      }), {
        key: we
      } = ze, Ge = q(ze, rw);
      return /* @__PURE__ */ w.jsx(ys, A({
        label: Mr(ae),
        size: Se
      }, Ge, h), we);
    });
  }
  if (G > -1 && Array.isArray(Ht)) {
    const X = Ht.length - G;
    !ye && X > 0 && (Ht = Ht.splice(0, G), Ht.push(/* @__PURE__ */ w.jsx("span", {
      className: xt.tag,
      children: z(X)
    }, Ht.length)));
  }
  const Fr = ke || ((X) => /* @__PURE__ */ w.jsxs("li", {
    children: [/* @__PURE__ */ w.jsx(fw, {
      className: xt.groupLabel,
      ownerState: It,
      component: "div",
      children: X.group
    }), /* @__PURE__ */ w.jsx(gw, {
      className: xt.groupUl,
      ownerState: It,
      children: X.children
    })]
  }, X.key)), _r = Te || ((X, ae) => {
    const {
      key: Me
    } = X, ze = q(X, nw);
    return /* @__PURE__ */ w.jsx("li", A({}, ze, {
      children: Mr(ae)
    }), Me);
  }), qr = (X, ae) => {
    const Me = Ie({
      option: X,
      index: ae
    });
    return _r(A({}, Me, {
      className: xt.option
    }), X, {
      selected: Me["aria-selected"],
      index: ae,
      inputValue: oe
    }, It);
  }, Kr = (n = Ke.clearIndicator) != null ? n : y.clearIndicator, Er = (o = Ke.paper) != null ? o : y.paper, $r = (i = Ke.popper) != null ? i : y.popper, Z = (a = Ke.popupIndicator) != null ? a : y.popupIndicator;
  return /* @__PURE__ */ w.jsxs(R.Fragment, {
    children: [/* @__PURE__ */ w.jsx(iw, A({
      ref: t,
      className: Y(xt.root, f),
      ownerState: It
    }, _e(He), {
      children: Oe({
        id: yt,
        disabled: S,
        fullWidth: !0,
        size: Se === "small" ? "small" : void 0,
        InputLabelProps: Ue(),
        InputProps: A({
          ref: U,
          className: xt.inputRoot,
          startAdornment: Ht,
          onClick: (X) => {
            X.target === X.currentTarget && Et(X);
          }
        }, (et || st) && {
          endAdornment: /* @__PURE__ */ w.jsxs(aw, {
            className: xt.endAdornment,
            ownerState: It,
            children: [et ? /* @__PURE__ */ w.jsx(sw, A({}, ht(), {
              "aria-label": x,
              title: x,
              ownerState: It
            }, Kr, {
              className: Y(xt.clearIndicator, Kr?.className),
              children: m
            })) : null, st ? /* @__PURE__ */ w.jsx(lw, A({}, Ye(), {
              disabled: S,
              "aria-label": Ot ? v : Q,
              title: Ot ? v : Q,
              ownerState: It
            }, Z, {
              className: Y(xt.popupIndicator, Z?.className),
              children: be
            })) : null]
          })
        }),
        inputProps: A({
          className: xt.input,
          disabled: S,
          readOnly: Ne
        }, Qe())
      })
    })), _ ? /* @__PURE__ */ w.jsx(cw, A({
      as: Re,
      disablePortal: M,
      style: {
        width: _ ? _.clientWidth : null
      },
      ownerState: It,
      role: "presentation",
      anchorEl: _,
      open: Ot
    }, $r, {
      className: Y(xt.popper, $r?.className),
      children: /* @__PURE__ */ w.jsxs(dw, A({
        ownerState: It,
        as: se
      }, Er, {
        className: Y(xt.paper, Er?.className),
        children: [Ce && Ae.length === 0 ? /* @__PURE__ */ w.jsx(uw, {
          className: xt.loading,
          ownerState: It,
          children: ne
        }) : null, Ae.length === 0 && !N && !Ce ? /* @__PURE__ */ w.jsx(pw, {
          className: xt.noOptions,
          ownerState: It,
          role: "presentation",
          onMouseDown: (X) => {
            X.preventDefault();
          },
          children: K
        }) : null, Ae.length > 0 ? /* @__PURE__ */ w.jsx(hw, A({
          as: re,
          className: xt.listbox,
          ownerState: It
        }, Yn, ce, {
          ref: No,
          children: Ae.map((X, ae) => B ? Fr({
            key: X.key,
            group: X.group,
            children: X.options.map((Me, ze) => qr(Me, X.index + ze))
          }) : qr(X, ae))
        })) : null]
      }))
    })) : null]
  });
});
process.env.NODE_ENV !== "production" && (jf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: l.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: l.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: l.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: l.oneOfType([l.oneOf(["mouse", "touch"]), l.bool]),
  /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */
  ChipProps: l.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: l.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: l.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: l.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: l.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: l.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: l.shape({
    clearIndicator: l.object,
    paper: l.object,
    popper: l.object,
    popupIndicator: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: Ft(l.any, (r) => r.multiple && r.defaultValue !== void 0 && !Array.isArray(r.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${r.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: l.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: l.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: l.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: l.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: l.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: l.oneOfType([l.oneOf(["auto"]), l.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: l.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: l.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: l.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: l.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: l.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: l.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: l.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: l.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: l.bool,
  /**
   * The input value.
   */
  inputValue: l.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: l.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: Ut,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   */
  ListboxComponent: l.elementType,
  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: l.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: l.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: l.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: l.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: l.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: l.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: l.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: l.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: l.string,
  /**
   * Array of options.
   */
  options: l.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   */
  PaperComponent: l.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   */
  PopperComponent: l.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: l.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: l.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: l.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: l.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: l.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: l.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: l.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium"]), l.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    clearIndicator: l.object,
    paper: l.object,
    popper: l.object,
    popupIndicator: l.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: Ft(l.any, (r) => r.multiple && r.value !== void 0 && !Array.isArray(r.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${r.value} was provided.`].join(`
`)) : null)
});
const mw = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function bw(r) {
  return fe("MuiAvatar", r);
}
ue("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]);
const xw = ["alt", "children", "className", "component", "slots", "slotProps", "imgProps", "sizes", "src", "srcSet", "variant"], vw = (r) => {
  const {
    classes: e,
    variant: t,
    colorDefault: n
  } = r;
  return he({
    root: ["root", t, n && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, bw, e);
}, yw = H("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[t.variant], t.colorDefault && e.colorDefault];
  }
})(({
  theme: r
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: r.typography.fontFamily,
  fontSize: r.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (r.vars || r).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: A({
      color: (r.vars || r).palette.background.default
    }, r.vars ? {
      backgroundColor: r.vars.palette.Avatar.defaultBg
    } : A({
      backgroundColor: r.palette.grey[400]
    }, r.applyStyles("dark", {
      backgroundColor: r.palette.grey[600]
    })))
  }]
})), ww = H("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (r, e) => e.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), Cw = H(mw, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (r, e) => e.fallback
})({
  width: "75%",
  height: "75%"
});
function kw({
  crossOrigin: r,
  referrerPolicy: e,
  src: t,
  srcSet: n
}) {
  const [o, i] = R.useState(!1);
  return R.useEffect(() => {
    if (!t && !n)
      return;
    i(!1);
    let a = !0;
    const s = new Image();
    return s.onload = () => {
      a && i("loaded");
    }, s.onerror = () => {
      a && i("error");
    }, s.crossOrigin = r, s.referrerPolicy = e, s.src = t, n && (s.srcset = n), () => {
      a = !1;
    };
  }, [r, e, t, n]), o;
}
const Sw = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiAvatar"
  }), {
    alt: o,
    children: i,
    className: a,
    component: s = "div",
    slots: c = {},
    slotProps: d = {},
    imgProps: u,
    sizes: p,
    src: h,
    srcSet: f,
    variant: m = "circular"
  } = n, g = q(n, xw);
  let b = null;
  const x = kw(A({}, u, {
    src: h,
    srcSet: f
  })), v = h || f, y = v && x !== "error", C = A({}, n, {
    colorDefault: !y,
    component: s,
    variant: m
  }), k = vw(C), [T, S] = Va("img", {
    className: k.img,
    elementType: ww,
    externalForwardedProps: {
      slots: c,
      slotProps: {
        img: A({}, u, d.img)
      }
    },
    additionalProps: {
      alt: o,
      src: h,
      srcSet: f,
      sizes: p
    },
    ownerState: C
  });
  return y ? b = /* @__PURE__ */ w.jsx(T, A({}, S)) : i || i === 0 ? b = i : v && o ? b = o[0] : b = /* @__PURE__ */ w.jsx(Cw, {
    ownerState: C,
    className: k.fallback
  }), /* @__PURE__ */ w.jsx(yw, A({
    as: s,
    ownerState: C,
    className: Y(k.root, a),
    ref: t
  }, g, {
    children: b
  }));
});
process.env.NODE_ENV !== "production" && (Sw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: l.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  imgProps: l.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: l.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    img: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    img: l.elementType
  }),
  /**
   * The `src` attribute for the `img` element.
   */
  src: l.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: l.oneOfType([l.oneOf(["circular", "rounded", "square"]), l.string])
});
const Tw = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], Aw = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Vc = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = yr(), o = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: a = !0,
    children: s,
    easing: c,
    in: d,
    onEnter: u,
    onEntered: p,
    onEntering: h,
    onExit: f,
    onExited: m,
    onExiting: g,
    style: b,
    timeout: x = o,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: v = wr
  } = e, y = q(e, Tw), C = R.useRef(null), k = ut(C, fn(s), t), T = (L) => (z) => {
    if (L) {
      const F = C.current;
      z === void 0 ? L(F) : L(F, z);
    }
  }, S = T(h), O = T((L, z) => {
    Lc(L);
    const F = ln({
      style: b,
      timeout: x,
      easing: c
    }, {
      mode: "enter"
    });
    L.style.webkitTransition = n.transitions.create("opacity", F), L.style.transition = n.transitions.create("opacity", F), u && u(L, z);
  }), P = T(p), M = T(g), I = T((L) => {
    const z = ln({
      style: b,
      timeout: x,
      easing: c
    }, {
      mode: "exit"
    });
    L.style.webkitTransition = n.transitions.create("opacity", z), L.style.transition = n.transitions.create("opacity", z), f && f(L);
  }), E = T(m), N = (L) => {
    i && i(C.current, L);
  };
  return /* @__PURE__ */ w.jsx(v, A({
    appear: a,
    in: d,
    nodeRef: C,
    onEnter: O,
    onEntered: P,
    onEntering: S,
    onExit: I,
    onExited: E,
    onExiting: M,
    addEndListener: N,
    timeout: x
  }, y, {
    children: (L, z) => /* @__PURE__ */ R.cloneElement(s, A({
      style: A({
        opacity: 0,
        visibility: L === "exited" && !d ? "hidden" : void 0
      }, Aw[L], b, s.props.style),
      ref: k
    }, z))
  }));
});
process.env.NODE_ENV !== "production" && (Vc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: l.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: l.bool,
  /**
   * A single child content element.
   */
  children: hn.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: l.oneOfType([l.shape({
    enter: l.string,
    exit: l.string
  }), l.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: l.bool,
  /**
   * @ignore
   */
  onEnter: l.func,
  /**
   * @ignore
   */
  onEntered: l.func,
  /**
   * @ignore
   */
  onEntering: l.func,
  /**
   * @ignore
   */
  onExit: l.func,
  /**
   * @ignore
   */
  onExited: l.func,
  /**
   * @ignore
   */
  onExiting: l.func,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
function Ow(r) {
  return fe("MuiBackdrop", r);
}
ue("MuiBackdrop", ["root", "invisible"]);
const Rw = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], Pw = (r) => {
  const {
    classes: e,
    invisible: t
  } = r;
  return he({
    root: ["root", t && "invisible"]
  }, Ow, e);
}, Mw = H("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.invisible && e.invisible];
  }
})(({
  ownerState: r
}) => A({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, r.invisible && {
  backgroundColor: "transparent"
})), Uc = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o, i;
  const a = ge({
    props: e,
    name: "MuiBackdrop"
  }), {
    children: s,
    className: c,
    component: d = "div",
    components: u = {},
    componentsProps: p = {},
    invisible: h = !1,
    open: f,
    slotProps: m = {},
    slots: g = {},
    TransitionComponent: b = Vc,
    transitionDuration: x
  } = a, v = q(a, Rw), y = A({}, a, {
    component: d,
    invisible: h
  }), C = Pw(y), k = (n = m.root) != null ? n : p.root;
  return /* @__PURE__ */ w.jsx(b, A({
    in: f,
    timeout: x
  }, v, {
    children: /* @__PURE__ */ w.jsx(Mw, A({
      "aria-hidden": !0
    }, k, {
      as: (o = (i = g.root) != null ? i : u.Root) != null ? o : d,
      className: Y(C.root, c, k?.className),
      ownerState: A({}, y, k?.ownerState),
      classes: C,
      ref: t,
      children: s
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Uc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    root: l.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: l.bool,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: l.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
function Ew(r) {
  const {
    badgeContent: e,
    invisible: t = !1,
    max: n = 99,
    showZero: o = !1
  } = r, i = Pc({
    badgeContent: e,
    max: n
  });
  let a = t;
  t === !1 && e === 0 && !o && (a = !0);
  const {
    badgeContent: s,
    max: c = n
  } = a ? i : r, d = s && Number(s) > c ? `${c}+` : s;
  return {
    badgeContent: s,
    invisible: a,
    max: c,
    displayValue: d
  };
}
function Iw(r) {
  return fe("MuiBadge", r);
}
const Zr = ue("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), Nw = ["anchorOrigin", "className", "classes", "component", "components", "componentsProps", "children", "overlap", "color", "invisible", "max", "badgeContent", "slots", "slotProps", "showZero", "variant"], Bs = 10, Fs = 4, Lw = (r) => {
  const {
    color: e,
    anchorOrigin: t,
    invisible: n,
    overlap: o,
    variant: i,
    classes: a = {}
  } = r, s = {
    root: ["root"],
    badge: ["badge", i, n && "invisible", `anchorOrigin${V(t.vertical)}${V(t.horizontal)}`, `anchorOrigin${V(t.vertical)}${V(t.horizontal)}${V(o)}`, `overlap${V(o)}`, e !== "default" && `color${V(e)}`]
  };
  return he(s, Iw, a);
}, jw = H("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), Dw = H("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.badge, e[t.variant], e[`anchorOrigin${V(t.anchorOrigin.vertical)}${V(t.anchorOrigin.horizontal)}${V(t.overlap)}`], t.color !== "default" && e[`color${V(t.color)}`], t.invisible && e.invisible];
  }
})(({
  theme: r
}) => {
  var e;
  return {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    position: "absolute",
    boxSizing: "border-box",
    fontFamily: r.typography.fontFamily,
    fontWeight: r.typography.fontWeightMedium,
    fontSize: r.typography.pxToRem(12),
    minWidth: Bs * 2,
    lineHeight: 1,
    padding: "0 6px",
    height: Bs * 2,
    borderRadius: Bs,
    zIndex: 1,
    // Render the badge on top of potential ripples.
    transition: r.transitions.create("transform", {
      easing: r.transitions.easing.easeInOut,
      duration: r.transitions.duration.enteringScreen
    }),
    variants: [...Object.keys(((e = r.vars) != null ? e : r).palette).filter((t) => {
      var n, o;
      return ((n = r.vars) != null ? n : r).palette[t].main && ((o = r.vars) != null ? o : r).palette[t].contrastText;
    }).map((t) => ({
      props: {
        color: t
      },
      style: {
        backgroundColor: (r.vars || r).palette[t].main,
        color: (r.vars || r).palette[t].contrastText
      }
    })), {
      props: {
        variant: "dot"
      },
      style: {
        borderRadius: Fs,
        height: Fs * 2,
        minWidth: Fs * 2,
        padding: 0
      }
    }, {
      props: ({
        ownerState: t
      }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
      style: {
        top: 0,
        right: 0,
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${Zr.invisible}`]: {
          transform: "scale(0) translate(50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: t
      }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
      style: {
        bottom: 0,
        right: 0,
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${Zr.invisible}`]: {
          transform: "scale(0) translate(50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: t
      }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
      style: {
        top: 0,
        left: 0,
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${Zr.invisible}`]: {
          transform: "scale(0) translate(-50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: t
      }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
      style: {
        bottom: 0,
        left: 0,
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${Zr.invisible}`]: {
          transform: "scale(0) translate(-50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: t
      }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
      style: {
        top: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${Zr.invisible}`]: {
          transform: "scale(0) translate(50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: t
      }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
      style: {
        bottom: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${Zr.invisible}`]: {
          transform: "scale(0) translate(50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: t
      }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
      style: {
        top: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${Zr.invisible}`]: {
          transform: "scale(0) translate(-50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: t
      }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
      style: {
        bottom: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${Zr.invisible}`]: {
          transform: "scale(0) translate(-50%, 50%)"
        }
      }
    }, {
      props: {
        invisible: !0
      },
      style: {
        transition: r.transitions.create("transform", {
          easing: r.transitions.easing.easeInOut,
          duration: r.transitions.duration.leavingScreen
        })
      }
    }]
  };
}), zw = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o, i, a, s, c;
  const d = ge({
    props: e,
    name: "MuiBadge"
  }), {
    anchorOrigin: u = {
      vertical: "top",
      horizontal: "right"
    },
    className: p,
    component: h,
    components: f = {},
    componentsProps: m = {},
    children: g,
    overlap: b = "rectangular",
    color: x = "default",
    invisible: v = !1,
    max: y = 99,
    badgeContent: C,
    slots: k,
    slotProps: T,
    showZero: S = !1,
    variant: O = "standard"
  } = d, P = q(d, Nw), {
    badgeContent: M,
    invisible: I,
    max: E,
    displayValue: N
  } = Ew({
    max: y,
    invisible: v,
    badgeContent: C,
    showZero: S
  }), L = Pc({
    anchorOrigin: u,
    color: x,
    overlap: b,
    variant: O,
    badgeContent: C
  }), z = I || M == null && O !== "dot", {
    color: F = x,
    overlap: B = b,
    anchorOrigin: D = u,
    variant: W = O
  } = z ? L : d, G = W !== "dot" ? N : void 0, re = A({}, d, {
    badgeContent: M,
    invisible: z,
    max: E,
    displayValue: G,
    showZero: S,
    anchorOrigin: D,
    color: F,
    overlap: B,
    variant: W
  }), ce = Lw(re), Ce = (n = (o = k?.root) != null ? o : f.Root) != null ? n : jw, ne = (i = (a = k?.badge) != null ? a : f.Badge) != null ? i : Dw, pe = (s = T?.root) != null ? s : m.root, K = (c = T?.badge) != null ? c : m.badge, le = tr({
    elementType: Ce,
    externalSlotProps: pe,
    externalForwardedProps: P,
    additionalProps: {
      ref: t,
      as: h
    },
    ownerState: re,
    className: Y(pe?.className, ce.root, p)
  }), Q = tr({
    elementType: ne,
    externalSlotProps: K,
    ownerState: re,
    className: Y(ce.badge, K?.className)
  });
  return /* @__PURE__ */ w.jsxs(Ce, A({}, le, {
    children: [g, /* @__PURE__ */ w.jsx(ne, A({}, Q, {
      children: G
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (zw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: l.shape({
    horizontal: l.oneOf(["left", "right"]).isRequired,
    vertical: l.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: l.node,
  /**
   * The badge will be added relative to this node.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Badge: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    badge: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: l.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: l.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: l.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: l.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: l.shape({
    badge: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    badge: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: l.oneOfType([l.oneOf(["dot", "standard"]), l.string])
});
const Bw = ue("MuiBox", ["root"]), Fw = Tc(), at = Mb({
  themeId: uo,
  defaultTheme: Fw,
  defaultClassName: Bw.root,
  generateClassName: Kh.generate
});
process.env.NODE_ENV !== "production" && (at.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: l.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const _w = At(/* @__PURE__ */ w.jsx("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz"), $w = ["slots", "slotProps"], Ww = H(Kt, {
  name: "MuiBreadcrumbCollapsed"
})(({
  theme: r
}) => A({
  display: "flex",
  marginLeft: `calc(${r.spacing(1)} * 0.5)`,
  marginRight: `calc(${r.spacing(1)} * 0.5)`
}, r.palette.mode === "light" ? {
  backgroundColor: r.palette.grey[100],
  color: r.palette.grey[700]
} : {
  backgroundColor: r.palette.grey[700],
  color: r.palette.grey[100]
}, {
  borderRadius: 2,
  "&:hover, &:focus": A({}, r.palette.mode === "light" ? {
    backgroundColor: r.palette.grey[200]
  } : {
    backgroundColor: r.palette.grey[600]
  }),
  "&:active": A({
    boxShadow: r.shadows[0]
  }, r.palette.mode === "light" ? {
    backgroundColor: Pe.emphasize(r.palette.grey[200], 0.12)
  } : {
    backgroundColor: Pe.emphasize(r.palette.grey[600], 0.12)
  })
})), Hw = H(_w)({
  width: 24,
  height: 16
});
function Df(r) {
  const {
    slots: e = {},
    slotProps: t = {}
  } = r, n = q(r, $w), o = r;
  return /* @__PURE__ */ w.jsx("li", {
    children: /* @__PURE__ */ w.jsx(Ww, A({
      focusRipple: !0
    }, n, {
      ownerState: o,
      children: /* @__PURE__ */ w.jsx(Hw, A({
        as: e.CollapsedIcon,
        ownerState: o
      }, t.collapsedIcon))
    }))
  });
}
process.env.NODE_ENV !== "production" && (Df.propTypes = {
  /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */
  slotProps: l.shape({
    collapsedIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    CollapsedIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.object
});
function Yw(r) {
  return fe("MuiBreadcrumbs", r);
}
const Xw = ue("MuiBreadcrumbs", ["root", "ol", "li", "separator"]), Vw = ["children", "className", "component", "slots", "slotProps", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"], Uw = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"],
    li: ["li"],
    ol: ["ol"],
    separator: ["separator"]
  }, Yw, e);
}, Gw = H(We, {
  name: "MuiBreadcrumbs",
  slot: "Root",
  overridesResolver: (r, e) => [{
    [`& .${Xw.li}`]: e.li
  }, e.root]
})({}), qw = H("ol", {
  name: "MuiBreadcrumbs",
  slot: "Ol",
  overridesResolver: (r, e) => e.ol
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
}), Kw = H("li", {
  name: "MuiBreadcrumbs",
  slot: "Separator",
  overridesResolver: (r, e) => e.separator
})({
  display: "flex",
  userSelect: "none",
  marginLeft: 8,
  marginRight: 8
});
function Zw(r, e, t, n) {
  return r.reduce((o, i, a) => (a < r.length - 1 ? o = o.concat(i, /* @__PURE__ */ w.jsx(Kw, {
    "aria-hidden": !0,
    className: e,
    ownerState: n,
    children: t
  }, `separator-${a}`)) : o.push(i), o), []);
}
const Jw = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiBreadcrumbs"
  }), {
    children: o,
    className: i,
    component: a = "nav",
    slots: s = {},
    slotProps: c = {},
    expandText: d = "Show path",
    itemsAfterCollapse: u = 1,
    itemsBeforeCollapse: p = 1,
    maxItems: h = 8,
    separator: f = "/"
  } = n, m = q(n, Vw), [g, b] = R.useState(!1), x = A({}, n, {
    component: a,
    expanded: g,
    expandText: d,
    itemsAfterCollapse: u,
    itemsBeforeCollapse: p,
    maxItems: h,
    separator: f
  }), v = Uw(x), y = tr({
    elementType: s.CollapsedIcon,
    externalSlotProps: c.collapsedIcon,
    ownerState: x
  }), C = R.useRef(null), k = (S) => {
    const O = () => {
      b(!0);
      const P = C.current.querySelector("a[href],button,[tabindex]");
      P && P.focus();
    };
    return p + u >= S.length ? (process.env.NODE_ENV !== "production" && console.error(["MUI: You have provided an invalid combination of props to the Breadcrumbs.", `itemsAfterCollapse={${u}} + itemsBeforeCollapse={${p}} >= maxItems={${h}}`].join(`
`)), S) : [...S.slice(0, p), /* @__PURE__ */ w.jsx(Df, {
      "aria-label": d,
      slots: {
        CollapsedIcon: s.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: y
      },
      onClick: O
    }, "ellipsis"), ...S.slice(S.length - u, S.length)];
  }, T = R.Children.toArray(o).filter((S) => (process.env.NODE_ENV !== "production" && wo.isFragment(S) && console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ R.isValidElement(S))).map((S, O) => /* @__PURE__ */ w.jsx("li", {
    className: v.li,
    children: S
  }, `child-${O}`));
  return /* @__PURE__ */ w.jsx(Gw, A({
    ref: t,
    component: a,
    color: "text.secondary",
    className: Y(v.root, i),
    ownerState: x
  }, m, {
    children: /* @__PURE__ */ w.jsx(qw, {
      className: v.ol,
      ref: C,
      ownerState: x,
      children: Zw(g || h && T.length <= h ? T : k(T), v.separator, f, x)
    })
  }));
});
process.env.NODE_ENV !== "production" && (Jw.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Show path'
   */
  expandText: l.string,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: Ut,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: Ut,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: Ut,
  /**
   * Custom separator node.
   * @default '/'
   */
  separator: l.node,
  /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */
  slotProps: l.shape({
    collapsedIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    CollapsedIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function Qw(r) {
  return fe("MuiButton", r);
}
const va = ue("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), zf = /* @__PURE__ */ R.createContext({});
process.env.NODE_ENV !== "production" && (zf.displayName = "ButtonGroupContext");
const Bf = /* @__PURE__ */ R.createContext(void 0);
process.env.NODE_ENV !== "production" && (Bf.displayName = "ButtonGroupButtonContext");
const e1 = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], t1 = (r) => {
  const {
    color: e,
    disableElevation: t,
    fullWidth: n,
    size: o,
    variant: i,
    classes: a
  } = r, s = {
    root: ["root", i, `${i}${V(e)}`, `size${V(o)}`, `${i}Size${V(o)}`, `color${V(e)}`, t && "disableElevation", n && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${V(o)}`],
    endIcon: ["icon", "endIcon", `iconSize${V(o)}`]
  }, c = he(s, Qw, a);
  return A({}, a, c);
}, Ff = (r) => A({}, r.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, r.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, r.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), r1 = H(Kt, {
  shouldForwardProp: (r) => _t(r) || r === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[t.variant], e[`${t.variant}${V(t.color)}`], e[`size${V(t.size)}`], e[`${t.variant}Size${V(t.size)}`], t.color === "inherit" && e.colorInherit, t.disableElevation && e.disableElevation, t.fullWidth && e.fullWidth];
  }
})(({
  theme: r,
  ownerState: e
}) => {
  var t, n;
  const o = r.palette.mode === "light" ? r.palette.grey[300] : r.palette.grey[800], i = r.palette.mode === "light" ? r.palette.grey.A100 : r.palette.grey[700];
  return A({}, r.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (r.vars || r).shape.borderRadius,
    transition: r.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: r.transitions.duration.short
    }),
    "&:hover": A({
      textDecoration: "none",
      backgroundColor: r.vars ? `rgba(${r.vars.palette.text.primaryChannel} / ${r.vars.palette.action.hoverOpacity})` : Pe.alpha(r.palette.text.primary, r.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, e.variant === "text" && e.color !== "inherit" && {
      backgroundColor: r.vars ? `rgba(${r.vars.palette[e.color].mainChannel} / ${r.vars.palette.action.hoverOpacity})` : Pe.alpha(r.palette[e.color].main, r.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, e.variant === "outlined" && e.color !== "inherit" && {
      border: `1px solid ${(r.vars || r).palette[e.color].main}`,
      backgroundColor: r.vars ? `rgba(${r.vars.palette[e.color].mainChannel} / ${r.vars.palette.action.hoverOpacity})` : Pe.alpha(r.palette[e.color].main, r.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, e.variant === "contained" && {
      backgroundColor: r.vars ? r.vars.palette.Button.inheritContainedHoverBg : i,
      boxShadow: (r.vars || r).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (r.vars || r).shadows[2],
        backgroundColor: (r.vars || r).palette.grey[300]
      }
    }, e.variant === "contained" && e.color !== "inherit" && {
      backgroundColor: (r.vars || r).palette[e.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (r.vars || r).palette[e.color].main
      }
    }),
    "&:active": A({}, e.variant === "contained" && {
      boxShadow: (r.vars || r).shadows[8]
    }),
    [`&.${va.focusVisible}`]: A({}, e.variant === "contained" && {
      boxShadow: (r.vars || r).shadows[6]
    }),
    [`&.${va.disabled}`]: A({
      color: (r.vars || r).palette.action.disabled
    }, e.variant === "outlined" && {
      border: `1px solid ${(r.vars || r).palette.action.disabledBackground}`
    }, e.variant === "contained" && {
      color: (r.vars || r).palette.action.disabled,
      boxShadow: (r.vars || r).shadows[0],
      backgroundColor: (r.vars || r).palette.action.disabledBackground
    })
  }, e.variant === "text" && {
    padding: "6px 8px"
  }, e.variant === "text" && e.color !== "inherit" && {
    color: (r.vars || r).palette[e.color].main
  }, e.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, e.variant === "outlined" && e.color !== "inherit" && {
    color: (r.vars || r).palette[e.color].main,
    border: r.vars ? `1px solid rgba(${r.vars.palette[e.color].mainChannel} / 0.5)` : `1px solid ${Pe.alpha(r.palette[e.color].main, 0.5)}`
  }, e.variant === "contained" && {
    color: r.vars ? (
      // this is safe because grey does not change between default light/dark mode
      r.vars.palette.text.primary
    ) : (t = (n = r.palette).getContrastText) == null ? void 0 : t.call(n, r.palette.grey[300]),
    backgroundColor: r.vars ? r.vars.palette.Button.inheritContainedBg : o,
    boxShadow: (r.vars || r).shadows[2]
  }, e.variant === "contained" && e.color !== "inherit" && {
    color: (r.vars || r).palette[e.color].contrastText,
    backgroundColor: (r.vars || r).palette[e.color].main
  }, e.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, e.size === "small" && e.variant === "text" && {
    padding: "4px 5px",
    fontSize: r.typography.pxToRem(13)
  }, e.size === "large" && e.variant === "text" && {
    padding: "8px 11px",
    fontSize: r.typography.pxToRem(15)
  }, e.size === "small" && e.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: r.typography.pxToRem(13)
  }, e.size === "large" && e.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: r.typography.pxToRem(15)
  }, e.size === "small" && e.variant === "contained" && {
    padding: "4px 10px",
    fontSize: r.typography.pxToRem(13)
  }, e.size === "large" && e.variant === "contained" && {
    padding: "8px 22px",
    fontSize: r.typography.pxToRem(15)
  }, e.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: r
}) => r.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${va.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${va.disabled}`]: {
    boxShadow: "none"
  }
}), n1 = H("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.startIcon, e[`iconSize${V(t.size)}`]];
  }
})(({
  ownerState: r
}) => A({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, r.size === "small" && {
  marginLeft: -2
}, Ff(r))), o1 = H("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.endIcon, e[`iconSize${V(t.size)}`]];
  }
})(({
  ownerState: r
}) => A({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, r.size === "small" && {
  marginRight: -2
}, Ff(r))), Sn = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = R.useContext(zf), o = R.useContext(Bf), i = qh(n, e), a = ge({
    props: i,
    name: "MuiButton"
  }), {
    children: s,
    color: c = "primary",
    component: d = "button",
    className: u,
    disabled: p = !1,
    disableElevation: h = !1,
    disableFocusRipple: f = !1,
    endIcon: m,
    focusVisibleClassName: g,
    fullWidth: b = !1,
    size: x = "medium",
    startIcon: v,
    type: y,
    variant: C = "text"
  } = a, k = q(a, e1), T = A({}, a, {
    color: c,
    component: d,
    disabled: p,
    disableElevation: h,
    disableFocusRipple: f,
    fullWidth: b,
    size: x,
    type: y,
    variant: C
  }), S = t1(T), O = v && /* @__PURE__ */ w.jsx(n1, {
    className: S.startIcon,
    ownerState: T,
    children: v
  }), P = m && /* @__PURE__ */ w.jsx(o1, {
    className: S.endIcon,
    ownerState: T,
    children: m
  }), M = o || "";
  return /* @__PURE__ */ w.jsxs(r1, A({
    ownerState: T,
    className: Y(n.className, S.root, u, M),
    component: d,
    disabled: p,
    focusRipple: !f,
    focusVisibleClassName: Y(S.focusVisible, g),
    ref: t,
    type: y
  }, k, {
    classes: S,
    children: [O, s, P]
  }));
});
process.env.NODE_ENV !== "production" && (Sn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * Element placed after the children.
   */
  endIcon: l.node,
  /**
   * @ignore
   */
  focusVisibleClassName: l.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: l.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * Element placed before the children.
   */
  startIcon: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @ignore
   */
  type: l.oneOfType([l.oneOf(["button", "reset", "submit"]), l.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: l.oneOfType([l.oneOf(["contained", "outlined", "text"]), l.string])
});
function i1(r) {
  return fe("MuiCard", r);
}
ue("MuiCard", ["root"]);
const a1 = ["className", "raised"], s1 = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, i1, e);
}, l1 = H(Wt, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})(() => ({
  overflow: "hidden"
})), c1 = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiCard"
  }), {
    className: o,
    raised: i = !1
  } = n, a = q(n, a1), s = A({}, n, {
    raised: i
  }), c = s1(s);
  return /* @__PURE__ */ w.jsx(l1, A({
    className: Y(c.root, o),
    elevation: i ? 8 : void 0,
    ref: t,
    ownerState: s
  }, a));
});
process.env.NODE_ENV !== "production" && (c1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: Ft(l.bool, (r) => r.raised && r.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function d1(r) {
  return fe("MuiCardActionArea", r);
}
const _s = ue("MuiCardActionArea", ["root", "focusVisible", "focusHighlight"]), u1 = ["children", "className", "focusVisibleClassName"], p1 = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"],
    focusHighlight: ["focusHighlight"]
  }, d1, e);
}, h1 = H(Kt, {
  name: "MuiCardActionArea",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})(({
  theme: r
}) => ({
  display: "block",
  textAlign: "inherit",
  borderRadius: "inherit",
  // for Safari to work https://github.com/mui/material-ui/issues/36285.
  width: "100%",
  [`&:hover .${_s.focusHighlight}`]: {
    opacity: (r.vars || r).palette.action.hoverOpacity,
    "@media (hover: none)": {
      opacity: 0
    }
  },
  [`&.${_s.focusVisible} .${_s.focusHighlight}`]: {
    opacity: (r.vars || r).palette.action.focusOpacity
  }
})), f1 = H("span", {
  name: "MuiCardActionArea",
  slot: "FocusHighlight",
  overridesResolver: (r, e) => e.focusHighlight
})(({
  theme: r
}) => ({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit",
  opacity: 0,
  backgroundColor: "currentcolor",
  transition: r.transitions.create("opacity", {
    duration: r.transitions.duration.short
  })
})), g1 = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiCardActionArea"
  }), {
    children: o,
    className: i,
    focusVisibleClassName: a
  } = n, s = q(n, u1), c = n, d = p1(c);
  return /* @__PURE__ */ w.jsxs(h1, A({
    className: Y(d.root, i),
    focusVisibleClassName: Y(a, d.focusVisible),
    ref: t,
    ownerState: c
  }, s, {
    children: [o, /* @__PURE__ */ w.jsx(f1, {
      className: d.focusHighlight,
      ownerState: c
    })]
  }));
});
process.env.NODE_ENV !== "production" && (g1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * @ignore
   */
  focusVisibleClassName: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function m1(r) {
  return fe("MuiCardContent", r);
}
ue("MuiCardContent", ["root"]);
const b1 = ["className", "component"], x1 = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, m1, e);
}, v1 = H("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})(() => ({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
})), y1 = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiCardContent"
  }), {
    className: o,
    component: i = "div"
  } = n, a = q(n, b1), s = A({}, n, {
    component: i
  }), c = x1(s);
  return /* @__PURE__ */ w.jsx(v1, A({
    as: i,
    className: Y(c.root, o),
    ownerState: s,
    ref: t
  }, a));
});
process.env.NODE_ENV !== "production" && (y1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function w1(r) {
  return fe("MuiCardHeader", r);
}
const Cu = ue("MuiCardHeader", ["root", "avatar", "action", "content", "title", "subheader"]), C1 = ["action", "avatar", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"], k1 = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"],
    avatar: ["avatar"],
    action: ["action"],
    content: ["content"],
    title: ["title"],
    subheader: ["subheader"]
  }, w1, e);
}, S1 = H("div", {
  name: "MuiCardHeader",
  slot: "Root",
  overridesResolver: (r, e) => A({
    [`& .${Cu.title}`]: e.title,
    [`& .${Cu.subheader}`]: e.subheader
  }, e.root)
})({
  display: "flex",
  alignItems: "center",
  padding: 16
}), T1 = H("div", {
  name: "MuiCardHeader",
  slot: "Avatar",
  overridesResolver: (r, e) => e.avatar
})({
  display: "flex",
  flex: "0 0 auto",
  marginRight: 16
}), A1 = H("div", {
  name: "MuiCardHeader",
  slot: "Action",
  overridesResolver: (r, e) => e.action
})({
  flex: "0 0 auto",
  alignSelf: "flex-start",
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
}), O1 = H("div", {
  name: "MuiCardHeader",
  slot: "Content",
  overridesResolver: (r, e) => e.content
})({
  flex: "1 1 auto"
}), R1 = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiCardHeader"
  }), {
    action: o,
    avatar: i,
    className: a,
    component: s = "div",
    disableTypography: c = !1,
    subheader: d,
    subheaderTypographyProps: u,
    title: p,
    titleTypographyProps: h
  } = n, f = q(n, C1), m = A({}, n, {
    component: s,
    disableTypography: c
  }), g = k1(m);
  let b = p;
  b != null && b.type !== We && !c && (b = /* @__PURE__ */ w.jsx(We, A({
    variant: i ? "body2" : "h5",
    className: g.title,
    component: "span",
    display: "block"
  }, h, {
    children: b
  })));
  let x = d;
  return x != null && x.type !== We && !c && (x = /* @__PURE__ */ w.jsx(We, A({
    variant: i ? "body2" : "body1",
    className: g.subheader,
    color: "text.secondary",
    component: "span",
    display: "block"
  }, u, {
    children: x
  }))), /* @__PURE__ */ w.jsxs(S1, A({
    className: Y(g.root, a),
    as: s,
    ref: t,
    ownerState: m
  }, f, {
    children: [i && /* @__PURE__ */ w.jsx(T1, {
      className: g.avatar,
      ownerState: m,
      children: i
    }), /* @__PURE__ */ w.jsxs(O1, {
      className: g.content,
      ownerState: m,
      children: [b, x]
    }), o && /* @__PURE__ */ w.jsx(A1, {
      className: g.action,
      ownerState: m,
      children: o
    })]
  }));
});
process.env.NODE_ENV !== "production" && (R1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display in the card header.
   */
  action: l.node,
  /**
   * The Avatar element to display.
   */
  avatar: l.node,
  /**
   * @ignore
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */
  disableTypography: l.bool,
  /**
   * The content of the component.
   */
  subheader: l.node,
  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The content of the component.
   */
  title: l.node,
  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: l.object
});
function P1(r) {
  return fe("MuiCardMedia", r);
}
ue("MuiCardMedia", ["root", "media", "img"]);
const M1 = ["children", "className", "component", "image", "src", "style"], E1 = (r) => {
  const {
    classes: e,
    isMediaComponent: t,
    isImageComponent: n
  } = r;
  return he({
    root: ["root", t && "media", n && "img"]
  }, P1, e);
}, I1 = H("div", {
  name: "MuiCardMedia",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r, {
      isMediaComponent: n,
      isImageComponent: o
    } = t;
    return [e.root, n && e.media, o && e.img];
  }
})(({
  ownerState: r
}) => A({
  display: "block",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center"
}, r.isMediaComponent && {
  width: "100%"
}, r.isImageComponent && {
  // ⚠️ object-fit is not supported by IE11.
  objectFit: "cover"
})), N1 = ["video", "audio", "picture", "iframe", "img"], L1 = ["picture", "img"], j1 = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiCardMedia"
  }), {
    children: o,
    className: i,
    component: a = "div",
    image: s,
    src: c,
    style: d
  } = n, u = q(n, M1), p = N1.indexOf(a) !== -1, h = !p && s ? A({
    backgroundImage: `url("${s}")`
  }, d) : d, f = A({}, n, {
    component: a,
    isMediaComponent: p,
    isImageComponent: L1.indexOf(a) !== -1
  }), m = E1(f);
  return /* @__PURE__ */ w.jsx(I1, A({
    className: Y(m.root, i),
    as: a,
    role: !p && s ? "img" : void 0,
    ref: t,
    style: h,
    ownerState: f,
    src: p ? s || c : void 0
  }, u, {
    children: o
  }));
});
process.env.NODE_ENV !== "production" && (j1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: Ft(l.node, (r) => !r.children && !r.image && !r.src && !r.component ? new Error("MUI: Either `children`, `image`, `src` or `component` prop must be specified.") : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: l.string,
  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: l.string,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function D1(r) {
  return fe("PrivateSwitchBase", r);
}
ue("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const z1 = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], B1 = (r) => {
  const {
    classes: e,
    checked: t,
    disabled: n,
    edge: o
  } = r, i = {
    root: ["root", t && "checked", n && "disabled", o && `edge${V(o)}`],
    input: ["input"]
  };
  return he(i, D1, e);
}, F1 = H(Kt, {
  name: "MuiSwitchBase"
})(({
  ownerState: r
}) => A({
  padding: 9,
  borderRadius: "50%"
}, r.edge === "start" && {
  marginLeft: r.size === "small" ? -3 : -12
}, r.edge === "end" && {
  marginRight: r.size === "small" ? -3 : -12
})), _1 = H("input", {
  name: "MuiSwitchBase",
  shouldForwardProp: _t
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), Ts = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const {
    autoFocus: n,
    checked: o,
    checkedIcon: i,
    className: a,
    defaultChecked: s,
    disabled: c,
    disableFocusRipple: d = !1,
    edge: u = !1,
    icon: p,
    id: h,
    inputProps: f,
    inputRef: m,
    name: g,
    onBlur: b,
    onChange: x,
    onFocus: v,
    readOnly: y,
    required: C = !1,
    tabIndex: k,
    type: T,
    value: S
  } = e, O = q(e, z1), [P, M] = Rr({
    controlled: o,
    default: !!s,
    name: "SwitchBase",
    state: "checked"
  }), I = Br(), E = (W) => {
    v && v(W), I && I.onFocus && I.onFocus(W);
  }, N = (W) => {
    b && b(W), I && I.onBlur && I.onBlur(W);
  }, L = (W) => {
    if (W.nativeEvent.defaultPrevented)
      return;
    const G = W.target.checked;
    M(G), x && x(W, G);
  };
  let z = c;
  I && typeof z > "u" && (z = I.disabled);
  const F = T === "checkbox" || T === "radio", B = A({}, e, {
    checked: P,
    disabled: z,
    disableFocusRipple: d,
    edge: u
  }), D = B1(B);
  return /* @__PURE__ */ w.jsxs(F1, A({
    component: "span",
    className: Y(D.root, a),
    centerRipple: !0,
    focusRipple: !d,
    disabled: z,
    tabIndex: null,
    role: void 0,
    onFocus: E,
    onBlur: N,
    ownerState: B,
    ref: t
  }, O, {
    children: [/* @__PURE__ */ w.jsx(_1, A({
      autoFocus: n,
      checked: o,
      defaultChecked: s,
      className: D.input,
      disabled: z,
      id: F ? h : void 0,
      name: g,
      onChange: L,
      readOnly: y,
      ref: m,
      required: C,
      ownerState: B,
      tabIndex: k,
      type: T
    }, T === "checkbox" && S === void 0 ? {} : {
      value: S
    }, f)), P ? i : p]
  }));
});
process.env.NODE_ENV !== "production" && (Ts.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: l.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * @ignore
   */
  defaultChecked: l.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: l.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: l.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $t,
  /*
   * @ignore
   */
  name: l.string,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.object,
  /**
   * @ignore
   */
  tabIndex: l.oneOfType([l.number, l.string]),
  /**
   * The input component prop `type`.
   */
  type: l.string.isRequired,
  /**
   * The value of the component.
   */
  value: l.any
});
const $1 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), W1 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), H1 = At(/* @__PURE__ */ w.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function Y1(r) {
  return fe("MuiCheckbox", r);
}
const $s = ue("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), X1 = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"], V1 = (r) => {
  const {
    classes: e,
    indeterminate: t,
    color: n,
    size: o
  } = r, i = {
    root: ["root", t && "indeterminate", `color${V(n)}`, `size${V(o)}`]
  }, a = he(i, Y1, e);
  return A({}, e, a);
}, U1 = H(Ts, {
  shouldForwardProp: (r) => _t(r) || r === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.indeterminate && e.indeterminate, e[`size${V(t.size)}`], t.color !== "default" && e[`color${V(t.color)}`]];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  color: (r.vars || r).palette.text.secondary
}, !e.disableRipple && {
  "&:hover": {
    backgroundColor: r.vars ? `rgba(${e.color === "default" ? r.vars.palette.action.activeChannel : r.vars.palette[e.color].mainChannel} / ${r.vars.palette.action.hoverOpacity})` : Pe.alpha(e.color === "default" ? r.palette.action.active : r.palette[e.color].main, r.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, e.color !== "default" && {
  [`&.${$s.checked}, &.${$s.indeterminate}`]: {
    color: (r.vars || r).palette[e.color].main
  },
  [`&.${$s.disabled}`]: {
    color: (r.vars || r).palette.action.disabled
  }
})), G1 = /* @__PURE__ */ w.jsx(W1, {}), q1 = /* @__PURE__ */ w.jsx($1, {}), K1 = /* @__PURE__ */ w.jsx(H1, {}), _f = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o;
  const i = ge({
    props: e,
    name: "MuiCheckbox"
  }), {
    checkedIcon: a = G1,
    color: s = "primary",
    icon: c = q1,
    indeterminate: d = !1,
    indeterminateIcon: u = K1,
    inputProps: p,
    size: h = "medium",
    className: f
  } = i, m = q(i, X1), g = d ? u : c, b = d ? u : a, x = A({}, i, {
    color: s,
    indeterminate: d,
    size: h
  }), v = V1(x);
  return /* @__PURE__ */ w.jsx(U1, A({
    type: "checkbox",
    inputProps: A({
      "data-indeterminate": d
    }, p),
    icon: /* @__PURE__ */ R.cloneElement(g, {
      fontSize: (n = g.props.fontSize) != null ? n : h
    }),
    checkedIcon: /* @__PURE__ */ R.cloneElement(b, {
      fontSize: (o = b.props.fontSize) != null ? o : h
    }),
    ownerState: x,
    ref: t,
    className: Y(v.root, f)
  }, m, {
    classes: v
  }));
});
process.env.NODE_ENV !== "production" && (_f.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: l.node,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: l.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: l.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $t,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: l.any
});
function Z1(r) {
  return fe("MuiCircularProgress", r);
}
ue("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const J1 = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let As = (r) => r, ku, Su, Tu, Au;
const Jr = 44, Q1 = zr(ku || (ku = As`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)), eC = zr(Su || (Su = As`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)), tC = (r) => {
  const {
    classes: e,
    variant: t,
    color: n,
    disableShrink: o
  } = r, i = {
    root: ["root", t, `color${V(n)}`],
    svg: ["svg"],
    circle: ["circle", `circle${V(t)}`, o && "circleDisableShrink"]
  };
  return he(i, Z1, e);
}, rC = H("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[t.variant], e[`color${V(t.color)}`]];
  }
})(({
  ownerState: r,
  theme: e
}) => A({
  display: "inline-block"
}, r.variant === "determinate" && {
  transition: e.transitions.create("transform")
}, r.color !== "inherit" && {
  color: (e.vars || e).palette[r.color].main
}), ({
  ownerState: r
}) => r.variant === "indeterminate" && Dn(Tu || (Tu = As`
      animation: ${0} 1.4s linear infinite;
    `), Q1)), nC = H("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (r, e) => e.svg
})({
  display: "block"
  // Keeps the progress centered
}), oC = H("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.circle, e[`circle${V(t.variant)}`], t.disableShrink && e.circleDisableShrink];
  }
})(({
  ownerState: r,
  theme: e
}) => A({
  stroke: "currentColor"
}, r.variant === "determinate" && {
  transition: e.transitions.create("stroke-dashoffset")
}, r.variant === "indeterminate" && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0
  // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState: r
}) => r.variant === "indeterminate" && !r.disableShrink && Dn(Au || (Au = As`
      animation: ${0} 1.4s ease-in-out infinite;
    `), eC)), iC = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiCircularProgress"
  }), {
    className: o,
    color: i = "primary",
    disableShrink: a = !1,
    size: s = 40,
    style: c,
    thickness: d = 3.6,
    value: u = 0,
    variant: p = "indeterminate"
  } = n, h = q(n, J1), f = A({}, n, {
    color: i,
    disableShrink: a,
    size: s,
    thickness: d,
    value: u,
    variant: p
  }), m = tC(f), g = {}, b = {}, x = {};
  if (p === "determinate") {
    const v = 2 * Math.PI * ((Jr - d) / 2);
    g.strokeDasharray = v.toFixed(3), x["aria-valuenow"] = Math.round(u), g.strokeDashoffset = `${((100 - u) / 100 * v).toFixed(3)}px`, b.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ w.jsx(rC, A({
    className: Y(m.root, o),
    style: A({
      width: s,
      height: s
    }, b, c),
    ownerState: f,
    ref: t,
    role: "progressbar"
  }, x, h, {
    children: /* @__PURE__ */ w.jsx(nC, {
      className: m.svg,
      ownerState: f,
      viewBox: `${Jr / 2} ${Jr / 2} ${Jr} ${Jr}`,
      children: /* @__PURE__ */ w.jsx(oC, {
        className: m.circle,
        style: g,
        ownerState: f,
        cx: Jr,
        cy: Jr,
        r: (Jr - d) / 2,
        fill: "none",
        strokeWidth: d
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (iC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: Ft(l.bool, (r) => r.disableShrink && r.variant && r.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: l.oneOfType([l.number, l.string]),
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: l.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: l.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: l.oneOf(["determinate", "indeterminate"])
});
function Ou(r) {
  return r.substring(2).toLowerCase();
}
function aC(r, e) {
  return e.documentElement.clientWidth < r.clientX || e.documentElement.clientHeight < r.clientY;
}
function Bi(r) {
  const {
    children: e,
    disableReactTree: t = !1,
    mouseEvent: n = "onClick",
    onClickAway: o,
    touchEvent: i = "onTouchEnd"
  } = r, a = R.useRef(!1), s = R.useRef(null), c = R.useRef(!1), d = R.useRef(!1);
  R.useEffect(() => (setTimeout(() => {
    c.current = !0;
  }, 0), () => {
    c.current = !1;
  }), []);
  const u = ut(fn(e), s), p = Lt((m) => {
    const g = d.current;
    d.current = !1;
    const b = Rt(s.current);
    if (!c.current || !s.current || "clientX" in m && aC(m, b))
      return;
    if (a.current) {
      a.current = !1;
      return;
    }
    let x;
    m.composedPath ? x = m.composedPath().indexOf(s.current) > -1 : x = !b.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      m.target
    ) || s.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      m.target
    ), !x && (t || !g) && o(m);
  }), h = (m) => (g) => {
    d.current = !0;
    const b = e.props[m];
    b && b(g);
  }, f = {
    ref: u
  };
  return i !== !1 && (f[i] = h(i)), R.useEffect(() => {
    if (i !== !1) {
      const m = Ou(i), g = Rt(s.current), b = () => {
        a.current = !0;
      };
      return g.addEventListener(m, p), g.addEventListener("touchmove", b), () => {
        g.removeEventListener(m, p), g.removeEventListener("touchmove", b);
      };
    }
  }, [p, i]), n !== !1 && (f[n] = h(n)), R.useEffect(() => {
    if (n !== !1) {
      const m = Ou(n), g = Rt(s.current);
      return g.addEventListener(m, p), () => {
        g.removeEventListener(m, p);
      };
    }
  }, [p, n]), /* @__PURE__ */ w.jsx(R.Fragment, {
    children: /* @__PURE__ */ R.cloneElement(e, f)
  });
}
process.env.NODE_ENV !== "production" && (Bi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: hn.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: l.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: l.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: l.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: l.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (Bi.propTypes = ko(Bi.propTypes));
const sC = Sx({
  createStyledComponent: H("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (r, e) => {
      const {
        ownerState: t
      } = r;
      return [e.root, e[`maxWidth${V(String(t.maxWidth))}`], t.fixed && e.fixed, t.disableGutters && e.disableGutters];
    }
  }),
  useThemeProps: (r) => ge({
    props: r,
    name: "MuiContainer"
  })
});
process.env.NODE_ENV !== "production" && (sC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   * @default false
   */
  fixed: l.bool,
  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'lg'
   */
  maxWidth: l.oneOfType([l.oneOf(["xs", "sm", "md", "lg", "xl", !1]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const lC = (r, e) => A({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%"
}, e && !r.vars && {
  colorScheme: r.palette.mode
}), cC = (r) => A({
  color: (r.vars || r).palette.text.primary
}, r.typography.body1, {
  backgroundColor: (r.vars || r).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (r.vars || r).palette.common.white
  }
}), dC = (r, e = !1) => {
  var t;
  const n = {};
  e && r.colorSchemes && Object.entries(r.colorSchemes).forEach(([a, s]) => {
    var c;
    n[r.getColorSchemeSelector(a).replace(/\s*&/, "")] = {
      colorScheme: (c = s.palette) == null ? void 0 : c.mode
    };
  });
  let o = A({
    html: lC(r, e),
    "*, *::before, *::after": {
      boxSizing: "inherit"
    },
    "strong, b": {
      fontWeight: r.typography.fontWeightBold
    },
    body: A({
      margin: 0
    }, cC(r), {
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      "&::backdrop": {
        backgroundColor: (r.vars || r).palette.background.default
      }
    })
  }, n);
  const i = (t = r.components) == null || (t = t.MuiCssBaseline) == null ? void 0 : t.styleOverrides;
  return i && (o = [o, i]), o;
};
function uC(r) {
  const e = ge({
    props: r,
    name: "MuiCssBaseline"
  }), {
    children: t,
    enableColorScheme: n = !1
  } = e;
  return /* @__PURE__ */ w.jsxs(R.Fragment, {
    children: [/* @__PURE__ */ w.jsx(Xc, {
      styles: (o) => dC(o, n)
    }), t]
  });
}
process.env.NODE_ENV !== "production" && (uC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: l.node,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   * @default false
   */
  enableColorScheme: l.bool
});
function pC(r) {
  const e = Rt(r);
  return e.body === r ? br(r).innerWidth > e.documentElement.clientWidth : r.scrollHeight > r.clientHeight;
}
function Ti(r, e) {
  e ? r.setAttribute("aria-hidden", "true") : r.removeAttribute("aria-hidden");
}
function Ru(r) {
  return parseInt(br(r).getComputedStyle(r).paddingRight, 10) || 0;
}
function hC(r) {
  const t = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(r.tagName) !== -1, n = r.tagName === "INPUT" && r.getAttribute("type") === "hidden";
  return t || n;
}
function Pu(r, e, t, n, o) {
  const i = [e, t, ...n];
  [].forEach.call(r.children, (a) => {
    const s = i.indexOf(a) === -1, c = !hC(a);
    s && c && Ti(a, o);
  });
}
function Ws(r, e) {
  let t = -1;
  return r.some((n, o) => e(n) ? (t = o, !0) : !1), t;
}
function fC(r, e) {
  const t = [], n = r.container;
  if (!e.disableScrollLock) {
    if (pC(n)) {
      const a = nf(Rt(n));
      t.push({
        value: n.style.paddingRight,
        property: "padding-right",
        el: n
      }), n.style.paddingRight = `${Ru(n) + a}px`;
      const s = Rt(n).querySelectorAll(".mui-fixed");
      [].forEach.call(s, (c) => {
        t.push({
          value: c.style.paddingRight,
          property: "padding-right",
          el: c
        }), c.style.paddingRight = `${Ru(c) + a}px`;
      });
    }
    let i;
    if (n.parentNode instanceof DocumentFragment)
      i = Rt(n).body;
    else {
      const a = n.parentElement, s = br(n);
      i = a?.nodeName === "HTML" && s.getComputedStyle(a).overflowY === "scroll" ? a : n;
    }
    t.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return () => {
    t.forEach(({
      value: i,
      el: a,
      property: s
    }) => {
      i ? a.style.setProperty(s, i) : a.style.removeProperty(s);
    });
  };
}
function gC(r) {
  const e = [];
  return [].forEach.call(r.children, (t) => {
    t.getAttribute("aria-hidden") === "true" && e.push(t);
  }), e;
}
class mC {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(e, t) {
    let n = this.modals.indexOf(e);
    if (n !== -1)
      return n;
    n = this.modals.length, this.modals.push(e), e.modalRef && Ti(e.modalRef, !1);
    const o = gC(t);
    Pu(t, e.mount, e.modalRef, o, !0);
    const i = Ws(this.containers, (a) => a.container === t);
    return i !== -1 ? (this.containers[i].modals.push(e), n) : (this.containers.push({
      modals: [e],
      container: t,
      restore: null,
      hiddenSiblings: o
    }), n);
  }
  mount(e, t) {
    const n = Ws(this.containers, (i) => i.modals.indexOf(e) !== -1), o = this.containers[n];
    o.restore || (o.restore = fC(o, t));
  }
  remove(e, t = !0) {
    const n = this.modals.indexOf(e);
    if (n === -1)
      return n;
    const o = Ws(this.containers, (a) => a.modals.indexOf(e) !== -1), i = this.containers[o];
    if (i.modals.splice(i.modals.indexOf(e), 1), this.modals.splice(n, 1), i.modals.length === 0)
      i.restore && i.restore(), e.modalRef && Ti(e.modalRef, t), Pu(i.container, e.mount, e.modalRef, i.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const a = i.modals[i.modals.length - 1];
      a.modalRef && Ti(a.modalRef, !1);
    }
    return n;
  }
  isTopModal(e) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === e;
  }
}
const bC = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function xC(r) {
  const e = parseInt(r.getAttribute("tabindex") || "", 10);
  return Number.isNaN(e) ? r.contentEditable === "true" || (r.nodeName === "AUDIO" || r.nodeName === "VIDEO" || r.nodeName === "DETAILS") && r.getAttribute("tabindex") === null ? 0 : r.tabIndex : e;
}
function vC(r) {
  if (r.tagName !== "INPUT" || r.type !== "radio" || !r.name)
    return !1;
  const e = (n) => r.ownerDocument.querySelector(`input[type="radio"]${n}`);
  let t = e(`[name="${r.name}"]:checked`);
  return t || (t = e(`[name="${r.name}"]`)), t !== r;
}
function yC(r) {
  return !(r.disabled || r.tagName === "INPUT" && r.type === "hidden" || vC(r));
}
function wC(r) {
  const e = [], t = [];
  return Array.from(r.querySelectorAll(bC)).forEach((n, o) => {
    const i = xC(n);
    i === -1 || !yC(n) || (i === 0 ? e.push(n) : t.push({
      documentOrder: o,
      tabIndex: i,
      node: n
    }));
  }), t.sort((n, o) => n.tabIndex === o.tabIndex ? n.documentOrder - o.documentOrder : n.tabIndex - o.tabIndex).map((n) => n.node).concat(e);
}
function CC() {
  return !0;
}
function Ka(r) {
  const {
    children: e,
    disableAutoFocus: t = !1,
    disableEnforceFocus: n = !1,
    disableRestoreFocus: o = !1,
    getTabbable: i = wC,
    isEnabled: a = CC,
    open: s
  } = r, c = R.useRef(!1), d = R.useRef(null), u = R.useRef(null), p = R.useRef(null), h = R.useRef(null), f = R.useRef(!1), m = R.useRef(null), g = ut(fn(e), m), b = R.useRef(null);
  R.useEffect(() => {
    !s || !m.current || (f.current = !t);
  }, [t, s]), R.useEffect(() => {
    if (!s || !m.current)
      return;
    const y = Rt(m.current);
    return m.current.contains(y.activeElement) || (m.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), m.current.setAttribute("tabIndex", "-1")), f.current && m.current.focus()), () => {
      o || (p.current && p.current.focus && (c.current = !0, p.current.focus()), p.current = null);
    };
  }, [s]), R.useEffect(() => {
    if (!s || !m.current)
      return;
    const y = Rt(m.current), C = (S) => {
      b.current = S, !(n || !a() || S.key !== "Tab") && y.activeElement === m.current && S.shiftKey && (c.current = !0, u.current && u.current.focus());
    }, k = () => {
      const S = m.current;
      if (S === null)
        return;
      if (!y.hasFocus() || !a() || c.current) {
        c.current = !1;
        return;
      }
      if (S.contains(y.activeElement) || n && y.activeElement !== d.current && y.activeElement !== u.current)
        return;
      if (y.activeElement !== h.current)
        h.current = null;
      else if (h.current !== null)
        return;
      if (!f.current)
        return;
      let O = [];
      if ((y.activeElement === d.current || y.activeElement === u.current) && (O = i(m.current)), O.length > 0) {
        var P, M;
        const I = !!((P = b.current) != null && P.shiftKey && ((M = b.current) == null ? void 0 : M.key) === "Tab"), E = O[0], N = O[O.length - 1];
        typeof E != "string" && typeof N != "string" && (I ? N.focus() : E.focus());
      } else
        S.focus();
    };
    y.addEventListener("focusin", k), y.addEventListener("keydown", C, !0);
    const T = setInterval(() => {
      y.activeElement && y.activeElement.tagName === "BODY" && k();
    }, 50);
    return () => {
      clearInterval(T), y.removeEventListener("focusin", k), y.removeEventListener("keydown", C, !0);
    };
  }, [t, n, o, a, s, i]);
  const x = (y) => {
    p.current === null && (p.current = y.relatedTarget), f.current = !0, h.current = y.target;
    const C = e.props.onFocus;
    C && C(y);
  }, v = (y) => {
    p.current === null && (p.current = y.relatedTarget), f.current = !0;
  };
  return /* @__PURE__ */ w.jsxs(R.Fragment, {
    children: [/* @__PURE__ */ w.jsx("div", {
      tabIndex: s ? 0 : -1,
      onFocus: v,
      ref: d,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ R.cloneElement(e, {
      ref: g,
      onFocus: x
    }), /* @__PURE__ */ w.jsx("div", {
      tabIndex: s ? 0 : -1,
      onFocus: v,
      ref: u,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (Ka.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: hn,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: l.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: l.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: l.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: l.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: l.func,
  /**
   * If `true`, focus is locked.
   */
  open: l.bool.isRequired
});
process.env.NODE_ENV !== "production" && (Ka.propTypes = ko(Ka.propTypes));
function kC(r) {
  return typeof r == "function" ? r() : r;
}
function SC(r) {
  return r ? r.props.hasOwnProperty("in") : !1;
}
const TC = new mC();
function AC(r) {
  const {
    container: e,
    disableEscapeKeyDown: t = !1,
    disableScrollLock: n = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: o = TC,
    closeAfterTransition: i = !1,
    onTransitionEnter: a,
    onTransitionExited: s,
    children: c,
    onClose: d,
    open: u,
    rootRef: p
  } = r, h = R.useRef({}), f = R.useRef(null), m = R.useRef(null), g = ut(m, p), [b, x] = R.useState(!u), v = SC(c);
  let y = !0;
  (r["aria-hidden"] === "false" || r["aria-hidden"] === !1) && (y = !1);
  const C = () => Rt(f.current), k = () => (h.current.modalRef = m.current, h.current.mount = f.current, h.current), T = () => {
    o.mount(k(), {
      disableScrollLock: n
    }), m.current && (m.current.scrollTop = 0);
  }, S = Lt(() => {
    const F = kC(e) || C().body;
    o.add(k(), F), m.current && T();
  }), O = R.useCallback(() => o.isTopModal(k()), [o]), P = Lt((F) => {
    f.current = F, F && (u && O() ? T() : m.current && Ti(m.current, y));
  }), M = R.useCallback(() => {
    o.remove(k(), y);
  }, [y, o]);
  R.useEffect(() => () => {
    M();
  }, [M]), R.useEffect(() => {
    u ? S() : (!v || !i) && M();
  }, [u, M, v, i, S]);
  const I = (F) => (B) => {
    var D;
    (D = F.onKeyDown) == null || D.call(F, B), !(B.key !== "Escape" || B.which === 229 || // Wait until IME is settled.
    !O()) && (t || (B.stopPropagation(), d && d(B, "escapeKeyDown")));
  }, E = (F) => (B) => {
    var D;
    (D = F.onClick) == null || D.call(F, B), B.target === B.currentTarget && d && d(B, "backdropClick");
  };
  return {
    getRootProps: (F = {}) => {
      const B = lf(r);
      delete B.onTransitionEnter, delete B.onTransitionExited;
      const D = A({}, B, F);
      return A({
        role: "presentation"
      }, D, {
        onKeyDown: I(D),
        ref: g
      });
    },
    getBackdropProps: (F = {}) => {
      const B = F;
      return A({
        "aria-hidden": !0
      }, B, {
        onClick: E(B),
        open: u
      });
    },
    getTransitionProps: () => {
      const F = () => {
        x(!1), a && a();
      }, B = () => {
        x(!0), s && s(), i && M();
      };
      return {
        onEnter: Wa(F, c?.props.onEnter),
        onExited: Wa(B, c?.props.onExited)
      };
    },
    rootRef: g,
    portalRef: P,
    isTopModal: O,
    exited: b,
    hasTransition: v
  };
}
function OC(r) {
  return fe("MuiModal", r);
}
ue("MuiModal", ["root", "hidden", "backdrop"]);
const RC = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], PC = (r) => {
  const {
    open: e,
    exited: t,
    classes: n
  } = r;
  return he({
    root: ["root", !e && t && "hidden"],
    backdrop: ["backdrop"]
  }, OC, n);
}, MC = H("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, !t.open && t.exited && e.hidden];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  position: "fixed",
  zIndex: (r.vars || r).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !e.open && e.exited && {
  visibility: "hidden"
})), EC = H(Uc, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (r, e) => e.backdrop
})({
  zIndex: -1
}), Os = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o, i, a, s, c;
  const d = ge({
    name: "MuiModal",
    props: e
  }), {
    BackdropComponent: u = EC,
    BackdropProps: p,
    className: h,
    closeAfterTransition: f = !1,
    children: m,
    container: g,
    component: b,
    components: x = {},
    componentsProps: v = {},
    disableAutoFocus: y = !1,
    disableEnforceFocus: C = !1,
    disableEscapeKeyDown: k = !1,
    disablePortal: T = !1,
    disableRestoreFocus: S = !1,
    disableScrollLock: O = !1,
    hideBackdrop: P = !1,
    keepMounted: M = !1,
    onBackdropClick: I,
    open: E,
    slotProps: N,
    slots: L
    // eslint-disable-next-line react/prop-types
  } = d, z = q(d, RC), F = A({}, d, {
    closeAfterTransition: f,
    disableAutoFocus: y,
    disableEnforceFocus: C,
    disableEscapeKeyDown: k,
    disablePortal: T,
    disableRestoreFocus: S,
    disableScrollLock: O,
    hideBackdrop: P,
    keepMounted: M
  }), {
    getRootProps: B,
    getBackdropProps: D,
    getTransitionProps: W,
    portalRef: G,
    isTopModal: re,
    exited: ce,
    hasTransition: Ce
  } = AC(A({}, F, {
    rootRef: t
  })), ne = A({}, F, {
    exited: ce
  }), pe = PC(ne), K = {};
  if (m.props.tabIndex === void 0 && (K.tabIndex = "-1"), Ce) {
    const {
      onEnter: ke,
      onExited: Oe
    } = W();
    K.onEnter = ke, K.onExited = Oe;
  }
  const le = (n = (o = L?.root) != null ? o : x.Root) != null ? n : MC, Q = (i = (a = L?.backdrop) != null ? a : x.Backdrop) != null ? i : u, se = (s = N?.root) != null ? s : v.root, Re = (c = N?.backdrop) != null ? c : v.backdrop, be = tr({
    elementType: le,
    externalSlotProps: se,
    externalForwardedProps: z,
    getSlotProps: B,
    additionalProps: {
      ref: t,
      as: b
    },
    ownerState: ne,
    className: Y(h, se?.className, pe?.root, !ne.open && ne.exited && pe?.hidden)
  }), Ne = tr({
    elementType: Q,
    externalSlotProps: Re,
    additionalProps: p,
    getSlotProps: (ke) => D(A({}, ke, {
      onClick: (Oe) => {
        I && I(Oe), ke != null && ke.onClick && ke.onClick(Oe);
      }
    })),
    className: Y(Re?.className, p?.className, pe?.backdrop),
    ownerState: ne
  });
  return !M && !E && (!Ce || ce) ? null : /* @__PURE__ */ w.jsx(zi, {
    ref: G,
    container: g,
    disablePortal: T,
    children: /* @__PURE__ */ w.jsxs(le, A({}, be, {
      children: [!P && u ? /* @__PURE__ */ w.jsx(Q, A({}, Ne)) : null, /* @__PURE__ */ w.jsx(Ka, {
        disableEnforceFocus: C,
        disableAutoFocus: y,
        disableRestoreFocus: S,
        isEnabled: re,
        open: E,
        children: /* @__PURE__ */ R.cloneElement(m, K)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Os.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: l.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: l.object,
  /**
   * A single child content element.
   */
  children: hn.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: l.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Backdrop: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    backdrop: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([jr, l.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: l.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: l.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: l.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: l.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: l.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: l.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: l.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: l.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: l.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: l.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: l.shape({
    backdrop: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    backdrop: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function IC(r) {
  return fe("MuiDialog", r);
}
const Hs = ue("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), Gc = /* @__PURE__ */ R.createContext({});
process.env.NODE_ENV !== "production" && (Gc.displayName = "DialogContext");
const NC = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"], LC = H(Uc, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (r, e) => e.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), jC = (r) => {
  const {
    classes: e,
    scroll: t,
    maxWidth: n,
    fullWidth: o,
    fullScreen: i
  } = r, a = {
    root: ["root"],
    container: ["container", `scroll${V(t)}`],
    paper: ["paper", `paperScroll${V(t)}`, `paperWidth${V(String(n))}`, o && "paperFullWidth", i && "paperFullScreen"]
  };
  return he(a, IC, e);
}, DC = H(Os, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), zC = H("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.container, e[`scroll${V(t.scroll)}`]];
  }
})(({
  ownerState: r
}) => A({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, r.scroll === "paper" && {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, r.scroll === "body" && {
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
  "&::after": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",
    height: "100%",
    width: "0"
  }
})), BC = H(Wt, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.paper, e[`scrollPaper${V(t.scroll)}`], e[`paperWidth${V(String(t.maxWidth))}`], t.fullWidth && e.paperFullWidth, t.fullScreen && e.paperFullScreen];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  // Fix IE11 issue, to remove at some point.
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  }
}, e.scroll === "paper" && {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100% - 64px)"
}, e.scroll === "body" && {
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "left"
  // 'initial' doesn't work on IE11
}, !e.maxWidth && {
  maxWidth: "calc(100% - 64px)"
}, e.maxWidth === "xs" && {
  maxWidth: r.breakpoints.unit === "px" ? Math.max(r.breakpoints.values.xs, 444) : `max(${r.breakpoints.values.xs}${r.breakpoints.unit}, 444px)`,
  [`&.${Hs.paperScrollBody}`]: {
    [r.breakpoints.down(Math.max(r.breakpoints.values.xs, 444) + 64)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, e.maxWidth && e.maxWidth !== "xs" && {
  maxWidth: `${r.breakpoints.values[e.maxWidth]}${r.breakpoints.unit}`,
  [`&.${Hs.paperScrollBody}`]: {
    [r.breakpoints.down(r.breakpoints.values[e.maxWidth] + 64)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, e.fullWidth && {
  width: "calc(100% - 64px)"
}, e.fullScreen && {
  margin: 0,
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "none",
  borderRadius: 0,
  [`&.${Hs.paperScrollBody}`]: {
    margin: 0,
    maxWidth: "100%"
  }
})), FC = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiDialog"
  }), o = yr(), i = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    "aria-describedby": a,
    "aria-labelledby": s,
    BackdropComponent: c,
    BackdropProps: d,
    children: u,
    className: p,
    disableEscapeKeyDown: h = !1,
    fullScreen: f = !1,
    fullWidth: m = !1,
    maxWidth: g = "sm",
    onBackdropClick: b,
    onClick: x,
    onClose: v,
    open: y,
    PaperComponent: C = Wt,
    PaperProps: k = {},
    scroll: T = "paper",
    TransitionComponent: S = Vc,
    transitionDuration: O = i,
    TransitionProps: P
  } = n, M = q(n, NC), I = A({}, n, {
    disableEscapeKeyDown: h,
    fullScreen: f,
    fullWidth: m,
    maxWidth: g,
    scroll: T
  }), E = jC(I), N = R.useRef(), L = (D) => {
    N.current = D.target === D.currentTarget;
  }, z = (D) => {
    x && x(D), N.current && (N.current = null, b && b(D), v && v(D, "backdropClick"));
  }, F = Yr(s), B = R.useMemo(() => ({
    titleId: F
  }), [F]);
  return /* @__PURE__ */ w.jsx(DC, A({
    className: Y(E.root, p),
    closeAfterTransition: !0,
    components: {
      Backdrop: LC
    },
    componentsProps: {
      backdrop: A({
        transitionDuration: O,
        as: c
      }, d)
    },
    disableEscapeKeyDown: h,
    onClose: v,
    open: y,
    ref: t,
    onClick: z,
    ownerState: I
  }, M, {
    children: /* @__PURE__ */ w.jsx(S, A({
      appear: !0,
      in: y,
      timeout: O,
      role: "presentation"
    }, P, {
      children: /* @__PURE__ */ w.jsx(zC, {
        className: Y(E.container),
        onMouseDown: L,
        ownerState: I,
        children: /* @__PURE__ */ w.jsx(BC, A({
          as: C,
          elevation: 24,
          role: "dialog",
          "aria-describedby": a,
          "aria-labelledby": F
        }, k, {
          className: Y(E.paper, k.className),
          ownerState: I,
          children: /* @__PURE__ */ w.jsx(Gc.Provider, {
            value: B,
            children: u
          })
        }))
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (FC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": l.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": l.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: l.elementType,
  /**
   * @ignore
   */
  BackdropProps: l.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: l.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: l.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: l.oneOfType([l.oneOf(["xs", "sm", "md", "lg", "xl", !1]), l.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: l.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: l.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: l.oneOf(["body", "paper"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: l.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: l.object
});
function _C(r) {
  return fe("MuiDialogActions", r);
}
ue("MuiDialogActions", ["root", "spacing"]);
const $C = ["className", "disableSpacing"], WC = (r) => {
  const {
    classes: e,
    disableSpacing: t
  } = r;
  return he({
    root: ["root", !t && "spacing"]
  }, _C, e);
}, HC = H("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, !t.disableSpacing && e.spacing];
  }
})(({
  ownerState: r
}) => A({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto"
}, !r.disableSpacing && {
  "& > :not(style) ~ :not(style)": {
    marginLeft: 8
  }
})), YC = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiDialogActions"
  }), {
    className: o,
    disableSpacing: i = !1
  } = n, a = q(n, $C), s = A({}, n, {
    disableSpacing: i
  }), c = WC(s);
  return /* @__PURE__ */ w.jsx(HC, A({
    className: Y(c.root, o),
    ownerState: s,
    ref: t
  }, a));
});
process.env.NODE_ENV !== "production" && (YC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function XC(r) {
  return fe("MuiDialogContent", r);
}
ue("MuiDialogContent", ["root", "dividers"]);
function VC(r) {
  return fe("MuiDialogTitle", r);
}
const UC = ue("MuiDialogTitle", ["root"]), GC = ["className", "dividers"], qC = (r) => {
  const {
    classes: e,
    dividers: t
  } = r;
  return he({
    root: ["root", t && "dividers"]
  }, XC, e);
}, KC = H("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.dividers && e.dividers];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px"
}, e.dividers ? {
  padding: "16px 24px",
  borderTop: `1px solid ${(r.vars || r).palette.divider}`,
  borderBottom: `1px solid ${(r.vars || r).palette.divider}`
} : {
  [`.${UC.root} + &`]: {
    paddingTop: 0
  }
})), ZC = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiDialogContent"
  }), {
    className: o,
    dividers: i = !1
  } = n, a = q(n, GC), s = A({}, n, {
    dividers: i
  }), c = qC(s);
  return /* @__PURE__ */ w.jsx(KC, A({
    className: Y(c.root, o),
    ownerState: s,
    ref: t
  }, a));
});
process.env.NODE_ENV !== "production" && (ZC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const JC = ["className", "id"], QC = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, VC, e);
}, ek = H(We, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), tk = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiDialogTitle"
  }), {
    className: o,
    id: i
  } = n, a = q(n, JC), s = n, c = QC(s), {
    titleId: d = i
  } = R.useContext(Gc);
  return /* @__PURE__ */ w.jsx(ek, A({
    component: "h2",
    className: Y(c.root, o),
    ownerState: s,
    ref: t,
    variant: "h6",
    id: i ?? d
  }, a));
});
process.env.NODE_ENV !== "production" && (tk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * @ignore
   */
  id: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function rk(r) {
  return fe("MuiDivider", r);
}
const Mu = ue("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), nk = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"], ok = (r) => {
  const {
    absolute: e,
    children: t,
    classes: n,
    flexItem: o,
    light: i,
    orientation: a,
    textAlign: s,
    variant: c
  } = r;
  return he({
    root: ["root", e && "absolute", c, i && "light", a === "vertical" && "vertical", o && "flexItem", t && "withChildren", t && a === "vertical" && "withChildrenVertical", s === "right" && a !== "vertical" && "textAlignRight", s === "left" && a !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", a === "vertical" && "wrapperVertical"]
  }, rk, n);
}, ik = H("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.absolute && e.absolute, e[t.variant], t.light && e.light, t.orientation === "vertical" && e.vertical, t.flexItem && e.flexItem, t.children && e.withChildren, t.children && t.orientation === "vertical" && e.withChildrenVertical, t.textAlign === "right" && t.orientation !== "vertical" && e.textAlignRight, t.textAlign === "left" && t.orientation !== "vertical" && e.textAlignLeft];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (r.vars || r).palette.divider,
  borderBottomWidth: "thin"
}, e.absolute && {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%"
}, e.light && {
  borderColor: r.vars ? `rgba(${r.vars.palette.dividerChannel} / 0.08)` : Pe.alpha(r.palette.divider, 0.08)
}, e.variant === "inset" && {
  marginLeft: 72
}, e.variant === "middle" && e.orientation === "horizontal" && {
  marginLeft: r.spacing(2),
  marginRight: r.spacing(2)
}, e.variant === "middle" && e.orientation === "vertical" && {
  marginTop: r.spacing(1),
  marginBottom: r.spacing(1)
}, e.orientation === "vertical" && {
  height: "100%",
  borderBottomWidth: 0,
  borderRightWidth: "thin"
}, e.flexItem && {
  alignSelf: "stretch",
  height: "auto"
}), ({
  ownerState: r
}) => A({}, r.children && {
  display: "flex",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0,
  borderTopStyle: "solid",
  borderLeftStyle: "solid",
  "&::before, &::after": {
    content: '""',
    alignSelf: "center"
  }
}), ({
  theme: r,
  ownerState: e
}) => A({}, e.children && e.orientation !== "vertical" && {
  "&::before, &::after": {
    width: "100%",
    borderTop: `thin solid ${(r.vars || r).palette.divider}`,
    borderTopStyle: "inherit"
  }
}), ({
  theme: r,
  ownerState: e
}) => A({}, e.children && e.orientation === "vertical" && {
  flexDirection: "column",
  "&::before, &::after": {
    height: "100%",
    borderLeft: `thin solid ${(r.vars || r).palette.divider}`,
    borderLeftStyle: "inherit"
  }
}), ({
  ownerState: r
}) => A({}, r.textAlign === "right" && r.orientation !== "vertical" && {
  "&::before": {
    width: "90%"
  },
  "&::after": {
    width: "10%"
  }
}, r.textAlign === "left" && r.orientation !== "vertical" && {
  "&::before": {
    width: "10%"
  },
  "&::after": {
    width: "90%"
  }
})), ak = H("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.wrapper, t.orientation === "vertical" && e.wrapperVertical];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  display: "inline-block",
  paddingLeft: `calc(${r.spacing(1)} * 1.2)`,
  paddingRight: `calc(${r.spacing(1)} * 1.2)`
}, e.orientation === "vertical" && {
  paddingTop: `calc(${r.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${r.spacing(1)} * 1.2)`
})), qc = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiDivider"
  }), {
    absolute: o = !1,
    children: i,
    className: a,
    component: s = i ? "div" : "hr",
    flexItem: c = !1,
    light: d = !1,
    orientation: u = "horizontal",
    role: p = s !== "hr" ? "separator" : void 0,
    textAlign: h = "center",
    variant: f = "fullWidth"
  } = n, m = q(n, nk), g = A({}, n, {
    absolute: o,
    component: s,
    flexItem: c,
    light: d,
    orientation: u,
    role: p,
    textAlign: h,
    variant: f
  }), b = ok(g);
  return /* @__PURE__ */ w.jsx(ik, A({
    as: s,
    className: Y(b.root, a),
    role: p,
    ref: t,
    ownerState: g
  }, m, {
    children: i ? /* @__PURE__ */ w.jsx(ak, {
      className: b.wrapper,
      ownerState: g,
      children: i
    }) : null
  }));
});
qc.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (qc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: l.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  light: l.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: l.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: l.oneOfType([l.oneOf(["fullWidth", "inset", "middle"]), l.string])
});
const sk = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function lk(r, e, t) {
  const n = e.getBoundingClientRect(), o = t && t.getBoundingClientRect(), i = br(e);
  let a;
  if (e.fakeTransform)
    a = e.fakeTransform;
  else {
    const d = i.getComputedStyle(e);
    a = d.getPropertyValue("-webkit-transform") || d.getPropertyValue("transform");
  }
  let s = 0, c = 0;
  if (a && a !== "none" && typeof a == "string") {
    const d = a.split("(")[1].split(")")[0].split(",");
    s = parseInt(d[4], 10), c = parseInt(d[5], 10);
  }
  return r === "left" ? o ? `translateX(${o.right + s - n.left}px)` : `translateX(${i.innerWidth + s - n.left}px)` : r === "right" ? o ? `translateX(-${n.right - o.left - s}px)` : `translateX(-${n.left + n.width - s}px)` : r === "up" ? o ? `translateY(${o.bottom + c - n.top}px)` : `translateY(${i.innerHeight + c - n.top}px)` : o ? `translateY(-${n.top - o.top + n.height - c}px)` : `translateY(-${n.top + n.height - c}px)`;
}
function $f(r) {
  return typeof r == "function" ? r() : r;
}
function ya(r, e, t) {
  const n = $f(t), o = lk(r, e, n);
  o && (e.style.webkitTransform = o, e.style.transform = o);
}
const Wf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = yr(), o = {
    enter: n.transitions.easing.easeOut,
    exit: n.transitions.easing.sharp
  }, i = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: a,
    appear: s = !0,
    children: c,
    container: d,
    direction: u = "down",
    easing: p = o,
    in: h,
    onEnter: f,
    onEntered: m,
    onEntering: g,
    onExit: b,
    onExited: x,
    onExiting: v,
    style: y,
    timeout: C = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: k = wr
  } = e, T = q(e, sk), S = R.useRef(null), O = ut(fn(c), S, t), P = (D) => (W) => {
    D && (W === void 0 ? D(S.current) : D(S.current, W));
  }, M = P((D, W) => {
    ya(u, D, d), Lc(D), f && f(D, W);
  }), I = P((D, W) => {
    const G = ln({
      timeout: C,
      style: y,
      easing: p
    }, {
      mode: "enter"
    });
    D.style.webkitTransition = n.transitions.create("-webkit-transform", A({}, G)), D.style.transition = n.transitions.create("transform", A({}, G)), D.style.webkitTransform = "none", D.style.transform = "none", g && g(D, W);
  }), E = P(m), N = P(v), L = P((D) => {
    const W = ln({
      timeout: C,
      style: y,
      easing: p
    }, {
      mode: "exit"
    });
    D.style.webkitTransition = n.transitions.create("-webkit-transform", W), D.style.transition = n.transitions.create("transform", W), ya(u, D, d), b && b(D);
  }), z = P((D) => {
    D.style.webkitTransition = "", D.style.transition = "", x && x(D);
  }), F = (D) => {
    a && a(S.current, D);
  }, B = R.useCallback(() => {
    S.current && ya(u, S.current, d);
  }, [u, d]);
  return R.useEffect(() => {
    if (h || u === "down" || u === "right")
      return;
    const D = So(() => {
      S.current && ya(u, S.current, d);
    }), W = br(S.current);
    return W.addEventListener("resize", D), () => {
      D.clear(), W.removeEventListener("resize", D);
    };
  }, [u, h, d]), R.useEffect(() => {
    h || B();
  }, [h, B]), /* @__PURE__ */ w.jsx(k, A({
    nodeRef: S,
    onEnter: M,
    onEntered: E,
    onEntering: I,
    onExit: L,
    onExited: z,
    onExiting: N,
    addEndListener: F,
    appear: s,
    in: h,
    timeout: C
  }, T, {
    children: (D, W) => /* @__PURE__ */ R.cloneElement(c, A({
      ref: O,
      style: A({
        visibility: D === "exited" && !h ? "hidden" : void 0
      }, y, c.props.style)
    }, W))
  }));
});
process.env.NODE_ENV !== "production" && (Wf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: l.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: l.bool,
  /**
   * A single child content element.
   */
  children: hn.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: Ft(l.oneOfType([jr, l.func]), (r) => {
    if (r.open) {
      const e = $f(r.container);
      if (e && e.nodeType === 1) {
        const t = e.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && t.top === 0 && t.left === 0 && t.right === 0 && t.bottom === 0)
          return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!e || typeof e.getBoundingClientRect != "function" || e.contextElement != null && e.contextElement.nodeType !== 1)
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join(`
`));
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: l.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: l.oneOfType([l.shape({
    enter: l.string,
    exit: l.string
  }), l.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: l.bool,
  /**
   * @ignore
   */
  onEnter: l.func,
  /**
   * @ignore
   */
  onEntered: l.func,
  /**
   * @ignore
   */
  onEntering: l.func,
  /**
   * @ignore
   */
  onExit: l.func,
  /**
   * @ignore
   */
  onExited: l.func,
  /**
   * @ignore
   */
  onExiting: l.func,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
function ck(r) {
  return fe("MuiDrawer", r);
}
ue("MuiDrawer", ["root", "docked", "paper", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]);
const dk = ["BackdropProps"], uk = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"], Hf = (r, e) => {
  const {
    ownerState: t
  } = r;
  return [e.root, (t.variant === "permanent" || t.variant === "persistent") && e.docked, e.modal];
}, pk = (r) => {
  const {
    classes: e,
    anchor: t,
    variant: n
  } = r, o = {
    root: ["root"],
    docked: [(n === "permanent" || n === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${V(t)}`, n !== "temporary" && `paperAnchorDocked${V(t)}`]
  };
  return he(o, ck, e);
}, hk = H(Os, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: Hf
})(({
  theme: r
}) => ({
  zIndex: (r.vars || r).zIndex.drawer
})), Eu = H("div", {
  shouldForwardProp: _t,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: !1,
  overridesResolver: Hf
})({
  flex: "0 0 auto"
}), fk = H(Wt, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.paper, e[`paperAnchor${V(t.anchor)}`], t.variant !== "temporary" && e[`paperAnchorDocked${V(t.anchor)}`]];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (r.vars || r).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, e.anchor === "left" && {
  left: 0
}, e.anchor === "top" && {
  top: 0,
  left: 0,
  right: 0,
  height: "auto",
  maxHeight: "100%"
}, e.anchor === "right" && {
  right: 0
}, e.anchor === "bottom" && {
  top: "auto",
  left: 0,
  bottom: 0,
  right: 0,
  height: "auto",
  maxHeight: "100%"
}, e.anchor === "left" && e.variant !== "temporary" && {
  borderRight: `1px solid ${(r.vars || r).palette.divider}`
}, e.anchor === "top" && e.variant !== "temporary" && {
  borderBottom: `1px solid ${(r.vars || r).palette.divider}`
}, e.anchor === "right" && e.variant !== "temporary" && {
  borderLeft: `1px solid ${(r.vars || r).palette.divider}`
}, e.anchor === "bottom" && e.variant !== "temporary" && {
  borderTop: `1px solid ${(r.vars || r).palette.divider}`
})), Yf = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function gk(r) {
  return ["left", "right"].indexOf(r) !== -1;
}
function mk({
  direction: r
}, e) {
  return r === "rtl" && gk(e) ? Yf[e] : e;
}
const bk = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiDrawer"
  }), o = yr(), i = gn(), a = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    anchor: s = "left",
    BackdropProps: c,
    children: d,
    className: u,
    elevation: p = 16,
    hideBackdrop: h = !1,
    ModalProps: {
      BackdropProps: f
    } = {},
    onClose: m,
    open: g = !1,
    PaperProps: b = {},
    SlideProps: x,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: v = Wf,
    transitionDuration: y = a,
    variant: C = "temporary"
  } = n, k = q(n.ModalProps, dk), T = q(n, uk), S = R.useRef(!1);
  R.useEffect(() => {
    S.current = !0;
  }, []);
  const O = mk({
    direction: i ? "rtl" : "ltr"
  }, s), M = A({}, n, {
    anchor: s,
    elevation: p,
    open: g,
    variant: C
  }, T), I = pk(M), E = /* @__PURE__ */ w.jsx(fk, A({
    elevation: C === "temporary" ? p : 0,
    square: !0
  }, b, {
    className: Y(I.paper, b.className),
    ownerState: M,
    children: d
  }));
  if (C === "permanent")
    return /* @__PURE__ */ w.jsx(Eu, A({
      className: Y(I.root, I.docked, u),
      ownerState: M,
      ref: t
    }, T, {
      children: E
    }));
  const N = /* @__PURE__ */ w.jsx(v, A({
    in: g,
    direction: Yf[O],
    timeout: y,
    appear: S.current
  }, x, {
    children: E
  }));
  return C === "persistent" ? /* @__PURE__ */ w.jsx(Eu, A({
    className: Y(I.root, I.docked, u),
    ownerState: M,
    ref: t
  }, T, {
    children: N
  })) : /* @__PURE__ */ w.jsx(hk, A({
    BackdropProps: A({}, c, f, {
      transitionDuration: y
    }),
    className: Y(I.root, I.modal, u),
    open: g,
    ownerState: M,
    onClose: m,
    hideBackdrop: h,
    ref: t
  }, T, k, {
    children: N
  }));
});
process.env.NODE_ENV !== "production" && (bk.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: l.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: l.object,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: Ut,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: l.bool,
  /**
   * Props applied to the [`Modal`](/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: l.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: l.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: l.bool,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: l.object,
  /**
   * Props applied to the [`Slide`](/material-ui/api/slide/) element.
   */
  SlideProps: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: l.oneOf(["permanent", "persistent", "temporary"])
});
const xk = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], vk = (r) => {
  const {
    classes: e,
    disableUnderline: t
  } = r, o = he({
    root: ["root", !t && "underline"],
    input: ["input"]
  }, J0, e);
  return A({}, e, o);
}, yk = H(ks, {
  shouldForwardProp: (r) => _t(r) || r === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [...ws(r, e), !t.disableUnderline && e.underline];
  }
})(({
  theme: r,
  ownerState: e
}) => {
  var t;
  const n = r.palette.mode === "light", o = n ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", i = n ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", a = n ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", s = n ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return A({
    position: "relative",
    backgroundColor: r.vars ? r.vars.palette.FilledInput.bg : i,
    borderTopLeftRadius: (r.vars || r).shape.borderRadius,
    borderTopRightRadius: (r.vars || r).shape.borderRadius,
    transition: r.transitions.create("background-color", {
      duration: r.transitions.duration.shorter,
      easing: r.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: r.vars ? r.vars.palette.FilledInput.hoverBg : a,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: r.vars ? r.vars.palette.FilledInput.bg : i
      }
    },
    [`&.${ir.focused}`]: {
      backgroundColor: r.vars ? r.vars.palette.FilledInput.bg : i
    },
    [`&.${ir.disabled}`]: {
      backgroundColor: r.vars ? r.vars.palette.FilledInput.disabledBg : s
    }
  }, !e.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(t = (r.vars || r).palette[e.color || "primary"]) == null ? void 0 : t.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: r.transitions.create("transform", {
        duration: r.transitions.duration.shorter,
        easing: r.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${ir.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${ir.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (r.vars || r).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${r.vars ? `rgba(${r.vars.palette.common.onBackgroundChannel} / ${r.vars.opacity.inputUnderline})` : o}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: r.transitions.create("border-bottom-color", {
        duration: r.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${ir.disabled}, .${ir.error}):before`]: {
      borderBottom: `1px solid ${(r.vars || r).palette.text.primary}`
    },
    [`&.${ir.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, e.startAdornment && {
    paddingLeft: 12
  }, e.endAdornment && {
    paddingRight: 12
  }, e.multiline && A({
    padding: "25px 12px 8px"
  }, e.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, e.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, e.hiddenLabel && e.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), wk = H(Ss, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: Cs
})(({
  theme: r,
  ownerState: e
}) => A({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !r.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: r.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: r.palette.mode === "light" ? null : "#fff",
    caretColor: r.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, r.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [r.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, e.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, e.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, e.startAdornment && {
  paddingLeft: 0
}, e.endAdornment && {
  paddingRight: 0
}, e.hiddenLabel && e.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, e.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), Kc = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o, i, a;
  const s = ge({
    props: e,
    name: "MuiFilledInput"
  }), {
    components: c = {},
    componentsProps: d,
    fullWidth: u = !1,
    // declare here to prevent spreading to DOM
    inputComponent: p = "input",
    multiline: h = !1,
    slotProps: f,
    slots: m = {},
    type: g = "text"
  } = s, b = q(s, xk), x = A({}, s, {
    fullWidth: u,
    inputComponent: p,
    multiline: h,
    type: g
  }), v = vk(s), y = {
    root: {
      ownerState: x
    },
    input: {
      ownerState: x
    }
  }, C = f ?? d ? co(y, f ?? d) : y, k = (n = (o = m.root) != null ? o : c.Root) != null ? n : yk, T = (i = (a = m.input) != null ? a : c.Input) != null ? i : wk;
  return /* @__PURE__ */ w.jsx(ea, A({
    slots: {
      root: k,
      input: T
    },
    componentsProps: C,
    fullWidth: u,
    inputComponent: p,
    multiline: h,
    ref: t,
    type: g
  }, b, {
    classes: v
  }));
});
process.env.NODE_ENV !== "production" && (Kc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $t,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
Kc.muiName = "Input";
function Ck(r) {
  return fe("MuiFormControl", r);
}
ue("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const kk = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], Sk = (r) => {
  const {
    classes: e,
    margin: t,
    fullWidth: n
  } = r, o = {
    root: ["root", t !== "none" && `margin${V(t)}`, n && "fullWidth"]
  };
  return he(o, Ck, e);
}, Tk = H("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: r
  }, e) => A({}, e.root, e[`margin${V(r.margin)}`], r.fullWidth && e.fullWidth)
})(({
  ownerState: r
}) => A({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, r.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, r.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, r.fullWidth && {
  width: "100%"
})), Rs = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiFormControl"
  }), {
    children: o,
    className: i,
    color: a = "primary",
    component: s = "div",
    disabled: c = !1,
    error: d = !1,
    focused: u,
    fullWidth: p = !1,
    hiddenLabel: h = !1,
    margin: f = "none",
    required: m = !1,
    size: g = "medium",
    variant: b = "outlined"
  } = n, x = q(n, kk), v = A({}, n, {
    color: a,
    component: s,
    disabled: c,
    error: d,
    fullWidth: p,
    hiddenLabel: h,
    margin: f,
    required: m,
    size: g,
    variant: b
  }), y = Sk(v), [C, k] = R.useState(() => {
    let N = !1;
    return o && R.Children.forEach(o, (L) => {
      if (!ao(L, ["Input", "Select"]))
        return;
      const z = ao(L, ["Select"]) ? L.props.input : L;
      z && X0(z.props) && (N = !0);
    }), N;
  }), [T, S] = R.useState(() => {
    let N = !1;
    return o && R.Children.forEach(o, (L) => {
      ao(L, ["Input", "Select"]) && (qa(L.props, !0) || qa(L.props.inputProps, !0)) && (N = !0);
    }), N;
  }), [O, P] = R.useState(!1);
  c && O && P(!1);
  const M = u !== void 0 && !c ? u : O;
  let I;
  if (process.env.NODE_ENV !== "production") {
    const N = R.useRef(!1);
    I = () => (N.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), N.current = !0, () => {
      N.current = !1;
    });
  }
  const E = R.useMemo(() => ({
    adornedStart: C,
    setAdornedStart: k,
    color: a,
    disabled: c,
    error: d,
    filled: T,
    focused: M,
    fullWidth: p,
    hiddenLabel: h,
    size: g,
    onBlur: () => {
      P(!1);
    },
    onEmpty: () => {
      S(!1);
    },
    onFilled: () => {
      S(!0);
    },
    onFocus: () => {
      P(!0);
    },
    registerEffect: I,
    required: m,
    variant: b
  }), [C, a, c, d, T, M, p, h, I, m, g, b]);
  return /* @__PURE__ */ w.jsx(Qi.Provider, {
    value: E,
    children: /* @__PURE__ */ w.jsx(Tk, A({
      as: s,
      ownerState: v,
      className: Y(y.root, i),
      ref: t
    }, x, {
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (Rs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: l.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: l.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
const Zc = Ix({
  createStyledComponent: H("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (r, e) => e.root
  }),
  useThemeProps: (r) => ge({
    props: r,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (Zc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: l.oneOfType([l.oneOf(["column-reverse", "column", "row-reverse", "row"]), l.arrayOf(l.oneOf(["column-reverse", "column", "row-reverse", "row"])), l.object]),
  /**
   * Add an element between each child.
   */
  divider: l.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: l.bool
});
function Ak(r) {
  return fe("MuiFormControlLabel", r);
}
const bi = ue("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), Ok = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"], Rk = (r) => {
  const {
    classes: e,
    disabled: t,
    labelPlacement: n,
    error: o,
    required: i
  } = r, a = {
    root: ["root", t && "disabled", `labelPlacement${V(n)}`, o && "error", i && "required"],
    label: ["label", t && "disabled"],
    asterisk: ["asterisk", o && "error"]
  };
  return he(a, Ak, e);
}, Pk = H("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [{
      [`& .${bi.label}`]: e.label
    }, e.root, e[`labelPlacement${V(t.labelPlacement)}`]];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${bi.disabled}`]: {
    cursor: "default"
  }
}, e.labelPlacement === "start" && {
  flexDirection: "row-reverse",
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, e.labelPlacement === "top" && {
  flexDirection: "column-reverse",
  marginLeft: 16
}, e.labelPlacement === "bottom" && {
  flexDirection: "column",
  marginLeft: 16
}, {
  [`& .${bi.label}`]: {
    [`&.${bi.disabled}`]: {
      color: (r.vars || r).palette.text.disabled
    }
  }
})), Mk = H("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (r, e) => e.asterisk
})(({
  theme: r
}) => ({
  [`&.${bi.error}`]: {
    color: (r.vars || r).palette.error.main
  }
})), Xf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o;
  const i = ge({
    props: e,
    name: "MuiFormControlLabel"
  }), {
    className: a,
    componentsProps: s = {},
    control: c,
    disabled: d,
    disableTypography: u,
    label: p,
    labelPlacement: h = "end",
    required: f,
    slotProps: m = {}
  } = i, g = q(i, Ok), b = Br(), x = (n = d ?? c.props.disabled) != null ? n : b?.disabled, v = f ?? c.props.required, y = {
    disabled: x,
    required: v
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((P) => {
    typeof c.props[P] > "u" && typeof i[P] < "u" && (y[P] = i[P]);
  });
  const C = bn({
    props: i,
    muiFormControl: b,
    states: ["error"]
  }), k = A({}, i, {
    disabled: x,
    labelPlacement: h,
    required: v,
    error: C.error
  }), T = Rk(k), S = (o = m.typography) != null ? o : s.typography;
  let O = p;
  return O != null && O.type !== We && !u && (O = /* @__PURE__ */ w.jsx(We, A({
    component: "span"
  }, S, {
    className: Y(T.label, S?.className),
    children: O
  }))), /* @__PURE__ */ w.jsxs(Pk, A({
    className: Y(T.root, a),
    ownerState: k,
    ref: t
  }, g, {
    children: [/* @__PURE__ */ R.cloneElement(c, y), v ? /* @__PURE__ */ w.jsxs(Zc, {
      display: "block",
      children: [O, /* @__PURE__ */ w.jsxs(Mk, {
        ownerState: k,
        "aria-hidden": !0,
        className: T.asterisk,
        children: [" ", "*"]
      })]
    }) : O]
  }));
});
process.env.NODE_ENV !== "production" && (Xf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: l.shape({
    typography: l.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: l.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: l.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $t,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: l.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: l.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: l.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: l.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    typography: l.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component.
   */
  value: l.any
});
function Ek(r) {
  return fe("MuiFormGroup", r);
}
ue("MuiFormGroup", ["root", "row", "error"]);
const Ik = ["className", "row"], Nk = (r) => {
  const {
    classes: e,
    row: t,
    error: n
  } = r;
  return he({
    root: ["root", t && "row", n && "error"]
  }, Ek, e);
}, Lk = H("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.row && e.row];
  }
})(({
  ownerState: r
}) => A({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap"
}, r.row && {
  flexDirection: "row"
})), Vf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiFormGroup"
  }), {
    className: o,
    row: i = !1
  } = n, a = q(n, Ik), s = Br(), c = bn({
    props: n,
    muiFormControl: s,
    states: ["error"]
  }), d = A({}, n, {
    row: i,
    error: c.error
  }), u = Nk(d);
  return /* @__PURE__ */ w.jsx(Lk, A({
    className: Y(u.root, o),
    ownerState: d,
    ref: t
  }, a));
});
process.env.NODE_ENV !== "production" && (Vf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function jk(r) {
  return fe("MuiFormHelperText", r);
}
const Iu = ue("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var Nu;
const Dk = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], zk = (r) => {
  const {
    classes: e,
    contained: t,
    size: n,
    disabled: o,
    error: i,
    filled: a,
    focused: s,
    required: c
  } = r, d = {
    root: ["root", o && "disabled", i && "error", n && `size${V(n)}`, t && "contained", s && "focused", a && "filled", c && "required"]
  };
  return he(d, jk, e);
}, Bk = H("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.size && e[`size${V(t.size)}`], t.contained && e.contained, t.filled && e.filled];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  color: (r.vars || r).palette.text.secondary
}, r.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${Iu.disabled}`]: {
    color: (r.vars || r).palette.text.disabled
  },
  [`&.${Iu.error}`]: {
    color: (r.vars || r).palette.error.main
  }
}, e.size === "small" && {
  marginTop: 4
}, e.contained && {
  marginLeft: 14,
  marginRight: 14
})), Uf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiFormHelperText"
  }), {
    children: o,
    className: i,
    component: a = "p"
  } = n, s = q(n, Dk), c = Br(), d = bn({
    props: n,
    muiFormControl: c,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), u = A({}, n, {
    component: a,
    contained: d.variant === "filled" || d.variant === "outlined",
    variant: d.variant,
    size: d.size,
    disabled: d.disabled,
    error: d.error,
    filled: d.filled,
    focused: d.focused,
    required: d.required
  }), p = zk(u);
  return /* @__PURE__ */ w.jsx(Bk, A({
    as: a,
    ownerState: u,
    className: Y(p.root, i),
    ref: t
  }, s, {
    children: o === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      Nu || (Nu = /* @__PURE__ */ w.jsx("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : o
  }));
});
process.env.NODE_ENV !== "production" && (Uf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: l.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: l.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: l.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: l.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: l.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   */
  variant: l.oneOfType([l.oneOf(["filled", "outlined", "standard"]), l.string])
});
function Fk(r) {
  return fe("MuiFormLabel", r);
}
const Ai = ue("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), _k = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], $k = (r) => {
  const {
    classes: e,
    color: t,
    focused: n,
    disabled: o,
    error: i,
    filled: a,
    required: s
  } = r, c = {
    root: ["root", `color${V(t)}`, o && "disabled", i && "error", a && "filled", n && "focused", s && "required"],
    asterisk: ["asterisk", i && "error"]
  };
  return he(c, Fk, e);
}, Wk = H("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: r
  }, e) => A({}, e.root, r.color === "secondary" && e.colorSecondary, r.filled && e.filled)
})(({
  theme: r,
  ownerState: e
}) => A({
  color: (r.vars || r).palette.text.secondary
}, r.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${Ai.focused}`]: {
    color: (r.vars || r).palette[e.color].main
  },
  [`&.${Ai.disabled}`]: {
    color: (r.vars || r).palette.text.disabled
  },
  [`&.${Ai.error}`]: {
    color: (r.vars || r).palette.error.main
  }
})), Hk = H("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (r, e) => e.asterisk
})(({
  theme: r
}) => ({
  [`&.${Ai.error}`]: {
    color: (r.vars || r).palette.error.main
  }
})), Jc = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiFormLabel"
  }), {
    children: o,
    className: i,
    component: a = "label"
  } = n, s = q(n, _k), c = Br(), d = bn({
    props: n,
    muiFormControl: c,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), u = A({}, n, {
    color: d.color || "primary",
    component: a,
    disabled: d.disabled,
    error: d.error,
    filled: d.filled,
    focused: d.focused,
    required: d.required
  }), p = $k(u);
  return /* @__PURE__ */ w.jsxs(Wk, A({
    as: a,
    ownerState: u,
    className: Y(p.root, i),
    ref: t
  }, s, {
    children: [o, d.required && /* @__PURE__ */ w.jsxs(Hk, {
      ownerState: u,
      "aria-hidden": !0,
      className: p.asterisk,
      children: [" ", "*"]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Jc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: l.oneOfType([l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: l.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: l.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: l.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const Fl = /* @__PURE__ */ R.createContext();
process.env.NODE_ENV !== "production" && (Fl.displayName = "GridContext");
function Yk(r) {
  return fe("MuiGrid", r);
}
const Xk = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Vk = ["column-reverse", "column", "row-reverse", "row"], Uk = ["nowrap", "wrap-reverse", "wrap"], zo = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], Fi = ue("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...Xk.map((r) => `spacing-xs-${r}`),
  // direction values
  ...Vk.map((r) => `direction-xs-${r}`),
  // wrap values
  ...Uk.map((r) => `wrap-xs-${r}`),
  // grid sizes for all breakpoints
  ...zo.map((r) => `grid-xs-${r}`),
  ...zo.map((r) => `grid-sm-${r}`),
  ...zo.map((r) => `grid-md-${r}`),
  ...zo.map((r) => `grid-lg-${r}`),
  ...zo.map((r) => `grid-xl-${r}`)
]), Gk = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "rowSpacing", "spacing", "wrap", "zeroMinWidth"];
function so(r) {
  const e = parseFloat(r);
  return `${e}${String(r).replace(String(e), "") || "px"}`;
}
function qk({
  theme: r,
  ownerState: e
}) {
  let t;
  return r.breakpoints.keys.reduce((n, o) => {
    let i = {};
    if (e[o] && (t = e[o]), !t)
      return n;
    if (t === !0)
      i = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (t === "auto")
      i = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const a = In({
        values: e.columns,
        breakpoints: r.breakpoints.values
      }), s = typeof a == "object" ? a[o] : a;
      if (s == null)
        return n;
      const c = `${Math.round(t / s * 1e8) / 1e6}%`;
      let d = {};
      if (e.container && e.item && e.columnSpacing !== 0) {
        const u = r.spacing(e.columnSpacing);
        if (u !== "0px") {
          const p = `calc(${c} + ${so(u)})`;
          d = {
            flexBasis: p,
            maxWidth: p
          };
        }
      }
      i = A({
        flexBasis: c,
        flexGrow: 0,
        maxWidth: c
      }, d);
    }
    return r.breakpoints.values[o] === 0 ? Object.assign(n, i) : n[r.breakpoints.up(o)] = i, n;
  }, {});
}
function Kk({
  theme: r,
  ownerState: e
}) {
  const t = In({
    values: e.direction,
    breakpoints: r.breakpoints.values
  });
  return Ii({
    theme: r
  }, t, (n) => {
    const o = {
      flexDirection: n
    };
    return n.indexOf("column") === 0 && (o[`& > .${Fi.item}`] = {
      maxWidth: "none"
    }), o;
  });
}
function Gf({
  breakpoints: r,
  values: e
}) {
  let t = "";
  Object.keys(e).forEach((o) => {
    t === "" && e[o] !== 0 && (t = o);
  });
  const n = Object.keys(r).sort((o, i) => r[o] - r[i]);
  return n.slice(0, n.indexOf(t));
}
function Zk({
  theme: r,
  ownerState: e
}) {
  const {
    container: t,
    rowSpacing: n
  } = e;
  let o = {};
  if (t && n !== 0) {
    const i = In({
      values: n,
      breakpoints: r.breakpoints.values
    });
    let a;
    typeof i == "object" && (a = Gf({
      breakpoints: r.breakpoints.values,
      values: i
    })), o = Ii({
      theme: r
    }, i, (s, c) => {
      var d;
      const u = r.spacing(s);
      return u !== "0px" ? {
        marginTop: `-${so(u)}`,
        [`& > .${Fi.item}`]: {
          paddingTop: so(u)
        }
      } : (d = a) != null && d.includes(c) ? {} : {
        marginTop: 0,
        [`& > .${Fi.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return o;
}
function Jk({
  theme: r,
  ownerState: e
}) {
  const {
    container: t,
    columnSpacing: n
  } = e;
  let o = {};
  if (t && n !== 0) {
    const i = In({
      values: n,
      breakpoints: r.breakpoints.values
    });
    let a;
    typeof i == "object" && (a = Gf({
      breakpoints: r.breakpoints.values,
      values: i
    })), o = Ii({
      theme: r
    }, i, (s, c) => {
      var d;
      const u = r.spacing(s);
      return u !== "0px" ? {
        width: `calc(100% + ${so(u)})`,
        marginLeft: `-${so(u)}`,
        [`& > .${Fi.item}`]: {
          paddingLeft: so(u)
        }
      } : (d = a) != null && d.includes(c) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${Fi.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return o;
}
function Qk(r, e, t = {}) {
  if (!r || r <= 0)
    return [];
  if (typeof r == "string" && !Number.isNaN(Number(r)) || typeof r == "number")
    return [t[`spacing-xs-${String(r)}`]];
  const n = [];
  return e.forEach((o) => {
    const i = r[o];
    Number(i) > 0 && n.push(t[`spacing-${o}-${String(i)}`]);
  }), n;
}
const eS = H("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r, {
      container: n,
      direction: o,
      item: i,
      spacing: a,
      wrap: s,
      zeroMinWidth: c,
      breakpoints: d
    } = t;
    let u = [];
    n && (u = Qk(a, d, e));
    const p = [];
    return d.forEach((h) => {
      const f = t[h];
      f && p.push(e[`grid-${h}-${String(f)}`]);
    }), [e.root, n && e.container, i && e.item, c && e.zeroMinWidth, ...u, o !== "row" && e[`direction-xs-${String(o)}`], s !== "wrap" && e[`wrap-xs-${String(s)}`], ...p];
  }
})(({
  ownerState: r
}) => A({
  boxSizing: "border-box"
}, r.container && {
  display: "flex",
  flexWrap: "wrap",
  width: "100%"
}, r.item && {
  margin: 0
  // For instance, it's useful when used with a `figure` element.
}, r.zeroMinWidth && {
  minWidth: 0
}, r.wrap !== "wrap" && {
  flexWrap: r.wrap
}), Kk, Zk, Jk, qk);
function tS(r, e) {
  if (!r || r <= 0)
    return [];
  if (typeof r == "string" && !Number.isNaN(Number(r)) || typeof r == "number")
    return [`spacing-xs-${String(r)}`];
  const t = [];
  return e.forEach((n) => {
    const o = r[n];
    if (Number(o) > 0) {
      const i = `spacing-${n}-${String(o)}`;
      t.push(i);
    }
  }), t;
}
const rS = (r) => {
  const {
    classes: e,
    container: t,
    direction: n,
    item: o,
    spacing: i,
    wrap: a,
    zeroMinWidth: s,
    breakpoints: c
  } = r;
  let d = [];
  t && (d = tS(i, c));
  const u = [];
  c.forEach((h) => {
    const f = r[h];
    f && u.push(`grid-${h}-${String(f)}`);
  });
  const p = {
    root: ["root", t && "container", o && "item", s && "zeroMinWidth", ...d, n !== "row" && `direction-xs-${String(n)}`, a !== "wrap" && `wrap-xs-${String(a)}`, ...u]
  };
  return he(p, Yk, e);
}, it = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiGrid"
  }), {
    breakpoints: o
  } = yr(), i = us(n), {
    className: a,
    columns: s,
    columnSpacing: c,
    component: d = "div",
    container: u = !1,
    direction: p = "row",
    item: h = !1,
    rowSpacing: f,
    spacing: m = 0,
    wrap: g = "wrap",
    zeroMinWidth: b = !1
  } = i, x = q(i, Gk), v = f || m, y = c || m, C = R.useContext(Fl), k = u ? s || 12 : C, T = {}, S = A({}, x);
  o.keys.forEach((M) => {
    x[M] != null && (T[M] = x[M], delete S[M]);
  });
  const O = A({}, i, {
    columns: k,
    container: u,
    direction: p,
    item: h,
    rowSpacing: v,
    columnSpacing: y,
    wrap: g,
    zeroMinWidth: b,
    spacing: m
  }, T, {
    breakpoints: o.keys
  }), P = rS(O);
  return /* @__PURE__ */ w.jsx(Fl.Provider, {
    value: k,
    children: /* @__PURE__ */ w.jsx(eS, A({
      ownerState: O,
      className: Y(P.root, a),
      as: d,
      ref: t
    }, S))
  });
});
process.env.NODE_ENV !== "production" && (it.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: l.oneOfType([l.arrayOf(l.number), l.number, l.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: l.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: l.oneOfType([l.oneOf(["column-reverse", "column", "row-reverse", "row"]), l.arrayOf(l.oneOf(["column-reverse", "column", "row-reverse", "row"])), l.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: l.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: l.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: l.bool
});
if (process.env.NODE_ENV !== "production") {
  const r = rf("Grid", it);
  it.propTypes = A({}, it.propTypes, {
    direction: r("container"),
    lg: r("item"),
    md: r("item"),
    sm: r("item"),
    spacing: r("container"),
    wrap: r("container"),
    xs: r("item"),
    zeroMinWidth: r("item")
  });
}
const nS = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function _l(r) {
  return `scale(${r}, ${r ** 2})`;
}
const oS = {
  entering: {
    opacity: 1,
    transform: _l(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, Ys = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), _i = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const {
    addEndListener: n,
    appear: o = !0,
    children: i,
    easing: a,
    in: s,
    onEnter: c,
    onEntered: d,
    onEntering: u,
    onExit: p,
    onExited: h,
    onExiting: f,
    style: m,
    timeout: g = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: b = wr
  } = e, x = q(e, nS), v = On(), y = R.useRef(), C = yr(), k = R.useRef(null), T = ut(k, fn(i), t), S = (z) => (F) => {
    if (z) {
      const B = k.current;
      F === void 0 ? z(B) : z(B, F);
    }
  }, O = S(u), P = S((z, F) => {
    Lc(z);
    const {
      duration: B,
      delay: D,
      easing: W
    } = ln({
      style: m,
      timeout: g,
      easing: a
    }, {
      mode: "enter"
    });
    let G;
    g === "auto" ? (G = C.transitions.getAutoHeightDuration(z.clientHeight), y.current = G) : G = B, z.style.transition = [C.transitions.create("opacity", {
      duration: G,
      delay: D
    }), C.transitions.create("transform", {
      duration: Ys ? G : G * 0.666,
      delay: D,
      easing: W
    })].join(","), c && c(z, F);
  }), M = S(d), I = S(f), E = S((z) => {
    const {
      duration: F,
      delay: B,
      easing: D
    } = ln({
      style: m,
      timeout: g,
      easing: a
    }, {
      mode: "exit"
    });
    let W;
    g === "auto" ? (W = C.transitions.getAutoHeightDuration(z.clientHeight), y.current = W) : W = F, z.style.transition = [C.transitions.create("opacity", {
      duration: W,
      delay: B
    }), C.transitions.create("transform", {
      duration: Ys ? W : W * 0.666,
      delay: Ys ? B : B || W * 0.333,
      easing: D
    })].join(","), z.style.opacity = 0, z.style.transform = _l(0.75), p && p(z);
  }), N = S(h), L = (z) => {
    g === "auto" && v.start(y.current || 0, z), n && n(k.current, z);
  };
  return /* @__PURE__ */ w.jsx(b, A({
    appear: o,
    in: s,
    nodeRef: k,
    onEnter: P,
    onEntered: M,
    onEntering: O,
    onExit: E,
    onExited: N,
    onExiting: I,
    addEndListener: L,
    timeout: g === "auto" ? null : g
  }, x, {
    children: (z, F) => /* @__PURE__ */ R.cloneElement(i, A({
      style: A({
        opacity: 0,
        transform: _l(0.75),
        visibility: z === "exited" && !s ? "hidden" : void 0
      }, oS[z], m, i.props.style),
      ref: T
    }, F))
  }));
});
process.env.NODE_ENV !== "production" && (_i.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: l.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: l.bool,
  /**
   * A single child content element.
   */
  children: hn.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: l.oneOfType([l.shape({
    enter: l.string,
    exit: l.string
  }), l.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: l.bool,
  /**
   * @ignore
   */
  onEnter: l.func,
  /**
   * @ignore
   */
  onEntered: l.func,
  /**
   * @ignore
   */
  onEntering: l.func,
  /**
   * @ignore
   */
  onExit: l.func,
  /**
   * @ignore
   */
  onExited: l.func,
  /**
   * @ignore
   */
  onExiting: l.func,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
_i.muiSupportAuto = !0;
const iS = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], aS = (r) => {
  const {
    classes: e,
    disableUnderline: t
  } = r, o = he({
    root: ["root", !t && "underline"],
    input: ["input"]
  }, K0, e);
  return A({}, e, o);
}, sS = H(ks, {
  shouldForwardProp: (r) => _t(r) || r === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [...ws(r, e), !t.disableUnderline && e.underline];
  }
})(({
  theme: r,
  ownerState: e
}) => {
  let n = r.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return r.vars && (n = `rgba(${r.vars.palette.common.onBackgroundChannel} / ${r.vars.opacity.inputUnderline})`), A({
    position: "relative"
  }, e.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !e.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(r.vars || r).palette[e.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: r.transitions.create("transform", {
        duration: r.transitions.duration.shorter,
        easing: r.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${rn.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${rn.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (r.vars || r).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${n}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: r.transitions.create("border-bottom-color", {
        duration: r.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${rn.disabled}, .${rn.error}):before`]: {
      borderBottom: `2px solid ${(r.vars || r).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${n}`
      }
    },
    [`&.${rn.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), lS = H(Ss, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: Cs
})({}), Qc = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o, i, a;
  const s = ge({
    props: e,
    name: "MuiInput"
  }), {
    disableUnderline: c,
    components: d = {},
    componentsProps: u,
    fullWidth: p = !1,
    inputComponent: h = "input",
    multiline: f = !1,
    slotProps: m,
    slots: g = {},
    type: b = "text"
  } = s, x = q(s, iS), v = aS(s), C = {
    root: {
      ownerState: {
        disableUnderline: c
      }
    }
  }, k = m ?? u ? co(m ?? u, C) : C, T = (n = (o = g.root) != null ? o : d.Root) != null ? n : sS, S = (i = (a = g.input) != null ? a : d.Input) != null ? i : lS;
  return /* @__PURE__ */ w.jsx(ea, A({
    slots: {
      root: T,
      input: S
    },
    slotProps: k,
    fullWidth: p,
    inputComponent: h,
    multiline: f,
    ref: t,
    type: b
  }, x, {
    classes: v
  }));
});
process.env.NODE_ENV !== "production" && (Qc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $t,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
Qc.muiName = "Input";
function cS(r) {
  return fe("MuiInputAdornment", r);
}
const Lu = ue("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var ju;
const dS = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], uS = (r, e) => {
  const {
    ownerState: t
  } = r;
  return [e.root, e[`position${V(t.position)}`], t.disablePointerEvents === !0 && e.disablePointerEvents, e[t.variant]];
}, pS = (r) => {
  const {
    classes: e,
    disablePointerEvents: t,
    hiddenLabel: n,
    position: o,
    size: i,
    variant: a
  } = r, s = {
    root: ["root", t && "disablePointerEvents", o && `position${V(o)}`, a, n && "hiddenLabel", i && `size${V(i)}`]
  };
  return he(s, cS, e);
}, hS = H("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: uS
})(({
  theme: r,
  ownerState: e
}) => A({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (r.vars || r).palette.action.active
}, e.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${Lu.positionStart}&:not(.${Lu.hiddenLabel})`]: {
    marginTop: 16
  }
}, e.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, e.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, e.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), qf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiInputAdornment"
  }), {
    children: o,
    className: i,
    component: a = "div",
    disablePointerEvents: s = !1,
    disableTypography: c = !1,
    position: d,
    variant: u
  } = n, p = q(n, dS), h = Br() || {};
  let f = u;
  u && h.variant && process.env.NODE_ENV !== "production" && u === h.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), h && !f && (f = h.variant);
  const m = A({}, n, {
    hiddenLabel: h.hiddenLabel,
    size: h.size,
    disablePointerEvents: s,
    position: d,
    variant: f
  }), g = pS(m);
  return /* @__PURE__ */ w.jsx(Qi.Provider, {
    value: null,
    children: /* @__PURE__ */ w.jsx(hS, A({
      as: a,
      ownerState: m,
      className: Y(g.root, i),
      ref: t
    }, p, {
      children: typeof o == "string" && !c ? /* @__PURE__ */ w.jsx(We, {
        color: "text.secondary",
        children: o
      }) : /* @__PURE__ */ w.jsxs(R.Fragment, {
        children: [d === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          ju || (ju = /* @__PURE__ */ w.jsx("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, o]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" && (qf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: l.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: l.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: l.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
function fS(r) {
  return fe("MuiInputLabel", r);
}
ue("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const gS = ["disableAnimation", "margin", "shrink", "variant", "className"], mS = (r) => {
  const {
    classes: e,
    formControl: t,
    size: n,
    shrink: o,
    disableAnimation: i,
    variant: a,
    required: s
  } = r, c = {
    root: ["root", t && "formControl", !i && "animated", o && "shrink", n && n !== "normal" && `size${V(n)}`, a],
    asterisk: [s && "asterisk"]
  }, d = he(c, fS, e);
  return A({}, e, d);
}, bS = H(Jc, {
  shouldForwardProp: (r) => _t(r) || r === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [{
      [`& .${Ai.asterisk}`]: e.asterisk
    }, e.root, t.formControl && e.formControl, t.size === "small" && e.sizeSmall, t.shrink && e.shrink, !t.disableAnimation && e.animated, t.focused && e.focused, e[t.variant]];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, e.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, e.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, e.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !e.disableAnimation && {
  transition: r.transitions.create(["color", "transform", "max-width"], {
    duration: r.transitions.duration.shorter,
    easing: r.transitions.easing.easeOut
  })
}, e.variant === "filled" && A({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, e.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, e.shrink && A({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, e.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), e.variant === "outlined" && A({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, e.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, e.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), ed = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    name: "MuiInputLabel",
    props: e
  }), {
    disableAnimation: o = !1,
    shrink: i,
    className: a
  } = n, s = q(n, gS), c = Br();
  let d = i;
  typeof d > "u" && c && (d = c.filled || c.focused || c.adornedStart);
  const u = bn({
    props: n,
    muiFormControl: c,
    states: ["size", "variant", "required", "focused"]
  }), p = A({}, n, {
    disableAnimation: o,
    formControl: c,
    shrink: d,
    size: u.size,
    variant: u.variant,
    required: u.required,
    focused: u.focused
  }), h = mS(p);
  return /* @__PURE__ */ w.jsx(bS, A({
    "data-shrink": d,
    ownerState: p,
    ref: t,
    className: Y(h.root, a)
  }, s, {
    classes: h
  }));
});
process.env.NODE_ENV !== "production" && (ed.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: l.oneOfType([l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), l.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: l.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: l.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: l.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: l.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: l.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: l.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: l.oneOfType([l.oneOf(["normal", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
function xS(r) {
  return fe("MuiLinearProgress", r);
}
ue("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const vS = ["className", "color", "value", "valueBuffer", "variant"];
let To = (r) => r, Du, zu, Bu, Fu, _u, $u;
const $l = 4, yS = zr(Du || (Du = To`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`)), wS = zr(zu || (zu = To`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`)), CS = zr(Bu || (Bu = To`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`)), kS = (r) => {
  const {
    classes: e,
    variant: t,
    color: n
  } = r, o = {
    root: ["root", `color${V(n)}`, t],
    dashed: ["dashed", `dashedColor${V(n)}`],
    bar1: ["bar", `barColor${V(n)}`, (t === "indeterminate" || t === "query") && "bar1Indeterminate", t === "determinate" && "bar1Determinate", t === "buffer" && "bar1Buffer"],
    bar2: ["bar", t !== "buffer" && `barColor${V(n)}`, t === "buffer" && `color${V(n)}`, (t === "indeterminate" || t === "query") && "bar2Indeterminate", t === "buffer" && "bar2Buffer"]
  };
  return he(o, xS, e);
}, td = (r, e) => e === "inherit" ? "currentColor" : r.vars ? r.vars.palette.LinearProgress[`${e}Bg`] : r.palette.mode === "light" ? Pe.lighten(r.palette[e].main, 0.62) : Pe.darken(r.palette[e].main, 0.5), SS = H("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[`color${V(t.color)}`], e[t.variant]];
  }
})(({
  ownerState: r,
  theme: e
}) => A({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  "@media print": {
    colorAdjust: "exact"
  },
  backgroundColor: td(e, r.color)
}, r.color === "inherit" && r.variant !== "buffer" && {
  backgroundColor: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "currentColor",
    opacity: 0.3
  }
}, r.variant === "buffer" && {
  backgroundColor: "transparent"
}, r.variant === "query" && {
  transform: "rotate(180deg)"
})), TS = H("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.dashed, e[`dashedColor${V(t.color)}`]];
  }
})(({
  ownerState: r,
  theme: e
}) => {
  const t = td(e, r.color);
  return A({
    position: "absolute",
    marginTop: 0,
    height: "100%",
    width: "100%"
  }, r.color === "inherit" && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${t} 0%, ${t} 16%, transparent 42%)`,
    backgroundSize: "10px 10px",
    backgroundPosition: "0 -23px"
  });
}, Dn(Fu || (Fu = To`
    animation: ${0} 3s infinite linear;
  `), CS)), AS = H("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.bar, e[`barColor${V(t.color)}`], (t.variant === "indeterminate" || t.variant === "query") && e.bar1Indeterminate, t.variant === "determinate" && e.bar1Determinate, t.variant === "buffer" && e.bar1Buffer];
  }
})(({
  ownerState: r,
  theme: e
}) => A({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  backgroundColor: r.color === "inherit" ? "currentColor" : (e.vars || e).palette[r.color].main
}, r.variant === "determinate" && {
  transition: `transform .${$l}s linear`
}, r.variant === "buffer" && {
  zIndex: 1,
  transition: `transform .${$l}s linear`
}), ({
  ownerState: r
}) => (r.variant === "indeterminate" || r.variant === "query") && Dn(_u || (_u = To`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), yS)), OS = H("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.bar, e[`barColor${V(t.color)}`], (t.variant === "indeterminate" || t.variant === "query") && e.bar2Indeterminate, t.variant === "buffer" && e.bar2Buffer];
  }
})(({
  ownerState: r,
  theme: e
}) => A({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left"
}, r.variant !== "buffer" && {
  backgroundColor: r.color === "inherit" ? "currentColor" : (e.vars || e).palette[r.color].main
}, r.color === "inherit" && {
  opacity: 0.3
}, r.variant === "buffer" && {
  backgroundColor: td(e, r.color),
  transition: `transform .${$l}s linear`
}), ({
  ownerState: r
}) => (r.variant === "indeterminate" || r.variant === "query") && Dn($u || ($u = To`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), wS)), RS = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiLinearProgress"
  }), {
    className: o,
    color: i = "primary",
    value: a,
    valueBuffer: s,
    variant: c = "indeterminate"
  } = n, d = q(n, vS), u = A({}, n, {
    color: i,
    variant: c
  }), p = kS(u), h = gn(), f = {}, m = {
    bar1: {},
    bar2: {}
  };
  if (c === "determinate" || c === "buffer")
    if (a !== void 0) {
      f["aria-valuenow"] = Math.round(a), f["aria-valuemin"] = 0, f["aria-valuemax"] = 100;
      let g = a - 100;
      h && (g = -g), m.bar1.transform = `translateX(${g}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (c === "buffer")
    if (s !== void 0) {
      let g = (s || 0) - 100;
      h && (g = -g), m.bar2.transform = `translateX(${g}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ w.jsxs(SS, A({
    className: Y(p.root, o),
    ownerState: u,
    role: "progressbar"
  }, f, {
    ref: t
  }, d, {
    children: [c === "buffer" ? /* @__PURE__ */ w.jsx(TS, {
      className: p.dashed,
      ownerState: u
    }) : null, /* @__PURE__ */ w.jsx(AS, {
      className: p.bar1,
      ownerState: u,
      style: m.bar1
    }), c === "determinate" ? null : /* @__PURE__ */ w.jsx(OS, {
      className: p.bar2,
      ownerState: u,
      style: m.bar2
    })]
  }));
});
process.env.NODE_ENV !== "production" && (RS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["inherit", "primary", "secondary"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: l.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: l.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: l.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
function PS(r) {
  return fe("MuiLink", r);
}
const MS = ue("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), Kf = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, ES = (r) => Kf[r] || r, IS = ({
  theme: r,
  ownerState: e
}) => {
  const t = ES(e.color), n = _d(r, `palette.${t}`, !1) || e.color, o = _d(r, `palette.${t}Channel`);
  return "vars" in r && o ? `rgba(${o} / 0.4)` : Pe.alpha(n, 0.4);
}, NS = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"], LS = (r) => {
  const {
    classes: e,
    component: t,
    focusVisible: n,
    underline: o
  } = r, i = {
    root: ["root", `underline${V(o)}`, t === "button" && "button", n && "focusVisible"]
  };
  return he(i, PS, e);
}, jS = H(We, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[`underline${V(t.underline)}`], t.component === "button" && e.button];
  }
})(({
  theme: r,
  ownerState: e
}) => A({}, e.underline === "none" && {
  textDecoration: "none"
}, e.underline === "hover" && {
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline"
  }
}, e.underline === "always" && A({
  textDecoration: "underline"
}, e.color !== "inherit" && {
  textDecorationColor: IS({
    theme: r,
    ownerState: e
  })
}, {
  "&:hover": {
    textDecorationColor: "inherit"
  }
}), e.component === "button" && {
  position: "relative",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${MS.focusVisible}`]: {
    outline: "auto"
  }
})), DS = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiLink"
  }), {
    className: o,
    color: i = "primary",
    component: a = "a",
    onBlur: s,
    onFocus: c,
    TypographyClasses: d,
    underline: u = "always",
    variant: p = "inherit",
    sx: h
  } = n, f = q(n, NS), {
    isFocusVisibleRef: m,
    onBlur: g,
    onFocus: b,
    ref: x
  } = gs(), [v, y] = R.useState(!1), C = ut(t, x), k = (P) => {
    g(P), m.current === !1 && y(!1), s && s(P);
  }, T = (P) => {
    b(P), m.current === !0 && y(!0), c && c(P);
  }, S = A({}, n, {
    color: i,
    component: a,
    focusVisible: v,
    underline: u,
    variant: p
  }), O = LS(S);
  return /* @__PURE__ */ w.jsx(jS, A({
    color: i,
    className: Y(O.root, o),
    classes: d,
    component: a,
    onBlur: k,
    onFocus: T,
    ref: C,
    ownerState: S,
    variant: p,
    sx: [...Object.keys(Kf).includes(i) ? [] : [{
      color: i
    }], ...Array.isArray(h) ? h : [h]]
  }, f));
});
process.env.NODE_ENV !== "production" && (DS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: l.any,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Co,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */
  TypographyClasses: l.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: l.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: l.oneOfType([l.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), l.string])
});
const Hr = /* @__PURE__ */ R.createContext({});
process.env.NODE_ENV !== "production" && (Hr.displayName = "ListContext");
function zS(r) {
  return fe("MuiList", r);
}
ue("MuiList", ["root", "padding", "dense", "subheader"]);
const BS = ["children", "className", "component", "dense", "disablePadding", "subheader"], FS = (r) => {
  const {
    classes: e,
    disablePadding: t,
    dense: n,
    subheader: o
  } = r;
  return he({
    root: ["root", !t && "padding", n && "dense", o && "subheader"]
  }, zS, e);
}, _S = H("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, !t.disablePadding && e.padding, t.dense && e.dense, t.subheader && e.subheader];
  }
})(({
  ownerState: r
}) => A({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !r.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, r.subheader && {
  paddingTop: 0
})), rd = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiList"
  }), {
    children: o,
    className: i,
    component: a = "ul",
    dense: s = !1,
    disablePadding: c = !1,
    subheader: d
  } = n, u = q(n, BS), p = R.useMemo(() => ({
    dense: s
  }), [s]), h = A({}, n, {
    component: a,
    dense: s,
    disablePadding: c
  }), f = FS(h);
  return /* @__PURE__ */ w.jsx(Hr.Provider, {
    value: p,
    children: /* @__PURE__ */ w.jsxs(_S, A({
      as: a,
      className: Y(f.root, i),
      ref: t,
      ownerState: h
    }, u, {
      children: [d, o]
    }))
  });
});
process.env.NODE_ENV !== "production" && (rd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: l.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: l.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function $S(r) {
  return fe("MuiListItem", r);
}
const eo = ue("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]), WS = ue("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function HS(r) {
  return fe("MuiListItemSecondaryAction", r);
}
ue("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const YS = ["className"], XS = (r) => {
  const {
    disableGutters: e,
    classes: t
  } = r;
  return he({
    root: ["root", e && "disableGutters"]
  }, HS, t);
}, VS = H("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.disableGutters && e.disableGutters];
  }
})(({
  ownerState: r
}) => A({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, r.disableGutters && {
  right: 0
})), nd = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiListItemSecondaryAction"
  }), {
    className: o
  } = n, i = q(n, YS), a = R.useContext(Hr), s = A({}, n, {
    disableGutters: a.disableGutters
  }), c = XS(s);
  return /* @__PURE__ */ w.jsx(VS, A({
    className: Y(c.root, o),
    ownerState: s,
    ref: t
  }, i));
});
process.env.NODE_ENV !== "production" && (nd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
nd.muiName = "ListItemSecondaryAction";
const US = ["className"], GS = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"], qS = (r, e) => {
  const {
    ownerState: t
  } = r;
  return [e.root, t.dense && e.dense, t.alignItems === "flex-start" && e.alignItemsFlexStart, t.divider && e.divider, !t.disableGutters && e.gutters, !t.disablePadding && e.padding, t.button && e.button, t.hasSecondaryAction && e.secondaryAction];
}, KS = (r) => {
  const {
    alignItems: e,
    button: t,
    classes: n,
    dense: o,
    disabled: i,
    disableGutters: a,
    disablePadding: s,
    divider: c,
    hasSecondaryAction: d,
    selected: u
  } = r;
  return he({
    root: ["root", o && "dense", !a && "gutters", !s && "padding", c && "divider", i && "disabled", t && "button", e === "flex-start" && "alignItemsFlexStart", d && "secondaryAction", u && "selected"],
    container: ["container"]
  }, $S, n);
}, ZS = H("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: qS
})(({
  theme: r,
  ownerState: e
}) => A({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !e.disablePadding && A({
  paddingTop: 8,
  paddingBottom: 8
}, e.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !e.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!e.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!e.secondaryAction && {
  [`& > .${WS.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${eo.focusVisible}`]: {
    backgroundColor: (r.vars || r).palette.action.focus
  },
  [`&.${eo.selected}`]: {
    backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / ${r.vars.palette.action.selectedOpacity})` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity),
    [`&.${eo.focusVisible}`]: {
      backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.focusOpacity}))` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity + r.palette.action.focusOpacity)
    }
  },
  [`&.${eo.disabled}`]: {
    opacity: (r.vars || r).palette.action.disabledOpacity
  }
}, e.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, e.divider && {
  borderBottom: `1px solid ${(r.vars || r).palette.divider}`,
  backgroundClip: "padding-box"
}, e.button && {
  transition: r.transitions.create("background-color", {
    duration: r.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (r.vars || r).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${eo.selected}:hover`]: {
    backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.hoverOpacity}))` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity + r.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / ${r.vars.palette.action.selectedOpacity})` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity)
    }
  }
}, e.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), JS = H("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (r, e) => e.container
})({
  position: "relative"
}), Zf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiListItem"
  }), {
    alignItems: o = "center",
    autoFocus: i = !1,
    button: a = !1,
    children: s,
    className: c,
    component: d,
    components: u = {},
    componentsProps: p = {},
    ContainerComponent: h = "li",
    ContainerProps: {
      className: f
    } = {},
    dense: m = !1,
    disabled: g = !1,
    disableGutters: b = !1,
    disablePadding: x = !1,
    divider: v = !1,
    focusVisibleClassName: y,
    secondaryAction: C,
    selected: k = !1,
    slotProps: T = {},
    slots: S = {}
  } = n, O = q(n.ContainerProps, US), P = q(n, GS), M = R.useContext(Hr), I = R.useMemo(() => ({
    dense: m || M.dense || !1,
    alignItems: o,
    disableGutters: b
  }), [o, M.dense, m, b]), E = R.useRef(null);
  qt(() => {
    i && (E.current ? E.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItem whose component has not been rendered."));
  }, [i]);
  const N = R.Children.toArray(s), L = N.length && ao(N[N.length - 1], ["ListItemSecondaryAction"]), z = A({}, n, {
    alignItems: o,
    autoFocus: i,
    button: a,
    dense: I.dense,
    disabled: g,
    disableGutters: b,
    disablePadding: x,
    divider: v,
    hasSecondaryAction: L,
    selected: k
  }), F = KS(z), B = ut(E, t), D = S.root || u.Root || ZS, W = T.root || p.root || {}, G = A({
    className: Y(F.root, W.className, c),
    disabled: g
  }, P);
  let re = d || "li";
  return a && (G.component = d || "div", G.focusVisibleClassName = Y(eo.focusVisible, y), re = Kt), L ? (re = !G.component && !d ? "div" : re, h === "li" && (re === "li" ? re = "div" : G.component === "li" && (G.component = "div")), /* @__PURE__ */ w.jsx(Hr.Provider, {
    value: I,
    children: /* @__PURE__ */ w.jsxs(JS, A({
      as: h,
      className: Y(F.container, f),
      ref: B,
      ownerState: z
    }, O, {
      children: [/* @__PURE__ */ w.jsx(D, A({}, W, !zn(D) && {
        as: re,
        ownerState: A({}, z, W.ownerState)
      }, G, {
        children: N
      })), N.pop()]
    }))
  })) : /* @__PURE__ */ w.jsx(Hr.Provider, {
    value: I,
    children: /* @__PURE__ */ w.jsxs(D, A({}, W, {
      as: re,
      ref: B
    }, !zn(D) && {
      ownerState: A({}, z, W.ownerState)
    }, G, {
      children: [N, C && /* @__PURE__ */ w.jsx(nd, {
        children: C
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Zf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: l.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: l.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: l.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: Ft(l.node, (r) => {
    const e = R.Children.toArray(r.children);
    let t = -1;
    for (let n = e.length - 1; n >= 0; n -= 1) {
      const o = e[n];
      if (ao(o, ["ListItemSecondaryAction"])) {
        t = n;
        break;
      }
    }
    return t !== -1 && t !== e.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    root: l.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: Co,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: l.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: l.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: l.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: l.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: l.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: l.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: l.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const Wu = ue("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
function QS(r) {
  return fe("MuiListItemText", r);
}
const Za = ue("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), eT = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], tT = (r) => {
  const {
    classes: e,
    inset: t,
    primary: n,
    secondary: o,
    dense: i
  } = r;
  return he({
    root: ["root", t && "inset", i && "dense", n && o && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, QS, e);
}, rT = H("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [{
      [`& .${Za.primary}`]: e.primary
    }, {
      [`& .${Za.secondary}`]: e.secondary
    }, e.root, t.inset && e.inset, t.primary && t.secondary && e.multiline, t.dense && e.dense];
  }
})(({
  ownerState: r
}) => A({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, r.primary && r.secondary && {
  marginTop: 6,
  marginBottom: 6
}, r.inset && {
  paddingLeft: 56
})), Jf = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiListItemText"
  }), {
    children: o,
    className: i,
    disableTypography: a = !1,
    inset: s = !1,
    primary: c,
    primaryTypographyProps: d,
    secondary: u,
    secondaryTypographyProps: p
  } = n, h = q(n, eT), {
    dense: f
  } = R.useContext(Hr);
  let m = c ?? o, g = u;
  const b = A({}, n, {
    disableTypography: a,
    inset: s,
    primary: !!m,
    secondary: !!g,
    dense: f
  }), x = tT(b);
  return m != null && m.type !== We && !a && (m = /* @__PURE__ */ w.jsx(We, A({
    variant: f ? "body2" : "body1",
    className: x.primary,
    component: d != null && d.variant ? void 0 : "span",
    display: "block"
  }, d, {
    children: m
  }))), g != null && g.type !== We && !a && (g = /* @__PURE__ */ w.jsx(We, A({
    variant: "body2",
    className: x.secondary,
    color: "text.secondary",
    display: "block"
  }, p, {
    children: g
  }))), /* @__PURE__ */ w.jsxs(rT, A({
    className: Y(x.root, i),
    ownerState: b,
    ref: t
  }, h, {
    children: [m, g]
  }));
});
process.env.NODE_ENV !== "production" && (Jf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: l.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: l.bool,
  /**
   * The main content element.
   */
  primary: l.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: l.object,
  /**
   * The secondary content element.
   */
  secondary: l.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const nT = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function Xs(r, e, t) {
  return r === e ? r.firstChild : e && e.nextElementSibling ? e.nextElementSibling : t ? null : r.firstChild;
}
function Hu(r, e, t) {
  return r === e ? t ? r.firstChild : r.lastChild : e && e.previousElementSibling ? e.previousElementSibling : t ? null : r.lastChild;
}
function Qf(r, e) {
  if (e === void 0)
    return !0;
  let t = r.innerText;
  return t === void 0 && (t = r.textContent), t = t.trim().toLowerCase(), t.length === 0 ? !1 : e.repeating ? t[0] === e.keys[0] : t.indexOf(e.keys.join("")) === 0;
}
function Bo(r, e, t, n, o, i) {
  let a = !1, s = o(r, e, e ? t : !1);
  for (; s; ) {
    if (s === r.firstChild) {
      if (a)
        return !1;
      a = !0;
    }
    const c = n ? !1 : s.disabled || s.getAttribute("aria-disabled") === "true";
    if (!s.hasAttribute("tabindex") || !Qf(s, i) || c)
      s = o(r, s, t);
    else
      return s.focus(), !0;
  }
  return !1;
}
const eg = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: n,
    autoFocus: o = !1,
    autoFocusItem: i = !1,
    children: a,
    className: s,
    disabledItemsFocusable: c = !1,
    disableListWrap: d = !1,
    onKeyDown: u,
    variant: p = "selectedMenu"
  } = e, h = q(e, nT), f = R.useRef(null), m = R.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  qt(() => {
    o && f.current.focus();
  }, [o]), R.useImperativeHandle(n, () => ({
    adjustStyleForScrollbar: (y, {
      direction: C
    }) => {
      const k = !f.current.style.width;
      if (y.clientHeight < f.current.clientHeight && k) {
        const T = `${nf(Rt(y))}px`;
        f.current.style[C === "rtl" ? "paddingLeft" : "paddingRight"] = T, f.current.style.width = `calc(100% + ${T})`;
      }
      return f.current;
    }
  }), []);
  const g = (y) => {
    const C = f.current, k = y.key, T = Rt(C).activeElement;
    if (k === "ArrowDown")
      y.preventDefault(), Bo(C, T, d, c, Xs);
    else if (k === "ArrowUp")
      y.preventDefault(), Bo(C, T, d, c, Hu);
    else if (k === "Home")
      y.preventDefault(), Bo(C, null, d, c, Xs);
    else if (k === "End")
      y.preventDefault(), Bo(C, null, d, c, Hu);
    else if (k.length === 1) {
      const S = m.current, O = k.toLowerCase(), P = performance.now();
      S.keys.length > 0 && (P - S.lastTime > 500 ? (S.keys = [], S.repeating = !0, S.previousKeyMatched = !0) : S.repeating && O !== S.keys[0] && (S.repeating = !1)), S.lastTime = P, S.keys.push(O);
      const M = T && !S.repeating && Qf(T, S);
      S.previousKeyMatched && (M || Bo(C, T, !1, c, Xs, S)) ? y.preventDefault() : S.previousKeyMatched = !1;
    }
    u && u(y);
  }, b = ut(f, t);
  let x = -1;
  R.Children.forEach(a, (y, C) => {
    if (!/* @__PURE__ */ R.isValidElement(y)) {
      x === C && (x += 1, x >= a.length && (x = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && wo.isFragment(y) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), y.props.disabled || (p === "selectedMenu" && y.props.selected || x === -1) && (x = C), x === C && (y.props.disabled || y.props.muiSkipListHighlight || y.type.muiSkipListHighlight) && (x += 1, x >= a.length && (x = -1));
  });
  const v = R.Children.map(a, (y, C) => {
    if (C === x) {
      const k = {};
      return i && (k.autoFocus = !0), y.props.tabIndex === void 0 && p === "selectedMenu" && (k.tabIndex = 0), /* @__PURE__ */ R.cloneElement(y, k);
    }
    return y;
  });
  return /* @__PURE__ */ w.jsx(rd, A({
    role: "menu",
    ref: b,
    className: s,
    onKeyDown: g,
    tabIndex: o ? 0 : -1
  }, h, {
    children: v
  }));
});
process.env.NODE_ENV !== "production" && (eg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: l.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: l.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: l.node,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: l.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: l.bool,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: l.oneOf(["menu", "selectedMenu"])
});
function oT(r) {
  return fe("MuiPopover", r);
}
ue("MuiPopover", ["root", "paper"]);
const iT = ["onEntering"], aT = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], sT = ["slotProps"];
function Yu(r, e) {
  let t = 0;
  return typeof e == "number" ? t = e : e === "center" ? t = r.height / 2 : e === "bottom" && (t = r.height), t;
}
function Xu(r, e) {
  let t = 0;
  return typeof e == "number" ? t = e : e === "center" ? t = r.width / 2 : e === "right" && (t = r.width), t;
}
function Vu(r) {
  return [r.horizontal, r.vertical].map((e) => typeof e == "number" ? `${e}px` : e).join(" ");
}
function La(r) {
  return typeof r == "function" ? r() : r;
}
const lT = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"],
    paper: ["paper"]
  }, oT, e);
}, cT = H(Os, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({}), tg = H(Wt, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (r, e) => e.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), od = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o, i;
  const a = ge({
    props: e,
    name: "MuiPopover"
  }), {
    action: s,
    anchorEl: c,
    anchorOrigin: d = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: u,
    anchorReference: p = "anchorEl",
    children: h,
    className: f,
    container: m,
    elevation: g = 8,
    marginThreshold: b = 16,
    open: x,
    PaperProps: v = {},
    slots: y,
    slotProps: C,
    transformOrigin: k = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: T = _i,
    transitionDuration: S = "auto",
    TransitionProps: {
      onEntering: O
    } = {},
    disableScrollLock: P = !1
  } = a, M = q(a.TransitionProps, iT), I = q(a, aT), E = (n = C?.paper) != null ? n : v, N = R.useRef(), L = ut(N, E.ref), z = A({}, a, {
    anchorOrigin: d,
    anchorReference: p,
    elevation: g,
    marginThreshold: b,
    externalPaperSlotProps: E,
    transformOrigin: k,
    TransitionComponent: T,
    transitionDuration: S,
    TransitionProps: M
  }), F = lT(z), B = R.useCallback(() => {
    if (p === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (u || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), u;
    const ke = La(c), Oe = ke && ke.nodeType === 1 ? ke : Rt(N.current).body, Te = Oe.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const me = Oe.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && me.top === 0 && me.left === 0 && me.right === 0 && me.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: Te.top + Yu(Te, d.vertical),
      left: Te.left + Xu(Te, d.horizontal)
    };
  }, [c, d.horizontal, d.vertical, u, p]), D = R.useCallback((ke) => ({
    vertical: Yu(ke, k.vertical),
    horizontal: Xu(ke, k.horizontal)
  }), [k.horizontal, k.vertical]), W = R.useCallback((ke) => {
    const Oe = {
      width: ke.offsetWidth,
      height: ke.offsetHeight
    }, Te = D(Oe);
    if (p === "none")
      return {
        top: null,
        left: null,
        transformOrigin: Vu(Te)
      };
    const me = B();
    let tt = me.top - Te.vertical, Se = me.left - Te.horizontal;
    const Ke = tt + Oe.height, He = Se + Oe.width, _e = br(La(c)), Qe = _e.innerHeight - b, Ue = _e.innerWidth - b;
    if (b !== null && tt < b) {
      const Ye = tt - b;
      tt -= Ye, Te.vertical += Ye;
    } else if (b !== null && Ke > Qe) {
      const Ye = Ke - Qe;
      tt -= Ye, Te.vertical += Ye;
    }
    if (process.env.NODE_ENV !== "production" && Oe.height > Qe && Oe.height && Qe && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${Oe.height - Qe}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), b !== null && Se < b) {
      const Ye = Se - b;
      Se -= Ye, Te.horizontal += Ye;
    } else if (He > Ue) {
      const Ye = He - Ue;
      Se -= Ye, Te.horizontal += Ye;
    }
    return {
      top: `${Math.round(tt)}px`,
      left: `${Math.round(Se)}px`,
      transformOrigin: Vu(Te)
    };
  }, [c, p, B, D, b]), [G, re] = R.useState(x), ce = R.useCallback(() => {
    const ke = N.current;
    if (!ke)
      return;
    const Oe = W(ke);
    Oe.top !== null && (ke.style.top = Oe.top), Oe.left !== null && (ke.style.left = Oe.left), ke.style.transformOrigin = Oe.transformOrigin, re(!0);
  }, [W]);
  R.useEffect(() => (P && window.addEventListener("scroll", ce), () => window.removeEventListener("scroll", ce)), [c, P, ce]);
  const Ce = (ke, Oe) => {
    O && O(ke, Oe), ce();
  }, ne = () => {
    re(!1);
  };
  R.useEffect(() => {
    x && ce();
  }), R.useImperativeHandle(s, () => x ? {
    updatePosition: () => {
      ce();
    }
  } : null, [x, ce]), R.useEffect(() => {
    if (!x)
      return;
    const ke = So(() => {
      ce();
    }), Oe = br(c);
    return Oe.addEventListener("resize", ke), () => {
      ke.clear(), Oe.removeEventListener("resize", ke);
    };
  }, [c, x, ce]);
  let pe = S;
  S === "auto" && !T.muiSupportAuto && (pe = void 0);
  const K = m || (c ? Rt(La(c)).body : void 0), le = (o = y?.root) != null ? o : cT, Q = (i = y?.paper) != null ? i : tg, se = tr({
    elementType: Q,
    externalSlotProps: A({}, E, {
      style: G ? E.style : A({}, E.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: g,
      ref: L
    },
    ownerState: z,
    className: Y(F.paper, E?.className)
  }), Re = tr({
    elementType: le,
    externalSlotProps: C?.root || {},
    externalForwardedProps: I,
    additionalProps: {
      ref: t,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: K,
      open: x
    },
    ownerState: z,
    className: Y(F.root, f)
  }), {
    slotProps: be
  } = Re, Ne = q(Re, sT);
  return /* @__PURE__ */ w.jsx(le, A({}, Ne, !zn(le) && {
    slotProps: be,
    disableScrollLock: P
  }, {
    children: /* @__PURE__ */ w.jsx(T, A({
      appear: !0,
      in: x,
      onEntering: Ce,
      onExited: ne,
      timeout: pe
    }, M, {
      children: /* @__PURE__ */ w.jsx(Q, A({}, se, {
        children: h
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (od.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: $t,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: Ft(l.oneOfType([jr, l.func]), (r) => {
    if (r.open && (!r.anchorReference || r.anchorReference === "anchorEl")) {
      const e = La(r.anchorEl);
      if (e && e.nodeType === 1) {
        const t = e.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && t.top === 0 && t.left === 0 && t.right === 0 && t.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${e}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: l.shape({
    horizontal: l.oneOfType([l.oneOf(["center", "left", "right"]), l.number]).isRequired,
    vertical: l.oneOfType([l.oneOf(["bottom", "center", "top"]), l.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: l.shape({
    left: l.number.isRequired,
    top: l.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: l.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([jr, l.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: l.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Ut,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: l.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: l.shape({
    component: Co
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: l.shape({
    paper: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: l.shape({
    paper: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: l.shape({
    horizontal: l.oneOfType([l.oneOf(["center", "left", "right"]), l.number]).isRequired,
    vertical: l.oneOfType([l.oneOf(["bottom", "center", "top"]), l.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: l.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: l.object
});
function dT(r) {
  return fe("MuiMenu", r);
}
ue("MuiMenu", ["root", "paper", "list"]);
const uT = ["onEntering"], pT = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], hT = {
  vertical: "top",
  horizontal: "right"
}, fT = {
  vertical: "top",
  horizontal: "left"
}, gT = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, dT, e);
}, mT = H(od, {
  shouldForwardProp: (r) => _t(r) || r === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({}), bT = H(tg, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (r, e) => e.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), xT = H(eg, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (r, e) => e.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), id = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o;
  const i = ge({
    props: e,
    name: "MuiMenu"
  }), {
    autoFocus: a = !0,
    children: s,
    className: c,
    disableAutoFocusItem: d = !1,
    MenuListProps: u = {},
    onClose: p,
    open: h,
    PaperProps: f = {},
    PopoverClasses: m,
    transitionDuration: g = "auto",
    TransitionProps: {
      onEntering: b
    } = {},
    variant: x = "selectedMenu",
    slots: v = {},
    slotProps: y = {}
  } = i, C = q(i.TransitionProps, uT), k = q(i, pT), T = gn(), S = A({}, i, {
    autoFocus: a,
    disableAutoFocusItem: d,
    MenuListProps: u,
    onEntering: b,
    PaperProps: f,
    transitionDuration: g,
    TransitionProps: C,
    variant: x
  }), O = gT(S), P = a && !d && h, M = R.useRef(null), I = (D, W) => {
    M.current && M.current.adjustStyleForScrollbar(D, {
      direction: T ? "rtl" : "ltr"
    }), b && b(D, W);
  }, E = (D) => {
    D.key === "Tab" && (D.preventDefault(), p && p(D, "tabKeyDown"));
  };
  let N = -1;
  R.Children.map(s, (D, W) => {
    /* @__PURE__ */ R.isValidElement(D) && (process.env.NODE_ENV !== "production" && wo.isFragment(D) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), D.props.disabled || (x === "selectedMenu" && D.props.selected || N === -1) && (N = W));
  });
  const L = (n = v.paper) != null ? n : bT, z = (o = y.paper) != null ? o : f, F = tr({
    elementType: v.root,
    externalSlotProps: y.root,
    ownerState: S,
    className: [O.root, c]
  }), B = tr({
    elementType: L,
    externalSlotProps: z,
    ownerState: S,
    className: O.paper
  });
  return /* @__PURE__ */ w.jsx(mT, A({
    onClose: p,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: T ? "right" : "left"
    },
    transformOrigin: T ? hT : fT,
    slots: {
      paper: L,
      root: v.root
    },
    slotProps: {
      root: F,
      paper: B
    },
    open: h,
    ref: t,
    transitionDuration: g,
    TransitionProps: A({
      onEntering: I
    }, C),
    ownerState: S
  }, k, {
    classes: m,
    children: /* @__PURE__ */ w.jsx(xT, A({
      onKeyDown: E,
      actions: M,
      autoFocus: a && (N === -1 || d),
      autoFocusItem: P,
      variant: x
    }, u, {
      className: Y(O.list, u.className),
      children: s
    }))
  }));
});
process.env.NODE_ENV !== "production" && (id.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: l.oneOfType([jr, l.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: l.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: l.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: l.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: l.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: l.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: l.shape({
    paper: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: l.shape({
    paper: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: l.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: l.oneOf(["menu", "selectedMenu"])
});
function vT(r) {
  return fe("MuiMenuItem", r);
}
const Fo = ue("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), yT = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], wT = (r, e) => {
  const {
    ownerState: t
  } = r;
  return [e.root, t.dense && e.dense, t.divider && e.divider, !t.disableGutters && e.gutters];
}, CT = (r) => {
  const {
    disabled: e,
    dense: t,
    divider: n,
    disableGutters: o,
    selected: i,
    classes: a
  } = r, c = he({
    root: ["root", t && "dense", e && "disabled", !o && "gutters", n && "divider", i && "selected"]
  }, vT, a);
  return A({}, a, c);
}, kT = H(Kt, {
  shouldForwardProp: (r) => _t(r) || r === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: wT
})(({
  theme: r,
  ownerState: e
}) => A({}, r.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !e.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, e.divider && {
  borderBottom: `1px solid ${(r.vars || r).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (r.vars || r).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Fo.selected}`]: {
    backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / ${r.vars.palette.action.selectedOpacity})` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity),
    [`&.${Fo.focusVisible}`]: {
      backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.focusOpacity}))` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity + r.palette.action.focusOpacity)
    }
  },
  [`&.${Fo.selected}:hover`]: {
    backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.hoverOpacity}))` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity + r.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / ${r.vars.palette.action.selectedOpacity})` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity)
    }
  },
  [`&.${Fo.focusVisible}`]: {
    backgroundColor: (r.vars || r).palette.action.focus
  },
  [`&.${Fo.disabled}`]: {
    opacity: (r.vars || r).palette.action.disabledOpacity
  },
  [`& + .${Mu.root}`]: {
    marginTop: r.spacing(1),
    marginBottom: r.spacing(1)
  },
  [`& + .${Mu.inset}`]: {
    marginLeft: 52
  },
  [`& .${Za.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${Za.inset}`]: {
    paddingLeft: 36
  },
  [`& .${Wu.root}`]: {
    minWidth: 36
  }
}, !e.dense && {
  [r.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, e.dense && A({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, r.typography.body2, {
  [`& .${Wu.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), mo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiMenuItem"
  }), {
    autoFocus: o = !1,
    component: i = "li",
    dense: a = !1,
    divider: s = !1,
    disableGutters: c = !1,
    focusVisibleClassName: d,
    role: u = "menuitem",
    tabIndex: p,
    className: h
  } = n, f = q(n, yT), m = R.useContext(Hr), g = R.useMemo(() => ({
    dense: a || m.dense || !1,
    disableGutters: c
  }), [m.dense, a, c]), b = R.useRef(null);
  qt(() => {
    o && (b.current ? b.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [o]);
  const x = A({}, n, {
    dense: g.dense,
    divider: s,
    disableGutters: c
  }), v = CT(n), y = ut(b, t);
  let C;
  return n.disabled || (C = p !== void 0 ? p : -1), /* @__PURE__ */ w.jsx(Hr.Provider, {
    value: g,
    children: /* @__PURE__ */ w.jsx(kT, A({
      ref: y,
      role: u,
      tabIndex: C,
      component: i,
      focusVisibleClassName: Y(v.focusVisible, d),
      className: Y(v.root, h)
    }, f, {
      ownerState: x,
      classes: v
    }))
  });
});
process.env.NODE_ENV !== "production" && (mo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: l.bool,
  /**
   * @ignore
   */
  disabled: l.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: l.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  /**
   * @ignore
   */
  role: l.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @default 0
   */
  tabIndex: l.number
});
function ST(r) {
  return fe("MuiNativeSelect", r);
}
const ad = ue("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), TT = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], AT = (r) => {
  const {
    classes: e,
    variant: t,
    disabled: n,
    multiple: o,
    open: i,
    error: a
  } = r, s = {
    select: ["select", t, n && "disabled", o && "multiple", a && "error"],
    icon: ["icon", `icon${V(t)}`, i && "iconOpen", n && "disabled"]
  };
  return he(s, ST, e);
}, rg = ({
  ownerState: r,
  theme: e
}) => A({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": A({}, e.vars ? {
    backgroundColor: `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: e.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${ad.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, r.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, r.variant === "outlined" && {
  borderRadius: (e.vars || e).shape.borderRadius,
  "&:focus": {
    borderRadius: (e.vars || e).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), OT = H("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: _t,
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.select, e[t.variant], t.error && e.error, {
      [`&.${ad.multiple}`]: e.multiple
    }];
  }
})(rg), ng = ({
  ownerState: r,
  theme: e
}) => A({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (e.vars || e).palette.action.active,
  [`&.${ad.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
}, r.open && {
  transform: "rotate(180deg)"
}, r.variant === "filled" && {
  right: 7
}, r.variant === "outlined" && {
  right: 7
}), RT = H("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.icon, t.variant && e[`icon${V(t.variant)}`], t.open && e.iconOpen];
  }
})(ng), og = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const {
    className: n,
    disabled: o,
    error: i,
    IconComponent: a,
    inputRef: s,
    variant: c = "standard"
  } = e, d = q(e, TT), u = A({}, e, {
    disabled: o,
    variant: c,
    error: i
  }), p = AT(u);
  return /* @__PURE__ */ w.jsxs(R.Fragment, {
    children: [/* @__PURE__ */ w.jsx(OT, A({
      ownerState: u,
      className: Y(p.select, n),
      disabled: o,
      ref: s || t
    }, d)), e.multiple ? null : /* @__PURE__ */ w.jsx(RT, {
      as: a,
      ownerState: u,
      className: p.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (og.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The CSS class name of the select element.
   */
  className: l.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: l.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: l.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: $t,
  /**
   * @ignore
   */
  multiple: l.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: l.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The input value.
   */
  value: l.any,
  /**
   * The variant to use.
   */
  variant: l.oneOf(["standard", "outlined", "filled"])
});
var Uu;
const PT = ["children", "classes", "className", "label", "notched"], MT = H("fieldset", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: _t
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), ET = H("legend", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: _t
})(({
  ownerState: r,
  theme: e
}) => A({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !r.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: e.transitions.create("width", {
    duration: 150,
    easing: e.transitions.easing.easeOut
  })
}, r.withLabel && A({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: e.transitions.create("max-width", {
    duration: 50,
    easing: e.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, r.notched && {
  maxWidth: "100%",
  transition: e.transitions.create("max-width", {
    duration: 100,
    easing: e.transitions.easing.easeOut,
    delay: 50
  })
})));
function ig(r) {
  const {
    className: e,
    label: t,
    notched: n
  } = r, o = q(r, PT), i = t != null && t !== "", a = A({}, r, {
    notched: n,
    withLabel: i
  });
  return /* @__PURE__ */ w.jsx(MT, A({
    "aria-hidden": !0,
    className: e,
    ownerState: a
  }, o, {
    children: /* @__PURE__ */ w.jsx(ET, {
      ownerState: a,
      children: i ? /* @__PURE__ */ w.jsx("span", {
        children: t
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Uu || (Uu = /* @__PURE__ */ w.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (ig.propTypes = {
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The label.
   */
  label: l.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: l.bool.isRequired,
  /**
   * @ignore
   */
  style: l.object
});
const IT = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], NT = (r) => {
  const {
    classes: e
  } = r, n = he({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, Z0, e);
  return A({}, e, n);
}, LT = H(ks, {
  shouldForwardProp: (r) => _t(r) || r === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: ws
})(({
  theme: r,
  ownerState: e
}) => {
  const t = r.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return A({
    position: "relative",
    borderRadius: (r.vars || r).shape.borderRadius,
    [`&:hover .${Ir.notchedOutline}`]: {
      borderColor: (r.vars || r).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Ir.notchedOutline}`]: {
        borderColor: r.vars ? `rgba(${r.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${Ir.focused} .${Ir.notchedOutline}`]: {
      borderColor: (r.vars || r).palette[e.color].main,
      borderWidth: 2
    },
    [`&.${Ir.error} .${Ir.notchedOutline}`]: {
      borderColor: (r.vars || r).palette.error.main
    },
    [`&.${Ir.disabled} .${Ir.notchedOutline}`]: {
      borderColor: (r.vars || r).palette.action.disabled
    }
  }, e.startAdornment && {
    paddingLeft: 14
  }, e.endAdornment && {
    paddingRight: 14
  }, e.multiline && A({
    padding: "16.5px 14px"
  }, e.size === "small" && {
    padding: "8.5px 14px"
  }));
}), jT = H(ig, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (r, e) => e.notchedOutline
})(({
  theme: r
}) => {
  const e = r.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: r.vars ? `rgba(${r.vars.palette.common.onBackgroundChannel} / 0.23)` : e
  };
}), DT = H(Ss, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: Cs
})(({
  theme: r,
  ownerState: e
}) => A({
  padding: "16.5px 14px"
}, !r.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: r.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: r.palette.mode === "light" ? null : "#fff",
    caretColor: r.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, r.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [r.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, e.size === "small" && {
  padding: "8.5px 14px"
}, e.multiline && {
  padding: 0
}, e.startAdornment && {
  paddingLeft: 0
}, e.endAdornment && {
  paddingRight: 0
})), Ps = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o, i, a, s;
  const c = ge({
    props: e,
    name: "MuiOutlinedInput"
  }), {
    components: d = {},
    fullWidth: u = !1,
    inputComponent: p = "input",
    label: h,
    multiline: f = !1,
    notched: m,
    slots: g = {},
    type: b = "text"
  } = c, x = q(c, IT), v = NT(c), y = Br(), C = bn({
    props: c,
    muiFormControl: y,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), k = A({}, c, {
    color: C.color || "primary",
    disabled: C.disabled,
    error: C.error,
    focused: C.focused,
    formControl: y,
    fullWidth: u,
    hiddenLabel: C.hiddenLabel,
    multiline: f,
    size: C.size,
    type: b
  }), T = (n = (o = g.root) != null ? o : d.Root) != null ? n : LT, S = (i = (a = g.input) != null ? a : d.Input) != null ? i : DT;
  return /* @__PURE__ */ w.jsx(ea, A({
    slots: {
      root: T,
      input: S
    },
    renderSuffix: (O) => /* @__PURE__ */ w.jsx(jT, {
      ownerState: k,
      className: v.notchedOutline,
      label: h != null && h !== "" && C.required ? s || (s = /* @__PURE__ */ w.jsxs(R.Fragment, {
        children: [h, " ", "*"]
      })) : h,
      notched: typeof m < "u" ? m : !!(O.startAdornment || O.filled || O.focused)
    }),
    fullWidth: u,
    inputComponent: p,
    multiline: f,
    ref: t,
    type: b
  }, x, {
    classes: A({}, v, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (Ps.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $t,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: l.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: l.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
Ps.muiName = "Input";
function zT(r) {
  return fe("MuiPagination", r);
}
ue("MuiPagination", ["root", "ul", "outlined", "text"]);
const BT = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
function FT(r = {}) {
  const {
    boundaryCount: e = 1,
    componentName: t = "usePagination",
    count: n = 1,
    defaultPage: o = 1,
    disabled: i = !1,
    hideNextButton: a = !1,
    hidePrevButton: s = !1,
    onChange: c,
    page: d,
    showFirstButton: u = !1,
    showLastButton: p = !1,
    siblingCount: h = 1
  } = r, f = q(r, BT), [m, g] = Rr({
    controlled: d,
    default: o,
    name: t,
    state: "page"
  }), b = (P, M) => {
    d || g(M), c && c(P, M);
  }, x = (P, M) => {
    const I = M - P + 1;
    return Array.from({
      length: I
    }, (E, N) => P + N);
  }, v = x(1, Math.min(e, n)), y = x(Math.max(n - e + 1, e + 1), n), C = Math.max(
    Math.min(
      // Natural start
      m - h,
      // Lower boundary when page is high
      n - e - h * 2 - 1
    ),
    // Greater than startPages
    e + 2
  ), k = Math.min(
    Math.max(
      // Natural end
      m + h,
      // Upper boundary when page is low
      e + h * 2 + 2
    ),
    // Less than endPages
    y.length > 0 ? y[0] - 2 : n - 1
  ), T = [
    ...u ? ["first"] : [],
    ...s ? [] : ["previous"],
    ...v,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...C > e + 2 ? ["start-ellipsis"] : e + 1 < n - e ? [e + 1] : [],
    // Sibling pages
    ...x(C, k),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...k < n - e - 1 ? ["end-ellipsis"] : n - e > e ? [n - e] : [],
    ...y,
    ...a ? [] : ["next"],
    ...p ? ["last"] : []
  ], S = (P) => {
    switch (P) {
      case "first":
        return 1;
      case "previous":
        return m - 1;
      case "next":
        return m + 1;
      case "last":
        return n;
      default:
        return null;
    }
  }, O = T.map((P) => typeof P == "number" ? {
    onClick: (M) => {
      b(M, P);
    },
    type: "page",
    page: P,
    selected: P === m,
    disabled: i,
    "aria-current": P === m ? "true" : void 0
  } : {
    onClick: (M) => {
      b(M, S(P));
    },
    type: P,
    page: S(P),
    selected: !1,
    disabled: i || P.indexOf("ellipsis") === -1 && (P === "next" || P === "last" ? m >= n : m <= 1)
  });
  return A({
    items: O
  }, f);
}
function _T(r) {
  return fe("MuiPaginationItem", r);
}
const dr = ue("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), Wl = At(/* @__PURE__ */ w.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), Hl = At(/* @__PURE__ */ w.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), Gu = At(/* @__PURE__ */ w.jsx("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), qu = At(/* @__PURE__ */ w.jsx("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), $T = ["className", "color", "component", "components", "disabled", "page", "selected", "shape", "size", "slots", "type", "variant"], ag = (r, e) => {
  const {
    ownerState: t
  } = r;
  return [e.root, e[t.variant], e[`size${V(t.size)}`], t.variant === "text" && e[`text${V(t.color)}`], t.variant === "outlined" && e[`outlined${V(t.color)}`], t.shape === "rounded" && e.rounded, t.type === "page" && e.page, (t.type === "start-ellipsis" || t.type === "end-ellipsis") && e.ellipsis, (t.type === "previous" || t.type === "next") && e.previousNext, (t.type === "first" || t.type === "last") && e.firstLast];
}, WT = (r) => {
  const {
    classes: e,
    color: t,
    disabled: n,
    selected: o,
    size: i,
    shape: a,
    type: s,
    variant: c
  } = r, d = {
    root: ["root", `size${V(i)}`, c, a, t !== "standard" && `color${V(t)}`, t !== "standard" && `${c}${V(t)}`, n && "disabled", o && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[s]],
    icon: ["icon"]
  };
  return he(d, _T, e);
}, HT = H("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: ag
})(({
  theme: r,
  ownerState: e
}) => A({}, r.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (r.vars || r).palette.text.primary,
  height: "auto",
  [`&.${dr.disabled}`]: {
    opacity: (r.vars || r).palette.action.disabledOpacity
  }
}, e.size === "small" && {
  minWidth: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, e.size === "large" && {
  minWidth: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: r.typography.pxToRem(15)
})), YT = H(Kt, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: ag
})(({
  theme: r,
  ownerState: e
}) => A({}, r.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (r.vars || r).palette.text.primary,
  [`&.${dr.focusVisible}`]: {
    backgroundColor: (r.vars || r).palette.action.focus
  },
  [`&.${dr.disabled}`]: {
    opacity: (r.vars || r).palette.action.disabledOpacity
  },
  transition: r.transitions.create(["color", "background-color"], {
    duration: r.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (r.vars || r).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${dr.selected}`]: {
    backgroundColor: (r.vars || r).palette.action.selected,
    "&:hover": {
      backgroundColor: r.vars ? `rgba(${r.vars.palette.action.selectedChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.hoverOpacity}))` : Pe.alpha(r.palette.action.selected, r.palette.action.selectedOpacity + r.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (r.vars || r).palette.action.selected
      }
    },
    [`&.${dr.focusVisible}`]: {
      backgroundColor: r.vars ? `rgba(${r.vars.palette.action.selectedChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.focusOpacity}))` : Pe.alpha(r.palette.action.selected, r.palette.action.selectedOpacity + r.palette.action.focusOpacity)
    },
    [`&.${dr.disabled}`]: {
      opacity: 1,
      color: (r.vars || r).palette.action.disabled,
      backgroundColor: (r.vars || r).palette.action.selected
    }
  }
}, e.size === "small" && {
  minWidth: 26,
  height: 26,
  borderRadius: 26 / 2,
  margin: "0 1px",
  padding: "0 4px"
}, e.size === "large" && {
  minWidth: 40,
  height: 40,
  borderRadius: 40 / 2,
  padding: "0 10px",
  fontSize: r.typography.pxToRem(15)
}, e.shape === "rounded" && {
  borderRadius: (r.vars || r).shape.borderRadius
}), ({
  theme: r,
  ownerState: e
}) => A({}, e.variant === "text" && {
  [`&.${dr.selected}`]: A({}, e.color !== "standard" && {
    color: (r.vars || r).palette[e.color].contrastText,
    backgroundColor: (r.vars || r).palette[e.color].main,
    "&:hover": {
      backgroundColor: (r.vars || r).palette[e.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (r.vars || r).palette[e.color].main
      }
    },
    [`&.${dr.focusVisible}`]: {
      backgroundColor: (r.vars || r).palette[e.color].dark
    }
  }, {
    [`&.${dr.disabled}`]: {
      color: (r.vars || r).palette.action.disabled
    }
  })
}, e.variant === "outlined" && {
  border: r.vars ? `1px solid rgba(${r.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${r.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
  [`&.${dr.selected}`]: A({}, e.color !== "standard" && {
    color: (r.vars || r).palette[e.color].main,
    border: `1px solid ${r.vars ? `rgba(${r.vars.palette[e.color].mainChannel} / 0.5)` : Pe.alpha(r.palette[e.color].main, 0.5)}`,
    backgroundColor: r.vars ? `rgba(${r.vars.palette[e.color].mainChannel} / ${r.vars.palette.action.activatedOpacity})` : Pe.alpha(r.palette[e.color].main, r.palette.action.activatedOpacity),
    "&:hover": {
      backgroundColor: r.vars ? `rgba(${r.vars.palette[e.color].mainChannel} / calc(${r.vars.palette.action.activatedOpacity} + ${r.vars.palette.action.focusOpacity}))` : Pe.alpha(r.palette[e.color].main, r.palette.action.activatedOpacity + r.palette.action.focusOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${dr.focusVisible}`]: {
      backgroundColor: r.vars ? `rgba(${r.vars.palette[e.color].mainChannel} / calc(${r.vars.palette.action.activatedOpacity} + ${r.vars.palette.action.focusOpacity}))` : Pe.alpha(r.palette[e.color].main, r.palette.action.activatedOpacity + r.palette.action.focusOpacity)
    }
  }, {
    [`&.${dr.disabled}`]: {
      borderColor: (r.vars || r).palette.action.disabledBackground,
      color: (r.vars || r).palette.action.disabled
    }
  })
})), XT = H("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (r, e) => e.icon
})(({
  theme: r,
  ownerState: e
}) => A({
  fontSize: r.typography.pxToRem(20),
  margin: "0 -8px"
}, e.size === "small" && {
  fontSize: r.typography.pxToRem(18)
}, e.size === "large" && {
  fontSize: r.typography.pxToRem(22)
})), sg = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiPaginationItem"
  }), {
    className: o,
    color: i = "standard",
    component: a,
    components: s = {},
    disabled: c = !1,
    page: d,
    selected: u = !1,
    shape: p = "circular",
    size: h = "medium",
    slots: f = {},
    type: m = "page",
    variant: g = "text"
  } = n, b = q(n, $T), x = A({}, n, {
    color: i,
    disabled: c,
    selected: u,
    shape: p,
    size: h,
    type: m,
    variant: g
  }), v = gn(), y = WT(x), k = (v ? {
    previous: f.next || s.next || qu,
    next: f.previous || s.previous || Gu,
    last: f.first || s.first || Wl,
    first: f.last || s.last || Hl
  } : {
    previous: f.previous || s.previous || Gu,
    next: f.next || s.next || qu,
    first: f.first || s.first || Wl,
    last: f.last || s.last || Hl
  })[m];
  return m === "start-ellipsis" || m === "end-ellipsis" ? /* @__PURE__ */ w.jsx(HT, {
    ref: t,
    ownerState: x,
    className: Y(y.root, o),
    children: "…"
  }) : /* @__PURE__ */ w.jsxs(YT, A({
    ref: t,
    ownerState: x,
    component: a,
    disabled: c,
    className: Y(y.root, o)
  }, b, {
    children: [m === "page" && d, k ? /* @__PURE__ */ w.jsx(XT, {
      as: k,
      ownerState: x,
      className: y.icon
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (sg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "standard"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    first: l.elementType,
    last: l.elementType,
    next: l.elementType,
    previous: l.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * The current page number.
   */
  page: l.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: l.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: l.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    first: l.elementType,
    last: l.elementType,
    next: l.elementType,
    previous: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: l.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: l.oneOfType([l.oneOf(["outlined", "text"]), l.string])
});
const VT = ["boundaryCount", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"], UT = (r) => {
  const {
    classes: e,
    variant: t
  } = r;
  return he({
    root: ["root", t],
    ul: ["ul"]
  }, zT, e);
}, GT = H("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[t.variant]];
  }
})({}), qT = H("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (r, e) => e.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function KT(r, e, t) {
  return r === "page" ? `${t ? "" : "Go to "}page ${e}` : `Go to ${r} page`;
}
const lg = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiPagination"
  }), {
    boundaryCount: o = 1,
    className: i,
    color: a = "standard",
    count: s = 1,
    defaultPage: c = 1,
    disabled: d = !1,
    getItemAriaLabel: u = KT,
    hideNextButton: p = !1,
    hidePrevButton: h = !1,
    renderItem: f = (O) => /* @__PURE__ */ w.jsx(sg, A({}, O)),
    shape: m = "circular",
    showFirstButton: g = !1,
    showLastButton: b = !1,
    siblingCount: x = 1,
    size: v = "medium",
    variant: y = "text"
  } = n, C = q(n, VT), {
    items: k
  } = FT(A({}, n, {
    componentName: "Pagination"
  })), T = A({}, n, {
    boundaryCount: o,
    color: a,
    count: s,
    defaultPage: c,
    disabled: d,
    getItemAriaLabel: u,
    hideNextButton: p,
    hidePrevButton: h,
    renderItem: f,
    shape: m,
    showFirstButton: g,
    showLastButton: b,
    siblingCount: x,
    size: v,
    variant: y
  }), S = UT(T);
  return /* @__PURE__ */ w.jsx(GT, A({
    "aria-label": "pagination navigation",
    className: Y(S.root, i),
    ownerState: T,
    ref: t
  }, C, {
    children: /* @__PURE__ */ w.jsx(qT, {
      className: S.ul,
      ownerState: T,
      children: k.map((O, P) => /* @__PURE__ */ w.jsx("li", {
        children: f(A({}, O, {
          color: a,
          "aria-label": u(O.type, O.page, O.selected),
          shape: m,
          size: v,
          variant: y
        }))
      }, P))
    })
  }));
});
process.env.NODE_ENV !== "production" && (lg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: Ut,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "standard"]), l.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: Ut,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: Ut,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: l.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: l.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: l.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: l.func,
  /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */
  page: Ut,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: l.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: l.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: l.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: l.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: Ut,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: l.oneOfType([l.oneOf(["outlined", "text"]), l.string])
});
const ZT = At(/* @__PURE__ */ w.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), JT = At(/* @__PURE__ */ w.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), QT = H("span", {
  name: "MuiRadioButtonIcon",
  shouldForwardProp: _t
})({
  position: "relative",
  display: "flex"
}), eA = H(ZT, {
  name: "MuiRadioButtonIcon"
})({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), tA = H(JT, {
  name: "MuiRadioButtonIcon"
})(({
  theme: r,
  ownerState: e
}) => A({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: r.transitions.create("transform", {
    easing: r.transitions.easing.easeIn,
    duration: r.transitions.duration.shortest
  })
}, e.checked && {
  transform: "scale(1)",
  transition: r.transitions.create("transform", {
    easing: r.transitions.easing.easeOut,
    duration: r.transitions.duration.shortest
  })
}));
function sd(r) {
  const {
    checked: e = !1,
    classes: t = {},
    fontSize: n
  } = r, o = A({}, r, {
    checked: e
  });
  return /* @__PURE__ */ w.jsxs(QT, {
    className: t.root,
    ownerState: o,
    children: [/* @__PURE__ */ w.jsx(eA, {
      fontSize: n,
      className: t.background,
      ownerState: o
    }), /* @__PURE__ */ w.jsx(tA, {
      fontSize: n,
      className: t.dot,
      ownerState: o
    })]
  });
}
process.env.NODE_ENV !== "production" && (sd.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: l.oneOf(["small", "medium"])
});
const ld = /* @__PURE__ */ R.createContext(void 0);
process.env.NODE_ENV !== "production" && (ld.displayName = "RadioGroupContext");
function rA() {
  return R.useContext(ld);
}
function nA(r) {
  return fe("MuiRadio", r);
}
const Ku = ue("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), oA = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"], iA = (r) => {
  const {
    classes: e,
    color: t,
    size: n
  } = r, o = {
    root: ["root", `color${V(t)}`, n !== "medium" && `size${V(n)}`]
  };
  return A({}, e, he(o, nA, e));
}, aA = H(Ts, {
  shouldForwardProp: (r) => _t(r) || r === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.size !== "medium" && e[`size${V(t.size)}`], e[`color${V(t.color)}`]];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  color: (r.vars || r).palette.text.secondary
}, !e.disableRipple && {
  "&:hover": {
    backgroundColor: r.vars ? `rgba(${e.color === "default" ? r.vars.palette.action.activeChannel : r.vars.palette[e.color].mainChannel} / ${r.vars.palette.action.hoverOpacity})` : Pe.alpha(e.color === "default" ? r.palette.action.active : r.palette[e.color].main, r.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, e.color !== "default" && {
  [`&.${Ku.checked}`]: {
    color: (r.vars || r).palette[e.color].main
  }
}, {
  [`&.${Ku.disabled}`]: {
    color: (r.vars || r).palette.action.disabled
  }
}));
function sA(r, e) {
  return typeof e == "object" && e !== null ? r === e : String(r) === String(e);
}
const Zu = /* @__PURE__ */ w.jsx(sd, {
  checked: !0
}), Ju = /* @__PURE__ */ w.jsx(sd, {}), lA = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o;
  const i = ge({
    props: e,
    name: "MuiRadio"
  }), {
    checked: a,
    checkedIcon: s = Zu,
    color: c = "primary",
    icon: d = Ju,
    name: u,
    onChange: p,
    size: h = "medium",
    className: f
  } = i, m = q(i, oA), g = A({}, i, {
    color: c,
    size: h
  }), b = iA(g), x = rA();
  let v = a;
  const y = Wa(p, x && x.onChange);
  let C = u;
  return x && (typeof v > "u" && (v = sA(x.value, i.value)), typeof C > "u" && (C = x.name)), /* @__PURE__ */ w.jsx(aA, A({
    type: "radio",
    icon: /* @__PURE__ */ R.cloneElement(d, {
      fontSize: (n = Ju.props.fontSize) != null ? n : h
    }),
    checkedIcon: /* @__PURE__ */ R.cloneElement(s, {
      fontSize: (o = Zu.props.fontSize) != null ? o : h
    }),
    ownerState: g,
    classes: b,
    name: C,
    checked: v,
    onChange: y,
    ref: t,
    className: Y(b.root, f)
  }, m));
});
process.env.NODE_ENV !== "production" && (lA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: l.node,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $t,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: l.any
});
function cA(r) {
  return fe("MuiRadioGroup", r);
}
ue("MuiRadioGroup", ["root", "row", "error"]);
const dA = ["actions", "children", "className", "defaultValue", "name", "onChange", "value"], uA = (r) => {
  const {
    classes: e,
    row: t,
    error: n
  } = r;
  return he({
    root: ["root", t && "row", n && "error"]
  }, cA, e);
}, pA = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: n,
    children: o,
    className: i,
    defaultValue: a,
    name: s,
    onChange: c,
    value: d
  } = e, u = q(e, dA), p = R.useRef(null), h = uA(e), [f, m] = Rr({
    controlled: d,
    default: a,
    name: "RadioGroup"
  });
  R.useImperativeHandle(n, () => ({
    focus: () => {
      let v = p.current.querySelector("input:not(:disabled):checked");
      v || (v = p.current.querySelector("input:not(:disabled)")), v && v.focus();
    }
  }), []);
  const g = ut(t, p), b = Yr(s), x = R.useMemo(() => ({
    name: b,
    onChange(v) {
      m(v.target.value), c && c(v, v.target.value);
    },
    value: f
  }), [b, c, m, f]);
  return /* @__PURE__ */ w.jsx(ld.Provider, {
    value: x,
    children: /* @__PURE__ */ w.jsx(Vf, A({
      role: "radiogroup",
      ref: g,
      className: Y(h.root, i)
    }, u, {
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (pA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: l.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: l.any
});
function hA(r) {
  return fe("MuiSelect", r);
}
const _o = ue("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var Qu;
const fA = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], gA = H("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [
      // Win specificity over the input base
      {
        [`&.${_o.select}`]: e.select
      },
      {
        [`&.${_o.select}`]: e[t.variant]
      },
      {
        [`&.${_o.error}`]: e.error
      },
      {
        [`&.${_o.multiple}`]: e.multiple
      }
    ];
  }
})(rg, {
  // Win specificity over the input base
  [`&.${_o.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), mA = H("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.icon, t.variant && e[`icon${V(t.variant)}`], t.open && e.iconOpen];
  }
})(ng), bA = H("input", {
  shouldForwardProp: (r) => fb(r) && r !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (r, e) => e.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function ep(r, e) {
  return typeof e == "object" && e !== null ? r === e : String(r) === String(e);
}
function xA(r) {
  return r == null || typeof r == "string" && !r.trim();
}
const vA = (r) => {
  const {
    classes: e,
    variant: t,
    disabled: n,
    multiple: o,
    open: i,
    error: a
  } = r, s = {
    select: ["select", t, n && "disabled", o && "multiple", a && "error"],
    icon: ["icon", `icon${V(t)}`, i && "iconOpen", n && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return he(s, hA, e);
}, cg = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n;
  const {
    "aria-describedby": o,
    "aria-label": i,
    autoFocus: a,
    autoWidth: s,
    children: c,
    className: d,
    defaultOpen: u,
    defaultValue: p,
    disabled: h,
    displayEmpty: f,
    error: m = !1,
    IconComponent: g,
    inputRef: b,
    labelId: x,
    MenuProps: v = {},
    multiple: y,
    name: C,
    onBlur: k,
    onChange: T,
    onClose: S,
    onFocus: O,
    onOpen: P,
    open: M,
    readOnly: I,
    renderValue: E,
    SelectDisplayProps: N = {},
    tabIndex: L,
    value: z,
    variant: F = "standard"
  } = e, B = q(e, fA), [D, W] = Rr({
    controlled: z,
    default: p,
    name: "Select"
  }), [G, re] = Rr({
    controlled: M,
    default: u,
    name: "Select"
  }), ce = R.useRef(null), Ce = R.useRef(null), [ne, pe] = R.useState(null), {
    current: K
  } = R.useRef(M != null), [le, Q] = R.useState(), se = ut(t, b), Re = R.useCallback((ye) => {
    Ce.current = ye, ye && pe(ye);
  }, []), be = ne?.parentNode;
  R.useImperativeHandle(se, () => ({
    focus: () => {
      Ce.current.focus();
    },
    node: ce.current,
    value: D
  }), [D]), R.useEffect(() => {
    u && G && ne && !K && (Q(s ? null : be.clientWidth), Ce.current.focus());
  }, [ne, s]), R.useEffect(() => {
    a && Ce.current.focus();
  }, [a]), R.useEffect(() => {
    if (!x)
      return;
    const ye = Rt(Ce.current).getElementById(x);
    if (ye) {
      const te = () => {
        getSelection().isCollapsed && Ce.current.focus();
      };
      return ye.addEventListener("click", te), () => {
        ye.removeEventListener("click", te);
      };
    }
  }, [x]);
  const Ne = (ye, te) => {
    ye ? P && P(te) : S && S(te), K || (Q(s ? null : be.clientWidth), re(ye));
  }, ke = (ye) => {
    ye.button === 0 && (ye.preventDefault(), Ce.current.focus(), Ne(!0, ye));
  }, Oe = (ye) => {
    Ne(!1, ye);
  }, Te = R.Children.toArray(c), me = (ye) => {
    const te = Te.find((_) => _.props.value === ye.target.value);
    te !== void 0 && (W(te.props.value), T && T(ye, te));
  }, tt = (ye) => (te) => {
    let _;
    if (te.currentTarget.hasAttribute("tabindex")) {
      if (y) {
        _ = Array.isArray(D) ? D.slice() : [];
        const U = D.indexOf(ye.props.value);
        U === -1 ? _.push(ye.props.value) : _.splice(U, 1);
      } else
        _ = ye.props.value;
      if (ye.props.onClick && ye.props.onClick(te), D !== _ && (W(_), T)) {
        const U = te.nativeEvent || te, oe = new U.constructor(U.type, U);
        Object.defineProperty(oe, "target", {
          writable: !0,
          value: {
            value: _,
            name: C
          }
        }), T(oe, ye);
      }
      y || Ne(!1, te);
    }
  }, Se = (ye) => {
    I || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(ye.key) !== -1 && (ye.preventDefault(), Ne(!0, ye));
  }, Ke = ne !== null && G, He = (ye) => {
    !Ke && k && (Object.defineProperty(ye, "target", {
      writable: !0,
      value: {
        value: D,
        name: C
      }
    }), k(ye));
  };
  delete B["aria-invalid"];
  let _e, Qe;
  const Ue = [];
  let Ye = !1, ht = !1;
  (qa({
    value: D
  }) || f) && (E ? _e = E(D) : Ye = !0);
  const bt = Te.map((ye) => {
    if (!/* @__PURE__ */ R.isValidElement(ye))
      return null;
    process.env.NODE_ENV !== "production" && wo.isFragment(ye) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let te;
    if (y) {
      if (!Array.isArray(D))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : _a(2));
      te = D.some((_) => ep(_, ye.props.value)), te && Ye && Ue.push(ye.props.children);
    } else
      te = ep(D, ye.props.value), te && Ye && (Qe = ye.props.children);
    return te && (ht = !0), /* @__PURE__ */ R.cloneElement(ye, {
      "aria-selected": te ? "true" : "false",
      onClick: tt(ye),
      onKeyUp: (_) => {
        _.key === " " && _.preventDefault(), ye.props.onKeyUp && ye.props.onKeyUp(_);
      },
      role: "option",
      selected: te,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": ye.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && R.useEffect(() => {
    if (!ht && !y && D !== "") {
      const ye = Te.map((te) => te.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${D}\` for the select ${C ? `(name="${C}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${ye.filter((te) => te != null).map((te) => `\`${te}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [ht, Te, y, C, D]), Ye && (y ? Ue.length === 0 ? _e = null : _e = Ue.reduce((ye, te, _) => (ye.push(te), _ < Ue.length - 1 && ye.push(", "), ye), []) : _e = Qe);
  let mt = le;
  !s && K && ne && (mt = be.clientWidth);
  let Ie;
  typeof L < "u" ? Ie = L : Ie = h ? null : 0;
  const de = N.id || (C ? `mui-component-select-${C}` : void 0), Ve = A({}, e, {
    variant: F,
    value: D,
    open: Ke,
    error: m
  }), vt = vA(Ve), yt = A({}, v.PaperProps, (n = v.slotProps) == null ? void 0 : n.paper), Ot = Yr();
  return /* @__PURE__ */ w.jsxs(R.Fragment, {
    children: [/* @__PURE__ */ w.jsx(gA, A({
      ref: Re,
      tabIndex: Ie,
      role: "combobox",
      "aria-controls": Ot,
      "aria-disabled": h ? "true" : void 0,
      "aria-expanded": Ke ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": i,
      "aria-labelledby": [x, de].filter(Boolean).join(" ") || void 0,
      "aria-describedby": o,
      onKeyDown: Se,
      onMouseDown: h || I ? null : ke,
      onBlur: He,
      onFocus: O
    }, N, {
      ownerState: Ve,
      className: Y(N.className, vt.select, d),
      id: de,
      children: xA(_e) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Qu || (Qu = /* @__PURE__ */ w.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : _e
    })), /* @__PURE__ */ w.jsx(bA, A({
      "aria-invalid": m,
      value: Array.isArray(D) ? D.join(",") : D,
      name: C,
      ref: ce,
      "aria-hidden": !0,
      onChange: me,
      tabIndex: -1,
      disabled: h,
      className: vt.nativeInput,
      autoFocus: a,
      ownerState: Ve
    }, B)), /* @__PURE__ */ w.jsx(mA, {
      as: g,
      className: vt.icon,
      ownerState: Ve
    }), /* @__PURE__ */ w.jsx(id, A({
      id: `menu-${C || ""}`,
      anchorEl: be,
      open: Ke,
      onClose: Oe,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, v, {
      MenuListProps: A({
        "aria-labelledby": x,
        role: "listbox",
        "aria-multiselectable": y ? "true" : void 0,
        disableListWrap: !0,
        id: Ot
      }, v.MenuListProps),
      slotProps: A({}, v.slotProps, {
        paper: A({}, yt, {
          style: A({
            minWidth: mt
          }, yt != null ? yt.style : null)
        })
      }),
      children: bt
    }))]
  });
});
process.env.NODE_ENV !== "production" && (cg.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": l.string,
  /**
   * @ignore
   */
  "aria-label": l.string,
  /**
   * @ignore
   */
  autoFocus: l.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: l.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The CSS class name of the select element.
   */
  className: l.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: l.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: l.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: l.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: l.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: $t,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: l.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: l.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: l.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: l.string,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: l.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool,
  /**
   * @ignore
   */
  readOnly: l.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: l.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: l.object,
  /**
   * @ignore
   */
  tabIndex: l.oneOfType([l.number, l.string]),
  /**
   * @ignore
   */
  type: l.any,
  /**
   * The input value.
   */
  value: l.any,
  /**
   * The variant to use.
   */
  variant: l.oneOf(["standard", "outlined", "filled"])
});
const yA = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], wA = ["root"], CA = (r) => {
  const {
    classes: e
  } = r;
  return e;
}, cd = {
  name: "MuiSelect",
  overridesResolver: (r, e) => e.root,
  shouldForwardProp: (r) => _t(r) && r !== "variant",
  slot: "Root"
}, kA = H(Qc, cd)(""), SA = H(Ps, cd)(""), TA = H(Kc, cd)(""), bo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    name: "MuiSelect",
    props: e
  }), {
    autoWidth: o = !1,
    children: i,
    classes: a = {},
    className: s,
    defaultOpen: c = !1,
    displayEmpty: d = !1,
    IconComponent: u = Lf,
    id: p,
    input: h,
    inputProps: f,
    label: m,
    labelId: g,
    MenuProps: b,
    multiple: x = !1,
    native: v = !1,
    onClose: y,
    onOpen: C,
    open: k,
    renderValue: T,
    SelectDisplayProps: S,
    variant: O = "outlined"
  } = n, P = q(n, yA), M = v ? og : cg, I = Br(), E = bn({
    props: n,
    muiFormControl: I,
    states: ["variant", "error"]
  }), N = E.variant || O, L = A({}, n, {
    variant: N,
    classes: a
  }), z = CA(L), F = q(z, wA), B = h || {
    standard: /* @__PURE__ */ w.jsx(kA, {
      ownerState: L
    }),
    outlined: /* @__PURE__ */ w.jsx(SA, {
      label: m,
      ownerState: L
    }),
    filled: /* @__PURE__ */ w.jsx(TA, {
      ownerState: L
    })
  }[N], D = ut(t, fn(B));
  return /* @__PURE__ */ w.jsx(R.Fragment, {
    children: /* @__PURE__ */ R.cloneElement(B, A({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: M,
      inputProps: A({
        children: i,
        error: E.error,
        IconComponent: u,
        variant: N,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: x
      }, v ? {
        id: p
      } : {
        autoWidth: o,
        defaultOpen: c,
        displayEmpty: d,
        labelId: g,
        MenuProps: b,
        onClose: y,
        onOpen: C,
        open: k,
        renderValue: T,
        SelectDisplayProps: A({
          id: p
        }, S)
      }, f, {
        classes: f ? co(F, f.classes) : F
      }, h ? h.props.inputProps : {})
    }, (x && v || d) && N === "outlined" ? {
      notched: !0
    } : {}, {
      ref: D,
      className: Y(B.props.className, s, z.root)
    }, !h && {
      variant: N
    }, P))
  });
});
process.env.NODE_ENV !== "production" && (bo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: l.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: l.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: l.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: l.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: l.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: l.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: l.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: l.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: l.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: l.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: l.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: l.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: l.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: l.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: l.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: l.oneOfType([l.oneOf([""]), l.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
bo.muiName = "Select";
function AA(r) {
  return fe("MuiSkeleton", r);
}
ue("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const OA = ["animation", "className", "component", "height", "style", "variant", "width"];
let Ja = (r) => r, tp, rp, np, op;
const RA = (r) => {
  const {
    classes: e,
    variant: t,
    animation: n,
    hasChildren: o,
    width: i,
    height: a
  } = r;
  return he({
    root: ["root", t, n, o && "withChildren", o && !i && "fitContent", o && !a && "heightAuto"]
  }, AA, e);
}, PA = zr(tp || (tp = Ja`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`)), MA = zr(rp || (rp = Ja`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`)), EA = H("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[t.variant], t.animation !== !1 && e[t.animation], t.hasChildren && e.withChildren, t.hasChildren && !t.width && e.fitContent, t.hasChildren && !t.height && e.heightAuto];
  }
})(({
  theme: r,
  ownerState: e
}) => {
  const t = Nx(r.shape.borderRadius) || "px", n = Lx(r.shape.borderRadius);
  return A({
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: r.vars ? r.vars.palette.Skeleton.bg : Xb(r.palette.text.primary, r.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em"
  }, e.variant === "text" && {
    marginTop: 0,
    marginBottom: 0,
    height: "auto",
    transformOrigin: "0 55%",
    transform: "scale(1, 0.60)",
    borderRadius: `${n}${t}/${Math.round(n / 0.6 * 10) / 10}${t}`,
    "&:empty:before": {
      content: '"\\00a0"'
    }
  }, e.variant === "circular" && {
    borderRadius: "50%"
  }, e.variant === "rounded" && {
    borderRadius: (r.vars || r).shape.borderRadius
  }, e.hasChildren && {
    "& > *": {
      visibility: "hidden"
    }
  }, e.hasChildren && !e.width && {
    maxWidth: "fit-content"
  }, e.hasChildren && !e.height && {
    height: "auto"
  });
}, ({
  ownerState: r
}) => r.animation === "pulse" && Dn(np || (np = Ja`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), PA), ({
  ownerState: r,
  theme: e
}) => r.animation === "wave" && Dn(op || (op = Ja`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), MA, (e.vars || e).palette.action.hover)), IA = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiSkeleton"
  }), {
    animation: o = "pulse",
    className: i,
    component: a = "span",
    height: s,
    style: c,
    variant: d = "text",
    width: u
  } = n, p = q(n, OA), h = A({}, n, {
    animation: o,
    component: a,
    variant: d,
    hasChildren: !!p.children
  }), f = RA(h);
  return /* @__PURE__ */ w.jsx(EA, A({
    as: a,
    ref: t,
    className: Y(f.root, i),
    ownerState: h
  }, p, {
    style: A({
      width: u,
      height: s
    }, c)
  }));
});
process.env.NODE_ENV !== "production" && (IA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: l.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: l.oneOfType([l.number, l.string]),
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: l.oneOfType([l.oneOf(["circular", "rectangular", "rounded", "text"]), l.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: l.oneOfType([l.number, l.string])
});
function NA(r) {
  return fe("MuiTooltip", r);
}
const on = ue("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), LA = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function jA(r) {
  return Math.round(r * 1e5) / 1e5;
}
const DA = (r) => {
  const {
    classes: e,
    disableInteractive: t,
    arrow: n,
    touch: o,
    placement: i
  } = r, a = {
    popper: ["popper", !t && "popperInteractive", n && "popperArrow"],
    tooltip: ["tooltip", n && "tooltipArrow", o && "touch", `tooltipPlacement${V(i.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return he(a, NA, e);
}, zA = H(Ji, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.popper, !t.disableInteractive && e.popperInteractive, t.arrow && e.popperArrow, !t.open && e.popperClose];
  }
})(({
  theme: r,
  ownerState: e,
  open: t
}) => A({
  zIndex: (r.vars || r).zIndex.tooltip,
  pointerEvents: "none"
}, !e.disableInteractive && {
  pointerEvents: "auto"
}, !t && {
  pointerEvents: "none"
}, e.arrow && {
  [`&[data-popper-placement*="bottom"] .${on.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${on.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${on.arrow}`]: A({}, e.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${on.arrow}`]: A({}, e.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), BA = H("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.tooltip, t.touch && e.touch, t.arrow && e.tooltipArrow, e[`tooltipPlacement${V(t.placement.split("-")[0])}`]];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  backgroundColor: r.vars ? r.vars.palette.Tooltip.bg : Pe.alpha(r.palette.grey[700], 0.92),
  borderRadius: (r.vars || r).shape.borderRadius,
  color: (r.vars || r).palette.common.white,
  fontFamily: r.typography.fontFamily,
  padding: "4px 8px",
  fontSize: r.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: r.typography.fontWeightMedium
}, e.arrow && {
  position: "relative",
  margin: 0
}, e.touch && {
  padding: "8px 16px",
  fontSize: r.typography.pxToRem(14),
  lineHeight: `${jA(16 / 14)}em`,
  fontWeight: r.typography.fontWeightRegular
}, {
  [`.${on.popper}[data-popper-placement*="left"] &`]: A({
    transformOrigin: "right center"
  }, e.isRtl ? A({
    marginLeft: "14px"
  }, e.touch && {
    marginLeft: "24px"
  }) : A({
    marginRight: "14px"
  }, e.touch && {
    marginRight: "24px"
  })),
  [`.${on.popper}[data-popper-placement*="right"] &`]: A({
    transformOrigin: "left center"
  }, e.isRtl ? A({
    marginRight: "14px"
  }, e.touch && {
    marginRight: "24px"
  }) : A({
    marginLeft: "14px"
  }, e.touch && {
    marginLeft: "24px"
  })),
  [`.${on.popper}[data-popper-placement*="top"] &`]: A({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, e.touch && {
    marginBottom: "24px"
  }),
  [`.${on.popper}[data-popper-placement*="bottom"] &`]: A({
    transformOrigin: "center top",
    marginTop: "14px"
  }, e.touch && {
    marginTop: "24px"
  })
})), FA = H("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (r, e) => e.arrow
})(({
  theme: r
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: r.vars ? r.vars.palette.Tooltip.bg : Pe.alpha(r.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let wa = !1;
const ip = new qi();
let $o = {
  x: 0,
  y: 0
};
function Ca(r, e) {
  return (t, ...n) => {
    e && e(t, ...n), r(t, ...n);
  };
}
const dg = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o, i, a, s, c, d, u, p, h, f, m, g, b, x, v, y, C, k;
  const T = ge({
    props: e,
    name: "MuiTooltip"
  }), {
    arrow: S = !1,
    children: O,
    components: P = {},
    componentsProps: M = {},
    describeChild: I = !1,
    disableFocusListener: E = !1,
    disableHoverListener: N = !1,
    disableInteractive: L = !1,
    disableTouchListener: z = !1,
    enterDelay: F = 100,
    enterNextDelay: B = 0,
    enterTouchDelay: D = 700,
    followCursor: W = !1,
    id: G,
    leaveDelay: re = 0,
    leaveTouchDelay: ce = 1500,
    onClose: Ce,
    onOpen: ne,
    open: pe,
    placement: K = "bottom",
    PopperComponent: le,
    PopperProps: Q = {},
    slotProps: se = {},
    slots: Re = {},
    title: be,
    TransitionComponent: Ne = _i,
    TransitionProps: ke
  } = T, Oe = q(T, LA), Te = /* @__PURE__ */ R.isValidElement(O) ? O : /* @__PURE__ */ w.jsx("span", {
    children: O
  }), me = yr(), tt = gn(), [Se, Ke] = R.useState(), [He, _e] = R.useState(null), Qe = R.useRef(!1), Ue = L || W, Ye = On(), ht = On(), bt = On(), mt = On(), [Ie, de] = Rr({
    controlled: pe,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let Ve = Ie;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: we
    } = R.useRef(pe !== void 0);
    R.useEffect(() => {
      Se && Se.disabled && !we && be !== "" && Se.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [be, Se, we]);
  }
  const vt = Yr(G), yt = R.useRef(), Ot = Lt(() => {
    yt.current !== void 0 && (document.body.style.WebkitUserSelect = yt.current, yt.current = void 0), mt.clear();
  });
  R.useEffect(() => Ot, [Ot]);
  const ye = (we) => {
    ip.clear(), wa = !0, de(!0), ne && !Ve && ne(we);
  }, te = Lt(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (we) => {
      ip.start(800 + re, () => {
        wa = !1;
      }), de(!1), Ce && Ve && Ce(we), Ye.start(me.transitions.duration.shortest, () => {
        Qe.current = !1;
      });
    }
  ), _ = (we) => {
    Qe.current && we.type !== "touchstart" || (Se && Se.removeAttribute("title"), ht.clear(), bt.clear(), F || wa && B ? ht.start(wa ? B : F, () => {
      ye(we);
    }) : ye(we));
  }, U = (we) => {
    ht.clear(), bt.start(re, () => {
      te(we);
    });
  }, {
    isFocusVisibleRef: oe,
    onBlur: Ae,
    onFocus: et,
    ref: st
  } = gs(), [, Et] = R.useState(!1), Pt = (we) => {
    Ae(we), oe.current === !1 && (Et(!1), U(we));
  }, kr = (we) => {
    Se || Ke(we.currentTarget), et(we), oe.current === !0 && (Et(!0), _(we));
  }, xn = (we) => {
    Qe.current = !0;
    const Ge = Te.props;
    Ge.onTouchStart && Ge.onTouchStart(we);
  }, Yn = (we) => {
    xn(we), bt.clear(), Ye.clear(), Ot(), yt.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", mt.start(D, () => {
      document.body.style.WebkitUserSelect = yt.current, _(we);
    });
  }, No = (we) => {
    Te.props.onTouchEnd && Te.props.onTouchEnd(we), Ot(), bt.start(ce, () => {
      te(we);
    });
  };
  R.useEffect(() => {
    if (!Ve)
      return;
    function we(Ge) {
      (Ge.key === "Escape" || Ge.key === "Esc") && te(Ge);
    }
    return document.addEventListener("keydown", we), () => {
      document.removeEventListener("keydown", we);
    };
  }, [te, Ve]);
  const ca = ut(fn(Te), st, Ke, t);
  !be && be !== 0 && (Ve = !1);
  const Mr = R.useRef(), It = (we) => {
    const Ge = Te.props;
    Ge.onMouseMove && Ge.onMouseMove(we), $o = {
      x: we.clientX,
      y: we.clientY
    }, Mr.current && Mr.current.update();
  }, xt = {}, Ht = typeof be == "string";
  I ? (xt.title = !Ve && Ht && !N ? be : null, xt["aria-describedby"] = Ve ? vt : null) : (xt["aria-label"] = Ht ? be : null, xt["aria-labelledby"] = Ve && !Ht ? vt : null);
  const Yt = A({}, xt, Oe, Te.props, {
    className: Y(Oe.className, Te.props.className),
    onTouchStart: xn,
    ref: ca
  }, W ? {
    onMouseMove: It
  } : {});
  process.env.NODE_ENV !== "production" && (Yt["data-mui-internal-clone-element"] = !0, R.useEffect(() => {
    Se && !Se.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [Se]));
  const Fr = {};
  z || (Yt.onTouchStart = Yn, Yt.onTouchEnd = No), N || (Yt.onMouseOver = Ca(_, Yt.onMouseOver), Yt.onMouseLeave = Ca(U, Yt.onMouseLeave), Ue || (Fr.onMouseOver = _, Fr.onMouseLeave = U)), E || (Yt.onFocus = Ca(kr, Yt.onFocus), Yt.onBlur = Ca(Pt, Yt.onBlur), Ue || (Fr.onFocus = kr, Fr.onBlur = Pt)), process.env.NODE_ENV !== "production" && Te.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${Te.props.title}\` or the Tooltip component.`].join(`
`));
  const Lo = R.useMemo(() => {
    var we;
    let Ge = [{
      name: "arrow",
      enabled: !!He,
      options: {
        element: He,
        padding: 4
      }
    }];
    return (we = Q.popperOptions) != null && we.modifiers && (Ge = Ge.concat(Q.popperOptions.modifiers)), A({}, Q.popperOptions, {
      modifiers: Ge
    });
  }, [He, Q]), _r = A({}, T, {
    isRtl: tt,
    arrow: S,
    disableInteractive: Ue,
    placement: K,
    PopperComponentProp: le,
    touch: Qe.current
  }), qr = DA(_r), Kr = (n = (o = Re.popper) != null ? o : P.Popper) != null ? n : zA, Er = (i = (a = (s = Re.transition) != null ? s : P.Transition) != null ? a : Ne) != null ? i : _i, $r = (c = (d = Re.tooltip) != null ? d : P.Tooltip) != null ? c : BA, Z = (u = (p = Re.arrow) != null ? p : P.Arrow) != null ? u : FA, X = to(Kr, A({}, Q, (h = se.popper) != null ? h : M.popper, {
    className: Y(qr.popper, Q?.className, (f = (m = se.popper) != null ? m : M.popper) == null ? void 0 : f.className)
  }), _r), ae = to(Er, A({}, ke, (g = se.transition) != null ? g : M.transition), _r), Me = to($r, A({}, (b = se.tooltip) != null ? b : M.tooltip, {
    className: Y(qr.tooltip, (x = (v = se.tooltip) != null ? v : M.tooltip) == null ? void 0 : x.className)
  }), _r), ze = to(Z, A({}, (y = se.arrow) != null ? y : M.arrow, {
    className: Y(qr.arrow, (C = (k = se.arrow) != null ? k : M.arrow) == null ? void 0 : C.className)
  }), _r);
  return /* @__PURE__ */ w.jsxs(R.Fragment, {
    children: [/* @__PURE__ */ R.cloneElement(Te, Yt), /* @__PURE__ */ w.jsx(Kr, A({
      as: le ?? Ji,
      placement: K,
      anchorEl: W ? {
        getBoundingClientRect: () => ({
          top: $o.y,
          left: $o.x,
          right: $o.x,
          bottom: $o.y,
          width: 0,
          height: 0
        })
      } : Se,
      popperRef: Mr,
      open: Se ? Ve : !1,
      id: vt,
      transition: !0
    }, Fr, X, {
      popperOptions: Lo,
      children: ({
        TransitionProps: we
      }) => /* @__PURE__ */ w.jsx(Er, A({
        timeout: me.transitions.duration.shorter
      }, we, ae, {
        children: /* @__PURE__ */ w.jsxs($r, A({}, Me, {
          children: [be, S ? /* @__PURE__ */ w.jsx(Z, A({}, ze, {
            ref: _e
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (dg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: l.bool,
  /**
   * Tooltip reference element.
   */
  children: hn.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Arrow: l.elementType,
    Popper: l.elementType,
    Tooltip: l.elementType,
    Transition: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    arrow: l.object,
    popper: l.object,
    tooltip: l.object,
    transition: l.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: l.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: l.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: l.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: l.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: l.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: l.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: l.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: l.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: l.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: l.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: l.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: l.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: l.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: l.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: l.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    arrow: l.object,
    popper: l.object,
    tooltip: l.object,
    transition: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    arrow: l.elementType,
    popper: l.elementType,
    tooltip: l.elementType,
    transition: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: l.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: l.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: l.object
});
function _A(r) {
  return fe("MuiSwitch", r);
}
const Xt = ue("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), $A = ["className", "color", "edge", "size", "sx"], WA = (r) => {
  const {
    classes: e,
    edge: t,
    size: n,
    color: o,
    checked: i,
    disabled: a
  } = r, s = {
    root: ["root", t && `edge${V(t)}`, `size${V(n)}`],
    switchBase: ["switchBase", `color${V(o)}`, i && "checked", a && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, c = he(s, _A, e);
  return A({}, e, c);
}, HA = H("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.edge && e[`edge${V(t.edge)}`], e[`size${V(t.size)}`]];
  }
})({
  display: "inline-flex",
  width: 58,
  height: 38,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${Xt.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${Xt.switchBase}`]: {
        padding: 4,
        [`&.${Xt.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), YA = H(Ts, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.switchBase, {
      [`& .${Xt.input}`]: e.input
    }, t.color !== "default" && e[`color${V(t.color)}`]];
  }
})(({
  theme: r
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: r.vars ? r.vars.palette.Switch.defaultColor : `${r.palette.mode === "light" ? r.palette.common.white : r.palette.grey[300]}`,
  transition: r.transitions.create(["left", "transform"], {
    duration: r.transitions.duration.shortest
  }),
  [`&.${Xt.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${Xt.disabled}`]: {
    color: r.vars ? r.vars.palette.Switch.defaultDisabledColor : `${r.palette.mode === "light" ? r.palette.grey[100] : r.palette.grey[600]}`
  },
  [`&.${Xt.checked} + .${Xt.track}`]: {
    opacity: 0.5
  },
  [`&.${Xt.disabled} + .${Xt.track}`]: {
    opacity: r.vars ? r.vars.opacity.switchTrackDisabled : `${r.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${Xt.input}`]: {
    left: "-100%",
    width: "300%"
  }
}), ({
  theme: r
}) => ({
  "&:hover": {
    backgroundColor: r.vars ? `rgba(${r.vars.palette.action.activeChannel} / ${r.vars.palette.action.hoverOpacity})` : Pe.alpha(r.palette.action.active, r.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(r.palette).filter(([, e]) => e.main && e.light).map(([e]) => ({
    props: {
      color: e
    },
    style: {
      [`&.${Xt.checked}`]: {
        color: (r.vars || r).palette[e].main,
        "&:hover": {
          backgroundColor: r.vars ? `rgba(${r.vars.palette[e].mainChannel} / ${r.vars.palette.action.hoverOpacity})` : Pe.alpha(r.palette[e].main, r.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${Xt.disabled}`]: {
          color: r.vars ? r.vars.palette.Switch[`${e}DisabledColor`] : `${r.palette.mode === "light" ? Pe.lighten(r.palette[e].main, 0.62) : Pe.darken(r.palette[e].main, 0.55)}`
        }
      },
      [`&.${Xt.checked} + .${Xt.track}`]: {
        backgroundColor: (r.vars || r).palette[e].main
      }
    }
  }))]
})), XA = H("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (r, e) => e.track
})(({
  theme: r
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: r.transitions.create(["opacity", "background-color"], {
    duration: r.transitions.duration.shortest
  }),
  backgroundColor: r.vars ? r.vars.palette.common.onBackground : `${r.palette.mode === "light" ? r.palette.common.black : r.palette.common.white}`,
  opacity: r.vars ? r.vars.opacity.switchTrack : `${r.palette.mode === "light" ? 0.38 : 0.3}`
})), VA = H("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (r, e) => e.thumb
})(({
  theme: r
}) => ({
  boxShadow: (r.vars || r).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
})), UA = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiSwitch"
  }), {
    className: o,
    color: i = "primary",
    edge: a = !1,
    size: s = "medium",
    sx: c
  } = n, d = q(n, $A), u = A({}, n, {
    color: i,
    edge: a,
    size: s
  }), p = WA(u), h = /* @__PURE__ */ w.jsx(VA, {
    className: p.thumb,
    ownerState: u
  });
  return /* @__PURE__ */ w.jsxs(HA, {
    className: Y(p.root, o),
    sx: c,
    ownerState: u,
    children: [/* @__PURE__ */ w.jsx(YA, A({
      type: "checkbox",
      icon: h,
      checkedIcon: h,
      ref: t,
      ownerState: u
    }, d, {
      classes: A({}, p, {
        root: p.switchBase
      })
    })), /* @__PURE__ */ w.jsx(XA, {
      className: p.track,
      ownerState: u
    })]
  });
});
process.env.NODE_ENV !== "production" && (UA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: l.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: l.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: l.node,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: $t,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: l.any
});
function GA(r) {
  return fe("MuiTab", r);
}
const Qr = ue("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper"]), qA = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"], KA = (r) => {
  const {
    classes: e,
    textColor: t,
    fullWidth: n,
    wrapped: o,
    icon: i,
    label: a,
    selected: s,
    disabled: c
  } = r, d = {
    root: ["root", i && a && "labelIcon", `textColor${V(t)}`, n && "fullWidth", o && "wrapped", s && "selected", c && "disabled"],
    iconWrapper: ["iconWrapper"]
  };
  return he(d, GA, e);
}, ZA = H(Kt, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.label && t.icon && e.labelIcon, e[`textColor${V(t.textColor)}`], t.fullWidth && e.fullWidth, t.wrapped && e.wrapped, {
      [`& .${Qr.iconWrapper}`]: e.iconWrapper
    }];
  }
})(({
  theme: r,
  ownerState: e
}) => A({}, r.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center"
}, e.label && {
  flexDirection: e.iconPosition === "top" || e.iconPosition === "bottom" ? "column" : "row"
}, {
  lineHeight: 1.25
}, e.icon && e.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${Qr.iconWrapper}`]: A({}, e.iconPosition === "top" && {
    marginBottom: 6
  }, e.iconPosition === "bottom" && {
    marginTop: 6
  }, e.iconPosition === "start" && {
    marginRight: r.spacing(1)
  }, e.iconPosition === "end" && {
    marginLeft: r.spacing(1)
  })
}, e.textColor === "inherit" && {
  color: "inherit",
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${Qr.selected}`]: {
    opacity: 1
  },
  [`&.${Qr.disabled}`]: {
    opacity: (r.vars || r).palette.action.disabledOpacity
  }
}, e.textColor === "primary" && {
  color: (r.vars || r).palette.text.secondary,
  [`&.${Qr.selected}`]: {
    color: (r.vars || r).palette.primary.main
  },
  [`&.${Qr.disabled}`]: {
    color: (r.vars || r).palette.text.disabled
  }
}, e.textColor === "secondary" && {
  color: (r.vars || r).palette.text.secondary,
  [`&.${Qr.selected}`]: {
    color: (r.vars || r).palette.secondary.main
  },
  [`&.${Qr.disabled}`]: {
    color: (r.vars || r).palette.text.disabled
  }
}, e.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: "none"
}, e.wrapped && {
  fontSize: r.typography.pxToRem(12)
})), JA = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTab"
  }), {
    className: o,
    disabled: i = !1,
    disableFocusRipple: a = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: s,
    icon: c,
    iconPosition: d = "top",
    // eslint-disable-next-line react/prop-types
    indicator: u,
    label: p,
    onChange: h,
    onClick: f,
    onFocus: m,
    // eslint-disable-next-line react/prop-types
    selected: g,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: b,
    // eslint-disable-next-line react/prop-types
    textColor: x = "inherit",
    value: v,
    wrapped: y = !1
  } = n, C = q(n, qA), k = A({}, n, {
    disabled: i,
    disableFocusRipple: a,
    selected: g,
    icon: !!c,
    iconPosition: d,
    label: !!p,
    fullWidth: s,
    textColor: x,
    wrapped: y
  }), T = KA(k), S = c && p && /* @__PURE__ */ R.isValidElement(c) ? /* @__PURE__ */ R.cloneElement(c, {
    className: Y(T.iconWrapper, c.props.className)
  }) : c, O = (M) => {
    !g && h && h(M, v), f && f(M);
  }, P = (M) => {
    b && !g && h && h(M, v), m && m(M);
  };
  return /* @__PURE__ */ w.jsxs(ZA, A({
    focusRipple: !a,
    className: Y(T.root, o),
    ref: t,
    role: "tab",
    "aria-selected": g,
    disabled: i,
    onClick: O,
    onFocus: P,
    ownerState: k,
    tabIndex: g ? 0 : -1
  }, C, {
    children: [d === "top" || d === "start" ? /* @__PURE__ */ w.jsxs(R.Fragment, {
      children: [S, p]
    }) : /* @__PURE__ */ w.jsxs(R.Fragment, {
      children: [p, S]
    }), u]
  }));
});
process.env.NODE_ENV !== "production" && (JA.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: Rc,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * The icon to display.
   */
  icon: l.oneOfType([l.element, l.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: l.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: l.node,
  /**
   * @ignore
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: l.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: l.bool
});
const dd = /* @__PURE__ */ R.createContext();
process.env.NODE_ENV !== "production" && (dd.displayName = "TableContext");
function QA(r) {
  return fe("MuiTable", r);
}
ue("MuiTable", ["root", "stickyHeader"]);
const eO = ["className", "component", "padding", "size", "stickyHeader"], tO = (r) => {
  const {
    classes: e,
    stickyHeader: t
  } = r;
  return he({
    root: ["root", t && "stickyHeader"]
  }, QA, e);
}, rO = H("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.stickyHeader && e.stickyHeader];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": A({}, r.typography.body2, {
    padding: r.spacing(2),
    color: (r.vars || r).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  })
}, e.stickyHeader && {
  borderCollapse: "separate"
})), ap = "table", ud = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTable"
  }), {
    className: o,
    component: i = ap,
    padding: a = "normal",
    size: s = "medium",
    stickyHeader: c = !1
  } = n, d = q(n, eO), u = A({}, n, {
    component: i,
    padding: a,
    size: s,
    stickyHeader: c
  }), p = tO(u), h = R.useMemo(() => ({
    padding: a,
    size: s,
    stickyHeader: c
  }), [a, s, c]);
  return /* @__PURE__ */ w.jsx(dd.Provider, {
    value: h,
    children: /* @__PURE__ */ w.jsx(rO, A({
      as: i,
      role: i === ap ? null : "table",
      ref: t,
      className: Y(p.root, o),
      ownerState: u
    }, d))
  });
});
process.env.NODE_ENV !== "production" && (ud.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: l.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */
  stickyHeader: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const Ao = /* @__PURE__ */ R.createContext();
process.env.NODE_ENV !== "production" && (Ao.displayName = "Tablelvl2Context");
function nO(r) {
  return fe("MuiTableBody", r);
}
ue("MuiTableBody", ["root"]);
const oO = ["className", "component"], iO = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, nO, e);
}, aO = H("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({
  display: "table-row-group"
}), sO = {
  variant: "body"
}, sp = "tbody", pd = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTableBody"
  }), {
    className: o,
    component: i = sp
  } = n, a = q(n, oO), s = A({}, n, {
    component: i
  }), c = iO(s);
  return /* @__PURE__ */ w.jsx(Ao.Provider, {
    value: sO,
    children: /* @__PURE__ */ w.jsx(aO, A({
      className: Y(c.root, o),
      as: i,
      ref: t,
      role: i === sp ? null : "rowgroup",
      ownerState: s
    }, a))
  });
});
process.env.NODE_ENV !== "production" && (pd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function lO(r) {
  return fe("MuiTableCell", r);
}
const cO = ue("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), dO = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"], uO = (r) => {
  const {
    classes: e,
    variant: t,
    align: n,
    padding: o,
    size: i,
    stickyHeader: a
  } = r, s = {
    root: ["root", t, a && "stickyHeader", n !== "inherit" && `align${V(n)}`, o !== "normal" && `padding${V(o)}`, `size${V(i)}`]
  };
  return he(s, lO, e);
}, pO = H("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, e[t.variant], e[`size${V(t.size)}`], t.padding !== "normal" && e[`padding${V(t.padding)}`], t.align !== "inherit" && e[`align${V(t.align)}`], t.stickyHeader && e.stickyHeader];
  }
})(({
  theme: r,
  ownerState: e
}) => A({}, r.typography.body2, {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: r.vars ? `1px solid ${r.vars.palette.TableCell.border}` : `1px solid
    ${r.palette.mode === "light" ? Pe.lighten(Pe.alpha(r.palette.divider, 1), 0.88) : Pe.darken(Pe.alpha(r.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16
}, e.variant === "head" && {
  color: (r.vars || r).palette.text.primary,
  lineHeight: r.typography.pxToRem(24),
  fontWeight: r.typography.fontWeightMedium
}, e.variant === "body" && {
  color: (r.vars || r).palette.text.primary
}, e.variant === "footer" && {
  color: (r.vars || r).palette.text.secondary,
  lineHeight: r.typography.pxToRem(21),
  fontSize: r.typography.pxToRem(12)
}, e.size === "small" && {
  padding: "6px 16px",
  [`&.${cO.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: "0 12px 0 16px",
    "& > *": {
      padding: 0
    }
  }
}, e.padding === "checkbox" && {
  width: 48,
  // prevent the checkbox column from growing
  padding: "0 0 0 4px"
}, e.padding === "none" && {
  padding: 0
}, e.align === "left" && {
  textAlign: "left"
}, e.align === "center" && {
  textAlign: "center"
}, e.align === "right" && {
  textAlign: "right",
  flexDirection: "row-reverse"
}, e.align === "justify" && {
  textAlign: "justify"
}, e.stickyHeader && {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: (r.vars || r).palette.background.default
})), Fn = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTableCell"
  }), {
    align: o = "inherit",
    className: i,
    component: a,
    padding: s,
    scope: c,
    size: d,
    sortDirection: u,
    variant: p
  } = n, h = q(n, dO), f = R.useContext(dd), m = R.useContext(Ao), g = m && m.variant === "head";
  let b;
  a ? b = a : b = g ? "th" : "td";
  let x = c;
  b === "td" ? x = void 0 : !x && g && (x = "col");
  const v = p || m && m.variant, y = A({}, n, {
    align: o,
    component: b,
    padding: s || (f && f.padding ? f.padding : "normal"),
    size: d || (f && f.size ? f.size : "medium"),
    sortDirection: u,
    stickyHeader: v === "head" && f && f.stickyHeader,
    variant: v
  }), C = uO(y);
  let k = null;
  return u && (k = u === "asc" ? "ascending" : "descending"), /* @__PURE__ */ w.jsx(pO, A({
    as: b,
    ref: t,
    className: Y(C.root, i),
    "aria-sort": k,
    scope: x,
    ownerState: y
  }, h));
});
process.env.NODE_ENV !== "production" && (Fn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: l.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: l.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: l.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: l.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: l.oneOfType([l.oneOf(["body", "footer", "head"]), l.string])
});
function hO(r) {
  return fe("MuiTableContainer", r);
}
ue("MuiTableContainer", ["root"]);
const fO = ["className", "component"], gO = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, hO, e);
}, mO = H("div", {
  name: "MuiTableContainer",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({
  width: "100%",
  overflowX: "auto"
}), hd = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTableContainer"
  }), {
    className: o,
    component: i = "div"
  } = n, a = q(n, fO), s = A({}, n, {
    component: i
  }), c = gO(s);
  return /* @__PURE__ */ w.jsx(mO, A({
    ref: t,
    as: i,
    className: Y(c.root, o),
    ownerState: s
  }, a));
});
process.env.NODE_ENV !== "production" && (hd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Table`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function bO(r) {
  return fe("MuiTableFooter", r);
}
ue("MuiTableFooter", ["root"]);
const xO = ["className", "component"], vO = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, bO, e);
}, yO = H("tfoot", {
  name: "MuiTableFooter",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({
  display: "table-footer-group"
}), wO = {
  variant: "footer"
}, lp = "tfoot", ug = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTableFooter"
  }), {
    className: o,
    component: i = lp
  } = n, a = q(n, xO), s = A({}, n, {
    component: i
  }), c = vO(s);
  return /* @__PURE__ */ w.jsx(Ao.Provider, {
    value: wO,
    children: /* @__PURE__ */ w.jsx(yO, A({
      as: i,
      className: Y(c.root, o),
      ref: t,
      role: i === lp ? null : "rowgroup",
      ownerState: s
    }, a))
  });
});
process.env.NODE_ENV !== "production" && (ug.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function CO(r) {
  return fe("MuiTableHead", r);
}
ue("MuiTableHead", ["root"]);
const kO = ["className", "component"], SO = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, CO, e);
}, TO = H("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})({
  display: "table-header-group"
}), AO = {
  variant: "head"
}, cp = "thead", fd = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTableHead"
  }), {
    className: o,
    component: i = cp
  } = n, a = q(n, kO), s = A({}, n, {
    component: i
  }), c = SO(s);
  return /* @__PURE__ */ w.jsx(Ao.Provider, {
    value: AO,
    children: /* @__PURE__ */ w.jsx(TO, A({
      as: i,
      className: Y(c.root, o),
      ref: t,
      role: i === cp ? null : "rowgroup",
      ownerState: s
    }, a))
  });
});
process.env.NODE_ENV !== "production" && (fd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function OO(r) {
  return fe("MuiToolbar", r);
}
ue("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const RO = ["className", "component", "disableGutters", "variant"], PO = (r) => {
  const {
    classes: e,
    disableGutters: t,
    variant: n
  } = r;
  return he({
    root: ["root", !t && "gutters", n]
  }, OO, e);
}, MO = H("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, !t.disableGutters && e.gutters, e[t.variant]];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  position: "relative",
  display: "flex",
  alignItems: "center"
}, !e.disableGutters && {
  paddingLeft: r.spacing(2),
  paddingRight: r.spacing(2),
  [r.breakpoints.up("sm")]: {
    paddingLeft: r.spacing(3),
    paddingRight: r.spacing(3)
  }
}, e.variant === "dense" && {
  minHeight: 48
}), ({
  theme: r,
  ownerState: e
}) => e.variant === "regular" && r.mixins.toolbar), pg = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiToolbar"
  }), {
    className: o,
    component: i = "div",
    disableGutters: a = !1,
    variant: s = "regular"
  } = n, c = q(n, RO), d = A({}, n, {
    component: i,
    disableGutters: a,
    variant: s
  }), u = PO(d);
  return /* @__PURE__ */ w.jsx(MO, A({
    as: i,
    className: Y(u.root, o),
    ref: t,
    ownerState: d
  }, c));
});
process.env.NODE_ENV !== "production" && (pg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: l.oneOfType([l.oneOf(["dense", "regular"]), l.string])
});
const hg = At(/* @__PURE__ */ w.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), fg = At(/* @__PURE__ */ w.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight"), EO = ["backIconButtonProps", "count", "disabled", "getItemAriaLabel", "nextIconButtonProps", "onPageChange", "page", "rowsPerPage", "showFirstButton", "showLastButton", "slots", "slotProps"], gg = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o, i, a, s, c, d, u;
  const {
    backIconButtonProps: p,
    count: h,
    disabled: f = !1,
    getItemAriaLabel: m,
    nextIconButtonProps: g,
    onPageChange: b,
    page: x,
    rowsPerPage: v,
    showFirstButton: y,
    showLastButton: C,
    slots: k = {},
    slotProps: T = {}
  } = e, S = q(e, EO), O = gn(), P = (se) => {
    b(se, 0);
  }, M = (se) => {
    b(se, x - 1);
  }, I = (se) => {
    b(se, x + 1);
  }, E = (se) => {
    b(se, Math.max(0, Math.ceil(h / v) - 1));
  }, N = (n = k.firstButton) != null ? n : jt, L = (o = k.lastButton) != null ? o : jt, z = (i = k.nextButton) != null ? i : jt, F = (a = k.previousButton) != null ? a : jt, B = (s = k.firstButtonIcon) != null ? s : Wl, D = (c = k.lastButtonIcon) != null ? c : Hl, W = (d = k.nextButtonIcon) != null ? d : fg, G = (u = k.previousButtonIcon) != null ? u : hg, re = O ? L : N, ce = O ? z : F, Ce = O ? F : z, ne = O ? N : L, pe = O ? T.lastButton : T.firstButton, K = O ? T.nextButton : T.previousButton, le = O ? T.previousButton : T.nextButton, Q = O ? T.firstButton : T.lastButton;
  return /* @__PURE__ */ w.jsxs("div", A({
    ref: t
  }, S, {
    children: [y && /* @__PURE__ */ w.jsx(re, A({
      onClick: P,
      disabled: f || x === 0,
      "aria-label": m("first", x),
      title: m("first", x)
    }, pe, {
      children: O ? /* @__PURE__ */ w.jsx(D, A({}, T.lastButtonIcon)) : /* @__PURE__ */ w.jsx(B, A({}, T.firstButtonIcon))
    })), /* @__PURE__ */ w.jsx(ce, A({
      onClick: M,
      disabled: f || x === 0,
      color: "inherit",
      "aria-label": m("previous", x),
      title: m("previous", x)
    }, K ?? p, {
      children: O ? /* @__PURE__ */ w.jsx(W, A({}, T.nextButtonIcon)) : /* @__PURE__ */ w.jsx(G, A({}, T.previousButtonIcon))
    })), /* @__PURE__ */ w.jsx(Ce, A({
      onClick: I,
      disabled: f || (h !== -1 ? x >= Math.ceil(h / v) - 1 : !1),
      color: "inherit",
      "aria-label": m("next", x),
      title: m("next", x)
    }, le ?? g, {
      children: O ? /* @__PURE__ */ w.jsx(G, A({}, T.previousButtonIcon)) : /* @__PURE__ */ w.jsx(W, A({}, T.nextButtonIcon))
    })), C && /* @__PURE__ */ w.jsx(ne, A({
      onClick: E,
      disabled: f || x >= Math.ceil(h / v) - 1,
      "aria-label": m("last", x),
      title: m("last", x)
    }, Q, {
      children: O ? /* @__PURE__ */ w.jsx(B, A({}, T.firstButtonIcon)) : /* @__PURE__ */ w.jsx(D, A({}, T.lastButtonIcon))
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (gg.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  backIconButtonProps: l.object,
  /**
   * The total number of rows.
   */
  count: l.number.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */
  getItemAriaLabel: l.func.isRequired,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: l.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: l.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: l.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: l.number.isRequired,
  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: l.bool.isRequired,
  /**
   * If `true`, show the last-page button.
   */
  showLastButton: l.bool.isRequired,
  /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */
  slotProps: l.shape({
    firstButton: l.object,
    firstButtonIcon: l.object,
    lastButton: l.object,
    lastButtonIcon: l.object,
    nextButton: l.object,
    nextButtonIcon: l.object,
    previousButton: l.object,
    previousButtonIcon: l.object
  }),
  /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    firstButton: l.elementType,
    firstButtonIcon: l.elementType,
    lastButton: l.elementType,
    lastButtonIcon: l.elementType,
    nextButton: l.elementType,
    nextButtonIcon: l.elementType,
    previousButton: l.elementType,
    previousButtonIcon: l.elementType
  })
});
function IO(r) {
  return fe("MuiTablePagination", r);
}
const Oi = ue("MuiTablePagination", ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]);
var dp;
const NO = ["ActionsComponent", "backIconButtonProps", "className", "colSpan", "component", "count", "disabled", "getItemAriaLabel", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onPageChange", "onRowsPerPageChange", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps", "showFirstButton", "showLastButton", "slotProps", "slots"], LO = H(Fn, {
  name: "MuiTablePagination",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})(({
  theme: r
}) => ({
  overflow: "auto",
  color: (r.vars || r).palette.text.primary,
  fontSize: r.typography.pxToRem(14),
  // Increase the specificity to override TableCell.
  "&:last-child": {
    padding: 0
  }
})), jO = H(pg, {
  name: "MuiTablePagination",
  slot: "Toolbar",
  overridesResolver: (r, e) => A({
    [`& .${Oi.actions}`]: e.actions
  }, e.toolbar)
})(({
  theme: r
}) => ({
  minHeight: 52,
  paddingRight: 2,
  [`${r.breakpoints.up("xs")} and (orientation: landscape)`]: {
    minHeight: 52
  },
  [r.breakpoints.up("sm")]: {
    minHeight: 52,
    paddingRight: 2
  },
  [`& .${Oi.actions}`]: {
    flexShrink: 0,
    marginLeft: 20
  }
})), DO = H("div", {
  name: "MuiTablePagination",
  slot: "Spacer",
  overridesResolver: (r, e) => e.spacer
})({
  flex: "1 1 100%"
}), zO = H("p", {
  name: "MuiTablePagination",
  slot: "SelectLabel",
  overridesResolver: (r, e) => e.selectLabel
})(({
  theme: r
}) => A({}, r.typography.body2, {
  flexShrink: 0
})), BO = H(bo, {
  name: "MuiTablePagination",
  slot: "Select",
  overridesResolver: (r, e) => A({
    [`& .${Oi.selectIcon}`]: e.selectIcon,
    [`& .${Oi.select}`]: e.select
  }, e.input, e.selectRoot)
})({
  color: "inherit",
  fontSize: "inherit",
  flexShrink: 0,
  marginRight: 32,
  marginLeft: 8,
  [`& .${Oi.select}`]: {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: "right",
    textAlignLast: "right"
    // Align <select> on Chrome.
  }
}), FO = H(mo, {
  name: "MuiTablePagination",
  slot: "MenuItem",
  overridesResolver: (r, e) => e.menuItem
})({}), _O = H("p", {
  name: "MuiTablePagination",
  slot: "DisplayedRows",
  overridesResolver: (r, e) => e.displayedRows
})(({
  theme: r
}) => A({}, r.typography.body2, {
  flexShrink: 0
}));
function $O({
  from: r,
  to: e,
  count: t
}) {
  return `${r}–${e} of ${t !== -1 ? t : `more than ${e}`}`;
}
function WO(r) {
  return `Go to ${r} page`;
}
const HO = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"],
    toolbar: ["toolbar"],
    spacer: ["spacer"],
    selectLabel: ["selectLabel"],
    select: ["select"],
    input: ["input"],
    selectIcon: ["selectIcon"],
    menuItem: ["menuItem"],
    displayedRows: ["displayedRows"],
    actions: ["actions"]
  }, IO, e);
}, mg = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n;
  const o = ge({
    props: e,
    name: "MuiTablePagination"
  }), {
    ActionsComponent: i = gg,
    backIconButtonProps: a,
    className: s,
    colSpan: c,
    component: d = Fn,
    count: u,
    disabled: p = !1,
    getItemAriaLabel: h = WO,
    labelDisplayedRows: f = $O,
    labelRowsPerPage: m = "Rows per page:",
    nextIconButtonProps: g,
    onPageChange: b,
    onRowsPerPageChange: x,
    page: v,
    rowsPerPage: y,
    rowsPerPageOptions: C = [10, 25, 50, 100],
    SelectProps: k = {},
    showFirstButton: T = !1,
    showLastButton: S = !1,
    slotProps: O = {},
    slots: P = {}
  } = o, M = q(o, NO), I = o, E = HO(I), N = (n = O?.select) != null ? n : k, L = N.native ? "option" : FO;
  let z;
  (d === Fn || d === "td") && (z = c || 1e3);
  const F = Yr(N.id), B = Yr(N.labelId), D = () => u === -1 ? (v + 1) * y : y === -1 ? u : Math.min(u, (v + 1) * y);
  return /* @__PURE__ */ w.jsx(LO, A({
    colSpan: z,
    ref: t,
    as: d,
    ownerState: I,
    className: Y(E.root, s)
  }, M, {
    children: /* @__PURE__ */ w.jsxs(jO, {
      className: E.toolbar,
      children: [/* @__PURE__ */ w.jsx(DO, {
        className: E.spacer
      }), C.length > 1 && /* @__PURE__ */ w.jsx(zO, {
        className: E.selectLabel,
        id: B,
        children: m
      }), C.length > 1 && /* @__PURE__ */ w.jsx(BO, A({
        variant: "standard"
      }, !N.variant && {
        input: dp || (dp = /* @__PURE__ */ w.jsx(ea, {}))
      }, {
        value: y,
        onChange: x,
        id: F,
        labelId: B
      }, N, {
        classes: A({}, N.classes, {
          // TODO v5 remove `classes.input`
          root: Y(E.input, E.selectRoot, (N.classes || {}).root),
          select: Y(E.select, (N.classes || {}).select),
          // TODO v5 remove `selectIcon`
          icon: Y(E.selectIcon, (N.classes || {}).icon)
        }),
        disabled: p,
        children: C.map((W) => /* @__PURE__ */ vb(L, A({}, !zn(L) && {
          ownerState: I
        }, {
          className: E.menuItem,
          key: W.label ? W.label : W,
          value: W.value ? W.value : W
        }), W.label ? W.label : W))
      })), /* @__PURE__ */ w.jsx(_O, {
        className: E.displayedRows,
        children: f({
          from: u === 0 ? 0 : v * y + 1,
          to: D(),
          count: u === -1 ? -1 : u,
          page: v
        })
      }), /* @__PURE__ */ w.jsx(i, {
        className: E.actions,
        backIconButtonProps: a,
        count: u,
        nextIconButtonProps: g,
        onPageChange: b,
        page: v,
        rowsPerPage: y,
        showFirstButton: T,
        showLastButton: S,
        slotProps: O.actions,
        slots: P.actions,
        getItemAriaLabel: h,
        disabled: p
      })]
    })
  }));
});
process.env.NODE_ENV !== "production" && (mg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */
  ActionsComponent: l.elementType,
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */
  backIconButtonProps: l.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * @ignore
   */
  colSpan: l.number,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: Ut.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: l.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: l.func,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: l.node,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */
  nextIconButtonProps: l.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: l.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: l.func,
  /**
   * The zero-based index of the current page.
   */
  page: Ft(Ut.isRequired, (r) => {
    const {
      count: e,
      page: t,
      rowsPerPage: n
    } = r;
    if (e === -1)
      return null;
    const o = Math.max(0, Math.ceil(e / n) - 1);
    return t < 0 || t > o ? new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${o}, but page is ${t}).`) : null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: Ut.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: l.arrayOf(l.oneOfType([l.number, l.shape({
    label: l.string.isRequired,
    value: l.number.isRequired
  })]).isRequired),
  /**
   * Props applied to the rows per page [`Select`](/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */
  SelectProps: l.object,
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: l.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: l.bool,
  /**
   * The props used for each slot inside the TablePagination.
   * @default {}
   */
  slotProps: l.shape({
    actions: l.shape({
      firstButton: l.object,
      firstButtonIcon: l.object,
      lastButton: l.object,
      lastButtonIcon: l.object,
      nextButton: l.object,
      nextButtonIcon: l.object,
      previousButton: l.object,
      previousButtonIcon: l.object
    }),
    select: l.object
  }),
  /**
   * The components used for each slot inside the TablePagination.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    actions: l.shape({
      firstButton: l.elementType,
      firstButtonIcon: l.elementType,
      lastButton: l.elementType,
      lastButtonIcon: l.elementType,
      nextButton: l.elementType,
      nextButtonIcon: l.elementType,
      previousButton: l.elementType,
      previousButtonIcon: l.elementType
    })
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function YO(r) {
  return fe("MuiTableRow", r);
}
const up = ue("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), XO = ["className", "component", "hover", "selected"], VO = (r) => {
  const {
    classes: e,
    selected: t,
    hover: n,
    head: o,
    footer: i
  } = r;
  return he({
    root: ["root", t && "selected", n && "hover", o && "head", i && "footer"]
  }, YO, e);
}, UO = H("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.head && e.head, t.footer && e.footer];
  }
})(({
  theme: r
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${up.hover}:hover`]: {
    backgroundColor: (r.vars || r).palette.action.hover
  },
  [`&.${up.selected}`]: {
    backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / ${r.vars.palette.action.selectedOpacity})` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: r.vars ? `rgba(${r.vars.palette.primary.mainChannel} / calc(${r.vars.palette.action.selectedOpacity} + ${r.vars.palette.action.hoverOpacity}))` : Pe.alpha(r.palette.primary.main, r.palette.action.selectedOpacity + r.palette.action.hoverOpacity)
    }
  }
})), pp = "tr", xo = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTableRow"
  }), {
    className: o,
    component: i = pp,
    hover: a = !1,
    selected: s = !1
  } = n, c = q(n, XO), d = R.useContext(Ao), u = A({}, n, {
    component: i,
    hover: a,
    selected: s,
    head: d && d.variant === "head",
    footer: d && d.variant === "footer"
  }), p = VO(u);
  return /* @__PURE__ */ w.jsx(UO, A({
    as: i,
    ref: t,
    className: Y(p.root, o),
    role: i === pp ? null : "row",
    ownerState: u
  }, c));
});
process.env.NODE_ENV !== "production" && (xo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: l.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const GO = At(/* @__PURE__ */ w.jsx("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");
function qO(r) {
  return fe("MuiTableSortLabel", r);
}
const Vs = ue("MuiTableSortLabel", ["root", "active", "icon", "iconDirectionDesc", "iconDirectionAsc"]), KO = ["active", "children", "className", "direction", "hideSortIcon", "IconComponent"], ZO = (r) => {
  const {
    classes: e,
    direction: t,
    active: n
  } = r, o = {
    root: ["root", n && "active"],
    icon: ["icon", `iconDirection${V(t)}`]
  };
  return he(o, qO, e);
}, JO = H(Kt, {
  name: "MuiTableSortLabel",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.active && e.active];
  }
})(({
  theme: r
}) => ({
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "flex-start",
  flexDirection: "inherit",
  alignItems: "center",
  "&:focus": {
    color: (r.vars || r).palette.text.secondary
  },
  "&:hover": {
    color: (r.vars || r).palette.text.secondary,
    [`& .${Vs.icon}`]: {
      opacity: 0.5
    }
  },
  [`&.${Vs.active}`]: {
    color: (r.vars || r).palette.text.primary,
    [`& .${Vs.icon}`]: {
      opacity: 1,
      color: (r.vars || r).palette.text.secondary
    }
  }
})), QO = H("span", {
  name: "MuiTableSortLabel",
  slot: "Icon",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.icon, e[`iconDirection${V(t.direction)}`]];
  }
})(({
  theme: r,
  ownerState: e
}) => A({
  fontSize: 18,
  marginRight: 4,
  marginLeft: 4,
  opacity: 0,
  transition: r.transitions.create(["opacity", "transform"], {
    duration: r.transitions.duration.shorter
  }),
  userSelect: "none"
}, e.direction === "desc" && {
  transform: "rotate(0deg)"
}, e.direction === "asc" && {
  transform: "rotate(180deg)"
})), eR = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTableSortLabel"
  }), {
    active: o = !1,
    children: i,
    className: a,
    direction: s = "asc",
    hideSortIcon: c = !1,
    IconComponent: d = GO
  } = n, u = q(n, KO), p = A({}, n, {
    active: o,
    direction: s,
    hideSortIcon: c,
    IconComponent: d
  }), h = ZO(p);
  return /* @__PURE__ */ w.jsxs(JO, A({
    className: Y(h.root, a),
    component: "span",
    disableRipple: !0,
    ownerState: p,
    ref: t
  }, u, {
    children: [i, c && !o ? null : /* @__PURE__ */ w.jsx(QO, {
      as: d,
      className: Y(h.icon),
      ownerState: p
    })]
  }));
});
process.env.NODE_ENV !== "production" && (eR.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */
  active: l.bool,
  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The current sort direction.
   * @default 'asc'
   */
  direction: l.oneOf(["asc", "desc"]),
  /**
   * Hide sort icon when active is false.
   * @default false
   */
  hideSortIcon: l.bool,
  /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */
  IconComponent: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function tR(r) {
  return (1 + Math.sin(Math.PI * r - Math.PI / 2)) / 2;
}
function rR(r, e, t, n = {}, o = () => {
}) {
  const {
    ease: i = tR,
    duration: a = 300
    // standard
  } = n;
  let s = null;
  const c = e[r];
  let d = !1;
  const u = () => {
    d = !0;
  }, p = (h) => {
    if (d) {
      o(new Error("Animation cancelled"));
      return;
    }
    s === null && (s = h);
    const f = Math.min(1, (h - s) / a);
    if (e[r] = i(f) * (t - c) + c, f >= 1) {
      requestAnimationFrame(() => {
        o(null);
      });
      return;
    }
    requestAnimationFrame(p);
  };
  return c === t ? (o(new Error("Element already at target position")), u) : (requestAnimationFrame(p), u);
}
const nR = ["onChange"], oR = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function bg(r) {
  const {
    onChange: e
  } = r, t = q(r, nR), n = R.useRef(), o = R.useRef(null), i = () => {
    n.current = o.current.offsetHeight - o.current.clientHeight;
  };
  return qt(() => {
    const a = So(() => {
      const c = n.current;
      i(), c !== n.current && e(n.current);
    }), s = br(o.current);
    return s.addEventListener("resize", a), () => {
      a.clear(), s.removeEventListener("resize", a);
    };
  }, [e]), R.useEffect(() => {
    i(), e(n.current);
  }, [e]), /* @__PURE__ */ w.jsx("div", A({
    style: oR
  }, t, {
    ref: o
  }));
}
process.env.NODE_ENV !== "production" && (bg.propTypes = {
  onChange: l.func.isRequired
});
function iR(r) {
  return fe("MuiTabScrollButton", r);
}
const aR = ue("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), sR = ["className", "slots", "slotProps", "direction", "orientation", "disabled"], lR = (r) => {
  const {
    classes: e,
    orientation: t,
    disabled: n
  } = r;
  return he({
    root: ["root", t, n && "disabled"]
  }, iR, e);
}, cR = H(Kt, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.root, t.orientation && e[t.orientation]];
  }
})(({
  ownerState: r
}) => A({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${aR.disabled}`]: {
    opacity: 0
  }
}, r.orientation === "vertical" && {
  width: "100%",
  height: 40,
  "& svg": {
    transform: `rotate(${r.isRtl ? -90 : 90}deg)`
  }
})), xg = /* @__PURE__ */ R.forwardRef(function(e, t) {
  var n, o;
  const i = ge({
    props: e,
    name: "MuiTabScrollButton"
  }), {
    className: a,
    slots: s = {},
    slotProps: c = {},
    direction: d
  } = i, u = q(i, sR), p = gn(), h = A({
    isRtl: p
  }, i), f = lR(h), m = (n = s.StartScrollButtonIcon) != null ? n : hg, g = (o = s.EndScrollButtonIcon) != null ? o : fg, b = tr({
    elementType: m,
    externalSlotProps: c.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: h
  }), x = tr({
    elementType: g,
    externalSlotProps: c.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: h
  });
  return /* @__PURE__ */ w.jsx(cR, A({
    component: "div",
    className: Y(f.root, a),
    ref: t,
    role: null,
    ownerState: h,
    tabIndex: null
  }, u, {
    children: d === "left" ? /* @__PURE__ */ w.jsx(m, A({}, b)) : /* @__PURE__ */ w.jsx(g, A({}, x))
  }));
});
process.env.NODE_ENV !== "production" && (xg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The direction the button should indicate.
   */
  direction: l.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: l.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: l.shape({
    endScrollButtonIcon: l.oneOfType([l.func, l.object]),
    startScrollButtonIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    EndScrollButtonIcon: l.elementType,
    StartScrollButtonIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function dR(r) {
  return fe("MuiTabs", r);
}
const Us = ue("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), uR = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "slots", "slotProps", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"], hp = (r, e) => r === e ? r.firstChild : e && e.nextElementSibling ? e.nextElementSibling : r.firstChild, fp = (r, e) => r === e ? r.lastChild : e && e.previousElementSibling ? e.previousElementSibling : r.lastChild, ka = (r, e, t) => {
  let n = !1, o = t(r, e);
  for (; o; ) {
    if (o === r.firstChild) {
      if (n)
        return;
      n = !0;
    }
    const i = o.disabled || o.getAttribute("aria-disabled") === "true";
    if (!o.hasAttribute("tabindex") || i)
      o = t(r, o);
    else {
      o.focus();
      return;
    }
  }
}, pR = (r) => {
  const {
    vertical: e,
    fixed: t,
    hideScrollbar: n,
    scrollableX: o,
    scrollableY: i,
    centered: a,
    scrollButtonsHideMobile: s,
    classes: c
  } = r;
  return he({
    root: ["root", e && "vertical"],
    scroller: ["scroller", t && "fixed", n && "hideScrollbar", o && "scrollableX", i && "scrollableY"],
    flexContainer: ["flexContainer", e && "flexContainerVertical", a && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", s && "scrollButtonsHideMobile"],
    scrollableX: [o && "scrollableX"],
    hideScrollbar: [n && "hideScrollbar"]
  }, dR, c);
}, hR = H("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [{
      [`& .${Us.scrollButtons}`]: e.scrollButtons
    }, {
      [`& .${Us.scrollButtons}`]: t.scrollButtonsHideMobile && e.scrollButtonsHideMobile
    }, e.root, t.vertical && e.vertical];
  }
})(({
  ownerState: r,
  theme: e
}) => A({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex"
}, r.vertical && {
  flexDirection: "column"
}, r.scrollButtonsHideMobile && {
  [`& .${Us.scrollButtons}`]: {
    [e.breakpoints.down("sm")]: {
      display: "none"
    }
  }
})), fR = H("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.scroller, t.fixed && e.fixed, t.hideScrollbar && e.hideScrollbar, t.scrollableX && e.scrollableX, t.scrollableY && e.scrollableY];
  }
})(({
  ownerState: r
}) => A({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap"
}, r.fixed && {
  overflowX: "hidden",
  width: "100%"
}, r.hideScrollbar && {
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}, r.scrollableX && {
  overflowX: "auto",
  overflowY: "hidden"
}, r.scrollableY && {
  overflowY: "auto",
  overflowX: "hidden"
})), gR = H("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (r, e) => {
    const {
      ownerState: t
    } = r;
    return [e.flexContainer, t.vertical && e.flexContainerVertical, t.centered && e.centered];
  }
})(({
  ownerState: r
}) => A({
  display: "flex"
}, r.vertical && {
  flexDirection: "column"
}, r.centered && {
  justifyContent: "center"
})), mR = H("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (r, e) => e.indicator
})(({
  ownerState: r,
  theme: e
}) => A({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: e.transitions.create()
}, r.indicatorColor === "primary" && {
  backgroundColor: (e.vars || e).palette.primary.main
}, r.indicatorColor === "secondary" && {
  backgroundColor: (e.vars || e).palette.secondary.main
}, r.vertical && {
  height: "100%",
  width: 2,
  right: 0
})), bR = H(bg)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), gp = {};
let mp = !1;
const vg = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = ge({
    props: e,
    name: "MuiTabs"
  }), o = yr(), i = gn(), {
    "aria-label": a,
    "aria-labelledby": s,
    action: c,
    centered: d = !1,
    children: u,
    className: p,
    component: h = "div",
    allowScrollButtonsMobile: f = !1,
    indicatorColor: m = "primary",
    onChange: g,
    orientation: b = "horizontal",
    ScrollButtonComponent: x = xg,
    scrollButtons: v = "auto",
    selectionFollowsFocus: y,
    slots: C = {},
    slotProps: k = {},
    TabIndicatorProps: T = {},
    TabScrollButtonProps: S = {},
    textColor: O = "primary",
    value: P,
    variant: M = "standard",
    visibleScrollbar: I = !1
  } = n, E = q(n, uR), N = M === "scrollable", L = b === "vertical", z = L ? "scrollTop" : "scrollLeft", F = L ? "top" : "left", B = L ? "bottom" : "right", D = L ? "clientHeight" : "clientWidth", W = L ? "height" : "width", G = A({}, n, {
    component: h,
    allowScrollButtonsMobile: f,
    indicatorColor: m,
    orientation: b,
    vertical: L,
    scrollButtons: v,
    textColor: O,
    variant: M,
    visibleScrollbar: I,
    fixed: !N,
    hideScrollbar: N && !I,
    scrollableX: N && !L,
    scrollableY: N && L,
    centered: d && !N,
    scrollButtonsHideMobile: !f
  }), re = pR(G), ce = tr({
    elementType: C.StartScrollButtonIcon,
    externalSlotProps: k.startScrollButtonIcon,
    ownerState: G
  }), Ce = tr({
    elementType: C.EndScrollButtonIcon,
    externalSlotProps: k.endScrollButtonIcon,
    ownerState: G
  });
  process.env.NODE_ENV !== "production" && d && N && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [ne, pe] = R.useState(!1), [K, le] = R.useState(gp), [Q, se] = R.useState(!1), [Re, be] = R.useState(!1), [Ne, ke] = R.useState(!1), [Oe, Te] = R.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), me = /* @__PURE__ */ new Map(), tt = R.useRef(null), Se = R.useRef(null), Ke = () => {
    const te = tt.current;
    let _;
    if (te) {
      const oe = te.getBoundingClientRect();
      _ = {
        clientWidth: te.clientWidth,
        scrollLeft: te.scrollLeft,
        scrollTop: te.scrollTop,
        scrollLeftNormalized: lx(te, i ? "rtl" : "ltr"),
        scrollWidth: te.scrollWidth,
        top: oe.top,
        bottom: oe.bottom,
        left: oe.left,
        right: oe.right
      };
    }
    let U;
    if (te && P !== !1) {
      const oe = Se.current.children;
      if (oe.length > 0) {
        const Ae = oe[me.get(P)];
        process.env.NODE_ENV !== "production" && (Ae || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${P}".`, me.keys ? `You can provide one of the following values: ${Array.from(me.keys()).join(", ")}.` : null].join(`
`))), U = Ae ? Ae.getBoundingClientRect() : null, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && !mp && U && U.width === 0 && U.height === 0 && // if the whole Tabs component is hidden, don't warn
        _.clientWidth !== 0 && (_ = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${P}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), mp = !0);
      }
    }
    return {
      tabsMeta: _,
      tabMeta: U
    };
  }, He = Lt(() => {
    const {
      tabsMeta: te,
      tabMeta: _
    } = Ke();
    let U = 0, oe;
    if (L)
      oe = "top", _ && te && (U = _.top - te.top + te.scrollTop);
    else if (oe = i ? "right" : "left", _ && te) {
      const et = i ? te.scrollLeftNormalized + te.clientWidth - te.scrollWidth : te.scrollLeft;
      U = (i ? -1 : 1) * (_[oe] - te[oe] + et);
    }
    const Ae = {
      [oe]: U,
      // May be wrong until the font is loaded.
      [W]: _ ? _[W] : 0
    };
    if (isNaN(K[oe]) || isNaN(K[W]))
      le(Ae);
    else {
      const et = Math.abs(K[oe] - Ae[oe]), st = Math.abs(K[W] - Ae[W]);
      (et >= 1 || st >= 1) && le(Ae);
    }
  }), _e = (te, {
    animation: _ = !0
  } = {}) => {
    _ ? rR(z, tt.current, te, {
      duration: o.transitions.duration.standard
    }) : tt.current[z] = te;
  }, Qe = (te) => {
    let _ = tt.current[z];
    L ? _ += te : (_ += te * (i ? -1 : 1), _ *= i && of() === "reverse" ? -1 : 1), _e(_);
  }, Ue = () => {
    const te = tt.current[D];
    let _ = 0;
    const U = Array.from(Se.current.children);
    for (let oe = 0; oe < U.length; oe += 1) {
      const Ae = U[oe];
      if (_ + Ae[D] > te) {
        oe === 0 && (_ = te);
        break;
      }
      _ += Ae[D];
    }
    return _;
  }, Ye = () => {
    Qe(-1 * Ue());
  }, ht = () => {
    Qe(Ue());
  }, bt = R.useCallback((te) => {
    Te({
      overflow: null,
      scrollbarWidth: te
    });
  }, []), mt = () => {
    const te = {};
    te.scrollbarSizeListener = N ? /* @__PURE__ */ w.jsx(bR, {
      onChange: bt,
      className: Y(re.scrollableX, re.hideScrollbar)
    }) : null;
    const U = N && (v === "auto" && (Q || Re) || v === !0);
    return te.scrollButtonStart = U ? /* @__PURE__ */ w.jsx(x, A({
      slots: {
        StartScrollButtonIcon: C.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: ce
      },
      orientation: b,
      direction: i ? "right" : "left",
      onClick: Ye,
      disabled: !Q
    }, S, {
      className: Y(re.scrollButtons, S.className)
    })) : null, te.scrollButtonEnd = U ? /* @__PURE__ */ w.jsx(x, A({
      slots: {
        EndScrollButtonIcon: C.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: Ce
      },
      orientation: b,
      direction: i ? "left" : "right",
      onClick: ht,
      disabled: !Re
    }, S, {
      className: Y(re.scrollButtons, S.className)
    })) : null, te;
  }, Ie = Lt((te) => {
    const {
      tabsMeta: _,
      tabMeta: U
    } = Ke();
    if (!(!U || !_)) {
      if (U[F] < _[F]) {
        const oe = _[z] + (U[F] - _[F]);
        _e(oe, {
          animation: te
        });
      } else if (U[B] > _[B]) {
        const oe = _[z] + (U[B] - _[B]);
        _e(oe, {
          animation: te
        });
      }
    }
  }), de = Lt(() => {
    N && v !== !1 && ke(!Ne);
  });
  R.useEffect(() => {
    const te = So(() => {
      tt.current && He();
    });
    let _;
    const U = (et) => {
      et.forEach((st) => {
        st.removedNodes.forEach((Et) => {
          var Pt;
          (Pt = _) == null || Pt.unobserve(Et);
        }), st.addedNodes.forEach((Et) => {
          var Pt;
          (Pt = _) == null || Pt.observe(Et);
        });
      }), te(), de();
    }, oe = br(tt.current);
    oe.addEventListener("resize", te);
    let Ae;
    return typeof ResizeObserver < "u" && (_ = new ResizeObserver(te), Array.from(Se.current.children).forEach((et) => {
      _.observe(et);
    })), typeof MutationObserver < "u" && (Ae = new MutationObserver(U), Ae.observe(Se.current, {
      childList: !0
    })), () => {
      var et, st;
      te.clear(), oe.removeEventListener("resize", te), (et = Ae) == null || et.disconnect(), (st = _) == null || st.disconnect();
    };
  }, [He, de]), R.useEffect(() => {
    const te = Array.from(Se.current.children), _ = te.length;
    if (typeof IntersectionObserver < "u" && _ > 0 && N && v !== !1) {
      const U = te[0], oe = te[_ - 1], Ae = {
        root: tt.current,
        threshold: 0.99
      }, et = (kr) => {
        se(!kr[0].isIntersecting);
      }, st = new IntersectionObserver(et, Ae);
      st.observe(U);
      const Et = (kr) => {
        be(!kr[0].isIntersecting);
      }, Pt = new IntersectionObserver(Et, Ae);
      return Pt.observe(oe), () => {
        st.disconnect(), Pt.disconnect();
      };
    }
  }, [N, v, Ne, u?.length]), R.useEffect(() => {
    pe(!0);
  }, []), R.useEffect(() => {
    He();
  }), R.useEffect(() => {
    Ie(gp !== K);
  }, [Ie, K]), R.useImperativeHandle(c, () => ({
    updateIndicator: He,
    updateScrollButtons: de
  }), [He, de]);
  const Ve = /* @__PURE__ */ w.jsx(mR, A({}, T, {
    className: Y(re.indicator, T.className),
    ownerState: G,
    style: A({}, K, T.style)
  }));
  let vt = 0;
  const yt = R.Children.map(u, (te) => {
    if (!/* @__PURE__ */ R.isValidElement(te))
      return null;
    process.env.NODE_ENV !== "production" && wo.isFragment(te) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const _ = te.props.value === void 0 ? vt : te.props.value;
    me.set(_, vt);
    const U = _ === P;
    return vt += 1, /* @__PURE__ */ R.cloneElement(te, A({
      fullWidth: M === "fullWidth",
      indicator: U && !ne && Ve,
      selected: U,
      selectionFollowsFocus: y,
      onChange: g,
      textColor: O,
      value: _
    }, vt === 1 && P === !1 && !te.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  }), Ot = (te) => {
    const _ = Se.current, U = Rt(_).activeElement;
    if (U.getAttribute("role") !== "tab")
      return;
    let Ae = b === "horizontal" ? "ArrowLeft" : "ArrowUp", et = b === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (b === "horizontal" && i && (Ae = "ArrowRight", et = "ArrowLeft"), te.key) {
      case Ae:
        te.preventDefault(), ka(_, U, fp);
        break;
      case et:
        te.preventDefault(), ka(_, U, hp);
        break;
      case "Home":
        te.preventDefault(), ka(_, null, hp);
        break;
      case "End":
        te.preventDefault(), ka(_, null, fp);
        break;
    }
  }, ye = mt();
  return /* @__PURE__ */ w.jsxs(hR, A({
    className: Y(re.root, p),
    ownerState: G,
    ref: t,
    as: h
  }, E, {
    children: [ye.scrollButtonStart, ye.scrollbarSizeListener, /* @__PURE__ */ w.jsxs(fR, {
      className: re.scroller,
      ownerState: G,
      style: {
        overflow: Oe.overflow,
        [L ? `margin${i ? "Left" : "Right"}` : "marginBottom"]: I ? void 0 : -Oe.scrollbarWidth
      },
      ref: tt,
      children: [/* @__PURE__ */ w.jsx(gR, {
        "aria-label": a,
        "aria-labelledby": s,
        "aria-orientation": b === "vertical" ? "vertical" : null,
        className: re.flexContainer,
        ownerState: G,
        onKeyDown: Ot,
        ref: Se,
        role: "tablist",
        children: yt
      }), ne && Ve]
    }), ye.scrollButtonEnd]
  }));
});
process.env.NODE_ENV !== "production" && (vg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: $t,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: l.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": l.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": l.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: l.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: l.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: l.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: l.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: l.shape({
    endScrollButtonIcon: l.oneOfType([l.func, l.object]),
    startScrollButtonIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    EndScrollButtonIcon: l.elementType,
    StartScrollButtonIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: l.object,
  /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: l.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: l.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: l.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: l.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: l.bool
});
const gd = /* @__PURE__ */ R.createContext(null);
process.env.NODE_ENV !== "production" && (gd.displayName = "TabContext");
function xR() {
  const [r, e] = R.useState(null);
  return R.useEffect(() => {
    e(`mui-p-${Math.round(Math.random() * 1e5)}`);
  }, []), r;
}
function vR(r) {
  const {
    children: e,
    value: t
  } = r, n = xR(), o = R.useMemo(() => ({
    idPrefix: n,
    value: t
  }), [n, t]);
  return /* @__PURE__ */ w.jsx(gd.Provider, {
    value: o,
    children: e
  });
}
process.env.NODE_ENV !== "production" && (vR.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * The value of the currently selected `Tab`.
   */
  value: l.oneOfType([l.number, l.string]).isRequired
});
function yg() {
  return R.useContext(gd);
}
function wg(r, e) {
  const {
    idPrefix: t
  } = r;
  return t === null ? null : `${r.idPrefix}-P-${e}`;
}
function Cg(r, e) {
  const {
    idPrefix: t
  } = r;
  return t === null ? null : `${r.idPrefix}-T-${e}`;
}
const yR = ["children"], wR = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const {
    children: n
  } = e, o = q(e, yR), i = yg();
  if (i === null)
    throw new TypeError("No TabContext provided");
  const a = R.Children.map(n, (s) => /* @__PURE__ */ R.isValidElement(s) ? /* @__PURE__ */ R.cloneElement(s, {
    // SOMEDAY: `Tabs` will set those themselves
    "aria-controls": wg(i, s.props.value),
    id: Cg(i, s.props.value)
  }) : null);
  return /* @__PURE__ */ w.jsx(vg, A({}, o, {
    ref: t,
    value: i.value,
    children: a
  }));
});
process.env.NODE_ENV !== "production" && (wR.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A list of `<Tab />` elements.
   */
  children: l.node
});
function CR(r) {
  return fe("MuiTabPanel", r);
}
ue("MuiTabPanel", ["root"]);
const kR = ["children", "className", "value"], SR = (r) => {
  const {
    classes: e
  } = r;
  return he({
    root: ["root"]
  }, CR, e);
}, TR = H("div", {
  name: "MuiTabPanel",
  slot: "Root",
  overridesResolver: (r, e) => e.root
})(({
  theme: r
}) => ({
  padding: r.spacing(3)
})), AR = /* @__PURE__ */ R.forwardRef(function(e, t) {
  const n = jx({
    props: e,
    name: "MuiTabPanel"
  }), {
    children: o,
    className: i,
    value: a
  } = n, s = q(n, kR), c = A({}, n), d = SR(c), u = yg();
  if (u === null)
    throw new TypeError("No TabContext provided");
  const p = wg(u, a), h = Cg(u, a);
  return /* @__PURE__ */ w.jsx(TR, A({
    "aria-labelledby": h,
    className: Y(d.root, i),
    hidden: a !== u.value,
    id: p,
    ref: t,
    role: "tabpanel",
    ownerState: c
  }, s, {
    children: a === u.value && o
  }));
});
process.env.NODE_ENV !== "production" && (AR.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The `value` of the corresponding `Tab`. Must use the index of the `Tab` when
   * no `value` was passed to `Tab`.
   */
  value: l.string.isRequired
});
const OR = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function RR(r = {}) {
  const {
    disableGlobal: e = !1,
    productionPrefix: t = "jss",
    seed: n = ""
  } = r, o = n === "" ? "" : `${n}-`;
  let i = 0;
  const a = () => (i += 1, process.env.NODE_ENV !== "production" && i >= 1e10 && console.warn(["MUI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), i);
  return (s, c) => {
    const d = c.options.name;
    if (d && d.indexOf("Mui") === 0 && !c.options.link && !e) {
      if (OR.indexOf(s.key) !== -1)
        return `Mui-${s.key}`;
      const p = `${o}${d}-${s.key}`;
      return !c.options.theme[uf] || n !== "" ? p : `${p}-${a()}`;
    }
    if (process.env.NODE_ENV === "production")
      return `${o}${t}${a()}`;
    const u = `${s.key}-${a()}`;
    return c.options.classNamePrefix ? `${o}${c.options.classNamePrefix}-${u}` : `${o}${u}`;
  };
}
function wj(r) {
  return r;
}
function PR(r) {
  const {
    theme: e,
    name: t,
    props: n
  } = r;
  if (!e || !e.components || !e.components[t] || !e.components[t].defaultProps)
    return n;
  const o = A({}, n), i = e.components[t].defaultProps;
  let a;
  for (a in i)
    o[a] === void 0 && (o[a] = i[a]);
  return o;
}
var MR = process.env.NODE_ENV === "production";
function Cr(r, e) {
  if (!MR) {
    var t = "Warning: " + e;
    typeof console < "u" && console.warn(t);
    try {
      throw Error(t);
    } catch {
    }
  }
}
var bp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
  return typeof r;
} : function(r) {
  return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, ta = (typeof window > "u" ? "undefined" : bp(window)) === "object" && (typeof document > "u" ? "undefined" : bp(document)) === "object" && document.nodeType === 9;
function ER(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, xx(n.key), n);
  }
}
function kg(r, e, t) {
  return e && ER(r.prototype, e), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
var IR = {}.constructor;
function Yl(r) {
  if (r == null || typeof r != "object") return r;
  if (Array.isArray(r)) return r.map(Yl);
  if (r.constructor !== IR) return r;
  var e = {};
  for (var t in r)
    e[t] = Yl(r[t]);
  return e;
}
function md(r, e, t) {
  r === void 0 && (r = "unnamed");
  var n = t.jss, o = Yl(e), i = n.plugins.onCreateRule(r, o, t);
  return i || (r[0] === "@" && process.env.NODE_ENV !== "production" && Cr(!1, "[JSS] Unknown rule " + r), null);
}
var xp = function(e, t) {
  for (var n = "", o = 0; o < e.length && e[o] !== "!important"; o++)
    n && (n += t), n += e[o];
  return n;
}, Ln = function(e) {
  if (!Array.isArray(e)) return e;
  var t = "";
  if (Array.isArray(e[0]))
    for (var n = 0; n < e.length && e[n] !== "!important"; n++)
      t && (t += ", "), t += xp(e[n], " ");
  else t = xp(e, ", ");
  return e[e.length - 1] === "!important" && (t += " !important"), t;
};
function Oo(r) {
  return r && r.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function Wo(r, e) {
  for (var t = "", n = 0; n < e; n++)
    t += "  ";
  return t + r;
}
function $i(r, e, t) {
  t === void 0 && (t = {});
  var n = "";
  if (!e) return n;
  var o = t, i = o.indent, a = i === void 0 ? 0 : i, s = e.fallbacks;
  t.format === !1 && (a = -1 / 0);
  var c = Oo(t), d = c.linebreak, u = c.space;
  if (r && a++, s)
    if (Array.isArray(s))
      for (var p = 0; p < s.length; p++) {
        var h = s[p];
        for (var f in h) {
          var m = h[f];
          m != null && (n && (n += d), n += Wo(f + ":" + u + Ln(m) + ";", a));
        }
      }
    else
      for (var g in s) {
        var b = s[g];
        b != null && (n && (n += d), n += Wo(g + ":" + u + Ln(b) + ";", a));
      }
  for (var x in e) {
    var v = e[x];
    v != null && x !== "fallbacks" && (n && (n += d), n += Wo(x + ":" + u + Ln(v) + ";", a));
  }
  return !n && !t.allowEmpty || !r ? n : (a--, n && (n = "" + d + n + d), Wo("" + r + u + "{" + n, a) + Wo("}", a));
}
var NR = /([[\].#*$><+~=|^:(),"'`\s])/g, vp = typeof CSS < "u" && CSS.escape, bd = (function(r) {
  return vp ? vp(r) : r.replace(NR, "\\$1");
}), Sg = /* @__PURE__ */ (function() {
  function r(t, n, o) {
    this.type = "style", this.isProcessed = !1;
    var i = o.sheet, a = o.Renderer;
    this.key = t, this.options = o, this.style = n, i ? this.renderer = i.renderer : a && (this.renderer = new a());
  }
  var e = r.prototype;
  return e.prop = function(n, o, i) {
    if (o === void 0) return this.style[n];
    var a = i ? i.force : !1;
    if (!a && this.style[n] === o) return this;
    var s = o;
    (!i || i.process !== !1) && (s = this.options.jss.plugins.onChangeValue(o, n, this));
    var c = s == null || s === !1, d = n in this.style;
    if (c && !d && !a) return this;
    var u = c && d;
    if (u ? delete this.style[n] : this.style[n] = s, this.renderable && this.renderer)
      return u ? this.renderer.removeProperty(this.renderable, n) : this.renderer.setProperty(this.renderable, n, s), this;
    var p = this.options.sheet;
    return p && p.attached && process.env.NODE_ENV !== "production" && Cr(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, r;
})(), Xl = /* @__PURE__ */ (function(r) {
  ms(e, r);
  function e(n, o, i) {
    var a;
    a = r.call(this, n, o, i) || this;
    var s = i.selector, c = i.scoped, d = i.sheet, u = i.generateId;
    return s ? a.selectorText = s : c !== !1 && (a.id = u(jl(jl(a)), d), a.selectorText = "." + bd(a.id)), a;
  }
  var t = e.prototype;
  return t.applyTo = function(o) {
    var i = this.renderer;
    if (i) {
      var a = this.toJSON();
      for (var s in a)
        i.setProperty(o, s, a[s]);
    }
    return this;
  }, t.toJSON = function() {
    var o = {};
    for (var i in this.style) {
      var a = this.style[i];
      typeof a != "object" ? o[i] = a : Array.isArray(a) && (o[i] = Ln(a));
    }
    return o;
  }, t.toString = function(o) {
    var i = this.options.sheet, a = i ? i.options.link : !1, s = a ? A({}, o, {
      allowEmpty: !0
    }) : o;
    return $i(this.selectorText, this.style, s);
  }, kg(e, [{
    key: "selector",
    set: function(o) {
      if (o !== this.selectorText) {
        this.selectorText = o;
        var i = this.renderer, a = this.renderable;
        if (!(!a || !i)) {
          var s = i.setSelector(a, o);
          s || i.replaceRule(a, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), e;
})(Sg), LR = {
  onCreateRule: function(e, t, n) {
    return e[0] === "@" || n.parent && n.parent.type === "keyframes" ? null : new Xl(e, t, n);
  }
}, Gs = {
  indent: 1,
  children: !0
}, jR = /@([\w-]+)/, DR = /* @__PURE__ */ (function() {
  function r(t, n, o) {
    this.type = "conditional", this.isProcessed = !1, this.key = t;
    var i = t.match(jR);
    this.at = i ? i[1] : "unknown", this.query = o.name || "@" + this.at, this.options = o, this.rules = new Ms(A({}, o, {
      parent: this
    }));
    for (var a in n)
      this.rules.add(a, n[a]);
    this.rules.process();
  }
  var e = r.prototype;
  return e.getRule = function(n) {
    return this.rules.get(n);
  }, e.indexOf = function(n) {
    return this.rules.indexOf(n);
  }, e.addRule = function(n, o, i) {
    var a = this.rules.add(n, o, i);
    return a ? (this.options.jss.plugins.onProcessRule(a), a) : null;
  }, e.replaceRule = function(n, o, i) {
    var a = this.rules.replace(n, o, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, e.toString = function(n) {
    n === void 0 && (n = Gs);
    var o = Oo(n), i = o.linebreak;
    if (n.indent == null && (n.indent = Gs.indent), n.children == null && (n.children = Gs.children), n.children === !1)
      return this.query + " {}";
    var a = this.rules.toString(n);
    return a ? this.query + " {" + i + a + i + "}" : "";
  }, r;
})(), zR = /@container|@media|@supports\s+/, BR = {
  onCreateRule: function(e, t, n) {
    return zR.test(e) ? new DR(e, t, n) : null;
  }
}, qs = {
  indent: 1,
  children: !0
}, FR = /@keyframes\s+([\w-]+)/, Vl = /* @__PURE__ */ (function() {
  function r(t, n, o) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var i = t.match(FR);
    i && i[1] ? this.name = i[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && Cr(!1, "[JSS] Bad keyframes name " + t)), this.key = this.type + "-" + this.name, this.options = o;
    var a = o.scoped, s = o.sheet, c = o.generateId;
    this.id = a === !1 ? this.name : bd(c(this, s)), this.rules = new Ms(A({}, o, {
      parent: this
    }));
    for (var d in n)
      this.rules.add(d, n[d], A({}, o, {
        parent: this
      }));
    this.rules.process();
  }
  var e = r.prototype;
  return e.toString = function(n) {
    n === void 0 && (n = qs);
    var o = Oo(n), i = o.linebreak;
    if (n.indent == null && (n.indent = qs.indent), n.children == null && (n.children = qs.children), n.children === !1)
      return this.at + " " + this.id + " {}";
    var a = this.rules.toString(n);
    return a && (a = "" + i + a + i), this.at + " " + this.id + " {" + a + "}";
  }, r;
})(), _R = /@keyframes\s+/, $R = /\$([\w-]+)/g, Ul = function(e, t) {
  return typeof e == "string" ? e.replace($R, function(n, o) {
    return o in t ? t[o] : (process.env.NODE_ENV !== "production" && Cr(!1, '[JSS] Referenced keyframes rule "' + o + '" is not defined.'), n);
  }) : e;
}, yp = function(e, t, n) {
  var o = e[t], i = Ul(o, n);
  i !== o && (e[t] = i);
}, WR = {
  onCreateRule: function(e, t, n) {
    return typeof e == "string" && _R.test(e) ? new Vl(e, t, n) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(e, t, n) {
    return t.type !== "style" || !n || ("animation-name" in e && yp(e, "animation-name", n.keyframes), "animation" in e && yp(e, "animation", n.keyframes)), e;
  },
  onChangeValue: function(e, t, n) {
    var o = n.options.sheet;
    if (!o)
      return e;
    switch (t) {
      case "animation":
        return Ul(e, o.keyframes);
      case "animation-name":
        return Ul(e, o.keyframes);
      default:
        return e;
    }
  }
}, HR = /* @__PURE__ */ (function(r) {
  ms(e, r);
  function e() {
    return r.apply(this, arguments) || this;
  }
  var t = e.prototype;
  return t.toString = function(o) {
    var i = this.options.sheet, a = i ? i.options.link : !1, s = a ? A({}, o, {
      allowEmpty: !0
    }) : o;
    return $i(this.key, this.style, s);
  }, e;
})(Sg), YR = {
  onCreateRule: function(e, t, n) {
    return n.parent && n.parent.type === "keyframes" ? new HR(e, t, n) : null;
  }
}, XR = /* @__PURE__ */ (function() {
  function r(t, n, o) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = t, this.style = n, this.options = o;
  }
  var e = r.prototype;
  return e.toString = function(n) {
    var o = Oo(n), i = o.linebreak;
    if (Array.isArray(this.style)) {
      for (var a = "", s = 0; s < this.style.length; s++)
        a += $i(this.at, this.style[s]), this.style[s + 1] && (a += i);
      return a;
    }
    return $i(this.at, this.style, n);
  }, r;
})(), VR = /@font-face/, UR = {
  onCreateRule: function(e, t, n) {
    return VR.test(e) ? new XR(e, t, n) : null;
  }
}, GR = /* @__PURE__ */ (function() {
  function r(t, n, o) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = t, this.style = n, this.options = o;
  }
  var e = r.prototype;
  return e.toString = function(n) {
    return $i(this.key, this.style, n);
  }, r;
})(), qR = {
  onCreateRule: function(e, t, n) {
    return e === "@viewport" || e === "@-ms-viewport" ? new GR(e, t, n) : null;
  }
}, KR = /* @__PURE__ */ (function() {
  function r(t, n, o) {
    this.type = "simple", this.isProcessed = !1, this.key = t, this.value = n, this.options = o;
  }
  var e = r.prototype;
  return e.toString = function(n) {
    if (Array.isArray(this.value)) {
      for (var o = "", i = 0; i < this.value.length; i++)
        o += this.key + " " + this.value[i] + ";", this.value[i + 1] && (o += `
`);
      return o;
    }
    return this.key + " " + this.value + ";";
  }, r;
})(), ZR = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, JR = {
  onCreateRule: function(e, t, n) {
    return e in ZR ? new KR(e, t, n) : null;
  }
}, wp = [LR, BR, WR, YR, UR, qR, JR], QR = {
  process: !0
}, Cp = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, Ms = /* @__PURE__ */ (function() {
  function r(t) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = t, this.classes = t.classes, this.keyframes = t.keyframes;
  }
  var e = r.prototype;
  return e.add = function(n, o, i) {
    var a = this.options, s = a.parent, c = a.sheet, d = a.jss, u = a.Renderer, p = a.generateId, h = a.scoped, f = A({
      classes: this.classes,
      parent: s,
      sheet: c,
      jss: d,
      Renderer: u,
      generateId: p,
      scoped: h,
      name: n,
      keyframes: this.keyframes,
      selector: void 0
    }, i), m = n;
    n in this.raw && (m = n + "-d" + this.counter++), this.raw[m] = o, m in this.classes && (f.selector = "." + bd(this.classes[m]));
    var g = md(m, o, f);
    if (!g) return null;
    this.register(g);
    var b = f.index === void 0 ? this.index.length : f.index;
    return this.index.splice(b, 0, g), g;
  }, e.replace = function(n, o, i) {
    var a = this.get(n), s = this.index.indexOf(a);
    a && this.remove(a);
    var c = i;
    return s !== -1 && (c = A({}, i, {
      index: s
    })), this.add(n, o, c);
  }, e.get = function(n) {
    return this.map[n];
  }, e.remove = function(n) {
    this.unregister(n), delete this.raw[n.key], this.index.splice(this.index.indexOf(n), 1);
  }, e.indexOf = function(n) {
    return this.index.indexOf(n);
  }, e.process = function() {
    var n = this.options.jss.plugins;
    this.index.slice(0).forEach(n.onProcessRule, n);
  }, e.register = function(n) {
    this.map[n.key] = n, n instanceof Xl ? (this.map[n.selector] = n, n.id && (this.classes[n.key] = n.id)) : n instanceof Vl && this.keyframes && (this.keyframes[n.name] = n.id);
  }, e.unregister = function(n) {
    delete this.map[n.key], n instanceof Xl ? (delete this.map[n.selector], delete this.classes[n.key]) : n instanceof Vl && delete this.keyframes[n.name];
  }, e.update = function() {
    var n, o, i;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (n = arguments.length <= 0 ? void 0 : arguments[0], o = arguments.length <= 1 ? void 0 : arguments[1], i = arguments.length <= 2 ? void 0 : arguments[2]) : (o = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], n = null), n)
      this.updateOne(this.get(n), o, i);
    else
      for (var a = 0; a < this.index.length; a++)
        this.updateOne(this.index[a], o, i);
  }, e.updateOne = function(n, o, i) {
    i === void 0 && (i = QR);
    var a = this.options, s = a.jss.plugins, c = a.sheet;
    if (n.rules instanceof r) {
      n.rules.update(o, i);
      return;
    }
    var d = n.style;
    if (s.onUpdate(o, n, c, i), i.process && d && d !== n.style) {
      s.onProcessStyle(n.style, n, c);
      for (var u in n.style) {
        var p = n.style[u], h = d[u];
        p !== h && n.prop(u, p, Cp);
      }
      for (var f in d) {
        var m = n.style[f], g = d[f];
        m == null && m !== g && n.prop(f, null, Cp);
      }
    }
  }, e.toString = function(n) {
    for (var o = "", i = this.options.sheet, a = i ? i.options.link : !1, s = Oo(n), c = s.linebreak, d = 0; d < this.index.length; d++) {
      var u = this.index[d], p = u.toString(n);
      !p && !a || (o && (o += c), o += p);
    }
    return o;
  }, r;
})(), Tg = /* @__PURE__ */ (function() {
  function r(t, n) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = A({}, n, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), n.Renderer && (this.renderer = new n.Renderer(this)), this.rules = new Ms(this.options);
    for (var o in t)
      this.rules.add(o, t[o]);
    this.rules.process();
  }
  var e = r.prototype;
  return e.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, e.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, e.addRule = function(n, o, i) {
    var a = this.queue;
    this.attached && !a && (this.queue = []);
    var s = this.rules.add(n, o, i);
    return s ? (this.options.jss.plugins.onProcessRule(s), this.attached ? (this.deployed && (a ? a.push(s) : (this.insertRule(s), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), s) : (this.deployed = !1, s)) : null;
  }, e.replaceRule = function(n, o, i) {
    var a = this.rules.get(n);
    if (!a) return this.addRule(n, o, i);
    var s = this.rules.replace(n, o, i);
    return s && this.options.jss.plugins.onProcessRule(s), this.attached ? (this.deployed && this.renderer && (s ? a.renderable && this.renderer.replaceRule(a.renderable, s) : this.renderer.deleteRule(a)), s) : (this.deployed = !1, s);
  }, e.insertRule = function(n) {
    this.renderer && this.renderer.insertRule(n);
  }, e.addRules = function(n, o) {
    var i = [];
    for (var a in n) {
      var s = this.addRule(a, n[a], o);
      s && i.push(s);
    }
    return i;
  }, e.getRule = function(n) {
    return this.rules.get(n);
  }, e.deleteRule = function(n) {
    var o = typeof n == "object" ? n : this.rules.get(n);
    return !o || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !o.renderable ? !1 : (this.rules.remove(o), this.attached && o.renderable && this.renderer ? this.renderer.deleteRule(o.renderable) : !0);
  }, e.indexOf = function(n) {
    return this.rules.indexOf(n);
  }, e.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, e.update = function() {
    var n;
    return (n = this.rules).update.apply(n, arguments), this;
  }, e.updateOne = function(n, o, i) {
    return this.rules.updateOne(n, o, i), this;
  }, e.toString = function(n) {
    return this.rules.toString(n);
  }, r;
})(), eP = /* @__PURE__ */ (function() {
  function r() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var e = r.prototype;
  return e.onCreateRule = function(n, o, i) {
    for (var a = 0; a < this.registry.onCreateRule.length; a++) {
      var s = this.registry.onCreateRule[a](n, o, i);
      if (s) return s;
    }
    return null;
  }, e.onProcessRule = function(n) {
    if (!n.isProcessed) {
      for (var o = n.options.sheet, i = 0; i < this.registry.onProcessRule.length; i++)
        this.registry.onProcessRule[i](n, o);
      n.style && this.onProcessStyle(n.style, n, o), n.isProcessed = !0;
    }
  }, e.onProcessStyle = function(n, o, i) {
    for (var a = 0; a < this.registry.onProcessStyle.length; a++)
      o.style = this.registry.onProcessStyle[a](o.style, o, i);
  }, e.onProcessSheet = function(n) {
    for (var o = 0; o < this.registry.onProcessSheet.length; o++)
      this.registry.onProcessSheet[o](n);
  }, e.onUpdate = function(n, o, i, a) {
    for (var s = 0; s < this.registry.onUpdate.length; s++)
      this.registry.onUpdate[s](n, o, i, a);
  }, e.onChangeValue = function(n, o, i) {
    for (var a = n, s = 0; s < this.registry.onChangeValue.length; s++)
      a = this.registry.onChangeValue[s](a, o, i);
    return a;
  }, e.use = function(n, o) {
    o === void 0 && (o = {
      queue: "external"
    });
    var i = this.plugins[o.queue];
    i.indexOf(n) === -1 && (i.push(n), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(a, s) {
      for (var c in s)
        c in a ? a[c].push(s[c]) : process.env.NODE_ENV !== "production" && Cr(!1, '[JSS] Unknown hook "' + c + '".');
      return a;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, r;
})(), tP = /* @__PURE__ */ (function() {
  function r() {
    this.registry = [];
  }
  var e = r.prototype;
  return e.add = function(n) {
    var o = this.registry, i = n.options.index;
    if (o.indexOf(n) === -1) {
      if (o.length === 0 || i >= this.index) {
        o.push(n);
        return;
      }
      for (var a = 0; a < o.length; a++)
        if (o[a].options.index > i) {
          o.splice(a, 0, n);
          return;
        }
    }
  }, e.reset = function() {
    this.registry = [];
  }, e.remove = function(n) {
    var o = this.registry.indexOf(n);
    this.registry.splice(o, 1);
  }, e.toString = function(n) {
    for (var o = n === void 0 ? {} : n, i = o.attached, a = q(o, ["attached"]), s = Oo(a), c = s.linebreak, d = "", u = 0; u < this.registry.length; u++) {
      var p = this.registry[u];
      i != null && p.attached !== i || (d && (d += c), d += p.toString(a));
    }
    return d;
  }, kg(r, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), r;
})(), Ri = new tP(), Gl = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), ql = "2f1acc6c3a606b082e5eef5e54414ffb";
Gl[ql] == null && (Gl[ql] = 0);
var kp = Gl[ql]++, rP = 1e10, Sp = function(e) {
  e === void 0 && (e = {});
  var t = 0, n = function(i, a) {
    t += 1, t > rP && process.env.NODE_ENV !== "production" && Cr(!1, "[JSS] You might have a memory leak. Rule counter is at " + t + ".");
    var s = "", c = "";
    return a && (a.options.classNamePrefix && (c = a.options.classNamePrefix), a.options.jss.id != null && (s = String(a.options.jss.id))), e.minify ? "" + (c || "c") + kp + s + t : c + i.key + "-" + kp + (s ? "-" + s : "") + "-" + t;
  };
  return n;
}, Ag = function(e) {
  var t;
  return function() {
    return t || (t = e()), t;
  };
}, nP = function(e, t) {
  try {
    return e.attributeStyleMap ? e.attributeStyleMap.get(t) : e.style.getPropertyValue(t);
  } catch {
    return "";
  }
}, oP = function(e, t, n) {
  try {
    var o = n;
    if (Array.isArray(n) && (o = Ln(n)), e.attributeStyleMap)
      e.attributeStyleMap.set(t, o);
    else {
      var i = o ? o.indexOf("!important") : -1, a = i > -1 ? o.substr(0, i - 1) : o;
      e.style.setProperty(t, a, i > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, iP = function(e, t) {
  try {
    e.attributeStyleMap ? e.attributeStyleMap.delete(t) : e.style.removeProperty(t);
  } catch (n) {
    process.env.NODE_ENV !== "production" && Cr(!1, '[JSS] DOMException "' + n.message + '" was thrown. Tried to remove property "' + t + '".');
  }
}, aP = function(e, t) {
  return e.selectorText = t, e.selectorText === t;
}, Og = Ag(function() {
  return document.querySelector("head");
});
function sP(r, e) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    if (n.attached && n.options.index > e.index && n.options.insertionPoint === e.insertionPoint)
      return n;
  }
  return null;
}
function lP(r, e) {
  for (var t = r.length - 1; t >= 0; t--) {
    var n = r[t];
    if (n.attached && n.options.insertionPoint === e.insertionPoint)
      return n;
  }
  return null;
}
function cP(r) {
  for (var e = Og(), t = 0; t < e.childNodes.length; t++) {
    var n = e.childNodes[t];
    if (n.nodeType === 8 && n.nodeValue.trim() === r)
      return n;
  }
  return null;
}
function dP(r) {
  var e = Ri.registry;
  if (e.length > 0) {
    var t = sP(e, r);
    if (t && t.renderer)
      return {
        parent: t.renderer.element.parentNode,
        node: t.renderer.element
      };
    if (t = lP(e, r), t && t.renderer)
      return {
        parent: t.renderer.element.parentNode,
        node: t.renderer.element.nextSibling
      };
  }
  var n = r.insertionPoint;
  if (n && typeof n == "string") {
    var o = cP(n);
    if (o)
      return {
        parent: o.parentNode,
        node: o.nextSibling
      };
    process.env.NODE_ENV !== "production" && Cr(!1, '[JSS] Insertion point "' + n + '" not found.');
  }
  return !1;
}
function uP(r, e) {
  var t = e.insertionPoint, n = dP(e);
  if (n !== !1 && n.parent) {
    n.parent.insertBefore(r, n.node);
    return;
  }
  if (t && typeof t.nodeType == "number") {
    var o = t, i = o.parentNode;
    i ? i.insertBefore(r, o.nextSibling) : process.env.NODE_ENV !== "production" && Cr(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  Og().appendChild(r);
}
var pP = Ag(function() {
  var r = document.querySelector('meta[property="csp-nonce"]');
  return r ? r.getAttribute("content") : null;
}), Tp = function(e, t, n) {
  try {
    "insertRule" in e ? e.insertRule(t, n) : "appendRule" in e && e.appendRule(t);
  } catch (o) {
    return process.env.NODE_ENV !== "production" && Cr(!1, "[JSS] " + o.message), !1;
  }
  return e.cssRules[n];
}, Ap = function(e, t) {
  var n = e.cssRules.length;
  return t === void 0 || t > n ? n : t;
}, hP = function() {
  var e = document.createElement("style");
  return e.textContent = `
`, e;
}, fP = /* @__PURE__ */ (function() {
  function r(t) {
    this.getPropertyValue = nP, this.setProperty = oP, this.removeProperty = iP, this.setSelector = aP, this.hasInsertedRules = !1, this.cssRules = [], t && Ri.add(t), this.sheet = t;
    var n = this.sheet ? this.sheet.options : {}, o = n.media, i = n.meta, a = n.element;
    this.element = a || hP(), this.element.setAttribute("data-jss", ""), o && this.element.setAttribute("media", o), i && this.element.setAttribute("data-meta", i);
    var s = pP();
    s && this.element.setAttribute("nonce", s);
  }
  var e = r.prototype;
  return e.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      uP(this.element, this.sheet.options);
      var n = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && n && (this.hasInsertedRules = !1, this.deploy());
    }
  }, e.detach = function() {
    if (this.sheet) {
      var n = this.element.parentNode;
      n && n.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, e.deploy = function() {
    var n = this.sheet;
    if (n) {
      if (n.options.link) {
        this.insertRules(n.rules);
        return;
      }
      this.element.textContent = `
` + n.toString() + `
`;
    }
  }, e.insertRules = function(n, o) {
    for (var i = 0; i < n.index.length; i++)
      this.insertRule(n.index[i], i, o);
  }, e.insertRule = function(n, o, i) {
    if (i === void 0 && (i = this.element.sheet), n.rules) {
      var a = n, s = i;
      if (n.type === "conditional" || n.type === "keyframes") {
        var c = Ap(i, o);
        if (s = Tp(i, a.toString({
          children: !1
        }), c), s === !1)
          return !1;
        this.refCssRule(n, c, s);
      }
      return this.insertRules(a.rules, s), s;
    }
    var d = n.toString();
    if (!d) return !1;
    var u = Ap(i, o), p = Tp(i, d, u);
    return p === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(n, u, p), p);
  }, e.refCssRule = function(n, o, i) {
    n.renderable = i, n.options.parent instanceof Tg && this.cssRules.splice(o, 0, i);
  }, e.deleteRule = function(n) {
    var o = this.element.sheet, i = this.indexOf(n);
    return i === -1 ? !1 : (o.deleteRule(i), this.cssRules.splice(i, 1), !0);
  }, e.indexOf = function(n) {
    return this.cssRules.indexOf(n);
  }, e.replaceRule = function(n, o) {
    var i = this.indexOf(n);
    return i === -1 ? !1 : (this.element.sheet.deleteRule(i), this.cssRules.splice(i, 1), this.insertRule(o, i));
  }, e.getRules = function() {
    return this.element.sheet.cssRules;
  }, r;
})(), gP = 0, mP = /* @__PURE__ */ (function() {
  function r(t) {
    this.id = gP++, this.version = "10.10.0", this.plugins = new eP(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: Sp,
      Renderer: ta ? fP : null,
      plugins: []
    }, this.generateId = Sp({
      minify: !1
    });
    for (var n = 0; n < wp.length; n++)
      this.plugins.use(wp[n], {
        queue: "internal"
      });
    this.setup(t);
  }
  var e = r.prototype;
  return e.setup = function(n) {
    return n === void 0 && (n = {}), n.createGenerateId && (this.options.createGenerateId = n.createGenerateId), n.id && (this.options.id = A({}, this.options.id, n.id)), (n.createGenerateId || n.id) && (this.generateId = this.options.createGenerateId(this.options.id)), n.insertionPoint != null && (this.options.insertionPoint = n.insertionPoint), "Renderer" in n && (this.options.Renderer = n.Renderer), n.plugins && this.use.apply(this, n.plugins), this;
  }, e.createStyleSheet = function(n, o) {
    o === void 0 && (o = {});
    var i = o, a = i.index;
    typeof a != "number" && (a = Ri.index === 0 ? 0 : Ri.index + 1);
    var s = new Tg(n, A({}, o, {
      jss: this,
      generateId: o.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: a
    }));
    return this.plugins.onProcessSheet(s), s;
  }, e.removeStyleSheet = function(n) {
    return n.detach(), Ri.remove(n), this;
  }, e.createRule = function(n, o, i) {
    if (o === void 0 && (o = {}), i === void 0 && (i = {}), typeof n == "object")
      return this.createRule(void 0, n, o);
    var a = A({}, i, {
      name: n,
      jss: this,
      Renderer: this.options.Renderer
    });
    a.generateId || (a.generateId = this.generateId), a.classes || (a.classes = {}), a.keyframes || (a.keyframes = {});
    var s = md(n, o, a);
    return s && this.plugins.onProcessRule(s), s;
  }, e.use = function() {
    for (var n = this, o = arguments.length, i = new Array(o), a = 0; a < o; a++)
      i[a] = arguments[a];
    return i.forEach(function(s) {
      n.plugins.use(s);
    }), this;
  }, r;
})(), xd = function(e) {
  return new mP(e);
}, vd = typeof CSS == "object" && CSS != null && "number" in CSS;
function Rg(r) {
  var e = null;
  for (var t in r) {
    var n = r[t], o = typeof n;
    if (o === "function")
      e || (e = {}), e[t] = n;
    else if (o === "object" && n !== null && !Array.isArray(n)) {
      var i = Rg(n);
      i && (e || (e = {}), e[t] = i);
    }
  }
  return e;
}
xd();
var Pg = Date.now(), Ks = "fnValues" + Pg, Zs = "fnStyle" + ++Pg, bP = function() {
  return {
    onCreateRule: function(t, n, o) {
      if (typeof n != "function") return null;
      var i = md(t, {}, o);
      return i[Zs] = n, i;
    },
    onProcessStyle: function(t, n) {
      if (Ks in n || Zs in n) return t;
      var o = {};
      for (var i in t) {
        var a = t[i];
        typeof a == "function" && (delete t[i], o[i] = a);
      }
      return n[Ks] = o, t;
    },
    onUpdate: function(t, n, o, i) {
      var a = n, s = a[Zs];
      if (s && (a.style = s(t) || {}, process.env.NODE_ENV === "development")) {
        for (var c in a.style)
          if (typeof a.style[c] == "function") {
            process.env.NODE_ENV !== "production" && Cr(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var d = a[Ks];
      if (d)
        for (var u in d)
          a.prop(u, d[u](t), i);
    }
  };
}, an = "@global", Kl = "@global ", xP = /* @__PURE__ */ (function() {
  function r(t, n, o) {
    this.type = "global", this.at = an, this.isProcessed = !1, this.key = t, this.options = o, this.rules = new Ms(A({}, o, {
      parent: this
    }));
    for (var i in n)
      this.rules.add(i, n[i]);
    this.rules.process();
  }
  var e = r.prototype;
  return e.getRule = function(n) {
    return this.rules.get(n);
  }, e.addRule = function(n, o, i) {
    var a = this.rules.add(n, o, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, e.replaceRule = function(n, o, i) {
    var a = this.rules.replace(n, o, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, e.indexOf = function(n) {
    return this.rules.indexOf(n);
  }, e.toString = function(n) {
    return this.rules.toString(n);
  }, r;
})(), vP = /* @__PURE__ */ (function() {
  function r(t, n, o) {
    this.type = "global", this.at = an, this.isProcessed = !1, this.key = t, this.options = o;
    var i = t.substr(Kl.length);
    this.rule = o.jss.createRule(i, n, A({}, o, {
      parent: this
    }));
  }
  var e = r.prototype;
  return e.toString = function(n) {
    return this.rule ? this.rule.toString(n) : "";
  }, r;
})(), yP = /\s*,\s*/g;
function Mg(r, e) {
  for (var t = r.split(yP), n = "", o = 0; o < t.length; o++)
    n += e + " " + t[o].trim(), t[o + 1] && (n += ", ");
  return n;
}
function wP(r, e) {
  var t = r.options, n = r.style, o = n ? n[an] : null;
  if (o) {
    for (var i in o)
      e.addRule(i, o[i], A({}, t, {
        selector: Mg(i, r.selector)
      }));
    delete n[an];
  }
}
function CP(r, e) {
  var t = r.options, n = r.style;
  for (var o in n)
    if (!(o[0] !== "@" || o.substr(0, an.length) !== an)) {
      var i = Mg(o.substr(an.length), r.selector);
      e.addRule(i, n[o], A({}, t, {
        selector: i
      })), delete n[o];
    }
}
function kP() {
  function r(t, n, o) {
    if (!t) return null;
    if (t === an)
      return new xP(t, n, o);
    if (t[0] === "@" && t.substr(0, Kl.length) === Kl)
      return new vP(t, n, o);
    var i = o.parent;
    return i && (i.type === "global" || i.options.parent && i.options.parent.type === "global") && (o.scoped = !1), !o.selector && o.scoped === !1 && (o.selector = t), null;
  }
  function e(t, n) {
    t.type !== "style" || !n || (wP(t, n), CP(t, n));
  }
  return {
    onCreateRule: r,
    onProcessRule: e
  };
}
var Op = /\s*,\s*/g, SP = /&/g, TP = /\$([\w-]+)/g;
function AP() {
  function r(o, i) {
    return function(a, s) {
      var c = o.getRule(s) || i && i.getRule(s);
      return c ? c.selector : (process.env.NODE_ENV !== "production" && Cr(!1, '[JSS] Could not find the referenced rule "' + s + '" in "' + (o.options.meta || o.toString()) + '".'), s);
    };
  }
  function e(o, i) {
    for (var a = i.split(Op), s = o.split(Op), c = "", d = 0; d < a.length; d++)
      for (var u = a[d], p = 0; p < s.length; p++) {
        var h = s[p];
        c && (c += ", "), c += h.indexOf("&") !== -1 ? h.replace(SP, u) : u + " " + h;
      }
    return c;
  }
  function t(o, i, a) {
    if (a) return A({}, a, {
      index: a.index + 1
    });
    var s = o.options.nestingLevel;
    s = s === void 0 ? 1 : s + 1;
    var c = A({}, o.options, {
      nestingLevel: s,
      index: i.indexOf(o) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete c.name, c;
  }
  function n(o, i, a) {
    if (i.type !== "style") return o;
    var s = i, c = s.options.parent, d, u;
    for (var p in o) {
      var h = p.indexOf("&") !== -1, f = p[0] === "@";
      if (!(!h && !f)) {
        if (d = t(s, c, d), h) {
          var m = e(p, s.selector);
          u || (u = r(c, a)), m = m.replace(TP, u);
          var g = s.key + "-" + p;
          "replaceRule" in c ? c.replaceRule(g, o[p], A({}, d, {
            selector: m
          })) : c.addRule(g, o[p], A({}, d, {
            selector: m
          }));
        } else f && c.addRule(p, {}, d).addRule(s.key, o[p], {
          selector: s.selector
        });
        delete o[p];
      }
    }
    return o;
  }
  return {
    onProcessStyle: n
  };
}
var OP = /[A-Z]/g, RP = /^ms-/, Js = {};
function PP(r) {
  return "-" + r.toLowerCase();
}
function Eg(r) {
  if (Js.hasOwnProperty(r))
    return Js[r];
  var e = r.replace(OP, PP);
  return Js[r] = RP.test(e) ? "-" + e : e;
}
function Qa(r) {
  var e = {};
  for (var t in r) {
    var n = t.indexOf("--") === 0 ? t : Eg(t);
    e[n] = r[t];
  }
  return r.fallbacks && (Array.isArray(r.fallbacks) ? e.fallbacks = r.fallbacks.map(Qa) : e.fallbacks = Qa(r.fallbacks)), e;
}
function MP() {
  function r(t) {
    if (Array.isArray(t)) {
      for (var n = 0; n < t.length; n++)
        t[n] = Qa(t[n]);
      return t;
    }
    return Qa(t);
  }
  function e(t, n, o) {
    if (n.indexOf("--") === 0)
      return t;
    var i = Eg(n);
    return n === i ? t : (o.prop(i, t), null);
  }
  return {
    onProcessStyle: r,
    onChangeValue: e
  };
}
var J = vd && CSS ? CSS.px : "px", Sa = vd && CSS ? CSS.ms : "ms", Un = vd && CSS ? CSS.percent : "%", EP = {
  // Animation properties
  "animation-delay": Sa,
  "animation-duration": Sa,
  // Background properties
  "background-position": J,
  "background-position-x": J,
  "background-position-y": J,
  "background-size": J,
  // Border Properties
  border: J,
  "border-bottom": J,
  "border-bottom-left-radius": J,
  "border-bottom-right-radius": J,
  "border-bottom-width": J,
  "border-left": J,
  "border-left-width": J,
  "border-radius": J,
  "border-right": J,
  "border-right-width": J,
  "border-top": J,
  "border-top-left-radius": J,
  "border-top-right-radius": J,
  "border-top-width": J,
  "border-width": J,
  "border-block": J,
  "border-block-end": J,
  "border-block-end-width": J,
  "border-block-start": J,
  "border-block-start-width": J,
  "border-block-width": J,
  "border-inline": J,
  "border-inline-end": J,
  "border-inline-end-width": J,
  "border-inline-start": J,
  "border-inline-start-width": J,
  "border-inline-width": J,
  "border-start-start-radius": J,
  "border-start-end-radius": J,
  "border-end-start-radius": J,
  "border-end-end-radius": J,
  // Margin properties
  margin: J,
  "margin-bottom": J,
  "margin-left": J,
  "margin-right": J,
  "margin-top": J,
  "margin-block": J,
  "margin-block-end": J,
  "margin-block-start": J,
  "margin-inline": J,
  "margin-inline-end": J,
  "margin-inline-start": J,
  // Padding properties
  padding: J,
  "padding-bottom": J,
  "padding-left": J,
  "padding-right": J,
  "padding-top": J,
  "padding-block": J,
  "padding-block-end": J,
  "padding-block-start": J,
  "padding-inline": J,
  "padding-inline-end": J,
  "padding-inline-start": J,
  // Mask properties
  "mask-position-x": J,
  "mask-position-y": J,
  "mask-size": J,
  // Width and height properties
  height: J,
  width: J,
  "min-height": J,
  "max-height": J,
  "min-width": J,
  "max-width": J,
  // Position properties
  bottom: J,
  left: J,
  top: J,
  right: J,
  inset: J,
  "inset-block": J,
  "inset-block-end": J,
  "inset-block-start": J,
  "inset-inline": J,
  "inset-inline-end": J,
  "inset-inline-start": J,
  // Shadow properties
  "box-shadow": J,
  "text-shadow": J,
  // Column properties
  "column-gap": J,
  "column-rule": J,
  "column-rule-width": J,
  "column-width": J,
  // Font and text properties
  "font-size": J,
  "font-size-delta": J,
  "letter-spacing": J,
  "text-decoration-thickness": J,
  "text-indent": J,
  "text-stroke": J,
  "text-stroke-width": J,
  "word-spacing": J,
  // Motion properties
  motion: J,
  "motion-offset": J,
  // Outline properties
  outline: J,
  "outline-offset": J,
  "outline-width": J,
  // Perspective properties
  perspective: J,
  "perspective-origin-x": Un,
  "perspective-origin-y": Un,
  // Transform properties
  "transform-origin": Un,
  "transform-origin-x": Un,
  "transform-origin-y": Un,
  "transform-origin-z": Un,
  // Transition properties
  "transition-delay": Sa,
  "transition-duration": Sa,
  // Alignment properties
  "vertical-align": J,
  "flex-basis": J,
  // Some random properties
  "shape-margin": J,
  size: J,
  gap: J,
  // Grid properties
  grid: J,
  "grid-gap": J,
  "row-gap": J,
  "grid-row-gap": J,
  "grid-column-gap": J,
  "grid-template-rows": J,
  "grid-template-columns": J,
  "grid-auto-rows": J,
  "grid-auto-columns": J,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": J,
  "box-shadow-y": J,
  "box-shadow-blur": J,
  "box-shadow-spread": J,
  "font-line-height": J,
  "text-shadow-x": J,
  "text-shadow-y": J,
  "text-shadow-blur": J
};
function Ig(r) {
  var e = /(-[a-z])/g, t = function(a) {
    return a[1].toUpperCase();
  }, n = {};
  for (var o in r)
    n[o] = r[o], n[o.replace(e, t)] = r[o];
  return n;
}
var IP = Ig(EP);
function Pi(r, e, t) {
  if (e == null) return e;
  if (Array.isArray(e))
    for (var n = 0; n < e.length; n++)
      e[n] = Pi(r, e[n], t);
  else if (typeof e == "object")
    if (r === "fallbacks")
      for (var o in e)
        e[o] = Pi(o, e[o], t);
    else
      for (var i in e)
        e[i] = Pi(r + "-" + i, e[i], t);
  else if (typeof e == "number" && isNaN(e) === !1) {
    var a = t[r] || IP[r];
    return a && !(e === 0 && a === J) ? typeof a == "function" ? a(e).toString() : "" + e + a : e.toString();
  }
  return e;
}
function NP(r) {
  r === void 0 && (r = {});
  var e = Ig(r);
  function t(o, i) {
    if (i.type !== "style") return o;
    for (var a in o)
      o[a] = Pi(a, o[a], e);
    return o;
  }
  function n(o, i) {
    return Pi(i, o, e);
  }
  return {
    onProcessStyle: t,
    onChangeValue: n
  };
}
function Zl(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = Array(e); t < e; t++) n[t] = r[t];
  return n;
}
function LP(r) {
  if (Array.isArray(r)) return Zl(r);
}
function jP(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
}
function DP(r, e) {
  if (r) {
    if (typeof r == "string") return Zl(r, e);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Zl(r, e) : void 0;
  }
}
function zP() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BP(r) {
  return LP(r) || jP(r) || DP(r) || zP();
}
var xi = "", Jl = "", Ng = "", Lg = "", FP = ta && "ontouchstart" in document.documentElement;
if (ta) {
  var Qs = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, _P = document.createElement("p"), el = _P.style, $P = "Transform";
  for (var tl in Qs)
    if (tl + $P in el) {
      xi = tl, Jl = Qs[tl];
      break;
    }
  xi === "Webkit" && "msHyphens" in el && (xi = "ms", Jl = Qs.ms, Lg = "edge"), xi === "Webkit" && "-apple-trailing-word" in el && (Ng = "apple");
}
var Fe = {
  js: xi,
  css: Jl,
  vendor: Ng,
  browser: Lg,
  isTouch: FP
};
function WP(r) {
  return r[1] === "-" || Fe.js === "ms" ? r : "@" + Fe.css + "keyframes" + r.substr(10);
}
var HP = {
  noPrefill: ["appearance"],
  supportedProperty: function(e) {
    return e !== "appearance" ? !1 : Fe.js === "ms" ? "-webkit-" + e : Fe.css + e;
  }
}, YP = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(e) {
    return e !== "color-adjust" ? !1 : Fe.js === "Webkit" ? Fe.css + "print-" + e : e;
  }
}, XP = /[-\s]+(.)?/g;
function VP(r, e) {
  return e ? e.toUpperCase() : "";
}
function yd(r) {
  return r.replace(XP, VP);
}
function cn(r) {
  return yd("-" + r);
}
var UP = {
  noPrefill: ["mask"],
  supportedProperty: function(e, t) {
    if (!/^mask/.test(e)) return !1;
    if (Fe.js === "Webkit") {
      var n = "mask-image";
      if (yd(n) in t)
        return e;
      if (Fe.js + cn(n) in t)
        return Fe.css + e;
    }
    return e;
  }
}, GP = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(e) {
    return e !== "text-orientation" ? !1 : Fe.vendor === "apple" && !Fe.isTouch ? Fe.css + e : e;
  }
}, qP = {
  noPrefill: ["transform"],
  supportedProperty: function(e, t, n) {
    return e !== "transform" ? !1 : n.transform ? e : Fe.css + e;
  }
}, KP = {
  noPrefill: ["transition"],
  supportedProperty: function(e, t, n) {
    return e !== "transition" ? !1 : n.transition ? e : Fe.css + e;
  }
}, ZP = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(e) {
    return e !== "writing-mode" ? !1 : Fe.js === "Webkit" || Fe.js === "ms" && Fe.browser !== "edge" ? Fe.css + e : e;
  }
}, JP = {
  noPrefill: ["user-select"],
  supportedProperty: function(e) {
    return e !== "user-select" ? !1 : Fe.js === "Moz" || Fe.js === "ms" || Fe.vendor === "apple" ? Fe.css + e : e;
  }
}, QP = {
  supportedProperty: function(e, t) {
    if (!/^break-/.test(e)) return !1;
    if (Fe.js === "Webkit") {
      var n = "WebkitColumn" + cn(e);
      return n in t ? Fe.css + "column-" + e : !1;
    }
    if (Fe.js === "Moz") {
      var o = "page" + cn(e);
      return o in t ? "page-" + e : !1;
    }
    return !1;
  }
}, eM = {
  supportedProperty: function(e, t) {
    if (!/^(border|margin|padding)-inline/.test(e)) return !1;
    if (Fe.js === "Moz") return e;
    var n = e.replace("-inline", "");
    return Fe.js + cn(n) in t ? Fe.css + n : !1;
  }
}, tM = {
  supportedProperty: function(e, t) {
    return yd(e) in t ? e : !1;
  }
}, rM = {
  supportedProperty: function(e, t) {
    var n = cn(e);
    return e[0] === "-" || e[0] === "-" && e[1] === "-" ? e : Fe.js + n in t ? Fe.css + e : Fe.js !== "Webkit" && "Webkit" + n in t ? "-webkit-" + e : !1;
  }
}, nM = {
  supportedProperty: function(e) {
    return e.substring(0, 11) !== "scroll-snap" ? !1 : Fe.js === "ms" ? "" + Fe.css + e : e;
  }
}, oM = {
  supportedProperty: function(e) {
    return e !== "overscroll-behavior" ? !1 : Fe.js === "ms" ? Fe.css + "scroll-chaining" : e;
  }
}, iM = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, aM = {
  supportedProperty: function(e, t) {
    var n = iM[e];
    return n && Fe.js + cn(n) in t ? Fe.css + n : !1;
  }
}, jg = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, sM = Object.keys(jg), lM = function(e) {
  return Fe.css + e;
}, cM = {
  supportedProperty: function(e, t, n) {
    var o = n.multiple;
    if (sM.indexOf(e) > -1) {
      var i = jg[e];
      if (!Array.isArray(i))
        return Fe.js + cn(i) in t ? Fe.css + i : !1;
      if (!o) return !1;
      for (var a = 0; a < i.length; a++)
        if (!(Fe.js + cn(i[0]) in t))
          return !1;
      return i.map(lM);
    }
    return !1;
  }
}, Dg = [HP, YP, UP, GP, qP, KP, ZP, JP, QP, eM, tM, rM, nM, oM, aM, cM], Rp = Dg.filter(function(r) {
  return r.supportedProperty;
}).map(function(r) {
  return r.supportedProperty;
}), dM = Dg.filter(function(r) {
  return r.noPrefill;
}).reduce(function(r, e) {
  return r.push.apply(r, BP(e.noPrefill)), r;
}, []), vi, Tn = {};
if (ta) {
  vi = document.createElement("p");
  var rl = window.getComputedStyle(document.documentElement, "");
  for (var nl in rl)
    isNaN(nl) || (Tn[rl[nl]] = rl[nl]);
  dM.forEach(function(r) {
    return delete Tn[r];
  });
}
function Ql(r, e) {
  if (e === void 0 && (e = {}), !vi) return r;
  if (process.env.NODE_ENV !== "benchmark" && Tn[r] != null)
    return Tn[r];
  (r === "transition" || r === "transform") && (e[r] = r in vi.style);
  for (var t = 0; t < Rp.length && (Tn[r] = Rp[t](r, vi.style, e), !Tn[r]); t++)
    ;
  try {
    vi.style[r] = "";
  } catch {
    return !1;
  }
  return Tn[r];
}
var Gn = {}, uM = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, pM = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, tn;
function hM(r, e, t) {
  if (e === "var") return "var";
  if (e === "all") return "all";
  if (t === "all") return ", all";
  var n = e ? Ql(e) : ", " + Ql(t);
  return n || e || t;
}
ta && (tn = document.createElement("p"));
function Pp(r, e) {
  var t = e;
  if (!tn || r === "content") return e;
  if (typeof t != "string" || !isNaN(parseInt(t, 10)))
    return t;
  var n = r + t;
  if (process.env.NODE_ENV !== "benchmark" && Gn[n] != null)
    return Gn[n];
  try {
    tn.style[r] = t;
  } catch {
    return Gn[n] = !1, !1;
  }
  if (uM[r])
    t = t.replace(pM, hM);
  else if (tn.style[r] === "" && (t = Fe.css + t, t === "-ms-flex" && (tn.style[r] = "-ms-flexbox"), tn.style[r] = t, tn.style[r] === ""))
    return Gn[n] = !1, !1;
  return tn.style[r] = "", Gn[n] = t, Gn[n];
}
function fM() {
  function r(o) {
    if (o.type === "keyframes") {
      var i = o;
      i.at = WP(i.at);
    }
  }
  function e(o) {
    for (var i in o) {
      var a = o[i];
      if (i === "fallbacks" && Array.isArray(a)) {
        o[i] = a.map(e);
        continue;
      }
      var s = !1, c = Ql(i);
      c && c !== i && (s = !0);
      var d = !1, u = Pp(c, Ln(a));
      u && u !== a && (d = !0), (s || d) && (s && delete o[i], o[c || i] = u || a);
    }
    return o;
  }
  function t(o, i) {
    return i.type !== "style" ? o : e(o);
  }
  function n(o, i) {
    return Pp(i, Ln(o)) || o;
  }
  return {
    onProcessRule: r,
    onProcessStyle: t,
    onChangeValue: n
  };
}
function gM() {
  var r = function(t, n) {
    return t.length === n.length ? t > n ? 1 : -1 : t.length - n.length;
  };
  return {
    onProcessStyle: function(t, n) {
      if (n.type !== "style") return t;
      for (var o = {}, i = Object.keys(t).sort(r), a = 0; a < i.length; a++)
        o[i[a]] = t[i[a]];
      return o;
    }
  };
}
function zg() {
  return {
    plugins: [
      bP(),
      kP(),
      AP(),
      MP(),
      NP(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window > "u" ? null : fM(),
      gM()
    ]
  };
}
function Bg(r = {}) {
  const {
    baseClasses: e,
    newClasses: t,
    Component: n
  } = r;
  if (!t)
    return e;
  const o = A({}, e);
  return process.env.NODE_ENV !== "production" && typeof t == "string" ? (console.error([`MUI: The value \`${t}\` provided to the classes prop of ${io(n)} is incorrect.`, "You might want to use the className prop instead."].join(`
`)), e) : (Object.keys(t).forEach((i) => {
    process.env.NODE_ENV !== "production" && (!e[i] && t[i] && console.error([`MUI: The key \`${i}\` provided to the classes prop is not implemented in ${io(n)}.`, `You can only override one of the following: ${Object.keys(e).join(",")}.`].join(`
`)), t[i] && typeof t[i] != "string" && console.error([`MUI: The key \`${i}\` provided to the classes prop is not valid for ${io(n)}.`, `You need to provide a non empty string instead of: ${t[i]}.`].join(`
`))), t[i] && (o[i] = `${e[i]} ${t[i]}`);
  }), o);
}
const no = {
  set: (r, e, t, n) => {
    let o = r.get(e);
    o || (o = /* @__PURE__ */ new Map(), r.set(e, o)), o.set(t, n);
  },
  get: (r, e, t) => {
    const n = r.get(e);
    return n ? n.get(t) : void 0;
  },
  delete: (r, e, t) => {
    r.get(e).delete(t);
  }
};
function Fg() {
  var r;
  const e = Ec();
  return (r = e?.$$material) != null ? r : e;
}
const mM = ["children", "injectFirst", "disableGeneration"], bM = xd(zg()), xM = RR(), vM = /* @__PURE__ */ new Map(), yM = {
  disableGeneration: !1,
  generateClassName: xM,
  jss: bM,
  sheetsCache: null,
  sheetsManager: vM,
  sheetsRegistry: null
}, es = /* @__PURE__ */ R.createContext(yM);
process.env.NODE_ENV !== "production" && (es.displayName = "StylesContext");
let Ta;
function ts(r) {
  const {
    children: e,
    injectFirst: t = !1,
    disableGeneration: n = !1
  } = r, o = q(r, mM), i = R.useContext(es), {
    generateClassName: a,
    jss: s,
    serverGenerateClassName: c,
    sheetsCache: d,
    sheetsManager: u,
    sheetsRegistry: p
  } = A({}, i, o);
  process.env.NODE_ENV !== "production" && t && o.jss && console.error("MUI: You cannot use the jss and injectFirst props at the same time.");
  const h = R.useMemo(() => {
    const f = {
      disableGeneration: n,
      generateClassName: a,
      jss: s,
      serverGenerateClassName: c,
      sheetsCache: d,
      sheetsManager: u,
      sheetsRegistry: p
    };
    if (process.env.NODE_ENV !== "production" && typeof window > "u" && !f.sheetsManager && console.error("MUI: You need to use the ServerStyleSheets API when rendering on the server."), process.env.NODE_ENV !== "production" && f.jss.options.insertionPoint && t && console.error("MUI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), !f.jss.options.insertionPoint && t && typeof window < "u") {
      if (!Ta) {
        const m = document.head;
        Ta = document.createComment("mui-inject-first"), m.insertBefore(Ta, m.firstChild);
      }
      f.jss = xd({
        plugins: zg().plugins,
        insertionPoint: Ta
      });
    }
    return f;
  }, [t, n, a, s, c, d, u, p]);
  return /* @__PURE__ */ w.jsx(es.Provider, {
    value: h,
    children: e
  });
}
process.env.NODE_ENV !== "production" && (ts.propTypes = {
  /**
   * Your component tree.
   */
  children: l.node,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: l.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: l.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: l.bool,
  /**
   * JSS's instance.
   */
  jss: l.object,
  /**
   * @ignore
   */
  serverGenerateClassName: l.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: l.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: l.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: l.object
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (ts.propTypes = ko(ts.propTypes));
let ol = -1e9;
function wM() {
  return ol += 1, process.env.NODE_ENV !== "production" && ol >= 0 && console.warn(["MUI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join(`
`)), ol;
}
const CM = ["variant"];
function Mp(r) {
  return r.length === 0;
}
function kM(r) {
  const {
    variant: e
  } = r, t = q(r, CM);
  let n = e || "";
  return Object.keys(t).sort().forEach((o) => {
    o === "color" ? n += Mp(n) ? r[o] : V(r[o]) : n += `${Mp(n) ? o : V(o)}${V(r[o].toString())}`;
  }), n;
}
const _g = {};
function SM(r) {
  const e = typeof r == "function";
  return process.env.NODE_ENV !== "production" && typeof r != "object" && !e && console.error(["MUI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join(`
`)), {
    create: (t, n) => {
      let o;
      try {
        o = e ? r(t) : r;
      } catch (c) {
        throw process.env.NODE_ENV !== "production" && e === !0 && t === _g && console.error(["MUI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`)), c;
      }
      if (!n || !t.components || !t.components[n] || !t.components[n].styleOverrides && !t.components[n].variants)
        return o;
      const i = t.components[n].styleOverrides || {}, a = t.components[n].variants || [], s = A({}, o);
      return Object.keys(i).forEach((c) => {
        process.env.NODE_ENV !== "production" && (s[c] || console.warn(["MUI: You are trying to override a style that does not exist.", `Fix the \`${c}\` key of \`theme.components.${n}.styleOverrides\`.`, "", `If you intentionally wanted to add a new key, please use the theme.components[${n}].variants option.`].join(`
`))), s[c] = co(s[c] || {}, i[c]);
      }), a.forEach((c) => {
        const d = kM(c.props);
        s[d] = co(s[d] || {}, c.style);
      }), s;
    },
    options: {}
  };
}
const TM = ["name", "classNamePrefix", "Component", "defaultTheme"];
function AM({
  state: r,
  stylesOptions: e
}, t, n) {
  if (e.disableGeneration)
    return t || {};
  r.cacheClasses || (r.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  let o = !1;
  return r.classes !== r.cacheClasses.lastJSS && (r.cacheClasses.lastJSS = r.classes, o = !0), t !== r.cacheClasses.lastProp && (r.cacheClasses.lastProp = t, o = !0), o && (r.cacheClasses.value = Bg({
    baseClasses: r.cacheClasses.lastJSS,
    newClasses: t,
    Component: n
  })), r.cacheClasses.value;
}
function OM({
  state: r,
  theme: e,
  stylesOptions: t,
  stylesCreator: n,
  name: o
}, i) {
  if (t.disableGeneration)
    return;
  let a = no.get(t.sheetsManager, n, e);
  a || (a = {
    refs: 0,
    staticSheet: null,
    dynamicStyles: null
  }, no.set(t.sheetsManager, n, e, a));
  const s = A({}, n.options, t, {
    theme: e,
    flip: typeof t.flip == "boolean" ? t.flip : e.direction === "rtl"
  });
  s.generateId = s.serverGenerateClassName || s.generateClassName;
  const c = t.sheetsRegistry;
  if (a.refs === 0) {
    let d;
    t.sheetsCache && (d = no.get(t.sheetsCache, n, e));
    const u = n.create(e, o);
    d || (d = t.jss.createStyleSheet(u, A({
      link: !1
    }, s)), d.attach(), t.sheetsCache && no.set(t.sheetsCache, n, e, d)), c && c.add(d), a.staticSheet = d, a.dynamicStyles = Rg(u);
  }
  if (a.dynamicStyles) {
    const d = t.jss.createStyleSheet(a.dynamicStyles, A({
      link: !0
    }, s));
    d.update(i), d.attach(), r.dynamicSheet = d, r.classes = Bg({
      baseClasses: a.staticSheet.classes,
      newClasses: d.classes
    }), c && c.add(d);
  } else
    r.classes = a.staticSheet.classes;
  a.refs += 1;
}
function RM({
  state: r
}, e) {
  r.dynamicSheet && r.dynamicSheet.update(e);
}
function PM({
  state: r,
  theme: e,
  stylesOptions: t,
  stylesCreator: n
}) {
  if (t.disableGeneration)
    return;
  const o = no.get(t.sheetsManager, n, e);
  o.refs -= 1;
  const i = t.sheetsRegistry;
  o.refs === 0 && (no.delete(t.sheetsManager, n, e), t.jss.removeStyleSheet(o.staticSheet), i && i.remove(o.staticSheet)), r.dynamicSheet && (t.jss.removeStyleSheet(r.dynamicSheet), i && i.remove(r.dynamicSheet));
}
function MM(r, e) {
  const t = R.useRef([]);
  let n;
  const o = R.useMemo(() => ({}), e);
  t.current !== o && (t.current = o, n = r()), R.useEffect(
    () => () => {
      n && n();
    },
    [o]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function je(r, e = {}) {
  const {
    // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name: t,
    // Help with debuggability.
    classNamePrefix: n,
    Component: o,
    defaultTheme: i = _g
  } = e, a = q(e, TM), s = SM(r), c = t || n || "makeStyles";
  return s.options = {
    index: wM(),
    name: t,
    meta: c,
    classNamePrefix: c
  }, (u = {}) => {
    const p = Fg() || i, h = A({}, R.useContext(es), a), f = R.useRef(), m = R.useRef();
    MM(() => {
      const b = {
        name: t,
        state: {},
        stylesCreator: s,
        stylesOptions: h,
        theme: p
      };
      return OM(b, u), m.current = !1, f.current = b, () => {
        PM(b);
      };
    }, [p, s]), R.useEffect(() => {
      m.current && RM(f.current, u), m.current = !0;
    });
    const g = AM(f.current, u.classes, o);
    return process.env.NODE_ENV !== "production" && R.useDebugValue(g), process.env.NODE_ENV !== "production" && t && ["MuiAvatar", "MuiBadge", "MuiButton", "MuiButtonGroup", "MuiChip", "MuiDivider", "MuiFab", "MuiPaper", "MuiToolbar", "MuiTypography", "MuiAlert", "MuiPagination", "MuiPaginationItem", "MuiSkeleton", "MuiTimelineDot"].indexOf(t) >= 0 && u.variant && !g[u.variant] && console.error([`MUI: You are using a variant value \`${u.variant}\` for which you didn't define styles.`, "Please create a new variant matcher in your theme for this variant. To learn more about matchers visit https://mui.com/r/custom-component-variants."].join(`
`)), g;
  };
}
const EM = ["defaultTheme", "withTheme", "name"], IM = ["classes"], $g = (r, e = {}) => (t) => {
  const {
    defaultTheme: n,
    withTheme: o = !1,
    name: i
  } = e, a = q(e, EM);
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join(`
`));
  let s = i;
  if (process.env.NODE_ENV !== "production" && !i) {
    const u = io(t);
    u !== void 0 && (s = u);
  }
  const c = je(r, A({
    defaultTheme: n,
    Component: t,
    name: i || t.displayName,
    classNamePrefix: s
  }, a)), d = /* @__PURE__ */ R.forwardRef(function(p, h) {
    const f = q(p, IM), m = c(A({}, t.defaultProps, p));
    let g, b = f;
    return (typeof i == "string" || o) && (g = Fg() || n, i && (b = PR({
      theme: g,
      name: i,
      props: f
    })), o && !b.theme && (b.theme = g)), /* @__PURE__ */ w.jsx(t, A({
      ref: h,
      classes: m
    }, b));
  });
  return process.env.NODE_ENV !== "production" && (d.propTypes = {
    /**
     * Override or extend the styles applied to the component.
     */
    classes: l.object
  }), process.env.NODE_ENV !== "production" && (d.displayName = `WithStyles(${io(t)})`), gb(d, t), process.env.NODE_ENV !== "production" && (d.Naked = t, d.options = e, d.useStyles = c), d;
}, Ep = ({
  color: r = "primary",
  disabled: e = !1,
  completed: t = !1,
  size: n = 18,
  children: o
}) => {
  const i = NM({
    disabled: e,
    completed: t,
    color: r,
    size: n
  });
  return /* @__PURE__ */ w.jsx(at, { className: i.badge, children: o });
}, NM = je(
  (r) => ({
    badge: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: ({ size: e }) => `${e}px`,
      height: ({ size: e }) => `${e}px`,
      color: r.palette.common.white,
      fontSize: ({ size: e }) => `${e}px`,
      borderRadius: "50%",
      backgroundColor: (e) => e.disabled ? r.palette.text.disabled : e.completed ? r.palette.success.main : r.palette[e.color].main
    }
  })
);
var Ho = {}, il = {};
const LM = /* @__PURE__ */ mb(Fx);
var Ip;
function kt() {
  return Ip || (Ip = 1, (function(r) {
    "use client";
    Object.defineProperty(r, "__esModule", {
      value: !0
    }), Object.defineProperty(r, "default", {
      enumerable: !0,
      get: function() {
        return e.createSvgIcon;
      }
    });
    var e = LM;
  })(il)), il;
}
var Np;
function jM() {
  if (Np) return Ho;
  Np = 1;
  var r = wt();
  Object.defineProperty(Ho, "__esModule", {
    value: !0
  }), Ho.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return Ho.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
  }), "Check"), Ho;
}
var DM = /* @__PURE__ */ jM();
const Wg = /* @__PURE__ */ gt(DM), Cj = ({
  badge: r,
  disabled: e = !1,
  completed: t = !1,
  width: n = "300px",
  color: o = "primary",
  children: i
}) => {
  const a = zM({ disabled: e, completed: t, color: o });
  return /* @__PURE__ */ w.jsxs(
    at,
    {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      width: n,
      className: a.container,
      children: [
        t ? /* @__PURE__ */ w.jsx(Ep, { completed: t, children: /* @__PURE__ */ w.jsx(Wg, {}) }) : /* @__PURE__ */ w.jsx(Ep, { color: o, disabled: e, children: r }),
        /* @__PURE__ */ w.jsx(We, { variant: "h4", className: a.badgedTitle, children: i })
      ]
    }
  );
}, zM = je(
  (r) => ({
    container: {
      borderBottom: (e) => `4px solid ${e.disabled ? r.palette.text.disabled : r.palette[e.color].main}`
    },
    badgedTitle: {
      marginTop: 2,
      marginLeft: 3,
      color: (e) => e.disabled || e.completed ? r.palette.text.disabled : r.palette[e.color].main
    }
  })
);
var Yo = {}, Lp;
function BM() {
  if (Lp) return Yo;
  Lp = 1;
  var r = wt();
  Object.defineProperty(Yo, "__esModule", {
    value: !0
  }), Yo.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return Yo.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), "Clear"), Yo;
}
var FM = /* @__PURE__ */ BM();
const Hg = /* @__PURE__ */ gt(FM), kj = (r) => {
  const e = _M({ selected: r.selected });
  return /* @__PURE__ */ w.jsx(
    ys,
    {
      deleteIcon: /* @__PURE__ */ w.jsx(Hg, {}),
      ...r,
      classes: {
        root: e.root,
        label: e.label,
        deleteIcon: e.deleteIcon
      }
    }
  );
}, _M = je(
  (r) => ({
    root: {
      padding: "4px 24px",
      height: "25px",
      fontSize: "0.875rem",
      borderRadius: "4px",
      color: ({ selected: e }) => e ? r.palette.common.white : r.palette.grey[900],
      background: ({ selected: e }) => e ? r.palette.primary.main : r.palette.grey[400],
      "&:hover": {
        "& .MuiChip-deleteIcon": {
          display: "block"
        },
        background: ({ selected: e }) => e ? r.palette.primary[800] : r.palette.primary[400]
      }
    },
    label: {
      paddingRight: "16px"
    },
    deleteIcon: {
      display: "none",
      width: "12px",
      height: "12px",
      margin: 0,
      marginLeft: "-12px",
      color: ({ selected: e }) => e ? r.palette.common.white : r.palette.grey[900],
      "&:hover": {
        color: ({ selected: e }) => e ? r.palette.common.white : r.palette.grey[900]
      }
    }
  })
), $M = ({
  className: r,
  onClick: e
}) => /* @__PURE__ */ w.jsxs(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    onClick: e,
    children: [
      /* @__PURE__ */ w.jsx(
        "path",
        {
          d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
          stroke: "currentColor",
          strokeMiterlimit: "10"
        }
      ),
      /* @__PURE__ */ w.jsx(
        "path",
        {
          d: "M10 6L6 10",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ w.jsx(
        "path",
        {
          d: "M10 10L6 6",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), WM = ({
  className: r,
  onClick: e
}) => /* @__PURE__ */ w.jsxs(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    onClick: e,
    children: [
      /* @__PURE__ */ w.jsx(
        "path",
        {
          d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
          fill: "#CACBCE"
        }
      ),
      /* @__PURE__ */ w.jsx(
        "path",
        {
          d: "M10 6L6 10",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ w.jsx(
        "path",
        {
          d: "M10 10L6 6",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), Yg = ({
  children: r,
  deletable: e,
  className: t,
  onDelete: n,
  size: o = "medium",
  variant: i = "filled",
  selected: a,
  onClick: s,
  onDoubleClick: c,
  dataTestId: d,
  color: u = "default",
  ...p
}) => {
  const h = i === "filled" ? WM : $M, [f, m] = R.useState(!1), g = e && f, b = u.charAt(0).toUpperCase() + u.slice(1), x = `MuiChip-${i}Color${b}`, v = (C) => {
    m(!0), p.onMouseEnter && p.onMouseEnter(C);
  }, y = (C) => {
    m(!1), p.onMouseLeave && p.onMouseLeave(C);
  };
  return /* @__PURE__ */ w.jsx(
    ys,
    {
      ...p,
      size: o,
      label: r,
      onClick: s,
      color: u,
      "data-testid": d,
      onMouseEnter: v,
      onMouseLeave: y,
      variant: i,
      onDoubleClick: c,
      deleteIcon: /* @__PURE__ */ w.jsx(h, {}),
      onDelete: g ? n : void 0,
      className: Y({ selected: a }, x, t)
    }
  );
};
var Xo = {}, jp;
function HM() {
  if (jp) return Xo;
  jp = 1;
  var r = wt();
  Object.defineProperty(Xo, "__esModule", {
    value: !0
  }), Xo.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return Xo.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), "Close"), Xo;
}
var YM = /* @__PURE__ */ HM();
const XM = /* @__PURE__ */ gt(YM);
var Vo = {}, Dp;
function VM() {
  if (Dp) return Vo;
  Dp = 1;
  var r = wt();
  Object.defineProperty(Vo, "__esModule", {
    value: !0
  }), Vo.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return Vo.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
  }), "Delete"), Vo;
}
var UM = /* @__PURE__ */ VM();
const GM = /* @__PURE__ */ gt(UM);
var Uo = {}, zp;
function qM() {
  if (zp) return Uo;
  zp = 1;
  var r = wt();
  Object.defineProperty(Uo, "__esModule", {
    value: !0
  }), Uo.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return Uo.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
  }), "Edit"), Uo;
}
var KM = /* @__PURE__ */ qM();
const ZM = /* @__PURE__ */ gt(KM);
var Go = {}, Bp;
function JM() {
  if (Bp) return Go;
  Bp = 1;
  var r = wt();
  Object.defineProperty(Go, "__esModule", {
    value: !0
  }), Go.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return Go.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
  }), "ExpandLess"), Go;
}
var QM = /* @__PURE__ */ JM();
const eE = /* @__PURE__ */ gt(QM);
var qo = {}, Fp;
function tE() {
  if (Fp) return qo;
  Fp = 1;
  var r = wt();
  Object.defineProperty(qo, "__esModule", {
    value: !0
  }), qo.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return qo.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
  }), "ExpandMore"), qo;
}
var rE = /* @__PURE__ */ tE();
const nE = /* @__PURE__ */ gt(rE);
var al, _p;
function oE() {
  if (_p) return al;
  _p = 1;
  var r = "Expected a function", e = "__lodash_hash_undefined__", t = "[object Function]", n = "[object GeneratorFunction]", o = "[object Symbol]", i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, a = /^\w*$/, s = /^\./, c = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, d = /[\\^$.*+?()[\]{}|]/g, u = /\\(\\)?/g, p = /^\[object .+?Constructor\]$/, h = typeof ua == "object" && ua && ua.Object === Object && ua, f = typeof self == "object" && self && self.Object === Object && self, m = h || f || Function("return this")();
  function g(_, U) {
    return _?.[U];
  }
  function b(_) {
    var U = !1;
    if (_ != null && typeof _.toString != "function")
      try {
        U = !!(_ + "");
      } catch {
      }
    return U;
  }
  var x = Array.prototype, v = Function.prototype, y = Object.prototype, C = m["__core-js_shared__"], k = (function() {
    var _ = /[^.]+$/.exec(C && C.keys && C.keys.IE_PROTO || "");
    return _ ? "Symbol(src)_1." + _ : "";
  })(), T = v.toString, S = y.hasOwnProperty, O = y.toString, P = RegExp(
    "^" + T.call(S).replace(d, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), M = m.Symbol, I = x.splice, E = He(m, "Map"), N = He(Object, "create"), L = M ? M.prototype : void 0, z = L ? L.toString : void 0;
  function F(_) {
    var U = -1, oe = _ ? _.length : 0;
    for (this.clear(); ++U < oe; ) {
      var Ae = _[U];
      this.set(Ae[0], Ae[1]);
    }
  }
  function B() {
    this.__data__ = N ? N(null) : {};
  }
  function D(_) {
    return this.has(_) && delete this.__data__[_];
  }
  function W(_) {
    var U = this.__data__;
    if (N) {
      var oe = U[_];
      return oe === e ? void 0 : oe;
    }
    return S.call(U, _) ? U[_] : void 0;
  }
  function G(_) {
    var U = this.__data__;
    return N ? U[_] !== void 0 : S.call(U, _);
  }
  function re(_, U) {
    var oe = this.__data__;
    return oe[_] = N && U === void 0 ? e : U, this;
  }
  F.prototype.clear = B, F.prototype.delete = D, F.prototype.get = W, F.prototype.has = G, F.prototype.set = re;
  function ce(_) {
    var U = -1, oe = _ ? _.length : 0;
    for (this.clear(); ++U < oe; ) {
      var Ae = _[U];
      this.set(Ae[0], Ae[1]);
    }
  }
  function Ce() {
    this.__data__ = [];
  }
  function ne(_) {
    var U = this.__data__, oe = Oe(U, _);
    if (oe < 0)
      return !1;
    var Ae = U.length - 1;
    return oe == Ae ? U.pop() : I.call(U, oe, 1), !0;
  }
  function pe(_) {
    var U = this.__data__, oe = Oe(U, _);
    return oe < 0 ? void 0 : U[oe][1];
  }
  function K(_) {
    return Oe(this.__data__, _) > -1;
  }
  function le(_, U) {
    var oe = this.__data__, Ae = Oe(oe, _);
    return Ae < 0 ? oe.push([_, U]) : oe[Ae][1] = U, this;
  }
  ce.prototype.clear = Ce, ce.prototype.delete = ne, ce.prototype.get = pe, ce.prototype.has = K, ce.prototype.set = le;
  function Q(_) {
    var U = -1, oe = _ ? _.length : 0;
    for (this.clear(); ++U < oe; ) {
      var Ae = _[U];
      this.set(Ae[0], Ae[1]);
    }
  }
  function se() {
    this.__data__ = {
      hash: new F(),
      map: new (E || ce)(),
      string: new F()
    };
  }
  function Re(_) {
    return Ke(this, _).delete(_);
  }
  function be(_) {
    return Ke(this, _).get(_);
  }
  function Ne(_) {
    return Ke(this, _).has(_);
  }
  function ke(_, U) {
    return Ke(this, _).set(_, U), this;
  }
  Q.prototype.clear = se, Q.prototype.delete = Re, Q.prototype.get = be, Q.prototype.has = Ne, Q.prototype.set = ke;
  function Oe(_, U) {
    for (var oe = _.length; oe--; )
      if (Ie(_[oe][0], U))
        return oe;
    return -1;
  }
  function Te(_, U) {
    U = _e(U, _) ? [U] : Se(U);
    for (var oe = 0, Ae = U.length; _ != null && oe < Ae; )
      _ = _[ht(U[oe++])];
    return oe && oe == Ae ? _ : void 0;
  }
  function me(_) {
    if (!vt(_) || Ue(_))
      return !1;
    var U = Ve(_) || b(_) ? P : p;
    return U.test(bt(_));
  }
  function tt(_) {
    if (typeof _ == "string")
      return _;
    if (Ot(_))
      return z ? z.call(_) : "";
    var U = _ + "";
    return U == "0" && 1 / _ == -1 / 0 ? "-0" : U;
  }
  function Se(_) {
    return de(_) ? _ : Ye(_);
  }
  function Ke(_, U) {
    var oe = _.__data__;
    return Qe(U) ? oe[typeof U == "string" ? "string" : "hash"] : oe.map;
  }
  function He(_, U) {
    var oe = g(_, U);
    return me(oe) ? oe : void 0;
  }
  function _e(_, U) {
    if (de(_))
      return !1;
    var oe = typeof _;
    return oe == "number" || oe == "symbol" || oe == "boolean" || _ == null || Ot(_) ? !0 : a.test(_) || !i.test(_) || U != null && _ in Object(U);
  }
  function Qe(_) {
    var U = typeof _;
    return U == "string" || U == "number" || U == "symbol" || U == "boolean" ? _ !== "__proto__" : _ === null;
  }
  function Ue(_) {
    return !!k && k in _;
  }
  var Ye = mt(function(_) {
    _ = ye(_);
    var U = [];
    return s.test(_) && U.push(""), _.replace(c, function(oe, Ae, et, st) {
      U.push(et ? st.replace(u, "$1") : Ae || oe);
    }), U;
  });
  function ht(_) {
    if (typeof _ == "string" || Ot(_))
      return _;
    var U = _ + "";
    return U == "0" && 1 / _ == -1 / 0 ? "-0" : U;
  }
  function bt(_) {
    if (_ != null) {
      try {
        return T.call(_);
      } catch {
      }
      try {
        return _ + "";
      } catch {
      }
    }
    return "";
  }
  function mt(_, U) {
    if (typeof _ != "function" || U && typeof U != "function")
      throw new TypeError(r);
    var oe = function() {
      var Ae = arguments, et = U ? U.apply(this, Ae) : Ae[0], st = oe.cache;
      if (st.has(et))
        return st.get(et);
      var Et = _.apply(this, Ae);
      return oe.cache = st.set(et, Et), Et;
    };
    return oe.cache = new (mt.Cache || Q)(), oe;
  }
  mt.Cache = Q;
  function Ie(_, U) {
    return _ === U || _ !== _ && U !== U;
  }
  var de = Array.isArray;
  function Ve(_) {
    var U = vt(_) ? O.call(_) : "";
    return U == t || U == n;
  }
  function vt(_) {
    var U = typeof _;
    return !!_ && (U == "object" || U == "function");
  }
  function yt(_) {
    return !!_ && typeof _ == "object";
  }
  function Ot(_) {
    return typeof _ == "symbol" || yt(_) && O.call(_) == o;
  }
  function ye(_) {
    return _ == null ? "" : tt(_);
  }
  function te(_, U, oe) {
    var Ae = _ == null ? void 0 : Te(_, U);
    return Ae === void 0 ? oe : Ae;
  }
  return al = te, al;
}
var iE = oE();
const $p = /* @__PURE__ */ gt(iE), aE = je(
  () => ({
    button: {
      padding: 0,
      minWidth: 48
    },
    boxContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    iconButton: {
      padding: 0
    },
    icon: {
      color: "#20A8BF"
    },
    expanded: {
      border: "none !important"
    }
  })
), Wp = $g((r) => ({
  root: {
    borderBottom: `1px solid ${r.palette.grey[500]}`,
    "& a": {
      color: r.palette.primary.main,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  }
}))(xo), qn = $g((r) => ({
  head: {
    backgroundColor: "white"
  },
  body: {
    height: 30,
    fontSize: 14,
    padding: "5px 10px"
  },
  root: {
    border: "none"
  }
}))(Fn), sE = ({
  actions: r,
  alignments: e,
  columns: t,
  rowData: n,
  editable: o,
  columnCount: i,
  collapsible: a,
  onClick: s
}) => {
  const c = aE(), [d, u] = R.useState(!1), [p, h] = R.useState(!1), f = e || [], m = () => {
    o?.onRowDelete?.(n), u(!1);
  }, g = () => {
    h(!p);
  };
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx(
      Wp,
      {
        className: Y({
          [c.expanded]: p
        }),
        onClick: s ? () => s(n) : void 0,
        children: d ? /* @__PURE__ */ w.jsx(qn, { colSpan: i, children: /* @__PURE__ */ w.jsxs(at, { className: c.boxContainer, children: [
          /* @__PURE__ */ w.jsx(We, { children: "Are you sure to delete this record?" }),
          /* @__PURE__ */ w.jsxs(at, { children: [
            /* @__PURE__ */ w.jsx(Sn, { onClick: m, children: /* @__PURE__ */ w.jsx(Wg, {}) }),
            /* @__PURE__ */ w.jsx(Sn, { onClick: () => u(!1), children: /* @__PURE__ */ w.jsx(XM, {}) })
          ] })
        ] }) }) : /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
          t.map((b, x) => /* @__PURE__ */ w.jsx(
            qn,
            {
              align: b.alignRow || "left",
              children: b.renderRow ? b.renderRow(n) : b.field && $p(n, b.field)
            },
            b.field || x
          )),
          o && !r && /* @__PURE__ */ w.jsxs(qn, { align: f[t.length] || "left", children: [
            o.isEditable && /* @__PURE__ */ w.jsx(
              Sn,
              {
                className: c.button,
                onClick: () => o.onRowEdit?.(n),
                children: /* @__PURE__ */ w.jsx(ZM, {})
              }
            ),
            o.isDeleteable && o.onRowDelete && /* @__PURE__ */ w.jsx(
              Sn,
              {
                className: c.button,
                onClick: () => u(!0),
                children: /* @__PURE__ */ w.jsx(GM, {})
              }
            )
          ] }),
          a && /* @__PURE__ */ w.jsx(qn, { align: "right", children: /* @__PURE__ */ w.jsx(
            jt,
            {
              className: c.iconButton,
              onClick: g,
              children: p ? /* @__PURE__ */ w.jsx(eE, { className: c.icon }) : /* @__PURE__ */ w.jsx(nE, { className: c.icon })
            }
          ) }),
          !o && r && /* @__PURE__ */ w.jsx(qn, { align: f[t.length] || "left", children: r.map((b, x) => /* @__PURE__ */ w.jsx(
            Sn,
            {
              onClick: (v) => b.onClick(v, n),
              children: b.icon && /* @__PURE__ */ w.jsx(b.icon, {})
            },
            x
          )) })
        ] })
      }
    ),
    p && /* @__PURE__ */ w.jsx(Wp, { children: /* @__PURE__ */ w.jsx(qn, { colSpan: i, children: $p(n, "expandedContent") }) })
  ] });
}, lE = ({
  actions: r,
  columns: e,
  rowsData: t,
  editable: n,
  alignments: o,
  collapsible: i,
  localization: a,
  eventHandlers: s,
  components: c
}) => {
  const d = e.length + (n !== void 0 || r !== void 0 ? 1 : 0) + (i ? 1 : 0), u = c?.TableRow || sE, p = c?.tableRowProps || {};
  return /* @__PURE__ */ w.jsx(pd, { children: (t || []).map((h, f) => /* @__PURE__ */ w.jsx(
    u,
    {
      rowIndex: f,
      actions: r,
      columns: e,
      rowData: h,
      editable: n,
      collapsible: i,
      alignments: o,
      columnCount: d,
      localization: a,
      onClick: s?.onRowClick,
      ...p
    },
    h.id || h.key || f
  )) });
}, cE = je((r) => ({
  tableCell: {
    border: "none",
    fontSize: 14,
    padding: "5px 0px"
  }
})), dE = ({
  footer: r,
  pagination: e,
  columnCount: t,
  components: n,
  isPaginated: o
}) => {
  const i = cE(), a = o && !!e, s = a && (e?.colSpan || t) || 0, c = n?.TableFooter ? r?.colSpan || (t || 0) - s : 0;
  return /* @__PURE__ */ w.jsx(ug, { children: (o && e || n?.TableFooter) && /* @__PURE__ */ w.jsxs(xo, { children: [
    n?.TableFooter && /* @__PURE__ */ w.jsx(Fn, { className: i.tableCell, colSpan: c, children: n.TableFooter }),
    a && e && /* @__PURE__ */ w.jsx(
      mg,
      {
        rowsPerPageOptions: [e.rowsPerPage || 10],
        colSpan: s,
        count: e.rowCount || 0,
        rowsPerPage: e.rowsPerPage || 10,
        page: e.page || 0,
        SelectProps: {
          native: !0
        },
        onPageChange: e.handleChangePage
      }
    )
  ] }) });
}, uE = je((r) => ({
  tableRow: {
    background: "white",
    borderBottom: `1px solid ${r.palette.grey[500]}`
  },
  tableCell: {
    height: 30,
    padding: "5px 10px",
    fontSize: 14,
    fontWeight: 500,
    border: "none"
  }
})), pE = ({
  columns: r,
  actions: e,
  editable: t,
  alignments: n,
  collapsible: o,
  localization: i,
  components: a
}) => {
  const s = n || [], c = uE(), d = a?.TableHeaderCell || Fn;
  return /* @__PURE__ */ w.jsx(fd, { children: a?.TableHeaderRow ? /* @__PURE__ */ w.jsx(a.TableHeaderRow, { columns: r }) : r && /* @__PURE__ */ w.jsxs(xo, { className: c.tableRow, children: [
    r.map((u, p) => /* @__PURE__ */ w.jsx(
      d,
      {
        className: c.tableCell,
        align: u.alignHeader || s[p] || "left",
        children: u.renderHeader ? u.renderHeader() : u.title
      },
      u.title || u.field || p
    )),
    (t || e) && /* @__PURE__ */ w.jsx(
      d,
      {
        align: s[r.length] || "left",
        className: c.tableCell,
        children: i?.actionsText === "" ? "" : i?.actionsText || "Actions"
      }
    ),
    o && /* @__PURE__ */ w.jsx(d, { className: c.tableCell, children: i?.collapseHeaderText })
  ] }) });
}, Sj = ({
  data: r,
  title: e,
  footer: t,
  actions: n,
  editable: o,
  pagination: i,
  alignments: a,
  components: s,
  collapsible: c,
  isFixedHeight: d,
  visibilities: u,
  localization: p,
  eventHandlers: h
}) => {
  const [f, m] = R.useState(0), g = R.useMemo(() => {
    if (!i)
      return r.rowsData;
    const v = i.rowsPerPage || 20;
    return (r.rowsData || []).slice(
      f * v,
      f * v + v
    );
  }, [f, i, r.rowsData]), b = (v, y) => {
    m(y), i?.onUpdatePage?.(y);
  }, x = r.columns.length + (o ? 1 : 0) + (c ? 1 : 0);
  return /* @__PURE__ */ w.jsxs(hd, { children: [
    /* @__PURE__ */ w.jsx(it, { item: !0, xs: 12, children: e }),
    s?.Toolbar ? /* @__PURE__ */ w.jsx(it, { item: !0, xs: 12, children: s?.Toolbar }) : null,
    /* @__PURE__ */ w.jsx(it, { item: !0, xs: 12, children: /* @__PURE__ */ w.jsxs(ud, { children: [
      u?.showHeader !== !1 && /* @__PURE__ */ w.jsx(
        pE,
        {
          columns: r.columns,
          actions: n,
          editable: o,
          collapsible: c,
          alignments: a,
          localization: p,
          components: s
        }
      ),
      /* @__PURE__ */ w.jsx(
        lE,
        {
          actions: n,
          columns: r.columns,
          editable: o,
          rowsData: g,
          alignments: a,
          collapsible: c,
          eventHandlers: h,
          isFixedHeight: d,
          components: s
        }
      ),
      u?.showFooter !== !1 && /* @__PURE__ */ w.jsx(
        dE,
        {
          isPaginated: !!i,
          columnCount: x,
          components: s,
          footer: t,
          pagination: {
            ...i,
            page: i?.asyncPage || f,
            rowCount: i?.asyncTotalCount || r.rowsData?.length,
            handleChangePage: b
          }
        }
      )
    ] }) })
  ] });
};
var Ko = {}, Hp;
function hE() {
  if (Hp) return Ko;
  Hp = 1;
  var r = wt();
  Object.defineProperty(Ko, "__esModule", {
    value: !0
  }), Ko.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return Ko.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
  }), "InfoOutlined"), Ko;
}
var fE = /* @__PURE__ */ hE();
const gE = /* @__PURE__ */ gt(fE);
function mE(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  r && r.addEventListener && r.addEventListener.apply(r, e);
}
function bE(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  r && r.removeEventListener && r.removeEventListener.apply(r, e);
}
var xE = ["mousedown", "touchstart"], vE = function(r, e, t) {
  t === void 0 && (t = xE);
  var n = Ea(e);
  $a(function() {
    n.current = e;
  }, [e]), $a(function() {
    for (var o = function(c) {
      var d = r.current;
      d && !d.contains(c.target) && n.current(c);
    }, i = 0, a = t; i < a.length; i++) {
      var s = a[i];
      mE(document, s, o);
    }
    return function() {
      for (var c = 0, d = t; c < d.length; c++) {
        var u = d[c];
        bE(document, u, o);
      }
    };
  }, [t, r]);
};
const Tj = je(
  () => ({
    fontBolder: {
      fontWeight: 700
    },
    fontBold: {
      fontWeight: 600
    },
    font500: {
      fontWeight: 500
    },
    fontNormal: {
      fontWeight: 400
    },
    noneTextDecoration: {
      textDecoration: "none"
    }
  })
), yE = je(
  (r) => ({
    gray: {
      color: r.palette.grey[900]
    },
    error: {
      color: r.palette.error.main
    },
    warning: {
      color: r.palette.warning.main
    },
    info: {
      color: r.palette.info.main
    },
    black: {
      color: r.palette.common.black
    },
    white: {
      color: r.palette.common.white
    },
    primary: {
      color: r.palette.primary.main
    },
    secondary: {
      color: r.palette.secondary.main
    }
  })
), wE = je(
  (r) => ({
    mb05: {
      marginBottom: r.spacing(0.5)
    },
    mb1: {
      marginBottom: r.spacing(1)
    },
    mb15: {
      marginBottom: r.spacing(1.5)
    },
    mb2: {
      marginBottom: r.spacing(2)
    },
    mb3: {
      marginBottom: r.spacing(3)
    },
    mb4: {
      marginBottom: r.spacing(4)
    },
    mb6: {
      marginBottom: r.spacing(6)
    },
    ml1: {
      marginLeft: r.spacing(1)
    },
    ml15: {
      marginLeft: r.spacing(1.5)
    },
    ml2: {
      marginLeft: r.spacing(2)
    },
    margin1: {
      marginBottom: r.spacing(1)
    },
    margin2: {
      marginBottom: r.spacing(2)
    },
    margin3: {
      marginBottom: r.spacing(3)
    },
    mt05: {
      marginTop: r.spacing(0.5)
    },
    mt1: {
      marginTop: r.spacing(1)
    },
    mt2: {
      marginTop: r.spacing(2)
    },
    mt3: {
      marginTop: r.spacing(3)
    },
    pl1: {
      paddingLeft: r.spacing(1)
    },
    pl2: {
      paddingLeft: r.spacing(2)
    },
    pl3: {
      paddingLeft: r.spacing(3)
    },
    pl4: {
      paddingLeft: r.spacing(4)
    },
    pt1: {
      paddingTop: r.spacing(1)
    },
    pt2: {
      paddingTop: r.spacing(2)
    },
    pt3: {
      paddingTop: r.spacing(3)
    },
    pb0: {
      paddingBottom: r.spacing(0)
    },
    pb1: {
      paddingBottom: r.spacing(1)
    },
    pb2: {
      paddingBottom: r.spacing(2)
    },
    pb3: {
      paddingBotom: r.spacing(3)
    },
    padding1: {
      padding: r.spacing(1)
    },
    padding2: {
      padding: r.spacing(2)
    },
    padding3: {
      padding: r.spacing(3)
    },
    noPadding: {
      padding: 0
    },
    noMargin: {
      padding: 0
    },
    fullHeight: {
      height: "100%"
    }
  })
), Be = Tc({
  palette: {
    primary: {
      main: "#6196FF",
      900: "#6196FF",
      800: "#71A0FF",
      700: "#90B6FF",
      600: "#B0CAFF",
      500: "#D0E0FF",
      400: "#EFF5FF",
      300: "#F7FAFF"
    },
    secondary: {
      main: "#DD2B7C",
      900: "#DD2B7C",
      800: "#E04089",
      700: "#E76BA3",
      600: "#EE95BE",
      500: "#F5BFD8",
      400: "#FCEAF2",
      300: "#FDF4F9"
    },
    grey: {
      900: "#4F525C",
      800: "#61636C",
      700: "#84868D",
      600: "#A7A8AE",
      500: "#CACBCE",
      400: "#EDEEEF",
      300: "#F6F6F7"
    },
    error: {
      main: "#B83B1F",
      900: "#B83B1F",
      800: "#BF4F35",
      700: "#CD7662",
      600: "#DC9D8F",
      500: "#EAC4BC",
      400: "#F8EBE9",
      300: "#FCF5F4"
    },
    warning: {
      main: "#F5A623",
      900: "#F5A623",
      800: "#F6AF39",
      700: "#F8C165",
      600: "#FAD291",
      500: "#FCE4BD",
      400: "#FEF6E9",
      300: "#FFFBF4"
    },
    success: {
      main: "#7ED321",
      900: "#7ED321",
      800: "#8BD737",
      700: "#A5E064",
      600: "#BFE990",
      500: "#D8F2BD",
      400: "#F2FBE9",
      300: "#F9FDF4"
    },
    common: {
      black: "#000000",
      white: "#FFFFFF"
    },
    text: {
      primary: "#4F525C",
      disabled: "#61636C"
    },
    purple: {
      main: "#302A6F",
      900: "#302A6F",
      800: "#453F7D",
      700: "#6E6A9A",
      600: "#9895B7",
      500: "#C1BFD4",
      400: "#EAEAF1",
      300: "#F5F4F8"
    }
  }
}), Sr = (r, e) => {
  if (e in r)
    return r[e];
}, yi = Tc({
  typography: {
    htmlFontSize: 16,
    fontFamily: "Montserrat",
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: {
      fontWeight: 700,
      fontSize: "3rem",
      lineHeight: 1.475
    },
    h2: {
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.219
    },
    h3: {
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: 1.208
    },
    h4: {
      fontWeight: 600,
      fontSize: "1.125rem",
      lineHeight: 1.222
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.25
    },
    caption: {
      fontSize: "0.875rem",
      lineHeight: 1.214,
      fontWeight: 400
    }
  },
  palette: Be.palette,
  shape: {
    borderRadius: 8
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0,
        disableTouchRipple: !0
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingBottom: 0
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        marginNormal: { marginTop: 0, marginBottom: 0 }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: { background: Be.palette.common.white }
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          zIndex: 0
        }
      }
    },
    MuiLink: {
      defaultProps: {
        underline: "hover"
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          position: "relative",
          borderRadius: Be.spacing(),
          color: Be.palette.grey[900],
          backgroundColor: Be.palette.grey[300],
          "&.MuiChip-filledColorDefault,&.MuiChip-filledColorPrimary": {
            "&.selected": {
              color: Be.palette.common.white,
              backgroundColor: Sr(Be.palette.primary, 900),
              "&:hover,&:focus": {
                backgroundColor: Sr(
                  Be.palette.primary,
                  800
                )
              }
            },
            "&:hover,&:focus": {
              backgroundColor: Sr(Be.palette.primary, 700)
            }
          },
          "&.MuiChip-filledColorSecondary": {
            "&.selected": {
              color: Be.palette.common.white,
              backgroundColor: Sr(
                Be.palette.secondary,
                900
              ),
              "&:hover,&:focus": {
                backgroundColor: Sr(
                  Be.palette.secondary,
                  800
                )
              }
            }
          },
          "&.MuiChip-outlinedColorDefault,&.MuiChip-outlinedColorPrimary": {
            "&:hover,&:focus,&.selected": {
              borderColor: Sr(Be.palette.primary, 900),
              backgroundColor: `${Sr(
                Be.palette.primary,
                400
              )} !important`
            }
          },
          "&.MuiChip-outlinedColorSecondary": {
            "&:hover,&:focus,&.selected": {
              borderColor: Sr(Be.palette.secondary, 900),
              backgroundColor: `${Sr(
                Be.palette.secondary,
                400
              )} !important`
            }
          }
        },
        outlined: {
          borderColor: Be.palette.grey[800],
          backgroundColor: Be.palette.common.white,
          "& .MuiChip-deleteIcon": {
            marginRight: Be.spacing(0, 1, 0, 0.5),
            position: "initial",
            right: "unset",
            top: "unset"
          }
        },
        outlinedPrimary: {
          backgroundColor: Be.palette.common.white
        },
        outlinedSecondary: {
          backgroundColor: Be.palette.common.white
        },
        labelSmall: {
          color: Be.palette.text.primary,
          fontSize: "0.875rem",
          fontWeight: 500
        },
        colorPrimary: {
          backgroundColor: Sr(Be.palette.primary, 600)
        },
        colorSecondary: {
          color: Be.palette.grey[900],
          backgroundColor: Sr(Be.palette.secondary, 600)
        },
        deleteIconColorSecondary: {
          color: Be.palette.grey[800],
          "&:hover": {
            color: Be.palette.secondary.main
          }
        },
        deleteIcon: {
          width: Be.spacing(3),
          height: Be.spacing(3),
          color: Be.palette.primary[800],
          position: "absolute",
          right: Be.spacing(-1.125),
          top: Be.spacing(-1.125),
          marginRight: Be.spacing(0, 1, 0, 0.5),
          margin: "unset",
          "&:hover": {
            color: Be.palette.primary.main
          }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "16px",
          lineHeight: "20px",
          fontWeight: 600,
          color: Be.palette.grey[900],
          textShadow: "0px 1px 2px rgb(16 24 40 / 5%), 0px 0px 0px #f4ebff"
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          "&::-webkit-scrollbar-thumb": {
            background: Be.palette.grey[500]
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent"
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
          borderWidth: 1,
          borderStyle: "solid",
          "&.Mui-disabled": {
            borderColor: Be.palette.grey[600],
            backgroundColor: Be.palette.grey[300]
          },
          "& fieldset": {
            border: "none"
          }
        },
        input: {
          padding: "10px 14px",
          borderRadius: Be.spacing()
        },
        multiline: {
          padding: Be.spacing(1, 0, 0, 1)
        },
        inputMultiline: {
          padding: Be.spacing(0, 1.5, 1.5, 0),
          resize: "vertical"
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          "&:focus": {
            backgroundColor: "unset"
          }
        },
        outlined: {
          "&:focus": {
            borderRadius: Be.spacing()
          }
        }
      }
    }
  }
}), CE = ({
  title: r,
  description: e
}) => e ? /* @__PURE__ */ w.jsxs(R.Fragment, { children: [
  /* @__PURE__ */ w.jsx("h1", { children: r }),
  /* @__PURE__ */ w.jsx("p", { children: e })
] }) : /* @__PURE__ */ w.jsx(R.Fragment, { children: r }), Es = ({
  children: r,
  arrow: e = !0,
  title: t,
  color: n = "default",
  description: o,
  classes: i,
  ...a
}) => {
  const s = kE({ color: n });
  return /* @__PURE__ */ w.jsx(
    dg,
    {
      arrow: e,
      title: /* @__PURE__ */ w.jsx(CE, { title: t, description: o }),
      ...a,
      classes: {
        ...i,
        arrow: Y(s.arrow, i?.arrow),
        tooltip: Y(s.tooltip, i?.tooltip)
      },
      children: r
    }
  );
}, sl = {
  default: {
    color: yi.palette.grey[900],
    background: yi.palette.common.white
  },
  purple: {
    color: yi.palette.common.white,
    background: yi.palette.purple[900]
  }
}, kE = je(
  (r) => ({
    arrow: {
      color: ({ color: e }) => sl[e].background
    },
    tooltip: {
      background: ({ color: e }) => sl[e].background,
      color: ({ color: e }) => sl[e].color,
      padding: "8px 12px",
      borderRadius: "8px",
      fontSize: 14,
      lineHeight: "17px",
      maxWidth: 328,
      filter: "drop-shadow(0px 0px 16px rgba(3, 27, 137, 0.15))",
      "& > h1": {
        margin: 0,
        fontSize: 14,
        fontWeight: r.typography.fontWeightBold
      },
      "& > p": {
        marginTop: 4
      }
    }
  })
), Aj = ({
  tooltip: r,
  className: e
}) => {
  const t = yE(), n = wE(), [o, i] = R.useState(!1), a = R.useRef(null), s = () => i(!o);
  return vE(a, () => {
    i(!1);
  }), /* @__PURE__ */ w.jsx(Es, { open: o, title: r, children: /* @__PURE__ */ w.jsx(
    jt,
    {
      onClick: s,
      disableRipple: !0,
      ref: a,
      className: Y(n.noPadding, e),
      children: /* @__PURE__ */ w.jsx(
        gE,
        {
          fontSize: "small",
          className: Y(t.gray, { [t.primary]: o })
        }
      )
    }
  ) });
}, SE = je(
  (r) => ({
    card: {
      fontFamily: "Montserrat",
      background: "#FFFFFF",
      boxShadow: "0px 0px 20px rgba(3, 27, 137, 0.1)",
      borderRadius: r.spacing(1),
      padding: r.spacing(2, 4),
      width: ({ width: e }) => e,
      height: ({ height: e }) => e
    }
  })
), Xg = ({
  className: r,
  id: e,
  width: t,
  height: n,
  ...o
}) => {
  const i = SE({ width: t, height: n });
  return /* @__PURE__ */ w.jsx(
    "div",
    {
      className: Y(i.card, r),
      "data-testid": e,
      ...o
    }
  );
};
var Zo = {}, Yp;
function TE() {
  if (Yp) return Zo;
  Yp = 1;
  var r = wt();
  Object.defineProperty(Zo, "__esModule", {
    value: !0
  }), Zo.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return Zo.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99"
  }), "Call"), Zo;
}
var AE = /* @__PURE__ */ TE();
const Vg = /* @__PURE__ */ gt(AE);
var Jo = {}, Xp;
function OE() {
  if (Xp) return Jo;
  Xp = 1;
  var r = wt();
  Object.defineProperty(Jo, "__esModule", {
    value: !0
  }), Jo.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return Jo.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"
  }), "CallMade"), Jo;
}
var RE = /* @__PURE__ */ OE();
const Ug = /* @__PURE__ */ gt(RE);
var Tr = /* @__PURE__ */ ((r) => (r[r.URL_INPUT = 1] = "URL_INPUT", r[r.PHONE_NUMBER_INPUT = 5] = "PHONE_NUMBER_INPUT", r[r.BLOCK_INPUT = 9] = "BLOCK_INPUT", r[r.FORM_INPUT = 10] = "FORM_INPUT", r[r.QR_URL = 101] = "QR_URL", r[r.QR_PHONE = 102] = "QR_PHONE", r[r.QR_EMAIL = 103] = "QR_EMAIL", r[r.QR_INTENT = 104] = "QR_INTENT", r[r.QR_FORM = 105] = "QR_FORM", r))(Tr || {});
function PE() {
  const [, r] = R.useState(0);
  return R.useCallback(() => r((e) => e + 1), []);
}
function ME(r, e) {
  const n = document.createElement("canvas").getContext("2d");
  return n.font = e, n.measureText(r).width;
}
const Gg = ({
  title: r,
  titleId: e,
  ...t
}) => /* @__PURE__ */ R.createElement("svg", { width: 28, height: 24, viewBox: "0 0 28 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": e, ...t }, r ? /* @__PURE__ */ R.createElement("title", { id: e }, r) : null, /* @__PURE__ */ R.createElement("path", { d: "M16.0974 7L10.4403 12L16.0974 17", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ R.createElement("path", { d: "M10.4402 12L24.0173 12", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ R.createElement("path", { d: "M10.4402 21L5.91447 21C5.31432 21 4.73876 20.7893 4.31439 20.4142C3.89002 20.0391 3.65161 19.5304 3.65161 19L3.65161 5C3.65161 4.46957 3.89002 3.96086 4.31439 3.58579C4.73876 3.21071 5.31433 3 5.91447 3L10.4402 3", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), qg = ({
  title: r,
  titleId: e,
  ...t
}) => /* @__PURE__ */ R.createElement("svg", { width: 28, height: 24, viewBox: "0 0 28 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": e, ...t }, r ? /* @__PURE__ */ R.createElement("title", { id: e }, r) : null, /* @__PURE__ */ R.createElement("path", { d: "M18.3601 17L24.0172 12L18.3601 7", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ R.createElement("path", { d: "M24.0173 12H10.4402", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ R.createElement("path", { d: "M10.4402 21H5.91447C5.31432 21 4.73876 20.7893 4.31439 20.4142C3.89002 20.0391 3.65161 19.5304 3.65161 19V5C3.65161 4.46957 3.89002 3.96086 4.31439 3.58579C4.73876 3.21071 5.31432 3 5.91447 3H10.4402", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), EE = 60, Vp = ({ type: r, blocks: e, onClick: t }) => {
  const n = IE(), o = PE(), [i, a] = R.useState(!1), s = R.useRef(null), c = s.current?.offsetWidth || 220, d = (b) => {
    switch (b.type) {
      case Tr.PHONE_NUMBER_INPUT:
      case Tr.QR_PHONE:
        return /* @__PURE__ */ w.jsx(Vg, { className: n.smallIcon });
      case Tr.QR_URL:
      case Tr.URL_INPUT:
      case Tr.QR_EMAIL:
        return /* @__PURE__ */ w.jsx(Ug, { className: n.smallIcon });
      default:
        return null;
    }
  }, u = R.useMemo(() => e.sort((b, x) => x.type - b.type), [e]), p = R.useMemo(() => {
    let b = 0;
    const x = [];
    if (!s.current) return u;
    for (let v = 0; v < u.length; v++) {
      const C = ME(
        u[v].name,
        "normal 16px Nunito-Regular"
      ) + 16;
      if (b + C < c && v === u.length - 1) {
        x.push(u[v]);
        continue;
      } else if (b + C + EE >= c)
        break;
      b += C, x.push(u[v]);
    }
    return x;
  }, [c, u]), h = e.length > p.length, f = !h || i ? u : p, m = () => {
    a(!0);
  }, g = () => {
    a(!1);
  };
  return R.useEffect(() => {
    o();
  }, [o, e]), /* @__PURE__ */ w.jsxs("div", { className: n.container, children: [
    /* @__PURE__ */ w.jsxs("div", { className: n.iconContainer, children: [
      r === "In" ? /* @__PURE__ */ w.jsx(Gg, {}) : /* @__PURE__ */ w.jsx(qg, {}),
      /* @__PURE__ */ w.jsxs(We, { color: "primary", className: n.showType, children: [
        r,
        " Blocks"
      ] })
    ] }),
    /* @__PURE__ */ w.jsxs(
      "div",
      {
        className: n.blocks,
        ref: (b) => s.current = b,
        children: [
          f.map((b) => /* @__PURE__ */ w.jsxs(
            We,
            {
              className: n.text,
              onClick: () => t(b),
              children: [
                b.name,
                d(b)
              ]
            },
            b.key || b.id
          )),
          h && !i ? /* @__PURE__ */ w.jsxs(
            We,
            {
              className: Y(n.text, n.typoButton),
              onClick: m,
              children: [
                e.length - f.length,
                " more"
              ]
            }
          ) : null,
          h && i && /* @__PURE__ */ w.jsx(
            We,
            {
              className: Y(n.text, n.typoButton),
              onClick: g,
              children: "Show Less"
            }
          )
        ]
      }
    )
  ] });
}, IE = je(
  (r) => ({
    container: {
      display: "flex",
      alignItems: "center"
    },
    iconContainer: {
      display: "flex",
      alignItems: "center",
      maxWidth: 134,
      minWidth: 134,
      color: r.palette.primary[900]
    },
    blocks: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      flexGrow: 1,
      gap: r.spacing(1)
    },
    showType: {
      fontWeight: 600,
      marginLeft: r.spacing(1)
    },
    iconButton: {
      padding: r.spacing(0),
      color: "#4F525C !important"
    },
    text: {
      cursor: "pointer",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      margin: `${r.spacing(0.5)}px ${r.spacing(1)}px`,
      "&:hover": {
        color: r.palette.primary[900]
      }
    },
    typoButton: {
      color: r.palette.primary[900],
      textDecoration: "underline"
    },
    smallIcon: {
      fontSize: 10,
      marginTop: -10
    }
  })
), Oj = ({
  inBlocks: r,
  outBlocks: e,
  onClick: t
}) => /* @__PURE__ */ w.jsx(Xg, { children: /* @__PURE__ */ w.jsxs(it, { container: !0, spacing: 1, children: [
  /* @__PURE__ */ w.jsx(it, { item: !0, xs: 12, children: /* @__PURE__ */ w.jsx(Vp, { type: "In", blocks: r, onClick: t }) }),
  /* @__PURE__ */ w.jsx(it, { item: !0, xs: 12, children: /* @__PURE__ */ w.jsx(Vp, { type: "Out", blocks: e, onClick: t }) })
] }) }), NE = je((r) => ({
  paperContainer: {
    maxHeight: `calc(100vh - ${r.spacing(25)}px)`,
    boxShadow: ({ variant: e }) => e === "transparent" ? "none" : void 0,
    "&::-webkit-scrollbar": {
      width: 4
    },
    "&::-webkit-scrollbar-thumb": {
      background: r.palette.grey[500]
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent"
    }
  },
  tableHead: {
    backgroundColor: ({ variant: e }) => e === "transparent" ? void 0 : r.palette.grey[400],
    "& th": {
      fontWeight: r.typography.fontWeightBold,
      backgroundColor: ({ variant: e }) => e === "transparent" ? "white" : void 0
    }
  },
  tableRow: {
    "&:nth-of-type(even)": {
      backgroundColor: ({ variant: e }) => e === "transparent" ? "transparent" : e === "plain" ? r.palette.common.white : r.palette.grey[100]
    },
    "&.MuiTableRow-hover:hover": {
      backgroundColor: r.palette.primary[500],
      cursor: "pointer"
    },
    "&.MuiTableRow-root.Mui-selected, &.MuiTableRow-root.Mui-selected:hover": {
      backgroundColor: r.palette.primary[500],
      cursor: "pointer"
    }
  },
  tableBody: {
    "& td": {
      borderColor: ({ variant: e }) => e === "plain" ? "transparent" : void 0
    }
  }
})), Rj = ({
  isLoading: r,
  headerColumns: e,
  renderRow: t,
  data: n,
  children: o,
  getKey: i,
  onRowClicked: a,
  loadingComponent: s,
  className: c,
  hover: d,
  dataTestId: u,
  size: p = "medium",
  stickyHeader: h = !0,
  isSelected: f,
  variant: m = "default",
  ...g
}) => {
  const b = yr(), x = NE({ variant: m });
  return /* @__PURE__ */ w.jsxs(
    hd,
    {
      component: Wt,
      className: c,
      classes: { root: x.paperContainer },
      "data-testid": u,
      children: [
        /* @__PURE__ */ w.jsxs(ud, { size: p, stickyHeader: h, ...g, children: [
          /* @__PURE__ */ w.jsx(fd, { className: x.tableHead, children: /* @__PURE__ */ w.jsx(xo, { className: x.tableRow, children: e }) }),
          /* @__PURE__ */ w.jsxs(pd, { className: x.tableBody, children: [
            n?.map((v) => /* @__PURE__ */ w.jsx(
              xo,
              {
                className: x.tableRow,
                hover: typeof d == "boolean" ? d : d?.(v),
                selected: f?.(v),
                onClick: a ? () => a(v) : void 0,
                children: t(v)
              },
              `botco-table-${i(v)}`
            )),
            o
          ] })
        ] }),
        r && s && /* @__PURE__ */ w.jsx(
          at,
          {
            width: "100%",
            height: n?.length ? b.spacing(8) : "70vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children: s
          }
        )
      ]
    }
  );
}, Vr = R.forwardRef(
  (r, e) => {
    const {
      color: t = "primary",
      size: n = "medium",
      variant: o = "contained",
      disabled: i = !1,
      className: a,
      children: s,
      labelClass: c,
      onClick: d,
      debounce: u,
      disabledPadding: p,
      ...h
    } = r, {
      button: f,
      label: m,
      disabledPadding: g,
      ...b
    } = LE({ color: t }), x = R.useRef(), v = (y) => {
      if (!d) return;
      if (!u) {
        d(y);
        return;
      }
      const C = typeof u == "number" ? u : 400;
      window.clearTimeout(x.current), x.current = window.setTimeout(() => {
        d(y);
      }, C);
    };
    return /* @__PURE__ */ w.jsx(
      Sn,
      {
        size: n,
        disabled: i,
        variant: o,
        disableRipple: !0,
        role: "button",
        classes: b,
        className: Y(
          f,
          m,
          c,
          {
            [g]: p
          },
          a
        ),
        onClick: v,
        ref: e,
        ...h,
        children: s
      }
    );
  }
);
Vr.displayName = "Button";
const Qo = (r, e) => {
  switch (e) {
    case "primary":
      return r.primary.main;
    case "secondary":
      return r.secondary.main;
    case "grey":
      return r.grey[900];
    default:
      return r.primary.main;
  }
}, LE = je(
  (r) => ({
    disabledPadding: {
      height: "auto !important",
      padding: 0
    },
    label: {
      fontSize: "16px",
      lineHeight: "20px",
      fontWeight: r.typography.fontWeightRegular
    },
    contained: {
      color: r.palette.common.white,
      border: ({ color: e }) => `1px solid ${Qo(r.palette, e)}`,
      backgroundColor: ({ color: e }) => Qo(r.palette, e),
      "&:hover": {
        border: ({ color: e }) => `1px solid ${r.palette[e][700]}`,
        backgroundColor: ({ color: e }) => r.palette[e][700]
      },
      "&.Mui-disabled": {
        color: r.palette.common.white,
        border: `1px solid ${r.palette.grey[500]}`,
        backgroundColor: r.palette.grey[500]
      }
    },
    outlined: {
      background: r.palette.common.white,
      color: ({ color: e }) => Qo(r.palette, e),
      border: ({ color: e }) => `1px solid ${Qo(r.palette, e)}`,
      "&:hover": {
        border: ({ color: e }) => `1px solid ${r.palette[e][700]}`,
        backgroundColor: ({ color: e }) => r.palette[e][300]
      },
      "&.Mui-disabled": {
        color: r.palette.grey[600],
        border: `1px solid ${r.palette.grey[600]}`
      }
    },
    text: {
      color: ({ color: e }) => Qo(r.palette, e),
      boxShadow: "unset !important",
      "&:hover": {
        backgroundColor: ({ color: e }) => r.palette[e][300]
      },
      "&.Mui-disabled": {
        color: r.palette.grey[600]
      }
    },
    button: {
      height: "36px",
      borderRadius: "8px",
      textTransform: "none",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
      "&:hover": {
        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)"
      }
    }
  })
);
var ei = {}, Up;
function jE() {
  if (Up) return ei;
  Up = 1;
  var r = wt();
  Object.defineProperty(ei, "__esModule", {
    value: !0
  }), ei.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return ei.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z"
  }), "CheckBoxOutlined"), ei;
}
var DE = /* @__PURE__ */ jE();
const zE = /* @__PURE__ */ gt(DE), BE = je(
  (r) => ({
    checkbox: {
      padding: 0,
      marginRight: 8,
      color: r.palette.grey[700],
      borderRadius: 0,
      width: 14,
      height: 14,
      "& svg": {
        width: 20,
        height: 20,
        marginTop: 5
      },
      "&.Mui-disabled": {
        color: r.palette.grey[500]
      }
    },
    label: {
      verticalAlign: "unset",
      alignItems: "flex-start",
      color: ({ disabled: e, hasDescription: t }) => e && t ? r.palette.grey[700] : r.palette.grey[900],
      "&:hover": {
        "& svg": {
          color: ({ color: e, disabled: t }) => t ? "" : r.palette[e].main,
          backgroundColor: ({ color: e, disabled: t }) => t ? "" : r.palette[e][400]
        }
      },
      "& .MuiFormControlLabel-label": {
        fontWeight: 600
      }
    },
    description: {
      fontWeight: 400,
      display: "block"
    }
  })
), Pj = ({
  checked: r,
  color: e = "primary",
  dataTestId: t,
  description: n,
  disabled: o = !1,
  id: i,
  label: a,
  labelClasses: s,
  labelPlacement: c = "end",
  name: d,
  onChange: u
}) => {
  const p = BE({
    color: e,
    disabled: o,
    hasDescription: !!n
  });
  return /* @__PURE__ */ w.jsx(
    Xf,
    {
      id: i,
      control: /* @__PURE__ */ w.jsx(
        _f,
        {
          color: e,
          disableRipple: !0,
          checked: r,
          onChange: u,
          className: p.checkbox,
          checkedIcon: /* @__PURE__ */ w.jsx(zE, {})
        }
      ),
      label: /* @__PURE__ */ w.jsxs(R.Fragment, { children: [
        a,
        n
      ] }),
      name: d,
      "data-testid": t,
      disabled: o,
      labelPlacement: c,
      classes: {
        ...s,
        root: Y(p.label, s?.root)
      }
    }
  );
}, Mj = (r) => {
  const e = R.useRef(null), t = FE(), n = R.useRef(r.defaultInputValue ?? ""), o = () => {
    n.current = r.defaultInputValue ?? "", r.onClose?.();
  }, i = (c) => {
    switch (c.key) {
      case "Enter": {
        if (c.preventDefault(), c.stopPropagation(), n.current?.trim()?.length) {
          if (r.onAdd(n.current)) {
            o();
            return;
          }
          setTimeout(() => {
            s();
          });
        }
        break;
      }
      case "Esc":
      case "Escape":
        o();
    }
  }, a = (c) => {
    n.current = (r.trimSpace ? c.currentTarget.textContent?.trim() : c.currentTarget.textContent) ?? "";
  };
  R.useEffect(() => {
    n.current = r.defaultInputValue ?? "";
  }, [r.defaultInputValue]);
  const s = () => {
    if (!e.current) return;
    const c = window.getSelection(), d = document.createRange();
    c?.removeAllRanges(), d.selectNodeContents(e.current), d.collapse(!1), c?.addRange(d), e.current?.focus();
    const u = c?.getRangeAt(0), p = document.createElement("br");
    u?.insertNode(p), p.scrollIntoView({
      block: "end"
    }), p.remove();
  };
  return R.useEffect(() => {
    r.showInput && s();
  }, [r.showInput]), /* @__PURE__ */ w.jsx(
    Yg,
    {
      ...r.chipProps,
      className: Y(t.label, r.chipProps?.className, {
        active: r.showInput
      }),
      children: r.showInput ? /* @__PURE__ */ w.jsx(Bi, { onClickAway: o, children: /* @__PURE__ */ w.jsx(
        "span",
        {
          className: t.input,
          role: "textbox",
          contentEditable: !0,
          ref: e,
          suppressContentEditableWarning: !0,
          spellCheck: !1,
          dangerouslySetInnerHTML: { __html: n.current },
          onKeyDown: i,
          onInput: a
        }
      ) }) : /* @__PURE__ */ w.jsx(R.Fragment, { children: typeof r.children == "string" ? r.defaultInputValue : r.children })
    }
  );
}, FE = je((r) => ({
  label: {
    "&.active": {
      "& .MuiChip-label": {
        display: "flex",
        textOverflow: "initial",
        overflow: "hidden"
      }
    }
  },
  input: {
    minWidth: r.spacing(10),
    border: "none",
    background: "unset",
    outline: "none",
    marginBottom: "0 !important",
    display: "block"
  }
}));
var ti = {}, Gp;
function _E() {
  if (Gp) return ti;
  Gp = 1;
  var r = wt();
  Object.defineProperty(ti, "__esModule", {
    value: !0
  }), ti.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return ti.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
  }), "ErrorOutlineOutlined"), ti;
}
var $E = /* @__PURE__ */ _E();
const Kg = /* @__PURE__ */ gt($E), wd = R.forwardRef(
  (r, e) => /* @__PURE__ */ w.jsx("span", { ref: e, ...r, children: /* @__PURE__ */ w.jsxs(
    "svg",
    {
      width: "25",
      height: "25",
      viewBox: "0 0 25 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M11.7188 11.7188H12.5V17.1875H13.2812",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M12.5 9.375C13.1472 9.375 13.6719 8.85033 13.6719 8.20312C13.6719 7.55592 13.1472 7.03125 12.5 7.03125C11.8528 7.03125 11.3281 7.55592 11.3281 8.20312C11.3281 8.85033 11.8528 9.375 12.5 9.375Z",
            fill: "currentColor"
          }
        )
      ]
    }
  ) })
);
wd.displayName = "InfoIcon";
const Zg = R.forwardRef(
  (r, e) => /* @__PURE__ */ w.jsx("span", { ref: e, style: { width: 25, height: 25 }, ...r, children: /* @__PURE__ */ w.jsxs(
    "svg",
    {
      width: "25",
      height: "25",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M26.9995 7L4.99951 7.00001",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M13 13V21",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M19 13V21",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M11 3H21",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ w.jsx(
          "path",
          {
            d: "M24.9995 7.00001V26C24.9995 26.2652 24.8942 26.5196 24.7066 26.7071C24.5191 26.8946 24.2647 27 23.9995 27H7.99951C7.7343 27 7.47994 26.8946 7.29241 26.7071C7.10487 26.5196 6.99951 26.2652 6.99951 26V7",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  ) })
);
Zg.displayName = "TrashIcon";
const WE = R.forwardRef(
  (r, e) => /* @__PURE__ */ w.jsx("span", { ref: e, ...r, children: /* @__PURE__ */ w.jsx(
    "svg",
    {
      width: "25",
      height: "25",
      viewBox: "0 0 25 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ w.jsx(
        "path",
        {
          d: "M17.7083 16.6667L13.5417 12.5V9.1875C14.75 8.75 15.625 7.60417 15.625 6.25C15.625 4.52083 14.2292 3.125 12.5 3.125C10.7708 3.125 9.375 4.52083 9.375 6.25C9.375 7.60417 10.25 8.75 11.4583 9.1875V12.5L7.29167 16.6667H3.125V21.875H8.33333V18.6979L12.5 14.3229L16.6667 18.6979V21.875H21.875V16.6667H17.7083Z",
          fill: "currentColor"
        }
      )
    }
  ) })
);
WE.displayName = "GotoIcon";
const HE = ({
  charLimit: r,
  children: e
}) => r ? /* @__PURE__ */ w.jsx(at, { position: "relative", children: e }) : /* @__PURE__ */ w.jsx(R.Fragment, {}), Is = R.forwardRef(
  ({
    id: r,
    label: e,
    charLimit: t,
    disabled: n,
    multiline: o = !1,
    onChange: i,
    onEnter: a,
    onKeyDown: s,
    error: c,
    endIcon: d,
    helperText: u,
    fullWidth: p,
    rows: h = 4,
    value: f,
    wrapperRef: m,
    tooltip: g,
    ...b
  }, x) => {
    const {
      labelClass: v,
      helperTextClass: y,
      limitTextClass: C,
      tooltipIcon: k,
      ...T
    } = YE({
      error: c,
      disabled: n,
      multiline: o
    }), S = (P) => {
      s?.(P), (P.keyCode === 13 || P.key === "Enter") && a && (a(P), !o && P.preventDefault());
    }, O = (P) => {
      i?.(t ? {
        ...P,
        target: { ...P.target, value: P.target.value.slice(0, t) }
      } : P);
    };
    return /* @__PURE__ */ w.jsxs(Rs, { fullWidth: p, ref: m, children: [
      e && /* @__PURE__ */ w.jsxs(ed, { className: v, htmlFor: r, children: [
        e,
        g && /* @__PURE__ */ w.jsx(Es, { title: g, children: /* @__PURE__ */ w.jsx(wd, { className: k }) })
      ] }),
      /* @__PURE__ */ w.jsxs(HE, { charLimit: !0, children: [
        /* @__PURE__ */ w.jsx(
          Ps,
          {
            ...b,
            id: r,
            classes: T,
            disabled: n,
            endAdornment: c ? /* @__PURE__ */ w.jsx(Kg, {}) : d,
            fullWidth: p,
            multiline: o,
            onKeyDown: S,
            onChange: O,
            inputRef: x,
            rows: h,
            value: f
          }
        ),
        t && f ? /* @__PURE__ */ w.jsxs(
          We,
          {
            color: c ? "error" : "primary",
            variant: "caption",
            className: C,
            children: [
              f?.length || 0,
              "/",
              t
            ]
          }
        ) : /* @__PURE__ */ w.jsx(w.Fragment, {})
      ] }),
      u && /* @__PURE__ */ w.jsx(
        We,
        {
          color: c ? "error" : "textPrimary",
          variant: "caption",
          className: y,
          children: u
        }
      )
    ] });
  }
), YE = je(
  (r) => ({
    root: {
      height: ({ multiline: e }) => e ? "auto" : 40,
      borderColor: ({ error: e }) => e ? r.palette.error.main : r.palette.grey[600],
      "&:hover": {
        borderColor: ({ error: e, disabled: t }) => t ? "" : e ? r.palette.error.main : r.palette.primary.main
      },
      "&.Mui-focused": {
        borderColor: ({ error: e }) => e ? r.palette.error.main : r.palette.primary.main
      }
    },
    adornedEnd: {
      color: ({ error: e }) => e ? r.palette.error.main : "",
      "& svg": {
        width: "20px",
        height: "20px"
      }
    },
    labelClass: {
      position: "relative",
      transition: "unset",
      transform: "unset",
      display: "flex",
      gap: r.spacing(1)
    },
    tooltipIcon: {
      color: r.palette.secondary[900],
      "& > svg": {
        width: 20,
        height: 20,
        minWidth: 20,
        minHeight: 20
      }
    },
    helperTextClass: {
      marginTop: 6
    },
    limitTextClass: {
      position: "absolute",
      right: r.spacing(1),
      bottom: r.spacing(0.75)
    }
  })
);
Is.displayName = "TextInput";
const XE = je(
  (r) => ({
    option: {
      width: "100%",
      padding: r.spacing(1, 0, 1, 2),
      fontSize: 16,
      lineHeight: "20px",
      color: r.palette.grey[900],
      '&:hover,&[data-focus="true"],&[aria-selected="true"]': {
        backgroundColor: r.palette.primary[300]
      },
      '&[aria-selected="true"]': {
        fontWeight: 600
      }
    },
    paper: {
      boxShadow: "0px 0px 16px rgb(3 27 137 / 15%)",
      borderRadius: "4px"
    }
  })
), VE = Cf(), Ej = ({
  label: r,
  tooltip: e,
  current: t,
  options: n,
  disabled: o,
  formatCreateLabel: i,
  isOptionDisabled: a,
  isValidNewOption: s,
  className: c,
  placeholder: d,
  dataTest: u,
  showError: p,
  required: h,
  onChange: f,
  onCreateOption: m,
  renderOption: g,
  renderGroup: b,
  groupBy: x,
  classes: v,
  limitTags: y,
  multiple: C,
  renderTags: k,
  inputValue: T,
  onInputChange: S,
  disableCreateOption: O,
  error: P,
  helperText: M,
  freeSolo: I = !0,
  isOptionEqualToValue: E
}) => {
  const N = XE(), L = p && h && !t ? "Input field must not be empty" : null, z = (D, W) => {
    typeof W == "string" ? m(W) : W && W.inputValue ? m(W.inputValue) : f(W);
  }, F = (D, W) => {
    const G = VE(D, W);
    if (!O && W.inputValue !== "" && i) {
      if (s && !s(W.inputValue, D))
        return G;
      G.unshift({
        label: i(W.inputValue, s),
        inputValue: W.inputValue
      });
    }
    return G;
  }, B = (D) => typeof D == "string" ? D : D.inputValue ? D.inputValue : D.label || "";
  return /* @__PURE__ */ w.jsx("div", { className: c, children: /* @__PURE__ */ w.jsx(
    jf,
    {
      limitTags: y,
      multiple: C,
      renderTags: k,
      freeSolo: I,
      clearOnBlur: !0,
      selectOnFocus: !0,
      clearOnEscape: !0,
      handleHomeEndKeys: !0,
      value: t,
      options: n,
      disabled: o,
      getOptionLabel: B,
      renderOption: g ? ({ key: D, ...W }, G) => /* @__PURE__ */ w.jsx("li", { ...W, children: g(G) }, D) : void 0,
      renderGroup: b,
      inputValue: T,
      onInputChange: S,
      groupBy: x,
      filterOptions: F,
      getOptionDisabled: (D) => a?.(D) || !1,
      onChange: z,
      isOptionEqualToValue: E,
      classes: {
        ...v,
        option: Y(N.option, v?.option),
        paper: Y(N.paper, v?.paper)
      },
      renderInput: ({
        InputProps: { ref: D, className: W, ...G },
        inputProps: re,
        id: ce,
        fullWidth: Ce,
        disabled: ne
      }) => /* @__PURE__ */ w.jsx(
        Is,
        {
          ...G,
          id: ce,
          wrapperRef: D,
          fullWidth: Ce,
          disabled: ne,
          label: r,
          tooltip: e,
          placeholder: d,
          error: P ?? !!L,
          helperText: M ?? L,
          inputProps: {
            ...re,
            "data-testid": u
          }
        }
      )
    }
  ) });
};
function qe(r) {
  const e = Object.prototype.toString.call(r);
  return r instanceof Date || typeof r == "object" && e === "[object Date]" ? new r.constructor(+r) : typeof r == "number" || e === "[object Number]" || typeof r == "string" || e === "[object String]" ? new Date(r) : /* @__PURE__ */ new Date(NaN);
}
function rr(r, e) {
  return r instanceof Date ? new r.constructor(e) : new Date(e);
}
function rs(r, e) {
  const t = qe(r);
  return isNaN(e) ? rr(r, NaN) : (e && t.setDate(t.getDate() + e), t);
}
function Nr(r, e) {
  const t = qe(r);
  if (isNaN(e)) return rr(r, NaN);
  if (!e)
    return t;
  const n = t.getDate(), o = rr(r, t.getTime());
  o.setMonth(t.getMonth() + e + 1, 0);
  const i = o.getDate();
  return n >= i ? o : (t.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    n
  ), t);
}
const Jg = 6048e5, UE = 864e5;
let GE = {};
function ra() {
  return GE;
}
function _n(r, e) {
  const t = ra(), n = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, o = qe(r), i = o.getDay(), a = (i < n ? 7 : 0) + i - n;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function ns(r) {
  return _n(r, { weekStartsOn: 1 });
}
function Qg(r) {
  const e = qe(r), t = e.getFullYear(), n = rr(r, 0);
  n.setFullYear(t + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const o = ns(n), i = rr(r, 0);
  i.setFullYear(t, 0, 4), i.setHours(0, 0, 0, 0);
  const a = ns(i);
  return e.getTime() >= o.getTime() ? t + 1 : e.getTime() >= a.getTime() ? t : t - 1;
}
function os(r) {
  const e = qe(r);
  return e.setHours(0, 0, 0, 0), e;
}
function qp(r) {
  const e = qe(r), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +r - +t;
}
function qE(r, e) {
  const t = os(r), n = os(e), o = +t - qp(t), i = +n - qp(n);
  return Math.round((o - i) / UE);
}
function KE(r) {
  const e = Qg(r), t = rr(r, 0);
  return t.setFullYear(e, 0, 4), t.setHours(0, 0, 0, 0), ns(t);
}
function ll(r, e) {
  const t = e * 7;
  return rs(r, t);
}
function Kp(r, e) {
  return Nr(r, e * 12);
}
function em(r) {
  let e;
  return r.forEach(function(t) {
    const n = qe(t);
    (e === void 0 || e < n || isNaN(Number(n))) && (e = n);
  }), e || /* @__PURE__ */ new Date(NaN);
}
function tm(r) {
  let e;
  return r.forEach((t) => {
    const n = qe(t);
    (!e || e > n || isNaN(+n)) && (e = n);
  }), e || /* @__PURE__ */ new Date(NaN);
}
function ZE(r) {
  return rr(r, Date.now());
}
function Ur(r, e) {
  const t = os(r), n = os(e);
  return +t == +n;
}
function JE(r) {
  return r instanceof Date || typeof r == "object" && Object.prototype.toString.call(r) === "[object Date]";
}
function rm(r) {
  if (!JE(r) && typeof r != "number")
    return !1;
  const e = qe(r);
  return !isNaN(Number(e));
}
function QE(r, e) {
  const t = qe(r), n = qe(e), o = t.getFullYear() - n.getFullYear(), i = t.getMonth() - n.getMonth();
  return o * 12 + i;
}
function nm(r) {
  const e = qe(r), t = e.getMonth();
  return e.setFullYear(e.getFullYear(), t + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function om(r) {
  const e = qe(r);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function e2(r) {
  const e = qe(r), t = rr(r, 0);
  return t.setFullYear(e.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function im(r, e) {
  const t = ra(), n = t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, o = qe(r), i = o.getDay(), a = (i < n ? -7 : 0) + 6 - (i - n);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
const t2 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, r2 = (r, e, t) => {
  let n;
  const o = t2[r];
  return typeof o == "string" ? n = o : e === 1 ? n = o.one : n = o.other.replace("{{count}}", e.toString()), t?.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function cl(r) {
  return (e = {}) => {
    const t = e.width ? String(e.width) : r.defaultWidth;
    return r.formats[t] || r.formats[r.defaultWidth];
  };
}
const n2 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, o2 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, i2 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, a2 = {
  date: cl({
    formats: n2,
    defaultWidth: "full"
  }),
  time: cl({
    formats: o2,
    defaultWidth: "full"
  }),
  dateTime: cl({
    formats: i2,
    defaultWidth: "full"
  })
}, s2 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, l2 = (r, e, t, n) => s2[r];
function ri(r) {
  return (e, t) => {
    const n = t?.context ? String(t.context) : "standalone";
    let o;
    if (n === "formatting" && r.formattingValues) {
      const a = r.defaultFormattingWidth || r.defaultWidth, s = t?.width ? String(t.width) : a;
      o = r.formattingValues[s] || r.formattingValues[a];
    } else {
      const a = r.defaultWidth, s = t?.width ? String(t.width) : r.defaultWidth;
      o = r.values[s] || r.values[a];
    }
    const i = r.argumentCallback ? r.argumentCallback(e) : e;
    return o[i];
  };
}
const c2 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, d2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, u2 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, p2 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, h2 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, f2 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, g2 = (r, e) => {
  const t = Number(r), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, m2 = {
  ordinalNumber: g2,
  era: ri({
    values: c2,
    defaultWidth: "wide"
  }),
  quarter: ri({
    values: d2,
    defaultWidth: "wide",
    argumentCallback: (r) => r - 1
  }),
  month: ri({
    values: u2,
    defaultWidth: "wide"
  }),
  day: ri({
    values: p2,
    defaultWidth: "wide"
  }),
  dayPeriod: ri({
    values: h2,
    defaultWidth: "wide",
    formattingValues: f2,
    defaultFormattingWidth: "wide"
  })
};
function ni(r) {
  return (e, t = {}) => {
    const n = t.width, o = n && r.matchPatterns[n] || r.matchPatterns[r.defaultMatchWidth], i = e.match(o);
    if (!i)
      return null;
    const a = i[0], s = n && r.parsePatterns[n] || r.parsePatterns[r.defaultParseWidth], c = Array.isArray(s) ? x2(s, (p) => p.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      b2(s, (p) => p.test(a))
    );
    let d;
    d = r.valueCallback ? r.valueCallback(c) : c, d = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(d)
    ) : d;
    const u = e.slice(a.length);
    return { value: d, rest: u };
  };
}
function b2(r, e) {
  for (const t in r)
    if (Object.prototype.hasOwnProperty.call(r, t) && e(r[t]))
      return t;
}
function x2(r, e) {
  for (let t = 0; t < r.length; t++)
    if (e(r[t]))
      return t;
}
function v2(r) {
  return (e, t = {}) => {
    const n = e.match(r.matchPattern);
    if (!n) return null;
    const o = n[0], i = e.match(r.parsePattern);
    if (!i) return null;
    let a = r.valueCallback ? r.valueCallback(i[0]) : i[0];
    a = t.valueCallback ? t.valueCallback(a) : a;
    const s = e.slice(o.length);
    return { value: a, rest: s };
  };
}
const y2 = /^(\d+)(th|st|nd|rd)?/i, w2 = /\d+/i, C2 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, k2 = {
  any: [/^b/i, /^(a|c)/i]
}, S2 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, T2 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, A2 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, O2 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, R2 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, P2 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, M2 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, E2 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, I2 = {
  ordinalNumber: v2({
    matchPattern: y2,
    parsePattern: w2,
    valueCallback: (r) => parseInt(r, 10)
  }),
  era: ni({
    matchPatterns: C2,
    defaultMatchWidth: "wide",
    parsePatterns: k2,
    defaultParseWidth: "any"
  }),
  quarter: ni({
    matchPatterns: S2,
    defaultMatchWidth: "wide",
    parsePatterns: T2,
    defaultParseWidth: "any",
    valueCallback: (r) => r + 1
  }),
  month: ni({
    matchPatterns: A2,
    defaultMatchWidth: "wide",
    parsePatterns: O2,
    defaultParseWidth: "any"
  }),
  day: ni({
    matchPatterns: R2,
    defaultMatchWidth: "wide",
    parsePatterns: P2,
    defaultParseWidth: "any"
  }),
  dayPeriod: ni({
    matchPatterns: M2,
    defaultMatchWidth: "any",
    parsePatterns: E2,
    defaultParseWidth: "any"
  })
}, N2 = {
  code: "en-US",
  formatDistance: r2,
  formatLong: a2,
  formatRelative: l2,
  localize: m2,
  match: I2,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function L2(r) {
  const e = qe(r);
  return qE(e, e2(e)) + 1;
}
function j2(r) {
  const e = qe(r), t = +ns(e) - +KE(e);
  return Math.round(t / Jg) + 1;
}
function am(r, e) {
  const t = qe(r), n = t.getFullYear(), o = ra(), i = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, a = rr(r, 0);
  a.setFullYear(n + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = _n(a, e), c = rr(r, 0);
  c.setFullYear(n, 0, i), c.setHours(0, 0, 0, 0);
  const d = _n(c, e);
  return t.getTime() >= s.getTime() ? n + 1 : t.getTime() >= d.getTime() ? n : n - 1;
}
function D2(r, e) {
  const t = ra(), n = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? t.firstWeekContainsDate ?? t.locale?.options?.firstWeekContainsDate ?? 1, o = am(r, e), i = rr(r, 0);
  return i.setFullYear(o, 0, n), i.setHours(0, 0, 0, 0), _n(i, e);
}
function z2(r, e) {
  const t = qe(r), n = +_n(t, e) - +D2(t, e);
  return Math.round(n / Jg) + 1;
}
function ct(r, e) {
  const t = r < 0 ? "-" : "", n = Math.abs(r).toString().padStart(e, "0");
  return t + n;
}
const en = {
  // Year
  y(r, e) {
    const t = r.getFullYear(), n = t > 0 ? t : 1 - t;
    return ct(e === "yy" ? n % 100 : n, e.length);
  },
  // Month
  M(r, e) {
    const t = r.getMonth();
    return e === "M" ? String(t + 1) : ct(t + 1, 2);
  },
  // Day of the month
  d(r, e) {
    return ct(r.getDate(), e.length);
  },
  // AM or PM
  a(r, e) {
    const t = r.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(r, e) {
    return ct(r.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(r, e) {
    return ct(r.getHours(), e.length);
  },
  // Minute
  m(r, e) {
    return ct(r.getMinutes(), e.length);
  },
  // Second
  s(r, e) {
    return ct(r.getSeconds(), e.length);
  },
  // Fraction of second
  S(r, e) {
    const t = e.length, n = r.getMilliseconds(), o = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return ct(o, e.length);
  }
}, Kn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Zp = {
  // Era
  G: function(r, e, t) {
    const n = r.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(r, e, t) {
    if (e === "yo") {
      const n = r.getFullYear(), o = n > 0 ? n : 1 - n;
      return t.ordinalNumber(o, { unit: "year" });
    }
    return en.y(r, e);
  },
  // Local week-numbering year
  Y: function(r, e, t, n) {
    const o = am(r, n), i = o > 0 ? o : 1 - o;
    if (e === "YY") {
      const a = i % 100;
      return ct(a, 2);
    }
    return e === "Yo" ? t.ordinalNumber(i, { unit: "year" }) : ct(i, e.length);
  },
  // ISO week-numbering year
  R: function(r, e) {
    const t = Qg(r);
    return ct(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(r, e) {
    const t = r.getFullYear();
    return ct(t, e.length);
  },
  // Quarter
  Q: function(r, e, t) {
    const n = Math.ceil((r.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return ct(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(r, e, t) {
    const n = Math.ceil((r.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return ct(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(r, e, t) {
    const n = r.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return en.M(r, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(r, e, t) {
    const n = r.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return ct(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(r, e, t, n) {
    const o = z2(r, n);
    return e === "wo" ? t.ordinalNumber(o, { unit: "week" }) : ct(o, e.length);
  },
  // ISO week of year
  I: function(r, e, t) {
    const n = j2(r);
    return e === "Io" ? t.ordinalNumber(n, { unit: "week" }) : ct(n, e.length);
  },
  // Day of the month
  d: function(r, e, t) {
    return e === "do" ? t.ordinalNumber(r.getDate(), { unit: "date" }) : en.d(r, e);
  },
  // Day of year
  D: function(r, e, t) {
    const n = L2(r);
    return e === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : ct(n, e.length);
  },
  // Day of week
  E: function(r, e, t) {
    const n = r.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(r, e, t, n) {
    const o = r.getDay(), i = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return ct(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(i, { unit: "day" });
      case "eee":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(r, e, t, n) {
    const o = r.getDay(), i = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return ct(i, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return t.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(o, {
          width: "short",
          context: "standalone"
        });
      default:
        return t.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(r, e, t) {
    const n = r.getDay(), o = n === 0 ? 7 : n;
    switch (e) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return ct(o, e.length);
      // 2nd
      case "io":
        return t.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(r, e, t) {
    const o = r.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(r, e, t) {
    const n = r.getHours();
    let o;
    switch (n === 12 ? o = Kn.noon : n === 0 ? o = Kn.midnight : o = n / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(r, e, t) {
    const n = r.getHours();
    let o;
    switch (n >= 17 ? o = Kn.evening : n >= 12 ? o = Kn.afternoon : n >= 4 ? o = Kn.morning : o = Kn.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(r, e, t) {
    if (e === "ho") {
      let n = r.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return en.h(r, e);
  },
  // Hour [0-23]
  H: function(r, e, t) {
    return e === "Ho" ? t.ordinalNumber(r.getHours(), { unit: "hour" }) : en.H(r, e);
  },
  // Hour [0-11]
  K: function(r, e, t) {
    const n = r.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : ct(n, e.length);
  },
  // Hour [1-24]
  k: function(r, e, t) {
    let n = r.getHours();
    return n === 0 && (n = 24), e === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : ct(n, e.length);
  },
  // Minute
  m: function(r, e, t) {
    return e === "mo" ? t.ordinalNumber(r.getMinutes(), { unit: "minute" }) : en.m(r, e);
  },
  // Second
  s: function(r, e, t) {
    return e === "so" ? t.ordinalNumber(r.getSeconds(), { unit: "second" }) : en.s(r, e);
  },
  // Fraction of second
  S: function(r, e) {
    return en.S(r, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(r, e, t) {
    const n = r.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return Qp(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return wn(n);
      // Hours and minutes with `:` delimiter
      default:
        return wn(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return Qp(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return wn(n);
      // Hours and minutes with `:` delimiter
      default:
        return wn(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Jp(n, ":");
      default:
        return "GMT" + wn(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(r, e, t) {
    const n = r.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Jp(n, ":");
      default:
        return "GMT" + wn(n, ":");
    }
  },
  // Seconds timestamp
  t: function(r, e, t) {
    const n = Math.trunc(r.getTime() / 1e3);
    return ct(n, e.length);
  },
  // Milliseconds timestamp
  T: function(r, e, t) {
    const n = r.getTime();
    return ct(n, e.length);
  }
};
function Jp(r, e = "") {
  const t = r > 0 ? "-" : "+", n = Math.abs(r), o = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? t + String(o) : t + String(o) + e + ct(i, 2);
}
function Qp(r, e) {
  return r % 60 === 0 ? (r > 0 ? "-" : "+") + ct(Math.abs(r) / 60, 2) : wn(r, e);
}
function wn(r, e = "") {
  const t = r > 0 ? "-" : "+", n = Math.abs(r), o = ct(Math.trunc(n / 60), 2), i = ct(n % 60, 2);
  return t + o + e + i;
}
const eh = (r, e) => {
  switch (r) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    default:
      return e.date({ width: "full" });
  }
}, sm = (r, e) => {
  switch (r) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    default:
      return e.time({ width: "full" });
  }
}, B2 = (r, e) => {
  const t = r.match(/(P+)(p+)?/) || [], n = t[1], o = t[2];
  if (!o)
    return eh(r, e);
  let i;
  switch (n) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", eh(n, e)).replace("{{time}}", sm(o, e));
}, F2 = {
  p: sm,
  P: B2
}, _2 = /^D+$/, $2 = /^Y+$/, W2 = ["D", "DD", "YY", "YYYY"];
function H2(r) {
  return _2.test(r);
}
function Y2(r) {
  return $2.test(r);
}
function X2(r, e, t) {
  const n = V2(r, e, t);
  if (console.warn(n), W2.includes(r)) throw new RangeError(n);
}
function V2(r, e, t) {
  const n = r[0] === "Y" ? "years" : "days of the month";
  return `Use \`${r.toLowerCase()}\` instead of \`${r}\` (in \`${e}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const U2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, G2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, q2 = /^'([^]*?)'?$/, K2 = /''/g, Z2 = /[a-zA-Z]/;
function ec(r, e, t) {
  const n = ra(), o = n.locale ?? N2, i = n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, a = n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, s = qe(r);
  if (!rm(s))
    throw new RangeError("Invalid time value");
  let c = e.match(G2).map((u) => {
    const p = u[0];
    if (p === "p" || p === "P") {
      const h = F2[p];
      return h(u, o.formatLong);
    }
    return u;
  }).join("").match(U2).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const p = u[0];
    if (p === "'")
      return { isToken: !1, value: J2(u) };
    if (Zp[p])
      return { isToken: !0, value: u };
    if (p.match(Z2))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + p + "`"
      );
    return { isToken: !1, value: u };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(s, c));
  const d = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return c.map((u) => {
    if (!u.isToken) return u.value;
    const p = u.value;
    (Y2(p) || H2(p)) && X2(p, e, String(r));
    const h = Zp[p[0]];
    return h(s, p, o.localize, d);
  }).join("");
}
function J2(r) {
  const e = r.match(q2);
  return e ? e[1].replace(K2, "'") : r;
}
function Q2(r) {
  return qe(r).getDate();
}
function eI(r) {
  const e = qe(r), t = e.getFullYear(), n = e.getMonth(), o = rr(r, 0);
  return o.setFullYear(t, n + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function tI(r) {
  return qe(r).getMonth();
}
function rI(r) {
  return qe(r).getFullYear();
}
function th(r, e) {
  const t = qe(r), n = qe(e);
  return t.getTime() > n.getTime();
}
function wi(r, e) {
  const t = qe(r), n = qe(e);
  return +t < +n;
}
function Cd(r, e) {
  const t = qe(r), n = qe(e);
  return t.getFullYear() === n.getFullYear() && t.getMonth() === n.getMonth();
}
function nI(r) {
  return Ur(r, ZE(r));
}
function kd(r, e) {
  const t = +qe(r), [n, o] = [
    +qe(e.start),
    +qe(e.end)
  ].sort((i, a) => i - a);
  return t >= n && t <= o;
}
function oI(r, e) {
  const t = qe(r), n = t.getFullYear(), o = t.getDate(), i = rr(r, 0);
  i.setFullYear(n, e, 15), i.setHours(0, 0, 0, 0);
  const a = eI(i);
  return t.setMonth(e, Math.min(o, a)), t;
}
function iI(r, e) {
  const t = qe(r);
  return isNaN(+t) ? rr(r, NaN) : (t.setFullYear(e), t);
}
var oi = {}, rh;
function aI() {
  if (rh) return oi;
  rh = 1;
  var r = wt();
  Object.defineProperty(oi, "__esModule", {
    value: !0
  }), oi.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return oi.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4z"
  }), "ArrowRightAlt"), oi;
}
var sI = /* @__PURE__ */ aI();
const lI = /* @__PURE__ */ gt(sI), cI = je((r) => ({
  listContainer: {
    marginLeft: "5px"
  },
  listItem: {
    border: `1px solid ${r.palette.primary[400]}`,
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: "5px",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: r.palette.primary[400]
    }
  },
  selected: {
    color: r.palette.common.white,
    backgroundColor: `${r.palette.primary[900]} !important`
  }
})), nh = (r, e) => {
  const { startDate: t, endDate: n } = r, { startDate: o, endDate: i } = e;
  return t && o && n && i ? Ur(t, o) && Ur(n, i) : !1;
}, dI = ({
  ranges: r,
  setRange: e,
  selectedRange: t
}) => {
  const n = cI();
  return /* @__PURE__ */ w.jsx(rd, { className: n.listContainer, children: r.map((o, i) => /* @__PURE__ */ w.jsx(
    Zf,
    {
      button: !0,
      onClick: () => e(o),
      className: n.listItem,
      classes: {
        selected: n.selected
      },
      selected: nh(o, t),
      children: /* @__PURE__ */ w.jsx(
        Jf,
        {
          primaryTypographyProps: {
            variant: "body2",
            style: {
              textAlign: "center",
              fontWeight: nh(o, t) ? "bold" : "normal"
            }
          },
          children: o.label
        }
      )
    },
    i
  )) });
}, uI = je((r) => ({
  leftBorderRadius: {
    borderRadius: "50% 0 0 50%"
  },
  rightBorderRadius: {
    borderRadius: "0 50% 50% 0"
  },
  buttonContainer: {
    display: "flex"
  },
  button: {
    height: 26,
    width: 26,
    padding: 0
  },
  buttonText: {
    lineHeight: 1.6
  },
  outlined: {
    border: `1px solid ${r.palette.primary.dark}`
  },
  filled: {
    "&:hover": {
      backgroundColor: r.palette.primary[900]
    },
    backgroundColor: r.palette.primary[900]
  },
  highlighted: {
    backgroundColor: r.palette.primary[500]
  },
  contrast: {
    color: r.palette.primary.contrastText
  }
})), pI = ({
  startOfRange: r,
  endOfRange: e,
  disabled: t,
  highlighted: n,
  outlined: o,
  filled: i,
  onClick: a,
  onHover: s,
  value: c
}) => {
  const d = uI();
  return /* @__PURE__ */ w.jsx(
    "div",
    {
      className: Y(
        d.buttonContainer,
        r && d.leftBorderRadius,
        e && d.rightBorderRadius,
        !t && n && d.highlighted
      ),
      children: /* @__PURE__ */ w.jsx(
        jt,
        {
          className: Y(
            d.button,
            !t && o && d.outlined,
            !t && i && d.filled
          ),
          disabled: t,
          onClick: a,
          onMouseOver: s,
          children: /* @__PURE__ */ w.jsx(
            We,
            {
              color: t ? "textSecondary" : "textPrimary",
              className: Y(
                d.buttonText,
                !t && i && d.contrast
              ),
              variant: "body2",
              children: c
            }
          )
        }
      )
    }
  );
};
var ii = {}, oh;
function hI() {
  if (oh) return ii;
  oh = 1;
  var r = wt();
  Object.defineProperty(ii, "__esModule", {
    value: !0
  }), ii.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return ii.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
  }), "ChevronLeft"), ii;
}
var fI = /* @__PURE__ */ hI();
const gI = /* @__PURE__ */ gt(fI);
var ai = {}, ih;
function mI() {
  if (ih) return ai;
  ih = 1;
  var r = wt();
  Object.defineProperty(ai, "__esModule", {
    value: !0
  }), ai.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return ai.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }), "ChevronRight"), ai;
}
var bI = /* @__PURE__ */ mI();
const xI = /* @__PURE__ */ gt(bI), vI = je(
  () => ({
    icon: {
      padding: 10,
      "&:hover": {
        background: "none"
      }
    },
    menuItem: {
      // @ts-ignore
      float: "none !important"
    }
  })
), yI = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
], wI = (r, e) => {
  const t = Math.floor(e / 2);
  return Array(e).fill(0).map((n, o) => r.getFullYear() - t + o);
}, CI = ({
  date: r,
  setDate: e,
  nextDisabled: t,
  prevDisabled: n,
  onClickNext: o,
  onClickPrevious: i
}) => {
  const a = vI(), s = (d) => {
    e(oI(r, parseInt(d.target.value, 10)));
  }, c = (d) => {
    e(iI(r, parseInt(d.target.value, 10)));
  };
  return /* @__PURE__ */ w.jsxs(it, { container: !0, justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ w.jsx(it, { item: !0, children: /* @__PURE__ */ w.jsx(
      jt,
      {
        className: a.icon,
        disabled: n,
        onClick: i,
        children: /* @__PURE__ */ w.jsx(gI, { color: n ? "disabled" : "action" })
      }
    ) }),
    /* @__PURE__ */ w.jsx(it, { item: !0, children: /* @__PURE__ */ w.jsx(
      bo,
      {
        size: "small",
        variant: "standard",
        value: tI(r),
        onChange: s,
        MenuProps: { disablePortal: !0 },
        children: yI.map((d, u) => /* @__PURE__ */ w.jsx(mo, { value: u, className: a.menuItem, children: d }, d))
      }
    ) }),
    /* @__PURE__ */ w.jsx(it, { item: !0, children: /* @__PURE__ */ w.jsx(
      bo,
      {
        size: "small",
        variant: "standard",
        value: rI(r),
        onChange: c,
        MenuProps: { disablePortal: !0 },
        children: wI(r, 30).map((d) => /* @__PURE__ */ w.jsx(mo, { value: d, className: a.menuItem, children: d }, d))
      }
    ) }),
    /* @__PURE__ */ w.jsx(it, { item: !0, children: /* @__PURE__ */ w.jsx(
      jt,
      {
        className: a.icon,
        disabled: t,
        onClick: o,
        children: /* @__PURE__ */ w.jsx(xI, { color: t ? "disabled" : "action" })
      }
    ) })
  ] });
};
var tc = /* @__PURE__ */ ((r) => (r[r.Previous = -1] = "Previous", r[r.Next = 1] = "Next", r))(tc || {});
const rc = {
  FIRST_MONTH: /* @__PURE__ */ Symbol("firstMonth"),
  SECOND_MONTH: /* @__PURE__ */ Symbol("secondMonth")
}, kI = (r, e) => Array.from(
  { length: Math.ceil(r.length / e) },
  (t, n) => r.slice(n * e, n * e + e)
), SI = (r) => {
  const e = _n(om(r)), t = im(nm(r)), n = [];
  for (let o = e; wi(o, t); )
    n.push(o), o = rs(o, 1);
  return n;
}, TI = ({ startDate: r }, e) => r && Ur(e, r), AI = ({ endDate: r }, e) => r && Ur(e, r), OI = ({ startDate: r, endDate: e }, t) => r && e && (kd(t, { start: r, end: e }) || Ur(t, r) || Ur(t, e)), RI = ({ startDate: r, endDate: e }) => r && e ? Ur(r, e) : !1, ah = (r, e) => {
  if (r) {
    const t = new Date(r);
    if (rm(t)) return t;
  }
  return e;
}, PI = (r, e, t) => {
  const { startDate: n, endDate: o } = r;
  if (n && o) {
    const i = em([n, e]), a = tm([o, t]);
    return [
      i,
      Cd(i, a) ? Nr(i, 1) : a
    ];
  }
  return [n, o];
}, MI = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], EI = je(() => ({
  root: {
    width: 230
  },
  weekDaysContainer: {
    marginTop: 10,
    paddingLeft: 30,
    paddingRight: 30
  },
  daysContainer: {
    paddingLeft: 15,
    paddingRight: 15,
    marginTop: 15,
    marginBottom: 20
  }
})), sh = (r) => {
  const e = EI(), {
    helpers: t,
    handlers: n,
    value: o,
    dateRange: i,
    marker: a,
    setValue: s,
    minDate: c,
    maxDate: d
  } = r, [u, p] = r.navState;
  return /* @__PURE__ */ w.jsx(Wt, { square: !0, elevation: 0, className: e.root, children: /* @__PURE__ */ w.jsxs(it, { container: !0, children: [
    /* @__PURE__ */ w.jsx(
      CI,
      {
        date: o,
        setDate: s,
        nextDisabled: !p,
        prevDisabled: !u,
        onClickPrevious: () => n.onMonthNavigate(a, tc.Previous),
        onClickNext: () => n.onMonthNavigate(a, tc.Next)
      }
    ),
    /* @__PURE__ */ w.jsx(
      it,
      {
        item: !0,
        container: !0,
        direction: "row",
        justifyContent: "space-between",
        className: e.weekDaysContainer,
        children: MI.map((h) => /* @__PURE__ */ w.jsx(We, { color: "textSecondary", variant: "caption", children: h }, h))
      }
    ),
    /* @__PURE__ */ w.jsx(
      it,
      {
        item: !0,
        container: !0,
        direction: "column",
        justifyContent: "space-between",
        className: e.daysContainer,
        children: kI(SI(o), 7).map((h, f) => /* @__PURE__ */ w.jsx(it, { container: !0, direction: "row", justifyContent: "center", children: h.map((m) => {
          const g = TI(i, m), b = AI(i, m), x = RI(i), v = OI(i, m) || t.inHoverRange(m);
          return /* @__PURE__ */ w.jsx(
            pI,
            {
              filled: g || b,
              outlined: nI(m),
              highlighted: v && !x,
              disabled: !Cd(o, m) || !kd(m, { start: c, end: d }),
              startOfRange: g && !x,
              endOfRange: b && !x,
              onClick: () => n.onDayClick(m),
              onHover: () => n.onDayHover(m),
              value: Q2(m)
            },
            ec(m, "MM-dd-yyyy")
          );
        }) }, f))
      }
    )
  ] }) });
}, II = je((r) => ({
  menuContainer: {
    borderRadius: "10px",
    border: `1px solid ${r.palette.primary[900]}`,
    padding: "2px"
  },
  header: {
    padding: "20px 70px"
  },
  headerItem: {
    flex: 1,
    textAlign: "center"
  },
  divider: {
    borderLeft: `1px solid ${r.palette.action.hover}`,
    marginBottom: 20
  },
  gripMenuButtons: {
    [r.breakpoints.up(720)]: {
      marginLeft: "10px"
    },
    [r.breakpoints.down(720)]: {
      margin: "auto"
    }
  },
  dateRangeText: {
    marginLeft: "7px",
    fontWeight: 550
  }
})), NI = (r) => {
  const e = II(), t = yr(), n = $b(t.breakpoints.up(720)), {
    ranges: o,
    dateRange: i,
    minDate: a,
    maxDate: s,
    firstMonth: c,
    setFirstMonth: d,
    secondMonth: u,
    setSecondMonth: p,
    setDateRange: h,
    helpers: f,
    handlers: m,
    onCancel: g,
    onDone: b
  } = r, { startDate: x, endDate: v } = i, y = QE(u, c) >= 2, C = {
    dateRange: i,
    minDate: a,
    maxDate: s,
    helpers: f,
    handlers: m
  };
  return /* @__PURE__ */ w.jsx(Wt, { elevation: 1, className: e.menuContainer, children: /* @__PURE__ */ w.jsxs(it, { container: !0, direction: "row", wrap: n ? "nowrap" : "wrap", children: [
    /* @__PURE__ */ w.jsxs(it, { children: [
      /* @__PURE__ */ w.jsxs(it, { container: !0, className: e.header, alignItems: "center", children: [
        /* @__PURE__ */ w.jsx(it, { item: !0, className: e.headerItem, children: /* @__PURE__ */ w.jsx(We, { variant: "subtitle1", children: x ? ec(x, "MMMM dd, yyyy") : "Start Date" }) }),
        /* @__PURE__ */ w.jsx(it, { item: !0, className: e.headerItem, children: /* @__PURE__ */ w.jsx(lI, { color: "action" }) }),
        /* @__PURE__ */ w.jsx(it, { item: !0, className: e.headerItem, children: /* @__PURE__ */ w.jsx(We, { variant: "subtitle1", children: v ? ec(v, "MMMM dd, yyyy") : "End Date" }) })
      ] }),
      /* @__PURE__ */ w.jsx(qc, {}),
      /* @__PURE__ */ w.jsxs(
        it,
        {
          container: !0,
          direction: "row",
          justifyContent: "center",
          wrap: n ? "nowrap" : "wrap",
          children: [
            /* @__PURE__ */ w.jsx(
              sh,
              {
                ...C,
                value: c,
                setValue: d,
                navState: [!0, y],
                marker: rc.FIRST_MONTH
              }
            ),
            /* @__PURE__ */ w.jsx("div", { className: e.divider }),
            /* @__PURE__ */ w.jsx(
              sh,
              {
                ...C,
                value: u,
                setValue: p,
                navState: [y, !0],
                marker: rc.SECOND_MONTH
              }
            )
          ]
        }
      )
    ] }),
    /* @__PURE__ */ w.jsx("div", { className: e.divider }),
    /* @__PURE__ */ w.jsxs(it, { className: e.gripMenuButtons, children: [
      /* @__PURE__ */ w.jsx(We, { variant: "subtitle1", className: e.dateRangeText, children: "Date Range" }),
      /* @__PURE__ */ w.jsx(
        dI,
        {
          selectedRange: i,
          ranges: o,
          setRange: h
        }
      ),
      r.children,
      /* @__PURE__ */ w.jsxs(Zc, { direction: "row", alignItems: "center", gap: 1, mt: 1, children: [
        /* @__PURE__ */ w.jsx(
          Vr,
          {
            variant: "outlined",
            size: "small",
            onClick: g,
            sx: {
              borderRadius: "50px !important",
              height: "28px !important"
            },
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ w.jsx(
          Vr,
          {
            variant: "contained",
            size: "small",
            color: "secondary",
            onClick: b,
            sx: {
              borderRadius: "50px !important",
              height: "28px !important"
            },
            children: "Done"
          }
        )
      ] })
    ] })
  ] }) });
}, LI = (r) => [
  {
    label: "Today",
    startDate: r,
    endDate: r
  },
  {
    label: "Yesterday",
    startDate: rs(r, -1),
    endDate: rs(r, -1)
  },
  // {
  //   label: 'This Week',
  //   startDate: startOfWeek(date),
  //   endDate: endOfWeek(date),
  // },
  {
    label: "Last Week",
    startDate: _n(ll(r, -1)),
    endDate: im(ll(r, -1))
  },
  {
    label: "Last Month",
    startDate: om(Nr(r, -1)),
    endDate: nm(Nr(r, -1))
  },
  {
    label: "Last 7 Days",
    startDate: ll(r, -1),
    endDate: r
  },
  // {
  //   label: 'This Month',
  //   startDate: startOfMonth(date),
  //   endDate: endOfMonth(date),
  // },
  {
    label: "Last 30 Days",
    startDate: Nr(r, -1),
    endDate: r
  }
], jI = (r) => {
  const e = /* @__PURE__ */ new Date(), {
    open: t,
    onChange: n,
    initialDateRange: o,
    minDate: i,
    maxDate: a,
    definedRanges: s = LI(/* @__PURE__ */ new Date()),
    onDone: c,
    onCancel: d
  } = r, u = ah(i, Kp(e, -10)), p = ah(a, Kp(e, 10)), [h, f] = PI(
    o || {},
    u,
    p
  ), [m, g] = R.useState({
    ...o
  }), [b, x] = R.useState(), [v, y] = R.useState(
    h || e
  ), [C, k] = R.useState(
    f || Nr(v, 1)
  ), { startDate: T, endDate: S } = m, O = (B) => {
    wi(B, C) && y(B);
  }, P = (B) => {
    th(B, v) && k(B);
  }, M = (B) => {
    let { startDate: D, endDate: W } = B;
    if (D && W)
      B.startDate = D = em([D, u]), B.endDate = W = tm([W, p]), g(B), n?.(B), y(D), k(
        Cd(D, W) ? Nr(D, 1) : W
      );
    else {
      const G = {};
      g(G), n?.(G), y(e), k(Nr(v, 1));
    }
  }, I = (B) => {
    if (T && !S && !wi(B, T)) {
      const D = { startDate: T, endDate: B };
      n?.(D), g(D);
    } else
      g({ startDate: B, endDate: void 0 });
    x(B);
  }, E = (B, D) => {
    if (B === rc.FIRST_MONTH) {
      const W = Nr(v, D);
      wi(W, C) && y(W);
    } else {
      const W = Nr(C, D);
      wi(v, W) && k(W);
    }
  }, N = (B) => {
    T && !S && (!b || !Ur(B, b)) && x(B);
  }, z = {
    inHoverRange: (B) => T && !S && b && th(b, T) && kd(B, { start: T, end: b })
  }, F = {
    onDayClick: I,
    onDayHover: N,
    onMonthNavigate: E
  };
  return t ? /* @__PURE__ */ w.jsx(
    NI,
    {
      dateRange: m,
      minDate: u,
      maxDate: p,
      ranges: s,
      firstMonth: v,
      secondMonth: C,
      setFirstMonth: O,
      setSecondMonth: P,
      setDateRange: M,
      helpers: z,
      handlers: F,
      onDone: () => c(m),
      onCancel: d,
      children: r.children
    }
  ) : null;
}, DI = je((r) => ({
  dateRangePickerContainer: {
    position: "relative",
    [r.breakpoints.up(720)]: {
      width: "680px"
    }
  },
  dateRangePicker: {
    position: "relative",
    zIndex: 1e3
  },
  dateRangeBackdrop: {
    position: "fixed",
    height: "100vh",
    width: "100vw",
    bottom: 0,
    zIndex: 0,
    right: 0,
    left: 0,
    top: 0
  }
})), zI = (r) => {
  const e = DI(), { closeOnClickOutside: t, wrapperClassName: n, toggle: o, open: i } = r, a = () => {
    t !== !1 && o();
  }, s = (c) => c?.key === "Escape" && a();
  return /* @__PURE__ */ w.jsxs("div", { className: e.dateRangePickerContainer, children: [
    i && /* @__PURE__ */ w.jsx(
      "div",
      {
        className: e.dateRangeBackdrop,
        onKeyPress: s,
        onClick: a
      }
    ),
    /* @__PURE__ */ w.jsx("div", { className: Y(e.dateRangePicker, n), children: /* @__PURE__ */ w.jsx(jI, { ...r }) })
  ] });
};
let Aa = 0;
const lh = "materialui-daterange-picker", BI = (r, e) => (Aa += 1, Aa > 1e10 && console.warn(
  [
    "Material-UI: you might have a memory leak.",
    "The ruleCounter is not supposed to grow that much."
  ].join("")
), e && e.options.meta ? `${lh}-${e.options.meta}-${r.key}-${Aa}` : `${lh}-${r.key}-${Aa}`), Ij = (r) => /* @__PURE__ */ w.jsx(ts, { generateClassName: BI, children: /* @__PURE__ */ w.jsx(zI, { ...r }) }), Nj = ({
  name: r,
  value: e,
  className: t,
  onBlur: n,
  onEnter: o,
  onChange: i
}) => {
  const a = FI(), s = (d) => {
    const { name: u, value: p } = d.target;
    i?.(u, p);
  }, c = (d) => {
    (d.key === "Enter" || d.keyCode === 13) && o && o(r);
  };
  return /* @__PURE__ */ w.jsx(
    "input",
    {
      name: r,
      autoFocus: !0,
      value: e,
      onBlur: n,
      onChange: s,
      onKeyDown: c,
      className: Y(a.input, t)
    }
  );
}, FI = je(
  (r) => ({
    input: {
      padding: r.spacing(0.5),
      fontSize: "1rem",
      lineHeight: "1.125rem",
      border: `1px dashed ${r.palette.secondary.main} !important`,
      borderColor: `${r.palette.secondary.main} !important`,
      "&:focus": {
        outline: "none"
      }
    }
  })
);
var si = {}, ch;
function _I() {
  if (ch) return si;
  ch = 1;
  var r = wt();
  Object.defineProperty(si, "__esModule", {
    value: !0
  }), si.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return si.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
  }), "Search"), si;
}
var $I = /* @__PURE__ */ _I();
const WI = /* @__PURE__ */ gt($I), HI = ({ id: r, text: e, rounded: t, className: n }) => {
  const o = YI();
  return /* @__PURE__ */ w.jsx(
    We,
    {
      id: r,
      variant: "caption",
      className: Y(o.label, t && o.rounded, n),
      children: e
    }
  );
}, YI = je(
  (r) => ({
    label: {
      fontSize: 12,
      family: r.typography.fontFamily,
      color: r.palette.grey[900]
    },
    rounded: {
      height: 22,
      fontSize: 16,
      lineHeight: 1.3,
      color: "#4F525C",
      backgroundColor: r.palette.grey[400],
      padding: r.spacing(1),
      borderRadius: r.spacing(1.25)
    }
  })
), XI = ({
  name: r,
  label: e,
  value: t,
  autoFocus: n = !1,
  dataTestId: o,
  fullWidth: i = !0,
  multiline: a = !1,
  placeholder: s,
  className: c,
  externalClasses: d,
  onEnter: u,
  onChange: p,
  onChangeRaw: h,
  onKeyDown: f
}) => {
  const m = VI(), g = R.useRef(null), b = (y) => {
    const { name: C, value: k } = y.target;
    p?.(C, k), h?.(y);
  }, x = (y) => {
    u?.(t), !a && y.preventDefault();
  }, v = () => {
    t ? p?.(r, "") : u?.(t), g.current?.focus();
  };
  return /* @__PURE__ */ w.jsxs(Rs, { className: Y(c, { [m.root]: i }), children: [
    e ? /* @__PURE__ */ w.jsx(HI, { text: e, className: m.label }) : null,
    /* @__PURE__ */ w.jsx(
      Is,
      {
        id: r,
        ref: g,
        name: r,
        value: t,
        multiline: a,
        fullWidth: i,
        placeholder: s ?? "Search",
        className: Y(m.searchField, d?.searchField),
        onEnter: x,
        onChange: b,
        onKeyDown: f,
        inputProps: { "data-testid": o, autoFocus: n },
        endIcon: /* @__PURE__ */ w.jsx(qf, { position: "end", children: /* @__PURE__ */ w.jsx(jt, { size: "small", onClick: v, children: t ? /* @__PURE__ */ w.jsx(Hg, {}) : /* @__PURE__ */ w.jsx(WI, {}) }) })
      }
    )
  ] });
}, VI = je((r) => {
  const e = {
    fontSize: 16,
    lineHeight: 1.3
  };
  return {
    root: {
      width: "100%"
    },
    label: {
      margin: 0
    },
    searchField: {
      "& .MuiOutlinedInput-root": {
        padding: 10,
        borderRadius: 20,
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.2)",
          borderWidth: "1px !important"
        }
      },
      "& .MuiInputBase-input": {
        fontSize: "1rem",
        lineHeight: "1.125rem",
        "&::--moz-placeholder": e,
        "&:-ms-input-placeholder": e,
        "&::-moz-placeholder": e,
        "&::-webkit-input-placeholder": e
      },
      "& .MuiOutlinedInput-input": {
        padding: r.spacing(0.5)
      },
      "& .MuiOutlinedInput-multiline": {
        padding: r.spacing(0.5)
      }
    }
  };
});
var li = {}, dh;
function UI() {
  if (dh) return li;
  dh = 1;
  var r = wt();
  Object.defineProperty(li, "__esModule", {
    value: !0
  }), li.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return li.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
  }), "KeyboardArrowDown"), li;
}
var GI = /* @__PURE__ */ UI();
const qI = /* @__PURE__ */ gt(GI), uh = H(
  mo
)(({ theme: r }) => ({
  width: "100%",
  padding: "10px 16px",
  fontSize: 16,
  lineHeight: "20px",
  color: r.palette.common.black,
  float: "none",
  "&:hover,&.Mui-selected": {
    backgroundColor: r.palette.primary[300]
  },
  "&.Mui-selected": {
    fontWeight: r.typography.fontWeightMedium
  }
})), ph = (r) => typeof r == "object" && "label" in r ? r?.label : r, KI = ({
  id: r,
  className: e,
  current: t,
  disabled: n,
  fullWidth: o,
  label: i,
  multiple: a,
  options: s,
  onChange: c,
  onOpen: d,
  onClose: u,
  placeholder: p,
  required: h,
  showError: f,
  renderOption: m,
  renderValue: g,
  helperText: b,
  dataTestId: x
}) => {
  const v = b || (f && h && (!t || !s.some(
    (O) => typeof O == "object" ? O.value === t : O === t
  )) ? "Input field must not be empty" : null), y = ZI({ placeholder: p, current: t }), C = (O) => O ? typeof O == "string" ? O : O.value : "", T = a ? Array.isArray(t) ? t.map(C) : [] : t, S = Array.isArray(t) ? t.map(ph).join(", ") : ph(t);
  return /* @__PURE__ */ w.jsxs(
    bo,
    {
      className: e,
      classes: { root: y.root },
      disabled: n,
      displayEmpty: !0,
      "data-testid": x,
      error: !!v,
      fullWidth: o,
      renderValue: g,
      title: S,
      input: /* @__PURE__ */ w.jsx(
        Is,
        {
          label: i,
          id: r,
          error: !!v,
          helperText: v
        }
      ),
      multiple: a,
      onOpen: d,
      onClose: u,
      onChange: (O) => c(O.target.value),
      value: T,
      variant: "outlined",
      IconComponent: v ? () => /* @__PURE__ */ w.jsx(R.Fragment, {}) : qI,
      MenuProps: {
        PopoverClasses: { paper: y.paper }
      },
      children: [
        p ? /* @__PURE__ */ w.jsx(uh, { value: "", disabled: !0, className: y.hiddenMenuItem, children: p }) : null,
        s.map((O) => {
          if (typeof m == "function") return m(O);
          const P = typeof O == "object" ? O.value : O, M = typeof O == "object" ? O.label : O;
          return /* @__PURE__ */ w.jsx(
            uh,
            {
              value: P,
              role: "menuitem",
              "aria-label": `menuitem-${P}`,
              children: M
            },
            P
          );
        })
      ]
    }
  );
}, ZI = je(
  (r) => ({
    root: {
      color: ({ current: e, placeholder: t }) => !e && t ? "currentColor" : "",
      opacity: ({ current: e, placeholder: t }) => !e && t ? 0.42 : 1,
      transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      "& .MuiPopover-root": {
        position: "relative"
      }
    },
    hiddenMenuItem: {
      display: "none !important"
    },
    paper: {
      "&::-webkit-scrollbar": {
        width: 8,
        backgroundColor: r.palette.common.white
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: r.palette.grey[400],
        borderRadius: 8
      }
    }
  })
), Lj = ({
  name: r,
  current: e,
  searchText: t,
  options: n,
  baseWidth: o = 120,
  className: i,
  onEnter: a,
  onChangeOption: s,
  onChangeSearchText: c
}) => {
  const d = JI({ baseWidth: o });
  return /* @__PURE__ */ w.jsxs(at, { className: Y(i, d.root), children: [
    /* @__PURE__ */ w.jsx(
      KI,
      {
        current: e,
        options: n,
        className: d.dropdownSelect,
        onChange: s
      }
    ),
    /* @__PURE__ */ w.jsx(
      XI,
      {
        name: r,
        value: t,
        className: d.searchInput,
        externalClasses: { searchField: d.searchInputField },
        onEnter: a,
        onChange: c
      }
    )
  ] });
}, JI = je(
  (r) => ({
    root: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "stretch",
      alignItems: "stretch"
    },
    searchInput: {
      flex: 1
    },
    dropdownSelect: {
      width: ({ baseWidth: e }) => e,
      height: r.spacing(5),
      borderRadius: 0,
      borderTopLeftRadius: r.spacing(2.5),
      borderBottomLeftRadius: r.spacing(2.5),
      "& .MuiSelect-outlined": {
        paddingLeft: r.spacing(2.5)
      }
    },
    searchInputField: {
      height: r.spacing(5),
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    textField: {
      "& .MuiOutlinedInput-root": {
        borderRadius: r.spacing(2.5)
      }
    }
  })
);
var ci = {}, hh;
function QI() {
  if (hh) return ci;
  hh = 1;
  var r = wt();
  Object.defineProperty(ci, "__esModule", {
    value: !0
  }), ci.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return ci.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
  }), "HighlightOff"), ci;
}
var eN = /* @__PURE__ */ QI();
const lm = /* @__PURE__ */ gt(eN), tN = ({
  value: r,
  className: e,
  onCloseClick: t,
  hideCloseButton: n
}) => {
  const o = rN({ hideCloseButton: n });
  return /* @__PURE__ */ w.jsxs("div", { className: Y(o.tag, e), children: [
    /* @__PURE__ */ w.jsx(We, { className: o.typography, children: r }),
    !n && /* @__PURE__ */ w.jsx(
      lm,
      {
        role: "button",
        onClick: t,
        className: o.icon
      }
    )
  ] });
}, rN = je((r) => ({
  tag: {
    border: `1px solid ${r.palette.grey[700]}`,
    position: "relative",
    borderRadius: r.spacing(1),
    padding: r.spacing(0.5, 1),
    whiteSpace: "nowrap",
    backgroundColor: r.palette.common.white,
    marginRight: r.spacing(1),
    maxWidth: "100%",
    display: "flex",
    "&:hover": {
      backgroundColor: r.palette.primary[400],
      border: `1px solid ${r.palette.primary.main}`,
      "& svg": {
        color: r.palette.primary.main
      }
    }
  },
  typography: {
    maxWidth: ({ hideCloseButton: e }) => e ? "100%" : "calc(100% - 20px)",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  icon: {
    cursor: "pointer",
    color: r.palette.grey[700],
    width: 20,
    height: 20,
    marginLeft: r.spacing(1)
  }
})), nN = je((r) => ({
  input: {
    borderWidth: 0,
    outlineWidth: 0,
    height: "100%",
    fontFamily: "Lato-Regular",
    fontSize: "1rem",
    color: r.palette.grey[900],
    fontWeight: 100,
    borderRadius: 0,
    maxWidth: "100%"
  },
  wrapper: {
    rowGap: r.spacing(),
    boxShadow: "unset",
    border: `1px solid ${r.palette.grey[600]}`,
    "&:focus-within,&:hover": {
      border: `1px solid ${r.palette.primary.main}`
    }
  },
  title: {
    fontWeight: 600
  }
})), jj = ({
  label: r,
  tags: e,
  keyMatch: t = [",", "Enter", " "],
  onAdd: n,
  onDelete: o
}) => {
  const [i, a] = R.useState(""), s = R.useRef(null), c = nN(), d = (f) => a(f.target.value ?? ""), u = () => {
    if (i.trim()) {
      if (n) {
        const f = n(i);
        if (typeof f == "boolean" && !f) return;
      }
      a("");
    }
  }, p = (f) => {
    switch (!0) {
      case f.key === "Tab": {
        i.trim().length > 0 && f.preventDefault(), u();
        break;
      }
      case t.includes(f.key): {
        f.preventDefault(), u();
        return;
      }
    }
  }, h = () => {
    s.current?.focus();
  };
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx(ed, { children: /* @__PURE__ */ w.jsx(We, { color: "textPrimary", className: c.title, children: r }) }),
    /* @__PURE__ */ w.jsx(Bi, { onClickAway: u, children: /* @__PURE__ */ w.jsxs(
      at,
      {
        component: Wt,
        minHeight: 40,
        width: "100%",
        display: "flex",
        overflow: "hidden",
        className: c.wrapper,
        flexWrap: "wrap",
        padding: 1,
        onClick: h,
        "data-testid": "tags-input-container",
        children: [
          e?.map((f, m) => /* @__PURE__ */ w.jsx(
            tN,
            {
              value: f,
              onCloseClick: () => o(m)
            },
            f + "_" + m
          )),
          /* @__PURE__ */ w.jsx(at, { width: "fit-content", maxWidth: "100%", children: /* @__PURE__ */ w.jsx(
            "input",
            {
              onKeyDown: p,
              size: i.length + 1,
              value: i,
              className: c.input,
              onChange: d,
              ref: s
            }
          ) })
        ]
      }
    ) })
  ] });
}, oN = je((r) => ({
  root: {
    padding: r.spacing(1, 0, 0, 0)
  }
})), iN = ({
  children: r,
  className: e,
  dataTestId: t
}) => {
  const n = oN();
  return /* @__PURE__ */ w.jsx("div", { className: Y(n.root, e), "data-testid": t, children: r });
}, aN = je((r) => ({
  root: {
    verticalAlign: "baseline",
    display: "inline-block"
  },
  disabled: {
    cursor: "not-allowed",
    "& .MuiChip-root": {
      backgroundColor: `${r.palette.grey[300]}`,
      color: `${r.palette.text.disabled}`,
      opacity: 0.7,
      border: `1px solid ${r.palette.grey[400]}`,
      textDecoration: "line-through",
      pointerEvents: "none"
    }
  }
})), sN = ({
  attributes: r,
  children: e,
  element: t,
  chipConfig: n
}) => {
  const o = wb(), i = Cb(), a = aN();
  if (t.type !== "chip") return null;
  const s = t.label, c = n?.(s) ?? { disabled: !1 }, d = /* @__PURE__ */ w.jsx(
    "span",
    {
      ...r,
      contentEditable: !1,
      className: `${a.root} ${c.disabled ? a.disabled : ""}`,
      children: /* @__PURE__ */ w.jsxs(
        Yg,
        {
          ...t.props,
          size: t.props?.size ?? "small",
          selected: o && i,
          children: [
            e,
            t.label
          ]
        }
      )
    }
  );
  return c.disabled && c.tooltipMessage ? /* @__PURE__ */ w.jsx(Es, { title: c.tooltipMessage, placement: "top", children: d }) : d;
}, lN = ({
  element: r,
  attributes: e,
  children: t,
  chipConfig: n
}) => r.type === "chip" ? /* @__PURE__ */ w.jsx(
  sN,
  {
    element: r,
    attributes: e,
    chipConfig: n,
    children: t
  }
) : /* @__PURE__ */ w.jsx(
  We,
  {
    ...e,
    variant: "body2",
    style: {
      display: r.type === "paragraph" ? "block" : void 0,
      position: r.type === "paragraph" ? "relative" : void 0
    },
    component: r.type === "paragraph" ? "span" : "p",
    children: t
  }
), cN = je((r) => ({
  root: {
    position: "relative",
    outline: "none"
  },
  editorWrapper: {
    position: "relative",
    width: r.spacing(28),
    border: `1px solid ${r.palette.grey[600]}`,
    borderRadius: r.shape.borderRadius,
    "&:focus": {
      borderColor: r.palette.primary.main
    },
    "&.fullWidth": {
      width: "unset"
    }
  },
  editor: {
    padding: r.spacing(2),
    fontFamily: r.typography.fontFamily,
    color: r.palette.text.primary,
    height: r.spacing(15),
    overflowY: "auto",
    overflowX: "hidden",
    outline: "none",
    resize: "vertical"
  },
  error: {
    borderColor: r.palette.error.main,
    "&:focus": {
      borderColor: r.palette.error.main
    }
  },
  errorIcon: {
    position: "absolute",
    top: `calc(50% - ${r.spacing(2)}px)`,
    right: r.spacing(1)
  }
})), dN = [
  {
    type: "paragraph",
    children: [{ text: "", type: "text" }]
  }
], uN = ({
  value: r = dN,
  dataTestId: e,
  className: t,
  fullWidth: n,
  label: o,
  error: i,
  helperText: a,
  onChange: s,
  placeholder: c,
  children: d,
  editor: u,
  onKeyDown: p,
  chipConfig: h
}) => {
  const f = cN(), m = R.useCallback(
    (g) => /* @__PURE__ */ w.jsx(lN, { ...g, chipConfig: h }),
    [h]
  );
  return /* @__PURE__ */ w.jsxs(
    Rs,
    {
      fullWidth: n,
      className: Y(f.root, t),
      "data-testid": e,
      children: [
        o && /* @__PURE__ */ w.jsx(Jc, { children: /* @__PURE__ */ w.jsx(We, { fontWeight: "600", color: "textPrimary", children: o }) }),
        /* @__PURE__ */ w.jsxs(
          "div",
          {
            "data-testid": "text-editor-wrapper",
            className: Y(f.editorWrapper, {
              fullWidth: n,
              [f.error]: i
            }),
            children: [
              /* @__PURE__ */ w.jsx(kb, { editor: u, initialValue: r, onChange: s, children: /* @__PURE__ */ w.jsx(
                Sb,
                {
                  placeholder: c,
                  "data-testid": "text-editor-content",
                  renderElement: m,
                  className: f.editor,
                  onKeyDown: p
                }
              ) }),
              i && /* @__PURE__ */ w.jsx(
                Kg,
                {
                  color: "error",
                  className: f.errorIcon,
                  fontSize: "small"
                }
              ),
              d
            ]
          }
        ),
        a && /* @__PURE__ */ w.jsx(Uf, { error: i, children: a })
      ]
    }
  );
}, pN = (r) => r.map((e) => Tb.string(e)).join(`
`), hN = (r, e = 0) => {
  const { insertText: t } = r;
  return r.insertText = (n) => {
    !e || e <= 0 || Ab.string(r, []).length > e || t(n);
  }, r;
}, fN = (r) => {
  const { isInline: e, isVoid: t, markableVoid: n } = r;
  return r.isInline = (o) => o.type === "chip" ? !0 : e(o), r.isVoid = (o) => o.type === "chip" ? !0 : t(o), r.markableVoid = (o) => o.type === "chip" || n(o), r;
}, gN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  plainSerialize: pN,
  withChip: fN,
  withTextLimit: hN
}, Symbol.toStringTag, { value: "Module" }));
var fh;
((r) => {
  r.Editor = uN, r.Actions = iN, r.utils = gN;
})(fh || (fh = {}));
var di = {}, gh;
function mN() {
  if (gh) return di;
  gh = 1;
  var r = wt();
  Object.defineProperty(di, "__esModule", {
    value: !0
  }), di.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return di.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"
  }), "KeyboardArrowLeft"), di;
}
var bN = /* @__PURE__ */ mN();
const xN = /* @__PURE__ */ gt(bN), Dj = ({
  hasError: r,
  expanded: e,
  hideSummaryWhenExpanded: t = !1,
  accordionSummary: n,
  accordionDetails: o,
  disabled: i = !1,
  onChange: a,
  className: s
}) => {
  const c = vN();
  return /* @__PURE__ */ w.jsxs(
    ff,
    {
      expanded: e,
      className: Y(
        { [c.errorContainer]: r },
        c.root,
        s
      ),
      onChange: (d, u) => a?.(u),
      children: [
        (!t || !e) && /* @__PURE__ */ w.jsx(
          xf,
          {
            expandIcon: /* @__PURE__ */ w.jsx(
              xN,
              {
                className: Y(c.expandIcon, i && c.hidden)
              }
            ),
            disableRipple: !0,
            disableTouchRipple: !0,
            children: n
          }
        ),
        /* @__PURE__ */ w.jsx(gf, { children: o })
      ]
    }
  );
}, vN = je(
  (r) => ({
    root: {
      "& .MuiAccordionSummary-expandIcon.Mui-expanded": {
        transform: "rotate(-90deg)"
      }
    },
    errorContainer: {
      border: `1px solid ${r.palette.error.main}`
    },
    expandIcon: {
      padding: 0
    },
    hidden: {
      display: "none"
    }
  })
), yN = je(
  (r) => ({
    trashButton: {
      margin: r.spacing(0),
      padding: r.spacing(0),
      "&:hover": {
        background: "none",
        color: "#6196FF"
      }
    }
  })
), cm = R.forwardRef(({ className: r, onClick: e, ...t }, n) => {
  const o = yN();
  return /* @__PURE__ */ w.jsx(
    jt,
    {
      ref: n,
      disableRipple: !0,
      disableFocusRipple: !0,
      className: Y(o.trashButton, r),
      onClick: e,
      ...t,
      children: /* @__PURE__ */ w.jsx(Zg, {})
    }
  );
});
cm.displayName = "TrashIconButton";
const wN = je(
  (r) => ({
    card: {
      color: r.palette.grey[900]
    },
    cardType: {
      fontSize: 14,
      fontWeight: 600,
      lineHeight: "17px",
      marginLeft: r.spacing(2.5)
    },
    infoIcon: {
      cursor: "pointer",
      color: "#DD2B7C",
      height: 25
    },
    wrapper: {
      display: "flex",
      alignItems: "center"
    },
    gap: {
      gap: r.spacing(2)
    }
  })
), zj = ({
  type: r,
  tipText: e,
  Icon: t,
  onClickDelete: n,
  children: o,
  headerActions: i,
  ...a
}) => {
  const s = wN();
  return /* @__PURE__ */ w.jsxs(Xg, { ...a, className: s.card, children: [
    /* @__PURE__ */ w.jsxs(at, { display: "flex", justifyContent: "space-between", children: [
      /* @__PURE__ */ w.jsxs("div", { className: s.wrapper, children: [
        t,
        /* @__PURE__ */ w.jsx(We, { className: s.cardType, children: r })
      ] }),
      /* @__PURE__ */ w.jsxs("div", { className: Y(s.wrapper, s.gap), children: [
        i,
        e && /* @__PURE__ */ w.jsx(Es, { title: e, children: /* @__PURE__ */ w.jsx(wd, { className: s.infoIcon }) }),
        /* @__PURE__ */ w.jsx(cm, { onClick: n })
      ] })
    ] }),
    /* @__PURE__ */ w.jsx(at, { pt: 2, children: o })
  ] });
}, Bj = ({ id: r, buttonContent: e, children: t }) => {
  const n = CN(), [o, i] = R.useState(
    null
  ), a = (d) => {
    i(d.currentTarget);
  }, s = () => {
    i(null);
  }, c = !!o;
  return /* @__PURE__ */ w.jsxs(at, { children: [
    /* @__PURE__ */ w.jsx(
      Vr,
      {
        color: "primary",
        variant: "text",
        "aria-describedby": r,
        className: n.popoverButton,
        onClick: a,
        children: e
      }
    ),
    /* @__PURE__ */ w.jsx(
      od,
      {
        id: r,
        open: c,
        anchorEl: o,
        onClose: s,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center"
        },
        className: n.popoverContainer,
        children: t
      }
    )
  ] });
}, CN = je(
  (r) => ({
    popoverButton: {
      padding: 0,
      fontWeight: r.typography.fontWeightLight
    },
    popoverContainer: {
      "& .MuiPopover-paper": {
        boxShadow: "none",
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 0,
        borderColor: r.palette.primary.main
      }
    }
  })
);
var ui = {}, mh;
function kN() {
  if (mh) return ui;
  mh = 1;
  var r = wt();
  Object.defineProperty(ui, "__esModule", {
    value: !0
  }), ui.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return ui.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
  }), "ArrowBack"), ui;
}
var SN = /* @__PURE__ */ kN();
const TN = /* @__PURE__ */ gt(SN), Fj = ({
  title: r,
  disabled: e,
  className: t,
  switchTo: n,
  onSave: o,
  onGoBackTo: i,
  onSwitchTo: a
}) => {
  const s = AN();
  return /* @__PURE__ */ w.jsxs(
    at,
    {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxShadow: "#dddddd 5px 2px 10px 3px",
      className: Y(s.header, t),
      children: [
        /* @__PURE__ */ w.jsxs(at, { display: "flex", alignItems: "center", children: [
          /* @__PURE__ */ w.jsx(at, { mx: 2, children: /* @__PURE__ */ w.jsx(jt, { onClick: i, children: /* @__PURE__ */ w.jsx(TN, { fontSize: "large", className: s.arrowBackIcon }) }) }),
          /* @__PURE__ */ w.jsx(at, { mx: 2, children: /* @__PURE__ */ w.jsx(We, { variant: "h5", className: s.title, children: r }) })
        ] }),
        /* @__PURE__ */ w.jsxs(at, { display: "flex", alignItems: "center", children: [
          n && /* @__PURE__ */ w.jsx(at, { mx: 2, children: /* @__PURE__ */ w.jsx(Vr, { variant: "text", color: "primary", onClick: a, children: n }) }),
          /* @__PURE__ */ w.jsx(at, { mx: 2, children: /* @__PURE__ */ w.jsx(
            Vr,
            {
              size: "large",
              variant: "outlined",
              color: "primary",
              disabled: e,
              onClick: o,
              children: "Save"
            }
          ) })
        ] })
      ]
    }
  );
}, AN = je(
  (r) => ({
    header: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: 60,
      zIndex: 1,
      background: "white"
    },
    title: {
      fontSize: 24,
      lineHeight: 1.2
    },
    arrowBackIcon: {
      color: r.palette.primary.main
    }
  })
), _j = ({
  text: r,
  color: e = "primary",
  selected: t,
  className: n,
  onClick: o,
  ...i
}) => {
  const a = ON({ selected: t, color: e });
  return /* @__PURE__ */ w.jsx(
    Vr,
    {
      variant: "text",
      labelClass: a.label,
      className: Y(a.tabButton, n),
      onClick: o,
      ...i,
      children: r
    }
  );
}, ON = je(
  (r) => ({
    label: {
      fontSize: 18
    },
    tabButton: {
      borderRadius: 0,
      color: ({ selected: e, color: t }) => e ? r.palette[t].main : r.palette.grey[900],
      borderBottom: ({ selected: e, color: t }) => e ? `1px solid ${r.palette[t].main}` : "none"
    }
  })
);
var pi = {}, bh;
function RN() {
  if (bh) return pi;
  bh = 1;
  var r = wt();
  Object.defineProperty(pi, "__esModule", {
    value: !0
  }), pi.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return pi.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m4.3 14.3c-.39.39-1.02.39-1.41 0L12 13.41 9.11 16.3c-.39.39-1.02.39-1.41 0a.9959.9959 0 0 1 0-1.41L10.59 12 7.7 9.11a.9959.9959 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L12 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 12l2.89 2.89c.38.38.38 1.02 0 1.41"
  }), "CancelRounded"), pi;
}
var PN = /* @__PURE__ */ RN();
const MN = /* @__PURE__ */ gt(PN);
var hi = {}, xh;
function EN() {
  if (xh) return hi;
  xh = 1;
  var r = wt();
  Object.defineProperty(hi, "__esModule", {
    value: !0
  }), hi.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return hi.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z"
  }), "ReportProblemOutlined"), hi;
}
var IN = /* @__PURE__ */ EN();
const Sd = /* @__PURE__ */ gt(IN), $j = ({
  text: r,
  hasError: e,
  errorText: t,
  selected: n,
  className: o,
  deletable: i,
  onClick: a,
  onDelete: s,
  ...c
}) => {
  const d = NN({ selected: n });
  return /* @__PURE__ */ w.jsxs("div", { className: d.toolButtonWrapper, children: [
    /* @__PURE__ */ w.jsxs(
      Vr,
      {
        variant: "outlined",
        className: Y(
          d.toolButton,
          e && d.hasError,
          o
        ),
        onClick: a,
        ...c,
        children: [
          r,
          i ? /* @__PURE__ */ w.jsx(
            MN,
            {
              fontSize: "small",
              className: d.closeIcon,
              onClick: s
            }
          ) : null
        ]
      }
    ),
    e && t && /* @__PURE__ */ w.jsxs("div", { className: d.errorWrapper, children: [
      /* @__PURE__ */ w.jsx(at, { width: 30, children: /* @__PURE__ */ w.jsx(Sd, {}) }),
      /* @__PURE__ */ w.jsx(We, { variant: "subtitle2", className: d.errorText, children: t })
    ] })
  ] });
}, NN = je(
  (r) => ({
    toolButtonWrapper: {
      display: "inline-flex",
      flexDirection: "column"
    },
    toolButton: {
      position: "relative",
      boxSizing: "border-box",
      color: (e) => e.selected ? r.palette.common.white : r.palette.common.black,
      backgroundColor: (e) => e.selected ? r.palette.primary.main : r.palette.grey[300],
      border: "none",
      borderRadius: 4,
      "&:hover": {
        color: (e) => e.selected ? r.palette.common.white : r.palette.common.black,
        backgroundColor: (e) => e.selected ? r.palette.primary.main : r.palette.grey[300]
      }
    },
    hasError: {
      border: `1px solid ${r.palette.error.main}`
    },
    errorWrapper: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      color: r.palette.error.main
    },
    errorText: {
      fontWeight: "normal"
    },
    closeIcon: {
      position: "absolute",
      top: r.spacing(-1),
      right: r.spacing(-1),
      cursor: "pointer",
      color: r.palette.common.black
    }
  })
), Wj = ({
  color: r = "primary",
  className: e,
  children: t,
  onHide: n
}) => {
  const o = LN({ color: r });
  return /* @__PURE__ */ w.jsxs(
    at,
    {
      width: 460,
      height: 1,
      padding: 2,
      boxShadow: "-5px 0px 5px 0px #dddddd",
      position: "relative",
      className: e,
      children: [
        /* @__PURE__ */ w.jsx(jt, { className: o.closeButton, onClick: n, children: /* @__PURE__ */ w.jsx(lm, { fontSize: "large" }) }),
        t
      ]
    }
  );
}, LN = je(
  (r) => ({
    closeButton: (e) => ({
      position: "absolute",
      top: 12,
      left: 12,
      padding: 0,
      color: r.palette[e.color].main
    })
  })
), jN = "All data fields need to be completed, you cannot proceed until the below errors are fixed", Hj = ({
  hasError: r,
  errorText: e = jN
}) => {
  const t = DN();
  return r ? /* @__PURE__ */ w.jsxs(at, { width: 1, height: 60, className: t.container, children: [
    /* @__PURE__ */ w.jsx(at, { width: 60, children: /* @__PURE__ */ w.jsx(
      Sd,
      {
        fontSize: "large",
        className: t.warnIcon
      }
    ) }),
    /* @__PURE__ */ w.jsx(We, { variant: "subtitle1", className: t.errorText, children: e })
  ] }) : null;
}, DN = je(
  (r) => ({
    container: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: r.spacing(2),
      boxSizing: "border-box",
      borderRadius: r.spacing(1),
      boxShadow: "0 6px 14px 2px rgba(0,0,0,0.1)"
    },
    warnIcon: {
      color: r.palette.error.main
    },
    errorText: {
      fontWeight: "lighter",
      color: r.palette.error.main
    }
  })
);
var fi = {}, vh;
function zN() {
  if (vh) return fi;
  vh = 1;
  var r = wt();
  Object.defineProperty(fi, "__esModule", {
    value: !0
  }), fi.default = void 0;
  var e = r(/* @__PURE__ */ kt()), t = Ct();
  return fi.default = (0, e.default)(/* @__PURE__ */ (0, t.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
  }), "MoreVert"), fi;
}
var BN = /* @__PURE__ */ zN();
const FN = /* @__PURE__ */ gt(BN), _N = 48, Yj = ({ options: r }) => {
  const e = $N(), [t, n] = R.useState(null), o = !!t, i = (c) => {
    n(c.currentTarget);
  }, a = () => {
    n(null);
  }, s = (c) => {
    c.onClick(), a();
  };
  return /* @__PURE__ */ w.jsxs(at, { width: 1, children: [
    /* @__PURE__ */ w.jsx(jt, { onClick: i, className: e.iconButton, children: /* @__PURE__ */ w.jsx(FN, { className: e.menuIcon }) }),
    /* @__PURE__ */ w.jsx(
      id,
      {
        id: "long-menu",
        anchorEl: t,
        keepMounted: !0,
        open: o,
        classes: {
          list: e.menuList
        },
        onClose: a,
        PaperProps: {
          style: {
            maxHeight: _N * 4.5,
            width: "20ch"
          }
        },
        children: r.map((c, d) => /* @__PURE__ */ w.jsx(
          mo,
          {
            className: e.menuItem,
            onClick: () => s(c),
            children: c.text
          },
          `${c.text}-${d}`
        ))
      }
    )
  ] });
}, $N = je(
  (r) => ({
    iconButton: {
      padding: 0
    },
    menuItem: {
      width: "100%"
    },
    menuIcon: {
      color: r.palette.grey[900]
    },
    menuList: {
      padding: 0
    }
  })
);
var Nt = {}, dl, yh;
function WN() {
  return yh || (yh = 1, dl = function r(e, t) {
    if (e === t) return !0;
    if (e && t && typeof e == "object" && typeof t == "object") {
      if (e.constructor !== t.constructor) return !1;
      var n, o, i;
      if (Array.isArray(e)) {
        if (n = e.length, n != t.length) return !1;
        for (o = n; o-- !== 0; )
          if (!r(e[o], t[o])) return !1;
        return !0;
      }
      if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
      if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
      if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
      if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
      for (o = n; o-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(t, i[o])) return !1;
      for (o = n; o-- !== 0; ) {
        var a = i[o];
        if (!r(e[a], t[a])) return !1;
      }
      return !0;
    }
    return e !== e && t !== t;
  }), dl;
}
var wh;
function HN() {
  if (wh) return Nt;
  wh = 1;
  var r = Nt && Nt.__extends || /* @__PURE__ */ (function() {
    var f = function(m, g) {
      return f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(b, x) {
        b.__proto__ = x;
      } || function(b, x) {
        for (var v in x) Object.prototype.hasOwnProperty.call(x, v) && (b[v] = x[v]);
      }, f(m, g);
    };
    return function(m, g) {
      if (typeof g != "function" && g !== null)
        throw new TypeError("Class extends value " + String(g) + " is not a constructor or null");
      f(m, g);
      function b() {
        this.constructor = m;
      }
      m.prototype = g === null ? Object.create(g) : (b.prototype = g.prototype, new b());
    };
  })(), e = Nt && Nt.__assign || function() {
    return e = Object.assign || function(f) {
      for (var m, g = 1, b = arguments.length; g < b; g++) {
        m = arguments[g];
        for (var x in m) Object.prototype.hasOwnProperty.call(m, x) && (f[x] = m[x]);
      }
      return f;
    }, e.apply(this, arguments);
  }, t = Nt && Nt.__createBinding || (Object.create ? (function(f, m, g, b) {
    b === void 0 && (b = g);
    var x = Object.getOwnPropertyDescriptor(m, g);
    (!x || ("get" in x ? !m.__esModule : x.writable || x.configurable)) && (x = { enumerable: !0, get: function() {
      return m[g];
    } }), Object.defineProperty(f, b, x);
  }) : (function(f, m, g, b) {
    b === void 0 && (b = g), f[b] = m[g];
  })), n = Nt && Nt.__setModuleDefault || (Object.create ? (function(f, m) {
    Object.defineProperty(f, "default", { enumerable: !0, value: m });
  }) : function(f, m) {
    f.default = m;
  }), o = Nt && Nt.__importStar || function(f) {
    if (f && f.__esModule) return f;
    var m = {};
    if (f != null) for (var g in f) g !== "default" && Object.prototype.hasOwnProperty.call(f, g) && t(m, f, g);
    return n(m, f), m;
  }, i = Nt && Nt.__rest || function(f, m) {
    var g = {};
    for (var b in f) Object.prototype.hasOwnProperty.call(f, b) && m.indexOf(b) < 0 && (g[b] = f[b]);
    if (f != null && typeof Object.getOwnPropertySymbols == "function")
      for (var x = 0, b = Object.getOwnPropertySymbols(f); x < b.length; x++)
        m.indexOf(b[x]) < 0 && Object.prototype.propertyIsEnumerable.call(f, b[x]) && (g[b[x]] = f[b[x]]);
    return g;
  }, a = Nt && Nt.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(Nt, "__esModule", { value: !0 });
  var s = o(hr), c = a(WN()), d = o(/* @__PURE__ */ bb());
  function u(f) {
    return f && f.replace(/&nbsp;|\u202F|\u00A0/g, " ").replace(/<br \/>/g, "<br>");
  }
  function p(f) {
    var m = document.createTextNode("");
    f.appendChild(m);
    var g = document.activeElement === f;
    if (m !== null && m.nodeValue !== null && g) {
      var b = window.getSelection();
      if (b !== null) {
        var x = document.createRange();
        x.setStart(m, m.nodeValue.length), x.collapse(!0), b.removeAllRanges(), b.addRange(x);
      }
      f instanceof HTMLElement && f.focus();
    }
  }
  var h = (
    /** @class */
    (function(f) {
      r(m, f);
      function m() {
        var g = f !== null && f.apply(this, arguments) || this;
        return g.lastHtml = g.props.html, g.el = typeof g.props.innerRef == "function" ? { current: null } : s.createRef(), g.getEl = function() {
          return (g.props.innerRef && typeof g.props.innerRef != "function" ? g.props.innerRef : g.el).current;
        }, g.emitChange = function(b) {
          var x = g.getEl();
          if (x) {
            var v = x.innerHTML;
            if (g.props.onChange && v !== g.lastHtml) {
              var y = Object.assign({}, b, {
                target: {
                  value: v
                }
              });
              g.props.onChange(y);
            }
            g.lastHtml = v;
          }
        }, g;
      }
      return m.prototype.render = function() {
        var g = this, b = this.props, x = b.tagName, v = b.html, y = b.innerRef, C = i(b, ["tagName", "html", "innerRef"]);
        return s.createElement(x || "div", e(e({}, C), { ref: typeof y == "function" ? function(k) {
          y(k), g.el.current = k;
        } : y || this.el, onInput: this.emitChange, onBlur: this.props.onBlur || this.emitChange, onKeyUp: this.props.onKeyUp || this.emitChange, onKeyDown: this.props.onKeyDown || this.emitChange, contentEditable: !this.props.disabled, dangerouslySetInnerHTML: { __html: v } }), this.props.children);
      }, m.prototype.shouldComponentUpdate = function(g) {
        var b = this.props, x = this.getEl();
        return !x || u(g.html) !== u(x.innerHTML) ? !0 : b.disabled !== g.disabled || b.tagName !== g.tagName || b.className !== g.className || b.innerRef !== g.innerRef || b.placeholder !== g.placeholder || !(0, c.default)(b.style, g.style);
      }, m.prototype.componentDidUpdate = function() {
        var g = this.getEl();
        g && (this.props.html !== g.innerHTML && (g.innerHTML = this.props.html), this.lastHtml = this.props.html, p(g));
      }, m.propTypes = {
        html: d.string.isRequired,
        onChange: d.func,
        disabled: d.bool,
        tagName: d.string,
        className: d.string,
        style: d.object,
        innerRef: d.oneOfType([
          d.object,
          d.func
        ])
      }, m;
    })(s.Component)
  );
  return Nt.default = h, Nt;
}
var YN = HN();
const XN = /* @__PURE__ */ gt(YN), Xj = ({
  text: r,
  width: e,
  padding: t,
  editable: n = !0,
  finished: o,
  height: i = "30px",
  showError: a = !1,
  className: s,
  onChange: c
}) => {
  const d = !r || !r.length, u = VN({
    width: e,
    height: i,
    padding: t,
    disabled: !!(d || o)
  }), p = R.useRef(null), [h, f] = R.useState();
  R.useEffect(() => {
    f(r);
  }, [r]);
  const m = () => {
    const y = p?.current?.innerText;
    y && c?.(y);
  }, g = (y) => {
    (y.which || y.keyCode) === 13 && (p.current?.blur(), m());
  }, b = (y) => {
    f(y.target.value);
  }, x = () => {
    h === void 0 && f("");
  }, v = a ? r ? null : "Input field must not be empty" : null;
  return /* @__PURE__ */ w.jsxs(w.Fragment, { children: [
    /* @__PURE__ */ w.jsx(
      XN,
      {
        innerRef: p,
        disabled: !n,
        html: h !== void 0 ? h : "Add Button Response",
        className: Y(s, u.button),
        onChange: b,
        onKeyDown: g,
        onClick: x,
        onBlur: m
      }
    ),
    v ? /* @__PURE__ */ w.jsxs("div", { className: u.errorWrapper, children: [
      /* @__PURE__ */ w.jsx(at, { width: 30, children: /* @__PURE__ */ w.jsx(Sd, {}) }),
      /* @__PURE__ */ w.jsx(We, { variant: "subtitle2", fontWeight: "normal", children: v })
    ] }) : null
  ] });
}, VN = je((r) => ({
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: (e) => e.padding,
    fontWeight: "normal",
    fontSize: 14,
    width: (e) => e.width,
    height: (e) => e.height,
    backgroundColor: "white",
    color: ({ disabled: e }) => e ? r.palette.text.disabled : r.palette.secondary.main,
    border: ({ disabled: e }) => `2px solid ${e ? r.palette.text.disabled : r.palette.secondary.main}`,
    borderRadius: "15px",
    outline: "0px solid transparent",
    "&:empty:not(:focus):before": {
      color: ({ disabled: e }) => e ? r.palette.text.disabled : r.palette.secondary.main,
      content: "attr(data-text)"
    }
  },
  errorWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    color: r.palette.error.main
  }
})), Ch = ({
  type: r,
  blocks: e,
  onClick: t
}) => {
  const n = UN(), o = (a) => {
    switch (a.type) {
      case Tr.PHONE_NUMBER_INPUT:
      case Tr.QR_PHONE:
        return /* @__PURE__ */ w.jsx(Vg, { className: n.smallIcon });
      case Tr.QR_URL:
      case Tr.URL_INPUT:
      case Tr.QR_EMAIL:
        return /* @__PURE__ */ w.jsx(Ug, { className: n.smallIcon });
      default:
        return null;
    }
  }, i = R.useMemo(() => e.sort((a, s) => s.type - a.type), [e]);
  return /* @__PURE__ */ w.jsxs(
    at,
    {
      width: 1,
      display: "flex",
      flexDirection: "row",
      padding: 1,
      className: n.container,
      children: [
        /* @__PURE__ */ w.jsx(
          at,
          {
            display: "flex",
            alignItems: "flex-start",
            className: n.iconContainer,
            children: /* @__PURE__ */ w.jsxs(at, { display: "flex", alignItems: "center", children: [
              r === "In" ? /* @__PURE__ */ w.jsx(Gg, {}) : /* @__PURE__ */ w.jsx(qg, {}),
              /* @__PURE__ */ w.jsx(We, { className: n.showType, children: r })
            ] })
          }
        ),
        /* @__PURE__ */ w.jsx(
          at,
          {
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            className: n.blockContainer,
            children: i.map((a) => /* @__PURE__ */ w.jsxs(
              We,
              {
                className: Y(n.text, n.blockName),
                onClick: () => t(a),
                children: [
                  a.name,
                  o(a)
                ]
              },
              a.key || a.id
            ))
          }
        )
      ]
    }
  );
}, UN = je(
  (r) => ({
    container: {
      boxSizing: "border-box"
    },
    iconContainer: {
      minWidth: 100,
      maxWidth: 100,
      fontFamily: "Nunito-Regular !important",
      paddingTop: r.spacing(0.5)
    },
    iconButton: {
      padding: r.spacing(0),
      color: "#4F525C !important"
    },
    blockContainer: {
      flexWrap: "wrap"
    },
    showType: {
      marginLeft: r.spacing(2)
    },
    text: {
      cursor: "pointer",
      color: "#17A7BF !important",
      fontFamily: "Nunito-Regular !important",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "16px !important",
      lineHeight: 1.4,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      display: "block",
      margin: `${r.spacing(0.5)}px ${r.spacing(1)}px !important`,
      "&:hover": {
        textDecoration: "underline"
      }
    },
    expandButton: {
      textDecoration: "underline"
    },
    blockName: {
      display: "block",
      alignItems: "flex-start"
    },
    smallIcon: {
      fontSize: 10,
      marginTop: -10
    }
  })
), Vj = ({
  inBlocks: r,
  outBlocks: e,
  onClick: t
}) => {
  const n = GN();
  return /* @__PURE__ */ w.jsxs(it, { container: !0, className: n.container, children: [
    /* @__PURE__ */ w.jsx(it, { item: !0, xs: 6, children: /* @__PURE__ */ w.jsx(Ch, { type: "In", blocks: r, onClick: t }) }),
    /* @__PURE__ */ w.jsx(it, { item: !0, xs: 6, children: /* @__PURE__ */ w.jsx(Ch, { type: "Out", blocks: e, onClick: t }) })
  ] });
}, GN = je(
  (r) => ({
    container: {
      background: "white",
      boxShadow: "0px 0px 10px rgba(23, 167, 191, 0.4)",
      borderRadius: 10,
      maxWidth: 1600,
      minHeight: r.spacing(6),
      padding: r.spacing(2, 4)
    }
  })
), Uj = ({ totalPages: r, ...e }) => /* @__PURE__ */ w.jsx(lg, { ...e, count: r }), Gj = ({ children: r, title: e, ...t }) => {
  const n = qN();
  return /* @__PURE__ */ w.jsxs(
    yf,
    {
      ...t,
      classes: {
        standardInfo: n.info,
        standardWarning: n.warning,
        standardError: n.error,
        standardSuccess: n.success,
        message: n.message
      },
      children: [
        /* @__PURE__ */ w.jsx(wf, { classes: { root: n.title }, children: e }),
        r
      ]
    }
  );
}, qN = je(
  (r) => ({
    info: {
      color: r.palette.primary.main,
      backgroundColor: r.palette.primary[300],
      border: `1px solid ${r.palette.primary.main}`
    },
    error: {
      color: r.palette.error.main,
      backgroundColor: r.palette.error[300],
      border: `1px solid ${r.palette.error.main}`
    },
    warning: {
      color: r.palette.warning.main,
      backgroundColor: r.palette.warning[300],
      border: `1px solid ${r.palette.warning.main}`
    },
    success: {
      color: r.palette.success.main,
      backgroundColor: r.palette.success[300],
      border: `1px solid ${r.palette.success.main}`
    },
    message: {
      fontSize: 16
    },
    title: {
      display: "inline",
      marginRight: 5
    }
  })
), KN = je(
  (r) => ({
    paper: {
      display: "flex",
      border: `1px solid ${r.palette.divider}`
    },
    divider: {
      margin: r.spacing(1, 0.5)
    },
    button: {
      flex: 1
    },
    unSelected: {
      color: r.palette.grey[900],
      border: "none !important"
    }
  })
), qj = (r) => {
  const { options: e, selected: t, onChange: n } = r, o = KN();
  return /* @__PURE__ */ w.jsx("div", { children: /* @__PURE__ */ w.jsx(Wt, { elevation: 0, className: o.paper, children: e.length > 0 && e.map((i, a) => /* @__PURE__ */ w.jsx(
    Vr,
    {
      className: Y(
        { [o.unSelected]: t !== i.value },
        o.button
      ),
      onClick: (s) => n(s, i.value),
      variant: t === i.value ? "contained" : "outlined",
      children: i.label
    },
    `${i.label}-${a}}`
  )) }) });
};
function nc(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = Array(e); t < e; t++) n[t] = r[t];
  return n;
}
function dm(r) {
  if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function xe(r, e) {
  if (!(r instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function kh(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, hm(n.key), n);
  }
}
function ve(r, e, t) {
  return e && kh(r.prototype, e), t && kh(r, t), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
function Ci(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = Td(r)) || e) {
      t && (r = t);
      var n = 0, o = function() {
      };
      return { s: o, n: function() {
        return n >= r.length ? { done: !0 } : { done: !1, value: r[n++] };
      }, e: function(c) {
        throw c;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, s = !1;
  return { s: function() {
    t = t.call(r);
  }, n: function() {
    var c = t.next();
    return a = c.done, c;
  }, e: function(c) {
    s = !0, i = c;
  }, f: function() {
    try {
      a || t.return == null || t.return();
    } finally {
      if (s) throw i;
    }
  } };
}
function na(r) {
  var e = um();
  return function() {
    var t, n = as(r);
    if (e) {
      var o = as(this).constructor;
      t = Reflect.construct(n, arguments, o);
    } else t = n.apply(this, arguments);
    return (function(i, a) {
      if (a && (typeof a == "object" || typeof a == "function")) return a;
      if (a !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
      return dm(i);
    })(this, t);
  };
}
function is(r, e, t) {
  return (e = hm(e)) in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
function as(r) {
  return as = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, as(r);
}
function oa(r, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, { constructor: { value: r, writable: !0, configurable: !0 } }), Object.defineProperty(r, "prototype", { writable: !1 }), e && oc(r, e);
}
function um() {
  try {
    var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {
    })));
  } catch {
  }
  return (um = function() {
    return !!r;
  })();
}
function Sh(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter((function(o) {
      return Object.getOwnPropertyDescriptor(r, o).enumerable;
    }))), t.push.apply(t, n);
  }
  return t;
}
function ie(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Sh(Object(t), !0).forEach((function(n) {
      is(r, n, t[n]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Sh(Object(t)).forEach((function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    }));
  }
  return r;
}
function oc(r, e) {
  return oc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, oc(r, e);
}
function pm(r, e) {
  return (function(t) {
    if (Array.isArray(t)) return t;
  })(r) || (function(t, n) {
    var o = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (o != null) {
      var i, a, s, c, d = [], u = !0, p = !1;
      try {
        if (s = (o = o.call(t)).next, n === 0) {
          if (Object(o) !== o) return;
          u = !1;
        } else for (; !(u = (i = s.call(o)).done) && (d.push(i.value), d.length !== n); u = !0) ;
      } catch (h) {
        p = !0, a = h;
      } finally {
        try {
          if (!u && o.return != null && (c = o.return(), Object(c) !== c)) return;
        } finally {
          if (p) throw a;
        }
      }
      return d;
    }
  })(r, e) || Td(r, e) || (function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  })();
}
function Mt(r) {
  return (function(e) {
    if (Array.isArray(e)) return nc(e);
  })(r) || (function(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  })(r) || Td(r) || (function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  })();
}
function hm(r) {
  var e = (function(t, n) {
    if (typeof t != "object" || !t) return t;
    var o = t[Symbol.toPrimitive];
    if (o !== void 0) {
      var i = o.call(t, n);
      if (typeof i != "object") return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (n === "string" ? String : Number)(t);
  })(r, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Vt(r) {
  return Vt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Vt(r);
}
function Td(r, e) {
  if (r) {
    if (typeof r == "string") return nc(r, e);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? nc(r, e) : void 0;
  }
}
var $ = (function() {
  function r() {
    xe(this, r);
  }
  return ve(r, [{ key: "shadeRGBColor", value: function(e, t) {
    var n = t.split(","), o = e < 0 ? 0 : 255, i = e < 0 ? -1 * e : e, a = parseInt(n[0].slice(4), 10), s = parseInt(n[1], 10), c = parseInt(n[2], 10);
    return "rgb(" + (Math.round((o - a) * i) + a) + "," + (Math.round((o - s) * i) + s) + "," + (Math.round((o - c) * i) + c) + ")";
  } }, { key: "shadeHexColor", value: function(e, t) {
    var n = parseInt(t.slice(1), 16), o = e < 0 ? 0 : 255, i = e < 0 ? -1 * e : e, a = n >> 16, s = n >> 8 & 255, c = 255 & n;
    return "#" + (16777216 + 65536 * (Math.round((o - a) * i) + a) + 256 * (Math.round((o - s) * i) + s) + (Math.round((o - c) * i) + c)).toString(16).slice(1);
  } }, { key: "shadeColor", value: function(e, t) {
    return r.isColorHex(t) ? this.shadeHexColor(e, t) : this.shadeRGBColor(e, t);
  } }], [{ key: "bind", value: function(e, t) {
    return function() {
      return e.apply(t, arguments);
    };
  } }, { key: "isObject", value: function(e) {
    return e && Vt(e) === "object" && !Array.isArray(e) && e != null;
  } }, { key: "is", value: function(e, t) {
    return Object.prototype.toString.call(t) === "[object " + e + "]";
  } }, { key: "isSafari", value: function() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  } }, { key: "listToArray", value: function(e) {
    var t, n = [];
    for (t = 0; t < e.length; t++) n[t] = e[t];
    return n;
  } }, { key: "extend", value: function(e, t) {
    var n = this;
    typeof Object.assign != "function" && (Object.assign = function(i) {
      if (i == null) throw new TypeError("Cannot convert undefined or null to object");
      for (var a = Object(i), s = 1; s < arguments.length; s++) {
        var c = arguments[s];
        if (c != null) for (var d in c) c.hasOwnProperty(d) && (a[d] = c[d]);
      }
      return a;
    });
    var o = Object.assign({}, e);
    return this.isObject(e) && this.isObject(t) && Object.keys(t).forEach((function(i) {
      n.isObject(t[i]) && i in e ? o[i] = n.extend(e[i], t[i]) : Object.assign(o, is({}, i, t[i]));
    })), o;
  } }, { key: "extendArray", value: function(e, t) {
    var n = [];
    return e.map((function(o) {
      n.push(r.extend(t, o));
    })), e = n;
  } }, { key: "monthMod", value: function(e) {
    return e % 12;
  } }, { key: "clone", value: function(e) {
    var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new WeakMap();
    if (e === null || Vt(e) !== "object") return e;
    if (n.has(e)) return n.get(e);
    if (Array.isArray(e)) {
      t = [], n.set(e, t);
      for (var o = 0; o < e.length; o++) t[o] = this.clone(e[o], n);
    } else if (e instanceof Date) t = new Date(e.getTime());
    else for (var i in t = {}, n.set(e, t), e) e.hasOwnProperty(i) && (t[i] = this.clone(e[i], n));
    return t;
  } }, { key: "log10", value: function(e) {
    return Math.log(e) / Math.LN10;
  } }, { key: "roundToBase10", value: function(e) {
    return Math.pow(10, Math.floor(Math.log10(e)));
  } }, { key: "roundToBase", value: function(e, t) {
    return Math.pow(t, Math.floor(Math.log(e) / Math.log(t)));
  } }, { key: "parseNumber", value: function(e) {
    return typeof e == "number" || e === null ? e : parseFloat(e);
  } }, { key: "stripNumber", value: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return Number.isInteger(e) ? e : parseFloat(e.toPrecision(t));
  } }, { key: "randomId", value: function() {
    return (Math.random() + 1).toString(36).substring(4);
  } }, { key: "noExponents", value: function(e) {
    return e.toString().includes("e") ? Math.round(e) : e;
  } }, { key: "elementExists", value: function(e) {
    return !(!e || !e.isConnected);
  } }, { key: "isInShadowDOM", value: function(e) {
    if (!e || !e.getRootNode) return !1;
    var t = e.getRootNode();
    return t && t !== document && r.is("ShadowRoot", t);
  } }, { key: "getShadowRootHost", value: function(e) {
    return r.isInShadowDOM(e) && e.getRootNode().host || null;
  } }, { key: "getDimensions", value: function(e) {
    if (!e) return [0, 0];
    var t, n = e.getRootNode && e.getRootNode();
    if (n && n !== document && n.host) {
      var o = n.host.getBoundingClientRect();
      return [o.width, o.height];
    }
    try {
      t = getComputedStyle(e, null);
    } catch {
      return [e.clientWidth || 0, e.clientHeight || 0];
    }
    var i = e.clientHeight, a = e.clientWidth;
    return i -= parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), [a -= parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), i];
  } }, { key: "getBoundingClientRect", value: function(e) {
    if (!e) return { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0, x: 0, y: 0 };
    var t = e.getBoundingClientRect();
    return { top: t.top, right: t.right, bottom: t.bottom, left: t.left, width: e.clientWidth, height: e.clientHeight, x: t.left, y: t.top };
  } }, { key: "getLargestStringFromArr", value: function(e) {
    return e.reduce((function(t, n) {
      return Array.isArray(n) && (n = n.reduce((function(o, i) {
        return o.length > i.length ? o : i;
      }))), t.length > n.length ? t : n;
    }), 0);
  } }, { key: "hexToRgba", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "#999999", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.6;
    e.substring(0, 1) !== "#" && (e = "#999999");
    var n = e.replace("#", "");
    n = n.match(new RegExp("(.{" + n.length / 3 + "})", "g"));
    for (var o = 0; o < n.length; o++) n[o] = parseInt(n[o].length === 1 ? n[o] + n[o] : n[o], 16);
    return t !== void 0 && n.push(t), "rgba(" + n.join(",") + ")";
  } }, { key: "getOpacityFromRGBA", value: function(e) {
    return parseFloat(e.replace(/^.*,(.+)\)/, "$1"));
  } }, { key: "rgb2hex", value: function(e) {
    return (e = e.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && e.length === 4 ? "#" + ("0" + parseInt(e[1], 10).toString(16)).slice(-2) + ("0" + parseInt(e[2], 10).toString(16)).slice(-2) + ("0" + parseInt(e[3], 10).toString(16)).slice(-2) : "";
  } }, { key: "isColorHex", value: function(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(e);
  } }, { key: "getPolygonPos", value: function(e, t) {
    for (var n = [], o = 2 * Math.PI / t, i = 0; i < t; i++) {
      var a = {};
      a.x = e * Math.sin(i * o), a.y = -e * Math.cos(i * o), n.push(a);
    }
    return n;
  } }, { key: "polarToCartesian", value: function(e, t, n, o) {
    var i = (o - 90) * Math.PI / 180;
    return { x: e + n * Math.cos(i), y: t + n * Math.sin(i) };
  } }, { key: "escapeString", value: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x", n = e.toString().slice();
    return n = n.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi, t);
  } }, { key: "negToZero", value: function(e) {
    return e < 0 ? 0 : e;
  } }, { key: "moveIndexInArray", value: function(e, t, n) {
    if (n >= e.length) for (var o = n - e.length + 1; o--; ) e.push(void 0);
    return e.splice(n, 0, e.splice(t, 1)[0]), e;
  } }, { key: "extractNumber", value: function(e) {
    return parseFloat(e.replace(/[^\d.]*/g, ""));
  } }, { key: "findAncestor", value: function(e, t) {
    for (; (e = e.parentElement) && !e.classList.contains(t); ) ;
    return e;
  } }, { key: "setELstyles", value: function(e, t) {
    for (var n in t) t.hasOwnProperty(n) && (e.style.key = t[n]);
  } }, { key: "preciseAddition", value: function(e, t) {
    var n = (String(e).split(".")[1] || "").length, o = (String(t).split(".")[1] || "").length, i = Math.pow(10, Math.max(n, o));
    return (Math.round(e * i) + Math.round(t * i)) / i;
  } }, { key: "isNumber", value: function(e) {
    return !isNaN(e) && parseFloat(Number(e)) === e && !isNaN(parseInt(e, 10));
  } }, { key: "isFloat", value: function(e) {
    return Number(e) === e && e % 1 != 0;
  } }, { key: "isMsEdge", value: function() {
    var e = window.navigator.userAgent, t = e.indexOf("Edge/");
    return t > 0 && parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
  } }, { key: "getGCD", value: function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 7, o = Math.pow(10, n - Math.floor(Math.log10(Math.max(e, t))));
    for (o > 1 ? (e = Math.round(Math.abs(e) * o), t = Math.round(Math.abs(t) * o)) : o = 1; t; ) {
      var i = t;
      t = e % t, e = i;
    }
    return e / o;
  } }, { key: "getPrimeFactors", value: function(e) {
    for (var t = [], n = 2; e >= 2; ) e % n == 0 ? (t.push(n), e /= n) : n++;
    return t;
  } }, { key: "mod", value: function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 7, o = Math.pow(10, n - Math.floor(Math.log10(Math.max(e, t))));
    return (e = Math.round(Math.abs(e) * o)) % (t = Math.round(Math.abs(t) * o)) / o;
  } }]), r;
})(), Ro = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "animateLine", value: function(e, t, n, o) {
    e.attr(t).animate(o).attr(n);
  } }, { key: "animateMarker", value: function(e, t, n, o) {
    e.attr({ opacity: 0 }).animate(t).attr({ opacity: 1 }).after((function() {
      o();
    }));
  } }, { key: "animateRect", value: function(e, t, n, o, i) {
    e.attr(t).animate(o).attr(n).after((function() {
      return i();
    }));
  } }, { key: "animatePathsGradually", value: function(e) {
    var t = e.el, n = e.realIndex, o = e.j, i = e.fill, a = e.pathFrom, s = e.pathTo, c = e.speed, d = e.delay, u = this.w, p = 0;
    u.config.chart.animations.animateGradually.enabled && (p = u.config.chart.animations.animateGradually.delay), u.config.chart.animations.dynamicAnimation.enabled && u.globals.dataChanged && u.config.chart.type !== "bar" && (p = 0), this.morphSVG(t, n, o, u.config.chart.type !== "line" || u.globals.comboCharts ? i : "stroke", a, s, c, d * p);
  } }, { key: "showDelayedElements", value: function() {
    this.w.globals.delayedElements.forEach((function(e) {
      var t = e.el;
      t.classList.remove("apexcharts-element-hidden"), t.classList.add("apexcharts-hidden-element-shown");
    }));
  } }, { key: "animationCompleted", value: function(e) {
    var t = this.w;
    t.globals.animationEnded || (t.globals.animationEnded = !0, this.showDelayedElements(), typeof t.config.chart.events.animationEnd == "function" && t.config.chart.events.animationEnd(this.ctx, { el: e, w: t }));
  } }, { key: "morphSVG", value: function(e, t, n, o, i, a, s, c) {
    var d = this, u = this.w;
    i || (i = e.attr("pathFrom")), a || (a = e.attr("pathTo"));
    var p = function(h) {
      return u.config.chart.type === "radar" && (s = 1), "M 0 ".concat(u.globals.gridHeight);
    };
    (!i || i.indexOf("undefined") > -1 || i.indexOf("NaN") > -1) && (i = p()), (!a.trim() || a.indexOf("undefined") > -1 || a.indexOf("NaN") > -1) && (a = p()), u.globals.shouldAnimate || (s = 1), e.plot(i).animate(1, c).plot(i).animate(s, c).plot(a).after((function() {
      $.isNumber(n) ? n === u.globals.series[u.globals.maxValsInArrayIndex].length - 2 && u.globals.shouldAnimate && d.animationCompleted(e) : o !== "none" && u.globals.shouldAnimate && (!u.globals.comboCharts && t === u.globals.series.length - 1 || u.globals.comboCharts) && d.animationCompleted(e), d.showDelayedElements();
    }));
  } }]), r;
})();
const ic = {}, fm = [];
function $e(r, e) {
  if (Array.isArray(r)) for (const t of r) $e(t, e);
  else if (typeof r != "object") gm(Object.getOwnPropertyNames(e)), ic[r] = Object.assign(ic[r] || {}, e);
  else for (const t in r) $e(t, r[t]);
}
function Jt(r) {
  return ic[r] || {};
}
function gm(r) {
  fm.push(...r);
}
function Ad(r, e) {
  let t;
  const n = r.length, o = [];
  for (t = 0; t < n; t++) o.push(e(r[t]));
  return o;
}
function ul(r) {
  return r % 360 * Math.PI / 180;
}
function Po(r) {
  return r.charAt(0).toUpperCase() + r.slice(1);
}
function Mo(r, e, t, n) {
  return e != null && t != null || (n = n || r.bbox(), e == null ? e = n.width / n.height * t : t == null && (t = n.height / n.width * e)), { width: e, height: t };
}
function ac(r, e) {
  const t = r.origin;
  let n = r.ox != null ? r.ox : r.originX != null ? r.originX : "center", o = r.oy != null ? r.oy : r.originY != null ? r.originY : "center";
  t != null && ([n, o] = Array.isArray(t) ? t : typeof t == "object" ? [t.x, t.y] : [t, t]);
  const i = typeof n == "string", a = typeof o == "string";
  if (i || a) {
    const { height: s, width: c, x: d, y: u } = e.bbox();
    i && (n = n.includes("left") ? d : n.includes("right") ? d + c : d + c / 2), a && (o = o.includes("top") ? u : o.includes("bottom") ? u + s : u + s / 2);
  }
  return [n, o];
}
const ZN = /* @__PURE__ */ new Set(["desc", "metadata", "title"]), sc = (r) => ZN.has(r.nodeName), mm = (r, e, t = {}) => {
  const n = { ...e };
  for (const o in n) n[o].valueOf() === t[o] && delete n[o];
  Object.keys(n).length ? r.node.setAttribute("data-svgjs", JSON.stringify(n)) : (r.node.removeAttribute("data-svgjs"), r.node.removeAttribute("svgjs:data"));
}, Od = "http://www.w3.org/2000/svg", pl = "http://www.w3.org/2000/xmlns/", Eo = "http://www.w3.org/1999/xlink", Ze = { window: typeof window > "u" ? null : window, document: typeof document > "u" ? null : document };
function ia() {
  return Ze.window;
}
let Rd = class {
};
const jn = {}, Pd = "___SYMBOL___ROOT___";
function Wi(r, e = Od) {
  return Ze.document.createElementNS(e, r);
}
function Gt(r, e = !1) {
  if (r instanceof Rd) return r;
  if (typeof r == "object") return hl(r);
  if (r == null) return new jn[Pd]();
  if (typeof r == "string" && r.charAt(0) !== "<") return hl(Ze.document.querySelector(r));
  const t = e ? Ze.document.createElement("div") : Wi("svg");
  return t.innerHTML = r, r = hl(t.firstChild), t.removeChild(t.firstChild), r;
}
function pt(r, e) {
  return e && (e instanceof Ze.window.Node || e.ownerDocument && e instanceof e.ownerDocument.defaultView.Node) ? e : Wi(r);
}
function pr(r) {
  if (!r) return null;
  if (r.instance instanceof Rd) return r.instance;
  if (r.nodeName === "#document-fragment") return new jn.Fragment(r);
  let e = Po(r.nodeName || "Dom");
  return e === "LinearGradient" || e === "RadialGradient" ? e = "Gradient" : jn[e] || (e = "Dom"), new jn[e](r);
}
let hl = pr;
function Je(r, e = r.name, t = !1) {
  return jn[e] = r, t && (jn[Pd] = r), gm(Object.getOwnPropertyNames(r.prototype)), r;
}
let JN = 1e3;
function bm(r) {
  return "Svgjs" + Po(r) + JN++;
}
function xm(r) {
  for (let e = r.children.length - 1; e >= 0; e--) xm(r.children[e]);
  return r.id && (r.id = bm(r.nodeName)), r;
}
function Le(r, e) {
  let t, n;
  for (n = (r = Array.isArray(r) ? r : [r]).length - 1; n >= 0; n--) for (t in e) r[n].prototype[t] = e[t];
}
function dt(r) {
  return function(...e) {
    const t = e[e.length - 1];
    return !t || t.constructor !== Object || t instanceof Array ? r.apply(this, e) : r.apply(this, e.slice(0, -1)).attr(t);
  };
}
$e("Dom", { siblings: function() {
  return this.parent().children();
}, position: function() {
  return this.parent().index(this);
}, next: function() {
  return this.siblings()[this.position() + 1];
}, prev: function() {
  return this.siblings()[this.position() - 1];
}, forward: function() {
  const r = this.position();
  return this.parent().add(this.remove(), r + 1), this;
}, backward: function() {
  const r = this.position();
  return this.parent().add(this.remove(), r ? r - 1 : 0), this;
}, front: function() {
  return this.parent().add(this.remove()), this;
}, back: function() {
  return this.parent().add(this.remove(), 0), this;
}, before: function(r) {
  (r = Gt(r)).remove();
  const e = this.position();
  return this.parent().add(r, e), this;
}, after: function(r) {
  (r = Gt(r)).remove();
  const e = this.position();
  return this.parent().add(r, e + 1), this;
}, insertBefore: function(r) {
  return (r = Gt(r)).before(this), this;
}, insertAfter: function(r) {
  return (r = Gt(r)).after(this), this;
} });
const vm = /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i, QN = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, eL = /rgb\((\d+),(\d+),(\d+)\)/, tL = /(#[a-z_][a-z0-9\-_]*)/i, rL = /\)\s*,?\s*/, nL = /\s/g, Th = /^#[a-f0-9]{3}$|^#[a-f0-9]{6}$/i, Ah = /^rgb\(/, Oh = /^(\s+)?$/, Rh = /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, oL = /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i, Gr = /[\s,]+/, Md = /[MLHVCSQTAZ]/i;
function iL(r) {
  const e = Math.round(r), t = Math.max(0, Math.min(255, e)).toString(16);
  return t.length === 1 ? "0" + t : t;
}
function Zn(r, e) {
  for (let t = e.length; t--; ) if (r[e[t]] == null) return !1;
  return !0;
}
function fl(r, e, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? r + 6 * (e - r) * t : t < 0.5 ? e : t < 2 / 3 ? r + (e - r) * (2 / 3 - t) * 6 : r;
}
$e("Dom", { classes: function() {
  const r = this.attr("class");
  return r == null ? [] : r.trim().split(Gr);
}, hasClass: function(r) {
  return this.classes().indexOf(r) !== -1;
}, addClass: function(r) {
  if (!this.hasClass(r)) {
    const e = this.classes();
    e.push(r), this.attr("class", e.join(" "));
  }
  return this;
}, removeClass: function(r) {
  return this.hasClass(r) && this.attr("class", this.classes().filter((function(e) {
    return e !== r;
  })).join(" ")), this;
}, toggleClass: function(r) {
  return this.hasClass(r) ? this.removeClass(r) : this.addClass(r);
} }), $e("Dom", { css: function(r, e) {
  const t = {};
  if (arguments.length === 0) return this.node.style.cssText.split(/\s*;\s*/).filter((function(n) {
    return !!n.length;
  })).forEach((function(n) {
    const o = n.split(/\s*:\s*/);
    t[o[0]] = o[1];
  })), t;
  if (arguments.length < 2) {
    if (Array.isArray(r)) {
      for (const n of r) {
        const o = n;
        t[n] = this.node.style.getPropertyValue(o);
      }
      return t;
    }
    if (typeof r == "string") return this.node.style.getPropertyValue(r);
    if (typeof r == "object") for (const n in r) this.node.style.setProperty(n, r[n] == null || Oh.test(r[n]) ? "" : r[n]);
  }
  return arguments.length === 2 && this.node.style.setProperty(r, e == null || Oh.test(e) ? "" : e), this;
}, show: function() {
  return this.css("display", "");
}, hide: function() {
  return this.css("display", "none");
}, visible: function() {
  return this.css("display") !== "none";
} }), $e("Dom", { data: function(r, e, t) {
  if (r == null) return this.data(Ad((function(n, o) {
    let i;
    const a = n.length, s = [];
    for (i = 0; i < a; i++) o(n[i]) && s.push(n[i]);
    return s;
  })(this.node.attributes, ((n) => n.nodeName.indexOf("data-") === 0)), ((n) => n.nodeName.slice(5))));
  if (r instanceof Array) {
    const n = {};
    for (const o of r) n[o] = this.data(o);
    return n;
  }
  if (typeof r == "object") for (e in r) this.data(e, r[e]);
  else if (arguments.length < 2) try {
    return JSON.parse(this.attr("data-" + r));
  } catch {
    return this.attr("data-" + r);
  }
  else this.attr("data-" + r, e === null ? null : t === !0 || typeof e == "string" || typeof e == "number" ? e : JSON.stringify(e));
  return this;
} }), $e("Dom", { remember: function(r, e) {
  if (typeof arguments[0] == "object") for (const t in r) this.remember(t, r[t]);
  else {
    if (arguments.length === 1) return this.memory()[r];
    this.memory()[r] = e;
  }
  return this;
}, forget: function() {
  if (arguments.length === 0) this._memory = {};
  else for (let r = arguments.length - 1; r >= 0; r--) delete this.memory()[arguments[r]];
  return this;
}, memory: function() {
  return this._memory = this._memory || {};
} });
class lt {
  constructor(...e) {
    this.init(...e);
  }
  static isColor(e) {
    return e && (e instanceof lt || this.isRgb(e) || this.test(e));
  }
  static isRgb(e) {
    return e && typeof e.r == "number" && typeof e.g == "number" && typeof e.b == "number";
  }
  static random(e = "vibrant", t) {
    const { random: n, round: o, sin: i, PI: a } = Math;
    if (e === "vibrant") {
      const s = 24 * n() + 57, c = 38 * n() + 45, d = 360 * n();
      return new lt(s, c, d, "lch");
    }
    if (e === "sine") {
      const s = o(80 * i(2 * a * (t = t ?? n()) / 0.5 + 0.01) + 150), c = o(50 * i(2 * a * t / 0.5 + 4.6) + 200), d = o(100 * i(2 * a * t / 0.5 + 2.3) + 150);
      return new lt(s, c, d);
    }
    if (e === "pastel") {
      const s = 8 * n() + 86, c = 17 * n() + 9, d = 360 * n();
      return new lt(s, c, d, "lch");
    }
    if (e === "dark") {
      const s = 10 + 10 * n(), c = 50 * n() + 86, d = 360 * n();
      return new lt(s, c, d, "lch");
    }
    if (e === "rgb") {
      const s = 255 * n(), c = 255 * n(), d = 255 * n();
      return new lt(s, c, d);
    }
    if (e === "lab") {
      const s = 100 * n(), c = 256 * n() - 128, d = 256 * n() - 128;
      return new lt(s, c, d, "lab");
    }
    if (e === "grey") {
      const s = 255 * n();
      return new lt(s, s, s);
    }
    throw new Error("Unsupported random color mode");
  }
  static test(e) {
    return typeof e == "string" && (Th.test(e) || Ah.test(e));
  }
  cmyk() {
    const { _a: e, _b: t, _c: n } = this.rgb(), [o, i, a] = [e, t, n].map(((c) => c / 255)), s = Math.min(1 - o, 1 - i, 1 - a);
    return s === 1 ? new lt(0, 0, 0, 1, "cmyk") : new lt((1 - o - s) / (1 - s), (1 - i - s) / (1 - s), (1 - a - s) / (1 - s), s, "cmyk");
  }
  hsl() {
    const { _a: e, _b: t, _c: n } = this.rgb(), [o, i, a] = [e, t, n].map(((h) => h / 255)), s = Math.max(o, i, a), c = Math.min(o, i, a), d = (s + c) / 2, u = s === c, p = s - c;
    return new lt(360 * (u ? 0 : s === o ? ((i - a) / p + (i < a ? 6 : 0)) / 6 : s === i ? ((a - o) / p + 2) / 6 : s === a ? ((o - i) / p + 4) / 6 : 0), 100 * (u ? 0 : d > 0.5 ? p / (2 - s - c) : p / (s + c)), 100 * d, "hsl");
  }
  init(e = 0, t = 0, n = 0, o = 0, i = "rgb") {
    if (e = e || 0, this.space) for (const p in this.space) delete this[this.space[p]];
    if (typeof e == "number") i = typeof o == "string" ? o : i, o = typeof o == "string" ? 0 : o, Object.assign(this, { _a: e, _b: t, _c: n, _d: o, space: i });
    else if (e instanceof Array) this.space = t || (typeof e[3] == "string" ? e[3] : e[4]) || "rgb", Object.assign(this, { _a: e[0], _b: e[1], _c: e[2], _d: e[3] || 0 });
    else if (e instanceof Object) {
      const p = (function(h, f) {
        const m = Zn(h, "rgb") ? { _a: h.r, _b: h.g, _c: h.b, _d: 0, space: "rgb" } : Zn(h, "xyz") ? { _a: h.x, _b: h.y, _c: h.z, _d: 0, space: "xyz" } : Zn(h, "hsl") ? { _a: h.h, _b: h.s, _c: h.l, _d: 0, space: "hsl" } : Zn(h, "lab") ? { _a: h.l, _b: h.a, _c: h.b, _d: 0, space: "lab" } : Zn(h, "lch") ? { _a: h.l, _b: h.c, _c: h.h, _d: 0, space: "lch" } : Zn(h, "cmyk") ? { _a: h.c, _b: h.m, _c: h.y, _d: h.k, space: "cmyk" } : { _a: 0, _b: 0, _c: 0, space: "rgb" };
        return m.space = f || m.space, m;
      })(e, t);
      Object.assign(this, p);
    } else if (typeof e == "string") if (Ah.test(e)) {
      const p = e.replace(nL, ""), [h, f, m] = eL.exec(p).slice(1, 4).map(((g) => parseInt(g)));
      Object.assign(this, { _a: h, _b: f, _c: m, _d: 0, space: "rgb" });
    } else {
      if (!Th.test(e)) throw Error("Unsupported string format, can't construct Color");
      {
        const p = (g) => parseInt(g, 16), [, h, f, m] = QN.exec((function(g) {
          return g.length === 4 ? ["#", g.substring(1, 2), g.substring(1, 2), g.substring(2, 3), g.substring(2, 3), g.substring(3, 4), g.substring(3, 4)].join("") : g;
        })(e)).map(p);
        Object.assign(this, { _a: h, _b: f, _c: m, _d: 0, space: "rgb" });
      }
    }
    const { _a: a, _b: s, _c: c, _d: d } = this, u = this.space === "rgb" ? { r: a, g: s, b: c } : this.space === "xyz" ? { x: a, y: s, z: c } : this.space === "hsl" ? { h: a, s, l: c } : this.space === "lab" ? { l: a, a: s, b: c } : this.space === "lch" ? { l: a, c: s, h: c } : this.space === "cmyk" ? { c: a, m: s, y: c, k: d } : {};
    Object.assign(this, u);
  }
  lab() {
    const { x: e, y: t, z: n } = this.xyz();
    return new lt(116 * t - 16, 500 * (e - t), 200 * (t - n), "lab");
  }
  lch() {
    const { l: e, a: t, b: n } = this.lab(), o = Math.sqrt(t ** 2 + n ** 2);
    let i = 180 * Math.atan2(n, t) / Math.PI;
    return i < 0 && (i *= -1, i = 360 - i), new lt(e, o, i, "lch");
  }
  rgb() {
    if (this.space === "rgb") return this;
    if ((e = this.space) === "lab" || e === "xyz" || e === "lch") {
      let { x: t, y: n, z: o } = this;
      if (this.space === "lab" || this.space === "lch") {
        let { l: f, a: m, b: g } = this;
        if (this.space === "lch") {
          const { c: T, h: S } = this, O = Math.PI / 180;
          m = T * Math.cos(O * S), g = T * Math.sin(O * S);
        }
        const b = (f + 16) / 116, x = m / 500 + b, v = b - g / 200, y = 16 / 116, C = 8856e-6, k = 7.787;
        t = 0.95047 * (x ** 3 > C ? x ** 3 : (x - y) / k), n = 1 * (b ** 3 > C ? b ** 3 : (b - y) / k), o = 1.08883 * (v ** 3 > C ? v ** 3 : (v - y) / k);
      }
      const i = 3.2406 * t + -1.5372 * n + -0.4986 * o, a = -0.9689 * t + 1.8758 * n + 0.0415 * o, s = 0.0557 * t + -0.204 * n + 1.057 * o, c = Math.pow, d = 31308e-7, u = i > d ? 1.055 * c(i, 1 / 2.4) - 0.055 : 12.92 * i, p = a > d ? 1.055 * c(a, 1 / 2.4) - 0.055 : 12.92 * a, h = s > d ? 1.055 * c(s, 1 / 2.4) - 0.055 : 12.92 * s;
      return new lt(255 * u, 255 * p, 255 * h);
    }
    if (this.space === "hsl") {
      let { h: t, s: n, l: o } = this;
      if (t /= 360, n /= 100, o /= 100, n === 0)
        return o *= 255, new lt(o, o, o);
      const i = o < 0.5 ? o * (1 + n) : o + n - o * n, a = 2 * o - i, s = 255 * fl(a, i, t + 1 / 3), c = 255 * fl(a, i, t), d = 255 * fl(a, i, t - 1 / 3);
      return new lt(s, c, d);
    }
    if (this.space === "cmyk") {
      const { c: t, m: n, y: o, k: i } = this, a = 255 * (1 - Math.min(1, t * (1 - i) + i)), s = 255 * (1 - Math.min(1, n * (1 - i) + i)), c = 255 * (1 - Math.min(1, o * (1 - i) + i));
      return new lt(a, s, c);
    }
    return this;
    var e;
  }
  toArray() {
    const { _a: e, _b: t, _c: n, _d: o, space: i } = this;
    return [e, t, n, o, i];
  }
  toHex() {
    const [e, t, n] = this._clamped().map(iL);
    return `#${e}${t}${n}`;
  }
  toRgb() {
    const [e, t, n] = this._clamped();
    return `rgb(${e},${t},${n})`;
  }
  toString() {
    return this.toHex();
  }
  xyz() {
    const { _a: e, _b: t, _c: n } = this.rgb(), [o, i, a] = [e, t, n].map(((b) => b / 255)), s = o > 0.04045 ? Math.pow((o + 0.055) / 1.055, 2.4) : o / 12.92, c = i > 0.04045 ? Math.pow((i + 0.055) / 1.055, 2.4) : i / 12.92, d = a > 0.04045 ? Math.pow((a + 0.055) / 1.055, 2.4) : a / 12.92, u = (0.4124 * s + 0.3576 * c + 0.1805 * d) / 0.95047, p = (0.2126 * s + 0.7152 * c + 0.0722 * d) / 1, h = (0.0193 * s + 0.1192 * c + 0.9505 * d) / 1.08883, f = u > 8856e-6 ? Math.pow(u, 1 / 3) : 7.787 * u + 16 / 116, m = p > 8856e-6 ? Math.pow(p, 1 / 3) : 7.787 * p + 16 / 116, g = h > 8856e-6 ? Math.pow(h, 1 / 3) : 7.787 * h + 16 / 116;
    return new lt(f, m, g, "xyz");
  }
  _clamped() {
    const { _a: e, _b: t, _c: n } = this.rgb(), { max: o, min: i, round: a } = Math;
    return [e, t, n].map(((s) => o(0, i(a(s), 255))));
  }
}
class nt {
  constructor(...e) {
    this.init(...e);
  }
  clone() {
    return new nt(this);
  }
  init(e, t) {
    const i = Array.isArray(e) ? { x: e[0], y: e[1] } : typeof e == "object" ? { x: e.x, y: e.y } : { x: e, y: t };
    return this.x = i.x == null ? 0 : i.x, this.y = i.y == null ? 0 : i.y, this;
  }
  toArray() {
    return [this.x, this.y];
  }
  transform(e) {
    return this.clone().transformO(e);
  }
  transformO(e) {
    Ee.isMatrixLike(e) || (e = new Ee(e));
    const { x: t, y: n } = this;
    return this.x = e.a * t + e.c * n + e.e, this.y = e.b * t + e.d * n + e.f, this;
  }
}
function Jn(r, e, t) {
  return Math.abs(e - r) < 1e-6;
}
class Ee {
  constructor(...e) {
    this.init(...e);
  }
  static formatTransforms(e) {
    const t = e.flip === "both" || e.flip === !0, n = e.flip && (t || e.flip === "x") ? -1 : 1, o = e.flip && (t || e.flip === "y") ? -1 : 1, i = e.skew && e.skew.length ? e.skew[0] : isFinite(e.skew) ? e.skew : isFinite(e.skewX) ? e.skewX : 0, a = e.skew && e.skew.length ? e.skew[1] : isFinite(e.skew) ? e.skew : isFinite(e.skewY) ? e.skewY : 0, s = e.scale && e.scale.length ? e.scale[0] * n : isFinite(e.scale) ? e.scale * n : isFinite(e.scaleX) ? e.scaleX * n : n, c = e.scale && e.scale.length ? e.scale[1] * o : isFinite(e.scale) ? e.scale * o : isFinite(e.scaleY) ? e.scaleY * o : o, d = e.shear || 0, u = e.rotate || e.theta || 0, p = new nt(e.origin || e.around || e.ox || e.originX, e.oy || e.originY), h = p.x, f = p.y, m = new nt(e.position || e.px || e.positionX || NaN, e.py || e.positionY || NaN), g = m.x, b = m.y, x = new nt(e.translate || e.tx || e.translateX, e.ty || e.translateY), v = x.x, y = x.y, C = new nt(e.relative || e.rx || e.relativeX, e.ry || e.relativeY);
    return { scaleX: s, scaleY: c, skewX: i, skewY: a, shear: d, theta: u, rx: C.x, ry: C.y, tx: v, ty: y, ox: h, oy: f, px: g, py: b };
  }
  static fromArray(e) {
    return { a: e[0], b: e[1], c: e[2], d: e[3], e: e[4], f: e[5] };
  }
  static isMatrixLike(e) {
    return e.a != null || e.b != null || e.c != null || e.d != null || e.e != null || e.f != null;
  }
  static matrixMultiply(e, t, n) {
    const o = e.a * t.a + e.c * t.b, i = e.b * t.a + e.d * t.b, a = e.a * t.c + e.c * t.d, s = e.b * t.c + e.d * t.d, c = e.e + e.a * t.e + e.c * t.f, d = e.f + e.b * t.e + e.d * t.f;
    return n.a = o, n.b = i, n.c = a, n.d = s, n.e = c, n.f = d, n;
  }
  around(e, t, n) {
    return this.clone().aroundO(e, t, n);
  }
  aroundO(e, t, n) {
    const o = e || 0, i = t || 0;
    return this.translateO(-o, -i).lmultiplyO(n).translateO(o, i);
  }
  clone() {
    return new Ee(this);
  }
  decompose(e = 0, t = 0) {
    const n = this.a, o = this.b, i = this.c, a = this.d, s = this.e, c = this.f, d = n * a - o * i, u = d > 0 ? 1 : -1, p = u * Math.sqrt(n * n + o * o), h = Math.atan2(u * o, u * n), f = 180 / Math.PI * h, m = Math.cos(h), g = Math.sin(h), b = (n * i + o * a) / d, x = i * p / (b * n - o) || a * p / (b * o + n);
    return { scaleX: p, scaleY: x, shear: b, rotate: f, translateX: s - e + e * m * p + t * (b * m * p - g * x), translateY: c - t + e * g * p + t * (b * g * p + m * x), originX: e, originY: t, a: this.a, b: this.b, c: this.c, d: this.d, e: this.e, f: this.f };
  }
  equals(e) {
    if (e === this) return !0;
    const t = new Ee(e);
    return Jn(this.a, t.a) && Jn(this.b, t.b) && Jn(this.c, t.c) && Jn(this.d, t.d) && Jn(this.e, t.e) && Jn(this.f, t.f);
  }
  flip(e, t) {
    return this.clone().flipO(e, t);
  }
  flipO(e, t) {
    return e === "x" ? this.scaleO(-1, 1, t, 0) : e === "y" ? this.scaleO(1, -1, 0, t) : this.scaleO(-1, -1, e, t || e);
  }
  init(e) {
    const t = Ee.fromArray([1, 0, 0, 1, 0, 0]);
    return e = e instanceof Bt ? e.matrixify() : typeof e == "string" ? Ee.fromArray(e.split(Gr).map(parseFloat)) : Array.isArray(e) ? Ee.fromArray(e) : typeof e == "object" && Ee.isMatrixLike(e) ? e : typeof e == "object" ? new Ee().transform(e) : arguments.length === 6 ? Ee.fromArray([].slice.call(arguments)) : t, this.a = e.a != null ? e.a : t.a, this.b = e.b != null ? e.b : t.b, this.c = e.c != null ? e.c : t.c, this.d = e.d != null ? e.d : t.d, this.e = e.e != null ? e.e : t.e, this.f = e.f != null ? e.f : t.f, this;
  }
  inverse() {
    return this.clone().inverseO();
  }
  inverseO() {
    const e = this.a, t = this.b, n = this.c, o = this.d, i = this.e, a = this.f, s = e * o - t * n;
    if (!s) throw new Error("Cannot invert " + this);
    const c = o / s, d = -t / s, u = -n / s, p = e / s, h = -(c * i + u * a), f = -(d * i + p * a);
    return this.a = c, this.b = d, this.c = u, this.d = p, this.e = h, this.f = f, this;
  }
  lmultiply(e) {
    return this.clone().lmultiplyO(e);
  }
  lmultiplyO(e) {
    const t = e instanceof Ee ? e : new Ee(e);
    return Ee.matrixMultiply(t, this, this);
  }
  multiply(e) {
    return this.clone().multiplyO(e);
  }
  multiplyO(e) {
    const t = e instanceof Ee ? e : new Ee(e);
    return Ee.matrixMultiply(this, t, this);
  }
  rotate(e, t, n) {
    return this.clone().rotateO(e, t, n);
  }
  rotateO(e, t = 0, n = 0) {
    e = ul(e);
    const o = Math.cos(e), i = Math.sin(e), { a, b: s, c, d, e: u, f: p } = this;
    return this.a = a * o - s * i, this.b = s * o + a * i, this.c = c * o - d * i, this.d = d * o + c * i, this.e = u * o - p * i + n * i - t * o + t, this.f = p * o + u * i - t * i - n * o + n, this;
  }
  scale() {
    return this.clone().scaleO(...arguments);
  }
  scaleO(e, t = e, n = 0, o = 0) {
    arguments.length === 3 && (o = n, n = t, t = e);
    const { a: i, b: a, c: s, d: c, e: d, f: u } = this;
    return this.a = i * e, this.b = a * t, this.c = s * e, this.d = c * t, this.e = d * e - n * e + n, this.f = u * t - o * t + o, this;
  }
  shear(e, t, n) {
    return this.clone().shearO(e, t, n);
  }
  shearO(e, t = 0, n = 0) {
    const { a: o, b: i, c: a, d: s, e: c, f: d } = this;
    return this.a = o + i * e, this.c = a + s * e, this.e = c + d * e - n * e, this;
  }
  skew() {
    return this.clone().skewO(...arguments);
  }
  skewO(e, t = e, n = 0, o = 0) {
    arguments.length === 3 && (o = n, n = t, t = e), e = ul(e), t = ul(t);
    const i = Math.tan(e), a = Math.tan(t), { a: s, b: c, c: d, d: u, e: p, f: h } = this;
    return this.a = s + c * i, this.b = c + s * a, this.c = d + u * i, this.d = u + d * a, this.e = p + h * i - o * i, this.f = h + p * a - n * a, this;
  }
  skewX(e, t, n) {
    return this.skew(e, 0, t, n);
  }
  skewY(e, t, n) {
    return this.skew(0, e, t, n);
  }
  toArray() {
    return [this.a, this.b, this.c, this.d, this.e, this.f];
  }
  toString() {
    return "matrix(" + this.a + "," + this.b + "," + this.c + "," + this.d + "," + this.e + "," + this.f + ")";
  }
  transform(e) {
    if (Ee.isMatrixLike(e))
      return new Ee(e).multiplyO(this);
    const t = Ee.formatTransforms(e), { x: n, y: o } = new nt(t.ox, t.oy).transform(this), i = new Ee().translateO(t.rx, t.ry).lmultiplyO(this).translateO(-n, -o).scaleO(t.scaleX, t.scaleY).skewO(t.skewX, t.skewY).shearO(t.shear).rotateO(t.theta).translateO(n, o);
    if (isFinite(t.px) || isFinite(t.py)) {
      const a = new nt(n, o).transform(i), s = isFinite(t.px) ? t.px - a.x : 0, c = isFinite(t.py) ? t.py - a.y : 0;
      i.translateO(s, c);
    }
    return i.translateO(t.tx, t.ty), i;
  }
  translate(e, t) {
    return this.clone().translateO(e, t);
  }
  translateO(e, t) {
    return this.e += e || 0, this.f += t || 0, this;
  }
  valueOf() {
    return { a: this.a, b: this.b, c: this.c, d: this.d, e: this.e, f: this.f };
  }
}
function nn() {
  if (!nn.nodes) {
    const r = Gt().size(2, 0);
    r.node.style.cssText = ["opacity: 0", "position: absolute", "left: -100%", "top: -100%", "overflow: hidden"].join(";"), r.attr("focusable", "false"), r.attr("aria-hidden", "true");
    const e = r.path().node;
    nn.nodes = { svg: r, path: e };
  }
  if (!nn.nodes.svg.node.parentNode) {
    const r = Ze.document.body || Ze.document.documentElement;
    nn.nodes.svg.addTo(r);
  }
  return nn.nodes;
}
function ym(r) {
  return !(r.width || r.height || r.x || r.y);
}
Je(Ee, "Matrix");
class St {
  constructor(...e) {
    this.init(...e);
  }
  addOffset() {
    return this.x += Ze.window.pageXOffset, this.y += Ze.window.pageYOffset, new St(this);
  }
  init(e) {
    return e = typeof e == "string" ? e.split(Gr).map(parseFloat) : Array.isArray(e) ? e : typeof e == "object" ? [e.left != null ? e.left : e.x, e.top != null ? e.top : e.y, e.width, e.height] : arguments.length === 4 ? [].slice.call(arguments) : [0, 0, 0, 0], this.x = e[0] || 0, this.y = e[1] || 0, this.width = this.w = e[2] || 0, this.height = this.h = e[3] || 0, this.x2 = this.x + this.w, this.y2 = this.y + this.h, this.cx = this.x + this.w / 2, this.cy = this.y + this.h / 2, this;
  }
  isNulled() {
    return ym(this);
  }
  merge(e) {
    const t = Math.min(this.x, e.x), n = Math.min(this.y, e.y), o = Math.max(this.x + this.width, e.x + e.width) - t, i = Math.max(this.y + this.height, e.y + e.height) - n;
    return new St(t, n, o, i);
  }
  toArray() {
    return [this.x, this.y, this.width, this.height];
  }
  toString() {
    return this.x + " " + this.y + " " + this.width + " " + this.height;
  }
  transform(e) {
    e instanceof Ee || (e = new Ee(e));
    let t = 1 / 0, n = -1 / 0, o = 1 / 0, i = -1 / 0;
    return [new nt(this.x, this.y), new nt(this.x2, this.y), new nt(this.x, this.y2), new nt(this.x2, this.y2)].forEach((function(a) {
      a = a.transform(e), t = Math.min(t, a.x), n = Math.max(n, a.x), o = Math.min(o, a.y), i = Math.max(i, a.y);
    })), new St(t, o, n - t, i - o);
  }
}
function Ph(r, e, t) {
  let n;
  try {
    if (n = e(r.node), ym(n) && (o = r.node) !== Ze.document && !(Ze.document.documentElement.contains || function(i) {
      for (; i.parentNode; ) i = i.parentNode;
      return i === Ze.document;
    }).call(Ze.document.documentElement, o)) throw new Error("Element not in the dom");
  } catch {
    n = t(r);
  }
  var o;
  return n;
}
$e({ viewbox: { viewbox(r, e, t, n) {
  return r == null ? new St(this.attr("viewBox")) : this.attr("viewBox", new St(r, e, t, n));
}, zoom(r, e) {
  let { width: t, height: n } = this.attr(["width", "height"]);
  if ((t || n) && typeof t != "string" && typeof n != "string" || (t = this.node.clientWidth, n = this.node.clientHeight), !t || !n) throw new Error("Impossible to get absolute width and height. Please provide an absolute width and height attribute on the zooming element");
  const o = this.viewbox(), i = t / o.width, a = n / o.height, s = Math.min(i, a);
  if (r == null) return s;
  let c = s / r;
  c === 1 / 0 && (c = Number.MAX_SAFE_INTEGER / 100), e = e || new nt(t / 2 / i + o.x, n / 2 / a + o.y);
  const d = new St(o).transform(new Ee({ scale: c, origin: e }));
  return this.viewbox(d);
} } }), Je(St, "Box");
class $n extends Array {
  constructor(e = [], ...t) {
    if (super(e, ...t), typeof e == "number") return this;
    this.length = 0, this.push(...e);
  }
}
Le([$n], { each(r, ...e) {
  return typeof r == "function" ? this.map(((t, n, o) => r.call(t, t, n, o))) : this.map(((t) => t[r](...e)));
}, toArray() {
  return Array.prototype.concat.apply([], this);
} });
const aL = ["toArray", "constructor", "each"];
function Hn(r, e) {
  return new $n(Ad((e || Ze.document).querySelectorAll(r), (function(t) {
    return pr(t);
  })));
}
$n.extend = function(r) {
  r = r.reduce(((e, t) => (aL.includes(t) || t[0] === "_" || (t in Array.prototype && (e["$" + t] = Array.prototype[t]), e[t] = function(...n) {
    return this.each(t, ...n);
  }), e)), {}), Le([$n], r);
};
let sL = 0;
const wm = {};
function Cm(r) {
  let e = r.getEventHolder();
  return e === Ze.window && (e = wm), e.events || (e.events = {}), e.events;
}
function Ed(r) {
  return r.getEventTarget();
}
function Wr(r, e, t, n, o) {
  const i = t.bind(n || r), a = Gt(r), s = Cm(a), c = Ed(a);
  e = Array.isArray(e) ? e : e.split(Gr), t._svgjsListenerId || (t._svgjsListenerId = ++sL), e.forEach((function(d) {
    const u = d.split(".")[0], p = d.split(".")[1] || "*";
    s[u] = s[u] || {}, s[u][p] = s[u][p] || {}, s[u][p][t._svgjsListenerId] = i, c.addEventListener(u, i, o || !1);
  }));
}
function fr(r, e, t, n) {
  const o = Gt(r), i = Cm(o), a = Ed(o);
  (typeof t != "function" || (t = t._svgjsListenerId)) && (e = Array.isArray(e) ? e : (e || "").split(Gr)).forEach((function(s) {
    const c = s && s.split(".")[0], d = s && s.split(".")[1];
    let u, p;
    if (t) i[c] && i[c][d || "*"] && (a.removeEventListener(c, i[c][d || "*"][t], n || !1), delete i[c][d || "*"][t]);
    else if (c && d) {
      if (i[c] && i[c][d]) {
        for (p in i[c][d]) fr(a, [c, d].join("."), p);
        delete i[c][d];
      }
    } else if (d) for (s in i) for (u in i[s]) d === u && fr(a, [s, d].join("."));
    else if (c) {
      if (i[c]) {
        for (u in i[c]) fr(a, [c, u].join("."));
        delete i[c];
      }
    } else {
      for (s in i) fr(a, s);
      (function(h) {
        let f = h.getEventHolder();
        f === Ze.window && (f = wm), f.events && (f.events = {});
      })(o);
    }
  }));
}
class aa extends Rd {
  addEventListener() {
  }
  dispatch(e, t, n) {
    return (function(o, i, a, s) {
      const c = Ed(o);
      return i instanceof Ze.window.Event || (i = new Ze.window.CustomEvent(i, { detail: a, cancelable: !0, ...s })), c.dispatchEvent(i), i;
    })(this, e, t, n);
  }
  dispatchEvent(e) {
    const t = this.getEventHolder().events;
    if (!t) return !0;
    const n = t[e.type];
    for (const o in n) for (const i in n[o]) n[o][i](e);
    return !e.defaultPrevented;
  }
  fire(e, t, n) {
    return this.dispatch(e, t, n), this;
  }
  getEventHolder() {
    return this;
  }
  getEventTarget() {
    return this;
  }
  off(e, t, n) {
    return fr(this, e, t, n), this;
  }
  on(e, t, n, o) {
    return Wr(this, e, t, n, o), this;
  }
  removeEventListener() {
  }
}
function Mh() {
}
Je(aa, "EventTarget");
const gl = 400, lL = ">", cL = 0, dL = { "fill-opacity": 1, "stroke-opacity": 1, "stroke-width": 0, "stroke-linejoin": "miter", "stroke-linecap": "butt", fill: "#000000", stroke: "#000000", opacity: 1, x: 0, y: 0, cx: 0, cy: 0, width: 0, height: 0, r: 0, rx: 0, ry: 0, offset: 0, "stop-opacity": 1, "stop-color": "#000000", "text-anchor": "start" };
class Wn extends Array {
  constructor(...e) {
    super(...e), this.init(...e);
  }
  clone() {
    return new this.constructor(this);
  }
  init(e) {
    return typeof e == "number" || (this.length = 0, this.push(...this.parse(e))), this;
  }
  parse(e = []) {
    return e instanceof Array ? e : e.trim().split(Gr).map(parseFloat);
  }
  toArray() {
    return Array.prototype.concat.apply([], this);
  }
  toSet() {
    return new Set(this);
  }
  toString() {
    return this.join(" ");
  }
  valueOf() {
    const e = [];
    return e.push(...this), e;
  }
}
class De {
  constructor(...e) {
    this.init(...e);
  }
  convert(e) {
    return new De(this.value, e);
  }
  divide(e) {
    return e = new De(e), new De(this / e, this.unit || e.unit);
  }
  init(e, t) {
    return t = Array.isArray(e) ? e[1] : t, e = Array.isArray(e) ? e[0] : e, this.value = 0, this.unit = t || "", typeof e == "number" ? this.value = isNaN(e) ? 0 : isFinite(e) ? e : e < 0 ? -34e37 : 34e37 : typeof e == "string" ? (t = e.match(vm)) && (this.value = parseFloat(t[1]), t[5] === "%" ? this.value /= 100 : t[5] === "s" && (this.value *= 1e3), this.unit = t[5]) : e instanceof De && (this.value = e.valueOf(), this.unit = e.unit), this;
  }
  minus(e) {
    return e = new De(e), new De(this - e, this.unit || e.unit);
  }
  plus(e) {
    return e = new De(e), new De(this + e, this.unit || e.unit);
  }
  times(e) {
    return e = new De(e), new De(this * e, this.unit || e.unit);
  }
  toArray() {
    return [this.value, this.unit];
  }
  toJSON() {
    return this.toString();
  }
  toString() {
    return (this.unit === "%" ? ~~(1e8 * this.value) / 1e6 : this.unit === "s" ? this.value / 1e3 : this.value) + this.unit;
  }
  valueOf() {
    return this.value;
  }
}
const uL = /* @__PURE__ */ new Set(["fill", "stroke", "color", "bgcolor", "stop-color", "flood-color", "lighting-color"]), km = [];
class dn extends aa {
  constructor(e, t) {
    super(), this.node = e, this.type = e.nodeName, t && e !== t && this.attr(t);
  }
  add(e, t) {
    return (e = Gt(e)).removeNamespace && this.node instanceof Ze.window.SVGElement && e.removeNamespace(), t == null ? this.node.appendChild(e.node) : e.node !== this.node.childNodes[t] && this.node.insertBefore(e.node, this.node.childNodes[t]), this;
  }
  addTo(e, t) {
    return Gt(e).put(this, t);
  }
  children() {
    return new $n(Ad(this.node.children, (function(e) {
      return pr(e);
    })));
  }
  clear() {
    for (; this.node.hasChildNodes(); ) this.node.removeChild(this.node.lastChild);
    return this;
  }
  clone(e = !0, t = !0) {
    this.writeDataToDom();
    let n = this.node.cloneNode(e);
    return t && (n = xm(n)), new this.constructor(n);
  }
  each(e, t) {
    const n = this.children();
    let o, i;
    for (o = 0, i = n.length; o < i; o++) e.apply(n[o], [o, n]), t && n[o].each(e, t);
    return this;
  }
  element(e, t) {
    return this.put(new dn(Wi(e), t));
  }
  first() {
    return pr(this.node.firstChild);
  }
  get(e) {
    return pr(this.node.childNodes[e]);
  }
  getEventHolder() {
    return this.node;
  }
  getEventTarget() {
    return this.node;
  }
  has(e) {
    return this.index(e) >= 0;
  }
  html(e, t) {
    return this.xml(e, t, "http://www.w3.org/1999/xhtml");
  }
  id(e) {
    return e !== void 0 || this.node.id || (this.node.id = bm(this.type)), this.attr("id", e);
  }
  index(e) {
    return [].slice.call(this.node.childNodes).indexOf(e.node);
  }
  last() {
    return pr(this.node.lastChild);
  }
  matches(e) {
    const t = this.node, n = t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector || null;
    return n && n.call(t, e);
  }
  parent(e) {
    let t = this;
    if (!t.node.parentNode) return null;
    if (t = pr(t.node.parentNode), !e) return t;
    do
      if (typeof e == "string" ? t.matches(e) : t instanceof e) return t;
    while (t = pr(t.node.parentNode));
    return t;
  }
  put(e, t) {
    return e = Gt(e), this.add(e, t), e;
  }
  putIn(e, t) {
    return Gt(e).add(this, t);
  }
  remove() {
    return this.parent() && this.parent().removeElement(this), this;
  }
  removeElement(e) {
    return this.node.removeChild(e.node), this;
  }
  replace(e) {
    return e = Gt(e), this.node.parentNode && this.node.parentNode.replaceChild(e.node, this.node), e;
  }
  round(e = 2, t = null) {
    const n = 10 ** e, o = this.attr(t);
    for (const i in o) typeof o[i] == "number" && (o[i] = Math.round(o[i] * n) / n);
    return this.attr(o), this;
  }
  svg(e, t) {
    return this.xml(e, t, Od);
  }
  toString() {
    return this.id();
  }
  words(e) {
    return this.node.textContent = e, this;
  }
  wrap(e) {
    const t = this.parent();
    if (!t) return this.addTo(e);
    const n = t.index(this);
    return t.put(e, n).put(this);
  }
  writeDataToDom() {
    return this.each((function() {
      this.writeDataToDom();
    })), this;
  }
  xml(e, t, n) {
    if (typeof e == "boolean" && (n = t, t = e, e = null), e == null || typeof e == "function") {
      t = t == null || t, this.writeDataToDom();
      let s = this;
      if (e != null) {
        if (s = pr(s.node.cloneNode(!0)), t) {
          const c = e(s);
          if (s = c || s, c === !1) return "";
        }
        s.each((function() {
          const c = e(this), d = c || this;
          c === !1 ? this.remove() : c && this !== d && this.replace(d);
        }), !0);
      }
      return t ? s.node.outerHTML : s.node.innerHTML;
    }
    t = t != null && t;
    const o = Wi("wrapper", n), i = Ze.document.createDocumentFragment();
    o.innerHTML = e;
    for (let s = o.children.length; s--; ) i.appendChild(o.firstElementChild);
    const a = this.parent();
    return t ? this.replace(i) && a : this.add(i);
  }
}
Le(dn, { attr: function(r, e, t) {
  if (r == null) {
    r = {}, e = this.node.attributes;
    for (const n of e) r[n.nodeName] = Rh.test(n.nodeValue) ? parseFloat(n.nodeValue) : n.nodeValue;
    return r;
  }
  if (r instanceof Array) return r.reduce(((n, o) => (n[o] = this.attr(o), n)), {});
  if (typeof r == "object" && r.constructor === Object) for (e in r) this.attr(e, r[e]);
  else if (e === null) this.node.removeAttribute(r);
  else {
    if (e == null) return (e = this.node.getAttribute(r)) == null ? dL[r] : Rh.test(e) ? parseFloat(e) : e;
    typeof (e = km.reduce(((n, o) => o(r, n, this)), e)) == "number" ? e = new De(e) : uL.has(r) && lt.isColor(e) ? e = new lt(e) : e.constructor === Array && (e = new Wn(e)), r === "leading" ? this.leading && this.leading(e) : typeof t == "string" ? this.node.setAttributeNS(t, r, e.toString()) : this.node.setAttribute(r, e.toString()), !this.rebuild || r !== "font-size" && r !== "x" || this.rebuild();
  }
  return this;
}, find: function(r) {
  return Hn(r, this.node);
}, findOne: function(r) {
  return pr(this.node.querySelector(r));
} }), Je(dn, "Dom");
let Bt = class extends dn {
  constructor(r, e) {
    super(r, e), this.dom = {}, this.node.instance = this, (r.hasAttribute("data-svgjs") || r.hasAttribute("svgjs:data")) && this.setData(JSON.parse(r.getAttribute("data-svgjs")) ?? JSON.parse(r.getAttribute("svgjs:data")) ?? {});
  }
  center(r, e) {
    return this.cx(r).cy(e);
  }
  cx(r) {
    return r == null ? this.x() + this.width() / 2 : this.x(r - this.width() / 2);
  }
  cy(r) {
    return r == null ? this.y() + this.height() / 2 : this.y(r - this.height() / 2);
  }
  defs() {
    const r = this.root();
    return r && r.defs();
  }
  dmove(r, e) {
    return this.dx(r).dy(e);
  }
  dx(r = 0) {
    return this.x(new De(r).plus(this.x()));
  }
  dy(r = 0) {
    return this.y(new De(r).plus(this.y()));
  }
  getEventHolder() {
    return this;
  }
  height(r) {
    return this.attr("height", r);
  }
  move(r, e) {
    return this.x(r).y(e);
  }
  parents(r = this.root()) {
    const e = typeof r == "string";
    e || (r = Gt(r));
    const t = new $n();
    let n = this;
    for (; (n = n.parent()) && n.node !== Ze.document && n.nodeName !== "#document-fragment" && (t.push(n), e || n.node !== r.node) && (!e || !n.matches(r)); ) if (n.node === this.root().node) return null;
    return t;
  }
  reference(r) {
    if (!(r = this.attr(r))) return null;
    const e = (r + "").match(tL);
    return e ? Gt(e[1]) : null;
  }
  root() {
    const r = this.parent((function(e) {
      return jn[e];
    })(Pd));
    return r && r.root();
  }
  setData(r) {
    return this.dom = r, this;
  }
  size(r, e) {
    const t = Mo(this, r, e);
    return this.width(new De(t.width)).height(new De(t.height));
  }
  width(r) {
    return this.attr("width", r);
  }
  writeDataToDom() {
    return mm(this, this.dom), super.writeDataToDom();
  }
  x(r) {
    return this.attr("x", r);
  }
  y(r) {
    return this.attr("y", r);
  }
};
Le(Bt, { bbox: function() {
  const r = Ph(this, ((e) => e.getBBox()), ((e) => {
    try {
      const t = e.clone().addTo(nn().svg).show(), n = t.node.getBBox();
      return t.remove(), n;
    } catch (t) {
      throw new Error(`Getting bbox of element "${e.node.nodeName}" is not possible: ${t.toString()}`);
    }
  }));
  return new St(r);
}, rbox: function(r) {
  const e = Ph(this, ((n) => n.getBoundingClientRect()), ((n) => {
    throw new Error(`Getting rbox of element "${n.node.nodeName}" is not possible`);
  })), t = new St(e);
  return r ? t.transform(r.screenCTM().inverseO()) : t.addOffset();
}, inside: function(r, e) {
  const t = this.bbox();
  return r > t.x && e > t.y && r < t.x + t.width && e < t.y + t.height;
}, point: function(r, e) {
  return new nt(r, e).transformO(this.screenCTM().inverseO());
}, ctm: function() {
  return new Ee(this.node.getCTM());
}, screenCTM: function() {
  try {
    if (typeof this.isRoot == "function" && !this.isRoot()) {
      const r = this.rect(1, 1), e = r.node.getScreenCTM();
      return r.remove(), new Ee(e);
    }
    return new Ee(this.node.getScreenCTM());
  } catch {
    return console.warn(`Cannot get CTM from SVG node ${this.node.nodeName}. Is the element rendered?`), new Ee();
  }
} }), Je(Bt, "Element");
const gi = { stroke: ["color", "width", "opacity", "linecap", "linejoin", "miterlimit", "dasharray", "dashoffset"], fill: ["color", "opacity", "rule"], prefix: function(r, e) {
  return e === "color" ? r : r + "-" + e;
} };
["fill", "stroke"].forEach((function(r) {
  const e = {};
  let t;
  e[r] = function(n) {
    if (n === void 0) return this.attr(r);
    if (typeof n == "string" || n instanceof lt || lt.isRgb(n) || n instanceof Bt) this.attr(r, n);
    else for (t = gi[r].length - 1; t >= 0; t--) n[gi[r][t]] != null && this.attr(gi.prefix(r, gi[r][t]), n[gi[r][t]]);
    return this;
  }, $e(["Element", "Runner"], e);
})), $e(["Element", "Runner"], { matrix: function(r, e, t, n, o, i) {
  return r == null ? new Ee(this) : this.attr("transform", new Ee(r, e, t, n, o, i));
}, rotate: function(r, e, t) {
  return this.transform({ rotate: r, ox: e, oy: t }, !0);
}, skew: function(r, e, t, n) {
  return arguments.length === 1 || arguments.length === 3 ? this.transform({ skew: r, ox: e, oy: t }, !0) : this.transform({ skew: [r, e], ox: t, oy: n }, !0);
}, shear: function(r, e, t) {
  return this.transform({ shear: r, ox: e, oy: t }, !0);
}, scale: function(r, e, t, n) {
  return arguments.length === 1 || arguments.length === 3 ? this.transform({ scale: r, ox: e, oy: t }, !0) : this.transform({ scale: [r, e], ox: t, oy: n }, !0);
}, translate: function(r, e) {
  return this.transform({ translate: [r, e] }, !0);
}, relative: function(r, e) {
  return this.transform({ relative: [r, e] }, !0);
}, flip: function(r = "both", e = "center") {
  return "xybothtrue".indexOf(r) === -1 && (e = r, r = "both"), this.transform({ flip: r, origin: e }, !0);
}, opacity: function(r) {
  return this.attr("opacity", r);
} }), $e("radius", { radius: function(r, e = r) {
  return (this._element || this).type === "radialGradient" ? this.attr("r", new De(r)) : this.rx(r).ry(e);
} }), $e("Path", { length: function() {
  return this.node.getTotalLength();
}, pointAt: function(r) {
  return new nt(this.node.getPointAtLength(r));
} }), $e(["Element", "Runner"], { font: function(r, e) {
  if (typeof r == "object") {
    for (e in r) this.font(e, r[e]);
    return this;
  }
  return r === "leading" ? this.leading(e) : r === "anchor" ? this.attr("text-anchor", e) : r === "size" || r === "family" || r === "weight" || r === "stretch" || r === "variant" || r === "style" ? this.attr("font-" + r, e) : this.attr(r, e);
} });
$e("Element", ["click", "dblclick", "mousedown", "mouseup", "mouseover", "mouseout", "mousemove", "mouseenter", "mouseleave", "touchstart", "touchmove", "touchleave", "touchend", "touchcancel", "contextmenu", "wheel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel"].reduce((function(r, e) {
  return r[e] = function(t) {
    return t === null ? this.off(e) : this.on(e, t), this;
  }, r;
}), {})), $e("Element", { untransform: function() {
  return this.attr("transform", null);
}, matrixify: function() {
  return (this.attr("transform") || "").split(rL).slice(0, -1).map((function(e) {
    const t = e.trim().split("(");
    return [t[0], t[1].split(Gr).map((function(n) {
      return parseFloat(n);
    }))];
  })).reverse().reduce((function(e, t) {
    return t[0] === "matrix" ? e.lmultiply(Ee.fromArray(t[1])) : e[t[0]].apply(e, t[1]);
  }), new Ee());
}, toParent: function(r, e) {
  if (this === r) return this;
  if (sc(this.node)) return this.addTo(r, e);
  const t = this.screenCTM(), n = r.screenCTM().inverse();
  return this.addTo(r, e).untransform().transform(n.multiply(t)), this;
}, toRoot: function(r) {
  return this.toParent(this.root(), r);
}, transform: function(r, e) {
  if (r == null || typeof r == "string") {
    const n = new Ee(this).decompose();
    return r == null ? n : n[r];
  }
  Ee.isMatrixLike(r) || (r = { ...r, origin: ac(r, this) });
  const t = new Ee(e === !0 ? this : e || !1).transform(r);
  return this.attr("transform", t);
} });
class Zt extends Bt {
  flatten() {
    return this.each((function() {
      if (this instanceof Zt) return this.flatten().ungroup();
    })), this;
  }
  ungroup(e = this.parent(), t = e.index(this)) {
    return t = t === -1 ? e.children().length : t, this.each((function(n, o) {
      return o[o.length - n - 1].toParent(e, t);
    })), this.remove();
  }
}
Je(Zt, "Container");
class Ns extends Zt {
  constructor(e, t = e) {
    super(pt("defs", e), t);
  }
  flatten() {
    return this;
  }
  ungroup() {
    return this;
  }
}
Je(Ns, "Defs");
class lr extends Bt {
}
function Id(r) {
  return this.attr("rx", r);
}
function Nd(r) {
  return this.attr("ry", r);
}
function Sm(r) {
  return r == null ? this.cx() - this.rx() : this.cx(r + this.rx());
}
function Tm(r) {
  return r == null ? this.cy() - this.ry() : this.cy(r + this.ry());
}
function Am(r) {
  return this.attr("cx", r);
}
function Om(r) {
  return this.attr("cy", r);
}
function Rm(r) {
  return r == null ? 2 * this.rx() : this.rx(new De(r).divide(2));
}
function Pm(r) {
  return r == null ? 2 * this.ry() : this.ry(new De(r).divide(2));
}
Je(lr, "Shape");
var pL = Object.freeze({ __proto__: null, cx: Am, cy: Om, height: Pm, rx: Id, ry: Nd, width: Rm, x: Sm, y: Tm });
class ja extends lr {
  constructor(e, t = e) {
    super(pt("ellipse", e), t);
  }
  size(e, t) {
    const n = Mo(this, e, t);
    return this.rx(new De(n.width).divide(2)).ry(new De(n.height).divide(2));
  }
}
Le(ja, pL), $e("Container", { ellipse: dt((function(r = 0, e = r) {
  return this.put(new ja()).size(r, e).move(0, 0);
})) }), Je(ja, "Ellipse");
class Mm extends dn {
  constructor(e = Ze.document.createDocumentFragment()) {
    super(e);
  }
  xml(e, t, n) {
    if (typeof e == "boolean" && (n = t, t = e, e = null), e == null || typeof e == "function") {
      const o = new dn(Wi("wrapper", n));
      return o.add(this.node.cloneNode(!0)), o.xml(!1, n);
    }
    return super.xml(e, !1, n);
  }
}
function Em(r, e) {
  return (this._element || this).type === "radialGradient" ? this.attr({ fx: new De(r), fy: new De(e) }) : this.attr({ x1: new De(r), y1: new De(e) });
}
function Im(r, e) {
  return (this._element || this).type === "radialGradient" ? this.attr({ cx: new De(r), cy: new De(e) }) : this.attr({ x2: new De(r), y2: new De(e) });
}
Je(Mm, "Fragment");
var hL = Object.freeze({ __proto__: null, from: Em, to: Im });
class Mi extends Zt {
  constructor(e, t) {
    super(pt(e + "Gradient", typeof e == "string" ? null : e), t);
  }
  attr(e, t, n) {
    return e === "transform" && (e = "gradientTransform"), super.attr(e, t, n);
  }
  bbox() {
    return new St();
  }
  targets() {
    return Hn("svg [fill*=" + this.id() + "]");
  }
  toString() {
    return this.url();
  }
  update(e) {
    return this.clear(), typeof e == "function" && e.call(this, this), this;
  }
  url() {
    return "url(#" + this.id() + ")";
  }
}
Le(Mi, hL), $e({ Container: { gradient(...r) {
  return this.defs().gradient(...r);
} }, Defs: { gradient: dt((function(r, e) {
  return this.put(new Mi(r)).update(e);
})) } }), Je(Mi, "Gradient");
class Hi extends Zt {
  constructor(e, t = e) {
    super(pt("pattern", e), t);
  }
  attr(e, t, n) {
    return e === "transform" && (e = "patternTransform"), super.attr(e, t, n);
  }
  bbox() {
    return new St();
  }
  targets() {
    return Hn("svg [fill*=" + this.id() + "]");
  }
  toString() {
    return this.url();
  }
  update(e) {
    return this.clear(), typeof e == "function" && e.call(this, this), this;
  }
  url() {
    return "url(#" + this.id() + ")";
  }
}
$e({ Container: { pattern(...r) {
  return this.defs().pattern(...r);
} }, Defs: { pattern: dt((function(r, e, t) {
  return this.put(new Hi()).update(t).attr({ x: 0, y: 0, width: r, height: e, patternUnits: "userSpaceOnUse" });
})) } }), Je(Hi, "Pattern");
let Da = class extends lr {
  constructor(r, e = r) {
    super(pt("image", r), e);
  }
  load(r, e) {
    if (!r) return this;
    const t = new Ze.window.Image();
    return Wr(t, "load", (function(n) {
      const o = this.parent(Hi);
      this.width() === 0 && this.height() === 0 && this.size(t.width, t.height), o instanceof Hi && o.width() === 0 && o.height() === 0 && o.size(this.width(), this.height()), typeof e == "function" && e.call(this, n);
    }), this), Wr(t, "load error", (function() {
      fr(t);
    })), this.attr("href", t.src = r, Eo);
  }
};
var Eh;
Eh = function(r, e, t) {
  return r !== "fill" && r !== "stroke" || oL.test(e) && (e = t.root().defs().image(e)), e instanceof Da && (e = t.root().defs().pattern(0, 0, ((n) => {
    n.add(e);
  }))), e;
}, km.push(Eh), $e({ Container: { image: dt((function(r, e) {
  return this.put(new Da()).size(0, 0).load(r, e);
})) } }), Je(Da, "Image");
class un extends Wn {
  bbox() {
    let e = -1 / 0, t = -1 / 0, n = 1 / 0, o = 1 / 0;
    return this.forEach((function(i) {
      e = Math.max(i[0], e), t = Math.max(i[1], t), n = Math.min(i[0], n), o = Math.min(i[1], o);
    })), new St(n, o, e - n, t - o);
  }
  move(e, t) {
    const n = this.bbox();
    if (e -= n.x, t -= n.y, !isNaN(e) && !isNaN(t)) for (let o = this.length - 1; o >= 0; o--) this[o] = [this[o][0] + e, this[o][1] + t];
    return this;
  }
  parse(e = [0, 0]) {
    const t = [];
    (e = e instanceof Array ? Array.prototype.concat.apply([], e) : e.trim().split(Gr).map(parseFloat)).length % 2 != 0 && e.pop();
    for (let n = 0, o = e.length; n < o; n += 2) t.push([e[n], e[n + 1]]);
    return t;
  }
  size(e, t) {
    let n;
    const o = this.bbox();
    for (n = this.length - 1; n >= 0; n--) o.width && (this[n][0] = (this[n][0] - o.x) * e / o.width + o.x), o.height && (this[n][1] = (this[n][1] - o.y) * t / o.height + o.y);
    return this;
  }
  toLine() {
    return { x1: this[0][0], y1: this[0][1], x2: this[1][0], y2: this[1][1] };
  }
  toString() {
    const e = [];
    for (let t = 0, n = this.length; t < n; t++) e.push(this[t].join(","));
    return e.join(" ");
  }
  transform(e) {
    return this.clone().transformO(e);
  }
  transformO(e) {
    Ee.isMatrixLike(e) || (e = new Ee(e));
    for (let t = this.length; t--; ) {
      const [n, o] = this[t];
      this[t][0] = e.a * n + e.c * o + e.e, this[t][1] = e.b * n + e.d * o + e.f;
    }
    return this;
  }
}
const fL = un;
var Ld = Object.freeze({ __proto__: null, MorphArray: fL, height: function(r) {
  const e = this.bbox();
  return r == null ? e.height : this.size(e.width, r);
}, width: function(r) {
  const e = this.bbox();
  return r == null ? e.width : this.size(r, e.height);
}, x: function(r) {
  return r == null ? this.bbox().x : this.move(r, this.bbox().y);
}, y: function(r) {
  return r == null ? this.bbox().y : this.move(this.bbox().x, r);
} });
let Pn = class extends lr {
  constructor(r, e = r) {
    super(pt("line", r), e);
  }
  array() {
    return new un([[this.attr("x1"), this.attr("y1")], [this.attr("x2"), this.attr("y2")]]);
  }
  move(r, e) {
    return this.attr(this.array().move(r, e).toLine());
  }
  plot(r, e, t, n) {
    return r == null ? this.array() : (r = e !== void 0 ? { x1: r, y1: e, x2: t, y2: n } : new un(r).toLine(), this.attr(r));
  }
  size(r, e) {
    const t = Mo(this, r, e);
    return this.attr(this.array().size(t.width, t.height).toLine());
  }
};
Le(Pn, Ld), $e({ Container: { line: dt((function(...r) {
  return Pn.prototype.plot.apply(this.put(new Pn()), r[0] != null ? r : [0, 0, 0, 0]);
})) } }), Je(Pn, "Line");
let za = class extends Zt {
  constructor(r, e = r) {
    super(pt("marker", r), e);
  }
  height(r) {
    return this.attr("markerHeight", r);
  }
  orient(r) {
    return this.attr("orient", r);
  }
  ref(r, e) {
    return this.attr("refX", r).attr("refY", e);
  }
  toString() {
    return "url(#" + this.id() + ")";
  }
  update(r) {
    return this.clear(), typeof r == "function" && r.call(this, this), this;
  }
  width(r) {
    return this.attr("markerWidth", r);
  }
};
function oo(r, e) {
  return function(t) {
    return t == null ? this[r] : (this[r] = t, e && e.call(this), this);
  };
}
$e({ Container: { marker(...r) {
  return this.defs().marker(...r);
} }, Defs: { marker: dt((function(r, e, t) {
  return this.put(new za()).size(r, e).ref(r / 2, e / 2).viewbox(0, 0, r, e).attr("orient", "auto").update(t);
})) }, marker: { marker(r, e, t, n) {
  let o = ["marker"];
  return r !== "all" && o.push(r), o = o.join("-"), r = arguments[1] instanceof za ? arguments[1] : this.defs().marker(e, t, n), this.attr(o, r);
} } }), Je(za, "Marker");
const gL = { "-": function(r) {
  return r;
}, "<>": function(r) {
  return -Math.cos(r * Math.PI) / 2 + 0.5;
}, ">": function(r) {
  return Math.sin(r * Math.PI / 2);
}, "<": function(r) {
  return 1 - Math.cos(r * Math.PI / 2);
}, bezier: function(r, e, t, n) {
  return function(o) {
    return o < 0 ? r > 0 ? e / r * o : t > 0 ? n / t * o : 0 : o > 1 ? t < 1 ? (1 - n) / (1 - t) * o + (n - t) / (1 - t) : r < 1 ? (1 - e) / (1 - r) * o + (e - r) / (1 - r) : 1 : 3 * o * (1 - o) ** 2 * e + 3 * o ** 2 * (1 - o) * n + o ** 3;
  };
}, steps: function(r, e = "end") {
  e = e.split("-").reverse()[0];
  let t = r;
  return e === "none" ? --t : e === "both" && ++t, (n, o = !1) => {
    let i = Math.floor(n * r);
    const a = n * i % 1 == 0;
    return e !== "start" && e !== "both" || ++i, o && a && --i, n >= 0 && i < 0 && (i = 0), n <= 1 && i > t && (i = t), i / t;
  };
} };
class jd {
  done() {
    return !1;
  }
}
class lc extends jd {
  constructor(e = lL) {
    super(), this.ease = gL[e] || e;
  }
  step(e, t, n) {
    return typeof e != "number" ? n < 1 ? e : t : e + (t - e) * this.ease(n);
  }
}
class ss extends jd {
  constructor(e) {
    super(), this.stepper = e;
  }
  done(e) {
    return e.done;
  }
  step(e, t, n, o) {
    return this.stepper(e, t, n, o);
  }
}
function Ih() {
  const r = (this._duration || 500) / 1e3, e = this._overshoot || 0, t = Math.PI, n = Math.log(e / 100 + 1e-10), o = -n / Math.sqrt(t * t + n * n), i = 3.9 / (o * r);
  this.d = 2 * o * i, this.k = i * i;
}
Le(class extends ss {
  constructor(r = 500, e = 0) {
    super(), this.duration(r).overshoot(e);
  }
  step(r, e, t, n) {
    if (typeof r == "string") return r;
    if (n.done = t === 1 / 0, t === 1 / 0) return e;
    if (t === 0) return r;
    t > 100 && (t = 16), t /= 1e3;
    const o = n.velocity || 0, i = -this.d * o - this.k * (r - e), a = r + o * t + i * t * t / 2;
    return n.velocity = o + i * t, n.done = Math.abs(e - a) + Math.abs(o) < 2e-3, n.done ? e : a;
  }
}, { duration: oo("_duration", Ih), overshoot: oo("_overshoot", Ih) });
Le(class extends ss {
  constructor(r = 0.1, e = 0.01, t = 0, n = 1e3) {
    super(), this.p(r).i(e).d(t).windup(n);
  }
  step(r, e, t, n) {
    if (typeof r == "string") return r;
    if (n.done = t === 1 / 0, t === 1 / 0) return e;
    if (t === 0) return r;
    const o = e - r;
    let i = (n.integral || 0) + o * t;
    const a = (o - (n.error || 0)) / t, s = this._windup;
    return s !== !1 && (i = Math.max(-s, Math.min(i, s))), n.error = o, n.integral = i, n.done = Math.abs(o) < 1e-3, n.done ? e : r + (this.P * o + this.I * i + this.D * a);
  }
}, { windup: oo("_windup"), p: oo("P"), i: oo("I"), d: oo("D") });
const mL = { M: 2, L: 2, H: 1, V: 1, C: 6, S: 4, Q: 4, T: 2, A: 7, Z: 0 }, cc = { M: function(r, e, t) {
  return e.x = t.x = r[0], e.y = t.y = r[1], ["M", e.x, e.y];
}, L: function(r, e) {
  return e.x = r[0], e.y = r[1], ["L", r[0], r[1]];
}, H: function(r, e) {
  return e.x = r[0], ["H", r[0]];
}, V: function(r, e) {
  return e.y = r[0], ["V", r[0]];
}, C: function(r, e) {
  return e.x = r[4], e.y = r[5], ["C", r[0], r[1], r[2], r[3], r[4], r[5]];
}, S: function(r, e) {
  return e.x = r[2], e.y = r[3], ["S", r[0], r[1], r[2], r[3]];
}, Q: function(r, e) {
  return e.x = r[2], e.y = r[3], ["Q", r[0], r[1], r[2], r[3]];
}, T: function(r, e) {
  return e.x = r[0], e.y = r[1], ["T", r[0], r[1]];
}, Z: function(r, e, t) {
  return e.x = t.x, e.y = t.y, ["Z"];
}, A: function(r, e) {
  return e.x = r[5], e.y = r[6], ["A", r[0], r[1], r[2], r[3], r[4], r[5], r[6]];
} }, ml = "mlhvqtcsaz".split("");
for (let r = 0, e = ml.length; r < e; ++r) cc[ml[r]] = /* @__PURE__ */ (function(t) {
  return function(n, o, i) {
    if (t === "H") n[0] = n[0] + o.x;
    else if (t === "V") n[0] = n[0] + o.y;
    else if (t === "A") n[5] = n[5] + o.x, n[6] = n[6] + o.y;
    else for (let a = 0, s = n.length; a < s; ++a) n[a] = n[a] + (a % 2 ? o.y : o.x);
    return cc[t](n, o, i);
  };
})(ml[r].toUpperCase());
function dc(r) {
  return r.segment.length && r.segment.length - 1 === mL[r.segment[0].toUpperCase()];
}
function bL(r, e) {
  r.inNumber && Cn(r, !1);
  const t = Md.test(e);
  if (t) r.segment = [e];
  else {
    const n = r.lastCommand, o = n.toLowerCase(), i = n === o;
    r.segment = [o === "m" ? i ? "l" : "L" : n];
  }
  return r.inSegment = !0, r.lastCommand = r.segment[0], t;
}
function Cn(r, e) {
  if (!r.inNumber) throw new Error("Parser Error");
  r.number && r.segment.push(parseFloat(r.number)), r.inNumber = e, r.number = "", r.pointSeen = !1, r.hasExponent = !1, dc(r) && uc(r);
}
function uc(r) {
  r.inSegment = !1, r.absolute && (r.segment = (function(e) {
    const t = e.segment[0];
    return cc[t](e.segment.slice(1), e.p, e.p0);
  })(r)), r.segments.push(r.segment);
}
function xL(r) {
  if (!r.segment.length) return !1;
  const e = r.segment[0].toUpperCase() === "A", t = r.segment.length;
  return e && (t === 4 || t === 5);
}
function vL(r) {
  return r.lastToken.toUpperCase() === "E";
}
const yL = /* @__PURE__ */ new Set([" ", ",", "	", `
`, "\r", "\f"]);
class Ar extends Wn {
  bbox() {
    return nn().path.setAttribute("d", this.toString()), new St(nn.nodes.path.getBBox());
  }
  move(e, t) {
    const n = this.bbox();
    if (e -= n.x, t -= n.y, !isNaN(e) && !isNaN(t)) for (let o, i = this.length - 1; i >= 0; i--) o = this[i][0], o === "M" || o === "L" || o === "T" ? (this[i][1] += e, this[i][2] += t) : o === "H" ? this[i][1] += e : o === "V" ? this[i][1] += t : o === "C" || o === "S" || o === "Q" ? (this[i][1] += e, this[i][2] += t, this[i][3] += e, this[i][4] += t, o === "C" && (this[i][5] += e, this[i][6] += t)) : o === "A" && (this[i][6] += e, this[i][7] += t);
    return this;
  }
  parse(e = "M0 0") {
    return Array.isArray(e) && (e = Array.prototype.concat.apply([], e).toString()), (function(t, n = !0) {
      let o = 0, i = "";
      const a = { segment: [], inNumber: !1, number: "", lastToken: "", inSegment: !1, segments: [], pointSeen: !1, hasExponent: !1, absolute: n, p0: new nt(), p: new nt() };
      for (; a.lastToken = i, i = t.charAt(o++); ) if (a.inSegment || !bL(a, i)) if (i !== ".") if (isNaN(parseInt(i))) if (yL.has(i)) a.inNumber && Cn(a, !1);
      else if (i !== "-" && i !== "+") if (i.toUpperCase() !== "E") {
        if (Md.test(i)) {
          if (a.inNumber) Cn(a, !1);
          else {
            if (!dc(a)) throw new Error("parser Error");
            uc(a);
          }
          --o;
        }
      } else a.number += i, a.hasExponent = !0;
      else {
        if (a.inNumber && !vL(a)) {
          Cn(a, !1), --o;
          continue;
        }
        a.number += i, a.inNumber = !0;
      }
      else {
        if (a.number === "0" || xL(a)) {
          a.inNumber = !0, a.number = i, Cn(a, !0);
          continue;
        }
        a.inNumber = !0, a.number += i;
      }
      else {
        if (a.pointSeen || a.hasExponent) {
          Cn(a, !1), --o;
          continue;
        }
        a.inNumber = !0, a.pointSeen = !0, a.number += i;
      }
      return a.inNumber && Cn(a, !1), a.inSegment && dc(a) && uc(a), a.segments;
    })(e);
  }
  size(e, t) {
    const n = this.bbox();
    let o, i;
    for (n.width = n.width === 0 ? 1 : n.width, n.height = n.height === 0 ? 1 : n.height, o = this.length - 1; o >= 0; o--) i = this[o][0], i === "M" || i === "L" || i === "T" ? (this[o][1] = (this[o][1] - n.x) * e / n.width + n.x, this[o][2] = (this[o][2] - n.y) * t / n.height + n.y) : i === "H" ? this[o][1] = (this[o][1] - n.x) * e / n.width + n.x : i === "V" ? this[o][1] = (this[o][1] - n.y) * t / n.height + n.y : i === "C" || i === "S" || i === "Q" ? (this[o][1] = (this[o][1] - n.x) * e / n.width + n.x, this[o][2] = (this[o][2] - n.y) * t / n.height + n.y, this[o][3] = (this[o][3] - n.x) * e / n.width + n.x, this[o][4] = (this[o][4] - n.y) * t / n.height + n.y, i === "C" && (this[o][5] = (this[o][5] - n.x) * e / n.width + n.x, this[o][6] = (this[o][6] - n.y) * t / n.height + n.y)) : i === "A" && (this[o][1] = this[o][1] * e / n.width, this[o][2] = this[o][2] * t / n.height, this[o][6] = (this[o][6] - n.x) * e / n.width + n.x, this[o][7] = (this[o][7] - n.y) * t / n.height + n.y);
    return this;
  }
  toString() {
    return (function(e) {
      let t = "";
      for (let n = 0, o = e.length; n < o; n++) t += e[n][0], e[n][1] != null && (t += e[n][1], e[n][2] != null && (t += " ", t += e[n][2], e[n][3] != null && (t += " ", t += e[n][3], t += " ", t += e[n][4], e[n][5] != null && (t += " ", t += e[n][5], t += " ", t += e[n][6], e[n][7] != null && (t += " ", t += e[n][7])))));
      return t + " ";
    })(this);
  }
}
const Nm = (r) => {
  const e = typeof r;
  return e === "number" ? De : e === "string" ? lt.isColor(r) ? lt : Gr.test(r) ? Md.test(r) ? Ar : Wn : vm.test(r) ? De : pc : hc.indexOf(r.constructor) > -1 ? r.constructor : Array.isArray(r) ? Wn : e === "object" ? Yi : pc;
};
class kn {
  constructor(e) {
    this._stepper = e || new lc("-"), this._from = null, this._to = null, this._type = null, this._context = null, this._morphObj = null;
  }
  at(e) {
    return this._morphObj.morph(this._from, this._to, e, this._stepper, this._context);
  }
  done() {
    return this._context.map(this._stepper.done).reduce((function(e, t) {
      return e && t;
    }), !0);
  }
  from(e) {
    return e == null ? this._from : (this._from = this._set(e), this);
  }
  stepper(e) {
    return e == null ? this._stepper : (this._stepper = e, this);
  }
  to(e) {
    return e == null ? this._to : (this._to = this._set(e), this);
  }
  type(e) {
    return e == null ? this._type : (this._type = e, this);
  }
  _set(e) {
    this._type || this.type(Nm(e));
    let t = new this._type(e);
    return this._type === lt && (t = this._to ? t[this._to[4]]() : this._from ? t[this._from[4]]() : t), this._type === Yi && (t = this._to ? t.align(this._to) : this._from ? t.align(this._from) : t), t = t.toConsumable(), this._morphObj = this._morphObj || new this._type(), this._context = this._context || Array.apply(null, Array(t.length)).map(Object).map((function(n) {
      return n.done = !0, n;
    })), t;
  }
}
class pc {
  constructor(...e) {
    this.init(...e);
  }
  init(e) {
    return e = Array.isArray(e) ? e[0] : e, this.value = e, this;
  }
  toArray() {
    return [this.value];
  }
  valueOf() {
    return this.value;
  }
}
class sa {
  constructor(...e) {
    this.init(...e);
  }
  init(e) {
    return Array.isArray(e) && (e = { scaleX: e[0], scaleY: e[1], shear: e[2], rotate: e[3], translateX: e[4], translateY: e[5], originX: e[6], originY: e[7] }), Object.assign(this, sa.defaults, e), this;
  }
  toArray() {
    const e = this;
    return [e.scaleX, e.scaleY, e.shear, e.rotate, e.translateX, e.translateY, e.originX, e.originY];
  }
}
sa.defaults = { scaleX: 1, scaleY: 1, shear: 0, rotate: 0, translateX: 0, translateY: 0, originX: 0, originY: 0 };
const wL = (r, e) => r[0] < e[0] ? -1 : r[0] > e[0] ? 1 : 0;
class Yi {
  constructor(...e) {
    this.init(...e);
  }
  align(e) {
    const t = this.values;
    for (let n = 0, o = t.length; n < o; ++n) {
      if (t[n + 1] === e[n + 1]) {
        if (t[n + 1] === lt && e[n + 7] !== t[n + 7]) {
          const s = e[n + 7], c = new lt(this.values.splice(n + 3, 5))[s]().toArray();
          this.values.splice(n + 3, 0, ...c);
        }
        n += t[n + 2] + 2;
        continue;
      }
      if (!e[n + 1]) return this;
      const i = new e[n + 1]().toArray(), a = t[n + 2] + 3;
      t.splice(n, a, e[n], e[n + 1], e[n + 2], ...i), n += t[n + 2] + 2;
    }
    return this;
  }
  init(e) {
    if (this.values = [], Array.isArray(e)) return void (this.values = e.slice());
    e = e || {};
    const t = [];
    for (const n in e) {
      const o = Nm(e[n]), i = new o(e[n]).toArray();
      t.push([n, o, i.length, ...i]);
    }
    return t.sort(wL), this.values = t.reduce(((n, o) => n.concat(o)), []), this;
  }
  toArray() {
    return this.values;
  }
  valueOf() {
    const e = {}, t = this.values;
    for (; t.length; ) {
      const n = t.shift(), o = t.shift(), i = t.shift(), a = t.splice(0, i);
      e[n] = new o(a);
    }
    return e;
  }
}
const hc = [pc, sa, Yi];
class lo extends lr {
  constructor(e, t = e) {
    super(pt("path", e), t);
  }
  array() {
    return this._array || (this._array = new Ar(this.attr("d")));
  }
  clear() {
    return delete this._array, this;
  }
  height(e) {
    return e == null ? this.bbox().height : this.size(this.bbox().width, e);
  }
  move(e, t) {
    return this.attr("d", this.array().move(e, t));
  }
  plot(e) {
    return e == null ? this.array() : this.clear().attr("d", typeof e == "string" ? e : this._array = new Ar(e));
  }
  size(e, t) {
    const n = Mo(this, e, t);
    return this.attr("d", this.array().size(n.width, n.height));
  }
  width(e) {
    return e == null ? this.bbox().width : this.size(e, this.bbox().height);
  }
  x(e) {
    return e == null ? this.bbox().x : this.move(e, this.bbox().y);
  }
  y(e) {
    return e == null ? this.bbox().y : this.move(this.bbox().x, e);
  }
}
lo.prototype.MorphArray = Ar, $e({ Container: { path: dt((function(r) {
  return this.put(new lo()).plot(r || new Ar());
})) } }), Je(lo, "Path");
var Lm = Object.freeze({ __proto__: null, array: function() {
  return this._array || (this._array = new un(this.attr("points")));
}, clear: function() {
  return delete this._array, this;
}, move: function(r, e) {
  return this.attr("points", this.array().move(r, e));
}, plot: function(r) {
  return r == null ? this.array() : this.clear().attr("points", typeof r == "string" ? r : this._array = new un(r));
}, size: function(r, e) {
  const t = Mo(this, r, e);
  return this.attr("points", this.array().size(t.width, t.height));
} });
class Mn extends lr {
  constructor(e, t = e) {
    super(pt("polygon", e), t);
  }
}
$e({ Container: { polygon: dt((function(r) {
  return this.put(new Mn()).plot(r || new un());
})) } }), Le(Mn, Ld), Le(Mn, Lm), Je(Mn, "Polygon");
class En extends lr {
  constructor(e, t = e) {
    super(pt("polyline", e), t);
  }
}
$e({ Container: { polyline: dt((function(r) {
  return this.put(new En()).plot(r || new un());
})) } }), Le(En, Ld), Le(En, Lm), Je(En, "Polyline");
class Ba extends lr {
  constructor(e, t = e) {
    super(pt("rect", e), t);
  }
}
Le(Ba, { rx: Id, ry: Nd }), $e({ Container: { rect: dt((function(r, e) {
  return this.put(new Ba()).size(r, e);
})) } }), Je(Ba, "Rect");
class bl {
  constructor() {
    this._first = null, this._last = null;
  }
  first() {
    return this._first && this._first.value;
  }
  last() {
    return this._last && this._last.value;
  }
  push(e) {
    const t = e.next !== void 0 ? e : { value: e, next: null, prev: null };
    return this._last ? (t.prev = this._last, this._last.next = t, this._last = t) : (this._last = t, this._first = t), t;
  }
  remove(e) {
    e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e === this._last && (this._last = e.prev), e === this._first && (this._first = e.next), e.prev = null, e.next = null;
  }
  shift() {
    const e = this._first;
    return e ? (this._first = e.next, this._first && (this._first.prev = null), this._last = this._first ? this._last : null, e.value) : null;
  }
}
const ot = { nextDraw: null, frames: new bl(), timeouts: new bl(), immediates: new bl(), timer: () => Ze.window.performance || Ze.window.Date, transforms: [], frame(r) {
  const e = ot.frames.push({ run: r });
  return ot.nextDraw === null && (ot.nextDraw = Ze.window.requestAnimationFrame(ot._draw)), e;
}, timeout(r, e) {
  e = e || 0;
  const t = ot.timer().now() + e, n = ot.timeouts.push({ run: r, time: t });
  return ot.nextDraw === null && (ot.nextDraw = Ze.window.requestAnimationFrame(ot._draw)), n;
}, immediate(r) {
  const e = ot.immediates.push(r);
  return ot.nextDraw === null && (ot.nextDraw = Ze.window.requestAnimationFrame(ot._draw)), e;
}, cancelFrame(r) {
  r != null && ot.frames.remove(r);
}, clearTimeout(r) {
  r != null && ot.timeouts.remove(r);
}, cancelImmediate(r) {
  r != null && ot.immediates.remove(r);
}, _draw(r) {
  let e = null;
  const t = ot.timeouts.last();
  for (; (e = ot.timeouts.shift()) && (r >= e.time ? e.run() : ot.timeouts.push(e), e !== t); ) ;
  let n = null;
  const o = ot.frames.last();
  for (; n !== o && (n = ot.frames.shift()); ) n.run(r);
  let i = null;
  for (; i = ot.immediates.shift(); ) i();
  ot.nextDraw = ot.timeouts.first() || ot.frames.first() ? Ze.window.requestAnimationFrame(ot._draw) : null;
} }, CL = function(r) {
  const e = r.start, t = r.runner.duration();
  return { start: e, duration: t, end: e + t, runner: r.runner };
}, kL = function() {
  const r = Ze.window;
  return (r.performance || r.Date).now();
};
class jm extends aa {
  constructor(e = kL) {
    super(), this._timeSource = e, this.terminate();
  }
  active() {
    return !!this._nextFrame;
  }
  finish() {
    return this.time(this.getEndTimeOfTimeline() + 1), this.pause();
  }
  getEndTime() {
    const e = this.getLastRunnerInfo(), t = e ? e.runner.duration() : 0;
    return (e ? e.start : this._time) + t;
  }
  getEndTimeOfTimeline() {
    const e = this._runners.map(((t) => t.start + t.runner.duration()));
    return Math.max(0, ...e);
  }
  getLastRunnerInfo() {
    return this.getRunnerInfoById(this._lastRunnerId);
  }
  getRunnerInfoById(e) {
    return this._runners[this._runnerIds.indexOf(e)] || null;
  }
  pause() {
    return this._paused = !0, this._continue();
  }
  persist(e) {
    return e == null ? this._persist : (this._persist = e, this);
  }
  play() {
    return this._paused = !1, this.updateTime()._continue();
  }
  reverse(e) {
    const t = this.speed();
    if (e == null) return this.speed(-t);
    const n = Math.abs(t);
    return this.speed(e ? -n : n);
  }
  schedule(e, t, n) {
    if (e == null) return this._runners.map(CL);
    let o = 0;
    const i = this.getEndTime();
    if (t = t || 0, n == null || n === "last" || n === "after") o = i;
    else if (n === "absolute" || n === "start") o = t, t = 0;
    else if (n === "now") o = this._time;
    else if (n === "relative") {
      const c = this.getRunnerInfoById(e.id);
      c && (o = c.start + t, t = 0);
    } else {
      if (n !== "with-last") throw new Error('Invalid value for the "when" parameter');
      {
        const c = this.getLastRunnerInfo();
        o = c ? c.start : this._time;
      }
    }
    e.unschedule(), e.timeline(this);
    const a = e.persist(), s = { persist: a === null ? this._persist : a, start: o + t, runner: e };
    return this._lastRunnerId = e.id, this._runners.push(s), this._runners.sort(((c, d) => c.start - d.start)), this._runnerIds = this._runners.map(((c) => c.runner.id)), this.updateTime()._continue(), this;
  }
  seek(e) {
    return this.time(this._time + e);
  }
  source(e) {
    return e == null ? this._timeSource : (this._timeSource = e, this);
  }
  speed(e) {
    return e == null ? this._speed : (this._speed = e, this);
  }
  stop() {
    return this.time(0), this.pause();
  }
  time(e) {
    return e == null ? this._time : (this._time = e, this._continue(!0));
  }
  unschedule(e) {
    const t = this._runnerIds.indexOf(e.id);
    return t < 0 || (this._runners.splice(t, 1), this._runnerIds.splice(t, 1), e.timeline(null)), this;
  }
  updateTime() {
    return this.active() || (this._lastSourceTime = this._timeSource()), this;
  }
  _continue(e = !1) {
    return ot.cancelFrame(this._nextFrame), this._nextFrame = null, e ? this._stepImmediate() : (this._paused || (this._nextFrame = ot.frame(this._step)), this);
  }
  _stepFn(e = !1) {
    const t = this._timeSource();
    let n = t - this._lastSourceTime;
    e && (n = 0);
    const o = this._speed * n + (this._time - this._lastStepTime);
    this._lastSourceTime = t, e || (this._time += o, this._time = this._time < 0 ? 0 : this._time), this._lastStepTime = this._time, this.fire("time", this._time);
    for (let a = this._runners.length; a--; ) {
      const s = this._runners[a], c = s.runner;
      this._time - s.start <= 0 && c.reset();
    }
    let i = !1;
    for (let a = 0, s = this._runners.length; a < s; a++) {
      const c = this._runners[a], d = c.runner;
      let u = o;
      const p = this._time - c.start;
      if (p <= 0) {
        i = !0;
        continue;
      }
      p < u && (u = p), d.active() && (d.step(u).done ? c.persist !== !0 && d.duration() - d.time() + this._time + c.persist < this._time && (d.unschedule(), --a, --s) : i = !0);
    }
    return i && !(this._speed < 0 && this._time === 0) || this._runnerIds.length && this._speed < 0 && this._time > 0 ? this._continue() : (this.pause(), this.fire("finished")), this;
  }
  terminate() {
    this._startTime = 0, this._speed = 1, this._persist = 0, this._nextFrame = null, this._paused = !0, this._runners = [], this._runnerIds = [], this._lastRunnerId = -1, this._time = 0, this._lastSourceTime = 0, this._lastStepTime = 0, this._step = this._stepFn.bind(this, !1), this._stepImmediate = this._stepFn.bind(this, !0);
  }
}
$e({ Element: { timeline: function(r) {
  return r == null ? (this._timeline = this._timeline || new jm(), this._timeline) : (this._timeline = r, this);
} } });
class ar extends aa {
  constructor(e) {
    super(), this.id = ar.id++, e = typeof (e = e ?? gl) == "function" ? new ss(e) : e, this._element = null, this._timeline = null, this.done = !1, this._queue = [], this._duration = typeof e == "number" && e, this._isDeclarative = e instanceof ss, this._stepper = this._isDeclarative ? e : new lc(), this._history = {}, this.enabled = !0, this._time = 0, this._lastTime = 0, this._reseted = !0, this.transforms = new Ee(), this.transformId = 1, this._haveReversed = !1, this._reverse = !1, this._loopsDone = 0, this._swing = !1, this._wait = 0, this._times = 1, this._frameId = null, this._persist = !!this._isDeclarative || null;
  }
  static sanitise(e, t, n) {
    let o = 1, i = !1, a = 0;
    return t = t ?? cL, n = n || "last", typeof (e = e ?? gl) != "object" || e instanceof jd || (t = e.delay ?? t, n = e.when ?? n, i = e.swing || i, o = e.times ?? o, a = e.wait ?? a, e = e.duration ?? gl), { duration: e, delay: t, swing: i, times: o, wait: a, when: n };
  }
  active(e) {
    return e == null ? this.enabled : (this.enabled = e, this);
  }
  addTransform(e) {
    return this.transforms.lmultiplyO(e), this;
  }
  after(e) {
    return this.on("finished", e);
  }
  animate(e, t, n) {
    const o = ar.sanitise(e, t, n), i = new ar(o.duration);
    return this._timeline && i.timeline(this._timeline), this._element && i.element(this._element), i.loop(o).schedule(o.delay, o.when);
  }
  clearTransform() {
    return this.transforms = new Ee(), this;
  }
  clearTransformsFromQueue() {
    this.done && this._timeline && this._timeline._runnerIds.includes(this.id) || (this._queue = this._queue.filter(((e) => !e.isTransform)));
  }
  delay(e) {
    return this.animate(0, e);
  }
  duration() {
    return this._times * (this._wait + this._duration) - this._wait;
  }
  during(e) {
    return this.queue(null, e);
  }
  ease(e) {
    return this._stepper = new lc(e), this;
  }
  element(e) {
    return e == null ? this._element : (this._element = e, e._prepareRunner(), this);
  }
  finish() {
    return this.step(1 / 0);
  }
  loop(e, t, n) {
    return typeof e == "object" && (t = e.swing, n = e.wait, e = e.times), this._times = e || 1 / 0, this._swing = t || !1, this._wait = n || 0, this._times === !0 && (this._times = 1 / 0), this;
  }
  loops(e) {
    const t = this._duration + this._wait;
    if (e == null) {
      const i = Math.floor(this._time / t), a = (this._time - i * t) / this._duration;
      return Math.min(i + a, this._times);
    }
    const n = e % 1, o = t * Math.floor(e) + this._duration * n;
    return this.time(o);
  }
  persist(e) {
    return e == null ? this._persist : (this._persist = e, this);
  }
  position(e) {
    const t = this._time, n = this._duration, o = this._wait, i = this._times, a = this._swing, s = this._reverse;
    let c;
    if (e == null) {
      const p = function(f) {
        const m = a * Math.floor(f % (2 * (o + n)) / (o + n)), g = m && !s || !m && s, b = Math.pow(-1, g) * (f % (o + n)) / n + g;
        return Math.max(Math.min(b, 1), 0);
      }, h = i * (o + n) - o;
      return c = t <= 0 ? Math.round(p(1e-5)) : t < h ? p(t) : Math.round(p(h - 1e-5)), c;
    }
    const d = Math.floor(this.loops()), u = a && d % 2 == 0;
    return c = d + (u && !s || s && u ? e : 1 - e), this.loops(c);
  }
  progress(e) {
    return e == null ? Math.min(1, this._time / this.duration()) : this.time(e * this.duration());
  }
  queue(e, t, n, o) {
    return this._queue.push({ initialiser: e || Mh, runner: t || Mh, retarget: n, isTransform: o, initialised: !1, finished: !1 }), this.timeline() && this.timeline()._continue(), this;
  }
  reset() {
    return this._reseted || (this.time(0), this._reseted = !0), this;
  }
  reverse(e) {
    return this._reverse = e ?? !this._reverse, this;
  }
  schedule(e, t, n) {
    if (e instanceof jm || (n = t, t = e, e = this.timeline()), !e) throw Error("Runner cannot be scheduled without timeline");
    return e.schedule(this, t, n), this;
  }
  step(e) {
    if (!this.enabled) return this;
    e = e ?? 16, this._time += e;
    const t = this.position(), n = this._lastPosition !== t && this._time >= 0;
    this._lastPosition = t;
    const o = this.duration(), i = this._lastTime <= 0 && this._time > 0, a = this._lastTime < o && this._time >= o;
    this._lastTime = this._time, i && this.fire("start", this);
    const s = this._isDeclarative;
    this.done = !s && !a && this._time >= o, this._reseted = !1;
    let c = !1;
    return (n || s) && (this._initialise(n), this.transforms = new Ee(), c = this._run(s ? e : t), this.fire("step", this)), this.done = this.done || c && s, a && this.fire("finished", this), this;
  }
  time(e) {
    if (e == null) return this._time;
    const t = e - this._time;
    return this.step(t), this;
  }
  timeline(e) {
    return e === void 0 ? this._timeline : (this._timeline = e, this);
  }
  unschedule() {
    const e = this.timeline();
    return e && e.unschedule(this), this;
  }
  _initialise(e) {
    if (e || this._isDeclarative) for (let t = 0, n = this._queue.length; t < n; ++t) {
      const o = this._queue[t], i = this._isDeclarative || !o.initialised && e;
      e = !o.finished, i && e && (o.initialiser.call(this), o.initialised = !0);
    }
  }
  _rememberMorpher(e, t) {
    if (this._history[e] = { morpher: t, caller: this._queue[this._queue.length - 1] }, this._isDeclarative) {
      const n = this.timeline();
      n && n.play();
    }
  }
  _run(e) {
    let t = !0;
    for (let n = 0, o = this._queue.length; n < o; ++n) {
      const i = this._queue[n], a = i.runner.call(this, e);
      i.finished = i.finished || a === !0, t = t && i.finished;
    }
    return t;
  }
  _tryRetarget(e, t, n) {
    if (this._history[e]) {
      if (!this._history[e].caller.initialised) {
        const i = this._queue.indexOf(this._history[e].caller);
        return this._queue.splice(i, 1), !1;
      }
      this._history[e].caller.retarget ? this._history[e].caller.retarget.call(this, t, n) : this._history[e].morpher.to(t), this._history[e].caller.finished = !1;
      const o = this.timeline();
      return o && o.play(), !0;
    }
    return !1;
  }
}
ar.id = 0;
class ls {
  constructor(e = new Ee(), t = -1, n = !0) {
    this.transforms = e, this.id = t, this.done = n;
  }
  clearTransformsFromQueue() {
  }
}
Le([ar, ls], { mergeWith(r) {
  return new ls(r.transforms.lmultiply(this.transforms), r.id);
} });
const Dm = (r, e) => r.lmultiplyO(e), zm = (r) => r.transforms;
function SL() {
  const r = this._transformationRunners.runners.map(zm).reduce(Dm, new Ee());
  this.transform(r), this._transformationRunners.merge(), this._transformationRunners.length() === 1 && (this._frameId = null);
}
class TL {
  constructor() {
    this.runners = [], this.ids = [];
  }
  add(e) {
    if (this.runners.includes(e)) return;
    const t = e.id + 1;
    return this.runners.push(e), this.ids.push(t), this;
  }
  clearBefore(e) {
    const t = this.ids.indexOf(e + 1) || 1;
    return this.ids.splice(0, t, 0), this.runners.splice(0, t, new ls()).forEach(((n) => n.clearTransformsFromQueue())), this;
  }
  edit(e, t) {
    const n = this.ids.indexOf(e + 1);
    return this.ids.splice(n, 1, e + 1), this.runners.splice(n, 1, t), this;
  }
  getByID(e) {
    return this.runners[this.ids.indexOf(e + 1)];
  }
  length() {
    return this.ids.length;
  }
  merge() {
    let e = null;
    for (let t = 0; t < this.runners.length; ++t) {
      const n = this.runners[t];
      if (e && n.done && e.done && (!n._timeline || !n._timeline._runnerIds.includes(n.id)) && (!e._timeline || !e._timeline._runnerIds.includes(e.id))) {
        this.remove(n.id);
        const o = n.mergeWith(e);
        this.edit(e.id, o), e = o, --t;
      } else e = n;
    }
    return this;
  }
  remove(e) {
    const t = this.ids.indexOf(e + 1);
    return this.ids.splice(t, 1), this.runners.splice(t, 1), this;
  }
}
$e({ Element: { animate(r, e, t) {
  const n = ar.sanitise(r, e, t), o = this.timeline();
  return new ar(n.duration).loop(n).element(this).timeline(o.play()).schedule(n.delay, n.when);
}, delay(r, e) {
  return this.animate(0, r, e);
}, _clearTransformRunnersBefore(r) {
  this._transformationRunners.clearBefore(r.id);
}, _currentTransform(r) {
  return this._transformationRunners.runners.filter(((e) => e.id <= r.id)).map(zm).reduce(Dm, new Ee());
}, _addRunner(r) {
  this._transformationRunners.add(r), ot.cancelImmediate(this._frameId), this._frameId = ot.immediate(SL.bind(this));
}, _prepareRunner() {
  this._frameId == null && (this._transformationRunners = new TL().add(new ls(new Ee(this))));
} } });
Le(ar, { attr(r, e) {
  return this.styleAttr("attr", r, e);
}, css(r, e) {
  return this.styleAttr("css", r, e);
}, styleAttr(r, e, t) {
  if (typeof e == "string") return this.styleAttr(r, { [e]: t });
  let n = e;
  if (this._tryRetarget(r, n)) return this;
  let o = new kn(this._stepper).to(n), i = Object.keys(n);
  return this.queue((function() {
    o = o.from(this.element()[r](i));
  }), (function(a) {
    return this.element()[r](o.at(a).valueOf()), o.done();
  }), (function(a) {
    const s = Object.keys(a), c = (d = i, s.filter(((p) => !d.includes(p))));
    var d;
    if (c.length) {
      const p = this.element()[r](c), h = new Yi(o.from()).valueOf();
      Object.assign(h, p), o.from(h);
    }
    const u = new Yi(o.to()).valueOf();
    Object.assign(u, a), o.to(u), i = s, n = a;
  })), this._rememberMorpher(r, o), this;
}, zoom(r, e) {
  if (this._tryRetarget("zoom", r, e)) return this;
  let t = new kn(this._stepper).to(new De(r));
  return this.queue((function() {
    t = t.from(this.element().zoom());
  }), (function(n) {
    return this.element().zoom(t.at(n), e), t.done();
  }), (function(n, o) {
    e = o, t.to(n);
  })), this._rememberMorpher("zoom", t), this;
}, transform(r, e, t) {
  if (e = r.relative || e, this._isDeclarative && !e && this._tryRetarget("transform", r)) return this;
  const n = Ee.isMatrixLike(r);
  t = r.affine != null ? r.affine : t ?? !n;
  const o = new kn(this._stepper).type(t ? sa : Ee);
  let i, a, s, c, d;
  return this.queue((function() {
    a = a || this.element(), i = i || ac(r, a), d = new Ee(e ? void 0 : a), a._addRunner(this), e || a._clearTransformRunnersBefore(this);
  }), (function(u) {
    e || this.clearTransform();
    const { x: p, y: h } = new nt(i).transform(a._currentTransform(this));
    let f = new Ee({ ...r, origin: [p, h] }), m = this._isDeclarative && s ? s : d;
    if (t) {
      f = f.decompose(p, h), m = m.decompose(p, h);
      const b = f.rotate, x = m.rotate, v = [b - 360, b, b + 360], y = v.map(((T) => Math.abs(T - x))), C = Math.min(...y), k = y.indexOf(C);
      f.rotate = v[k];
    }
    e && (n || (f.rotate = r.rotate || 0), this._isDeclarative && c && (m.rotate = c)), o.from(m), o.to(f);
    const g = o.at(u);
    return c = g.rotate, s = new Ee(g), this.addTransform(s), a._addRunner(this), o.done();
  }), (function(u) {
    (u.origin || "center").toString() !== (r.origin || "center").toString() && (i = ac(u, a)), r = { ...u, origin: i };
  }), !0), this._isDeclarative && this._rememberMorpher("transform", o), this;
}, x(r) {
  return this._queueNumber("x", r);
}, y(r) {
  return this._queueNumber("y", r);
}, ax(r) {
  return this._queueNumber("ax", r);
}, ay(r) {
  return this._queueNumber("ay", r);
}, dx(r = 0) {
  return this._queueNumberDelta("x", r);
}, dy(r = 0) {
  return this._queueNumberDelta("y", r);
}, dmove(r, e) {
  return this.dx(r).dy(e);
}, _queueNumberDelta(r, e) {
  if (e = new De(e), this._tryRetarget(r, e)) return this;
  const t = new kn(this._stepper).to(e);
  let n = null;
  return this.queue((function() {
    n = this.element()[r](), t.from(n), t.to(n + e);
  }), (function(o) {
    return this.element()[r](t.at(o)), t.done();
  }), (function(o) {
    t.to(n + new De(o));
  })), this._rememberMorpher(r, t), this;
}, _queueObject(r, e) {
  if (this._tryRetarget(r, e)) return this;
  const t = new kn(this._stepper).to(e);
  return this.queue((function() {
    t.from(this.element()[r]());
  }), (function(n) {
    return this.element()[r](t.at(n)), t.done();
  })), this._rememberMorpher(r, t), this;
}, _queueNumber(r, e) {
  return this._queueObject(r, new De(e));
}, cx(r) {
  return this._queueNumber("cx", r);
}, cy(r) {
  return this._queueNumber("cy", r);
}, move(r, e) {
  return this.x(r).y(e);
}, amove(r, e) {
  return this.ax(r).ay(e);
}, center(r, e) {
  return this.cx(r).cy(e);
}, size(r, e) {
  let t;
  return r && e || (t = this._element.bbox()), r || (r = t.width / t.height * e), e || (e = t.height / t.width * r), this.width(r).height(e);
}, width(r) {
  return this._queueNumber("width", r);
}, height(r) {
  return this._queueNumber("height", r);
}, plot(r, e, t, n) {
  if (arguments.length === 4) return this.plot([r, e, t, n]);
  if (this._tryRetarget("plot", r)) return this;
  const o = new kn(this._stepper).type(this._element.MorphArray).to(r);
  return this.queue((function() {
    o.from(this._element.array());
  }), (function(i) {
    return this._element.plot(o.at(i)), o.done();
  })), this._rememberMorpher("plot", o), this;
}, leading(r) {
  return this._queueNumber("leading", r);
}, viewbox(r, e, t, n) {
  return this._queueObject("viewbox", new St(r, e, t, n));
}, update(r) {
  return typeof r != "object" ? this.update({ offset: arguments[0], color: arguments[1], opacity: arguments[2] }) : (r.opacity != null && this.attr("stop-opacity", r.opacity), r.color != null && this.attr("stop-color", r.color), r.offset != null && this.attr("offset", r.offset), this);
} }), Le(ar, { rx: Id, ry: Nd, from: Em, to: Im }), Je(ar, "Runner");
class fc extends Zt {
  constructor(e, t = e) {
    super(pt("svg", e), t), this.namespace();
  }
  defs() {
    return this.isRoot() ? pr(this.node.querySelector("defs")) || this.put(new Ns()) : this.root().defs();
  }
  isRoot() {
    return !this.node.parentNode || !(this.node.parentNode instanceof Ze.window.SVGElement) && this.node.parentNode.nodeName !== "#document-fragment";
  }
  namespace() {
    return this.isRoot() ? this.attr({ xmlns: Od, version: "1.1" }).attr("xmlns:xlink", Eo, pl) : this.root().namespace();
  }
  removeNamespace() {
    return this.attr({ xmlns: null, version: null }).attr("xmlns:xlink", null, pl).attr("xmlns:svgjs", null, pl);
  }
  root() {
    return this.isRoot() ? this : super.root();
  }
}
$e({ Container: { nested: dt((function() {
  return this.put(new fc());
})) } }), Je(fc, "Svg", !0);
let gc = class extends Zt {
  constructor(r, e = r) {
    super(pt("symbol", r), e);
  }
};
$e({ Container: { symbol: dt((function() {
  return this.put(new gc());
})) } }), Je(gc, "Symbol");
var Bm = Object.freeze({ __proto__: null, amove: function(r, e) {
  return this.ax(r).ay(e);
}, ax: function(r) {
  return this.attr("x", r);
}, ay: function(r) {
  return this.attr("y", r);
}, build: function(r) {
  return this._build = !!r, this;
}, center: function(r, e, t = this.bbox()) {
  return this.cx(r, t).cy(e, t);
}, cx: function(r, e = this.bbox()) {
  return r == null ? e.cx : this.attr("x", this.attr("x") + r - e.cx);
}, cy: function(r, e = this.bbox()) {
  return r == null ? e.cy : this.attr("y", this.attr("y") + r - e.cy);
}, length: function() {
  return this.node.getComputedTextLength();
}, move: function(r, e, t = this.bbox()) {
  return this.x(r, t).y(e, t);
}, plain: function(r) {
  return this._build === !1 && this.clear(), this.node.appendChild(Ze.document.createTextNode(r)), this;
}, x: function(r, e = this.bbox()) {
  return r == null ? e.x : this.attr("x", this.attr("x") + r - e.x);
}, y: function(r, e = this.bbox()) {
  return r == null ? e.y : this.attr("y", this.attr("y") + r - e.y);
} });
class Or extends lr {
  constructor(e, t = e) {
    super(pt("text", e), t), this.dom.leading = this.dom.leading ?? new De(1.3), this._rebuild = !0, this._build = !1;
  }
  leading(e) {
    return e == null ? this.dom.leading : (this.dom.leading = new De(e), this.rebuild());
  }
  rebuild(e) {
    if (typeof e == "boolean" && (this._rebuild = e), this._rebuild) {
      const t = this;
      let n = 0;
      const o = this.dom.leading;
      this.each((function(i) {
        if (sc(this.node)) return;
        const a = Ze.window.getComputedStyle(this.node).getPropertyValue("font-size"), s = o * new De(a);
        this.dom.newLined && (this.attr("x", t.attr("x")), this.text() === `
` ? n += s : (this.attr("dy", i ? s + n : 0), n = 0));
      })), this.fire("rebuild");
    }
    return this;
  }
  setData(e) {
    return this.dom = e, this.dom.leading = new De(e.leading || 1.3), this;
  }
  writeDataToDom() {
    return mm(this, this.dom, { leading: 1.3 }), this;
  }
  text(e) {
    if (e === void 0) {
      const t = this.node.childNodes;
      let n = 0;
      e = "";
      for (let o = 0, i = t.length; o < i; ++o) t[o].nodeName === "textPath" || sc(t[o]) ? o === 0 && (n = o + 1) : (o !== n && t[o].nodeType !== 3 && pr(t[o]).dom.newLined === !0 && (e += `
`), e += t[o].textContent);
      return e;
    }
    if (this.clear().build(!0), typeof e == "function") e.call(this, this);
    else for (let t = 0, n = (e = (e + "").split(`
`)).length; t < n; t++) this.newLine(e[t]);
    return this.build(!1).rebuild();
  }
}
Le(Or, Bm), $e({ Container: { text: dt((function(r = "") {
  return this.put(new Or()).text(r);
})), plain: dt((function(r = "") {
  return this.put(new Or()).plain(r);
})) } }), Je(Or, "Text");
class Fa extends lr {
  constructor(e, t = e) {
    super(pt("tspan", e), t), this._build = !1;
  }
  dx(e) {
    return this.attr("dx", e);
  }
  dy(e) {
    return this.attr("dy", e);
  }
  newLine() {
    this.dom.newLined = !0;
    const e = this.parent();
    if (!(e instanceof Or)) return this;
    const t = e.index(this), n = Ze.window.getComputedStyle(this.node).getPropertyValue("font-size"), o = e.dom.leading * new De(n);
    return this.dy(t ? o : 0).attr("x", e.x());
  }
  text(e) {
    return e == null ? this.node.textContent + (this.dom.newLined ? `
` : "") : (typeof e == "function" ? (this.clear().build(!0), e.call(this, this), this.build(!1)) : this.plain(e), this);
  }
}
Le(Fa, Bm), $e({ Tspan: { tspan: dt((function(r = "") {
  const e = new Fa();
  return this._build || this.clear(), this.put(e).text(r);
})) }, Text: { newLine: function(r = "") {
  return this.tspan(r).newLine();
} } }), Je(Fa, "Tspan");
class xl extends lr {
  constructor(e, t = e) {
    super(pt("circle", e), t);
  }
  radius(e) {
    return this.attr("r", e);
  }
  rx(e) {
    return this.attr("r", e);
  }
  ry(e) {
    return this.rx(e);
  }
  size(e) {
    return this.radius(new De(e).divide(2));
  }
}
Le(xl, { x: Sm, y: Tm, cx: Am, cy: Om, width: Rm, height: Pm }), $e({ Container: { circle: dt((function(r = 0) {
  return this.put(new xl()).size(r).move(0, 0);
})) } }), Je(xl, "Circle");
class vl extends Zt {
  constructor(e, t = e) {
    super(pt("clipPath", e), t);
  }
  remove() {
    return this.targets().forEach((function(e) {
      e.unclip();
    })), super.remove();
  }
  targets() {
    return Hn("svg [clip-path*=" + this.id() + "]");
  }
}
$e({ Container: { clip: dt((function() {
  return this.defs().put(new vl());
})) }, Element: { clipper() {
  return this.reference("clip-path");
}, clipWith(r) {
  const e = r instanceof vl ? r : this.parent().clip().add(r);
  return this.attr("clip-path", "url(#" + e.id() + ")");
}, unclip() {
  return this.attr("clip-path", null);
} } }), Je(vl, "ClipPath");
class Nh extends Bt {
  constructor(e, t = e) {
    super(pt("foreignObject", e), t);
  }
}
$e({ Container: { foreignObject: dt((function(r, e) {
  return this.put(new Nh()).size(r, e);
})) } }), Je(Nh, "ForeignObject");
var Fm = Object.freeze({ __proto__: null, dmove: function(r, e) {
  return this.children().forEach(((t) => {
    let n;
    try {
      n = t.node instanceof ia().SVGSVGElement ? new St(t.attr(["x", "y", "width", "height"])) : t.bbox();
    } catch {
      return;
    }
    const o = new Ee(t), i = o.translate(r, e).transform(o.inverse()), a = new nt(n.x, n.y).transform(i);
    t.move(a.x, a.y);
  })), this;
}, dx: function(r) {
  return this.dmove(r, 0);
}, dy: function(r) {
  return this.dmove(0, r);
}, height: function(r, e = this.bbox()) {
  return r == null ? e.height : this.size(e.width, r, e);
}, move: function(r = 0, e = 0, t = this.bbox()) {
  const n = r - t.x, o = e - t.y;
  return this.dmove(n, o);
}, size: function(r, e, t = this.bbox()) {
  const n = Mo(this, r, e, t), o = n.width / t.width, i = n.height / t.height;
  return this.children().forEach(((a) => {
    const s = new nt(t).transform(new Ee(a).inverse());
    a.scale(o, i, s.x, s.y);
  })), this;
}, width: function(r, e = this.bbox()) {
  return r == null ? e.width : this.size(r, e.height, e);
}, x: function(r, e = this.bbox()) {
  return r == null ? e.x : this.move(r, e.y, e);
}, y: function(r, e = this.bbox()) {
  return r == null ? e.y : this.move(e.x, r, e);
} });
class sn extends Zt {
  constructor(e, t = e) {
    super(pt("g", e), t);
  }
}
Le(sn, Fm), $e({ Container: { group: dt((function() {
  return this.put(new sn());
})) } }), Je(sn, "G");
class Oa extends Zt {
  constructor(e, t = e) {
    super(pt("a", e), t);
  }
  target(e) {
    return this.attr("target", e);
  }
  to(e) {
    return this.attr("href", e, Eo);
  }
}
Le(Oa, Fm), $e({ Container: { link: dt((function(r) {
  return this.put(new Oa()).to(r);
})) }, Element: { unlink() {
  const r = this.linker();
  if (!r) return this;
  const e = r.parent();
  if (!e) return this.remove();
  const t = e.index(r);
  return e.add(this, t), r.remove(), this;
}, linkTo(r) {
  let e = this.linker();
  return e || (e = new Oa(), this.wrap(e)), typeof r == "function" ? r.call(e, e) : e.to(r), this;
}, linker() {
  const r = this.parent();
  return r && r.node.nodeName.toLowerCase() === "a" ? r : null;
} } }), Je(Oa, "A");
class yl extends Zt {
  constructor(e, t = e) {
    super(pt("mask", e), t);
  }
  remove() {
    return this.targets().forEach((function(e) {
      e.unmask();
    })), super.remove();
  }
  targets() {
    return Hn("svg [mask*=" + this.id() + "]");
  }
}
$e({ Container: { mask: dt((function() {
  return this.defs().put(new yl());
})) }, Element: { masker() {
  return this.reference("mask");
}, maskWith(r) {
  const e = r instanceof yl ? r : this.parent().mask().add(r);
  return this.attr("mask", "url(#" + e.id() + ")");
}, unmask() {
  return this.attr("mask", null);
} } }), Je(yl, "Mask");
class Lh extends Bt {
  constructor(e, t = e) {
    super(pt("stop", e), t);
  }
  update(e) {
    return (typeof e == "number" || e instanceof De) && (e = { offset: arguments[0], color: arguments[1], opacity: arguments[2] }), e.opacity != null && this.attr("stop-opacity", e.opacity), e.color != null && this.attr("stop-color", e.color), e.offset != null && this.attr("offset", new De(e.offset)), this;
  }
}
$e({ Gradient: { stop: function(r, e, t) {
  return this.put(new Lh()).update(r, e, t);
} } }), Je(Lh, "Stop");
class wl extends Bt {
  constructor(e, t = e) {
    super(pt("style", e), t);
  }
  addText(e = "") {
    return this.node.textContent += e, this;
  }
  font(e, t, n = {}) {
    return this.rule("@font-face", { fontFamily: e, src: t, ...n });
  }
  rule(e, t) {
    return this.addText((function(n, o) {
      if (!n) return "";
      if (!o) return n;
      let i = n + "{";
      for (const a in o) i += a.replace(/([A-Z])/g, (function(s, c) {
        return "-" + c.toLowerCase();
      })) + ":" + o[a] + ";";
      return i += "}", i;
    })(e, t));
  }
}
$e("Dom", { style(r, e) {
  return this.put(new wl()).rule(r, e);
}, fontface(r, e, t) {
  return this.put(new wl()).font(r, e, t);
} }), Je(wl, "Style");
class Cl extends Or {
  constructor(e, t = e) {
    super(pt("textPath", e), t);
  }
  array() {
    const e = this.track();
    return e ? e.array() : null;
  }
  plot(e) {
    const t = this.track();
    let n = null;
    return t && (n = t.plot(e)), e == null ? n : this;
  }
  track() {
    return this.reference("href");
  }
}
$e({ Container: { textPath: dt((function(r, e) {
  return r instanceof Or || (r = this.text(r)), r.path(e);
})) }, Text: { path: dt((function(r, e = !0) {
  const t = new Cl();
  let n;
  if (r instanceof lo || (r = this.defs().path(r)), t.attr("href", "#" + r, Eo), e) for (; n = this.node.firstChild; ) t.node.appendChild(n);
  return this.put(t);
})), textPath() {
  return this.findOne("textPath");
} }, Path: { text: dt((function(r) {
  return r instanceof Or || (r = new Or().addTo(this.parent()).text(r)), r.path(this);
})), targets() {
  return Hn("svg textPath").filter(((r) => (r.attr("href") || "").includes(this.id())));
} } }), Cl.prototype.MorphArray = Ar, Je(Cl, "TextPath");
class jh extends lr {
  constructor(e, t = e) {
    super(pt("use", e), t);
  }
  use(e, t) {
    return this.attr("href", (t || "") + "#" + e, Eo);
  }
}
$e({ Container: { use: dt((function(r, e) {
  return this.put(new jh()).use(r, e);
})) } }), Je(jh, "Use");
const AL = Gt;
Le([fc, gc, Da, Hi, za], Jt("viewbox")), Le([Pn, En, Mn, lo], Jt("marker")), Le(Or, Jt("Text")), Le(lo, Jt("Path")), Le(Ns, Jt("Defs")), Le([Or, Fa], Jt("Tspan")), Le([Ba, ja, Mi, ar], Jt("radius")), Le(aa, Jt("EventTarget")), Le(dn, Jt("Dom")), Le(Bt, Jt("Element")), Le(lr, Jt("Shape")), Le([Zt, Mm], Jt("Container")), Le(Mi, Jt("Gradient")), Le(ar, Jt("Runner")), $n.extend([...new Set(fm)]), (function(r = []) {
  hc.push(...[].concat(r));
})([De, lt, St, Ee, Wn, un, Ar, nt]), Le(hc, { to(r) {
  return new kn().type(this.constructor).from(this.toArray()).to(r);
}, fromArray(r) {
  return this.init(r), this;
}, toConsumable() {
  return this.toArray();
}, morph(r, e, t, n, o) {
  return this.fromArray(r.map((function(i, a) {
    return n.step(i, e[a], t, o[a], o);
  })));
} });
class ft extends Bt {
  constructor(e) {
    super(pt("filter", e), e), this.$source = "SourceGraphic", this.$sourceAlpha = "SourceAlpha", this.$background = "BackgroundImage", this.$backgroundAlpha = "BackgroundAlpha", this.$fill = "FillPaint", this.$stroke = "StrokePaint", this.$autoSetIn = !0;
  }
  put(e, t) {
    return !(e = super.put(e, t)).attr("in") && this.$autoSetIn && e.attr("in", this.$source), e.attr("result") || e.attr("result", e.id()), e;
  }
  remove() {
    return this.targets().each("unfilter"), super.remove();
  }
  targets() {
    return Hn('svg [filter*="' + this.id() + '"]');
  }
  toString() {
    return "url(#" + this.id() + ")";
  }
}
class Dd extends Bt {
  constructor(e, t) {
    super(e, t), this.result(this.id());
  }
  in(e) {
    if (e == null) {
      const t = this.attr("in");
      return this.parent() && this.parent().find(`[result="${t}"]`)[0] || t;
    }
    return this.attr("in", e);
  }
  result(e) {
    return this.attr("result", e);
  }
  toString() {
    return this.result();
  }
}
const cr = (r) => function(...e) {
  for (let t = r.length; t--; ) e[t] != null && this.attr(r[t], e[t]);
}, OL = { blend: cr(["in", "in2", "mode"]), colorMatrix: cr(["type", "values"]), composite: cr(["in", "in2", "operator"]), convolveMatrix: function(r) {
  r = new Wn(r).toString(), this.attr({ order: Math.sqrt(r.split(" ").length), kernelMatrix: r });
}, diffuseLighting: cr(["surfaceScale", "lightingColor", "diffuseConstant", "kernelUnitLength"]), displacementMap: cr(["in", "in2", "scale", "xChannelSelector", "yChannelSelector"]), dropShadow: cr(["in", "dx", "dy", "stdDeviation"]), flood: cr(["flood-color", "flood-opacity"]), gaussianBlur: function(r = 0, e = r) {
  this.attr("stdDeviation", r + " " + e);
}, image: function(r) {
  this.attr("href", r, Eo);
}, morphology: cr(["operator", "radius"]), offset: cr(["dx", "dy"]), specularLighting: cr(["surfaceScale", "lightingColor", "diffuseConstant", "specularExponent", "kernelUnitLength"]), tile: cr([]), turbulence: cr(["baseFrequency", "numOctaves", "seed", "stitchTiles", "type"]) };
["blend", "colorMatrix", "componentTransfer", "composite", "convolveMatrix", "diffuseLighting", "displacementMap", "dropShadow", "flood", "gaussianBlur", "image", "merge", "morphology", "offset", "specularLighting", "tile", "turbulence"].forEach(((r) => {
  const e = Po(r), t = OL[r];
  ft[e + "Effect"] = class extends Dd {
    constructor(n) {
      super(pt("fe" + e, n), n);
    }
    update(n) {
      return t.apply(this, n), this;
    }
  }, ft.prototype[r] = dt((function(n, ...o) {
    const i = new ft[e + "Effect"]();
    return n == null ? this.put(i) : (typeof n == "function" ? n.call(i, i) : o.unshift(n), this.put(i).update(o));
  }));
})), Le(ft, { merge(r) {
  const e = this.put(new ft.MergeEffect());
  return typeof r == "function" ? (r.call(e, e), e) : ((r instanceof Array ? r : [...arguments]).forEach(((t) => {
    t instanceof ft.MergeNode ? e.put(t) : e.mergeNode(t);
  })), e);
}, componentTransfer(r = {}) {
  const e = this.put(new ft.ComponentTransferEffect());
  if (typeof r == "function") return r.call(e, e), e;
  r.r || r.g || r.b || r.a || (r = { r, g: r, b: r, a: r });
  for (const t in r) e.add(new ft["Func" + t.toUpperCase()](r[t]));
  return e;
} });
["distantLight", "pointLight", "spotLight", "mergeNode", "FuncR", "FuncG", "FuncB", "FuncA"].forEach(((r) => {
  const e = Po(r);
  ft[e] = class extends Dd {
    constructor(t) {
      super(pt("fe" + e, t), t);
    }
  };
}));
["funcR", "funcG", "funcB", "funcA"].forEach((function(r) {
  const e = ft[Po(r)], t = dt((function() {
    return this.put(new e());
  }));
  ft.ComponentTransferEffect.prototype[r] = t;
}));
["distantLight", "pointLight", "spotLight"].forEach(((r) => {
  const e = ft[Po(r)], t = dt((function() {
    return this.put(new e());
  }));
  ft.DiffuseLightingEffect.prototype[r] = t, ft.SpecularLightingEffect.prototype[r] = t;
})), Le(ft.MergeEffect, { mergeNode(r) {
  return this.put(new ft.MergeNode()).attr("in", r);
} }), Le(Ns, { filter: function(r) {
  const e = this.put(new ft());
  return typeof r == "function" && r.call(e, e), e;
} }), Le(Zt, { filter: function(r) {
  return this.defs().filter(r);
} }), Le(Bt, { filterWith: function(r) {
  const e = r instanceof ft ? r : this.defs().filter(r);
  return this.attr("filter", e);
}, unfilter: function(r) {
  return this.attr("filter", null);
}, filterer() {
  return this.reference("filter");
} });
const RL = { blend: function(r, e) {
  return this.parent() && this.parent().blend(this, r, e);
}, colorMatrix: function(r, e) {
  return this.parent() && this.parent().colorMatrix(r, e).in(this);
}, componentTransfer: function(r) {
  return this.parent() && this.parent().componentTransfer(r).in(this);
}, composite: function(r, e) {
  return this.parent() && this.parent().composite(this, r, e);
}, convolveMatrix: function(r) {
  return this.parent() && this.parent().convolveMatrix(r).in(this);
}, diffuseLighting: function(r, e, t, n) {
  return this.parent() && this.parent().diffuseLighting(r, t, n).in(this);
}, displacementMap: function(r, e, t, n) {
  return this.parent() && this.parent().displacementMap(this, r, e, t, n);
}, dropShadow: function(r, e, t) {
  return this.parent() && this.parent().dropShadow(this, r, e, t).in(this);
}, flood: function(r, e) {
  return this.parent() && this.parent().flood(r, e);
}, gaussianBlur: function(r, e) {
  return this.parent() && this.parent().gaussianBlur(r, e).in(this);
}, image: function(r) {
  return this.parent() && this.parent().image(r);
}, merge: function(r) {
  return r = r instanceof Array ? r : [...r], this.parent() && this.parent().merge(this, ...r);
}, morphology: function(r, e) {
  return this.parent() && this.parent().morphology(r, e).in(this);
}, offset: function(r, e) {
  return this.parent() && this.parent().offset(r, e).in(this);
}, specularLighting: function(r, e, t, n, o) {
  return this.parent() && this.parent().specularLighting(r, t, n, o).in(this);
}, tile: function() {
  return this.parent() && this.parent().tile().in(this);
}, turbulence: function(r, e, t, n, o) {
  return this.parent() && this.parent().turbulence(r, e, t, n, o).in(this);
} };
Le(Dd, RL), Le(ft.MergeEffect, { in: function(r) {
  return r instanceof ft.MergeNode ? this.add(r, 0) : this.add(new ft.MergeNode().in(r), 0), this;
} }), Le([ft.CompositeEffect, ft.BlendEffect, ft.DisplacementMapEffect], { in2: function(r) {
  if (r == null) {
    const e = this.attr("in2");
    return this.parent() && this.parent().find(`[result="${e}"]`)[0] || e;
  }
  return this.attr("in2", r);
} }), ft.filter = { sepiatone: [0.343, 0.669, 0.119, 0, 0, 0.249, 0.626, 0.13, 0, 0, 0.172, 0.334, 0.111, 0, 0, 0, 0, 0, 1, 0] };
var zt = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "getDefaultFilter", value: function(e, t) {
    var n = this.w;
    e.unfilter(!0), new ft().size("120%", "180%", "-5%", "-40%"), n.config.chart.dropShadow.enabled && this.dropShadow(e, n.config.chart.dropShadow, t);
  } }, { key: "applyFilter", value: function(e, t, n) {
    var o, i = this, a = this.w;
    if (e.unfilter(!0), n !== "none") {
      var s, c, d = a.config.chart.dropShadow, u = n === "lighten" ? 2 : 0.3;
      e.filterWith((function(p) {
        p.colorMatrix({ type: "matrix", values: `
          `.concat(u, ` 0 0 0 0
          0 `).concat(u, ` 0 0 0
          0 0 `).concat(u, ` 0 0
          0 0 0 1 0
        `), in: "SourceGraphic", result: "brightness" }), d.enabled && i.addShadow(p, t, d, "brightness");
      })), !d.noUserSpaceOnUse && ((s = e.filterer()) === null || s === void 0 || (c = s.node) === null || c === void 0 || c.setAttribute("filterUnits", "userSpaceOnUse")), this._scaleFilterSize((o = e.filterer()) === null || o === void 0 ? void 0 : o.node);
    } else this.getDefaultFilter(e, t);
  } }, { key: "addShadow", value: function(e, t, n, o) {
    var i, a = this.w, s = n.blur, c = n.top, d = n.left, u = n.color, p = n.opacity;
    if (u = Array.isArray(u) ? u[t] : u, ((i = a.config.chart.dropShadow.enabledOnSeries) === null || i === void 0 ? void 0 : i.length) > 0 && a.config.chart.dropShadow.enabledOnSeries.indexOf(t) === -1) return e;
    e.offset({ in: o, dx: d, dy: c, result: "offset" }), e.gaussianBlur({ in: "offset", stdDeviation: s, result: "blur" }), e.flood({ "flood-color": u, "flood-opacity": p, result: "flood" }), e.composite({ in: "flood", in2: "blur", operator: "in", result: "shadow" }), e.merge(["shadow", o]);
  } }, { key: "dropShadow", value: function(e, t) {
    var n, o, i, a, s, c = this, d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, u = this.w;
    return e.unfilter(!0), $.isMsEdge() && u.config.chart.type === "radialBar" || ((n = u.config.chart.dropShadow.enabledOnSeries) === null || n === void 0 ? void 0 : n.length) > 0 && ((i = u.config.chart.dropShadow.enabledOnSeries) === null || i === void 0 ? void 0 : i.indexOf(d)) === -1 ? e : (e.filterWith((function(p) {
      c.addShadow(p, d, t, "SourceGraphic");
    })), t.noUserSpaceOnUse || (a = e.filterer()) === null || a === void 0 || (s = a.node) === null || s === void 0 || s.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize((o = e.filterer()) === null || o === void 0 ? void 0 : o.node), e);
  } }, { key: "setSelectionFilter", value: function(e, t, n) {
    var o = this.w;
    if (o.globals.selectedDataPoints[t] !== void 0 && o.globals.selectedDataPoints[t].indexOf(n) > -1) {
      e.node.setAttribute("selected", !0);
      var i = o.config.states.active.filter;
      i !== "none" && this.applyFilter(e, t, i.type);
    }
  } }, { key: "_scaleFilterSize", value: function(e) {
    e && (function(t) {
      for (var n in t) t.hasOwnProperty(n) && e.setAttribute(n, t[n]);
    })({ width: "200%", height: "200%", x: "-50%", y: "-50%" });
  } }]), r;
})(), ee = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "roundPathCorners", value: function(e, t) {
    function n(O, P, M) {
      var I = P.x - O.x, E = P.y - O.y, N = Math.sqrt(I * I + E * E);
      return o(O, P, Math.min(1, M / N));
    }
    function o(O, P, M) {
      return { x: O.x + (P.x - O.x) * M, y: O.y + (P.y - O.y) * M };
    }
    function i(O, P) {
      O.length > 2 && (O[O.length - 2] = P.x, O[O.length - 1] = P.y);
    }
    function a(O) {
      return { x: parseFloat(O[O.length - 2]), y: parseFloat(O[O.length - 1]) };
    }
    e.indexOf("NaN") > -1 && (e = "");
    var s = e.split(/[,\s]/).reduce((function(O, P) {
      var M = P.match(/^([a-zA-Z])(.+)/);
      return M ? (O.push(M[1]), O.push(M[2])) : O.push(P), O;
    }), []).reduce((function(O, P) {
      return parseFloat(P) == P && O.length ? O[O.length - 1].push(P) : O.push([P]), O;
    }), []), c = [];
    if (s.length > 1) {
      var d = a(s[0]), u = null;
      s[s.length - 1][0] == "Z" && s[0].length > 2 && (u = ["L", d.x, d.y], s[s.length - 1] = u), c.push(s[0]);
      for (var p = 1; p < s.length; p++) {
        var h = c[c.length - 1], f = s[p], m = f == u ? s[1] : s[p + 1];
        if (m && h && h.length > 2 && f[0] == "L" && m.length > 2 && m[0] == "L") {
          var g, b, x = a(h), v = a(f), y = a(m);
          g = n(v, x, t), b = n(v, y, t), i(f, g), f.origPoint = v, c.push(f);
          var C = o(g, v, 0.5), k = o(v, b, 0.5), T = ["C", C.x, C.y, k.x, k.y, b.x, b.y];
          T.origPoint = v, c.push(T);
        } else c.push(f);
      }
      if (u) {
        var S = a(c[c.length - 1]);
        c.push(["Z"]), i(c[0], S);
      }
    } else c = s;
    return c.reduce((function(O, P) {
      return O + P.join(" ") + " ";
    }), "");
  } }, { key: "drawLine", value: function(e, t, n, o) {
    var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "#a8a8a8", a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, c = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "butt";
    return this.w.globals.dom.Paper.line().attr({ x1: e, y1: t, x2: n, y2: o, stroke: i, "stroke-dasharray": a, "stroke-width": s, "stroke-linecap": c });
  } }, { key: "drawRect", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "#fefefe", s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 1, c = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, d = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null, u = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : 0, p = this.w.globals.dom.Paper.rect();
    return p.attr({ x: e, y: t, width: n > 0 ? n : 0, height: o > 0 ? o : 0, rx: i, ry: i, opacity: s, "stroke-width": c !== null ? c : 0, stroke: d !== null ? d : "none", "stroke-dasharray": u }), p.node.setAttribute("fill", a), p;
  } }, { key: "drawPolygon", value: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "#e1e1e1", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "none";
    return this.w.globals.dom.Paper.polygon(e).attr({ fill: o, stroke: t, "stroke-width": n });
  } }, { key: "drawCircle", value: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    e < 0 && (e = 0);
    var n = this.w.globals.dom.Paper.circle(2 * e);
    return t !== null && n.attr(t), n;
  } }, { key: "drawPath", value: function(e) {
    var t = e.d, n = t === void 0 ? "" : t, o = e.stroke, i = o === void 0 ? "#a8a8a8" : o, a = e.strokeWidth, s = a === void 0 ? 1 : a, c = e.fill, d = e.fillOpacity, u = d === void 0 ? 1 : d, p = e.strokeOpacity, h = p === void 0 ? 1 : p, f = e.classes, m = e.strokeLinecap, g = m === void 0 ? null : m, b = e.strokeDashArray, x = b === void 0 ? 0 : b, v = this.w;
    return g === null && (g = v.config.stroke.lineCap), (n.indexOf("undefined") > -1 || n.indexOf("NaN") > -1) && (n = "M 0 ".concat(v.globals.gridHeight)), v.globals.dom.Paper.path(n).attr({ fill: c, "fill-opacity": u, stroke: i, "stroke-opacity": h, "stroke-linecap": g, "stroke-width": s, "stroke-dasharray": x, class: f });
  } }, { key: "group", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, t = this.w.globals.dom.Paper.group();
    return e !== null && t.attr(e), t;
  } }, { key: "move", value: function(e, t) {
    var n = ["M", e, t].join(" ");
    return n;
  } }, { key: "line", value: function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, o = null;
    return n === null ? o = [" L", e, t].join(" ") : n === "H" ? o = [" H", e].join(" ") : n === "V" && (o = [" V", t].join(" ")), o;
  } }, { key: "curve", value: function(e, t, n, o, i, a) {
    var s = ["C", e, t, n, o, i, a].join(" ");
    return s;
  } }, { key: "quadraticCurve", value: function(e, t, n, o) {
    return ["Q", e, t, n, o].join(" ");
  } }, { key: "arc", value: function(e, t, n, o, i, a, s) {
    var c = "A";
    arguments.length > 7 && arguments[7] !== void 0 && arguments[7] && (c = "a");
    var d = [c, e, t, n, o, i, a, s].join(" ");
    return d;
  } }, { key: "renderPaths", value: function(e) {
    var t, n = e.j, o = e.realIndex, i = e.pathFrom, a = e.pathTo, s = e.stroke, c = e.strokeWidth, d = e.strokeLinecap, u = e.fill, p = e.animationDelay, h = e.initialSpeed, f = e.dataChangeSpeed, m = e.className, g = e.chartType, b = e.shouldClipToGrid, x = b === void 0 || b, v = e.bindEventsOnPaths, y = v === void 0 || v, C = e.drawShadow, k = C === void 0 || C, T = this.w, S = new zt(this.ctx), O = new Ro(this.ctx), P = this.w.config.chart.animations.enabled, M = P && this.w.config.chart.animations.dynamicAnimation.enabled;
    if (i && i.startsWith("M 0 0") && a) {
      var I = a.match(/^M\s+[\d.-]+\s+[\d.-]+/);
      I && (i = i.replace(/^M\s+0\s+0/, I[0]));
    }
    var E = !!(P && !T.globals.resized || M && T.globals.dataChanged && T.globals.shouldAnimate);
    E ? t = i : (t = a, T.globals.animationEnded = !0);
    var N = T.config.stroke.dashArray, L = 0;
    L = Array.isArray(N) ? N[o] : T.config.stroke.dashArray;
    var z = this.drawPath({ d: t, stroke: s, strokeWidth: c, fill: u, fillOpacity: 1, classes: m, strokeLinecap: d, strokeDashArray: L });
    z.attr("index", o), x && (g === "bar" && !T.globals.isHorizontal || T.globals.comboCharts ? z.attr({ "clip-path": "url(#gridRectBarMask".concat(T.globals.cuid, ")") }) : z.attr({ "clip-path": "url(#gridRectMask".concat(T.globals.cuid, ")") })), T.config.chart.dropShadow.enabled && k && S.dropShadow(z, T.config.chart.dropShadow, o), y && (z.node.addEventListener("mouseenter", this.pathMouseEnter.bind(this, z)), z.node.addEventListener("mouseleave", this.pathMouseLeave.bind(this, z)), z.node.addEventListener("mousedown", this.pathMouseDown.bind(this, z))), z.attr({ pathTo: a, pathFrom: i });
    var F = { el: z, j: n, realIndex: o, pathFrom: i, pathTo: a, fill: u, strokeWidth: c, delay: p };
    return !P || T.globals.resized || T.globals.dataChanged ? !T.globals.resized && T.globals.dataChanged || O.showDelayedElements() : O.animatePathsGradually(ie(ie({}, F), {}, { speed: h })), T.globals.dataChanged && M && E && O.animatePathsGradually(ie(ie({}, F), {}, { speed: f })), z;
  } }, { key: "drawPattern", value: function(e, t, n) {
    var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "#a8a8a8", i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    return this.w.globals.dom.Paper.pattern(t, n, (function(a) {
      e === "horizontalLines" ? a.line(0, 0, n, 0).stroke({ color: o, width: i + 1 }) : e === "verticalLines" ? a.line(0, 0, 0, t).stroke({ color: o, width: i + 1 }) : e === "slantedLines" ? a.line(0, 0, t, n).stroke({ color: o, width: i }) : e === "squares" ? a.rect(t, n).fill("none").stroke({ color: o, width: i }) : e === "circles" && a.circle(t).fill("none").stroke({ color: o, width: i });
    }));
  } }, { key: "drawGradient", value: function(e, t, n, o, i) {
    var a, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, c = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, d = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [], u = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0, p = this.w;
    t.length < 9 && t.indexOf("#") === 0 && (t = $.hexToRgba(t, o)), n.length < 9 && n.indexOf("#") === 0 && (n = $.hexToRgba(n, i));
    var h = 0, f = 1, m = 1, g = null;
    c !== null && (h = c[0] !== void 0 ? c[0] / 100 : 0, f = c[1] !== void 0 ? c[1] / 100 : 1, m = c[2] !== void 0 ? c[2] / 100 : 1, g = c[3] !== void 0 ? c[3] / 100 : null);
    var b = !(p.config.chart.type !== "donut" && p.config.chart.type !== "pie" && p.config.chart.type !== "polarArea" && p.config.chart.type !== "bubble");
    if (a = d && d.length !== 0 ? p.globals.dom.Paper.gradient(b ? "radial" : "linear", (function(y) {
      (Array.isArray(d[u]) ? d[u] : d).forEach((function(C) {
        y.stop(C.offset / 100, C.color, C.opacity);
      }));
    })) : p.globals.dom.Paper.gradient(b ? "radial" : "linear", (function(y) {
      y.stop(h, t, o), y.stop(f, n, i), y.stop(m, n, i), g !== null && y.stop(g, t, o);
    })), b) {
      var x = p.globals.gridWidth / 2, v = p.globals.gridHeight / 2;
      p.config.chart.type !== "bubble" ? a.attr({ gradientUnits: "userSpaceOnUse", cx: x, cy: v, r: s }) : a.attr({ cx: 0.5, cy: 0.5, r: 0.8, fx: 0.2, fy: 0.2 });
    } else e === "vertical" ? a.from(0, 0).to(0, 1) : e === "diagonal" ? a.from(0, 0).to(1, 1) : e === "horizontal" ? a.from(0, 1).to(1, 1) : e === "diagonal2" && a.from(1, 0).to(0, 1);
    return a;
  } }, { key: "getTextBasedOnMaxWidth", value: function(e) {
    var t = e.text, n = e.maxWidth, o = e.fontSize, i = e.fontFamily, a = this.getTextRects(t, o, i), s = a.width / t.length, c = Math.floor(n / s);
    return n < a.width ? t.slice(0, c - 3) + "..." : t;
  } }, { key: "drawText", value: function(e) {
    var t = this, n = e.x, o = e.y, i = e.text, a = e.textAnchor, s = e.fontSize, c = e.fontFamily, d = e.fontWeight, u = e.foreColor, p = e.opacity, h = e.maxWidth, f = e.cssClass, m = f === void 0 ? "" : f, g = e.isPlainText, b = g === void 0 || g, x = e.dominantBaseline, v = x === void 0 ? "auto" : x, y = this.w;
    i === void 0 && (i = "");
    var C = i;
    a || (a = "start"), u && u.length || (u = y.config.chart.foreColor), c = c || y.config.chart.fontFamily, d = d || "regular";
    var k, T = { maxWidth: h, fontSize: s = s || "11px", fontFamily: c };
    return Array.isArray(i) ? k = y.globals.dom.Paper.text((function(S) {
      for (var O = 0; O < i.length; O++) C = i[O], h && (C = t.getTextBasedOnMaxWidth(ie({ text: i[O] }, T))), O === 0 ? S.tspan(C) : S.tspan(C).newLine();
    })) : (h && (C = this.getTextBasedOnMaxWidth(ie({ text: i }, T))), k = b ? y.globals.dom.Paper.plain(i) : y.globals.dom.Paper.text((function(S) {
      return S.tspan(C);
    }))), k.attr({ x: n, y: o, "text-anchor": a, "dominant-baseline": v, "font-size": s, "font-family": c, "font-weight": d, fill: u, class: "apexcharts-text " + m }), k.node.style.fontFamily = c, k.node.style.opacity = p, k;
  } }, { key: "getMarkerPath", value: function(e, t, n, o) {
    var i = "";
    switch (n) {
      case "cross":
        i = "M ".concat(e - (o /= 1.4), " ").concat(t - o, " L ").concat(e + o, " ").concat(t + o, "  M ").concat(e - o, " ").concat(t + o, " L ").concat(e + o, " ").concat(t - o);
        break;
      case "plus":
        i = "M ".concat(e - (o /= 1.12), " ").concat(t, " L ").concat(e + o, " ").concat(t, "  M ").concat(e, " ").concat(t - o, " L ").concat(e, " ").concat(t + o);
        break;
      case "star":
      case "sparkle":
        var a = 5;
        o *= 1.15, n === "sparkle" && (o /= 1.1, a = 4);
        for (var s = Math.PI / a, c = 0; c <= 2 * a; c++) {
          var d = c * s, u = c % 2 == 0 ? o : o / 2;
          i += (c === 0 ? "M" : "L") + (e + u * Math.sin(d)) + "," + (t - u * Math.cos(d));
        }
        i += "Z";
        break;
      case "triangle":
        i = "M ".concat(e, " ").concat(t - o, ` 
             L `).concat(e + o, " ").concat(t + o, ` 
             L `).concat(e - o, " ").concat(t + o, ` 
             Z`);
        break;
      case "square":
      case "rect":
        i = "M ".concat(e - (o /= 1.125), " ").concat(t - o, ` 
           L `).concat(e + o, " ").concat(t - o, ` 
           L `).concat(e + o, " ").concat(t + o, ` 
           L `).concat(e - o, " ").concat(t + o, ` 
           Z`);
        break;
      case "diamond":
        o *= 1.05, i = "M ".concat(e, " ").concat(t - o, ` 
             L `).concat(e + o, " ").concat(t, ` 
             L `).concat(e, " ").concat(t + o, ` 
             L `).concat(e - o, " ").concat(t, ` 
            Z`);
        break;
      case "line":
        i = "M ".concat(e - (o /= 1.1), " ").concat(t, ` 
           L `).concat(e + o, " ").concat(t);
        break;
      default:
        o *= 2, i = "M ".concat(e, ", ").concat(t, ` 
           m -`).concat(o / 2, `, 0 
           a `).concat(o / 2, ",").concat(o / 2, " 0 1,0 ").concat(o, `,0 
           a `).concat(o / 2, ",").concat(o / 2, " 0 1,0 -").concat(o, ",0");
    }
    return i;
  } }, { key: "drawMarkerShape", value: function(e, t, n, o, i) {
    var a = this.drawPath({ d: this.getMarkerPath(e, t, n, o, i), stroke: i.pointStrokeColor, strokeDashArray: i.pointStrokeDashArray, strokeWidth: i.pointStrokeWidth, fill: i.pointFillColor, fillOpacity: i.pointFillOpacity, strokeOpacity: i.pointStrokeOpacity });
    return a.attr({ cx: e, cy: t, shape: i.shape, class: i.class ? i.class : "" }), a;
  } }, { key: "drawMarker", value: function(e, t, n) {
    e = e || 0;
    var o = n.pSize || 0;
    return $.isNumber(t) || (o = 0, t = 0), this.drawMarkerShape(e, t, n?.shape, o, ie(ie({}, n), n.shape === "line" || n.shape === "plus" || n.shape === "cross" ? { pointStrokeColor: n.pointFillColor, pointStrokeOpacity: n.pointFillOpacity } : {}));
  } }, { key: "pathMouseEnter", value: function(e, t) {
    var n = this.w, o = new zt(this.ctx), i = parseInt(e.node.getAttribute("index"), 10), a = parseInt(e.node.getAttribute("j"), 10);
    if (typeof n.config.chart.events.dataPointMouseEnter == "function" && n.config.chart.events.dataPointMouseEnter(t, this.ctx, { seriesIndex: i, dataPointIndex: a, w: n }), this.ctx.events.fireEvent("dataPointMouseEnter", [t, this.ctx, { seriesIndex: i, dataPointIndex: a, w: n }]), (n.config.states.active.filter.type === "none" || e.node.getAttribute("selected") !== "true") && n.config.states.hover.filter.type !== "none" && !n.globals.isTouchDevice) {
      var s = n.config.states.hover.filter;
      o.applyFilter(e, i, s.type);
    }
  } }, { key: "pathMouseLeave", value: function(e, t) {
    var n = this.w, o = new zt(this.ctx), i = parseInt(e.node.getAttribute("index"), 10), a = parseInt(e.node.getAttribute("j"), 10);
    typeof n.config.chart.events.dataPointMouseLeave == "function" && n.config.chart.events.dataPointMouseLeave(t, this.ctx, { seriesIndex: i, dataPointIndex: a, w: n }), this.ctx.events.fireEvent("dataPointMouseLeave", [t, this.ctx, { seriesIndex: i, dataPointIndex: a, w: n }]), n.config.states.active.filter.type !== "none" && e.node.getAttribute("selected") === "true" || n.config.states.hover.filter.type !== "none" && o.getDefaultFilter(e, i);
  } }, { key: "pathMouseDown", value: function(e, t) {
    var n = this.w, o = new zt(this.ctx), i = parseInt(e.node.getAttribute("index"), 10), a = parseInt(e.node.getAttribute("j"), 10), s = "false";
    if (e.node.getAttribute("selected") === "true") {
      if (e.node.setAttribute("selected", "false"), n.globals.selectedDataPoints[i].indexOf(a) > -1) {
        var c = n.globals.selectedDataPoints[i].indexOf(a);
        n.globals.selectedDataPoints[i].splice(c, 1);
      }
    } else {
      if (!n.config.states.active.allowMultipleDataPointsSelection && n.globals.selectedDataPoints.length > 0) {
        n.globals.selectedDataPoints = [];
        var d = n.globals.dom.Paper.find(".apexcharts-series path:not(.apexcharts-decoration-element)"), u = n.globals.dom.Paper.find(".apexcharts-series circle:not(.apexcharts-decoration-element), .apexcharts-series rect:not(.apexcharts-decoration-element)"), p = function(m) {
          Array.prototype.forEach.call(m, (function(g) {
            g.node.setAttribute("selected", "false"), o.getDefaultFilter(g, i);
          }));
        };
        p(d), p(u);
      }
      e.node.setAttribute("selected", "true"), s = "true", n.globals.selectedDataPoints[i] === void 0 && (n.globals.selectedDataPoints[i] = []), n.globals.selectedDataPoints[i].push(a);
    }
    if (s === "true") {
      var h = n.config.states.active.filter;
      if (h !== "none") o.applyFilter(e, i, h.type);
      else if (n.config.states.hover.filter !== "none" && !n.globals.isTouchDevice) {
        var f = n.config.states.hover.filter;
        o.applyFilter(e, i, f.type);
      }
    } else n.config.states.active.filter.type !== "none" && (n.config.states.hover.filter.type === "none" || n.globals.isTouchDevice ? o.getDefaultFilter(e, i) : (f = n.config.states.hover.filter, o.applyFilter(e, i, f.type)));
    typeof n.config.chart.events.dataPointSelection == "function" && n.config.chart.events.dataPointSelection(t, this.ctx, { selectedDataPoints: n.globals.selectedDataPoints, seriesIndex: i, dataPointIndex: a, w: n }), t && this.ctx.events.fireEvent("dataPointSelection", [t, this.ctx, { selectedDataPoints: n.globals.selectedDataPoints, seriesIndex: i, dataPointIndex: a, w: n }]);
  } }, { key: "rotateAroundCenter", value: function(e) {
    var t = {};
    return e && typeof e.getBBox == "function" && (t = e.getBBox()), { x: t.x + t.width / 2, y: t.y + t.height / 2 };
  } }, { key: "getTextRects", value: function(e, t, n, o) {
    var i = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4], a = this.w, s = this.drawText({ x: -200, y: -200, text: e, textAnchor: "start", fontSize: t, fontFamily: n, foreColor: "#fff", opacity: 0 });
    o && s.attr("transform", o), a.globals.dom.Paper.add(s);
    var c = s.bbox();
    return i || (c = s.node.getBoundingClientRect()), s.remove(), { width: c.width, height: c.height };
  } }, { key: "placeTextWithEllipsis", value: function(e, t, n) {
    if (typeof e.getComputedTextLength == "function" && (e.textContent = t, t.length > 0 && e.getComputedTextLength() >= n / 1.1)) {
      for (var o = t.length - 3; o > 0; o -= 3) if (e.getSubStringLength(0, o) <= n / 1.1) return void (e.textContent = t.substring(0, o) + "...");
      e.textContent = ".";
    }
  } }], [{ key: "setAttrs", value: function(e, t) {
    for (var n in t) t.hasOwnProperty(n) && e.setAttribute(n, t[n]);
  } }]), r;
})(), Tt = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "getStackedSeriesTotals", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = this.w, n = [];
    if (t.globals.series.length === 0) return n;
    for (var o = 0; o < t.globals.series[t.globals.maxValsInArrayIndex].length; o++) {
      for (var i = 0, a = 0; a < t.globals.series.length; a++) t.globals.series[a][o] !== void 0 && e.indexOf(a) === -1 && (i += t.globals.series[a][o]);
      n.push(i);
    }
    return n;
  } }, { key: "getSeriesTotalByIndex", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return e === null ? this.w.config.series.reduce((function(t, n) {
      return t + n;
    }), 0) : this.w.globals.series[e].reduce((function(t, n) {
      return t + n;
    }), 0);
  } }, { key: "getStackedSeriesTotalsByGroups", value: function() {
    var e = this, t = this.w, n = [];
    return t.globals.seriesGroups.forEach((function(o) {
      var i = [];
      t.config.series.forEach((function(s, c) {
        o.indexOf(t.globals.seriesNames[c]) > -1 && i.push(c);
      }));
      var a = t.globals.series.map((function(s, c) {
        return i.indexOf(c) === -1 ? c : -1;
      })).filter((function(s) {
        return s !== -1;
      }));
      n.push(e.getStackedSeriesTotals(a));
    })), n;
  } }, { key: "setSeriesYAxisMappings", value: function() {
    var e = this.w.globals, t = this.w.config, n = [], o = [], i = [], a = e.series.length > t.yaxis.length || t.yaxis.some((function(p) {
      return Array.isArray(p.seriesName);
    }));
    t.series.forEach((function(p, h) {
      i.push(h), o.push(null);
    })), t.yaxis.forEach((function(p, h) {
      n[h] = [];
    }));
    var s = [];
    t.yaxis.forEach((function(p, h) {
      var f = !1;
      if (p.seriesName) {
        var m = [];
        Array.isArray(p.seriesName) ? m = p.seriesName : m.push(p.seriesName), m.forEach((function(g) {
          t.series.forEach((function(b, x) {
            if (b.name === g) {
              var v = x;
              h === x || a ? !a || i.indexOf(x) > -1 ? n[h].push([h, x]) : console.warn("Series '" + b.name + "' referenced more than once in what looks like the new style. That is, when using either seriesName: [], or when there are more series than yaxes.") : (n[x].push([x, h]), v = h), f = !0, (v = i.indexOf(v)) !== -1 && i.splice(v, 1);
            }
          }));
        }));
      }
      f || s.push(h);
    })), n = n.map((function(p, h) {
      var f = [];
      return p.forEach((function(m) {
        o[m[1]] = m[0], f.push(m[1]);
      })), f;
    }));
    for (var c = t.yaxis.length - 1, d = 0; d < s.length && (c = s[d], n[c] = [], i); d++) {
      var u = i[0];
      i.shift(), n[c].push(u), o[u] = c;
    }
    i.forEach((function(p) {
      n[c].push(p), o[p] = c;
    })), e.seriesYAxisMap = n.map((function(p) {
      return p;
    })), e.seriesYAxisReverseMap = o.map((function(p) {
      return p;
    })), e.seriesYAxisMap.forEach((function(p, h) {
      p.forEach((function(f) {
        t.series[f] && t.series[f].group === void 0 && (t.series[f].group = "apexcharts-axis-".concat(h.toString()));
      }));
    }));
  } }, { key: "isSeriesNull", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return (e === null ? this.w.config.series.filter((function(t) {
      return t !== null;
    })) : this.w.config.series[e].data.filter((function(t) {
      return t !== null;
    }))).length === 0;
  } }, { key: "seriesHaveSameValues", value: function(e) {
    return this.w.globals.series[e].every((function(t, n, o) {
      return t === o[0];
    }));
  } }, { key: "getCategoryLabels", value: function(e) {
    var t = this.w, n = e.slice();
    return t.config.xaxis.convertedCatToNumeric && (n = e.map((function(o, i) {
      return t.config.xaxis.labels.formatter(o - t.globals.minX + 1);
    }))), n;
  } }, { key: "getLargestSeries", value: function() {
    var e = this.w;
    e.globals.maxValsInArrayIndex = e.globals.series.map((function(t) {
      return t.length;
    })).indexOf(Math.max.apply(Math, e.globals.series.map((function(t) {
      return t.length;
    }))));
  } }, { key: "getLargestMarkerSize", value: function() {
    var e = this.w, t = 0;
    return e.globals.markers.size.forEach((function(n) {
      t = Math.max(t, n);
    })), e.config.markers.discrete && e.config.markers.discrete.length && e.config.markers.discrete.forEach((function(n) {
      t = Math.max(t, n.size);
    })), t > 0 && (e.config.markers.hover.size > 0 ? t = e.config.markers.hover.size : t += e.config.markers.hover.sizeOffset), e.globals.markers.largestSize = t, t;
  } }, { key: "getSeriesTotals", value: function() {
    var e = this.w;
    e.globals.seriesTotals = e.globals.series.map((function(t, n) {
      var o = 0;
      if (Array.isArray(t)) for (var i = 0; i < t.length; i++) o += t[i];
      else o += t;
      return o;
    }));
  } }, { key: "getSeriesTotalsXRange", value: function(e, t) {
    var n = this.w;
    return n.globals.series.map((function(o, i) {
      for (var a = 0, s = 0; s < o.length; s++) n.globals.seriesX[i][s] > e && n.globals.seriesX[i][s] < t && (a += o[s]);
      return a;
    }));
  } }, { key: "getPercentSeries", value: function() {
    var e = this.w;
    e.globals.seriesPercent = e.globals.series.map((function(t, n) {
      var o = [];
      if (Array.isArray(t)) for (var i = 0; i < t.length; i++) {
        var a = e.globals.stackedSeriesTotals[i], s = 0;
        a && (s = 100 * t[i] / a), o.push(s);
      }
      else {
        var c = 100 * t / e.globals.seriesTotals.reduce((function(d, u) {
          return d + u;
        }), 0);
        o.push(c);
      }
      return o;
    }));
  } }, { key: "getCalculatedRatios", value: function() {
    var e, t, n, o = this, i = this.w, a = i.globals, s = [], c = 0, d = [], u = 0.1, p = 0;
    if (a.yRange = [], a.isMultipleYAxis) for (var h = 0; h < a.minYArr.length; h++) a.yRange.push(Math.abs(a.minYArr[h] - a.maxYArr[h])), d.push(0);
    else a.yRange.push(Math.abs(a.minY - a.maxY));
    a.xRange = Math.abs(a.maxX - a.minX), a.zRange = Math.abs(a.maxZ - a.minZ);
    for (var f = 0; f < a.yRange.length; f++) s.push(a.yRange[f] / a.gridHeight);
    if (t = a.xRange / a.gridWidth, e = a.yRange / a.gridWidth, n = a.xRange / a.gridHeight, (c = a.zRange / a.gridHeight * 16) || (c = 1), a.minY !== Number.MIN_VALUE && Math.abs(a.minY) !== 0 && (a.hasNegs = !0), i.globals.seriesYAxisReverseMap.length > 0) {
      var m = function(b, x) {
        var v = i.config.yaxis[i.globals.seriesYAxisReverseMap[x]], y = b < 0 ? -1 : 1;
        return b = Math.abs(b), v.logarithmic && (b = o.getBaseLog(v.logBase, b)), -y * b / s[x];
      };
      if (a.isMultipleYAxis) {
        d = [];
        for (var g = 0; g < s.length; g++) d.push(m(a.minYArr[g], g));
      } else (d = []).push(m(a.minY, 0)), a.minY !== Number.MIN_VALUE && Math.abs(a.minY) !== 0 && (u = -a.minY / e, p = a.minX / t);
    } else (d = []).push(0), u = 0, p = 0;
    return { yRatio: s, invertedYRatio: e, zRatio: c, xRatio: t, invertedXRatio: n, baseLineInvertedY: u, baseLineY: d, baseLineX: p };
  } }, { key: "getLogSeries", value: function(e) {
    var t = this, n = this.w;
    return n.globals.seriesLog = e.map((function(o, i) {
      var a = n.globals.seriesYAxisReverseMap[i];
      return n.config.yaxis[a] && n.config.yaxis[a].logarithmic ? o.map((function(s) {
        return s === null ? null : t.getLogVal(n.config.yaxis[a].logBase, s, i);
      })) : o;
    })), n.globals.invalidLogScale ? e : n.globals.seriesLog;
  } }, { key: "getLogValAtSeriesIndex", value: function(e, t) {
    if (e === null) return null;
    var n = this.w, o = n.globals.seriesYAxisReverseMap[t];
    return n.config.yaxis[o] && n.config.yaxis[o].logarithmic ? this.getLogVal(n.config.yaxis[o].logBase, e, t) : e;
  } }, { key: "getBaseLog", value: function(e, t) {
    return Math.log(t) / Math.log(e);
  } }, { key: "getLogVal", value: function(e, t, n) {
    if (t <= 0) return 0;
    var o = this.w, i = o.globals.minYArr[n] === 0 ? -1 : this.getBaseLog(e, o.globals.minYArr[n]), a = (o.globals.maxYArr[n] === 0 ? 0 : this.getBaseLog(e, o.globals.maxYArr[n])) - i;
    return t < 1 ? t / a : (this.getBaseLog(e, t) - i) / a;
  } }, { key: "getLogYRatios", value: function(e) {
    var t = this, n = this.w, o = this.w.globals;
    return o.yLogRatio = e.slice(), o.logYRange = o.yRange.map((function(i, a) {
      var s = n.globals.seriesYAxisReverseMap[a];
      if (n.config.yaxis[s] && t.w.config.yaxis[s].logarithmic) {
        var c, d = -Number.MAX_VALUE, u = Number.MIN_VALUE;
        return o.seriesLog.forEach((function(p, h) {
          p.forEach((function(f) {
            n.config.yaxis[h] && n.config.yaxis[h].logarithmic && (d = Math.max(f, d), u = Math.min(f, u));
          }));
        })), c = Math.pow(o.yRange[a], Math.abs(u - d) / o.yRange[a]), o.yLogRatio[a] = c / o.gridHeight, c;
      }
    })), o.invalidLogScale ? e.slice() : o.yLogRatio;
  } }, { key: "drawSeriesByGroup", value: function(e, t, n, o) {
    var i = this.w, a = [];
    return e.series.length > 0 && t.forEach((function(s) {
      var c = [], d = [];
      e.i.forEach((function(u, p) {
        i.config.series[u].group === s && (c.push(e.series[p]), d.push(u));
      })), c.length > 0 && a.push(o.draw(c, n, d));
    })), a;
  } }], [{ key: "checkComboSeries", value: function(e, t) {
    var n = !1, o = 0, i = 0;
    return t === void 0 && (t = "line"), e.length && e[0].type !== void 0 && e.forEach((function(a) {
      a.type !== "bar" && a.type !== "column" && a.type !== "candlestick" && a.type !== "boxPlot" || o++, a.type !== void 0 && a.type !== t && i++;
    })), i > 0 && (n = !0), { comboBarCount: o, comboCharts: n };
  } }, { key: "extendArrayProps", value: function(e, t, n) {
    var o, i, a, s, c, d;
    return (o = t) !== null && o !== void 0 && o.yaxis && (t = e.extendYAxis(t, n)), (i = t) !== null && i !== void 0 && i.annotations && (t.annotations.yaxis && (t = e.extendYAxisAnnotations(t)), (a = t) !== null && a !== void 0 && (s = a.annotations) !== null && s !== void 0 && s.xaxis && (t = e.extendXAxisAnnotations(t)), (c = t) !== null && c !== void 0 && (d = c.annotations) !== null && d !== void 0 && d.points && (t = e.extendPointAnnotations(t))), t;
  } }]), r;
})(), Ls = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.annoCtx = e;
  }
  return ve(r, [{ key: "setOrientations", value: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = this.w;
    if (e.label.orientation === "vertical") {
      var o = t !== null ? t : 0, i = n.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(o, "']"));
      if (i !== null) {
        var a = i.getBoundingClientRect();
        i.setAttribute("x", parseFloat(i.getAttribute("x")) - a.height + 4);
        var s = e.label.position === "top" ? a.width : -a.width;
        i.setAttribute("y", parseFloat(i.getAttribute("y")) + s);
        var c = this.annoCtx.graphics.rotateAroundCenter(i), d = c.x, u = c.y;
        i.setAttribute("transform", "rotate(-90 ".concat(d, " ").concat(u, ")"));
      }
    }
  } }, { key: "addBackgroundToAnno", value: function(e, t) {
    var n = this.w;
    if (!e || !t.label.text || !String(t.label.text).trim()) return null;
    var o = n.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(), i = e.getBoundingClientRect(), a = t.label.style.padding, s = a.left, c = a.right, d = a.top, u = a.bottom;
    if (t.label.orientation === "vertical") {
      var p = [s, c, d, u];
      d = p[0], u = p[1], s = p[2], c = p[3];
    }
    var h = i.left - o.left - s, f = i.top - o.top - d, m = this.annoCtx.graphics.drawRect(h - n.globals.barPadForNumericAxis, f, i.width + s + c, i.height + d + u, t.label.borderRadius, t.label.style.background, 1, t.label.borderWidth, t.label.borderColor, 0);
    return t.id && m.node.classList.add(t.id), m;
  } }, { key: "annotationsBackground", value: function() {
    var e = this, t = this.w, n = function(o, i, a) {
      var s = t.globals.dom.baseEl.querySelector(".apexcharts-".concat(a, "-annotations .apexcharts-").concat(a, "-annotation-label[rel='").concat(i, "']"));
      if (s) {
        var c = s.parentNode, d = e.addBackgroundToAnno(s, o);
        d && (c.insertBefore(d.node, s), o.label.mouseEnter && d.node.addEventListener("mouseenter", o.label.mouseEnter.bind(e, o)), o.label.mouseLeave && d.node.addEventListener("mouseleave", o.label.mouseLeave.bind(e, o)), o.label.click && d.node.addEventListener("click", o.label.click.bind(e, o)));
      }
    };
    t.config.annotations.xaxis.forEach((function(o, i) {
      return n(o, i, "xaxis");
    })), t.config.annotations.yaxis.forEach((function(o, i) {
      return n(o, i, "yaxis");
    })), t.config.annotations.points.forEach((function(o, i) {
      return n(o, i, "point");
    }));
  } }, { key: "getY1Y2", value: function(e, t) {
    var n, o = this.w, i = e === "y1" ? t.y : t.y2, a = !1;
    if (this.annoCtx.invertAxis) {
      var s = o.config.xaxis.convertedCatToNumeric ? o.globals.categoryLabels : o.globals.labels, c = s.indexOf(i), d = o.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(".concat(c + 1, ")"));
      n = d ? parseFloat(d.getAttribute("y")) : (o.globals.gridHeight / s.length - 1) * (c + 1) - o.globals.barHeight, t.seriesIndex !== void 0 && o.globals.barHeight && (n -= o.globals.barHeight / 2 * (o.globals.series.length - 1) - o.globals.barHeight * t.seriesIndex);
    } else {
      var u, p = o.globals.seriesYAxisMap[t.yAxisIndex][0], h = o.config.yaxis[t.yAxisIndex].logarithmic ? new Tt(this.annoCtx.ctx).getLogVal(o.config.yaxis[t.yAxisIndex].logBase, i, p) / o.globals.yLogRatio[p] : (i - o.globals.minYArr[p]) / (o.globals.yRange[p] / o.globals.gridHeight);
      n = o.globals.gridHeight - Math.min(Math.max(h, 0), o.globals.gridHeight), a = h > o.globals.gridHeight || h < 0, !t.marker || t.y !== void 0 && t.y !== null || (n = 0), (u = o.config.yaxis[t.yAxisIndex]) !== null && u !== void 0 && u.reversed && (n = h);
    }
    return typeof i == "string" && i.includes("px") && (n = parseFloat(i)), { yP: n, clipped: a };
  } }, { key: "getX1X2", value: function(e, t) {
    var n = this.w, o = e === "x1" ? t.x : t.x2, i = this.annoCtx.invertAxis ? n.globals.minY : n.globals.minX, a = this.annoCtx.invertAxis ? n.globals.maxY : n.globals.maxX, s = this.annoCtx.invertAxis ? n.globals.yRange[0] : n.globals.xRange, c = !1, d = this.annoCtx.inversedReversedAxis ? (a - o) / (s / n.globals.gridWidth) : (o - i) / (s / n.globals.gridWidth);
    return n.config.xaxis.type !== "category" && !n.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || n.globals.dataFormatXNumeric || n.config.chart.sparkline.enabled || (d = this.getStringX(o)), typeof o == "string" && o.includes("px") && (d = parseFloat(o)), o == null && t.marker && (d = n.globals.gridWidth), t.seriesIndex !== void 0 && n.globals.barWidth && !this.annoCtx.invertAxis && (d -= n.globals.barWidth / 2 * (n.globals.series.length - 1) - n.globals.barWidth * t.seriesIndex), typeof d != "number" && (d = 0, c = !0), parseFloat(d.toFixed(10)) > parseFloat(n.globals.gridWidth.toFixed(10)) ? (d = n.globals.gridWidth, c = !0) : d < 0 && (d = 0, c = !0), { x: d, clipped: c };
  } }, { key: "getStringX", value: function(e) {
    var t = this.w, n = e;
    t.config.xaxis.convertedCatToNumeric && t.globals.categoryLabels.length && (e = t.globals.categoryLabels.indexOf(e) + 1);
    var o = t.globals.labels.map((function(a) {
      return Array.isArray(a) ? a.join(" ") : a;
    })).indexOf(e), i = t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(".concat(o + 1, ")"));
    return i && (n = parseFloat(i.getAttribute("x"))), n;
  } }]), r;
})(), PL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.annoCtx = e, this.invertAxis = this.annoCtx.invertAxis, this.helpers = new Ls(this.annoCtx);
  }
  return ve(r, [{ key: "addXaxisAnnotation", value: function(e, t, n) {
    var o, i = this.w, a = this.helpers.getX1X2("x1", e), s = a.x, c = a.clipped, d = !0, u = e.label.text, p = e.strokeDashArray;
    if ($.isNumber(s)) {
      if (e.x2 === null || e.x2 === void 0) {
        if (!c) {
          var h = this.annoCtx.graphics.drawLine(s + e.offsetX, 0 + e.offsetY, s + e.offsetX, i.globals.gridHeight + e.offsetY, e.borderColor, p, e.borderWidth);
          t.appendChild(h.node), e.id && h.node.classList.add(e.id);
        }
      } else {
        var f = this.helpers.getX1X2("x2", e);
        if (o = f.x, d = f.clipped, o < s) {
          var m = s;
          s = o, o = m;
        }
        var g = this.annoCtx.graphics.drawRect(s + e.offsetX, 0 + e.offsetY, o - s, i.globals.gridHeight + e.offsetY, 0, e.fillColor, e.opacity, 1, e.borderColor, p);
        g.node.classList.add("apexcharts-annotation-rect"), g.attr("clip-path", "url(#gridRectMask".concat(i.globals.cuid, ")")), t.appendChild(g.node), e.id && g.node.classList.add(e.id);
      }
      if (!c || !d) {
        var b = this.annoCtx.graphics.getTextRects(u, parseFloat(e.label.style.fontSize)), x = e.label.position === "top" ? 4 : e.label.position === "center" ? i.globals.gridHeight / 2 + (e.label.orientation === "vertical" ? b.width / 2 : 0) : i.globals.gridHeight, v = this.annoCtx.graphics.drawText({ x: s + e.label.offsetX, y: x + e.label.offsetY - (e.label.orientation === "vertical" ? e.label.position === "top" ? b.width / 2 - 12 : -b.width / 2 : 0), text: u, textAnchor: e.label.textAnchor, fontSize: e.label.style.fontSize, fontFamily: e.label.style.fontFamily, fontWeight: e.label.style.fontWeight, foreColor: e.label.style.color, cssClass: "apexcharts-xaxis-annotation-label ".concat(e.label.style.cssClass, " ").concat(e.id ? e.id : "") });
        v.attr({ rel: n }), t.appendChild(v.node), this.annoCtx.helpers.setOrientations(e, n);
      }
    }
  } }, { key: "drawXAxisAnnotations", value: function() {
    var e = this, t = this.w, n = this.annoCtx.graphics.group({ class: "apexcharts-xaxis-annotations" });
    return t.config.annotations.xaxis.map((function(o, i) {
      e.addXaxisAnnotation(o, n.node, i);
    })), n;
  } }]), r;
})(), Dt = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.months31 = [1, 3, 5, 7, 8, 10, 12], this.months30 = [2, 4, 6, 9, 11], this.daysCntOfYear = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  }
  return ve(r, [{ key: "isValidDate", value: function(e) {
    return typeof e != "number" && !isNaN(this.parseDate(e));
  } }, { key: "getTimeStamp", value: function(e) {
    return Date.parse(e) ? this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(e).toISOString().substr(0, 25)).getTime() : new Date(e).getTime() : e;
  } }, { key: "getDate", value: function(e) {
    return this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(e).toUTCString()) : new Date(e);
  } }, { key: "parseDate", value: function(e) {
    var t = Date.parse(e);
    if (!isNaN(t)) return this.getTimeStamp(e);
    var n = Date.parse(e.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
    return n = this.getTimeStamp(n);
  } }, { key: "parseDateWithTimezone", value: function(e) {
    return Date.parse(e.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
  } }, { key: "formatDate", value: function(e, t) {
    var n = this.w.globals.locale, o = this.w.config.xaxis.labels.datetimeUTC, i = ["\0"].concat(Mt(n.months)), a = [""].concat(Mt(n.shortMonths)), s = [""].concat(Mt(n.days)), c = [""].concat(Mt(n.shortDays));
    function d(O, P) {
      var M = O + "";
      for (P = P || 2; M.length < P; ) M = "0" + M;
      return M;
    }
    var u = o ? e.getUTCFullYear() : e.getFullYear();
    t = (t = (t = t.replace(/(^|[^\\])yyyy+/g, "$1" + u)).replace(/(^|[^\\])yy/g, "$1" + u.toString().substr(2, 2))).replace(/(^|[^\\])y/g, "$1" + u);
    var p = (o ? e.getUTCMonth() : e.getMonth()) + 1;
    t = (t = (t = (t = t.replace(/(^|[^\\])MMMM+/g, "$1" + i[0])).replace(/(^|[^\\])MMM/g, "$1" + a[0])).replace(/(^|[^\\])MM/g, "$1" + d(p))).replace(/(^|[^\\])M/g, "$1" + p);
    var h = o ? e.getUTCDate() : e.getDate();
    t = (t = (t = (t = t.replace(/(^|[^\\])dddd+/g, "$1" + s[0])).replace(/(^|[^\\])ddd/g, "$1" + c[0])).replace(/(^|[^\\])dd/g, "$1" + d(h))).replace(/(^|[^\\])d/g, "$1" + h);
    var f = o ? e.getUTCHours() : e.getHours(), m = f > 12 ? f - 12 : f === 0 ? 12 : f;
    t = (t = (t = (t = t.replace(/(^|[^\\])HH+/g, "$1" + d(f))).replace(/(^|[^\\])H/g, "$1" + f)).replace(/(^|[^\\])hh+/g, "$1" + d(m))).replace(/(^|[^\\])h/g, "$1" + m);
    var g = o ? e.getUTCMinutes() : e.getMinutes();
    t = (t = t.replace(/(^|[^\\])mm+/g, "$1" + d(g))).replace(/(^|[^\\])m/g, "$1" + g);
    var b = o ? e.getUTCSeconds() : e.getSeconds();
    t = (t = t.replace(/(^|[^\\])ss+/g, "$1" + d(b))).replace(/(^|[^\\])s/g, "$1" + b);
    var x = o ? e.getUTCMilliseconds() : e.getMilliseconds();
    t = t.replace(/(^|[^\\])fff+/g, "$1" + d(x, 3)), x = Math.round(x / 10), t = t.replace(/(^|[^\\])ff/g, "$1" + d(x)), x = Math.round(x / 10);
    var v = f < 12 ? "AM" : "PM";
    t = (t = (t = t.replace(/(^|[^\\])f/g, "$1" + x)).replace(/(^|[^\\])TT+/g, "$1" + v)).replace(/(^|[^\\])T/g, "$1" + v.charAt(0));
    var y = v.toLowerCase();
    t = (t = t.replace(/(^|[^\\])tt+/g, "$1" + y)).replace(/(^|[^\\])t/g, "$1" + y.charAt(0));
    var C = -e.getTimezoneOffset(), k = o || !C ? "Z" : C > 0 ? "+" : "-";
    if (!o) {
      var T = (C = Math.abs(C)) % 60;
      k += d(Math.floor(C / 60)) + ":" + d(T);
    }
    t = t.replace(/(^|[^\\])K/g, "$1" + k);
    var S = (o ? e.getUTCDay() : e.getDay()) + 1;
    return t = (t = (t = (t = (t = t.replace(new RegExp(s[0], "g"), s[S])).replace(new RegExp(c[0], "g"), c[S])).replace(new RegExp(i[0], "g"), i[p])).replace(new RegExp(a[0], "g"), a[p])).replace(/\\(.)/g, "$1");
  } }, { key: "getTimeUnitsfromTimestamp", value: function(e, t, n) {
    var o = this.w;
    o.config.xaxis.min !== void 0 && (e = o.config.xaxis.min), o.config.xaxis.max !== void 0 && (t = o.config.xaxis.max);
    var i = this.getDate(e), a = this.getDate(t), s = this.formatDate(i, "yyyy MM dd HH mm ss fff").split(" "), c = this.formatDate(a, "yyyy MM dd HH mm ss fff").split(" ");
    return { minMillisecond: parseInt(s[6], 10), maxMillisecond: parseInt(c[6], 10), minSecond: parseInt(s[5], 10), maxSecond: parseInt(c[5], 10), minMinute: parseInt(s[4], 10), maxMinute: parseInt(c[4], 10), minHour: parseInt(s[3], 10), maxHour: parseInt(c[3], 10), minDate: parseInt(s[2], 10), maxDate: parseInt(c[2], 10), minMonth: parseInt(s[1], 10) - 1, maxMonth: parseInt(c[1], 10) - 1, minYear: parseInt(s[0], 10), maxYear: parseInt(c[0], 10) };
  } }, { key: "isLeapYear", value: function(e) {
    return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
  } }, { key: "calculcateLastDaysOfMonth", value: function(e, t, n) {
    return this.determineDaysOfMonths(e, t) - n;
  } }, { key: "determineDaysOfYear", value: function(e) {
    var t = 365;
    return this.isLeapYear(e) && (t = 366), t;
  } }, { key: "determineRemainingDaysOfYear", value: function(e, t, n) {
    var o = this.daysCntOfYear[t] + n;
    return t > 1 && this.isLeapYear() && o++, o;
  } }, { key: "determineDaysOfMonths", value: function(e, t) {
    var n = 30;
    switch (e = $.monthMod(e), !0) {
      case this.months30.indexOf(e) > -1:
        e === 2 && (n = this.isLeapYear(t) ? 29 : 28);
        break;
      case this.months31.indexOf(e) > -1:
      default:
        n = 31;
    }
    return n;
  } }]), r;
})(), la = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.tooltipKeyFormat = "dd MMM";
  }
  return ve(r, [{ key: "xLabelFormat", value: function(e, t, n, o) {
    var i = this.w;
    if (i.config.xaxis.type === "datetime" && i.config.xaxis.labels.formatter === void 0 && i.config.tooltip.x.formatter === void 0) {
      var a = new Dt(this.ctx);
      return a.formatDate(a.getDate(t), i.config.tooltip.x.format);
    }
    return e(t, n, o);
  } }, { key: "defaultGeneralFormatter", value: function(e) {
    return Array.isArray(e) ? e.map((function(t) {
      return t;
    })) : e;
  } }, { key: "defaultYFormatter", value: function(e, t, n) {
    var o = this.w;
    if ($.isNumber(e)) if (o.globals.yValueDecimal !== 0) e = e.toFixed(t.decimalsInFloat !== void 0 ? t.decimalsInFloat : o.globals.yValueDecimal);
    else {
      var i = e.toFixed(0);
      e = e == i ? i : e.toFixed(1);
    }
    return e;
  } }, { key: "setLabelFormatters", value: function() {
    var e = this, t = this.w;
    return t.globals.xaxisTooltipFormatter = function(n) {
      return e.defaultGeneralFormatter(n);
    }, t.globals.ttKeyFormatter = function(n) {
      return e.defaultGeneralFormatter(n);
    }, t.globals.ttZFormatter = function(n) {
      return n;
    }, t.globals.legendFormatter = function(n) {
      return e.defaultGeneralFormatter(n);
    }, t.config.xaxis.labels.formatter !== void 0 ? t.globals.xLabelFormatter = t.config.xaxis.labels.formatter : t.globals.xLabelFormatter = function(n) {
      if ($.isNumber(n)) {
        if (!t.config.xaxis.convertedCatToNumeric && t.config.xaxis.type === "numeric") {
          if ($.isNumber(t.config.xaxis.decimalsInFloat)) return n.toFixed(t.config.xaxis.decimalsInFloat);
          var o = t.globals.maxX - t.globals.minX;
          return o > 0 && o < 100 ? n.toFixed(1) : n.toFixed(0);
        }
        return t.globals.isBarHorizontal && t.globals.maxY - t.globals.minYArr < 4 ? n.toFixed(1) : n.toFixed(0);
      }
      return n;
    }, typeof t.config.tooltip.x.formatter == "function" ? t.globals.ttKeyFormatter = t.config.tooltip.x.formatter : t.globals.ttKeyFormatter = t.globals.xLabelFormatter, typeof t.config.xaxis.tooltip.formatter == "function" && (t.globals.xaxisTooltipFormatter = t.config.xaxis.tooltip.formatter), (Array.isArray(t.config.tooltip.y) || t.config.tooltip.y.formatter !== void 0) && (t.globals.ttVal = t.config.tooltip.y), t.config.tooltip.z.formatter !== void 0 && (t.globals.ttZFormatter = t.config.tooltip.z.formatter), t.config.legend.formatter !== void 0 && (t.globals.legendFormatter = t.config.legend.formatter), t.config.yaxis.forEach((function(n, o) {
      n.labels.formatter !== void 0 ? t.globals.yLabelFormatters[o] = n.labels.formatter : t.globals.yLabelFormatters[o] = function(i) {
        return t.globals.xyCharts ? Array.isArray(i) ? i.map((function(a) {
          return e.defaultYFormatter(a, n, o);
        })) : e.defaultYFormatter(i, n, o) : i;
      };
    })), t.globals;
  } }, { key: "heatmapLabelFormatters", value: function() {
    var e = this.w;
    if (e.config.chart.type === "heatmap") {
      e.globals.yAxisScale[0].result = e.globals.seriesNames.slice();
      var t = e.globals.seriesNames.reduce((function(n, o) {
        return n.length > o.length ? n : o;
      }), 0);
      e.globals.yAxisScale[0].niceMax = t, e.globals.yAxisScale[0].niceMin = t;
    }
  } }]), r;
})(), pn = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "getLabel", value: function(e, t, n, o) {
    var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "12px", s = !(arguments.length > 6 && arguments[6] !== void 0) || arguments[6], c = this.w, d = e[o] === void 0 ? "" : e[o], u = d, p = c.globals.xLabelFormatter, h = c.config.xaxis.labels.formatter, f = !1, m = new la(this.ctx), g = d;
    s && (u = m.xLabelFormat(p, d, g, { i: o, dateFormatter: new Dt(this.ctx).formatDate, w: c }), h !== void 0 && (u = h(d, e[o], { i: o, dateFormatter: new Dt(this.ctx).formatDate, w: c })));
    var b, x;
    t.length > 0 ? (b = t[o].unit, x = null, t.forEach((function(k) {
      k.unit === "month" ? x = "year" : k.unit === "day" ? x = "month" : k.unit === "hour" ? x = "day" : k.unit === "minute" && (x = "hour");
    })), f = x === b, n = t[o].position, u = t[o].value) : c.config.xaxis.type === "datetime" && h === void 0 && (u = ""), u === void 0 && (u = ""), u = Array.isArray(u) ? u : u.toString();
    var v = new ee(this.ctx), y = {};
    y = c.globals.rotateXLabels && s ? v.getTextRects(u, parseInt(a, 10), null, "rotate(".concat(c.config.xaxis.labels.rotate, " 0 0)"), !1) : v.getTextRects(u, parseInt(a, 10));
    var C = !c.config.xaxis.labels.showDuplicates && this.ctx.timeScale;
    return !Array.isArray(u) && (String(u) === "NaN" || i.indexOf(u) >= 0 && C) && (u = ""), { x: n, text: u, textRect: y, isBold: f };
  } }, { key: "checkLabelBasedOnTickamount", value: function(e, t, n) {
    var o = this.w, i = o.config.xaxis.tickAmount;
    return i === "dataPoints" && (i = Math.round(o.globals.gridWidth / 120)), i > n || e % Math.round(n / (i + 1)) == 0 || (t.text = ""), t;
  } }, { key: "checkForOverflowingLabels", value: function(e, t, n, o, i) {
    var a = this.w;
    if (e === 0 && a.globals.skipFirstTimelinelabel && (t.text = ""), e === n - 1 && a.globals.skipLastTimelinelabel && (t.text = ""), a.config.xaxis.labels.hideOverlappingLabels && o.length > 0) {
      var s = i[i.length - 1];
      if (a.config.xaxis.labels.trim && a.config.xaxis.type !== "datetime") return t;
      t.x < s.textRect.width / (a.globals.rotateXLabels ? Math.abs(a.config.xaxis.labels.rotate) / 12 : 1.01) + s.x && (t.text = "");
    }
    return t;
  } }, { key: "checkForReversedLabels", value: function(e, t) {
    var n = this.w;
    return n.config.yaxis[e] && n.config.yaxis[e].reversed && t.reverse(), t;
  } }, { key: "yAxisAllSeriesCollapsed", value: function(e) {
    var t = this.w.globals;
    return !t.seriesYAxisMap[e].some((function(n) {
      return t.collapsedSeriesIndices.indexOf(n) === -1;
    }));
  } }, { key: "translateYAxisIndex", value: function(e) {
    var t = this.w, n = t.globals, o = t.config.yaxis;
    return n.series.length > o.length || o.some((function(i) {
      return Array.isArray(i.seriesName);
    })) ? e : n.seriesYAxisReverseMap[e];
  } }, { key: "isYAxisHidden", value: function(e) {
    var t = this.w, n = t.config.yaxis[e];
    if (!n.show || this.yAxisAllSeriesCollapsed(e)) return !0;
    if (!n.showForNullSeries) {
      var o = t.globals.seriesYAxisMap[e], i = new Tt(this.ctx);
      return o.every((function(a) {
        return i.isSeriesNull(a);
      }));
    }
    return !1;
  } }, { key: "getYAxisForeColor", value: function(e, t) {
    var n = this.w;
    return Array.isArray(e) && n.globals.yAxisScale[t] && this.ctx.theme.pushExtraColors(e, n.globals.yAxisScale[t].result.length, !1), e;
  } }, { key: "drawYAxisTicks", value: function(e, t, n, o, i, a, s) {
    var c = this.w, d = new ee(this.ctx), u = c.globals.translateY + c.config.yaxis[i].labels.offsetY;
    if (c.globals.isBarHorizontal ? u = 0 : c.config.chart.type === "heatmap" && (u += a / 2), o.show && t > 0) {
      c.config.yaxis[i].opposite === !0 && (e += o.width);
      for (var p = t; p >= 0; p--) {
        var h = d.drawLine(e + n.offsetX - o.width + o.offsetX, u + o.offsetY, e + n.offsetX + o.offsetX, u + o.offsetY, o.color);
        s.add(h), u += a;
      }
    }
  } }]), r;
})(), ML = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.annoCtx = e, this.helpers = new Ls(this.annoCtx), this.axesUtils = new pn(this.annoCtx);
  }
  return ve(r, [{ key: "addYaxisAnnotation", value: function(e, t, n) {
    var o, i = this.w, a = e.strokeDashArray, s = this.helpers.getY1Y2("y1", e), c = s.yP, d = s.clipped, u = !0, p = !1, h = e.label.text;
    if (e.y2 === null || e.y2 === void 0) {
      if (!d) {
        p = !0;
        var f = this.annoCtx.graphics.drawLine(0 + e.offsetX, c + e.offsetY, this._getYAxisAnnotationWidth(e), c + e.offsetY, e.borderColor, a, e.borderWidth);
        t.appendChild(f.node), e.id && f.node.classList.add(e.id);
      }
    } else {
      if (o = (s = this.helpers.getY1Y2("y2", e)).yP, u = s.clipped, o > c) {
        var m = c;
        c = o, o = m;
      }
      if (!d || !u) {
        p = !0;
        var g = this.annoCtx.graphics.drawRect(0 + e.offsetX, o + e.offsetY, this._getYAxisAnnotationWidth(e), c - o, 0, e.fillColor, e.opacity, 1, e.borderColor, a);
        g.node.classList.add("apexcharts-annotation-rect"), g.attr("clip-path", "url(#gridRectMask".concat(i.globals.cuid, ")")), t.appendChild(g.node), e.id && g.node.classList.add(e.id);
      }
    }
    if (p) {
      var b = e.label.position === "right" ? i.globals.gridWidth : e.label.position === "center" ? i.globals.gridWidth / 2 : 0, x = this.annoCtx.graphics.drawText({ x: b + e.label.offsetX, y: (o ?? c) + e.label.offsetY - 3, text: h, textAnchor: e.label.textAnchor, fontSize: e.label.style.fontSize, fontFamily: e.label.style.fontFamily, fontWeight: e.label.style.fontWeight, foreColor: e.label.style.color, cssClass: "apexcharts-yaxis-annotation-label ".concat(e.label.style.cssClass, " ").concat(e.id ? e.id : "") });
      x.attr({ rel: n }), t.appendChild(x.node);
    }
  } }, { key: "_getYAxisAnnotationWidth", value: function(e) {
    var t = this.w;
    return t.globals.gridWidth, (e.width.indexOf("%") > -1 ? t.globals.gridWidth * parseInt(e.width, 10) / 100 : parseInt(e.width, 10)) + e.offsetX;
  } }, { key: "drawYAxisAnnotations", value: function() {
    var e = this, t = this.w, n = this.annoCtx.graphics.group({ class: "apexcharts-yaxis-annotations" });
    return t.config.annotations.yaxis.forEach((function(o, i) {
      o.yAxisIndex = e.axesUtils.translateYAxisIndex(o.yAxisIndex), e.axesUtils.isYAxisHidden(o.yAxisIndex) && e.axesUtils.yAxisAllSeriesCollapsed(o.yAxisIndex) || e.addYaxisAnnotation(o, n.node, i);
    })), n;
  } }]), r;
})(), EL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.annoCtx = e, this.helpers = new Ls(this.annoCtx);
  }
  return ve(r, [{ key: "addPointAnnotation", value: function(e, t, n) {
    if (!(this.w.globals.collapsedSeriesIndices.indexOf(e.seriesIndex) > -1)) {
      var o = this.helpers.getX1X2("x1", e), i = o.x, a = o.clipped, s = (o = this.helpers.getY1Y2("y1", e)).yP, c = o.clipped;
      if ($.isNumber(i) && !c && !a) {
        var d = { pSize: e.marker.size, pointStrokeWidth: e.marker.strokeWidth, pointFillColor: e.marker.fillColor, pointStrokeColor: e.marker.strokeColor, shape: e.marker.shape, pRadius: e.marker.radius, class: "apexcharts-point-annotation-marker ".concat(e.marker.cssClass, " ").concat(e.id ? e.id : "") }, u = this.annoCtx.graphics.drawMarker(i + e.marker.offsetX, s + e.marker.offsetY, d);
        t.appendChild(u.node);
        var p = e.label.text ? e.label.text : "", h = this.annoCtx.graphics.drawText({ x: i + e.label.offsetX, y: s + e.label.offsetY - e.marker.size - parseFloat(e.label.style.fontSize) / 1.6, text: p, textAnchor: e.label.textAnchor, fontSize: e.label.style.fontSize, fontFamily: e.label.style.fontFamily, fontWeight: e.label.style.fontWeight, foreColor: e.label.style.color, cssClass: "apexcharts-point-annotation-label ".concat(e.label.style.cssClass, " ").concat(e.id ? e.id : "") });
        if (h.attr({ rel: n }), t.appendChild(h.node), e.customSVG.SVG) {
          var f = this.annoCtx.graphics.group({ class: "apexcharts-point-annotations-custom-svg " + e.customSVG.cssClass });
          f.attr({ transform: "translate(".concat(i + e.customSVG.offsetX, ", ").concat(s + e.customSVG.offsetY, ")") }), f.node.innerHTML = e.customSVG.SVG, t.appendChild(f.node);
        }
        if (e.image.path) {
          var m = e.image.width ? e.image.width : 20, g = e.image.height ? e.image.height : 20;
          u = this.annoCtx.addImage({ x: i + e.image.offsetX - m / 2, y: s + e.image.offsetY - g / 2, width: m, height: g, path: e.image.path, appendTo: ".apexcharts-point-annotations" });
        }
        e.mouseEnter && u.node.addEventListener("mouseenter", e.mouseEnter.bind(this, e)), e.mouseLeave && u.node.addEventListener("mouseleave", e.mouseLeave.bind(this, e)), e.click && u.node.addEventListener("click", e.click.bind(this, e));
      }
    }
  } }, { key: "drawPointAnnotations", value: function() {
    var e = this, t = this.w, n = this.annoCtx.graphics.group({ class: "apexcharts-point-annotations" });
    return t.config.annotations.points.map((function(o, i) {
      e.addPointAnnotation(o, n.node, i);
    })), n;
  } }]), r;
})(), _m = { name: "en", options: { months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], toolbar: { exportToSVG: "Download SVG", exportToPNG: "Download PNG", exportToCSV: "Download CSV", menu: "Menu", selection: "Selection", selectionZoom: "Selection Zoom", zoomIn: "Zoom In", zoomOut: "Zoom Out", pan: "Panning", reset: "Reset Zoom" } } }, An = (function() {
  function r() {
    xe(this, r), this.yAxis = { show: !0, showAlways: !1, showForNullSeries: !0, seriesName: void 0, opposite: !1, reversed: !1, logarithmic: !1, logBase: 10, tickAmount: void 0, stepSize: void 0, forceNiceScale: !1, max: void 0, min: void 0, floating: !1, decimalsInFloat: void 0, labels: { show: !0, showDuplicates: !1, minWidth: 0, maxWidth: 160, offsetX: 0, offsetY: 0, align: void 0, rotate: 0, padding: 20, style: { colors: [], fontSize: "11px", fontWeight: 400, fontFamily: void 0, cssClass: "" }, formatter: void 0 }, axisBorder: { show: !1, color: "#e0e0e0", width: 1, offsetX: 0, offsetY: 0 }, axisTicks: { show: !1, color: "#e0e0e0", width: 6, offsetX: 0, offsetY: 0 }, title: { text: void 0, rotate: -90, offsetY: 0, offsetX: 0, style: { color: void 0, fontSize: "11px", fontWeight: 900, fontFamily: void 0, cssClass: "" } }, tooltip: { enabled: !1, offsetX: 0 }, crosshairs: { show: !0, position: "front", stroke: { color: "#b6b6b6", width: 1, dashArray: 0 } } }, this.pointAnnotation = { id: void 0, x: 0, y: null, yAxisIndex: 0, seriesIndex: void 0, mouseEnter: void 0, mouseLeave: void 0, click: void 0, marker: { size: 4, fillColor: "#fff", strokeWidth: 2, strokeColor: "#333", shape: "circle", offsetX: 0, offsetY: 0, cssClass: "" }, label: { borderColor: "#c2c2c2", borderWidth: 1, borderRadius: 2, text: void 0, textAnchor: "middle", offsetX: 0, offsetY: 0, mouseEnter: void 0, mouseLeave: void 0, click: void 0, style: { background: "#fff", color: void 0, fontSize: "11px", fontFamily: void 0, fontWeight: 400, cssClass: "", padding: { left: 5, right: 5, top: 2, bottom: 2 } } }, customSVG: { SVG: void 0, cssClass: void 0, offsetX: 0, offsetY: 0 }, image: { path: void 0, width: 20, height: 20, offsetX: 0, offsetY: 0 } }, this.yAxisAnnotation = { id: void 0, y: 0, y2: null, strokeDashArray: 1, fillColor: "#c2c2c2", borderColor: "#c2c2c2", borderWidth: 1, opacity: 0.3, offsetX: 0, offsetY: 0, width: "100%", yAxisIndex: 0, label: { borderColor: "#c2c2c2", borderWidth: 1, borderRadius: 2, text: void 0, textAnchor: "end", position: "right", offsetX: 0, offsetY: -3, mouseEnter: void 0, mouseLeave: void 0, click: void 0, style: { background: "#fff", color: void 0, fontSize: "11px", fontFamily: void 0, fontWeight: 400, cssClass: "", padding: { left: 5, right: 5, top: 2, bottom: 2 } } } }, this.xAxisAnnotation = { id: void 0, x: 0, x2: null, strokeDashArray: 1, fillColor: "#c2c2c2", borderColor: "#c2c2c2", borderWidth: 1, opacity: 0.3, offsetX: 0, offsetY: 0, label: { borderColor: "#c2c2c2", borderWidth: 1, borderRadius: 2, text: void 0, textAnchor: "middle", orientation: "vertical", position: "top", offsetX: 0, offsetY: 0, mouseEnter: void 0, mouseLeave: void 0, click: void 0, style: { background: "#fff", color: void 0, fontSize: "11px", fontFamily: void 0, fontWeight: 400, cssClass: "", padding: { left: 5, right: 5, top: 2, bottom: 2 } } } }, this.text = { x: 0, y: 0, text: "", textAnchor: "start", foreColor: void 0, fontSize: "13px", fontFamily: void 0, fontWeight: 400, appendTo: ".apexcharts-annotations", backgroundColor: "transparent", borderColor: "#c2c2c2", borderRadius: 0, borderWidth: 0, paddingLeft: 4, paddingRight: 4, paddingTop: 2, paddingBottom: 2 };
  }
  return ve(r, [{ key: "init", value: function() {
    return { annotations: { yaxis: [this.yAxisAnnotation], xaxis: [this.xAxisAnnotation], points: [this.pointAnnotation], texts: [], images: [], shapes: [] }, chart: { animations: { enabled: !0, speed: 800, animateGradually: { delay: 150, enabled: !0 }, dynamicAnimation: { enabled: !0, speed: 350 } }, background: "", locales: [_m], defaultLocale: "en", dropShadow: { enabled: !1, enabledOnSeries: void 0, top: 2, left: 2, blur: 4, color: "#000", opacity: 0.7 }, events: { animationEnd: void 0, beforeMount: void 0, mounted: void 0, updated: void 0, click: void 0, mouseMove: void 0, mouseLeave: void 0, xAxisLabelClick: void 0, legendClick: void 0, markerClick: void 0, selection: void 0, dataPointSelection: void 0, dataPointMouseEnter: void 0, dataPointMouseLeave: void 0, beforeZoom: void 0, beforeResetZoom: void 0, zoomed: void 0, scrolled: void 0, brushScrolled: void 0 }, foreColor: "#373d3f", fontFamily: "Helvetica, Arial, sans-serif", height: "auto", parentHeightOffset: 15, redrawOnParentResize: !0, redrawOnWindowResize: !0, id: void 0, group: void 0, nonce: void 0, offsetX: 0, offsetY: 0, injectStyleSheet: !0, selection: { enabled: !1, type: "x", fill: { color: "#24292e", opacity: 0.1 }, stroke: { width: 1, color: "#24292e", opacity: 0.4, dashArray: 3 }, xaxis: { min: void 0, max: void 0 }, yaxis: { min: void 0, max: void 0 } }, sparkline: { enabled: !1 }, brush: { enabled: !1, autoScaleYaxis: !0, target: void 0, targets: void 0 }, stacked: !1, stackOnlyBar: !0, stackType: "normal", toolbar: { show: !0, offsetX: 0, offsetY: 0, tools: { download: !0, selection: !0, zoom: !0, zoomin: !0, zoomout: !0, pan: !0, reset: !0, customIcons: [] }, export: { csv: { filename: void 0, columnDelimiter: ",", headerCategory: "category", headerValue: "value", categoryFormatter: void 0, valueFormatter: void 0 }, png: { filename: void 0 }, svg: { filename: void 0 }, scale: void 0, width: void 0 }, autoSelected: "zoom" }, type: "line", width: "100%", zoom: { enabled: !0, type: "x", autoScaleYaxis: !1, allowMouseWheelZoom: !0, zoomedArea: { fill: { color: "#90CAF9", opacity: 0.4 }, stroke: { color: "#0D47A1", opacity: 0.4, width: 1 } } } }, parsing: { x: void 0, y: void 0 }, plotOptions: { line: { isSlopeChart: !1, colors: { threshold: 0, colorAboveThreshold: void 0, colorBelowThreshold: void 0 } }, area: { fillTo: "origin" }, bar: { horizontal: !1, columnWidth: "70%", barHeight: "70%", distributed: !1, borderRadius: 0, borderRadiusApplication: "around", borderRadiusWhenStacked: "last", rangeBarOverlap: !0, rangeBarGroupRows: !1, hideZeroBarsWhenGrouped: !1, isDumbbell: !1, dumbbellColors: void 0, isFunnel: !1, isFunnel3d: !0, colors: { ranges: [], backgroundBarColors: [], backgroundBarOpacity: 1, backgroundBarRadius: 0 }, dataLabels: { position: "top", maxItems: 100, hideOverflowingLabels: !0, orientation: "horizontal", total: { enabled: !1, formatter: void 0, offsetX: 0, offsetY: 0, style: { color: "#373d3f", fontSize: "12px", fontFamily: void 0, fontWeight: 600 } } } }, bubble: { zScaling: !0, minBubbleRadius: void 0, maxBubbleRadius: void 0 }, candlestick: { colors: { upward: "#00B746", downward: "#EF403C" }, wick: { useFillColor: !0 } }, boxPlot: { colors: { upper: "#00E396", lower: "#008FFB" } }, heatmap: { radius: 2, enableShades: !0, shadeIntensity: 0.5, reverseNegativeShade: !1, distributed: !1, useFillColorAsStroke: !1, colorScale: { inverse: !1, ranges: [], min: void 0, max: void 0 } }, treemap: { enableShades: !0, shadeIntensity: 0.5, distributed: !1, reverseNegativeShade: !1, useFillColorAsStroke: !1, borderRadius: 4, dataLabels: { format: "scale" }, colorScale: { inverse: !1, ranges: [], min: void 0, max: void 0 }, seriesTitle: { show: !0, offsetY: 1, offsetX: 1, borderColor: "#000", borderWidth: 1, borderRadius: 2, style: { background: "rgba(0, 0, 0, 0.6)", color: "#fff", fontSize: "12px", fontFamily: void 0, fontWeight: 400, cssClass: "", padding: { left: 6, right: 6, top: 2, bottom: 2 } } } }, radialBar: { inverseOrder: !1, startAngle: 0, endAngle: 360, offsetX: 0, offsetY: 0, hollow: { margin: 5, size: "50%", background: "transparent", image: void 0, imageWidth: 150, imageHeight: 150, imageOffsetX: 0, imageOffsetY: 0, imageClipped: !0, position: "front", dropShadow: { enabled: !1, top: 0, left: 0, blur: 3, color: "#000", opacity: 0.5 } }, track: { show: !0, startAngle: void 0, endAngle: void 0, background: "#f2f2f2", strokeWidth: "97%", opacity: 1, margin: 5, dropShadow: { enabled: !1, top: 0, left: 0, blur: 3, color: "#000", opacity: 0.5 } }, dataLabels: { show: !0, name: { show: !0, fontSize: "16px", fontFamily: void 0, fontWeight: 600, color: void 0, offsetY: 0, formatter: function(e) {
      return e;
    } }, value: { show: !0, fontSize: "14px", fontFamily: void 0, fontWeight: 400, color: void 0, offsetY: 16, formatter: function(e) {
      return e + "%";
    } }, total: { show: !1, label: "Total", fontSize: "16px", fontWeight: 600, fontFamily: void 0, color: void 0, formatter: function(e) {
      return e.globals.seriesTotals.reduce((function(t, n) {
        return t + n;
      }), 0) / e.globals.series.length + "%";
    } } }, barLabels: { enabled: !1, offsetX: 0, offsetY: 0, useSeriesColors: !0, fontFamily: void 0, fontWeight: 600, fontSize: "16px", formatter: function(e) {
      return e;
    }, onClick: void 0 } }, pie: { customScale: 1, offsetX: 0, offsetY: 0, startAngle: 0, endAngle: 360, expandOnClick: !0, dataLabels: { offset: 0, minAngleToShowLabel: 10 }, donut: { size: "65%", background: "transparent", labels: { show: !1, name: { show: !0, fontSize: "16px", fontFamily: void 0, fontWeight: 600, color: void 0, offsetY: -10, formatter: function(e) {
      return e;
    } }, value: { show: !0, fontSize: "20px", fontFamily: void 0, fontWeight: 400, color: void 0, offsetY: 10, formatter: function(e) {
      return e;
    } }, total: { show: !1, showAlways: !1, label: "Total", fontSize: "16px", fontWeight: 400, fontFamily: void 0, color: void 0, formatter: function(e) {
      return e.globals.seriesTotals.reduce((function(t, n) {
        return t + n;
      }), 0);
    } } } } }, polarArea: { rings: { strokeWidth: 1, strokeColor: "#e8e8e8" }, spokes: { strokeWidth: 1, connectorColors: "#e8e8e8" } }, radar: { size: void 0, offsetX: 0, offsetY: 0, polygons: { strokeWidth: 1, strokeColors: "#e8e8e8", connectorColors: "#e8e8e8", fill: { colors: void 0 } } } }, colors: void 0, dataLabels: { enabled: !0, enabledOnSeries: void 0, formatter: function(e) {
      return e !== null ? e : "";
    }, textAnchor: "middle", distributed: !1, offsetX: 0, offsetY: 0, style: { fontSize: "12px", fontFamily: void 0, fontWeight: 600, colors: void 0 }, background: { enabled: !0, foreColor: "#fff", backgroundColor: void 0, borderRadius: 2, padding: 4, opacity: 0.9, borderWidth: 1, borderColor: "#fff", dropShadow: { enabled: !1, top: 1, left: 1, blur: 1, color: "#000", opacity: 0.8 } }, dropShadow: { enabled: !1, top: 1, left: 1, blur: 1, color: "#000", opacity: 0.8 } }, fill: { type: "solid", colors: void 0, opacity: 0.85, gradient: { shade: "dark", type: "horizontal", shadeIntensity: 0.5, gradientToColors: void 0, inverseColors: !0, opacityFrom: 1, opacityTo: 1, stops: [0, 50, 100], colorStops: [] }, image: { src: [], width: void 0, height: void 0 }, pattern: { style: "squares", width: 6, height: 6, strokeWidth: 2 } }, forecastDataPoints: { count: 0, fillOpacity: 0.5, strokeWidth: void 0, dashArray: 4 }, grid: { show: !0, borderColor: "#e0e0e0", strokeDashArray: 0, position: "back", xaxis: { lines: { show: !1 } }, yaxis: { lines: { show: !0 } }, row: { colors: void 0, opacity: 0.5 }, column: { colors: void 0, opacity: 0.5 }, padding: { top: 0, right: 10, bottom: 0, left: 12 } }, labels: [], legend: { show: !0, showForSingleSeries: !1, showForNullSeries: !0, showForZeroSeries: !0, floating: !1, position: "bottom", horizontalAlign: "center", inverseOrder: !1, fontSize: "12px", fontFamily: void 0, fontWeight: 400, width: void 0, height: void 0, formatter: void 0, tooltipHoverFormatter: void 0, offsetX: -20, offsetY: 4, customLegendItems: [], clusterGroupedSeries: !0, clusterGroupedSeriesOrientation: "vertical", labels: { colors: void 0, useSeriesColors: !1 }, markers: { size: 7, fillColors: void 0, strokeWidth: 1, shape: void 0, offsetX: 0, offsetY: 0, customHTML: void 0, onClick: void 0 }, itemMargin: { horizontal: 5, vertical: 4 }, onItemClick: { toggleDataSeries: !0 }, onItemHover: { highlightDataSeries: !0 } }, markers: { discrete: [], size: 0, colors: void 0, strokeColors: "#fff", strokeWidth: 2, strokeOpacity: 0.9, strokeDashArray: 0, fillOpacity: 1, shape: "circle", offsetX: 0, offsetY: 0, showNullDataPoints: !0, onClick: void 0, onDblClick: void 0, hover: { size: void 0, sizeOffset: 3 } }, noData: { text: void 0, align: "center", verticalAlign: "middle", offsetX: 0, offsetY: 0, style: { color: void 0, fontSize: "14px", fontFamily: void 0 } }, responsive: [], series: void 0, states: { hover: { filter: { type: "lighten" } }, active: { allowMultipleDataPointsSelection: !1, filter: { type: "darken" } } }, title: { text: void 0, align: "left", margin: 5, offsetX: 0, offsetY: 0, floating: !1, style: { fontSize: "14px", fontWeight: 900, fontFamily: void 0, color: void 0 } }, subtitle: { text: void 0, align: "left", margin: 5, offsetX: 0, offsetY: 30, floating: !1, style: { fontSize: "12px", fontWeight: 400, fontFamily: void 0, color: void 0 } }, stroke: { show: !0, curve: "smooth", lineCap: "butt", width: 2, colors: void 0, dashArray: 0, fill: { type: "solid", colors: void 0, opacity: 0.85, gradient: { shade: "dark", type: "horizontal", shadeIntensity: 0.5, gradientToColors: void 0, inverseColors: !0, opacityFrom: 1, opacityTo: 1, stops: [0, 50, 100], colorStops: [] } } }, tooltip: { enabled: !0, enabledOnSeries: void 0, shared: !0, hideEmptySeries: !1, followCursor: !1, intersect: !1, inverseOrder: !1, custom: void 0, fillSeriesColor: !1, theme: "light", cssClass: "", style: { fontSize: "12px", fontFamily: void 0 }, onDatasetHover: { highlightDataSeries: !1 }, x: { show: !0, format: "dd MMM", formatter: void 0 }, y: { formatter: void 0, title: { formatter: function(e) {
      return e ? e + ": " : "";
    } } }, z: { formatter: void 0, title: "Size: " }, marker: { show: !0, fillColors: void 0 }, items: { display: "flex" }, fixed: { enabled: !1, position: "topRight", offsetX: 0, offsetY: 0 } }, xaxis: { type: "category", categories: [], convertedCatToNumeric: !1, offsetX: 0, offsetY: 0, overwriteCategories: void 0, labels: { show: !0, rotate: -45, rotateAlways: !1, hideOverlappingLabels: !0, trim: !1, minHeight: void 0, maxHeight: 120, showDuplicates: !0, style: { colors: [], fontSize: "12px", fontWeight: 400, fontFamily: void 0, cssClass: "" }, offsetX: 0, offsetY: 0, format: void 0, formatter: void 0, datetimeUTC: !0, datetimeFormatter: { year: "yyyy", month: "MMM 'yy", day: "dd MMM", hour: "HH:mm", minute: "HH:mm:ss", second: "HH:mm:ss" } }, group: { groups: [], style: { colors: [], fontSize: "12px", fontWeight: 400, fontFamily: void 0, cssClass: "" } }, axisBorder: { show: !0, color: "#e0e0e0", width: "100%", height: 1, offsetX: 0, offsetY: 0 }, axisTicks: { show: !0, color: "#e0e0e0", height: 6, offsetX: 0, offsetY: 0 }, stepSize: void 0, tickAmount: void 0, tickPlacement: "on", min: void 0, max: void 0, range: void 0, floating: !1, decimalsInFloat: void 0, position: "bottom", title: { text: void 0, offsetX: 0, offsetY: 0, style: { color: void 0, fontSize: "12px", fontWeight: 900, fontFamily: void 0, cssClass: "" } }, crosshairs: { show: !0, width: 1, position: "back", opacity: 0.9, stroke: { color: "#b6b6b6", width: 1, dashArray: 3 }, fill: { type: "solid", color: "#B1B9C4", gradient: { colorFrom: "#D8E3F0", colorTo: "#BED1E6", stops: [0, 100], opacityFrom: 0.4, opacityTo: 0.5 } }, dropShadow: { enabled: !1, left: 0, top: 0, blur: 1, opacity: 0.8 } }, tooltip: { enabled: !0, offsetY: 0, formatter: void 0, style: { fontSize: "12px", fontFamily: void 0 } } }, yaxis: this.yAxis, theme: { mode: "", palette: "palette1", monochrome: { enabled: !1, color: "#008FFB", shadeTo: "light", shadeIntensity: 0.65 } } };
  } }]), r;
})(), IL = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.graphics = new ee(this.ctx), this.w.globals.isBarHorizontal && (this.invertAxis = !0), this.helpers = new Ls(this), this.xAxisAnnotations = new PL(this), this.yAxisAnnotations = new ML(this), this.pointsAnnotations = new EL(this), this.w.globals.isBarHorizontal && this.w.config.yaxis[0].reversed && (this.inversedReversedAxis = !0), this.xDivision = this.w.globals.gridWidth / this.w.globals.dataPoints;
  }
  return ve(r, [{ key: "drawAxesAnnotations", value: function() {
    var e = this.w;
    if (e.globals.axisCharts && e.globals.dataPoints) {
      for (var t = this.yAxisAnnotations.drawYAxisAnnotations(), n = this.xAxisAnnotations.drawXAxisAnnotations(), o = this.pointsAnnotations.drawPointAnnotations(), i = e.config.chart.animations.enabled, a = [t, n, o], s = [n.node, t.node, o.node], c = 0; c < 3; c++) e.globals.dom.elGraphical.add(a[c]), !i || e.globals.resized || e.globals.dataChanged || e.config.chart.type !== "scatter" && e.config.chart.type !== "bubble" && e.globals.dataPoints > 1 && s[c].classList.add("apexcharts-element-hidden"), e.globals.delayedElements.push({ el: s[c], index: 0 });
      this.helpers.annotationsBackground();
    }
  } }, { key: "drawImageAnnos", value: function() {
    var e = this;
    this.w.config.annotations.images.map((function(t, n) {
      e.addImage(t, n);
    }));
  } }, { key: "drawTextAnnos", value: function() {
    var e = this;
    this.w.config.annotations.texts.map((function(t, n) {
      e.addText(t, n);
    }));
  } }, { key: "addXaxisAnnotation", value: function(e, t, n) {
    this.xAxisAnnotations.addXaxisAnnotation(e, t, n);
  } }, { key: "addYaxisAnnotation", value: function(e, t, n) {
    this.yAxisAnnotations.addYaxisAnnotation(e, t, n);
  } }, { key: "addPointAnnotation", value: function(e, t, n) {
    this.pointsAnnotations.addPointAnnotation(e, t, n);
  } }, { key: "addText", value: function(e, t) {
    var n = e.x, o = e.y, i = e.text, a = e.textAnchor, s = e.foreColor, c = e.fontSize, d = e.fontFamily, u = e.fontWeight, p = e.cssClass, h = e.backgroundColor, f = e.borderWidth, m = e.strokeDashArray, g = e.borderRadius, b = e.borderColor, x = e.appendTo, v = x === void 0 ? ".apexcharts-svg" : x, y = e.paddingLeft, C = y === void 0 ? 4 : y, k = e.paddingRight, T = k === void 0 ? 4 : k, S = e.paddingBottom, O = S === void 0 ? 2 : S, P = e.paddingTop, M = P === void 0 ? 2 : P, I = this.w, E = this.graphics.drawText({ x: n, y: o, text: i, textAnchor: a || "start", fontSize: c || "12px", fontWeight: u || "regular", fontFamily: d || I.config.chart.fontFamily, foreColor: s || I.config.chart.foreColor, cssClass: p }), N = I.globals.dom.baseEl.querySelector(v);
    N && N.appendChild(E.node);
    var L = E.bbox();
    if (i) {
      var z = this.graphics.drawRect(L.x - C, L.y - M, L.width + C + T, L.height + O + M, g, h || "transparent", 1, f, b, m);
      N.insertBefore(z.node, E.node);
    }
  } }, { key: "addImage", value: function(e, t) {
    var n = this.w, o = e.path, i = e.x, a = i === void 0 ? 0 : i, s = e.y, c = s === void 0 ? 0 : s, d = e.width, u = d === void 0 ? 20 : d, p = e.height, h = p === void 0 ? 20 : p, f = e.appendTo, m = f === void 0 ? ".apexcharts-svg" : f, g = n.globals.dom.Paper.image(o);
    g.size(u, h).move(a, c);
    var b = n.globals.dom.baseEl.querySelector(m);
    return b && b.appendChild(g.node), g;
  } }, { key: "addXaxisAnnotationExternal", value: function(e, t, n) {
    return this.addAnnotationExternal({ params: e, pushToMemory: t, context: n, type: "xaxis", contextMethod: n.addXaxisAnnotation }), n;
  } }, { key: "addYaxisAnnotationExternal", value: function(e, t, n) {
    return this.addAnnotationExternal({ params: e, pushToMemory: t, context: n, type: "yaxis", contextMethod: n.addYaxisAnnotation }), n;
  } }, { key: "addPointAnnotationExternal", value: function(e, t, n) {
    return this.invertAxis === void 0 && (this.invertAxis = n.w.globals.isBarHorizontal), this.addAnnotationExternal({ params: e, pushToMemory: t, context: n, type: "point", contextMethod: n.addPointAnnotation }), n;
  } }, { key: "addAnnotationExternal", value: function(e) {
    var t = e.params, n = e.pushToMemory, o = e.context, i = e.type, a = e.contextMethod, s = o, c = s.w, d = c.globals.dom.baseEl.querySelector(".apexcharts-".concat(i, "-annotations")), u = d.childNodes.length + 1, p = new An(), h = Object.assign({}, i === "xaxis" ? p.xAxisAnnotation : i === "yaxis" ? p.yAxisAnnotation : p.pointAnnotation), f = $.extend(h, t);
    switch (i) {
      case "xaxis":
        this.addXaxisAnnotation(f, d, u);
        break;
      case "yaxis":
        this.addYaxisAnnotation(f, d, u);
        break;
      case "point":
        this.addPointAnnotation(f, d, u);
    }
    var m = c.globals.dom.baseEl.querySelector(".apexcharts-".concat(i, "-annotations .apexcharts-").concat(i, "-annotation-label[rel='").concat(u, "']")), g = this.helpers.addBackgroundToAnno(m, f);
    return g && d.insertBefore(g.node, m), n && c.globals.memory.methodsToExec.push({ context: s, id: f.id ? f.id : $.randomId(), method: a, label: "addAnnotation", params: t }), o;
  } }, { key: "clearAnnotations", value: function(e) {
    for (var t = e.w, n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations"), o = t.globals.memory.methodsToExec.length - 1; o >= 0; o--) t.globals.memory.methodsToExec[o].label !== "addText" && t.globals.memory.methodsToExec[o].label !== "addAnnotation" || t.globals.memory.methodsToExec.splice(o, 1);
    n = $.listToArray(n), Array.prototype.forEach.call(n, (function(i) {
      for (; i.firstChild; ) i.removeChild(i.firstChild);
    }));
  } }, { key: "removeAnnotation", value: function(e, t) {
    var n = e.w, o = n.globals.dom.baseEl.querySelectorAll(".".concat(t));
    o && (n.globals.memory.methodsToExec.map((function(i, a) {
      i.id === t && n.globals.memory.methodsToExec.splice(a, 1);
    })), Object.keys(n.config.annotations).forEach((function(i) {
      var a = n.config.annotations[i];
      Array.isArray(a) && (n.config.annotations[i] = a.filter((function(s) {
        return s.id !== t;
      })));
    })), Array.prototype.forEach.call(o, (function(i) {
      i.parentElement.removeChild(i);
    })));
  } }]), r;
})(), kl = function(r) {
  var e, t = r.isTimeline, n = r.ctx, o = r.seriesIndex, i = r.dataPointIndex, a = r.y1, s = r.y2, c = r.w, d = c.globals.seriesRangeStart[o][i], u = c.globals.seriesRangeEnd[o][i], p = c.globals.labels[i], h = c.config.series[o].name ? c.config.series[o].name : "", f = c.globals.ttKeyFormatter, m = c.config.tooltip.y.title.formatter, g = { w: c, seriesIndex: o, dataPointIndex: i, start: d, end: u };
  typeof m == "function" && (h = m(h, g)), (e = c.config.series[o].data[i]) !== null && e !== void 0 && e.x && (p = c.config.series[o].data[i].x), t || c.config.xaxis.type === "datetime" && (p = new la(n).xLabelFormat(c.globals.ttKeyFormatter, p, p, { i: void 0, dateFormatter: new Dt(n).formatDate, w: c })), typeof f == "function" && (p = f(p, g)), Number.isFinite(a) && Number.isFinite(s) && (d = a, u = s);
  var b = "", x = "", v = c.globals.colors[o];
  if (c.config.tooltip.x.formatter === void 0) if (c.config.xaxis.type === "datetime") {
    var y = new Dt(n);
    b = y.formatDate(y.getDate(d), c.config.tooltip.x.format), x = y.formatDate(y.getDate(u), c.config.tooltip.x.format);
  } else b = d, x = u;
  else b = c.config.tooltip.x.formatter(d), x = c.config.tooltip.x.formatter(u);
  return { start: d, end: u, startVal: b, endVal: x, ylabel: p, color: v, seriesName: h };
}, Sl = function(r) {
  var e = r.color, t = r.seriesName, n = r.ylabel, o = r.start, i = r.end, a = r.seriesIndex, s = r.dataPointIndex, c = r.ctx.tooltip.tooltipLabels.getFormatters(a);
  o = c.yLbFormatter(o), i = c.yLbFormatter(i);
  var d = c.yLbFormatter(r.w.globals.series[a][s]), u = `<span class="value start-value">
  `.concat(o, `
  </span> <span class="separator">-</span> <span class="value end-value">
  `).concat(i, `
  </span>`);
  return '<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: ' + e + '">' + (t || "") + '</span></div><div> <span class="category">' + n + ": </span> " + (r.w.globals.comboCharts ? r.w.config.series[a].type === "rangeArea" || r.w.config.series[a].type === "rangeBar" ? u : "<span>".concat(d, "</span>") : u) + " </div></div>";
}, Xi = (function() {
  function r(e) {
    xe(this, r), this.opts = e;
  }
  return ve(r, [{ key: "hideYAxis", value: function() {
    this.opts.yaxis[0].show = !1, this.opts.yaxis[0].title.text = "", this.opts.yaxis[0].axisBorder.show = !1, this.opts.yaxis[0].axisTicks.show = !1, this.opts.yaxis[0].floating = !0;
  } }, { key: "line", value: function() {
    return { dataLabels: { enabled: !1 }, stroke: { width: 5, curve: "straight" }, markers: { size: 0, hover: { sizeOffset: 6 } }, xaxis: { crosshairs: { width: 1 } } };
  } }, { key: "sparkline", value: function(e) {
    return this.hideYAxis(), $.extend(e, { grid: { show: !1, padding: { left: 0, right: 0, top: 0, bottom: 0 } }, legend: { show: !1 }, xaxis: { labels: { show: !1 }, tooltip: { enabled: !1 }, axisBorder: { show: !1 }, axisTicks: { show: !1 } }, chart: { toolbar: { show: !1 }, zoom: { enabled: !1 } }, dataLabels: { enabled: !1 } });
  } }, { key: "slope", value: function() {
    return this.hideYAxis(), { chart: { toolbar: { show: !1 }, zoom: { enabled: !1 } }, dataLabels: { enabled: !0, formatter: function(e, t) {
      var n = t.w.config.series[t.seriesIndex].name;
      return e !== null ? n + ": " + e : "";
    }, background: { enabled: !1 }, offsetX: -5 }, grid: { xaxis: { lines: { show: !0 } }, yaxis: { lines: { show: !1 } } }, xaxis: { position: "top", labels: { style: { fontSize: 14, fontWeight: 900 } }, tooltip: { enabled: !1 }, crosshairs: { show: !1 } }, markers: { size: 8, hover: { sizeOffset: 1 } }, legend: { show: !1 }, tooltip: { shared: !1, intersect: !0, followCursor: !0 }, stroke: { width: 5, curve: "straight" } };
  } }, { key: "bar", value: function() {
    return { chart: { stacked: !1 }, plotOptions: { bar: { dataLabels: { position: "center" } } }, dataLabels: { style: { colors: ["#fff"] }, background: { enabled: !1 } }, stroke: { width: 0, lineCap: "square" }, fill: { opacity: 0.85 }, legend: { markers: { shape: "square" } }, tooltip: { shared: !1, intersect: !0 }, xaxis: { tooltip: { enabled: !1 }, tickPlacement: "between", crosshairs: { width: "barWidth", position: "back", fill: { type: "gradient" }, dropShadow: { enabled: !1 }, stroke: { width: 0 } } } };
  } }, { key: "funnel", value: function() {
    return this.hideYAxis(), ie(ie({}, this.bar()), {}, { chart: { animations: { speed: 800, animateGradually: { enabled: !1 } } }, plotOptions: { bar: { horizontal: !0, borderRadiusApplication: "around", borderRadius: 0, dataLabels: { position: "center" } } }, grid: { show: !1, padding: { left: 0, right: 0 } }, xaxis: { labels: { show: !1 }, tooltip: { enabled: !1 }, axisBorder: { show: !1 }, axisTicks: { show: !1 } } });
  } }, { key: "candlestick", value: function() {
    var e = this;
    return { stroke: { width: 1 }, fill: { opacity: 1 }, dataLabels: { enabled: !1 }, tooltip: { shared: !0, custom: function(t) {
      var n = t.seriesIndex, o = t.dataPointIndex, i = t.w;
      return e._getBoxTooltip(i, n, o, ["Open", "High", "", "Low", "Close"], "candlestick");
    } }, states: { active: { filter: { type: "none" } } }, xaxis: { crosshairs: { width: 1 } } };
  } }, { key: "boxPlot", value: function() {
    var e = this;
    return { chart: { animations: { dynamicAnimation: { enabled: !1 } } }, stroke: { width: 1, colors: ["#24292e"] }, dataLabels: { enabled: !1 }, tooltip: { shared: !0, custom: function(t) {
      var n = t.seriesIndex, o = t.dataPointIndex, i = t.w;
      return e._getBoxTooltip(i, n, o, ["Minimum", "Q1", "Median", "Q3", "Maximum"], "boxPlot");
    } }, markers: { size: 7, strokeWidth: 1, strokeColors: "#111" }, xaxis: { crosshairs: { width: 1 } } };
  } }, { key: "rangeBar", value: function() {
    return { chart: { animations: { animateGradually: !1 } }, stroke: { width: 0, lineCap: "square" }, plotOptions: { bar: { borderRadius: 0, dataLabels: { position: "center" } } }, dataLabels: { enabled: !1, formatter: function(e, t) {
      t.ctx;
      var n = t.seriesIndex, o = t.dataPointIndex, i = t.w, a = function() {
        var s = i.globals.seriesRangeStart[n][o];
        return i.globals.seriesRangeEnd[n][o] - s;
      };
      return i.globals.comboCharts ? i.config.series[n].type === "rangeBar" || i.config.series[n].type === "rangeArea" ? a() : e : a();
    }, background: { enabled: !1 }, style: { colors: ["#fff"] } }, markers: { size: 10 }, tooltip: { shared: !1, followCursor: !0, custom: function(e) {
      return e.w.config.plotOptions && e.w.config.plotOptions.bar && e.w.config.plotOptions.bar.horizontal ? (function(t) {
        var n = kl(ie(ie({}, t), {}, { isTimeline: !0 })), o = n.color, i = n.seriesName, a = n.ylabel, s = n.startVal, c = n.endVal;
        return Sl(ie(ie({}, t), {}, { color: o, seriesName: i, ylabel: a, start: s, end: c }));
      })(e) : (function(t) {
        var n = kl(t), o = n.color, i = n.seriesName, a = n.ylabel, s = n.start, c = n.end;
        return Sl(ie(ie({}, t), {}, { color: o, seriesName: i, ylabel: a, start: s, end: c }));
      })(e);
    } }, xaxis: { tickPlacement: "between", tooltip: { enabled: !1 }, crosshairs: { stroke: { width: 0 } } } };
  } }, { key: "dumbbell", value: function(e) {
    var t, n;
    return (t = e.plotOptions.bar) !== null && t !== void 0 && t.barHeight || (e.plotOptions.bar.barHeight = 2), (n = e.plotOptions.bar) !== null && n !== void 0 && n.columnWidth || (e.plotOptions.bar.columnWidth = 2), e;
  } }, { key: "area", value: function() {
    return { stroke: { width: 4, fill: { type: "solid", gradient: { inverseColors: !1, shade: "light", type: "vertical", opacityFrom: 0.65, opacityTo: 0.5, stops: [0, 100, 100] } } }, fill: { type: "gradient", gradient: { inverseColors: !1, shade: "light", type: "vertical", opacityFrom: 0.65, opacityTo: 0.5, stops: [0, 100, 100] } }, markers: { size: 0, hover: { sizeOffset: 6 } }, tooltip: { followCursor: !1 } };
  } }, { key: "rangeArea", value: function() {
    return { stroke: { curve: "straight", width: 0 }, fill: { type: "solid", opacity: 0.6 }, markers: { size: 0 }, states: { hover: { filter: { type: "none" } }, active: { filter: { type: "none" } } }, tooltip: { intersect: !1, shared: !0, followCursor: !0, custom: function(e) {
      return (function(t) {
        var n = kl(t), o = n.color, i = n.seriesName, a = n.ylabel, s = n.start, c = n.end;
        return Sl(ie(ie({}, t), {}, { color: o, seriesName: i, ylabel: a, start: s, end: c }));
      })(e);
    } } };
  } }, { key: "brush", value: function(e) {
    return $.extend(e, { chart: { toolbar: { autoSelected: "selection", show: !1 }, zoom: { enabled: !1 } }, dataLabels: { enabled: !1 }, stroke: { width: 1 }, tooltip: { enabled: !1 }, xaxis: { tooltip: { enabled: !1 } } });
  } }, { key: "stacked100", value: function(e) {
    e.dataLabels = e.dataLabels || {}, e.dataLabels.formatter = e.dataLabels.formatter || void 0;
    var t = e.dataLabels.formatter;
    return e.yaxis.forEach((function(n, o) {
      e.yaxis[o].min = 0, e.yaxis[o].max = 100;
    })), e.chart.type === "bar" && (e.dataLabels.formatter = t || function(n) {
      return typeof n == "number" && n ? n.toFixed(0) + "%" : n;
    }), e;
  } }, { key: "stackedBars", value: function() {
    var e = this.bar();
    return ie(ie({}, e), {}, { plotOptions: ie(ie({}, e.plotOptions), {}, { bar: ie(ie({}, e.plotOptions.bar), {}, { borderRadiusApplication: "end", borderRadiusWhenStacked: "last" }) }) });
  } }, { key: "convertCatToNumeric", value: function(e) {
    return e.xaxis.convertedCatToNumeric = !0, e;
  } }, { key: "convertCatToNumericXaxis", value: function(e, t, n) {
    e.xaxis.type = "numeric", e.xaxis.labels = e.xaxis.labels || {}, e.xaxis.labels.formatter = e.xaxis.labels.formatter || function(a) {
      return $.isNumber(a) ? Math.floor(a) : a;
    };
    var o = e.xaxis.labels.formatter, i = e.xaxis.categories && e.xaxis.categories.length ? e.xaxis.categories : e.labels;
    return n && n.length && (i = n.map((function(a) {
      return Array.isArray(a) ? a : String(a);
    }))), i && i.length && (e.xaxis.labels.formatter = function(a) {
      return $.isNumber(a) ? o(i[Math.floor(a) - 1]) : o(a);
    }), e.xaxis.categories = [], e.labels = [], e.xaxis.tickAmount = e.xaxis.tickAmount || "dataPoints", e;
  } }, { key: "bubble", value: function() {
    return { dataLabels: { style: { colors: ["#fff"] } }, tooltip: { shared: !1, intersect: !0 }, xaxis: { crosshairs: { width: 0 } }, fill: { type: "solid", gradient: { shade: "light", inverse: !0, shadeIntensity: 0.55, opacityFrom: 0.4, opacityTo: 0.8 } } };
  } }, { key: "scatter", value: function() {
    return { dataLabels: { enabled: !1 }, tooltip: { shared: !1, intersect: !0 }, markers: { size: 6, strokeWidth: 1, hover: { sizeOffset: 2 } } };
  } }, { key: "heatmap", value: function() {
    return { chart: { stacked: !1 }, fill: { opacity: 1 }, dataLabels: { style: { colors: ["#fff"] } }, stroke: { colors: ["#fff"] }, tooltip: { followCursor: !0, marker: { show: !1 }, x: { show: !1 } }, legend: { position: "top", markers: { shape: "square" } }, grid: { padding: { right: 20 } } };
  } }, { key: "treemap", value: function() {
    return { chart: { zoom: { enabled: !1 } }, dataLabels: { style: { fontSize: 14, fontWeight: 600, colors: ["#fff"] } }, stroke: { show: !0, width: 2, colors: ["#fff"] }, legend: { show: !1 }, fill: { opacity: 1, gradient: { stops: [0, 100] } }, tooltip: { followCursor: !0, x: { show: !1 } }, grid: { padding: { left: 0, right: 0 } }, xaxis: { crosshairs: { show: !1 }, tooltip: { enabled: !1 } } };
  } }, { key: "pie", value: function() {
    return { chart: { toolbar: { show: !1 } }, plotOptions: { pie: { donut: { labels: { show: !1 } } } }, dataLabels: { formatter: function(e) {
      return e.toFixed(1) + "%";
    }, style: { colors: ["#fff"] }, background: { enabled: !1 }, dropShadow: { enabled: !0 } }, stroke: { colors: ["#fff"] }, fill: { opacity: 1, gradient: { shade: "light", stops: [0, 100] } }, tooltip: { theme: "dark", fillSeriesColor: !0 }, legend: { position: "right" }, grid: { padding: { left: 0, right: 0, top: 0, bottom: 0 } } };
  } }, { key: "donut", value: function() {
    return { chart: { toolbar: { show: !1 } }, dataLabels: { formatter: function(e) {
      return e.toFixed(1) + "%";
    }, style: { colors: ["#fff"] }, background: { enabled: !1 }, dropShadow: { enabled: !0 } }, stroke: { colors: ["#fff"] }, fill: { opacity: 1, gradient: { shade: "light", shadeIntensity: 0.35, stops: [80, 100], opacityFrom: 1, opacityTo: 1 } }, tooltip: { theme: "dark", fillSeriesColor: !0 }, legend: { position: "right" }, grid: { padding: { left: 0, right: 0, top: 0, bottom: 0 } } };
  } }, { key: "polarArea", value: function() {
    return { chart: { toolbar: { show: !1 } }, dataLabels: { formatter: function(e) {
      return e.toFixed(1) + "%";
    }, enabled: !1 }, stroke: { show: !0, width: 2 }, fill: { opacity: 0.7 }, tooltip: { theme: "dark", fillSeriesColor: !0 }, legend: { position: "right" }, grid: { padding: { left: 0, right: 0, top: 0, bottom: 0 } } };
  } }, { key: "radar", value: function() {
    return this.opts.yaxis[0].labels.offsetY = this.opts.yaxis[0].labels.offsetY ? this.opts.yaxis[0].labels.offsetY : 6, { dataLabels: { enabled: !1, style: { fontSize: "11px" } }, stroke: { width: 2 }, markers: { size: 5, strokeWidth: 1, strokeOpacity: 1 }, fill: { opacity: 0.2 }, tooltip: { shared: !1, intersect: !0, followCursor: !0 }, grid: { show: !1, padding: { left: 0, right: 0, top: 0, bottom: 0 } }, xaxis: { labels: { formatter: function(e) {
      return e;
    }, style: { colors: ["#a8a8a8"], fontSize: "11px" } }, tooltip: { enabled: !1 }, crosshairs: { show: !1 } } };
  } }, { key: "radialBar", value: function() {
    return { chart: { animations: { dynamicAnimation: { enabled: !0, speed: 800 } }, toolbar: { show: !1 } }, fill: { gradient: { shade: "dark", shadeIntensity: 0.4, inverseColors: !1, type: "diagonal2", opacityFrom: 1, opacityTo: 1, stops: [70, 98, 100] } }, legend: { show: !1, position: "right" }, tooltip: { enabled: !1, fillSeriesColor: !0 }, grid: { padding: { left: 0, right: 0, top: 0, bottom: 0 } } };
  } }, { key: "_getBoxTooltip", value: function(e, t, n, o, i) {
    var a = e.globals.seriesCandleO[t][n], s = e.globals.seriesCandleH[t][n], c = e.globals.seriesCandleM[t][n], d = e.globals.seriesCandleL[t][n], u = e.globals.seriesCandleC[t][n];
    return e.config.series[t].type && e.config.series[t].type !== i ? `<div class="apexcharts-custom-tooltip">
          `.concat(e.config.series[t].name ? e.config.series[t].name : "series-" + (t + 1), ": <strong>").concat(e.globals.series[t][n], `</strong>
        </div>`) : '<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(e.config.chart.type, '">') + "<div>".concat(o[0], ': <span class="value">') + a + "</span></div>" + "<div>".concat(o[1], ': <span class="value">') + s + "</span></div>" + (c ? "<div>".concat(o[2], ': <span class="value">') + c + "</span></div>" : "") + "<div>".concat(o[3], ': <span class="value">') + d + "</span></div>" + "<div>".concat(o[4], ': <span class="value">') + u + "</span></div></div>";
  } }]), r;
})(), Vi = (function() {
  function r(e) {
    xe(this, r), this.opts = e;
  }
  return ve(r, [{ key: "init", value: function(e) {
    var t = e.responsiveOverride, n = this.opts, o = new An(), i = new Xi(n);
    this.chartType = n.chart.type, n = this.extendYAxis(n), n = this.extendAnnotations(n);
    var a = o.init(), s = {};
    if (n && Vt(n) === "object") {
      var c, d, u, p, h, f, m, g, b, x, v = {};
      v = ["line", "area", "bar", "candlestick", "boxPlot", "rangeBar", "rangeArea", "bubble", "scatter", "heatmap", "treemap", "pie", "polarArea", "donut", "radar", "radialBar"].indexOf(n.chart.type) !== -1 ? i[n.chart.type]() : i.line(), (c = n.plotOptions) !== null && c !== void 0 && (d = c.bar) !== null && d !== void 0 && d.isFunnel && (v = i.funnel()), n.chart.stacked && n.chart.type === "bar" && (v = i.stackedBars()), (u = n.chart.brush) !== null && u !== void 0 && u.enabled && (v = i.brush(v)), (p = n.plotOptions) !== null && p !== void 0 && (h = p.line) !== null && h !== void 0 && h.isSlopeChart && (v = i.slope()), n.chart.stacked && n.chart.stackType === "100%" && (n = i.stacked100(n)), (f = n.plotOptions) !== null && f !== void 0 && (m = f.bar) !== null && m !== void 0 && m.isDumbbell && (n = i.dumbbell(n)), this.checkForDarkTheme(window.Apex), this.checkForDarkTheme(n), n.xaxis = n.xaxis || window.Apex.xaxis || {}, t || (n.xaxis.convertedCatToNumeric = !1), ((g = (n = this.checkForCatToNumericXAxis(this.chartType, v, n)).chart.sparkline) !== null && g !== void 0 && g.enabled || (b = window.Apex.chart) !== null && b !== void 0 && (x = b.sparkline) !== null && x !== void 0 && x.enabled) && (v = i.sparkline(v)), s = $.extend(a, v);
    }
    var y = $.extend(s, window.Apex);
    return a = $.extend(y, n), a = this.handleUserInputErrors(a);
  } }, { key: "checkForCatToNumericXAxis", value: function(e, t, n) {
    var o, i, a = new Xi(n), s = (e === "bar" || e === "boxPlot") && ((o = n.plotOptions) === null || o === void 0 || (i = o.bar) === null || i === void 0 ? void 0 : i.horizontal), c = e === "pie" || e === "polarArea" || e === "donut" || e === "radar" || e === "radialBar" || e === "heatmap", d = n.xaxis.type !== "datetime" && n.xaxis.type !== "numeric", u = n.xaxis.tickPlacement ? n.xaxis.tickPlacement : t.xaxis && t.xaxis.tickPlacement;
    return s || c || !d || u === "between" || (n = a.convertCatToNumeric(n)), n;
  } }, { key: "extendYAxis", value: function(e, t) {
    var n = new An();
    (e.yaxis === void 0 || !e.yaxis || Array.isArray(e.yaxis) && e.yaxis.length === 0) && (e.yaxis = {}), e.yaxis.constructor !== Array && window.Apex.yaxis && window.Apex.yaxis.constructor !== Array && (e.yaxis = $.extend(e.yaxis, window.Apex.yaxis)), e.yaxis.constructor !== Array ? e.yaxis = [$.extend(n.yAxis, e.yaxis)] : e.yaxis = $.extendArray(e.yaxis, n.yAxis);
    var o = !1;
    e.yaxis.forEach((function(a) {
      a.logarithmic && (o = !0);
    }));
    var i = e.series;
    return t && !i && (i = t.config.series), o && i.length !== e.yaxis.length && i.length && (e.yaxis = i.map((function(a, s) {
      if (a.name || (i[s].name = "series-".concat(s + 1)), e.yaxis[s]) return e.yaxis[s].seriesName = i[s].name, e.yaxis[s];
      var c = $.extend(n.yAxis, e.yaxis[0]);
      return c.show = !1, c;
    }))), o && i.length > 1 && i.length !== e.yaxis.length && console.warn("A multi-series logarithmic chart should have equal number of series and y-axes"), e;
  } }, { key: "extendAnnotations", value: function(e) {
    return e.annotations === void 0 && (e.annotations = {}, e.annotations.yaxis = [], e.annotations.xaxis = [], e.annotations.points = []), e = this.extendYAxisAnnotations(e), e = this.extendXAxisAnnotations(e), e = this.extendPointAnnotations(e);
  } }, { key: "extendYAxisAnnotations", value: function(e) {
    var t = new An();
    return e.annotations.yaxis = $.extendArray(e.annotations.yaxis !== void 0 ? e.annotations.yaxis : [], t.yAxisAnnotation), e;
  } }, { key: "extendXAxisAnnotations", value: function(e) {
    var t = new An();
    return e.annotations.xaxis = $.extendArray(e.annotations.xaxis !== void 0 ? e.annotations.xaxis : [], t.xAxisAnnotation), e;
  } }, { key: "extendPointAnnotations", value: function(e) {
    var t = new An();
    return e.annotations.points = $.extendArray(e.annotations.points !== void 0 ? e.annotations.points : [], t.pointAnnotation), e;
  } }, { key: "checkForDarkTheme", value: function(e) {
    e.theme && e.theme.mode === "dark" && (e.tooltip || (e.tooltip = {}), e.tooltip.theme !== "light" && (e.tooltip.theme = "dark"), e.chart.foreColor || (e.chart.foreColor = "#f6f7f8"), e.theme.palette || (e.theme.palette = "palette4"));
  } }, { key: "handleUserInputErrors", value: function(e) {
    var t = e;
    if (t.tooltip.shared && t.tooltip.intersect) throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");
    if (t.chart.type === "bar" && t.plotOptions.bar.horizontal) {
      if (t.yaxis.length > 1) throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");
      t.yaxis[0].reversed && (t.yaxis[0].opposite = !0), t.xaxis.tooltip.enabled = !1, t.yaxis[0].tooltip.enabled = !1, t.chart.zoom.enabled = !1;
    }
    return t.chart.type !== "bar" && t.chart.type !== "rangeBar" || t.tooltip.shared && t.xaxis.crosshairs.width === "barWidth" && t.series.length > 1 && (t.xaxis.crosshairs.width = "tickWidth"), t.chart.type !== "candlestick" && t.chart.type !== "boxPlot" || t.yaxis[0].reversed && (console.warn("Reversed y-axis in ".concat(t.chart.type, " chart is not supported.")), t.yaxis[0].reversed = !1), t;
  } }]), r;
})(), $m = (function() {
  function r() {
    xe(this, r);
  }
  return ve(r, [{ key: "initGlobalVars", value: function(e) {
    e.series = [], e.seriesCandleO = [], e.seriesCandleH = [], e.seriesCandleM = [], e.seriesCandleL = [], e.seriesCandleC = [], e.seriesRangeStart = [], e.seriesRangeEnd = [], e.seriesRange = [], e.seriesPercent = [], e.seriesGoals = [], e.seriesX = [], e.seriesZ = [], e.seriesNames = [], e.seriesTotals = [], e.seriesLog = [], e.seriesColors = [], e.stackedSeriesTotals = [], e.seriesXvalues = [], e.seriesYvalues = [], e.dataWasParsed = !1, e.originalSeries = null, e.labels = [], e.hasXaxisGroups = !1, e.groups = [], e.barGroups = [], e.lineGroups = [], e.areaGroups = [], e.hasSeriesGroups = !1, e.seriesGroups = [], e.categoryLabels = [], e.timescaleLabels = [], e.noLabelsProvided = !1, e.resizeTimer = null, e.selectionResizeTimer = null, e.lastWheelExecution = 0, e.delayedElements = [], e.pointsArray = [], e.dataLabelsRects = [], e.isXNumeric = !1, e.skipLastTimelinelabel = !1, e.skipFirstTimelinelabel = !1, e.isDataXYZ = !1, e.isMultiLineX = !1, e.isMultipleYAxis = !1, e.maxY = -Number.MAX_VALUE, e.minY = Number.MIN_VALUE, e.minYArr = [], e.maxYArr = [], e.maxX = -Number.MAX_VALUE, e.minX = Number.MAX_VALUE, e.initialMaxX = -Number.MAX_VALUE, e.initialMinX = Number.MAX_VALUE, e.maxDate = 0, e.minDate = Number.MAX_VALUE, e.minZ = Number.MAX_VALUE, e.maxZ = -Number.MAX_VALUE, e.minXDiff = Number.MAX_VALUE, e.yAxisScale = [], e.xAxisScale = null, e.xAxisTicksPositions = [], e.yLabelsCoords = [], e.yTitleCoords = [], e.barPadForNumericAxis = 0, e.padHorizontal = 0, e.xRange = 0, e.yRange = [], e.zRange = 0, e.dataPoints = 0, e.xTickAmount = 0, e.multiAxisTickAmount = 0;
  } }, { key: "globalVars", value: function(e) {
    return { chartID: null, cuid: null, events: { beforeMount: [], mounted: [], updated: [], clicked: [], selection: [], dataPointSelection: [], zoomed: [], scrolled: [] }, colors: [], clientX: null, clientY: null, fill: { colors: [] }, stroke: { colors: [] }, dataLabels: { style: { colors: [] } }, radarPolygons: { fill: { colors: [] } }, markers: { colors: [], size: e.markers.size, largestSize: 0 }, animationEnded: !1, isTouchDevice: "ontouchstart" in window || navigator.msMaxTouchPoints, isDirty: !1, isExecCalled: !1, initialConfig: null, initialSeries: [], lastXAxis: [], lastYAxis: [], columnSeries: null, labels: [], timescaleLabels: [], noLabelsProvided: !1, allSeriesCollapsed: !1, collapsedSeries: [], collapsedSeriesIndices: [], ancillaryCollapsedSeries: [], ancillaryCollapsedSeriesIndices: [], risingSeries: [], dataFormatXNumeric: !1, capturedSeriesIndex: -1, capturedDataPointIndex: -1, selectedDataPoints: [], invalidLogScale: !1, ignoreYAxisIndexes: [], maxValsInArrayIndex: 0, radialSize: 0, selection: void 0, zoomEnabled: e.chart.toolbar.autoSelected === "zoom" && e.chart.toolbar.tools.zoom && e.chart.zoom.enabled, panEnabled: e.chart.toolbar.autoSelected === "pan" && e.chart.toolbar.tools.pan, selectionEnabled: e.chart.toolbar.autoSelected === "selection" && e.chart.toolbar.tools.selection, yaxis: null, mousedown: !1, lastClientPosition: {}, visibleXRange: void 0, yValueDecimal: 0, total: 0, SVGNS: "http://www.w3.org/2000/svg", svgWidth: 0, svgHeight: 0, noData: !1, locale: {}, dom: {}, memory: { methodsToExec: [] }, shouldAnimate: !0, skipLastTimelinelabel: !1, skipFirstTimelinelabel: !1, delayedElements: [], axisCharts: !0, isDataXYZ: !1, isSlopeChart: e.plotOptions.line.isSlopeChart, resized: !1, resizeTimer: null, comboCharts: !1, dataChanged: !1, previousPaths: [], allSeriesHasEqualX: !0, pointsArray: [], dataLabelsRects: [], lastDrawnDataLabelsIndexes: [], hasNullValues: !1, zoomed: !1, gridWidth: 0, gridHeight: 0, rotateXLabels: !1, defaultLabels: !1, xLabelFormatter: void 0, yLabelFormatters: [], xaxisTooltipFormatter: void 0, ttKeyFormatter: void 0, ttVal: void 0, ttZFormatter: void 0, LINE_HEIGHT_RATIO: 1.618, xAxisLabelsHeight: 0, xAxisGroupLabelsHeight: 0, xAxisLabelsWidth: 0, yAxisLabelsWidth: 0, scaleX: 1, scaleY: 1, translateX: 0, translateY: 0, translateYAxisX: [], yAxisWidths: [], translateXAxisY: 0, translateXAxisX: 0, tooltip: null, niceScaleAllowedMagMsd: [[1, 1, 2, 5, 5, 5, 10, 10, 10, 10, 10], [1, 1, 2, 5, 5, 5, 10, 10, 10, 10, 10]], niceScaleDefaultTicks: [1, 2, 4, 4, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 12, 12, 12, 12, 12, 12, 12, 12, 12, 24], seriesYAxisMap: [], seriesYAxisReverseMap: [] };
  } }, { key: "init", value: function(e) {
    var t = this.globalVars(e);
    return this.initGlobalVars(t), t.initialConfig = $.extend({}, e), t.initialSeries = $.clone(e.series), t.lastXAxis = $.clone(t.initialConfig.xaxis), t.lastYAxis = $.clone(t.initialConfig.yaxis), t;
  } }]), r;
})(), NL = (function() {
  function r(e) {
    xe(this, r), this.opts = e;
  }
  return ve(r, [{ key: "init", value: function() {
    var e = new Vi(this.opts).init({ responsiveOverride: !1 });
    return { config: e, globals: new $m().init(e) };
  } }]), r;
})(), Pr = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.opts = null, this.seriesIndex = 0, this.patternIDs = [];
  }
  return ve(r, [{ key: "clippedImgArea", value: function(e) {
    var t = this.w, n = t.config, o = parseInt(t.globals.gridWidth, 10), i = parseInt(t.globals.gridHeight, 10), a = o > i ? o : i, s = e.image, c = 0, d = 0;
    e.width === void 0 && e.height === void 0 ? n.fill.image.width !== void 0 && n.fill.image.height !== void 0 ? (c = n.fill.image.width + 1, d = n.fill.image.height) : (c = a + 1, d = a) : (c = e.width, d = e.height);
    var u = document.createElementNS(t.globals.SVGNS, "pattern");
    ee.setAttrs(u, { id: e.patternID, patternUnits: e.patternUnits ? e.patternUnits : "userSpaceOnUse", width: c + "px", height: d + "px" });
    var p = document.createElementNS(t.globals.SVGNS, "image");
    u.appendChild(p), p.setAttributeNS(window.SVG.xlink, "href", s), ee.setAttrs(p, { x: 0, y: 0, preserveAspectRatio: "none", width: c + "px", height: d + "px" }), p.style.opacity = e.opacity, t.globals.dom.elDefs.node.appendChild(u);
  } }, { key: "getSeriesIndex", value: function(e) {
    var t = this.w, n = t.config.chart.type;
    return (n === "bar" || n === "rangeBar") && t.config.plotOptions.bar.distributed || n === "heatmap" || n === "treemap" ? this.seriesIndex = e.seriesNumber : this.seriesIndex = e.seriesNumber % t.globals.series.length, this.seriesIndex;
  } }, { key: "computeColorStops", value: function(e, t) {
    var n, o = this.w, i = null, a = null, s = Ci(e);
    try {
      for (s.s(); !(n = s.n()).done; ) {
        var c = n.value;
        c >= t.threshold ? (i === null || c > i) && (i = c) : (a === null || c < a) && (a = c);
      }
    } catch (p) {
      s.e(p);
    } finally {
      s.f();
    }
    i === null && (i = t.threshold), a === null && (a = t.threshold);
    var d = i - t.threshold + (t.threshold - a);
    d === 0 && (d = 1);
    var u = 100 - (t.threshold - a) / d * 100;
    return [{ offset: u = Math.max(0, Math.min(u, 100)), color: t.colorAboveThreshold, opacity: o.config.fill.opacity }, { offset: 0, color: t.colorBelowThreshold, opacity: o.config.fill.opacity }];
  } }, { key: "fillPath", value: function(e) {
    var t, n, o, i = this.w;
    this.opts = e;
    var a, s, c, d = this.w.config;
    this.seriesIndex = this.getSeriesIndex(e);
    var u = d.plotOptions.line.colors.colorAboveThreshold && d.plotOptions.line.colors.colorBelowThreshold, p = this.getFillColors()[this.seriesIndex];
    i.globals.seriesColors[this.seriesIndex] !== void 0 && (p = i.globals.seriesColors[this.seriesIndex]), typeof p == "function" && (p = p({ seriesIndex: this.seriesIndex, dataPointIndex: e.dataPointIndex, value: e.value, w: i }));
    var h, f, m, g = e.fillType ? e.fillType : this.getFillType(this.seriesIndex), b = Array.isArray(d.fill.opacity) ? d.fill.opacity[this.seriesIndex] : d.fill.opacity, x = g === "gradient" || u;
    e.color && (p = e.color), (t = i.config.series[this.seriesIndex]) !== null && t !== void 0 && (n = t.data) !== null && n !== void 0 && (o = n[e.dataPointIndex]) !== null && o !== void 0 && o.fillColor && (p = (h = i.config.series[this.seriesIndex]) === null || h === void 0 || (f = h.data) === null || f === void 0 || (m = f[e.dataPointIndex]) === null || m === void 0 ? void 0 : m.fillColor), p || (p = "#fff", console.warn("undefined color - ApexCharts"));
    var v = p;
    if (p.indexOf("rgb") === -1 ? p.indexOf("#") === -1 ? v = p : p.length < 9 && (v = $.hexToRgba(p, b)) : p.indexOf("rgba") > -1 ? b = $.getOpacityFromRGBA(p) : v = $.hexToRgba($.rgb2hex(p), b), e.opacity && (b = e.opacity), g === "pattern" && (s = this.handlePatternFill({ fillConfig: e.fillConfig, patternFill: s, fillColor: p, fillOpacity: b, defaultColor: v })), x) {
      var y = Mt(d.fill.gradient.colorStops) || [], C = d.fill.gradient.type;
      u && (y[this.seriesIndex] = this.computeColorStops(i.globals.series[this.seriesIndex], d.plotOptions.line.colors), C = "vertical"), c = this.handleGradientFill({ type: C, fillConfig: e.fillConfig, fillColor: p, fillOpacity: b, colorStops: y, i: this.seriesIndex });
    }
    if (g === "image") {
      var k = d.fill.image.src, T = e.patternID ? e.patternID : "", S = "pattern".concat(i.globals.cuid).concat(e.seriesNumber + 1).concat(T);
      this.patternIDs.indexOf(S) === -1 && (this.clippedImgArea({ opacity: b, image: Array.isArray(k) ? e.seriesNumber < k.length ? k[e.seriesNumber] : k[0] : k, width: e.width ? e.width : void 0, height: e.height ? e.height : void 0, patternUnits: e.patternUnits, patternID: S }), this.patternIDs.push(S)), a = "url(#".concat(S, ")");
    } else a = x ? c : g === "pattern" ? s : v;
    return e.solid && (a = v), a;
  } }, { key: "getFillType", value: function(e) {
    var t = this.w;
    return Array.isArray(t.config.fill.type) ? t.config.fill.type[e] : t.config.fill.type;
  } }, { key: "getFillColors", value: function() {
    var e = this.w, t = e.config, n = this.opts, o = [];
    return e.globals.comboCharts ? e.config.series[this.seriesIndex].type === "line" ? Array.isArray(e.globals.stroke.colors) ? o = e.globals.stroke.colors : o.push(e.globals.stroke.colors) : Array.isArray(e.globals.fill.colors) ? o = e.globals.fill.colors : o.push(e.globals.fill.colors) : t.chart.type === "line" ? Array.isArray(e.globals.stroke.colors) ? o = e.globals.stroke.colors : o.push(e.globals.stroke.colors) : Array.isArray(e.globals.fill.colors) ? o = e.globals.fill.colors : o.push(e.globals.fill.colors), n.fillColors !== void 0 && (o = [], Array.isArray(n.fillColors) ? o = n.fillColors.slice() : o.push(n.fillColors)), o;
  } }, { key: "handlePatternFill", value: function(e) {
    var t = e.fillConfig, n = e.patternFill, o = e.fillColor, i = e.fillOpacity, a = e.defaultColor, s = this.w.config.fill;
    t && (s = t);
    var c = this.opts, d = new ee(this.ctx), u = Array.isArray(s.pattern.strokeWidth) ? s.pattern.strokeWidth[this.seriesIndex] : s.pattern.strokeWidth, p = o;
    return Array.isArray(s.pattern.style) ? n = s.pattern.style[c.seriesNumber] !== void 0 ? d.drawPattern(s.pattern.style[c.seriesNumber], s.pattern.width, s.pattern.height, p, u, i) : a : n = d.drawPattern(s.pattern.style, s.pattern.width, s.pattern.height, p, u, i), n;
  } }, { key: "handleGradientFill", value: function(e) {
    var t = e.type, n = e.fillColor, o = e.fillOpacity, i = e.fillConfig, a = e.colorStops, s = e.i, c = this.w.config.fill;
    i && (c = ie(ie({}, c), i));
    var d = this.opts, u = new ee(this.ctx), p = new $();
    t = t || c.gradient.type;
    var h, f = n, m = c.gradient.opacityFrom === void 0 ? o : Array.isArray(c.gradient.opacityFrom) ? c.gradient.opacityFrom[s] : c.gradient.opacityFrom;
    f.indexOf("rgba") > -1 && (m = $.getOpacityFromRGBA(f));
    var g = c.gradient.opacityTo === void 0 ? o : Array.isArray(c.gradient.opacityTo) ? c.gradient.opacityTo[s] : c.gradient.opacityTo;
    if (c.gradient.gradientToColors === void 0 || c.gradient.gradientToColors.length === 0) h = c.gradient.shade === "dark" ? p.shadeColor(-1 * parseFloat(c.gradient.shadeIntensity), n.indexOf("rgb") > -1 ? $.rgb2hex(n) : n) : p.shadeColor(parseFloat(c.gradient.shadeIntensity), n.indexOf("rgb") > -1 ? $.rgb2hex(n) : n);
    else if (c.gradient.gradientToColors[d.seriesNumber]) {
      var b = c.gradient.gradientToColors[d.seriesNumber];
      h = b, b.indexOf("rgba") > -1 && (g = $.getOpacityFromRGBA(b));
    } else h = n;
    if (c.gradient.gradientFrom && (f = c.gradient.gradientFrom), c.gradient.gradientTo && (h = c.gradient.gradientTo), c.gradient.inverseColors) {
      var x = f;
      f = h, h = x;
    }
    return f.indexOf("rgb") > -1 && (f = $.rgb2hex(f)), h.indexOf("rgb") > -1 && (h = $.rgb2hex(h)), u.drawGradient(t, f, h, m, g, d.size, c.gradient.stops, a, s);
  } }]), r;
})(), Io = (function() {
  function r(e, t) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "setGlobalMarkerSize", value: function() {
    var e = this.w;
    if (e.globals.markers.size = Array.isArray(e.config.markers.size) ? e.config.markers.size : [e.config.markers.size], e.globals.markers.size.length > 0) {
      if (e.globals.markers.size.length < e.globals.series.length + 1) for (var t = 0; t <= e.globals.series.length; t++) e.globals.markers.size[t] === void 0 && e.globals.markers.size.push(e.globals.markers.size[0]);
    } else e.globals.markers.size = e.config.series.map((function(n) {
      return e.config.markers.size;
    }));
  } }, { key: "plotChartMarkers", value: function(e) {
    var t = e.pointsPos, n = e.seriesIndex, o = e.j, i = e.pSize, a = e.alwaysDrawMarker, s = a !== void 0 && a, c = e.isVirtualPoint, d = c !== void 0 && c, u = this.w, p = n, h = t, f = null, m = new ee(this.ctx), g = u.config.markers.discrete && u.config.markers.discrete.length;
    if (Array.isArray(h.x)) for (var b = 0; b < h.x.length; b++) {
      var x = void 0, v = o, y = !$.isNumber(h.y[b]);
      u.globals.markers.largestSize === 0 && u.globals.hasNullValues && u.globals.series[p][o + 1] !== null && !d && (y = !0), o === 1 && b === 0 && (v = 0), o === 1 && b === 1 && (v = 1);
      var C = "apexcharts-marker";
      if (u.config.chart.type !== "line" && u.config.chart.type !== "area" || u.globals.comboCharts || u.config.tooltip.intersect || (C += " no-pointer-events"), (Array.isArray(u.config.markers.size) ? u.globals.markers.size[n] > 0 : u.config.markers.size > 0) || s || g) {
        y || (C += " w".concat($.randomId()));
        var k = this.getMarkerConfig({ cssClass: C, seriesIndex: n, dataPointIndex: v });
        u.config.series[p].data[v] && (u.config.series[p].data[v].fillColor && (k.pointFillColor = u.config.series[p].data[v].fillColor), u.config.series[p].data[v].strokeColor && (k.pointStrokeColor = u.config.series[p].data[v].strokeColor)), i !== void 0 && (k.pSize = i), (h.x[b] < -u.globals.markers.largestSize || h.x[b] > u.globals.gridWidth + u.globals.markers.largestSize || h.y[b] < -u.globals.markers.largestSize || h.y[b] > u.globals.gridHeight + u.globals.markers.largestSize) && (k.pSize = 0), !y && ((u.globals.markers.size[n] > 0 || s || g) && !f && (f = m.group({ class: s || g ? "" : "apexcharts-series-markers" })).attr("clip-path", "url(#gridRectMarkerMask".concat(u.globals.cuid, ")")), (x = m.drawMarker(h.x[b], h.y[b], k)).attr("rel", v), x.attr("j", v), x.attr("index", n), x.node.setAttribute("default-marker-size", k.pSize), new zt(this.ctx).setSelectionFilter(x, n, v), this.addEvents(x), f && f.add(x));
      } else u.globals.pointsArray[n] === void 0 && (u.globals.pointsArray[n] = []), u.globals.pointsArray[n].push([h.x[b], h.y[b]]);
    }
    return f;
  } }, { key: "getMarkerConfig", value: function(e) {
    var t = e.cssClass, n = e.seriesIndex, o = e.dataPointIndex, i = o === void 0 ? null : o, a = e.radius, s = a === void 0 ? null : a, c = e.size, d = c === void 0 ? null : c, u = e.strokeWidth, p = u === void 0 ? null : u, h = this.w, f = this.getMarkerStyle(n), m = d === null ? h.globals.markers.size[n] : d, g = h.config.markers;
    return i !== null && g.discrete.length && g.discrete.map((function(b) {
      b.seriesIndex === n && b.dataPointIndex === i && (f.pointStrokeColor = b.strokeColor, f.pointFillColor = b.fillColor, m = b.size, f.pointShape = b.shape);
    })), { pSize: s === null ? m : s, pRadius: s !== null ? s : g.radius, pointStrokeWidth: p !== null ? p : Array.isArray(g.strokeWidth) ? g.strokeWidth[n] : g.strokeWidth, pointStrokeColor: f.pointStrokeColor, pointFillColor: f.pointFillColor, shape: f.pointShape || (Array.isArray(g.shape) ? g.shape[n] : g.shape), class: t, pointStrokeOpacity: Array.isArray(g.strokeOpacity) ? g.strokeOpacity[n] : g.strokeOpacity, pointStrokeDashArray: Array.isArray(g.strokeDashArray) ? g.strokeDashArray[n] : g.strokeDashArray, pointFillOpacity: Array.isArray(g.fillOpacity) ? g.fillOpacity[n] : g.fillOpacity, seriesIndex: n };
  } }, { key: "addEvents", value: function(e) {
    var t = this.w, n = new ee(this.ctx);
    e.node.addEventListener("mouseenter", n.pathMouseEnter.bind(this.ctx, e)), e.node.addEventListener("mouseleave", n.pathMouseLeave.bind(this.ctx, e)), e.node.addEventListener("mousedown", n.pathMouseDown.bind(this.ctx, e)), e.node.addEventListener("click", t.config.markers.onClick), e.node.addEventListener("dblclick", t.config.markers.onDblClick), e.node.addEventListener("touchstart", n.pathMouseDown.bind(this.ctx, e), { passive: !0 });
  } }, { key: "getMarkerStyle", value: function(e) {
    var t = this.w, n = t.globals.markers.colors, o = t.config.markers.strokeColor || t.config.markers.strokeColors;
    return { pointStrokeColor: Array.isArray(o) ? o[e] : o, pointFillColor: Array.isArray(n) ? n[e] : n };
  } }]), r;
})(), Wm = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.initialAnim = this.w.config.chart.animations.enabled;
  }
  return ve(r, [{ key: "draw", value: function(e, t, n) {
    var o = this.w, i = new ee(this.ctx), a = n.realIndex, s = n.pointsPos, c = n.zRatio, d = n.elParent, u = i.group({ class: "apexcharts-series-markers apexcharts-series-".concat(o.config.chart.type) });
    if (u.attr("clip-path", "url(#gridRectMarkerMask".concat(o.globals.cuid, ")")), Array.isArray(s.x)) for (var p = 0; p < s.x.length; p++) {
      var h = t + 1, f = !0;
      t === 0 && p === 0 && (h = 0), t === 0 && p === 1 && (h = 1);
      var m = o.globals.markers.size[a];
      if (c !== 1 / 0) {
        var g = o.config.plotOptions.bubble;
        m = o.globals.seriesZ[a][h], g.zScaling && (m /= c), g.minBubbleRadius && m < g.minBubbleRadius && (m = g.minBubbleRadius), g.maxBubbleRadius && m > g.maxBubbleRadius && (m = g.maxBubbleRadius);
      }
      var b = s.x[p], x = s.y[p];
      if (m = m || 0, x !== null && o.globals.series[a][h] !== void 0 || (f = !1), f) {
        var v = this.drawPoint(b, x, m, a, h, t);
        u.add(v);
      }
      d.add(u);
    }
  } }, { key: "drawPoint", value: function(e, t, n, o, i, a) {
    var s = this.w, c = o, d = new Ro(this.ctx), u = new zt(this.ctx), p = new Pr(this.ctx), h = new Io(this.ctx), f = new ee(this.ctx), m = h.getMarkerConfig({ cssClass: "apexcharts-marker", seriesIndex: c, dataPointIndex: i, radius: s.config.chart.type === "bubble" || s.globals.comboCharts && s.config.series[o] && s.config.series[o].type === "bubble" ? n : null }), g = p.fillPath({ seriesNumber: o, dataPointIndex: i, color: m.pointFillColor, patternUnits: "objectBoundingBox", value: s.globals.series[o][a] }), b = f.drawMarker(e, t, m);
    if (s.config.series[c].data[i] && s.config.series[c].data[i].fillColor && (g = s.config.series[c].data[i].fillColor), b.attr({ fill: g }), s.config.chart.dropShadow.enabled) {
      var x = s.config.chart.dropShadow;
      u.dropShadow(b, x, o);
    }
    if (!this.initialAnim || s.globals.dataChanged || s.globals.resized) s.globals.animationEnded = !0;
    else {
      var v = s.config.chart.animations.speed;
      d.animateMarker(b, v, s.globals.easing, (function() {
        window.setTimeout((function() {
          d.animationCompleted(b);
        }), 100);
      }));
    }
    return b.attr({ rel: i, j: i, index: o, "default-marker-size": m.pSize }), u.setSelectionFilter(b, o, i), h.addEvents(b), b.node.classList.add("apexcharts-marker"), b;
  } }, { key: "centerTextInBubble", value: function(e) {
    var t = this.w;
    return { y: e += parseInt(t.config.dataLabels.style.fontSize, 10) / 4 };
  } }]), r;
})(), vo = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "dataLabelsCorrection", value: function(e, t, n, o, i, a, s) {
    var c = this.w, d = !1, u = new ee(this.ctx).getTextRects(n, s), p = u.width, h = u.height;
    t < 0 && (t = 0), t > c.globals.gridHeight + h && (t = c.globals.gridHeight + h / 2), c.globals.dataLabelsRects[o] === void 0 && (c.globals.dataLabelsRects[o] = []), c.globals.dataLabelsRects[o].push({ x: e, y: t, width: p, height: h });
    var f = c.globals.dataLabelsRects[o].length - 2, m = c.globals.lastDrawnDataLabelsIndexes[o] !== void 0 ? c.globals.lastDrawnDataLabelsIndexes[o][c.globals.lastDrawnDataLabelsIndexes[o].length - 1] : 0;
    if (c.globals.dataLabelsRects[o][f] !== void 0) {
      var g = c.globals.dataLabelsRects[o][m];
      (e > g.x + g.width || t > g.y + g.height || t + h < g.y || e + p < g.x) && (d = !0);
    }
    return (i === 0 || a) && (d = !0), { x: e, y: t, textRects: u, drawnextLabel: d };
  } }, { key: "drawDataLabel", value: function(e) {
    var t = this, n = e.type, o = e.pos, i = e.i, a = e.j, s = e.isRangeStart, c = e.strokeWidth, d = c === void 0 ? 2 : c, u = this.w, p = new ee(this.ctx), h = u.config.dataLabels, f = 0, m = 0, g = a, b = null;
    if (u.globals.collapsedSeriesIndices.indexOf(i) !== -1 || !h.enabled || !Array.isArray(o.x)) return b;
    b = p.group({ class: "apexcharts-data-labels" });
    for (var x = 0; x < o.x.length; x++) if (f = o.x[x] + h.offsetX, m = o.y[x] + h.offsetY + d, !isNaN(f)) {
      a === 1 && x === 0 && (g = 0), a === 1 && x === 1 && (g = 1);
      var v = u.globals.series[i][g];
      n === "rangeArea" && (v = s ? u.globals.seriesRangeStart[i][g] : u.globals.seriesRangeEnd[i][g]);
      var y = "", C = function(T) {
        return u.config.dataLabels.formatter(T, { ctx: t.ctx, seriesIndex: i, dataPointIndex: g, w: u });
      };
      u.config.chart.type === "bubble" ? (y = C(v = u.globals.seriesZ[i][g]), m = o.y[x], m = new Wm(this.ctx).centerTextInBubble(m, i, g).y) : v !== void 0 && (y = C(v));
      var k = u.config.dataLabels.textAnchor;
      u.globals.isSlopeChart && (k = g === 0 ? "end" : g === u.config.series[i].data.length - 1 ? "start" : "middle"), this.plotDataLabelsText({ x: f, y: m, text: y, i, j: g, parent: b, offsetCorrection: !0, dataLabelsConfig: u.config.dataLabels, textAnchor: k });
    }
    return b;
  } }, { key: "plotDataLabelsText", value: function(e) {
    var t = this.w, n = new ee(this.ctx), o = e.x, i = e.y, a = e.i, s = e.j, c = e.text, d = e.textAnchor, u = e.fontSize, p = e.parent, h = e.dataLabelsConfig, f = e.color, m = e.alwaysDrawDataLabel, g = e.offsetCorrection, b = e.className, x = null;
    if (Array.isArray(t.config.dataLabels.enabledOnSeries) && t.config.dataLabels.enabledOnSeries.indexOf(a) < 0) return x;
    var v = { x: o, y: i, drawnextLabel: !0, textRects: null };
    g && (v = this.dataLabelsCorrection(o, i, c, a, s, m, parseInt(h.style.fontSize, 10))), t.globals.zoomed || (o = v.x, i = v.y), v.textRects && (o < -20 - v.textRects.width || o > t.globals.gridWidth + v.textRects.width + 30) && (c = "");
    var y = t.globals.dataLabels.style.colors[a];
    ((t.config.chart.type === "bar" || t.config.chart.type === "rangeBar") && t.config.plotOptions.bar.distributed || t.config.dataLabels.distributed) && (y = t.globals.dataLabels.style.colors[s]), typeof y == "function" && (y = y({ series: t.globals.series, seriesIndex: a, dataPointIndex: s, w: t })), f && (y = f);
    var C = h.offsetX, k = h.offsetY;
    if (t.config.chart.type !== "bar" && t.config.chart.type !== "rangeBar" || (C = 0, k = 0), t.globals.isSlopeChart && (s !== 0 && (C = -2 * h.offsetX + 5), s !== 0 && s !== t.config.series[a].data.length - 1 && (C = 0)), v.drawnextLabel) {
      if (d === "middle" && o === t.globals.gridWidth && (d = "end"), (x = n.drawText({ width: 100, height: parseInt(h.style.fontSize, 10), x: o + C, y: i + k, foreColor: y, textAnchor: d || h.textAnchor, text: c, fontSize: u || h.style.fontSize, fontFamily: h.style.fontFamily, fontWeight: h.style.fontWeight || "normal" })).attr({ class: b || "apexcharts-datalabel", cx: o, cy: i }), h.dropShadow.enabled) {
        var T = h.dropShadow;
        new zt(this.ctx).dropShadow(x, T);
      }
      p.add(x), t.globals.lastDrawnDataLabelsIndexes[a] === void 0 && (t.globals.lastDrawnDataLabelsIndexes[a] = []), t.globals.lastDrawnDataLabelsIndexes[a].push(s);
    }
    return x;
  } }, { key: "addBackgroundToDataLabel", value: function(e, t) {
    var n = this.w, o = n.config.dataLabels.background, i = o.padding, a = o.padding / 2, s = t.width, c = t.height, d = new ee(this.ctx).drawRect(t.x - i, t.y - a / 2, s + 2 * i, c + a, o.borderRadius, n.config.chart.background !== "transparent" && n.config.chart.background ? n.config.chart.background : "#fff", o.opacity, o.borderWidth, o.borderColor);
    return o.dropShadow.enabled && new zt(this.ctx).dropShadow(d, o.dropShadow), d;
  } }, { key: "dataLabelsBackground", value: function() {
    var e = this.w;
    if (e.config.chart.type !== "bubble") for (var t = e.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"), n = 0; n < t.length; n++) {
      var o = t[n], i = o.getBBox(), a = null;
      if (i.width && i.height && (a = this.addBackgroundToDataLabel(o, i)), a) {
        o.parentNode.insertBefore(a.node, o);
        var s = e.config.dataLabels.background.backgroundColor || o.getAttribute("fill");
        e.config.chart.animations.enabled && !e.globals.resized && !e.globals.dataChanged ? a.animate().attr({ fill: s }) : a.attr({ fill: s }), o.setAttribute("fill", e.config.dataLabels.background.foreColor);
      }
    }
  } }, { key: "bringForward", value: function() {
    for (var e = this.w, t = e.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"), n = e.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"), o = 0; o < t.length; o++) n && n.insertBefore(t[o], n.nextSibling);
  } }]), r;
})(), Hm = `.apexcharts-flip-y {
  transform: scaleY(-1) translateY(-100%);
  transform-origin: top;
  transform-box: fill-box;
}
.apexcharts-flip-x {
  transform: scaleX(-1);
  transform-origin: center;
  transform-box: fill-box;
}
.apexcharts-legend {
  display: flex;
  overflow: auto;
  padding: 0 10px;
}
.apexcharts-legend.apexcharts-legend-group-horizontal {
  flex-direction: column;
}
.apexcharts-legend-group {
  display: flex;
}
.apexcharts-legend-group-vertical {
  flex-direction: column-reverse;
}
.apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {
  flex-wrap: wrap
}
.apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {
  flex-direction: column;
  bottom: 0;
}
.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {
  justify-content: flex-start;
  align-items: flex-start;
}
.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
  justify-content: center;
  align-items: center;
}
.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {
  justify-content: flex-end;
  align-items: flex-end;
}
.apexcharts-legend-series {
  cursor: pointer;
  line-height: normal;
  display: flex;
  align-items: center;
}
.apexcharts-legend-text {
  position: relative;
  font-size: 14px;
}
.apexcharts-legend-text *, .apexcharts-legend-marker * {
  pointer-events: none;
}
.apexcharts-legend-marker {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 1px;
}

.apexcharts-legend-series.apexcharts-no-click {
  cursor: auto;
}
.apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {
  display: none !important;
}
.apexcharts-inactive-legend {
  opacity: 0.45;
} `, mr = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.legendInactiveClass = "legend-mouseover-inactive";
  }
  return ve(r, [{ key: "getAllSeriesEls", value: function() {
    return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series");
  } }, { key: "getSeriesByName", value: function(e) {
    return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat($.escapeString(e), "']"));
  } }, { key: "isSeriesHidden", value: function(e) {
    var t = this.getSeriesByName(e), n = parseInt(t.getAttribute("data:realIndex"), 10);
    return { isHidden: t.classList.contains("apexcharts-series-collapsed"), realIndex: n };
  } }, { key: "addCollapsedClassToSeries", value: function(e, t) {
    var n = this.w;
    function o(i) {
      for (var a = 0; a < i.length; a++) i[a].index === t && e.node.classList.add("apexcharts-series-collapsed");
    }
    o(n.globals.collapsedSeries), o(n.globals.ancillaryCollapsedSeries);
  } }, { key: "toggleSeries", value: function(e) {
    var t = this.isSeriesHidden(e);
    return this.ctx.legend.legendHelpers.toggleDataSeries(t.realIndex, t.isHidden), t.isHidden;
  } }, { key: "showSeries", value: function(e) {
    var t = this.isSeriesHidden(e);
    t.isHidden && this.ctx.legend.legendHelpers.toggleDataSeries(t.realIndex, !0);
  } }, { key: "hideSeries", value: function(e) {
    var t = this.isSeriesHidden(e);
    t.isHidden || this.ctx.legend.legendHelpers.toggleDataSeries(t.realIndex, !1);
  } }, { key: "resetSeries", value: function() {
    var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0], t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], n = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], o = this.w, i = $.clone(o.globals.initialSeries);
    o.globals.previousPaths = [], n ? (o.globals.collapsedSeries = [], o.globals.ancillaryCollapsedSeries = [], o.globals.collapsedSeriesIndices = [], o.globals.ancillaryCollapsedSeriesIndices = []) : i = this.emptyCollapsedSeries(i), o.config.series = i, e && (t && (o.globals.zoomed = !1, this.ctx.updateHelpers.revertDefaultAxisMinMax()), this.ctx.updateHelpers._updateSeries(i, o.config.chart.animations.dynamicAnimation.enabled));
  } }, { key: "emptyCollapsedSeries", value: function(e) {
    for (var t = this.w, n = 0; n < e.length; n++) t.globals.collapsedSeriesIndices.indexOf(n) > -1 && (e[n].data = []);
    return e;
  } }, { key: "highlightSeries", value: function(e) {
    var t = this.w, n = this.getSeriesByName(e), o = parseInt(n?.getAttribute("data:realIndex"), 10), i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels, .apexcharts-yaxis"), a = null, s = null, c = null;
    if (t.globals.axisCharts || t.config.chart.type === "radialBar") if (t.globals.axisCharts) {
      a = t.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(o, "']")), s = t.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(o, "']"));
      var d = t.globals.seriesYAxisReverseMap[o];
      c = t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(d, "']"));
    } else a = t.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(o + 1, "']"));
    else a = t.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(o + 1, "'] path"));
    for (var u = 0; u < i.length; u++) i[u].classList.add(this.legendInactiveClass);
    if (a) t.globals.axisCharts || a.parentNode.classList.remove(this.legendInactiveClass), a.classList.remove(this.legendInactiveClass), s !== null && s.classList.remove(this.legendInactiveClass), c !== null && c.classList.remove(this.legendInactiveClass);
    else for (var p = 0; p < i.length; p++) i[p].classList.remove(this.legendInactiveClass);
  } }, { key: "toggleSeriesOnHover", value: function(e, t) {
    var n = this.w;
    t || (t = e.target);
    var o = n.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels, .apexcharts-yaxis");
    if (e.type === "mousemove") {
      var i = parseInt(t.getAttribute("rel"), 10) - 1;
      this.highlightSeries(n.globals.seriesNames[i]);
    } else if (e.type === "mouseout") for (var a = 0; a < o.length; a++) o[a].classList.remove(this.legendInactiveClass);
  } }, { key: "highlightRangeInSeries", value: function(e, t) {
    var n = this, o = this.w, i = o.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"), a = function(d) {
      for (var u = 0; u < i.length; u++) i[u].classList[d](n.legendInactiveClass);
    };
    if (e.type === "mousemove") {
      var s = parseInt(t.getAttribute("rel"), 10) - 1;
      a("add");
      var c = o.config.plotOptions.heatmap.colorScale.ranges;
      (function(d, u) {
        for (var p = 0; p < i.length; p++) {
          var h = Number(i[p].getAttribute("val"));
          h >= d.from && (h < d.to || d.to === u && h === u) && i[p].classList.remove(n.legendInactiveClass);
        }
      })(c[s], c.reduce((function(d, u) {
        return Math.max(d, u.to);
      }), 0));
    } else e.type === "mouseout" && a("remove");
  } }, { key: "getActiveConfigSeriesIndex", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "asc", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = this.w, o = 0;
    if (n.config.series.length > 1) {
      for (var i = n.config.series.map((function(s, c) {
        return s.data && s.data.length > 0 && n.globals.collapsedSeriesIndices.indexOf(c) === -1 && (!n.globals.comboCharts || t.length === 0 || t.length && t.indexOf(n.config.series[c].type) > -1) ? c : -1;
      })), a = e === "asc" ? 0 : i.length - 1; e === "asc" ? a < i.length : a >= 0; e === "asc" ? a++ : a--) if (i[a] !== -1) {
        o = i[a];
        break;
      }
    }
    return o;
  } }, { key: "getBarSeriesIndices", value: function() {
    return this.w.globals.comboCharts ? this.w.config.series.map((function(e, t) {
      return e.type === "bar" || e.type === "column" ? t : -1;
    })).filter((function(e) {
      return e !== -1;
    })) : this.w.config.series.map((function(e, t) {
      return t;
    }));
  } }, { key: "getPreviousPaths", value: function() {
    var e = this.w;
    function t(a, s, c) {
      for (var d = a[s].childNodes, u = { type: c, paths: [], realIndex: a[s].getAttribute("data:realIndex") }, p = 0; p < d.length; p++) if (d[p].hasAttribute("pathTo")) {
        var h = d[p].getAttribute("pathTo");
        u.paths.push({ d: h });
      }
      e.globals.previousPaths.push(u);
    }
    e.globals.previousPaths = [], ["line", "area", "bar", "rangebar", "rangeArea", "candlestick", "radar"].forEach((function(a) {
      for (var s, c = (s = a, e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(s, "-series .apexcharts-series"))), d = 0; d < c.length; d++) t(c, d, a);
    }));
    var n = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(e.config.chart.type, " .apexcharts-series"));
    if (n.length > 0) for (var o = function(a) {
      for (var s = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(e.config.chart.type, " .apexcharts-series[data\\:realIndex='").concat(a, "'] rect")), c = [], d = function(p) {
        var h = function(m) {
          return s[p].getAttribute(m);
        }, f = { x: parseFloat(h("x")), y: parseFloat(h("y")), width: parseFloat(h("width")), height: parseFloat(h("height")) };
        c.push({ rect: f, color: s[p].getAttribute("color") });
      }, u = 0; u < s.length; u++) d(u);
      e.globals.previousPaths.push(c);
    }, i = 0; i < n.length; i++) o(i);
    e.globals.axisCharts || (e.globals.previousPaths = e.globals.series);
  } }, { key: "clearPreviousPaths", value: function() {
    var e = this.w;
    e.globals.previousPaths = [], e.globals.allSeriesCollapsed = !1;
  } }, { key: "handleNoData", value: function() {
    var e = this.w, t = e.config.noData, n = new ee(this.ctx), o = e.globals.svgWidth / 2, i = e.globals.svgHeight / 2, a = "middle";
    if (e.globals.noData = !0, e.globals.animationEnded = !0, t.align === "left" ? (o = 10, a = "start") : t.align === "right" && (o = e.globals.svgWidth - 10, a = "end"), t.verticalAlign === "top" ? i = 50 : t.verticalAlign === "bottom" && (i = e.globals.svgHeight - 50), o += t.offsetX, i = i + parseInt(t.style.fontSize, 10) + 2 + t.offsetY, t.text !== void 0 && t.text !== "") {
      var s = n.drawText({ x: o, y: i, text: t.text, textAnchor: a, fontSize: t.style.fontSize, fontFamily: t.style.fontFamily, foreColor: t.style.color, opacity: 1, class: "apexcharts-text-nodata" });
      e.globals.dom.Paper.add(s);
    }
  } }, { key: "setNullSeriesToZeroValues", value: function(e) {
    for (var t = this.w, n = 0; n < e.length; n++) if (e[n].length === 0) for (var o = 0; o < e[t.globals.maxValsInArrayIndex].length; o++) e[n].push(0);
    return e;
  } }, { key: "hasAllSeriesEqualX", value: function() {
    for (var e = !0, t = this.w, n = this.filteredSeriesX(), o = 0; o < n.length - 1; o++) if (n[o][0] !== n[o + 1][0]) {
      e = !1;
      break;
    }
    return t.globals.allSeriesHasEqualX = e, e;
  } }, { key: "filteredSeriesX", value: function() {
    var e = this.w.globals.seriesX.map((function(t) {
      return t.length > 0 ? t : [];
    }));
    return e;
  } }]), r;
})(), zd = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.twoDSeries = [], this.threeDSeries = [], this.twoDSeriesX = [], this.seriesGoals = [], this.coreUtils = new Tt(this.ctx);
  }
  return ve(r, [{ key: "isMultiFormat", value: function() {
    return this.isFormatXY() || this.isFormat2DArray();
  } }, { key: "isFormatXY", value: function() {
    var e = this.w.config.series.slice(), t = new mr(this.ctx);
    if (this.activeSeriesIndex = t.getActiveConfigSeriesIndex(), e[this.activeSeriesIndex].data !== void 0 && e[this.activeSeriesIndex].data.length > 0 && e[this.activeSeriesIndex].data[0] !== null && e[this.activeSeriesIndex].data[0].x !== void 0 && e[this.activeSeriesIndex].data[0] !== null) return !0;
  } }, { key: "isFormat2DArray", value: function() {
    var e = this.w.config.series.slice(), t = new mr(this.ctx);
    if (this.activeSeriesIndex = t.getActiveConfigSeriesIndex(), e[this.activeSeriesIndex].data !== void 0 && e[this.activeSeriesIndex].data.length > 0 && e[this.activeSeriesIndex].data[0] !== void 0 && e[this.activeSeriesIndex].data[0] !== null && e[this.activeSeriesIndex].data[0].constructor === Array) return !0;
  } }, { key: "handleFormat2DArray", value: function(e, t) {
    for (var n = this.w.config, o = this.w.globals, i = n.chart.type === "boxPlot" || n.series[t].type === "boxPlot", a = 0; a < e[t].data.length; a++) if (e[t].data[a][1] !== void 0 && (Array.isArray(e[t].data[a][1]) && e[t].data[a][1].length === 4 && !i ? this.twoDSeries.push($.parseNumber(e[t].data[a][1][3])) : e[t].data[a].length >= 5 ? this.twoDSeries.push($.parseNumber(e[t].data[a][4])) : this.twoDSeries.push($.parseNumber(e[t].data[a][1])), o.dataFormatXNumeric = !0), n.xaxis.type === "datetime") {
      var s = new Date(e[t].data[a][0]);
      s = new Date(s).getTime(), this.twoDSeriesX.push(s);
    } else this.twoDSeriesX.push(e[t].data[a][0]);
    for (var c = 0; c < e[t].data.length; c++) e[t].data[c][2] !== void 0 && (this.threeDSeries.push(e[t].data[c][2]), o.isDataXYZ = !0);
  } }, { key: "handleFormatXY", value: function(e, t) {
    var n = this.w.config, o = this.w.globals, i = new Dt(this.ctx), a = t;
    o.collapsedSeriesIndices.indexOf(t) > -1 && (a = this.activeSeriesIndex);
    for (var s = 0; s < e[t].data.length; s++) e[t].data[s].y !== void 0 && (Array.isArray(e[t].data[s].y) ? this.twoDSeries.push($.parseNumber(e[t].data[s].y[e[t].data[s].y.length - 1])) : this.twoDSeries.push($.parseNumber(e[t].data[s].y))), e[t].data[s].goals !== void 0 && Array.isArray(e[t].data[s].goals) ? (this.seriesGoals[t] === void 0 && (this.seriesGoals[t] = []), this.seriesGoals[t].push(e[t].data[s].goals)) : (this.seriesGoals[t] === void 0 && (this.seriesGoals[t] = []), this.seriesGoals[t].push(null));
    for (var c = 0; c < e[a].data.length; c++) {
      var d = typeof e[a].data[c].x == "string", u = Array.isArray(e[a].data[c].x), p = !u && !!i.isValidDate(e[a].data[c].x);
      if (d || p) if (d || n.xaxis.convertedCatToNumeric) {
        var h = o.isBarHorizontal && o.isRangeData;
        n.xaxis.type !== "datetime" || h ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(e[a].data[c].x), isNaN(e[a].data[c].x) || this.w.config.xaxis.type === "category" || typeof e[a].data[c].x == "string" || (o.isXNumeric = !0)) : this.twoDSeriesX.push(i.parseDate(e[a].data[c].x));
      } else n.xaxis.type === "datetime" ? this.twoDSeriesX.push(i.parseDate(e[a].data[c].x.toString())) : (o.dataFormatXNumeric = !0, o.isXNumeric = !0, this.twoDSeriesX.push(parseFloat(e[a].data[c].x)));
      else u ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(e[a].data[c].x)) : (o.isXNumeric = !0, o.dataFormatXNumeric = !0, this.twoDSeriesX.push(e[a].data[c].x));
    }
    if (e[t].data[0] && e[t].data[0].z !== void 0) {
      for (var f = 0; f < e[t].data.length; f++) this.threeDSeries.push(e[t].data[f].z);
      o.isDataXYZ = !0;
    }
  } }, { key: "handleRangeData", value: function(e, t) {
    var n = this.w.globals, o = {};
    return this.isFormat2DArray() ? o = this.handleRangeDataFormat("array", e, t) : this.isFormatXY() && (o = this.handleRangeDataFormat("xy", e, t)), n.seriesRangeStart[t] = o.start === void 0 ? [] : o.start, n.seriesRangeEnd[t] = o.end === void 0 ? [] : o.end, n.seriesRange[t] = o.rangeUniques, n.seriesRange.forEach((function(i, a) {
      i && i.forEach((function(s, c) {
        s.y.forEach((function(d, u) {
          for (var p = 0; p < s.y.length; p++) if (u !== p) {
            var h = d.y1, f = d.y2, m = s.y[p].y1;
            h <= s.y[p].y2 && m <= f && (s.overlaps.indexOf(d.rangeName) < 0 && s.overlaps.push(d.rangeName), s.overlaps.indexOf(s.y[p].rangeName) < 0 && s.overlaps.push(s.y[p].rangeName));
          }
        }));
      }));
    })), o;
  } }, { key: "handleCandleStickBoxData", value: function(e, t) {
    var n = this.w.globals, o = {};
    return this.isFormat2DArray() ? o = this.handleCandleStickBoxDataFormat("array", e, t) : this.isFormatXY() && (o = this.handleCandleStickBoxDataFormat("xy", e, t)), n.seriesCandleO[t] = o.o, n.seriesCandleH[t] = o.h, n.seriesCandleM[t] = o.m, n.seriesCandleL[t] = o.l, n.seriesCandleC[t] = o.c, o;
  } }, { key: "handleRangeDataFormat", value: function(e, t, n) {
    var o = [], i = [], a = t[n].data.filter((function(u, p, h) {
      return p === h.findIndex((function(f) {
        return f.x === u.x;
      }));
    })).map((function(u, p) {
      return { x: u.x, overlaps: [], y: [] };
    }));
    if (e === "array") for (var s = 0; s < t[n].data.length; s++) Array.isArray(t[n].data[s]) ? (o.push(t[n].data[s][1][0]), i.push(t[n].data[s][1][1])) : (o.push(t[n].data[s]), i.push(t[n].data[s]));
    else if (e === "xy") for (var c = function(u) {
      var p = Array.isArray(t[n].data[u].y), h = $.randomId(), f = t[n].data[u].x, m = { y1: p ? t[n].data[u].y[0] : t[n].data[u].y, y2: p ? t[n].data[u].y[1] : t[n].data[u].y, rangeName: h };
      t[n].data[u].rangeName = h;
      var g = a.findIndex((function(b) {
        return b.x === f;
      }));
      a[g].y.push(m), o.push(m.y1), i.push(m.y2);
    }, d = 0; d < t[n].data.length; d++) c(d);
    return { start: o, end: i, rangeUniques: a };
  } }, { key: "handleCandleStickBoxDataFormat", value: function(e, t, n) {
    var o = this.w, i = o.config.chart.type === "boxPlot" || o.config.series[n].type === "boxPlot", a = [], s = [], c = [], d = [], u = [];
    if (e === "array") if (i && t[n].data[0].length === 6 || !i && t[n].data[0].length === 5) for (var p = 0; p < t[n].data.length; p++) a.push(t[n].data[p][1]), s.push(t[n].data[p][2]), i ? (c.push(t[n].data[p][3]), d.push(t[n].data[p][4]), u.push(t[n].data[p][5])) : (d.push(t[n].data[p][3]), u.push(t[n].data[p][4]));
    else for (var h = 0; h < t[n].data.length; h++) Array.isArray(t[n].data[h][1]) && (a.push(t[n].data[h][1][0]), s.push(t[n].data[h][1][1]), i ? (c.push(t[n].data[h][1][2]), d.push(t[n].data[h][1][3]), u.push(t[n].data[h][1][4])) : (d.push(t[n].data[h][1][2]), u.push(t[n].data[h][1][3])));
    else if (e === "xy") for (var f = 0; f < t[n].data.length; f++) Array.isArray(t[n].data[f].y) && (a.push(t[n].data[f].y[0]), s.push(t[n].data[f].y[1]), i ? (c.push(t[n].data[f].y[2]), d.push(t[n].data[f].y[3]), u.push(t[n].data[f].y[4])) : (d.push(t[n].data[f].y[2]), u.push(t[n].data[f].y[3])));
    return { o: a, h: s, m: c, l: d, c: u };
  } }, { key: "parseDataAxisCharts", value: function(e) {
    var t = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.ctx, o = this.w.config, i = this.w.globals, a = new Dt(n), s = o.labels.length > 0 ? o.labels.slice() : o.xaxis.categories.slice();
    i.isRangeBar = o.chart.type === "rangeBar" && i.isBarHorizontal, i.hasXaxisGroups = o.xaxis.type === "category" && o.xaxis.group.groups.length > 0, i.hasXaxisGroups && (i.groups = o.xaxis.group.groups), e.forEach((function(f, m) {
      f.name !== void 0 ? i.seriesNames.push(f.name) : i.seriesNames.push("series-" + parseInt(m + 1, 10));
    })), this.coreUtils.setSeriesYAxisMappings();
    var c = [], d = Mt(new Set(o.series.map((function(f) {
      return f.group;
    }))));
    o.series.forEach((function(f, m) {
      var g = d.indexOf(f.group);
      c[g] || (c[g] = []), c[g].push(i.seriesNames[m]);
    })), i.seriesGroups = c;
    for (var u = function() {
      for (var f = 0; f < s.length; f++) if (typeof s[f] == "string") {
        if (!a.isValidDate(s[f])) throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");
        t.twoDSeriesX.push(a.parseDate(s[f]));
      } else t.twoDSeriesX.push(s[f]);
    }, p = 0; p < e.length; p++) {
      if (this.twoDSeries = [], this.twoDSeriesX = [], this.threeDSeries = [], e[p].data === void 0) return void console.error("It is a possibility that you may have not included 'data' property in series.");
      if (o.chart.type !== "rangeBar" && o.chart.type !== "rangeArea" && e[p].type !== "rangeBar" && e[p].type !== "rangeArea" || (i.isRangeData = !0, this.handleRangeData(e, p)), this.isMultiFormat()) this.isFormat2DArray() ? this.handleFormat2DArray(e, p) : this.isFormatXY() && this.handleFormatXY(e, p), o.chart.type !== "candlestick" && e[p].type !== "candlestick" && o.chart.type !== "boxPlot" && e[p].type !== "boxPlot" || this.handleCandleStickBoxData(e, p), i.series.push(this.twoDSeries), i.labels.push(this.twoDSeriesX), i.seriesX.push(this.twoDSeriesX), i.seriesGoals = this.seriesGoals, p !== this.activeSeriesIndex || this.fallbackToCategory || (i.isXNumeric = !0);
      else {
        o.xaxis.type === "datetime" ? (i.isXNumeric = !0, u(), i.seriesX.push(this.twoDSeriesX)) : o.xaxis.type === "numeric" && (i.isXNumeric = !0, s.length > 0 && (this.twoDSeriesX = s, i.seriesX.push(this.twoDSeriesX))), i.labels.push(this.twoDSeriesX);
        var h = e[p].data.map((function(f) {
          return $.parseNumber(f);
        }));
        i.series.push(h);
      }
      i.seriesZ.push(this.threeDSeries), e[p].color !== void 0 ? i.seriesColors.push(e[p].color) : i.seriesColors.push(void 0);
    }
    return this.w;
  } }, { key: "parseDataNonAxisCharts", value: function(e) {
    var t = this.w.globals, n = this.w.config, o = Array.isArray(e) && e.every((function(u) {
      return typeof u == "number";
    })) && n.labels.length > 0, i = Array.isArray(e) && e.some((function(u) {
      return u && Vt(u) === "object" && u.data || u && Vt(u) === "object" && u.parsing;
    }));
    if (o && i && console.warn("ApexCharts: Both old format (numeric series + labels) and new format (series objects with data/parsing) detected. Using old format for backward compatibility."), o) {
      t.series = e.slice(), t.seriesNames = n.labels.slice();
      for (var a = 0; a < t.series.length; a++) t.seriesNames[a] === void 0 && t.seriesNames.push("series-" + (a + 1));
      return this.w;
    }
    if (Array.isArray(e) && e.every((function(u) {
      return typeof u == "number";
    }))) {
      t.series = e.slice(), t.seriesNames = [];
      for (var s = 0; s < t.series.length; s++) t.seriesNames.push(n.labels[s] || "series-".concat(s + 1));
      return this.w;
    }
    var c = this.extractPieDataFromSeries(e);
    t.series = c.values, t.seriesNames = c.labels, n.chart.type === "radialBar" && (t.series = t.series.map((function(u) {
      var p = $.parseNumber(u);
      return p > 100 && console.warn("ApexCharts: RadialBar value ".concat(p, " > 100, consider using percentage values (0-100)")), p;
    })));
    for (var d = 0; d < t.series.length; d++) t.seriesNames[d] === void 0 && t.seriesNames.push("series-" + (d + 1));
    return this.w;
  } }, { key: "resetParsingFlags", value: function() {
    var e = this.w;
    e.globals.dataWasParsed = !1, e.globals.originalSeries = null, e.config.series && e.config.series.forEach((function(t) {
      t.__apexParsed && delete t.__apexParsed;
    }));
  } }, { key: "extractPieDataFromSeries", value: function(e) {
    var t = [], n = [];
    if (!Array.isArray(e)) return console.warn("ApexCharts: Expected array for series data"), { values: [], labels: [] };
    if (e.length === 0) return console.warn("ApexCharts: Empty series array"), { values: [], labels: [] };
    var o = e[0];
    return Vt(o) === "object" && o !== null && o.data ? (this.extractPieDataFromSeriesObjects(e, t, n), { values: t, labels: n }) : (console.warn("ApexCharts: Unsupported series format for pie/donut/radialBar. Expected series objects with data property."), { values: [], labels: [] });
  } }, { key: "extractPieDataFromSeriesObjects", value: function(e, t, n) {
    e.forEach((function(o, i) {
      o.data && Array.isArray(o.data) ? o.data.forEach((function(a) {
        Vt(a) === "object" && a !== null ? a.x !== void 0 && a.y !== void 0 ? (n.push(String(a.x)), t.push($.parseNumber(a.y))) : console.warn("ApexCharts: Invalid data point format for pie chart. Expected {x, y} format:", a) : console.warn("ApexCharts: Expected object data point, got:", Vt(a));
      })) : console.warn("ApexCharts: Series ".concat(i, " has no valid data array"));
    }));
  } }, { key: "handleExternalLabelsData", value: function(e) {
    var t = this.w.config, n = this.w.globals;
    t.xaxis.categories.length > 0 ? n.labels = t.xaxis.categories : t.labels.length > 0 ? n.labels = t.labels.slice() : this.fallbackToCategory ? (n.labels = n.labels[0], n.seriesRange.length && (n.seriesRange.map((function(o) {
      o.forEach((function(i) {
        n.labels.indexOf(i.x) < 0 && i.x && n.labels.push(i.x);
      }));
    })), n.labels = Array.from(new Set(n.labels.map(JSON.stringify)), JSON.parse)), t.xaxis.convertedCatToNumeric && (new Xi(t).convertCatToNumericXaxis(t, this.ctx, n.seriesX[0]), this._generateExternalLabels(e))) : this._generateExternalLabels(e);
  } }, { key: "_generateExternalLabels", value: function(e) {
    var t = this.w.globals, n = this.w.config, o = [];
    if (t.axisCharts) {
      if (t.series.length > 0) if (this.isFormatXY()) for (var i = n.series.map((function(p, h) {
        return p.data.filter((function(f, m, g) {
          return g.findIndex((function(b) {
            return b.x === f.x;
          })) === m;
        }));
      })), a = i.reduce((function(p, h, f, m) {
        return m[p].length > h.length ? p : f;
      }), 0), s = 0; s < i[a].length; s++) o.push(s + 1);
      else for (var c = 0; c < t.series[t.maxValsInArrayIndex].length; c++) o.push(c + 1);
      t.seriesX = [];
      for (var d = 0; d < e.length; d++) t.seriesX.push(o);
      this.w.globals.isBarHorizontal || (t.isXNumeric = !0);
    }
    if (o.length === 0) {
      o = t.axisCharts ? [] : t.series.map((function(p, h) {
        return h + 1;
      }));
      for (var u = 0; u < e.length; u++) t.seriesX.push(o);
    }
    t.labels = o, n.xaxis.convertedCatToNumeric && (t.categoryLabels = o.map((function(p) {
      return n.xaxis.labels.formatter(p);
    }))), t.noLabelsProvided = !0;
  } }, { key: "parseRawDataIfNeeded", value: function(e) {
    var t = this, n = this.w.config, o = this.w.globals, i = n.parsing;
    if (o.dataWasParsed || !i && !e.some((function(s) {
      return s.parsing;
    }))) return e;
    var a = e.map((function(s, c) {
      var d, u, p;
      if (!s.data || !Array.isArray(s.data) || s.data.length === 0) return s;
      var h = { x: ((d = s.parsing) === null || d === void 0 ? void 0 : d.x) || i?.x, y: ((u = s.parsing) === null || u === void 0 ? void 0 : u.y) || i?.y, z: ((p = s.parsing) === null || p === void 0 ? void 0 : p.z) || i?.z };
      if (!h.x && !h.y) return s;
      var f = s.data[0];
      if (Vt(f) === "object" && f !== null && (f.hasOwnProperty("x") || f.hasOwnProperty("y")) || Array.isArray(f)) return s;
      if (!h.x || !h.y || Array.isArray(h.y) && h.y.length === 0) return console.warn("ApexCharts: Series ".concat(c, " has parsing config but missing x or y field specification")), s;
      var m = s.data.map((function(g, b) {
        if (Vt(g) !== "object" || g === null) return console.warn("ApexCharts: Series ".concat(c, ", data point ").concat(b, " is not an object, skipping parsing")), g;
        var x, v = t.getNestedValue(g, h.x), y = void 0;
        if (Array.isArray(h.y)) {
          var C = h.y.map((function(S) {
            return t.getNestedValue(g, S);
          }));
          x = t.w.config.chart.type === "bubble" && C.length === 2 ? C[0] : C;
        } else x = t.getNestedValue(g, h.y);
        h.z && (y = t.getNestedValue(g, h.z)), v === void 0 && console.warn("ApexCharts: Series ".concat(c, ", data point ").concat(b, " missing field '").concat(h.x, "'")), x === void 0 && console.warn("ApexCharts: Series ".concat(c, ", data point ").concat(b, " missing field '").concat(h.y, "'"));
        var k = { x: v, y: x };
        if (t.w.config.chart.type === "bubble" && Array.isArray(h.y) && h.y.length === 2) {
          var T = t.getNestedValue(g, h.y[1]);
          T !== void 0 && (k.z = T);
        }
        return y !== void 0 && (k.z = y), k;
      }));
      return ie(ie({}, s), {}, { data: m, __apexParsed: !0 });
    }));
    return o.dataWasParsed = !0, o.originalSeries || (o.originalSeries = $.clone(e)), a;
  } }, { key: "getNestedValue", value: function(e, t) {
    if (e && Vt(e) === "object" && t) {
      if (t.indexOf(".") === -1) return e[t];
      for (var n = t.split("."), o = e, i = 0; i < n.length; i++) {
        if (o == null || Vt(o) !== "object") return;
        o = o[n[i]];
      }
      return o;
    }
  } }, { key: "parseData", value: function(e) {
    var t = this.w, n = t.config, o = t.globals;
    if (e = this.parseRawDataIfNeeded(e), n.series = e, o.initialSeries = $.clone(e), this.excludeCollapsedSeriesInYAxis(), this.fallbackToCategory = !1, this.ctx.core.resetGlobals(), this.ctx.core.isMultipleY(), o.axisCharts ? (this.parseDataAxisCharts(e), this.coreUtils.getLargestSeries()) : this.parseDataNonAxisCharts(e), n.chart.stacked) {
      var i = new mr(this.ctx);
      o.series = i.setNullSeriesToZeroValues(o.series);
    }
    this.coreUtils.getSeriesTotals(), o.axisCharts && (o.stackedSeriesTotals = this.coreUtils.getStackedSeriesTotals(), o.stackedSeriesTotalsByGroups = this.coreUtils.getStackedSeriesTotalsByGroups()), this.coreUtils.getPercentSeries(), o.dataFormatXNumeric || o.isXNumeric && (n.xaxis.type !== "numeric" || n.labels.length !== 0 || n.xaxis.categories.length !== 0) || this.handleExternalLabelsData(e);
    for (var a = this.coreUtils.getCategoryLabels(o.labels), s = 0; s < a.length; s++) if (Array.isArray(a[s])) {
      o.isMultiLineX = !0;
      break;
    }
  } }, { key: "excludeCollapsedSeriesInYAxis", value: function() {
    var e = this.w, t = [];
    e.globals.seriesYAxisMap.forEach((function(n, o) {
      var i = 0;
      n.forEach((function(a) {
        e.globals.collapsedSeriesIndices.indexOf(a) !== -1 && i++;
      })), i > 0 && i == n.length && t.push(o);
    })), e.globals.ignoreYAxisIndexes = t.map((function(n) {
      return n;
    }));
  } }]), r;
})(), Ei = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "svgStringToNode", value: function(e) {
    return new DOMParser().parseFromString(e, "image/svg+xml").documentElement;
  } }, { key: "scaleSvgNode", value: function(e, t) {
    var n = parseFloat(e.getAttributeNS(null, "width")), o = parseFloat(e.getAttributeNS(null, "height"));
    e.setAttributeNS(null, "width", n * t), e.setAttributeNS(null, "height", o * t), e.setAttributeNS(null, "viewBox", "0 0 " + n + " " + o);
  } }, { key: "getSvgString", value: function(e) {
    var t = this;
    return new Promise((function(n) {
      var o = t.w, i = e || o.config.chart.toolbar.export.scale || o.config.chart.toolbar.export.width / o.globals.svgWidth;
      i || (i = 1);
      var a = o.globals.svgWidth * i, s = o.globals.svgHeight * i, c = o.globals.dom.elWrap.cloneNode(!0);
      c.style.width = a + "px", c.style.height = s + "px";
      var d = new XMLSerializer().serializeToString(c), u = `
        .apexcharts-tooltip, .apexcharts-toolbar, .apexcharts-xaxistooltip, .apexcharts-yaxistooltip, .apexcharts-xcrosshairs, .apexcharts-ycrosshairs, .apexcharts-zoom-rect, .apexcharts-selection-rect {
          display: none;
        }
      `;
      o.config.legend.show && o.globals.dom.elLegendWrap && o.globals.dom.elLegendWrap.children.length > 0 && (u += Hm);
      var p = `
        <svg xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          class="apexcharts-svg"
          xmlns:data="ApexChartsNS"
          transform="translate(0, 0)"
          width="`.concat(o.globals.svgWidth, 'px" height="').concat(o.globals.svgHeight, `px">
          <foreignObject width="100%" height="100%">
            <div xmlns="http://www.w3.org/1999/xhtml" style="width:`).concat(a, "px; height:").concat(s, `px;">
            <style type="text/css">
              `).concat(u, `
            </style>
              `).concat(d, `
            </div>
          </foreignObject>
        </svg>
      `), h = t.svgStringToNode(p);
      i !== 1 && t.scaleSvgNode(h, i), t.convertImagesToBase64(h).then((function() {
        p = new XMLSerializer().serializeToString(h), n(p.replace(/&nbsp;/g, "&#160;"));
      }));
    }));
  } }, { key: "convertImagesToBase64", value: function(e) {
    var t = this, n = e.getElementsByTagName("image"), o = Array.from(n).map((function(i) {
      var a = i.getAttributeNS("http://www.w3.org/1999/xlink", "href");
      return a && !a.startsWith("data:") ? t.getBase64FromUrl(a).then((function(s) {
        i.setAttributeNS("http://www.w3.org/1999/xlink", "href", s);
      })).catch((function(s) {
        console.error("Error converting image to base64:", s);
      })) : Promise.resolve();
    }));
    return Promise.all(o);
  } }, { key: "getBase64FromUrl", value: function(e) {
    return new Promise((function(t, n) {
      var o = new Image();
      o.crossOrigin = "Anonymous", o.onload = function() {
        var i = document.createElement("canvas");
        i.width = o.width, i.height = o.height, i.getContext("2d").drawImage(o, 0, 0), t(i.toDataURL());
      }, o.onerror = n, o.src = e;
    }));
  } }, { key: "svgUrl", value: function() {
    var e = this;
    return new Promise((function(t) {
      e.getSvgString().then((function(n) {
        var o = new Blob([n], { type: "image/svg+xml;charset=utf-8" });
        t(URL.createObjectURL(o));
      }));
    }));
  } }, { key: "dataURI", value: function(e) {
    var t = this;
    return new Promise((function(n) {
      var o = t.w, i = e ? e.scale || e.width / o.globals.svgWidth : 1, a = document.createElement("canvas");
      a.width = o.globals.svgWidth * i, a.height = parseInt(o.globals.dom.elWrap.style.height, 10) * i;
      var s = o.config.chart.background !== "transparent" && o.config.chart.background ? o.config.chart.background : "#fff", c = a.getContext("2d");
      c.fillStyle = s, c.fillRect(0, 0, a.width * i, a.height * i), t.getSvgString(i).then((function(d) {
        var u = "data:image/svg+xml," + encodeURIComponent(d), p = new Image();
        p.crossOrigin = "anonymous", p.onload = function() {
          if (c.drawImage(p, 0, 0), a.msToBlob) {
            var h = a.msToBlob();
            n({ blob: h });
          } else {
            var f = a.toDataURL("image/png");
            n({ imgURI: f });
          }
        }, p.src = u;
      }));
    }));
  } }, { key: "exportToSVG", value: function() {
    var e = this;
    this.svgUrl().then((function(t) {
      e.triggerDownload(t, e.w.config.chart.toolbar.export.svg.filename, ".svg");
    }));
  } }, { key: "exportToPng", value: function() {
    var e = this, t = this.w.config.chart.toolbar.export.scale, n = this.w.config.chart.toolbar.export.width, o = t ? { scale: t } : n ? { width: n } : void 0;
    this.dataURI(o).then((function(i) {
      var a = i.imgURI, s = i.blob;
      s ? navigator.msSaveOrOpenBlob(s, e.w.globals.chartID + ".png") : e.triggerDownload(a, e.w.config.chart.toolbar.export.png.filename, ".png");
    }));
  } }, { key: "exportToCSV", value: function(e) {
    var t = this, n = e.series, o = e.fileName, i = e.columnDelimiter, a = i === void 0 ? "," : i, s = e.lineDelimiter, c = s === void 0 ? `
` : s, d = this.w;
    n || (n = d.config.series);
    var u = [], p = [], h = "", f = d.globals.series.map((function(k, T) {
      return d.globals.collapsedSeriesIndices.indexOf(T) === -1 ? k : [];
    })), m = function(k) {
      return typeof d.config.chart.toolbar.export.csv.categoryFormatter == "function" ? d.config.chart.toolbar.export.csv.categoryFormatter(k) : d.config.xaxis.type === "datetime" && String(k).length >= 10 ? new Date(k).toDateString() : $.isNumber(k) ? k : k.split(a).join("");
    }, g = function(k) {
      return typeof d.config.chart.toolbar.export.csv.valueFormatter == "function" ? d.config.chart.toolbar.export.csv.valueFormatter(k) : k;
    }, b = Math.max.apply(Math, Mt(n.map((function(k) {
      return k.data ? k.data.length : 0;
    })))), x = new zd(this.ctx), v = new pn(this.ctx), y = function(k) {
      var T = "";
      if (d.globals.axisCharts) {
        if (d.config.xaxis.type === "category" || d.config.xaxis.convertedCatToNumeric) if (d.globals.isBarHorizontal) {
          var S = d.globals.yLabelFormatters[0], O = new mr(t.ctx).getActiveConfigSeriesIndex();
          T = S(d.globals.labels[k], { seriesIndex: O, dataPointIndex: k, w: d });
        } else T = v.getLabel(d.globals.labels, d.globals.timescaleLabels, 0, k).text;
        d.config.xaxis.type === "datetime" && (d.config.xaxis.categories.length ? T = d.config.xaxis.categories[k] : d.config.labels.length && (T = d.config.labels[k]));
      } else T = d.config.labels[k];
      return T === null ? "nullvalue" : (Array.isArray(T) && (T = T.join(" ")), $.isNumber(T) ? T : T.split(a).join(""));
    }, C = function(k, T) {
      if (u.length && T === 0 && p.push(u.join(a)), k.data) {
        k.data = k.data.length && k.data || Mt(Array(b)).map((function() {
          return "";
        }));
        for (var S = 0; S < k.data.length; S++) {
          u = [];
          var O = y(S);
          if (O !== "nullvalue") {
            if (O || (x.isFormatXY() ? O = n[T].data[S].x : x.isFormat2DArray() && (O = n[T].data[S] ? n[T].data[S][0] : "")), T === 0) {
              u.push(m(O));
              for (var P = 0; P < d.globals.series.length; P++) {
                var M, I = x.isFormatXY() ? (M = n[P].data[S]) === null || M === void 0 ? void 0 : M.y : f[P][S];
                u.push(g(I));
              }
            }
            (d.config.chart.type === "candlestick" || k.type && k.type === "candlestick") && (u.pop(), u.push(d.globals.seriesCandleO[T][S]), u.push(d.globals.seriesCandleH[T][S]), u.push(d.globals.seriesCandleL[T][S]), u.push(d.globals.seriesCandleC[T][S])), (d.config.chart.type === "boxPlot" || k.type && k.type === "boxPlot") && (u.pop(), u.push(d.globals.seriesCandleO[T][S]), u.push(d.globals.seriesCandleH[T][S]), u.push(d.globals.seriesCandleM[T][S]), u.push(d.globals.seriesCandleL[T][S]), u.push(d.globals.seriesCandleC[T][S])), d.config.chart.type === "rangeBar" && (u.pop(), u.push(d.globals.seriesRangeStart[T][S]), u.push(d.globals.seriesRangeEnd[T][S])), u.length && p.push(u.join(a));
          }
        }
      }
    };
    u.push(d.config.chart.toolbar.export.csv.headerCategory), d.config.chart.type === "boxPlot" ? (u.push("minimum"), u.push("q1"), u.push("median"), u.push("q3"), u.push("maximum")) : d.config.chart.type === "candlestick" ? (u.push("open"), u.push("high"), u.push("low"), u.push("close")) : d.config.chart.type === "rangeBar" ? (u.push("minimum"), u.push("maximum")) : n.map((function(k, T) {
      var S = (k.name ? k.name : "series-".concat(T)) + "";
      d.globals.axisCharts && u.push(S.split(a).join("") ? S.split(a).join("") : "series-".concat(T));
    })), d.globals.axisCharts || (u.push(d.config.chart.toolbar.export.csv.headerValue), p.push(u.join(a))), d.globals.allSeriesHasEqualX || !d.globals.axisCharts || d.config.xaxis.categories.length || d.config.labels.length ? n.map((function(k, T) {
      d.globals.axisCharts ? C(k, T) : ((u = []).push(m(d.globals.labels[T])), u.push(g(f[T])), p.push(u.join(a)));
    })) : (function() {
      var k = /* @__PURE__ */ new Set(), T = {};
      n.forEach((function(S, O) {
        S?.data.forEach((function(P) {
          var M, I;
          if (x.isFormatXY()) M = P.x, I = P.y;
          else {
            if (!x.isFormat2DArray()) return;
            M = P[0], I = P[1];
          }
          T[M] || (T[M] = Array(n.length).fill("")), T[M][O] = g(I), k.add(M);
        }));
      })), u.length && p.push(u.join(a)), Array.from(k).sort().forEach((function(S) {
        p.push([m(S), T[S].join(a)]);
      }));
    })(), h += p.join(c), this.triggerDownload("data:text/csv; charset=utf-8," + encodeURIComponent("\uFEFF" + h), o || d.config.chart.toolbar.export.csv.filename, ".csv");
  } }, { key: "triggerDownload", value: function(e, t, n) {
    var o = document.createElement("a");
    o.href = e, o.download = (t || this.w.globals.chartID) + n, document.body.appendChild(o), o.click(), document.body.removeChild(o);
  } }]), r;
})(), Ui = (function() {
  function r(e, t) {
    xe(this, r), this.ctx = e, this.elgrid = t, this.w = e.w;
    var n = this.w;
    this.axesUtils = new pn(e), this.xaxisLabels = n.globals.labels.slice(), n.globals.timescaleLabels.length > 0 && !n.globals.isBarHorizontal && (this.xaxisLabels = n.globals.timescaleLabels.slice()), n.config.xaxis.overwriteCategories && (this.xaxisLabels = n.config.xaxis.overwriteCategories), this.drawnLabels = [], this.drawnLabelsRects = [], n.config.xaxis.position === "top" ? this.offY = 0 : this.offY = n.globals.gridHeight, this.offY = this.offY + n.config.xaxis.axisBorder.offsetY, this.isCategoryBarHorizontal = n.config.chart.type === "bar" && n.config.plotOptions.bar.horizontal, this.xaxisFontSize = n.config.xaxis.labels.style.fontSize, this.xaxisFontFamily = n.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = n.config.xaxis.labels.style.colors, this.xaxisBorderWidth = n.config.xaxis.axisBorder.width, this.isCategoryBarHorizontal && (this.xaxisBorderWidth = n.config.yaxis[0].axisBorder.width.toString()), String(this.xaxisBorderWidth).indexOf("%") > -1 ? this.xaxisBorderWidth = n.globals.gridWidth * parseInt(this.xaxisBorderWidth, 10) / 100 : this.xaxisBorderWidth = parseInt(this.xaxisBorderWidth, 10), this.xaxisBorderHeight = n.config.xaxis.axisBorder.height, this.yaxis = n.config.yaxis[0];
  }
  return ve(r, [{ key: "drawXaxis", value: function() {
    var e = this.w, t = new ee(this.ctx), n = t.group({ class: "apexcharts-xaxis", transform: "translate(".concat(e.config.xaxis.offsetX, ", ").concat(e.config.xaxis.offsetY, ")") }), o = t.group({ class: "apexcharts-xaxis-texts-g", transform: "translate(".concat(e.globals.translateXAxisX, ", ").concat(e.globals.translateXAxisY, ")") });
    n.add(o);
    for (var i = [], a = 0; a < this.xaxisLabels.length; a++) i.push(this.xaxisLabels[a]);
    if (this.drawXAxisLabelAndGroup(!0, t, o, i, e.globals.isXNumeric, (function(m, g) {
      return g;
    })), e.globals.hasXaxisGroups) {
      var s = e.globals.groups;
      i = [];
      for (var c = 0; c < s.length; c++) i.push(s[c].title);
      var d = {};
      e.config.xaxis.group.style && (d.xaxisFontSize = e.config.xaxis.group.style.fontSize, d.xaxisFontFamily = e.config.xaxis.group.style.fontFamily, d.xaxisForeColors = e.config.xaxis.group.style.colors, d.fontWeight = e.config.xaxis.group.style.fontWeight, d.cssClass = e.config.xaxis.group.style.cssClass), this.drawXAxisLabelAndGroup(!1, t, o, i, !1, (function(m, g) {
        return s[m].cols * g;
      }), d);
    }
    if (e.config.xaxis.title.text !== void 0) {
      var u = t.group({ class: "apexcharts-xaxis-title" }), p = t.drawText({ x: e.globals.gridWidth / 2 + e.config.xaxis.title.offsetX, y: this.offY + parseFloat(this.xaxisFontSize) + (e.config.xaxis.position === "bottom" ? e.globals.xAxisLabelsHeight : -e.globals.xAxisLabelsHeight - 10) + e.config.xaxis.title.offsetY, text: e.config.xaxis.title.text, textAnchor: "middle", fontSize: e.config.xaxis.title.style.fontSize, fontFamily: e.config.xaxis.title.style.fontFamily, fontWeight: e.config.xaxis.title.style.fontWeight, foreColor: e.config.xaxis.title.style.color, cssClass: "apexcharts-xaxis-title-text " + e.config.xaxis.title.style.cssClass });
      u.add(p), n.add(u);
    }
    if (e.config.xaxis.axisBorder.show) {
      var h = e.globals.barPadForNumericAxis, f = t.drawLine(e.globals.padHorizontal + e.config.xaxis.axisBorder.offsetX - h, this.offY, this.xaxisBorderWidth + h, this.offY, e.config.xaxis.axisBorder.color, 0, this.xaxisBorderHeight);
      this.elgrid && this.elgrid.elGridBorders && e.config.grid.show ? this.elgrid.elGridBorders.add(f) : n.add(f);
    }
    return n;
  } }, { key: "drawXAxisLabelAndGroup", value: function(e, t, n, o, i, a) {
    var s, c = this, d = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, u = [], p = [], h = this.w, f = d.xaxisFontSize || this.xaxisFontSize, m = d.xaxisFontFamily || this.xaxisFontFamily, g = d.xaxisForeColors || this.xaxisForeColors, b = d.fontWeight || h.config.xaxis.labels.style.fontWeight, x = d.cssClass || h.config.xaxis.labels.style.cssClass, v = h.globals.padHorizontal, y = o.length, C = h.config.xaxis.type === "category" ? h.globals.dataPoints : y;
    if (C === 0 && y > C && (C = y), i) {
      var k = Math.max(Number(h.config.xaxis.tickAmount) || 1, C > 1 ? C - 1 : C);
      s = h.globals.gridWidth / Math.min(k, y - 1), v = v + a(0, s) / 2 + h.config.xaxis.labels.offsetX;
    } else s = h.globals.gridWidth / C, v = v + a(0, s) + h.config.xaxis.labels.offsetX;
    for (var T = function(O) {
      var P = v - a(O, s) / 2 + h.config.xaxis.labels.offsetX;
      O === 0 && y === 1 && s / 2 === v && C === 1 && (P = h.globals.gridWidth / 2);
      var M = c.axesUtils.getLabel(o, h.globals.timescaleLabels, P, O, u, f, e), I = 28;
      if (h.globals.rotateXLabels && e && (I = 22), h.config.xaxis.title.text && h.config.xaxis.position === "top" && (I += parseFloat(h.config.xaxis.title.style.fontSize) + 2), e || (I = I + parseFloat(f) + (h.globals.xAxisLabelsHeight - h.globals.xAxisGroupLabelsHeight) + (h.globals.rotateXLabels ? 10 : 0)), M = h.config.xaxis.tickAmount !== void 0 && h.config.xaxis.tickAmount !== "dataPoints" && h.config.xaxis.type !== "datetime" ? c.axesUtils.checkLabelBasedOnTickamount(O, M, y) : c.axesUtils.checkForOverflowingLabels(O, M, y, u, p), h.config.xaxis.labels.show) {
        var E = t.drawText({ x: M.x, y: c.offY + h.config.xaxis.labels.offsetY + I - (h.config.xaxis.position === "top" ? h.globals.xAxisHeight + h.config.xaxis.axisTicks.height - 2 : 0), text: M.text, textAnchor: "middle", fontWeight: M.isBold ? 600 : b, fontSize: f, fontFamily: m, foreColor: Array.isArray(g) ? e && h.config.xaxis.convertedCatToNumeric ? g[h.globals.minX + O - 1] : g[O] : g, isPlainText: !1, cssClass: (e ? "apexcharts-xaxis-label " : "apexcharts-xaxis-group-label ") + x });
        if (n.add(E), E.on("click", (function(L) {
          if (typeof h.config.chart.events.xAxisLabelClick == "function") {
            var z = Object.assign({}, h, { labelIndex: O });
            h.config.chart.events.xAxisLabelClick(L, c.ctx, z);
          }
        })), e) {
          var N = document.createElementNS(h.globals.SVGNS, "title");
          N.textContent = Array.isArray(M.text) ? M.text.join(" ") : M.text, E.node.appendChild(N), M.text !== "" && (u.push(M.text), p.push(M));
        }
      }
      O < y - 1 && (v += a(O + 1, s));
    }, S = 0; S <= y - 1; S++) T(S);
  } }, { key: "drawXaxisInversed", value: function(e) {
    var t, n, o = this, i = this.w, a = new ee(this.ctx), s = i.config.yaxis[0].opposite ? i.globals.translateYAxisX[e] : 0, c = a.group({ class: "apexcharts-yaxis apexcharts-xaxis-inversed", rel: e }), d = a.group({ class: "apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g", transform: "translate(" + s + ", 0)" });
    c.add(d);
    var u = [];
    if (i.config.yaxis[e].show) for (var p = 0; p < this.xaxisLabels.length; p++) u.push(this.xaxisLabels[p]);
    t = i.globals.gridHeight / u.length, n = -t / 2.2;
    var h = i.globals.yLabelFormatters[0], f = i.config.yaxis[0].labels;
    if (f.show) for (var m = function(k) {
      var T = u[k] === void 0 ? "" : u[k];
      T = h(T, { seriesIndex: e, dataPointIndex: k, w: i });
      var S = o.axesUtils.getYAxisForeColor(f.style.colors, e), O = 0;
      Array.isArray(T) && (O = T.length / 2 * parseInt(f.style.fontSize, 10));
      var P = f.offsetX - 15, M = "end";
      o.yaxis.opposite && (M = "start"), i.config.yaxis[0].labels.align === "left" ? (P = f.offsetX, M = "start") : i.config.yaxis[0].labels.align === "center" ? (P = f.offsetX, M = "middle") : i.config.yaxis[0].labels.align === "right" && (M = "end");
      var I = a.drawText({ x: P, y: n + t + f.offsetY - O, text: T, textAnchor: M, foreColor: Array.isArray(S) ? S[k] : S, fontSize: f.style.fontSize, fontFamily: f.style.fontFamily, fontWeight: f.style.fontWeight, isPlainText: !1, cssClass: "apexcharts-yaxis-label " + f.style.cssClass, maxWidth: f.maxWidth });
      d.add(I), I.on("click", (function(L) {
        if (typeof i.config.chart.events.xAxisLabelClick == "function") {
          var z = Object.assign({}, i, { labelIndex: k });
          i.config.chart.events.xAxisLabelClick(L, o.ctx, z);
        }
      }));
      var E = document.createElementNS(i.globals.SVGNS, "title");
      if (E.textContent = Array.isArray(T) ? T.join(" ") : T, I.node.appendChild(E), i.config.yaxis[e].labels.rotate !== 0) {
        var N = a.rotateAroundCenter(I.node);
        I.node.setAttribute("transform", "rotate(".concat(i.config.yaxis[e].labels.rotate, " 0 ").concat(N.y, ")"));
      }
      n += t;
    }, g = 0; g <= u.length - 1; g++) m(g);
    if (i.config.yaxis[0].title.text !== void 0) {
      var b = a.group({ class: "apexcharts-yaxis-title apexcharts-xaxis-title-inversed", transform: "translate(" + s + ", 0)" }), x = a.drawText({ x: i.config.yaxis[0].title.offsetX, y: i.globals.gridHeight / 2 + i.config.yaxis[0].title.offsetY, text: i.config.yaxis[0].title.text, textAnchor: "middle", foreColor: i.config.yaxis[0].title.style.color, fontSize: i.config.yaxis[0].title.style.fontSize, fontWeight: i.config.yaxis[0].title.style.fontWeight, fontFamily: i.config.yaxis[0].title.style.fontFamily, cssClass: "apexcharts-yaxis-title-text " + i.config.yaxis[0].title.style.cssClass });
      b.add(x), c.add(b);
    }
    var v = 0;
    this.isCategoryBarHorizontal && i.config.yaxis[0].opposite && (v = i.globals.gridWidth);
    var y = i.config.xaxis.axisBorder;
    if (y.show) {
      var C = a.drawLine(i.globals.padHorizontal + y.offsetX + v, 1 + y.offsetY, i.globals.padHorizontal + y.offsetX + v, i.globals.gridHeight + y.offsetY, y.color, 0);
      this.elgrid && this.elgrid.elGridBorders && i.config.grid.show ? this.elgrid.elGridBorders.add(C) : c.add(C);
    }
    return i.config.yaxis[0].axisTicks.show && this.axesUtils.drawYAxisTicks(v, u.length, i.config.yaxis[0].axisBorder, i.config.yaxis[0].axisTicks, 0, t, c), c;
  } }, { key: "drawXaxisTicks", value: function(e, t, n) {
    var o = this.w, i = e;
    if (!(e < 0 || e - 2 > o.globals.gridWidth)) {
      var a = this.offY + o.config.xaxis.axisTicks.offsetY;
      if (t = t + a + o.config.xaxis.axisTicks.height, o.config.xaxis.position === "top" && (t = a - o.config.xaxis.axisTicks.height), o.config.xaxis.axisTicks.show) {
        var s = new ee(this.ctx).drawLine(e + o.config.xaxis.axisTicks.offsetX, a + o.config.xaxis.offsetY, i + o.config.xaxis.axisTicks.offsetX, t + o.config.xaxis.offsetY, o.config.xaxis.axisTicks.color);
        n.add(s), s.node.classList.add("apexcharts-xaxis-tick");
      }
    }
  } }, { key: "getXAxisTicksPositions", value: function() {
    var e = this.w, t = [], n = this.xaxisLabels.length, o = e.globals.padHorizontal;
    if (e.globals.timescaleLabels.length > 0) for (var i = 0; i < n; i++) o = this.xaxisLabels[i].position, t.push(o);
    else for (var a = n, s = 0; s < a; s++) {
      var c = a;
      e.globals.isXNumeric && e.config.chart.type !== "bar" && (c -= 1), o += e.globals.gridWidth / c, t.push(o);
    }
    return t;
  } }, { key: "xAxisLabelCorrections", value: function() {
    var e = this.w, t = new ee(this.ctx), n = e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"), o = e.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"), i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"), a = e.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");
    if (e.globals.rotateXLabels || e.config.xaxis.labels.rotateAlways) for (var s = 0; s < o.length; s++) {
      var c = t.rotateAroundCenter(o[s]);
      c.y = c.y - 1, c.x = c.x + 1, o[s].setAttribute("transform", "rotate(".concat(e.config.xaxis.labels.rotate, " ").concat(c.x, " ").concat(c.y, ")")), o[s].setAttribute("text-anchor", "end"), n.setAttribute("transform", "translate(0, ".concat(-10, ")"));
      var d = o[s].childNodes;
      e.config.xaxis.labels.trim && Array.prototype.forEach.call(d, (function(f) {
        t.placeTextWithEllipsis(f, f.textContent, e.globals.xAxisLabelsHeight - (e.config.legend.position === "bottom" ? 20 : 10));
      }));
    }
    else (function() {
      for (var f = e.globals.gridWidth / (e.globals.labels.length + 1), m = 0; m < o.length; m++) {
        var g = o[m].childNodes;
        e.config.xaxis.labels.trim && e.config.xaxis.type !== "datetime" && Array.prototype.forEach.call(g, (function(b) {
          t.placeTextWithEllipsis(b, b.textContent, f);
        }));
      }
    })();
    if (i.length > 0) {
      var u = i[i.length - 1].getBBox(), p = i[0].getBBox();
      u.x < -20 && i[i.length - 1].parentNode.removeChild(i[i.length - 1]), p.x + p.width > e.globals.gridWidth && !e.globals.isBarHorizontal && i[0].parentNode.removeChild(i[0]);
      for (var h = 0; h < a.length; h++) t.placeTextWithEllipsis(a[h], a[h].textContent, e.config.yaxis[0].labels.maxWidth - (e.config.yaxis[0].title.text ? 2 * parseFloat(e.config.yaxis[0].title.style.fontSize) : 0) - 15);
    }
  } }]), r;
})(), Ym = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
    var t = this.w;
    this.xaxisLabels = t.globals.labels.slice(), this.axesUtils = new pn(e), this.isRangeBar = t.globals.seriesRange.length && t.globals.isBarHorizontal, t.globals.timescaleLabels.length > 0 && (this.xaxisLabels = t.globals.timescaleLabels.slice());
  }
  return ve(r, [{ key: "drawGridArea", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, t = this.w, n = new ee(this.ctx);
    e || (e = n.group({ class: "apexcharts-grid" }));
    var o = n.drawLine(t.globals.padHorizontal, 1, t.globals.padHorizontal, t.globals.gridHeight, "transparent"), i = n.drawLine(t.globals.padHorizontal, t.globals.gridHeight, t.globals.gridWidth, t.globals.gridHeight, "transparent");
    return e.add(i), e.add(o), e;
  } }, { key: "drawGrid", value: function() {
    if (this.w.globals.axisCharts) {
      var e = this.renderGrid();
      return this.drawGridArea(e.el), e;
    }
    return null;
  } }, { key: "createGridMask", value: function() {
    var e = this.w, t = e.globals, n = new ee(this.ctx), o = Array.isArray(e.config.stroke.width) ? Math.max.apply(Math, Mt(e.config.stroke.width)) : e.config.stroke.width, i = function(u) {
      var p = document.createElementNS(t.SVGNS, "clipPath");
      return p.setAttribute("id", u), p;
    };
    t.dom.elGridRectMask = i("gridRectMask".concat(t.cuid)), t.dom.elGridRectBarMask = i("gridRectBarMask".concat(t.cuid)), t.dom.elGridRectMarkerMask = i("gridRectMarkerMask".concat(t.cuid)), t.dom.elForecastMask = i("forecastMask".concat(t.cuid)), t.dom.elNonForecastMask = i("nonForecastMask".concat(t.cuid));
    var a = 0, s = 0;
    (["bar", "rangeBar", "candlestick", "boxPlot"].includes(e.config.chart.type) || e.globals.comboBarCount > 0) && e.globals.isXNumeric && !e.globals.isBarHorizontal && (a = Math.max(e.config.grid.padding.left, t.barPadForNumericAxis), s = Math.max(e.config.grid.padding.right, t.barPadForNumericAxis)), t.dom.elGridRect = n.drawRect(-o / 2 - 2, -o / 2 - 2, t.gridWidth + o + 4, t.gridHeight + o + 4, 0, "#fff"), t.dom.elGridRectBar = n.drawRect(-o / 2 - a - 2, -o / 2 - 2, t.gridWidth + o + s + a + 4, t.gridHeight + o + 4, 0, "#fff");
    var c = e.globals.markers.largestSize;
    t.dom.elGridRectMarker = n.drawRect(Math.min(-o / 2 - a - 2, -c), -c, t.gridWidth + Math.max(o + s + a + 4, 2 * c), t.gridHeight + 2 * c, 0, "#fff"), t.dom.elGridRectMask.appendChild(t.dom.elGridRect.node), t.dom.elGridRectBarMask.appendChild(t.dom.elGridRectBar.node), t.dom.elGridRectMarkerMask.appendChild(t.dom.elGridRectMarker.node);
    var d = t.dom.baseEl.querySelector("defs");
    d.appendChild(t.dom.elGridRectMask), d.appendChild(t.dom.elGridRectBarMask), d.appendChild(t.dom.elGridRectMarkerMask), d.appendChild(t.dom.elForecastMask), d.appendChild(t.dom.elNonForecastMask);
  } }, { key: "_drawGridLines", value: function(e) {
    var t = e.i, n = e.x1, o = e.y1, i = e.x2, a = e.y2, s = e.xCount, c = e.parent, d = this.w;
    if (!(t === 0 && d.globals.skipFirstTimelinelabel || t === s - 1 && d.globals.skipLastTimelinelabel && !d.config.xaxis.labels.formatter || d.config.chart.type === "radar")) {
      d.config.grid.xaxis.lines.show && this._drawGridLine({ i: t, x1: n, y1: o, x2: i, y2: a, xCount: s, parent: c });
      var u = 0;
      if (d.globals.hasXaxisGroups && d.config.xaxis.tickPlacement === "between") {
        var p = d.globals.groups;
        if (p) {
          for (var h = 0, f = 0; h < t && f < p.length; f++) h += p[f].cols;
          h === t && (u = 0.6 * d.globals.xAxisLabelsHeight);
        }
      }
      new Ui(this.ctx).drawXaxisTicks(n, u, d.globals.dom.elGraphical);
    }
  } }, { key: "_drawGridLine", value: function(e) {
    var t = e.i, n = e.x1, o = e.y1, i = e.x2, a = e.y2, s = e.xCount, c = e.parent, d = this.w, u = c.node.classList.contains("apexcharts-gridlines-horizontal"), p = d.globals.barPadForNumericAxis, h = o === 0 && a === 0 || n === 0 && i === 0 || o === d.globals.gridHeight && a === d.globals.gridHeight || d.globals.isBarHorizontal && (t === 0 || t === s - 1), f = new ee(this).drawLine(n - (u ? p : 0), o, i + (u ? p : 0), a, d.config.grid.borderColor, d.config.grid.strokeDashArray);
    f.node.classList.add("apexcharts-gridline"), h && d.config.grid.show ? this.elGridBorders.add(f) : c.add(f);
  } }, { key: "_drawGridBandRect", value: function(e) {
    var t = e.c, n = e.x1, o = e.y1, i = e.x2, a = e.y2, s = e.type, c = this.w, d = new ee(this.ctx), u = c.globals.barPadForNumericAxis, p = c.config.grid[s].colors[t], h = d.drawRect(n - (s === "row" ? u : 0), o, i + (s === "row" ? 2 * u : 0), a, 0, p, c.config.grid[s].opacity);
    this.elg.add(h), h.attr("clip-path", "url(#gridRectMask".concat(c.globals.cuid, ")")), h.node.classList.add("apexcharts-grid-".concat(s));
  } }, { key: "_drawXYLines", value: function(e) {
    var t = this, n = e.xCount, o = e.tickAmount, i = this.w;
    if (i.config.grid.xaxis.lines.show || i.config.xaxis.axisTicks.show) {
      var a, s = i.globals.padHorizontal, c = i.globals.gridHeight;
      i.globals.timescaleLabels.length ? (function(m) {
        for (var g = m.xC, b = m.x1, x = m.y1, v = m.x2, y = m.y2, C = 0; C < g; C++) b = t.xaxisLabels[C].position, v = t.xaxisLabels[C].position, t._drawGridLines({ i: C, x1: b, y1: x, x2: v, y2: y, xCount: n, parent: t.elgridLinesV });
      })({ xC: n, x1: s, y1: 0, x2: a, y2: c }) : (i.globals.isXNumeric && (n = i.globals.xAxisScale.result.length), (function(m) {
        for (var g = m.xC, b = m.x1, x = m.y1, v = m.x2, y = m.y2, C = 0; C < g + (i.globals.isXNumeric ? 0 : 1); C++) C === 0 && g === 1 && i.globals.dataPoints === 1 && (v = b = i.globals.gridWidth / 2), t._drawGridLines({ i: C, x1: b, y1: x, x2: v, y2: y, xCount: n, parent: t.elgridLinesV }), v = b += i.globals.gridWidth / (i.globals.isXNumeric ? g - 1 : g);
      })({ xC: n, x1: s, y1: 0, x2: a, y2: c }));
    }
    if (i.config.grid.yaxis.lines.show) {
      var d = 0, u = 0, p = i.globals.gridWidth, h = o + 1;
      this.isRangeBar && (h = i.globals.labels.length);
      for (var f = 0; f < h + (this.isRangeBar ? 1 : 0); f++) this._drawGridLine({ i: f, xCount: h + (this.isRangeBar ? 1 : 0), x1: 0, y1: d, x2: p, y2: u, parent: this.elgridLinesH }), u = d += i.globals.gridHeight / (this.isRangeBar ? h : o);
    }
  } }, { key: "_drawInvertedXYLines", value: function(e) {
    var t = e.xCount, n = this.w;
    if (n.config.grid.xaxis.lines.show || n.config.xaxis.axisTicks.show) for (var o, i = n.globals.padHorizontal, a = n.globals.gridHeight, s = 0; s < t + 1; s++)
      n.config.grid.xaxis.lines.show && this._drawGridLine({ i: s, xCount: t + 1, x1: i, y1: 0, x2: o, y2: a, parent: this.elgridLinesV }), new Ui(this.ctx).drawXaxisTicks(i, 0, n.globals.dom.elGraphical), o = i += n.globals.gridWidth / t;
    if (n.config.grid.yaxis.lines.show) for (var c = 0, d = 0, u = n.globals.gridWidth, p = 0; p < n.globals.dataPoints + 1; p++) this._drawGridLine({ i: p, xCount: n.globals.dataPoints + 1, x1: 0, y1: c, x2: u, y2: d, parent: this.elgridLinesH }), d = c += n.globals.gridHeight / n.globals.dataPoints;
  } }, { key: "renderGrid", value: function() {
    var e = this.w, t = e.globals, n = new ee(this.ctx);
    this.elg = n.group({ class: "apexcharts-grid" }), this.elgridLinesH = n.group({ class: "apexcharts-gridlines-horizontal" }), this.elgridLinesV = n.group({ class: "apexcharts-gridlines-vertical" }), this.elGridBorders = n.group({ class: "apexcharts-grid-borders" }), this.elg.add(this.elgridLinesH), this.elg.add(this.elgridLinesV), e.config.grid.show || (this.elgridLinesV.hide(), this.elgridLinesH.hide(), this.elGridBorders.hide());
    for (var o = 0; o < t.seriesYAxisMap.length && t.ignoreYAxisIndexes.includes(o); ) o++;
    o === t.seriesYAxisMap.length && (o = 0);
    var i, a = t.yAxisScale[o].result.length - 1;
    if (!t.isBarHorizontal || this.isRangeBar) {
      var s, c, d;
      i = this.xaxisLabels.length, this.isRangeBar && (a = t.labels.length, e.config.xaxis.tickAmount && e.config.xaxis.labels.formatter && (i = e.config.xaxis.tickAmount), ((s = t.yAxisScale) === null || s === void 0 || (c = s[o]) === null || c === void 0 || (d = c.result) === null || d === void 0 ? void 0 : d.length) > 0 && e.config.xaxis.type !== "datetime" && (i = t.yAxisScale[o].result.length - 1)), this._drawXYLines({ xCount: i, tickAmount: a });
    } else i = a, a = t.xTickAmount, this._drawInvertedXYLines({ xCount: i, tickAmount: a });
    return this.drawGridBands(i, a), { el: this.elg, elGridBorders: this.elGridBorders, xAxisTickWidth: t.gridWidth / i };
  } }, { key: "drawGridBands", value: function(e, t) {
    var n, o, i = this, a = this.w;
    if (((n = a.config.grid.row.colors) === null || n === void 0 ? void 0 : n.length) > 0 && (function(m, g, b, x, v, y) {
      for (var C = 0, k = 0; C < g; C++, k++) k >= a.config.grid[m].colors.length && (k = 0), i._drawGridBandRect({ c: k, x1: b, y1: x, x2: v, y2: y, type: m }), x += a.globals.gridHeight / t;
    })("row", t, 0, 0, a.globals.gridWidth, a.globals.gridHeight / t), ((o = a.config.grid.column.colors) === null || o === void 0 ? void 0 : o.length) > 0) {
      var s = a.globals.isBarHorizontal || a.config.xaxis.tickPlacement !== "on" || a.config.xaxis.type !== "category" && !a.config.xaxis.convertedCatToNumeric ? e : e - 1;
      a.globals.isXNumeric && (s = a.globals.xAxisScale.result.length - 1);
      for (var c = a.globals.padHorizontal, d = a.globals.padHorizontal + a.globals.gridWidth / s, u = a.globals.gridHeight, p = 0, h = 0; p < e; p++, h++) {
        var f;
        h >= a.config.grid.column.colors.length && (h = 0), a.config.xaxis.type === "datetime" && (c = this.xaxisLabels[p].position, d = (((f = this.xaxisLabels[p + 1]) === null || f === void 0 ? void 0 : f.position) || a.globals.gridWidth) - this.xaxisLabels[p].position), this._drawGridBandRect({ c: h, x1: c, y1: 0, x2: d, y2: u, type: "column" }), c += a.globals.gridWidth / s;
      }
    }
  } }]), r;
})(), Xm = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.coreUtils = new Tt(this.ctx);
  }
  return ve(r, [{ key: "niceScale", value: function(e, t) {
    var n, o, i, a, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, c = 1e-11, d = this.w, u = d.globals;
    u.isBarHorizontal ? (n = d.config.xaxis, o = Math.max((u.svgWidth - 100) / 25, 2)) : (n = d.config.yaxis[s], o = Math.max((u.svgHeight - 100) / 15, 2)), $.isNumber(o) || (o = 10), i = n.min !== void 0 && n.min !== null, a = n.max !== void 0 && n.min !== null;
    var p = n.stepSize !== void 0 && n.stepSize !== null, h = n.tickAmount !== void 0 && n.tickAmount !== null, f = h ? n.tickAmount : u.niceScaleDefaultTicks[Math.min(Math.round(o / 2), u.niceScaleDefaultTicks.length - 1)];
    if (u.isMultipleYAxis && !h && u.multiAxisTickAmount > 0 && (f = u.multiAxisTickAmount, h = !0), f = f === "dataPoints" ? u.dataPoints - 1 : Math.abs(Math.round(f)), (e === Number.MIN_VALUE && t === 0 || !$.isNumber(e) && !$.isNumber(t) || e === Number.MIN_VALUE && t === -Number.MAX_VALUE) && (e = $.isNumber(n.min) ? n.min : 0, t = $.isNumber(n.max) ? n.max : e + f, u.allSeriesCollapsed = !1), e > t) {
      console.warn("axis.min cannot be greater than axis.max: swapping min and max");
      var m = t;
      t = e, e = m;
    } else e === t && (e = e === 0 ? 0 : e - 1, t = t === 0 ? 2 : t + 1);
    var g = [];
    f < 1 && (f = 1);
    var b = f, x = Math.abs(t - e);
    !i && e > 0 && e / x < 0.15 && (e = 0, i = !0), !a && t < 0 && -t / x < 0.15 && (t = 0, a = !0);
    var v = (x = Math.abs(t - e)) / b, y = v, C = Math.floor(Math.log10(y)), k = Math.pow(10, C), T = Math.ceil(y / k);
    if (v = y = (T = u.niceScaleAllowedMagMsd[u.yValueDecimal === 0 ? 0 : 1][T]) * k, u.isBarHorizontal && n.stepSize && n.type !== "datetime" ? (v = n.stepSize, p = !0) : p && (v = n.stepSize), p && n.forceNiceScale) {
      var S = Math.floor(Math.log10(v));
      v *= Math.pow(10, C - S);
    }
    if (i && a) {
      var O = x / b;
      if (h) if (p) if ($.mod(x, v) != 0) {
        var P = $.getGCD(v, O);
        v = O / P < 10 ? P : O;
      } else $.mod(v, O) == 0 ? v = O : (O = v, h = !1);
      else v = O;
      else if (p) $.mod(x, v) == 0 ? O = v : v = O;
      else if ($.mod(x, v) == 0) O = v;
      else {
        O = x / (b = Math.ceil(x / v));
        var M = $.getGCD(x, v);
        x / M < o && (O = M), v = O;
      }
      b = Math.round(x / v);
    } else {
      if (i || a) {
        if (a) if (h) e = t - v * b;
        else {
          var I = e;
          e = v * Math.floor(e / v), Math.abs(t - e) / $.getGCD(x, v) > o && (e = t - v * f, e += v * Math.floor((I - e) / v));
        }
        else if (i) if (h) t = e + v * b;
        else {
          var E = t;
          t = v * Math.ceil(t / v), Math.abs(t - e) / $.getGCD(x, v) > o && (t = e + v * f, t += v * Math.ceil((E - t) / v));
        }
      } else if (u.isMultipleYAxis && h) {
        var N = v * Math.floor(e / v), L = N + v * b;
        L < t && (v *= 2), L = t, t = (e = N) + v * b, x = Math.abs(t - e), e > 0 && e < Math.abs(L - t) && (e = 0, t = v * b), t < 0 && -t < Math.abs(N - e) && (t = 0, e = -v * b);
      } else e = v * Math.floor(e / v), t = v * Math.ceil(t / v);
      x = Math.abs(t - e), v = $.getGCD(x, v), b = Math.round(x / v);
    }
    if (h || i || a || (b = Math.ceil((x - c) / (v + c))) > 16 && $.getPrimeFactors(b).length < 2 && b++, !h && n.forceNiceScale && u.yValueDecimal === 0 && b > x && (b = x, v = Math.round(x / b)), b > o && (!h && !p || n.forceNiceScale)) {
      var z = $.getPrimeFactors(b), F = z.length - 1, B = b;
      e: for (var D = 0; D < F; D++) for (var W = 0; W <= F - D; W++) {
        for (var G = Math.min(W + D, F), re = B, ce = 1, Ce = W; Ce <= G; Ce++) ce *= z[Ce];
        if ((re /= ce) < o) {
          B = re;
          break e;
        }
      }
      v = B === b ? x : x / B, b = Math.round(x / v);
    }
    u.isMultipleYAxis && u.multiAxisTickAmount == 0 && u.ignoreYAxisIndexes.indexOf(s) < 0 && (u.multiAxisTickAmount = b);
    var ne = e - v, pe = v * c;
    do
      ne += v, g.push($.stripNumber(ne, 7));
    while (t - ne > pe);
    return { result: g, niceMin: g[0], niceMax: g[g.length - 1] };
  } }, { key: "linearScale", value: function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : void 0, a = Math.abs(t - e), s = [];
    if (e === t) return { result: s = [e], niceMin: s[0], niceMax: s[s.length - 1] };
    (n = this._adjustTicksForSmallRange(n, o, a)) === "dataPoints" && (n = this.w.globals.dataPoints - 1), i || (i = a / n), i = Math.round(100 * (i + Number.EPSILON)) / 100, n === Number.MAX_VALUE && (n = 5, i = 1);
    for (var c = e; n >= 0; ) s.push(c), c = $.preciseAddition(c, i), n -= 1;
    return { result: s, niceMin: s[0], niceMax: s[s.length - 1] };
  } }, { key: "logarithmicScaleNice", value: function(e, t, n) {
    t <= 0 && (t = Math.max(e, n)), e <= 0 && (e = Math.min(t, n));
    for (var o = [], i = Math.ceil(Math.log(t) / Math.log(n) + 1), a = Math.floor(Math.log(e) / Math.log(n)); a < i; a++) o.push(Math.pow(n, a));
    return { result: o, niceMin: o[0], niceMax: o[o.length - 1] };
  } }, { key: "logarithmicScale", value: function(e, t, n) {
    t <= 0 && (t = Math.max(e, n)), e <= 0 && (e = Math.min(t, n));
    for (var o = [], i = Math.log(t) / Math.log(n), a = Math.log(e) / Math.log(n), s = i - a, c = Math.round(s), d = s / c, u = 0, p = a; u < c; u++, p += d) o.push(Math.pow(n, p));
    return o.push(Math.pow(n, i)), { result: o, niceMin: e, niceMax: t };
  } }, { key: "_adjustTicksForSmallRange", value: function(e, t, n) {
    var o = e;
    if (t !== void 0 && this.w.config.yaxis[t].labels.formatter && this.w.config.yaxis[t].tickAmount === void 0) {
      var i = Number(this.w.config.yaxis[t].labels.formatter(1));
      $.isNumber(i) && this.w.globals.yValueDecimal === 0 && (o = Math.ceil(n));
    }
    return o < e ? o : e;
  } }, { key: "setYScaleForIndex", value: function(e, t, n) {
    var o = this.w.globals, i = this.w.config, a = o.isBarHorizontal ? i.xaxis : i.yaxis[e];
    o.yAxisScale[e] === void 0 && (o.yAxisScale[e] = []);
    var s = Math.abs(n - t);
    a.logarithmic && s <= 5 && (o.invalidLogScale = !0), a.logarithmic && s > 5 ? (o.allSeriesCollapsed = !1, o.yAxisScale[e] = a.forceNiceScale ? this.logarithmicScaleNice(t, n, a.logBase) : this.logarithmicScale(t, n, a.logBase)) : n !== -Number.MAX_VALUE && $.isNumber(n) && t !== Number.MAX_VALUE && $.isNumber(t) ? (o.allSeriesCollapsed = !1, o.yAxisScale[e] = this.niceScale(t, n, e)) : o.yAxisScale[e] = this.niceScale(Number.MIN_VALUE, 0, e);
  } }, { key: "setXScale", value: function(e, t) {
    var n = this.w, o = n.globals;
    if (t !== -Number.MAX_VALUE && $.isNumber(t)) {
      var i = o.xTickAmount;
      o.xAxisScale = this.linearScale(e, t, i, 0, n.config.xaxis.max === void 0 ? n.config.xaxis.stepSize : void 0);
    } else o.xAxisScale = this.linearScale(0, 10, 10);
    return o.xAxisScale;
  } }, { key: "scaleMultipleYAxes", value: function() {
    var e = this, t = this.w.config, n = this.w.globals;
    this.coreUtils.setSeriesYAxisMappings();
    var o = n.seriesYAxisMap, i = n.minYArr, a = n.maxYArr;
    n.allSeriesCollapsed = !0, n.barGroups = [], o.forEach((function(s, c) {
      var d = [];
      s.forEach((function(u) {
        var p, h = (p = t.series[u]) === null || p === void 0 ? void 0 : p.group;
        d.indexOf(h) < 0 && d.push(h);
      })), s.length > 0 ? (function() {
        var u, p, h = Number.MAX_VALUE, f = -Number.MAX_VALUE, m = h, g = f;
        if (t.chart.stacked) (function() {
          var v = new Array(n.dataPoints).fill(0), y = [], C = [], k = [];
          d.forEach((function() {
            y.push(v.map((function() {
              return Number.MIN_VALUE;
            }))), C.push(v.map((function() {
              return Number.MIN_VALUE;
            }))), k.push(v.map((function() {
              return Number.MIN_VALUE;
            })));
          }));
          for (var T = function(O) {
            !u && t.series[s[O]].type && (u = t.series[s[O]].type);
            var P = s[O];
            p = t.series[P].group ? t.series[P].group : "axis-".concat(c), !(n.collapsedSeriesIndices.indexOf(P) < 0 && n.ancillaryCollapsedSeriesIndices.indexOf(P) < 0) || (n.allSeriesCollapsed = !1, d.forEach((function(M, I) {
              if (t.series[P].group === M) for (var E = 0; E < n.series[P].length; E++) {
                var N = n.series[P][E];
                N >= 0 ? C[I][E] += N : k[I][E] += N, y[I][E] += N, m = Math.min(m, N), g = Math.max(g, N);
              }
            }))), u !== "bar" && u !== "column" || n.barGroups.push(p);
          }, S = 0; S < s.length; S++) T(S);
          u || (u = t.chart.type), u === "bar" || u === "column" ? d.forEach((function(O, P) {
            h = Math.min(h, Math.min.apply(null, k[P])), f = Math.max(f, Math.max.apply(null, C[P]));
          })) : (d.forEach((function(O, P) {
            m = Math.min(m, Math.min.apply(null, y[P])), g = Math.max(g, Math.max.apply(null, y[P]));
          })), h = m, f = g), h === Number.MIN_VALUE && f === Number.MIN_VALUE && (f = -Number.MAX_VALUE);
        })();
        else for (var b = 0; b < s.length; b++) {
          var x = s[b];
          h = Math.min(h, i[x]), f = Math.max(f, a[x]), !(n.collapsedSeriesIndices.indexOf(x) < 0 && n.ancillaryCollapsedSeriesIndices.indexOf(x) < 0) || (n.allSeriesCollapsed = !1);
        }
        t.yaxis[c].min !== void 0 && (h = typeof t.yaxis[c].min == "function" ? t.yaxis[c].min(h) : t.yaxis[c].min), t.yaxis[c].max !== void 0 && (f = typeof t.yaxis[c].max == "function" ? t.yaxis[c].max(f) : t.yaxis[c].max), n.barGroups = n.barGroups.filter((function(v, y, C) {
          return C.indexOf(v) === y;
        })), e.setYScaleForIndex(c, h, f), s.forEach((function(v) {
          i[v] = n.yAxisScale[c].niceMin, a[v] = n.yAxisScale[c].niceMax;
        }));
      })() : e.setYScaleForIndex(c, 0, -Number.MAX_VALUE);
    }));
  } }]), r;
})(), mc = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.scales = new Xm(e);
  }
  return ve(r, [{ key: "init", value: function() {
    this.setYRange(), this.setXRange(), this.setZRange();
  } }, { key: "getMinYMaxY", value: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -Number.MAX_VALUE, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, i = this.w.config, a = this.w.globals, s = -Number.MAX_VALUE, c = Number.MIN_VALUE;
    o === null && (o = e + 1);
    var d = a.series, u = d, p = d;
    i.chart.type === "candlestick" ? (u = a.seriesCandleL, p = a.seriesCandleH) : i.chart.type === "boxPlot" ? (u = a.seriesCandleO, p = a.seriesCandleC) : a.isRangeData && (u = a.seriesRangeStart, p = a.seriesRangeEnd);
    var h = !1;
    if (a.seriesX.length >= o) {
      var f, m = (f = a.brushSource) === null || f === void 0 ? void 0 : f.w.config.chart.brush;
      (i.chart.zoom.enabled && i.chart.zoom.autoScaleYaxis || m != null && m.enabled && m != null && m.autoScaleYaxis) && (h = !0);
    }
    for (var g = e; g < o; g++) {
      a.dataPoints = Math.max(a.dataPoints, d[g].length);
      var b = i.series[g].type;
      a.categoryLabels.length && (a.dataPoints = a.categoryLabels.filter((function(P) {
        return P !== void 0;
      })).length), a.labels.length && i.xaxis.type !== "datetime" && a.series.reduce((function(P, M) {
        return P + M.length;
      }), 0) !== 0 && (a.dataPoints = Math.max(a.dataPoints, a.labels.length));
      var x = 0, v = d[g].length - 1;
      if (h) {
        if (i.xaxis.min) for (; x < v && a.seriesX[g][x] < i.xaxis.min; x++) ;
        if (i.xaxis.max) for (; v > x && a.seriesX[g][v] > i.xaxis.max; v--) ;
      }
      for (var y = x; y <= v && y < a.series[g].length; y++) {
        var C = d[g][y];
        if (C !== null && $.isNumber(C)) {
          var k, T, S, O;
          switch (((k = p[g]) === null || k === void 0 ? void 0 : k[y]) !== void 0 && (s = Math.max(s, p[g][y]), t = Math.min(t, p[g][y])), ((T = u[g]) === null || T === void 0 ? void 0 : T[y]) !== void 0 && (t = Math.min(t, u[g][y]), n = Math.max(n, u[g][y])), b) {
            case "candlestick":
              a.seriesCandleC[g][y] !== void 0 && (s = Math.max(s, a.seriesCandleH[g][y]), t = Math.min(t, a.seriesCandleL[g][y]));
              break;
            case "boxPlot":
              a.seriesCandleC[g][y] !== void 0 && (s = Math.max(s, a.seriesCandleC[g][y]), t = Math.min(t, a.seriesCandleO[g][y]));
          }
          b && b !== "candlestick" && b !== "boxPlot" && b !== "rangeArea" && b !== "rangeBar" && (s = Math.max(s, a.series[g][y]), t = Math.min(t, a.series[g][y])), a.seriesGoals[g] && a.seriesGoals[g][y] && Array.isArray(a.seriesGoals[g][y]) && a.seriesGoals[g][y].forEach((function(P) {
            s = Math.max(s, P.value), t = Math.min(t, P.value);
          })), n = s, C = $.noExponents(C), $.isFloat(C) && (a.yValueDecimal = Math.max(a.yValueDecimal, C.toString().split(".")[1].length)), c > ((S = u[g]) === null || S === void 0 ? void 0 : S[y]) && ((O = u[g]) === null || O === void 0 ? void 0 : O[y]) < 0 && (c = u[g][y]);
        } else a.hasNullValues = !0;
      }
      b !== "bar" && b !== "column" || (c < 0 && s < 0 && (s = 0, n = Math.max(n, 0)), c === Number.MIN_VALUE && (c = 0, t = Math.min(t, 0)));
    }
    return i.chart.type === "rangeBar" && a.seriesRangeStart.length && a.isBarHorizontal && (c = t), i.chart.type === "bar" && (c < 0 && s < 0 && (s = 0), c === Number.MIN_VALUE && (c = 0)), { minY: c, maxY: s, lowestY: t, highestY: n };
  } }, { key: "setYRange", value: function() {
    var e = this.w.globals, t = this.w.config;
    e.maxY = -Number.MAX_VALUE, e.minY = Number.MIN_VALUE;
    var n, o = Number.MAX_VALUE;
    if (e.isMultipleYAxis) {
      o = Number.MAX_VALUE;
      for (var i = 0; i < e.series.length; i++) n = this.getMinYMaxY(i), e.minYArr[i] = n.lowestY, e.maxYArr[i] = n.highestY, o = Math.min(o, n.lowestY);
    }
    return n = this.getMinYMaxY(0, o, null, e.series.length), t.chart.type === "bar" ? (e.minY = n.minY, e.maxY = n.maxY) : (e.minY = n.lowestY, e.maxY = n.highestY), o = n.lowestY, t.chart.stacked && this._setStackedMinMax(), t.chart.type === "line" || t.chart.type === "area" || t.chart.type === "scatter" || t.chart.type === "candlestick" || t.chart.type === "boxPlot" || t.chart.type === "rangeBar" && !e.isBarHorizontal ? e.minY === Number.MIN_VALUE && o !== -Number.MAX_VALUE && o !== e.maxY && (e.minY = o) : e.minY = e.minY !== Number.MIN_VALUE ? Math.min(n.minY, e.minY) : n.minY, t.yaxis.forEach((function(a, s) {
      a.max !== void 0 && (typeof a.max == "number" ? e.maxYArr[s] = a.max : typeof a.max == "function" && (e.maxYArr[s] = a.max(e.isMultipleYAxis ? e.maxYArr[s] : e.maxY)), e.maxY = e.maxYArr[s]), a.min !== void 0 && (typeof a.min == "number" ? e.minYArr[s] = a.min : typeof a.min == "function" && (e.minYArr[s] = a.min(e.isMultipleYAxis ? e.minYArr[s] === Number.MIN_VALUE ? 0 : e.minYArr[s] : e.minY)), e.minY = e.minYArr[s]);
    })), e.isBarHorizontal && ["min", "max"].forEach((function(a) {
      t.xaxis[a] !== void 0 && typeof t.xaxis[a] == "number" && (a === "min" ? e.minY = t.xaxis[a] : e.maxY = t.xaxis[a]);
    })), e.isMultipleYAxis ? (this.scales.scaleMultipleYAxes(), e.minY = o) : (this.scales.setYScaleForIndex(0, e.minY, e.maxY), e.minY = e.yAxisScale[0].niceMin, e.maxY = e.yAxisScale[0].niceMax, e.minYArr[0] = e.minY, e.maxYArr[0] = e.maxY), e.barGroups = [], e.lineGroups = [], e.areaGroups = [], t.series.forEach((function(a) {
      switch (a.type || t.chart.type) {
        case "bar":
        case "column":
          e.barGroups.push(a.group);
          break;
        case "line":
          e.lineGroups.push(a.group);
          break;
        case "area":
          e.areaGroups.push(a.group);
      }
    })), e.barGroups = e.barGroups.filter((function(a, s, c) {
      return c.indexOf(a) === s;
    })), e.lineGroups = e.lineGroups.filter((function(a, s, c) {
      return c.indexOf(a) === s;
    })), e.areaGroups = e.areaGroups.filter((function(a, s, c) {
      return c.indexOf(a) === s;
    })), { minY: e.minY, maxY: e.maxY, minYArr: e.minYArr, maxYArr: e.maxYArr, yAxisScale: e.yAxisScale };
  } }, { key: "setXRange", value: function() {
    var e = this.w.globals, t = this.w.config, n = t.xaxis.type === "numeric" || t.xaxis.type === "datetime" || t.xaxis.type === "category" && !e.noLabelsProvided || e.noLabelsProvided || e.isXNumeric;
    if (e.isXNumeric && (function() {
      for (var c = 0; c < e.series.length; c++) if (e.labels[c]) for (var d = 0; d < e.labels[c].length; d++) e.labels[c][d] !== null && $.isNumber(e.labels[c][d]) && (e.maxX = Math.max(e.maxX, e.labels[c][d]), e.initialMaxX = Math.max(e.maxX, e.labels[c][d]), e.minX = Math.min(e.minX, e.labels[c][d]), e.initialMinX = Math.min(e.minX, e.labels[c][d]));
    })(), e.noLabelsProvided && t.xaxis.categories.length === 0 && (e.maxX = e.labels[e.labels.length - 1], e.initialMaxX = e.labels[e.labels.length - 1], e.minX = 1, e.initialMinX = 1), e.isXNumeric || e.noLabelsProvided || e.dataFormatXNumeric) {
      var o = 10;
      if (t.xaxis.tickAmount === void 0) o = Math.round(e.svgWidth / 150), t.xaxis.type === "numeric" && e.dataPoints < 30 && (o = e.dataPoints - 1), o > e.dataPoints && e.dataPoints !== 0 && (o = e.dataPoints - 1);
      else if (t.xaxis.tickAmount === "dataPoints") {
        if (e.series.length > 1 && (o = e.series[e.maxValsInArrayIndex].length - 1), e.isXNumeric) {
          var i = Math.round(e.maxX - e.minX);
          i < 30 && (o = i);
        }
      } else o = t.xaxis.tickAmount;
      if (e.xTickAmount = o, t.xaxis.max !== void 0 && typeof t.xaxis.max == "number" && (e.maxX = t.xaxis.max), t.xaxis.min !== void 0 && typeof t.xaxis.min == "number" && (e.minX = t.xaxis.min), t.xaxis.range !== void 0 && (e.minX = e.maxX - t.xaxis.range), e.minX !== Number.MAX_VALUE && e.maxX !== -Number.MAX_VALUE) if (t.xaxis.convertedCatToNumeric && !e.dataFormatXNumeric) {
        for (var a = [], s = e.minX - 1; s < e.maxX; s++) a.push(s + 1);
        e.xAxisScale = { result: a, niceMin: a[0], niceMax: a[a.length - 1] };
      } else e.xAxisScale = this.scales.setXScale(e.minX, e.maxX);
      else e.xAxisScale = this.scales.linearScale(0, o, o, 0, t.xaxis.stepSize), e.noLabelsProvided && e.labels.length > 0 && (e.xAxisScale = this.scales.linearScale(1, e.labels.length, o - 1, 0, t.xaxis.stepSize), e.seriesX = e.labels.slice());
      n && (e.labels = e.xAxisScale.result.slice());
    }
    return e.isBarHorizontal && e.labels.length && (e.xTickAmount = e.labels.length), this._handleSingleDataPoint(), this._getMinXDiff(), { minX: e.minX, maxX: e.maxX };
  } }, { key: "setZRange", value: function() {
    var e = this.w.globals;
    if (e.isDataXYZ) {
      for (var t = 0; t < e.series.length; t++) if (e.seriesZ[t] !== void 0) for (var n = 0; n < e.seriesZ[t].length; n++) e.seriesZ[t][n] !== null && $.isNumber(e.seriesZ[t][n]) && (e.maxZ = Math.max(e.maxZ, e.seriesZ[t][n]), e.minZ = Math.min(e.minZ, e.seriesZ[t][n]));
    }
  } }, { key: "_handleSingleDataPoint", value: function() {
    var e = this.w.globals, t = this.w.config;
    if (e.minX === e.maxX) {
      var n = new Dt(this.ctx);
      if (t.xaxis.type === "datetime") {
        var o = n.getDate(e.minX);
        t.xaxis.labels.datetimeUTC ? o.setUTCDate(o.getUTCDate() - 2) : o.setDate(o.getDate() - 2), e.minX = new Date(o).getTime();
        var i = n.getDate(e.maxX);
        t.xaxis.labels.datetimeUTC ? i.setUTCDate(i.getUTCDate() + 2) : i.setDate(i.getDate() + 2), e.maxX = new Date(i).getTime();
      } else (t.xaxis.type === "numeric" || t.xaxis.type === "category" && !e.noLabelsProvided) && (e.minX = e.minX - 2, e.initialMinX = e.minX, e.maxX = e.maxX + 2, e.initialMaxX = e.maxX);
    }
  } }, { key: "_getMinXDiff", value: function() {
    var e = this.w.globals;
    e.isXNumeric && e.seriesX.forEach((function(t, n) {
      if (t.length) {
        t.length === 1 && t.push(e.seriesX[e.maxValsInArrayIndex][e.seriesX[e.maxValsInArrayIndex].length - 1]);
        var o = t.slice();
        o.sort((function(i, a) {
          return i - a;
        })), o.forEach((function(i, a) {
          if (a > 0) {
            var s = i - o[a - 1];
            s > 0 && (e.minXDiff = Math.min(s, e.minXDiff));
          }
        })), e.dataPoints !== 1 && e.minXDiff !== Number.MAX_VALUE || (e.minXDiff = 0.5);
      }
    }));
  } }, { key: "_setStackedMinMax", value: function() {
    var e = this, t = this.w.globals;
    if (t.series.length) {
      var n = t.seriesGroups;
      n.length || (n = [this.w.globals.seriesNames.map((function(a) {
        return a;
      }))]);
      var o = {}, i = {};
      n.forEach((function(a) {
        o[a] = [], i[a] = [], e.w.config.series.map((function(s, c) {
          return a.indexOf(t.seriesNames[c]) > -1 ? c : null;
        })).filter((function(s) {
          return s !== null;
        })).forEach((function(s) {
          for (var c = 0; c < t.series[t.maxValsInArrayIndex].length; c++) {
            var d, u, p, h;
            o[a][c] === void 0 && (o[a][c] = 0, i[a][c] = 0), (e.w.config.chart.stacked && !t.comboCharts || e.w.config.chart.stacked && t.comboCharts && (!e.w.config.chart.stackOnlyBar || ((d = e.w.config.series) === null || d === void 0 || (u = d[s]) === null || u === void 0 ? void 0 : u.type) === "bar" || ((p = e.w.config.series) === null || p === void 0 || (h = p[s]) === null || h === void 0 ? void 0 : h.type) === "column")) && t.series[s][c] !== null && $.isNumber(t.series[s][c]) && (t.series[s][c] > 0 ? o[a][c] += parseFloat(t.series[s][c]) + 1e-4 : i[a][c] += parseFloat(t.series[s][c]));
          }
        }));
      })), Object.entries(o).forEach((function(a) {
        var s = pm(a, 1)[0];
        o[s].forEach((function(c, d) {
          t.maxY = Math.max(t.maxY, o[s][d]), t.minY = Math.min(t.minY, i[s][d]);
        }));
      }));
    }
  } }]), r;
})(), Bd = (function() {
  function r(e, t) {
    xe(this, r), this.ctx = e, this.elgrid = t, this.w = e.w;
    var n = this.w;
    this.xaxisFontSize = n.config.xaxis.labels.style.fontSize, this.axisFontFamily = n.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = n.config.xaxis.labels.style.colors, this.isCategoryBarHorizontal = n.config.chart.type === "bar" && n.config.plotOptions.bar.horizontal, this.xAxisoffX = n.config.xaxis.position === "bottom" ? n.globals.gridHeight : 0, this.drawnLabels = [], this.axesUtils = new pn(e);
  }
  return ve(r, [{ key: "drawYaxis", value: function(e) {
    var t = this.w, n = new ee(this.ctx), o = t.config.yaxis[e].labels.style, i = o.fontSize, a = o.fontFamily, s = o.fontWeight, c = n.group({ class: "apexcharts-yaxis", rel: e, transform: "translate(".concat(t.globals.translateYAxisX[e], ", 0)") });
    if (this.axesUtils.isYAxisHidden(e)) return c;
    var d = n.group({ class: "apexcharts-yaxis-texts-g" });
    c.add(d);
    var u = t.globals.yAxisScale[e].result.length - 1, p = t.globals.gridHeight / u, h = t.globals.yLabelFormatters[e], f = this.axesUtils.checkForReversedLabels(e, t.globals.yAxisScale[e].result.slice());
    if (t.config.yaxis[e].labels.show) {
      var m = t.globals.translateY + t.config.yaxis[e].labels.offsetY;
      t.globals.isBarHorizontal ? m = 0 : t.config.chart.type === "heatmap" && (m -= p / 2), m += parseInt(i, 10) / 3;
      for (var g = u; g >= 0; g--) {
        var b = h(f[g], g, t), x = t.config.yaxis[e].labels.padding;
        t.config.yaxis[e].opposite && t.config.yaxis.length !== 0 && (x *= -1);
        var v = this.getTextAnchor(t.config.yaxis[e].labels.align, t.config.yaxis[e].opposite), y = this.axesUtils.getYAxisForeColor(o.colors, e), C = Array.isArray(y) ? y[g] : y, k = $.listToArray(t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(e, "'] .apexcharts-yaxis-label tspan"))).map((function(S) {
          return S.textContent;
        })), T = n.drawText({ x, y: m, text: k.includes(b) && !t.config.yaxis[e].labels.showDuplicates ? "" : b, textAnchor: v, fontSize: i, fontFamily: a, fontWeight: s, maxWidth: t.config.yaxis[e].labels.maxWidth, foreColor: C, isPlainText: !1, cssClass: "apexcharts-yaxis-label ".concat(o.cssClass) });
        d.add(T), this.addTooltip(T, b), t.config.yaxis[e].labels.rotate !== 0 && this.rotateLabel(n, T, firstLabel, t.config.yaxis[e].labels.rotate), m += p;
      }
    }
    return this.addYAxisTitle(n, c, e), this.addAxisBorder(n, c, e, u, p), c;
  } }, { key: "getTextAnchor", value: function(e, t) {
    return e === "left" ? "start" : e === "center" ? "middle" : e === "right" ? "end" : t ? "start" : "end";
  } }, { key: "addTooltip", value: function(e, t) {
    var n = document.createElementNS(this.w.globals.SVGNS, "title");
    n.textContent = Array.isArray(t) ? t.join(" ") : t, e.node.appendChild(n);
  } }, { key: "rotateLabel", value: function(e, t, n, o) {
    var i = e.rotateAroundCenter(n.node), a = e.rotateAroundCenter(t.node);
    t.node.setAttribute("transform", "rotate(".concat(o, " ").concat(i.x, " ").concat(a.y, ")"));
  } }, { key: "addYAxisTitle", value: function(e, t, n) {
    var o = this.w;
    if (o.config.yaxis[n].title.text !== void 0) {
      var i = e.group({ class: "apexcharts-yaxis-title" }), a = o.config.yaxis[n].opposite ? o.globals.translateYAxisX[n] : 0, s = e.drawText({ x: a, y: o.globals.gridHeight / 2 + o.globals.translateY + o.config.yaxis[n].title.offsetY, text: o.config.yaxis[n].title.text, textAnchor: "end", foreColor: o.config.yaxis[n].title.style.color, fontSize: o.config.yaxis[n].title.style.fontSize, fontWeight: o.config.yaxis[n].title.style.fontWeight, fontFamily: o.config.yaxis[n].title.style.fontFamily, cssClass: "apexcharts-yaxis-title-text ".concat(o.config.yaxis[n].title.style.cssClass) });
      i.add(s), t.add(i);
    }
  } }, { key: "addAxisBorder", value: function(e, t, n, o, i) {
    var a = this.w, s = a.config.yaxis[n].axisBorder, c = 31 + s.offsetX;
    if (a.config.yaxis[n].opposite && (c = -31 - s.offsetX), s.show) {
      var d = e.drawLine(c, a.globals.translateY + s.offsetY - 2, c, a.globals.gridHeight + a.globals.translateY + s.offsetY + 2, s.color, 0, s.width);
      t.add(d);
    }
    a.config.yaxis[n].axisTicks.show && this.axesUtils.drawYAxisTicks(c, o, s, a.config.yaxis[n].axisTicks, n, i, t);
  } }, { key: "drawYaxisInversed", value: function(e) {
    var t = this.w, n = new ee(this.ctx), o = n.group({ class: "apexcharts-xaxis apexcharts-yaxis-inversed" }), i = n.group({ class: "apexcharts-xaxis-texts-g", transform: "translate(".concat(t.globals.translateXAxisX, ", ").concat(t.globals.translateXAxisY, ")") });
    o.add(i);
    var a = t.globals.yAxisScale[e].result.length - 1, s = t.globals.gridWidth / a + 0.1, c = s + t.config.xaxis.labels.offsetX, d = t.globals.xLabelFormatter, u = this.axesUtils.checkForReversedLabels(e, t.globals.yAxisScale[e].result.slice()), p = t.globals.timescaleLabels;
    if (p.length > 0 && (this.xaxisLabels = p.slice(), a = (u = p.slice()).length), t.config.xaxis.labels.show) for (var h = p.length ? 0 : a; p.length ? h < p.length : h >= 0; p.length ? h++ : h--) {
      var f = d(u[h], h, t), m = t.globals.gridWidth + t.globals.padHorizontal - (c - s + t.config.xaxis.labels.offsetX);
      if (p.length) {
        var g = this.axesUtils.getLabel(u, p, m, h, this.drawnLabels, this.xaxisFontSize);
        m = g.x, f = g.text, this.drawnLabels.push(g.text), h === 0 && t.globals.skipFirstTimelinelabel && (f = ""), h === u.length - 1 && t.globals.skipLastTimelinelabel && (f = "");
      }
      var b = n.drawText({ x: m, y: this.xAxisoffX + t.config.xaxis.labels.offsetY + 30 - (t.config.xaxis.position === "top" ? t.globals.xAxisHeight + t.config.xaxis.axisTicks.height - 2 : 0), text: f, textAnchor: "middle", foreColor: Array.isArray(this.xaxisForeColors) ? this.xaxisForeColors[e] : this.xaxisForeColors, fontSize: this.xaxisFontSize, fontFamily: this.xaxisFontFamily, fontWeight: t.config.xaxis.labels.style.fontWeight, isPlainText: !1, cssClass: "apexcharts-xaxis-label ".concat(t.config.xaxis.labels.style.cssClass) });
      i.add(b), b.tspan(f), this.addTooltip(b, f), c += s;
    }
    return this.inversedYAxisTitleText(o), this.inversedYAxisBorder(o), o;
  } }, { key: "inversedYAxisBorder", value: function(e) {
    var t = this.w, n = new ee(this.ctx), o = t.config.xaxis.axisBorder;
    if (o.show) {
      var i = 0;
      t.config.chart.type === "bar" && t.globals.isXNumeric && (i -= 15);
      var a = n.drawLine(t.globals.padHorizontal + i + o.offsetX, this.xAxisoffX, t.globals.gridWidth, this.xAxisoffX, o.color, 0, o.height);
      this.elgrid && this.elgrid.elGridBorders && t.config.grid.show ? this.elgrid.elGridBorders.add(a) : e.add(a);
    }
  } }, { key: "inversedYAxisTitleText", value: function(e) {
    var t = this.w, n = new ee(this.ctx);
    if (t.config.xaxis.title.text !== void 0) {
      var o = n.group({ class: "apexcharts-xaxis-title apexcharts-yaxis-title-inversed" }), i = n.drawText({ x: t.globals.gridWidth / 2 + t.config.xaxis.title.offsetX, y: this.xAxisoffX + parseFloat(this.xaxisFontSize) + parseFloat(t.config.xaxis.title.style.fontSize) + t.config.xaxis.title.offsetY + 20, text: t.config.xaxis.title.text, textAnchor: "middle", fontSize: t.config.xaxis.title.style.fontSize, fontFamily: t.config.xaxis.title.style.fontFamily, fontWeight: t.config.xaxis.title.style.fontWeight, foreColor: t.config.xaxis.title.style.color, cssClass: "apexcharts-xaxis-title-text ".concat(t.config.xaxis.title.style.cssClass) });
      o.add(i), e.add(o);
    }
  } }, { key: "yAxisTitleRotate", value: function(e, t) {
    var n = this.w, o = new ee(this.ctx), i = n.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(e, "'] .apexcharts-yaxis-texts-g")), a = i ? i.getBoundingClientRect() : { width: 0, height: 0 }, s = n.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(e, "'] .apexcharts-yaxis-title text")), c = s ? s.getBoundingClientRect() : { width: 0, height: 0 };
    if (s) {
      var d = this.xPaddingForYAxisTitle(e, a, c, t);
      s.setAttribute("x", d.xPos - (t ? 10 : 0));
      var u = o.rotateAroundCenter(s);
      s.setAttribute("transform", "rotate(".concat(t ? -1 * n.config.yaxis[e].title.rotate : n.config.yaxis[e].title.rotate, " ").concat(u.x, " ").concat(u.y, ")"));
    }
  } }, { key: "xPaddingForYAxisTitle", value: function(e, t, n, o) {
    var i = this.w, a = 0, s = 10;
    return i.config.yaxis[e].title.text === void 0 || e < 0 ? { xPos: a, padd: 0 } : (o ? a = t.width + i.config.yaxis[e].title.offsetX + n.width / 2 + s / 2 : (a = -1 * t.width + i.config.yaxis[e].title.offsetX + s / 2 + n.width / 2, i.globals.isBarHorizontal && (s = 25, a = -1 * t.width - i.config.yaxis[e].title.offsetX - s)), { xPos: a, padd: s });
  } }, { key: "setYAxisXPosition", value: function(e, t) {
    var n = this.w, o = 0, i = 0, a = 18, s = 1;
    n.config.yaxis.length > 1 && (this.multipleYs = !0), n.config.yaxis.forEach((function(c, d) {
      var u = n.globals.ignoreYAxisIndexes.includes(d) || !c.show || c.floating || e[d].width === 0, p = e[d].width + t[d].width;
      c.opposite ? n.globals.isBarHorizontal ? (i = n.globals.gridWidth + n.globals.translateX - 1, n.globals.translateYAxisX[d] = i - c.labels.offsetX) : (i = n.globals.gridWidth + n.globals.translateX + s, u || (s += p + 20), n.globals.translateYAxisX[d] = i - c.labels.offsetX + 20) : (o = n.globals.translateX - a, u || (a += p + 20), n.globals.translateYAxisX[d] = o + c.labels.offsetX);
    }));
  } }, { key: "setYAxisTextAlignments", value: function() {
    var e = this.w;
    $.listToArray(e.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis")).forEach((function(t, n) {
      var o = e.config.yaxis[n];
      if (o && !o.floating && o.labels.align !== void 0) {
        var i = e.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(n, "'] .apexcharts-yaxis-texts-g")), a = $.listToArray(e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(n, "'] .apexcharts-yaxis-label"))), s = i.getBoundingClientRect();
        a.forEach((function(c) {
          c.setAttribute("text-anchor", o.labels.align);
        })), o.labels.align !== "left" || o.opposite ? o.labels.align === "center" ? i.setAttribute("transform", "translate(".concat(s.width / 2 * (o.opposite ? 1 : -1), ", 0)")) : o.labels.align === "right" && o.opposite && i.setAttribute("transform", "translate(".concat(s.width, ", 0)")) : i.setAttribute("transform", "translate(-".concat(s.width, ", 0)"));
      }
    }));
  } }]), r;
})(), LL = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.documentEvent = $.bind(this.documentEvent, this);
  }
  return ve(r, [{ key: "addEventListener", value: function(e, t) {
    var n = this.w;
    n.globals.events.hasOwnProperty(e) ? n.globals.events[e].push(t) : n.globals.events[e] = [t];
  } }, { key: "removeEventListener", value: function(e, t) {
    var n = this.w;
    if (n.globals.events.hasOwnProperty(e)) {
      var o = n.globals.events[e].indexOf(t);
      o !== -1 && n.globals.events[e].splice(o, 1);
    }
  } }, { key: "fireEvent", value: function(e, t) {
    var n = this.w;
    if (n.globals.events.hasOwnProperty(e)) {
      t && t.length || (t = []);
      for (var o = n.globals.events[e], i = o.length, a = 0; a < i; a++) o[a].apply(null, t);
    }
  } }, { key: "setupEventHandlers", value: function() {
    var e = this, t = this.w, n = this.ctx, o = t.globals.dom.baseEl.querySelector(t.globals.chartClass);
    this.ctx.eventList.forEach((function(i) {
      o.addEventListener(i, (function(a) {
        var s = a.target.getAttribute("i") === null && t.globals.capturedSeriesIndex !== -1 ? t.globals.capturedSeriesIndex : a.target.getAttribute("i"), c = a.target.getAttribute("j") === null && t.globals.capturedDataPointIndex !== -1 ? t.globals.capturedDataPointIndex : a.target.getAttribute("j"), d = Object.assign({}, t, { seriesIndex: t.globals.axisCharts ? s : 0, dataPointIndex: c });
        a.type === "mousemove" || a.type === "touchmove" ? typeof t.config.chart.events.mouseMove == "function" && t.config.chart.events.mouseMove(a, n, d) : a.type === "mouseleave" || a.type === "touchleave" ? typeof t.config.chart.events.mouseLeave == "function" && t.config.chart.events.mouseLeave(a, n, d) : (a.type === "mouseup" && a.which === 1 || a.type === "touchend") && (typeof t.config.chart.events.click == "function" && t.config.chart.events.click(a, n, d), n.ctx.events.fireEvent("click", [a, n, d]));
      }), { capture: !1, passive: !0 });
    })), this.ctx.eventList.forEach((function(i) {
      t.globals.dom.baseEl.addEventListener(i, e.documentEvent, { passive: !0 });
    })), this.ctx.core.setupBrushHandler();
  } }, { key: "documentEvent", value: function(e) {
    var t = this.w, n = e.target.className;
    if (e.type === "click") {
      var o = t.globals.dom.baseEl.querySelector(".apexcharts-menu");
      o && o.classList.contains("apexcharts-menu-open") && n !== "apexcharts-menu-icon" && o.classList.remove("apexcharts-menu-open");
    }
    t.globals.clientX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX, t.globals.clientY = e.type === "touchmove" ? e.touches[0].clientY : e.clientY;
  } }]), r;
})(), jL = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "setCurrentLocaleValues", value: function(e) {
    var t = this.w.config.chart.locales;
    window.Apex.chart && window.Apex.chart.locales && window.Apex.chart.locales.length > 0 && (t = this.w.config.chart.locales.concat(window.Apex.chart.locales));
    var n = t.filter((function(i) {
      return i.name === e;
    }))[0];
    if (!n) throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");
    var o = $.extend(_m, n);
    this.w.globals.locale = o.options;
  } }]), r;
})(), DL = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "drawAxis", value: function(e, t) {
    var n, o, i = this, a = this.w.globals, s = this.w.config, c = new Ui(this.ctx, t), d = new Bd(this.ctx, t);
    a.axisCharts && e !== "radar" && (a.isBarHorizontal ? (o = d.drawYaxisInversed(0), n = c.drawXaxisInversed(0), a.dom.elGraphical.add(n), a.dom.elGraphical.add(o)) : (n = c.drawXaxis(), a.dom.elGraphical.add(n), s.yaxis.map((function(u, p) {
      if (a.ignoreYAxisIndexes.indexOf(p) === -1 && (o = d.drawYaxis(p), a.dom.Paper.add(o), i.w.config.grid.position === "back")) {
        var h = a.dom.Paper.children()[1];
        h.remove(), a.dom.Paper.add(h);
      }
    }))));
  } }]), r;
})(), bc = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "drawXCrosshairs", value: function() {
    var e = this.w, t = new ee(this.ctx), n = new zt(this.ctx), o = e.config.xaxis.crosshairs.fill.gradient, i = e.config.xaxis.crosshairs.dropShadow, a = e.config.xaxis.crosshairs.fill.type, s = o.colorFrom, c = o.colorTo, d = o.opacityFrom, u = o.opacityTo, p = o.stops, h = i.enabled, f = i.left, m = i.top, g = i.blur, b = i.color, x = i.opacity, v = e.config.xaxis.crosshairs.fill.color;
    if (e.config.xaxis.crosshairs.show) {
      a === "gradient" && (v = t.drawGradient("vertical", s, c, d, u, null, p, null));
      var y = t.drawRect();
      e.config.xaxis.crosshairs.width === 1 && (y = t.drawLine());
      var C = e.globals.gridHeight;
      (!$.isNumber(C) || C < 0) && (C = 0);
      var k = e.config.xaxis.crosshairs.width;
      (!$.isNumber(k) || k < 0) && (k = 0), y.attr({ class: "apexcharts-xcrosshairs", x: 0, y: 0, y2: C, width: k, height: C, fill: v, filter: "none", "fill-opacity": e.config.xaxis.crosshairs.opacity, stroke: e.config.xaxis.crosshairs.stroke.color, "stroke-width": e.config.xaxis.crosshairs.stroke.width, "stroke-dasharray": e.config.xaxis.crosshairs.stroke.dashArray }), h && (y = n.dropShadow(y, { left: f, top: m, blur: g, color: b, opacity: x })), e.globals.dom.elGraphical.add(y);
    }
  } }, { key: "drawYCrosshairs", value: function() {
    var e = this.w, t = new ee(this.ctx), n = e.config.yaxis[0].crosshairs, o = e.globals.barPadForNumericAxis;
    if (e.config.yaxis[0].crosshairs.show) {
      var i = t.drawLine(-o, 0, e.globals.gridWidth + o, 0, n.stroke.color, n.stroke.dashArray, n.stroke.width);
      i.attr({ class: "apexcharts-ycrosshairs" }), e.globals.dom.elGraphical.add(i);
    }
    var a = t.drawLine(-o, 0, e.globals.gridWidth + o, 0, n.stroke.color, 0, 0);
    a.attr({ class: "apexcharts-ycrosshairs-hidden" }), e.globals.dom.elGraphical.add(a);
  } }]), r;
})(), zL = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "checkResponsiveConfig", value: function(e) {
    var t = this, n = this.w, o = n.config;
    if (o.responsive.length !== 0) {
      var i = o.responsive.slice();
      i.sort((function(d, u) {
        return d.breakpoint > u.breakpoint ? 1 : u.breakpoint > d.breakpoint ? -1 : 0;
      })).reverse();
      var a = new Vi({}), s = function() {
        var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = i[0].breakpoint, p = window.innerWidth > 0 ? window.innerWidth : screen.width;
        if (p > u) {
          var h = $.clone(n.globals.initialConfig);
          h.series = $.clone(n.config.series);
          var f = Tt.extendArrayProps(a, h, n);
          d = $.extend(f, d), d = $.extend(n.config, d), t.overrideResponsiveOptions(d);
        } else for (var m = 0; m < i.length; m++) p < i[m].breakpoint && (d = Tt.extendArrayProps(a, i[m].options, n), d = $.extend(n.config, d), t.overrideResponsiveOptions(d));
      };
      if (e) {
        var c = Tt.extendArrayProps(a, e, n);
        c = $.extend(n.config, c), s(c = $.extend(c, e));
      } else s({});
    }
  } }, { key: "overrideResponsiveOptions", value: function(e) {
    var t = new Vi(e).init({ responsiveOverride: !0 });
    this.w.config = t;
  } }]), r;
})(), BL = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.colors = [], this.isColorFn = !1, this.isHeatmapDistributed = this.checkHeatmapDistributed(), this.isBarDistributed = this.checkBarDistributed();
  }
  return ve(r, [{ key: "checkHeatmapDistributed", value: function() {
    var e = this.w.config, t = e.chart, n = e.plotOptions;
    return t.type === "treemap" && n.treemap && n.treemap.distributed || t.type === "heatmap" && n.heatmap && n.heatmap.distributed;
  } }, { key: "checkBarDistributed", value: function() {
    var e = this.w.config, t = e.chart, n = e.plotOptions;
    return n.bar && n.bar.distributed && (t.type === "bar" || t.type === "rangeBar");
  } }, { key: "init", value: function() {
    this.setDefaultColors();
  } }, { key: "setDefaultColors", value: function() {
    var e = this.w, t = new $();
    e.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(e.config.theme.mode || "light"));
    var n = Mt(e.config.colors || e.config.fill.colors || []);
    e.globals.colors = this.getColors(n), this.applySeriesColors(e.globals.seriesColors, e.globals.colors), e.config.theme.monochrome.enabled && (e.globals.colors = this.getMonochromeColors(e.config.theme.monochrome, e.globals.series, t));
    var o = e.globals.colors.slice();
    this.pushExtraColors(e.globals.colors), this.applyColorTypes(["fill", "stroke"], o), this.applyDataLabelsColors(o), this.applyRadarPolygonsColors(), this.applyMarkersColors(o);
  } }, { key: "getColors", value: function(e) {
    var t = this, n = this.w;
    return e && e.length !== 0 ? Array.isArray(e) && e.length > 0 && typeof e[0] == "function" ? (this.isColorFn = !0, n.config.series.map((function(o, i) {
      var a = e[i] || e[0];
      return typeof a == "function" ? a({ value: n.globals.axisCharts ? n.globals.series[i][0] || 0 : n.globals.series[i], seriesIndex: i, dataPointIndex: i, w: t.w }) : a;
    }))) : e : this.predefined();
  } }, { key: "applySeriesColors", value: function(e, t) {
    e.forEach((function(n, o) {
      n && (t[o] = n);
    }));
  } }, { key: "getMonochromeColors", value: function(e, t, n) {
    var o = e.color, i = e.shadeIntensity, a = e.shadeTo, s = this.isBarDistributed || this.isHeatmapDistributed ? t[0].length * t.length : t.length, c = 1 / (s / i), d = 0;
    return Array.from({ length: s }, (function() {
      var u = a === "dark" ? n.shadeColor(-1 * d, o) : n.shadeColor(d, o);
      return d += c, u;
    }));
  } }, { key: "applyColorTypes", value: function(e, t) {
    var n = this, o = this.w;
    e.forEach((function(i) {
      o.globals[i].colors = o.config[i].colors === void 0 ? n.isColorFn ? o.config.colors : t : o.config[i].colors.slice(), n.pushExtraColors(o.globals[i].colors);
    }));
  } }, { key: "applyDataLabelsColors", value: function(e) {
    var t = this.w;
    t.globals.dataLabels.style.colors = t.config.dataLabels.style.colors === void 0 ? e : t.config.dataLabels.style.colors.slice(), this.pushExtraColors(t.globals.dataLabels.style.colors, 50);
  } }, { key: "applyRadarPolygonsColors", value: function() {
    var e = this.w;
    e.globals.radarPolygons.fill.colors = e.config.plotOptions.radar.polygons.fill.colors === void 0 ? [e.config.theme.mode === "dark" ? "#343A3F" : "none"] : e.config.plotOptions.radar.polygons.fill.colors.slice(), this.pushExtraColors(e.globals.radarPolygons.fill.colors, 20);
  } }, { key: "applyMarkersColors", value: function(e) {
    var t = this.w;
    t.globals.markers.colors = t.config.markers.colors === void 0 ? e : t.config.markers.colors.slice(), this.pushExtraColors(t.globals.markers.colors);
  } }, { key: "pushExtraColors", value: function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, o = this.w, i = t || o.globals.series.length;
    if (n === null && (n = this.isBarDistributed || this.isHeatmapDistributed || o.config.chart.type === "heatmap" && o.config.plotOptions.heatmap && o.config.plotOptions.heatmap.colorScale.inverse), n && o.globals.series.length && (i = o.globals.series[o.globals.maxValsInArrayIndex].length * o.globals.series.length), e.length < i) for (var a = i - e.length, s = 0; s < a; s++) e.push(e[s]);
  } }, { key: "updateThemeOptions", value: function(e) {
    e.chart = e.chart || {}, e.tooltip = e.tooltip || {};
    var t = e.theme.mode, n = t === "dark" ? "palette4" : t === "light" ? "palette1" : e.theme.palette || "palette1", o = t === "dark" ? "#f6f7f8" : t === "light" ? "#373d3f" : e.chart.foreColor || "#373d3f";
    return e.tooltip.theme = t || "light", e.chart.foreColor = o, e.theme.palette = n, e;
  } }, { key: "predefined", value: function() {
    var e = this.w.config.theme.palette, t = this.ctx.constructor.getThemePalettes();
    return t[e] || t.palette1;
  } }]), r;
})(), FL = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "draw", value: function() {
    this.drawTitleSubtitle("title"), this.drawTitleSubtitle("subtitle");
  } }, { key: "drawTitleSubtitle", value: function(e) {
    var t = this.w, n = e === "title" ? t.config.title : t.config.subtitle, o = t.globals.svgWidth / 2, i = n.offsetY, a = "middle";
    if (n.align === "left" ? (o = 10, a = "start") : n.align === "right" && (o = t.globals.svgWidth - 10, a = "end"), o += n.offsetX, i = i + parseInt(n.style.fontSize, 10) + n.margin / 2, n.text !== void 0) {
      var s = new ee(this.ctx).drawText({ x: o, y: i, text: n.text, textAnchor: a, fontSize: n.style.fontSize, fontFamily: n.style.fontFamily, fontWeight: n.style.fontWeight, foreColor: n.style.color, opacity: 1 });
      s.node.setAttribute("class", "apexcharts-".concat(e, "-text")), t.globals.dom.Paper.add(s);
    }
  } }]), r;
})(), _L = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.dCtx = e;
  }
  return ve(r, [{ key: "getTitleSubtitleCoords", value: function(e) {
    var t = this.w, n = 0, o = 0, i = e === "title" ? t.config.title.floating : t.config.subtitle.floating, a = t.globals.dom.baseEl.querySelector(".apexcharts-".concat(e, "-text"));
    if (a !== null && !i) {
      var s = a.getBoundingClientRect();
      n = s.width, o = t.globals.axisCharts ? s.height + 5 : s.height;
    }
    return { width: n, height: o };
  } }, { key: "getLegendsRect", value: function() {
    var e = this.w, t = e.globals.dom.elLegendWrap;
    e.config.legend.height || e.config.legend.position !== "top" && e.config.legend.position !== "bottom" || (t.style.maxHeight = e.globals.svgHeight / 2 + "px");
    var n = Object.assign({}, $.getBoundingClientRect(t));
    return t !== null && !e.config.legend.floating && e.config.legend.show ? this.dCtx.lgRect = { x: n.x, y: n.y, height: n.height, width: n.height === 0 ? 0 : n.width } : this.dCtx.lgRect = { x: 0, y: 0, height: 0, width: 0 }, e.config.legend.position !== "left" && e.config.legend.position !== "right" || 1.5 * this.dCtx.lgRect.width > e.globals.svgWidth && (this.dCtx.lgRect.width = e.globals.svgWidth / 1.5), this.dCtx.lgRect;
  } }, { key: "getDatalabelsRect", value: function() {
    var e = this, t = this.w, n = [];
    t.config.series.forEach((function(c, d) {
      c.data.forEach((function(u, p) {
        var h;
        h = t.globals.series[d][p], o = t.config.dataLabels.formatter(h, { ctx: e.dCtx.ctx, seriesIndex: d, dataPointIndex: p, w: t }), n.push(o);
      }));
    }));
    var o = $.getLargestStringFromArr(n), i = new ee(this.dCtx.ctx), a = t.config.dataLabels.style, s = i.getTextRects(o, parseInt(a.fontSize), a.fontFamily);
    return { width: 1.05 * s.width, height: s.height };
  } }, { key: "getLargestStringFromMultiArr", value: function(e, t) {
    var n = e;
    if (this.w.globals.isMultiLineX) {
      var o = t.map((function(a, s) {
        return Array.isArray(a) ? a.length : 1;
      })), i = Math.max.apply(Math, Mt(o));
      n = t[o.indexOf(i)];
    }
    return n;
  } }]), r;
})(), $L = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.dCtx = e;
  }
  return ve(r, [{ key: "getxAxisLabelsCoords", value: function() {
    var e, t = this.w, n = t.globals.labels.slice();
    if (t.config.xaxis.convertedCatToNumeric && n.length === 0 && (n = t.globals.categoryLabels), t.globals.timescaleLabels.length > 0) {
      var o = this.getxAxisTimeScaleLabelsCoords();
      e = { width: o.width, height: o.height }, t.globals.rotateXLabels = !1;
    } else {
      this.dCtx.lgWidthForSideLegends = t.config.legend.position !== "left" && t.config.legend.position !== "right" || t.config.legend.floating ? 0 : this.dCtx.lgRect.width;
      var i = t.globals.xLabelFormatter, a = $.getLargestStringFromArr(n), s = this.dCtx.dimHelpers.getLargestStringFromMultiArr(a, n);
      t.globals.isBarHorizontal && (s = a = t.globals.yAxisScale[0].result.reduce((function(m, g) {
        return m.length > g.length ? m : g;
      }), 0));
      var c = new la(this.dCtx.ctx), d = a;
      a = c.xLabelFormat(i, a, d, { i: void 0, dateFormatter: new Dt(this.dCtx.ctx).formatDate, w: t }), s = c.xLabelFormat(i, s, d, { i: void 0, dateFormatter: new Dt(this.dCtx.ctx).formatDate, w: t }), (t.config.xaxis.convertedCatToNumeric && a === void 0 || String(a).trim() === "") && (s = a = "1");
      var u = new ee(this.dCtx.ctx), p = u.getTextRects(a, t.config.xaxis.labels.style.fontSize), h = p;
      if (a !== s && (h = u.getTextRects(s, t.config.xaxis.labels.style.fontSize)), (e = { width: p.width >= h.width ? p.width : h.width, height: p.height >= h.height ? p.height : h.height }).width * n.length > t.globals.svgWidth - this.dCtx.lgWidthForSideLegends - this.dCtx.yAxisWidth - this.dCtx.gridPad.left - this.dCtx.gridPad.right && t.config.xaxis.labels.rotate !== 0 || t.config.xaxis.labels.rotateAlways) {
        if (!t.globals.isBarHorizontal) {
          t.globals.rotateXLabels = !0;
          var f = function(m) {
            return u.getTextRects(m, t.config.xaxis.labels.style.fontSize, t.config.xaxis.labels.style.fontFamily, "rotate(".concat(t.config.xaxis.labels.rotate, " 0 0)"), !1);
          };
          p = f(a), a !== s && (h = f(s)), e.height = (p.height > h.height ? p.height : h.height) / 1.5, e.width = p.width > h.width ? p.width : h.width;
        }
      } else t.globals.rotateXLabels = !1;
    }
    return t.config.xaxis.labels.show || (e = { width: 0, height: 0 }), { width: e.width, height: e.height };
  } }, { key: "getxAxisGroupLabelsCoords", value: function() {
    var e, t = this.w;
    if (!t.globals.hasXaxisGroups) return { width: 0, height: 0 };
    var n, o = ((e = t.config.xaxis.group.style) === null || e === void 0 ? void 0 : e.fontSize) || t.config.xaxis.labels.style.fontSize, i = t.globals.groups.map((function(p) {
      return p.title;
    })), a = $.getLargestStringFromArr(i), s = this.dCtx.dimHelpers.getLargestStringFromMultiArr(a, i), c = new ee(this.dCtx.ctx), d = c.getTextRects(a, o), u = d;
    return a !== s && (u = c.getTextRects(s, o)), n = { width: d.width >= u.width ? d.width : u.width, height: d.height >= u.height ? d.height : u.height }, t.config.xaxis.labels.show || (n = { width: 0, height: 0 }), { width: n.width, height: n.height };
  } }, { key: "getxAxisTitleCoords", value: function() {
    var e = this.w, t = 0, n = 0;
    if (e.config.xaxis.title.text !== void 0) {
      var o = new ee(this.dCtx.ctx).getTextRects(e.config.xaxis.title.text, e.config.xaxis.title.style.fontSize);
      t = o.width, n = o.height;
    }
    return { width: t, height: n };
  } }, { key: "getxAxisTimeScaleLabelsCoords", value: function() {
    var e, t = this.w;
    this.dCtx.timescaleLabels = t.globals.timescaleLabels.slice();
    var n = this.dCtx.timescaleLabels.map((function(i) {
      return i.value;
    })), o = n.reduce((function(i, a) {
      return i === void 0 ? (console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"), 0) : i.length > a.length ? i : a;
    }), 0);
    return 1.05 * (e = new ee(this.dCtx.ctx).getTextRects(o, t.config.xaxis.labels.style.fontSize)).width * n.length > t.globals.gridWidth && t.config.xaxis.labels.rotate !== 0 && (t.globals.overlappingXLabels = !0), e;
  } }, { key: "additionalPaddingXLabels", value: function(e) {
    var t = this, n = this.w, o = n.globals, i = n.config, a = i.xaxis.type, s = e.width;
    o.skipLastTimelinelabel = !1, o.skipFirstTimelinelabel = !1;
    var c = n.config.yaxis[0].opposite && n.globals.isBarHorizontal, d = function(u, p) {
      i.yaxis.length > 1 && (function(h) {
        return o.collapsedSeriesIndices.indexOf(h) !== -1;
      })(p) || (function(h) {
        if (t.dCtx.timescaleLabels && t.dCtx.timescaleLabels.length) {
          var f = t.dCtx.timescaleLabels[0], m = t.dCtx.timescaleLabels[t.dCtx.timescaleLabels.length - 1].position + s / 1.75 - t.dCtx.yAxisWidthRight, g = f.position - s / 1.75 + t.dCtx.yAxisWidthLeft, b = n.config.legend.position === "right" && t.dCtx.lgRect.width > 0 ? t.dCtx.lgRect.width : 0;
          m > o.svgWidth - o.translateX - b && (o.skipLastTimelinelabel = !0), g < -(h.show && !h.floating || i.chart.type !== "bar" && i.chart.type !== "candlestick" && i.chart.type !== "rangeBar" && i.chart.type !== "boxPlot" ? 10 : s / 1.75) && (o.skipFirstTimelinelabel = !0);
        } else a === "datetime" ? t.dCtx.gridPad.right < s && !o.rotateXLabels && (o.skipLastTimelinelabel = !0) : a !== "datetime" && t.dCtx.gridPad.right < s / 2 - t.dCtx.yAxisWidthRight && !o.rotateXLabels && !n.config.xaxis.labels.trim && (t.dCtx.xPadRight = s / 2 + 1);
      })(u);
    };
    i.yaxis.forEach((function(u, p) {
      c ? (t.dCtx.gridPad.left < s && (t.dCtx.xPadLeft = s / 2 + 1), t.dCtx.xPadRight = s / 2 + 1) : d(u, p);
    }));
  } }]), r;
})(), WL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.dCtx = e;
  }
  return ve(r, [{ key: "getyAxisLabelsCoords", value: function() {
    var e = this, t = this.w, n = [], o = 10, i = new pn(this.dCtx.ctx);
    return t.config.yaxis.map((function(a, s) {
      var c = { seriesIndex: s, dataPointIndex: -1, w: t }, d = t.globals.yAxisScale[s], u = 0;
      if (!i.isYAxisHidden(s) && a.labels.show && a.labels.minWidth !== void 0 && (u = a.labels.minWidth), !i.isYAxisHidden(s) && a.labels.show && d.result.length) {
        var p = t.globals.yLabelFormatters[s], h = d.niceMin === Number.MIN_VALUE ? 0 : d.niceMin, f = d.result.reduce((function(C, k) {
          var T, S;
          return ((T = String(p(C, c))) === null || T === void 0 ? void 0 : T.length) > ((S = String(p(k, c))) === null || S === void 0 ? void 0 : S.length) ? C : k;
        }), h), m = f = p(f, c);
        if (f !== void 0 && f.length !== 0 || (f = d.niceMax), t.globals.isBarHorizontal) {
          o = 0;
          var g = t.globals.labels.slice();
          f = $.getLargestStringFromArr(g), f = p(f, { seriesIndex: s, dataPointIndex: -1, w: t }), m = e.dCtx.dimHelpers.getLargestStringFromMultiArr(f, g);
        }
        var b = new ee(e.dCtx.ctx), x = "rotate(".concat(a.labels.rotate, " 0 0)"), v = b.getTextRects(f, a.labels.style.fontSize, a.labels.style.fontFamily, x, !1), y = v;
        f !== m && (y = b.getTextRects(m, a.labels.style.fontSize, a.labels.style.fontFamily, x, !1)), n.push({ width: (u > y.width || u > v.width ? u : y.width > v.width ? y.width : v.width) + o, height: y.height > v.height ? y.height : v.height });
      } else n.push({ width: 0, height: 0 });
    })), n;
  } }, { key: "getyAxisTitleCoords", value: function() {
    var e = this, t = this.w, n = [];
    return t.config.yaxis.map((function(o, i) {
      if (o.show && o.title.text !== void 0) {
        var a = new ee(e.dCtx.ctx), s = "rotate(".concat(o.title.rotate, " 0 0)"), c = a.getTextRects(o.title.text, o.title.style.fontSize, o.title.style.fontFamily, s, !1);
        n.push({ width: c.width, height: c.height });
      } else n.push({ width: 0, height: 0 });
    })), n;
  } }, { key: "getTotalYAxisWidth", value: function() {
    var e = this.w, t = 0, n = 0, o = 0, i = e.globals.yAxisScale.length > 1 ? 10 : 0, a = new pn(this.dCtx.ctx), s = function(c, d) {
      var u = e.config.yaxis[d].floating, p = 0;
      c.width > 0 && !u ? (p = c.width + i, (function(h) {
        return e.globals.ignoreYAxisIndexes.indexOf(h) > -1;
      })(d) && (p = p - c.width - i)) : p = u || a.isYAxisHidden(d) ? 0 : 5, e.config.yaxis[d].opposite ? o += p : n += p, t += p;
    };
    return e.globals.yLabelsCoords.map((function(c, d) {
      s(c, d);
    })), e.globals.yTitleCoords.map((function(c, d) {
      s(c, d);
    })), e.globals.isBarHorizontal && !e.config.yaxis[0].floating && (t = e.globals.yLabelsCoords[0].width + e.globals.yTitleCoords[0].width + 15), this.dCtx.yAxisWidthLeft = n, this.dCtx.yAxisWidthRight = o, t;
  } }]), r;
})(), HL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.dCtx = e;
  }
  return ve(r, [{ key: "gridPadForColumnsInNumericAxis", value: function(e) {
    var t = this.w, n = t.config, o = t.globals;
    if (o.noData || o.collapsedSeries.length + o.ancillaryCollapsedSeries.length === n.series.length) return 0;
    var i = function(f) {
      return ["bar", "rangeBar", "candlestick", "boxPlot"].includes(f);
    }, a = n.chart.type, s = 0, c = i(a) ? n.series.length : 1;
    o.comboBarCount > 0 && (c = o.comboBarCount), o.collapsedSeries.forEach((function(f) {
      i(f.type) && (c -= 1);
    })), n.chart.stacked && (c = 1);
    var d = i(a) || o.comboBarCount > 0, u = Math.abs(o.initialMaxX - o.initialMinX);
    if (d && o.isXNumeric && !o.isBarHorizontal && c > 0 && u !== 0) {
      u <= 3 && (u = o.dataPoints);
      var p = u / e, h = o.minXDiff && o.minXDiff / p > 0 ? o.minXDiff / p : 0;
      h > e / 2 && (h /= 2), (s = h * parseInt(n.plotOptions.bar.columnWidth, 10) / 100) < 1 && (s = 1), o.barPadForNumericAxis = s;
    }
    return s;
  } }, { key: "gridPadFortitleSubtitle", value: function() {
    var e = this, t = this.w, n = t.globals, o = this.dCtx.isSparkline || !n.axisCharts ? 0 : 10;
    ["title", "subtitle"].forEach((function(s) {
      t.config[s].text !== void 0 ? o += t.config[s].margin : o += e.dCtx.isSparkline || !n.axisCharts ? 0 : 5;
    })), !t.config.legend.show || t.config.legend.position !== "bottom" || t.config.legend.floating || n.axisCharts || (o += 10);
    var i = this.dCtx.dimHelpers.getTitleSubtitleCoords("title"), a = this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");
    n.gridHeight -= i.height + a.height + o, n.translateY += i.height + a.height + o;
  } }, { key: "setGridXPosForDualYAxis", value: function(e, t) {
    var n = this.w, o = new pn(this.dCtx.ctx);
    n.config.yaxis.forEach((function(i, a) {
      n.globals.ignoreYAxisIndexes.indexOf(a) !== -1 || i.floating || o.isYAxisHidden(a) || (i.opposite && (n.globals.translateX -= t[a].width + e[a].width + parseInt(i.labels.style.fontSize, 10) / 1.2 + 12), n.globals.translateX < 2 && (n.globals.translateX = 2));
    }));
  } }]), r;
})(), cs = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.lgRect = {}, this.yAxisWidth = 0, this.yAxisWidthLeft = 0, this.yAxisWidthRight = 0, this.xAxisHeight = 0, this.isSparkline = this.w.config.chart.sparkline.enabled, this.dimHelpers = new _L(this), this.dimYAxis = new WL(this), this.dimXAxis = new $L(this), this.dimGrid = new HL(this), this.lgWidthForSideLegends = 0, this.gridPad = this.w.config.grid.padding, this.xPadRight = 0, this.xPadLeft = 0;
  }
  return ve(r, [{ key: "plotCoords", value: function() {
    var e = this, t = this.w, n = t.globals;
    this.lgRect = this.dimHelpers.getLegendsRect(), this.datalabelsCoords = { width: 0, height: 0 };
    var o = Array.isArray(t.config.stroke.width) ? Math.max.apply(Math, Mt(t.config.stroke.width)) : t.config.stroke.width;
    this.isSparkline && ((t.config.markers.discrete.length > 0 || t.config.markers.size > 0) && Object.entries(this.gridPad).forEach((function(a) {
      var s = pm(a, 2), c = s[0], d = s[1];
      e.gridPad[c] = Math.max(d, e.w.globals.markers.largestSize / 1.5);
    })), this.gridPad.top = Math.max(o / 2, this.gridPad.top), this.gridPad.bottom = Math.max(o / 2, this.gridPad.bottom)), n.axisCharts ? this.setDimensionsForAxisCharts() : this.setDimensionsForNonAxisCharts(), this.dimGrid.gridPadFortitleSubtitle(), n.gridHeight = n.gridHeight - this.gridPad.top - this.gridPad.bottom, n.gridWidth = n.gridWidth - this.gridPad.left - this.gridPad.right - this.xPadRight - this.xPadLeft;
    var i = this.dimGrid.gridPadForColumnsInNumericAxis(n.gridWidth);
    n.gridWidth = n.gridWidth - 2 * i, n.translateX = n.translateX + this.gridPad.left + this.xPadLeft + (i > 0 ? i : 0), n.translateY = n.translateY + this.gridPad.top;
  } }, { key: "setDimensionsForAxisCharts", value: function() {
    var e = this, t = this.w, n = t.globals, o = this.dimYAxis.getyAxisLabelsCoords(), i = this.dimYAxis.getyAxisTitleCoords();
    n.isSlopeChart && (this.datalabelsCoords = this.dimHelpers.getDatalabelsRect()), t.globals.yLabelsCoords = [], t.globals.yTitleCoords = [], t.config.yaxis.map((function(f, m) {
      t.globals.yLabelsCoords.push({ width: o[m].width, index: m }), t.globals.yTitleCoords.push({ width: i[m].width, index: m });
    })), this.yAxisWidth = this.dimYAxis.getTotalYAxisWidth();
    var a = this.dimXAxis.getxAxisLabelsCoords(), s = this.dimXAxis.getxAxisGroupLabelsCoords(), c = this.dimXAxis.getxAxisTitleCoords();
    this.conditionalChecksForAxisCoords(a, c, s), n.translateXAxisY = t.globals.rotateXLabels ? this.xAxisHeight / 8 : -4, n.translateXAxisX = t.globals.rotateXLabels && t.globals.isXNumeric && t.config.xaxis.labels.rotate <= -45 ? -this.xAxisWidth / 4 : 0, t.globals.isBarHorizontal && (n.rotateXLabels = !1, n.translateXAxisY = parseInt(t.config.xaxis.labels.style.fontSize, 10) / 1.5 * -1), n.translateXAxisY = n.translateXAxisY + t.config.xaxis.labels.offsetY, n.translateXAxisX = n.translateXAxisX + t.config.xaxis.labels.offsetX;
    var d = this.yAxisWidth, u = this.xAxisHeight;
    n.xAxisLabelsHeight = this.xAxisHeight - c.height, n.xAxisGroupLabelsHeight = n.xAxisLabelsHeight - a.height, n.xAxisLabelsWidth = this.xAxisWidth, n.xAxisHeight = this.xAxisHeight;
    var p = 10;
    (t.config.chart.type === "radar" || this.isSparkline) && (d = 0, u = 0), this.isSparkline && (this.lgRect = { height: 0, width: 0 }), (this.isSparkline || t.config.chart.type === "treemap") && (d = 0, u = 0, p = 0), this.isSparkline || t.config.chart.type === "treemap" || this.dimXAxis.additionalPaddingXLabels(a);
    var h = function() {
      n.translateX = d + e.datalabelsCoords.width, n.gridHeight = n.svgHeight - e.lgRect.height - u - (e.isSparkline || t.config.chart.type === "treemap" ? 0 : t.globals.rotateXLabels ? 10 : 15), n.gridWidth = n.svgWidth - d - 2 * e.datalabelsCoords.width;
    };
    switch (t.config.xaxis.position === "top" && (p = n.xAxisHeight - t.config.xaxis.axisTicks.height - 5), t.config.legend.position) {
      case "bottom":
        n.translateY = p, h();
        break;
      case "top":
        n.translateY = this.lgRect.height + p, h();
        break;
      case "left":
        n.translateY = p, n.translateX = this.lgRect.width + d + this.datalabelsCoords.width, n.gridHeight = n.svgHeight - u - 12, n.gridWidth = n.svgWidth - this.lgRect.width - d - 2 * this.datalabelsCoords.width;
        break;
      case "right":
        n.translateY = p, n.translateX = d + this.datalabelsCoords.width, n.gridHeight = n.svgHeight - u - 12, n.gridWidth = n.svgWidth - this.lgRect.width - d - 2 * this.datalabelsCoords.width - 5;
        break;
      default:
        throw new Error("Legend position not supported");
    }
    this.dimGrid.setGridXPosForDualYAxis(i, o), new Bd(this.ctx).setYAxisXPosition(o, i);
  } }, { key: "setDimensionsForNonAxisCharts", value: function() {
    var e = this.w, t = e.globals, n = e.config, o = 0;
    e.config.legend.show && !e.config.legend.floating && (o = 20);
    var i = n.chart.type === "pie" || n.chart.type === "polarArea" || n.chart.type === "donut" ? "pie" : "radialBar", a = n.plotOptions[i].offsetY, s = n.plotOptions[i].offsetX;
    if (!n.legend.show || n.legend.floating) {
      t.gridHeight = t.svgHeight;
      var c = t.dom.elWrap.getBoundingClientRect().width;
      return t.gridWidth = Math.min(c, t.gridHeight), t.translateY = a, void (t.translateX = s + (t.svgWidth - t.gridWidth) / 2);
    }
    switch (n.legend.position) {
      case "bottom":
        t.gridHeight = t.svgHeight - this.lgRect.height, t.gridWidth = t.svgWidth, t.translateY = a - 10, t.translateX = s + (t.svgWidth - t.gridWidth) / 2;
        break;
      case "top":
        t.gridHeight = t.svgHeight - this.lgRect.height, t.gridWidth = t.svgWidth, t.translateY = this.lgRect.height + a + 10, t.translateX = s + (t.svgWidth - t.gridWidth) / 2;
        break;
      case "left":
        t.gridWidth = t.svgWidth - this.lgRect.width - o, t.gridHeight = n.chart.height !== "auto" ? t.svgHeight : t.gridWidth, t.translateY = a, t.translateX = s + this.lgRect.width + o;
        break;
      case "right":
        t.gridWidth = t.svgWidth - this.lgRect.width - o - 5, t.gridHeight = n.chart.height !== "auto" ? t.svgHeight : t.gridWidth, t.translateY = a, t.translateX = s + 10;
        break;
      default:
        throw new Error("Legend position not supported");
    }
  } }, { key: "conditionalChecksForAxisCoords", value: function(e, t, n) {
    var o = this.w, i = o.globals.hasXaxisGroups ? 2 : 1, a = n.height + e.height + t.height, s = o.globals.isMultiLineX ? 1.2 : o.globals.LINE_HEIGHT_RATIO, c = o.globals.rotateXLabels ? 22 : 10, d = o.globals.rotateXLabels && o.config.legend.position === "bottom" ? 10 : 0;
    this.xAxisHeight = a * s + i * c + d, this.xAxisWidth = e.width, this.xAxisHeight - t.height > o.config.xaxis.labels.maxHeight && (this.xAxisHeight = o.config.xaxis.labels.maxHeight), o.config.xaxis.labels.minHeight && this.xAxisHeight < o.config.xaxis.labels.minHeight && (this.xAxisHeight = o.config.xaxis.labels.minHeight), o.config.xaxis.floating && (this.xAxisHeight = 0);
    var u = 0, p = 0;
    o.config.yaxis.forEach((function(h) {
      u += h.labels.minWidth, p += h.labels.maxWidth;
    })), this.yAxisWidth < u && (this.yAxisWidth = u), this.yAxisWidth > p && (this.yAxisWidth = p);
  } }]), r;
})(), YL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.lgCtx = e;
  }
  return ve(r, [{ key: "getLegendStyles", value: function() {
    var e, t, n, o = document.createElement("style");
    o.setAttribute("type", "text/css");
    var i = ((e = this.lgCtx.ctx) === null || e === void 0 || (t = e.opts) === null || t === void 0 || (n = t.chart) === null || n === void 0 ? void 0 : n.nonce) || this.w.config.chart.nonce;
    i && o.setAttribute("nonce", i);
    var a = document.createTextNode(Hm);
    return o.appendChild(a), o;
  } }, { key: "getLegendDimensions", value: function() {
    var e = this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(), t = e.width;
    return { clwh: e.height, clww: t };
  } }, { key: "appendToForeignObject", value: function() {
    var e = this.w.globals;
    this.w.config.chart.injectStyleSheet !== !1 && e.dom.elLegendForeign.appendChild(this.getLegendStyles());
  } }, { key: "toggleDataSeries", value: function(e, t) {
    var n = this, o = this.w;
    if (o.globals.axisCharts || o.config.chart.type === "radialBar") {
      o.globals.resized = !0;
      var i = null, a = null;
      o.globals.risingSeries = [], o.globals.axisCharts ? (i = o.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e, "']")), a = parseInt(i.getAttribute("data:realIndex"), 10)) : (i = o.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(e + 1, "']")), a = parseInt(i.getAttribute("rel"), 10) - 1), t ? [{ cs: o.globals.collapsedSeries, csi: o.globals.collapsedSeriesIndices }, { cs: o.globals.ancillaryCollapsedSeries, csi: o.globals.ancillaryCollapsedSeriesIndices }].forEach((function(u) {
        n.riseCollapsedSeries(u.cs, u.csi, a);
      })) : this.hideSeries({ seriesEl: i, realIndex: a });
    } else {
      var s = o.globals.dom.Paper.findOne(" .apexcharts-series[rel='".concat(e + 1, "'] path")), c = o.config.chart.type;
      if (c === "pie" || c === "polarArea" || c === "donut") {
        var d = o.config.plotOptions.pie.donut.labels;
        new ee(this.lgCtx.ctx).pathMouseDown(s, null), this.lgCtx.ctx.pie.printDataLabelsInner(s.node, d);
      }
      s.fire("click");
    }
  } }, { key: "getSeriesAfterCollapsing", value: function(e) {
    var t = e.realIndex, n = this.w, o = n.globals, i = $.clone(n.config.series);
    if (o.axisCharts) {
      var a = n.config.yaxis[o.seriesYAxisReverseMap[t]], s = { index: t, data: i[t].data.slice(), type: i[t].type || n.config.chart.type };
      if (a && a.show && a.showAlways) o.ancillaryCollapsedSeriesIndices.indexOf(t) < 0 && (o.ancillaryCollapsedSeries.push(s), o.ancillaryCollapsedSeriesIndices.push(t));
      else if (o.collapsedSeriesIndices.indexOf(t) < 0) {
        o.collapsedSeries.push(s), o.collapsedSeriesIndices.push(t);
        var c = o.risingSeries.indexOf(t);
        o.risingSeries.splice(c, 1);
      }
    } else o.collapsedSeries.push({ index: t, data: i[t] }), o.collapsedSeriesIndices.push(t);
    return o.allSeriesCollapsed = o.collapsedSeries.length + o.ancillaryCollapsedSeries.length === n.config.series.length, this._getSeriesBasedOnCollapsedState(i);
  } }, { key: "hideSeries", value: function(e) {
    for (var t = e.seriesEl, n = e.realIndex, o = this.w, i = this.getSeriesAfterCollapsing({ realIndex: n }), a = t.childNodes, s = 0; s < a.length; s++) a[s].classList.contains("apexcharts-series-markers-wrap") && (a[s].classList.contains("apexcharts-hide") ? a[s].classList.remove("apexcharts-hide") : a[s].classList.add("apexcharts-hide"));
    this.lgCtx.ctx.updateHelpers._updateSeries(i, o.config.chart.animations.dynamicAnimation.enabled);
  } }, { key: "riseCollapsedSeries", value: function(e, t, n) {
    var o = this.w, i = $.clone(o.config.series);
    if (e.length > 0) {
      for (var a = 0; a < e.length; a++) e[a].index === n && (o.globals.axisCharts ? i[n].data = e[a].data.slice() : i[n] = e[a].data, typeof i[n] != "number" && (i[n].hidden = !1), e.splice(a, 1), t.splice(a, 1), o.globals.risingSeries.push(n));
      i = this._getSeriesBasedOnCollapsedState(i), this.lgCtx.ctx.updateHelpers._updateSeries(i, o.config.chart.animations.dynamicAnimation.enabled);
    }
  } }, { key: "_getSeriesBasedOnCollapsedState", value: function(e) {
    var t = this.w, n = 0;
    return t.globals.axisCharts ? e.forEach((function(o, i) {
      t.globals.collapsedSeriesIndices.indexOf(i) < 0 && t.globals.ancillaryCollapsedSeriesIndices.indexOf(i) < 0 || (e[i].data = [], n++);
    })) : e.forEach((function(o, i) {
      !t.globals.collapsedSeriesIndices.indexOf(i) < 0 && (e[i] = 0, n++);
    })), t.globals.allSeriesCollapsed = n === e.length, e;
  } }]), r;
})(), Vm = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.onLegendClick = this.onLegendClick.bind(this), this.onLegendHovered = this.onLegendHovered.bind(this), this.isBarsDistributed = this.w.config.chart.type === "bar" && this.w.config.plotOptions.bar.distributed && this.w.config.series.length === 1, this.legendHelpers = new YL(this);
  }
  return ve(r, [{ key: "init", value: function() {
    var e = this.w, t = e.globals, n = e.config, o = n.legend.showForSingleSeries && t.series.length === 1 || this.isBarsDistributed || t.series.length > 1;
    if (this.legendHelpers.appendToForeignObject(), (o || !t.axisCharts) && n.legend.show) {
      for (; t.dom.elLegendWrap.firstChild; ) t.dom.elLegendWrap.removeChild(t.dom.elLegendWrap.firstChild);
      this.drawLegends(), n.legend.position === "bottom" || n.legend.position === "top" ? this.legendAlignHorizontal() : n.legend.position !== "right" && n.legend.position !== "left" || this.legendAlignVertical();
    }
  } }, { key: "createLegendMarker", value: function(e) {
    var t = e.i, n = e.fillcolor, o = this.w, i = document.createElement("span");
    i.classList.add("apexcharts-legend-marker");
    var a = o.config.legend.markers.shape || o.config.markers.shape, s = a;
    Array.isArray(a) && (s = a[t]);
    var c = Array.isArray(o.config.legend.markers.size) ? parseFloat(o.config.legend.markers.size[t]) : parseFloat(o.config.legend.markers.size), d = Array.isArray(o.config.legend.markers.offsetX) ? parseFloat(o.config.legend.markers.offsetX[t]) : parseFloat(o.config.legend.markers.offsetX), u = Array.isArray(o.config.legend.markers.offsetY) ? parseFloat(o.config.legend.markers.offsetY[t]) : parseFloat(o.config.legend.markers.offsetY), p = Array.isArray(o.config.legend.markers.strokeWidth) ? parseFloat(o.config.legend.markers.strokeWidth[t]) : parseFloat(o.config.legend.markers.strokeWidth), h = i.style;
    if (h.height = 2 * (c + p) + "px", h.width = 2 * (c + p) + "px", h.left = d + "px", h.top = u + "px", o.config.legend.markers.customHTML) h.background = "transparent", h.color = n[t], Array.isArray(o.config.legend.markers.customHTML) ? o.config.legend.markers.customHTML[t] && (i.innerHTML = o.config.legend.markers.customHTML[t]()) : i.innerHTML = o.config.legend.markers.customHTML();
    else {
      var f = new Io(this.ctx).getMarkerConfig({ cssClass: "apexcharts-legend-marker apexcharts-marker apexcharts-marker-".concat(s), seriesIndex: t, strokeWidth: p, size: c }), m = window.SVG().addTo(i).size("100%", "100%"), g = new ee(this.ctx).drawMarker(0, 0, ie(ie({}, f), {}, { pointFillColor: Array.isArray(n) ? n[t] : f.pointFillColor, shape: s }));
      o.globals.dom.Paper.find(".apexcharts-legend-marker.apexcharts-marker").forEach((function(b) {
        b.node.classList.contains("apexcharts-marker-triangle") ? b.node.style.transform = "translate(50%, 45%)" : b.node.style.transform = "translate(50%, 50%)";
      })), m.add(g);
    }
    return i;
  } }, { key: "drawLegends", value: function() {
    var e = this, t = this, n = this.w, o = n.config.legend.fontFamily, i = n.globals.seriesNames, a = n.config.legend.markers.fillColors ? n.config.legend.markers.fillColors.slice() : n.globals.colors.slice();
    if (n.config.chart.type === "heatmap") {
      var s = n.config.plotOptions.heatmap.colorScale.ranges;
      i = s.map((function(f) {
        return f.name ? f.name : f.from + " - " + f.to;
      })), a = s.map((function(f) {
        return f.color;
      }));
    } else this.isBarsDistributed && (i = n.globals.labels.slice());
    n.config.legend.customLegendItems.length && (i = n.config.legend.customLegendItems);
    var c = n.globals.legendFormatter, d = n.config.legend.inverseOrder, u = [];
    n.globals.seriesGroups.length > 1 && n.config.legend.clusterGroupedSeries && n.globals.seriesGroups.forEach((function(f, m) {
      u[m] = document.createElement("div"), u[m].classList.add("apexcharts-legend-group", "apexcharts-legend-group-".concat(m)), n.config.legend.clusterGroupedSeriesOrientation === "horizontal" ? n.globals.dom.elLegendWrap.classList.add("apexcharts-legend-group-horizontal") : u[m].classList.add("apexcharts-legend-group-vertical");
    }));
    for (var p = function(f) {
      var m, g = c(i[f], { seriesIndex: f, w: n }), b = !1, x = !1;
      if (n.globals.collapsedSeries.length > 0) for (var v = 0; v < n.globals.collapsedSeries.length; v++) n.globals.collapsedSeries[v].index === f && (b = !0);
      if (n.globals.ancillaryCollapsedSeriesIndices.length > 0) for (var y = 0; y < n.globals.ancillaryCollapsedSeriesIndices.length; y++) n.globals.ancillaryCollapsedSeriesIndices[y] === f && (x = !0);
      var C = e.createLegendMarker({ i: f, fillcolor: a });
      ee.setAttrs(C, { rel: f + 1, "data:collapsed": b || x }), (b || x) && C.classList.add("apexcharts-inactive-legend");
      var k = document.createElement("div"), T = document.createElement("span");
      T.classList.add("apexcharts-legend-text"), T.innerHTML = Array.isArray(g) ? g.join(" ") : g;
      var S = n.config.legend.labels.useSeriesColors ? n.globals.colors[f] : Array.isArray(n.config.legend.labels.colors) ? (m = n.config.legend.labels.colors) === null || m === void 0 ? void 0 : m[f] : n.config.legend.labels.colors;
      S || (S = n.config.chart.foreColor), T.style.color = S, T.style.fontSize = parseFloat(n.config.legend.fontSize) + "px", T.style.fontWeight = n.config.legend.fontWeight, T.style.fontFamily = o || n.config.chart.fontFamily, ee.setAttrs(T, { rel: f + 1, i: f, "data:default-text": encodeURIComponent(g), "data:collapsed": b || x }), k.appendChild(C), k.appendChild(T);
      var O = new Tt(e.ctx);
      n.config.legend.showForZeroSeries || O.getSeriesTotalByIndex(f) === 0 && O.seriesHaveSameValues(f) && !O.isSeriesNull(f) && n.globals.collapsedSeriesIndices.indexOf(f) === -1 && n.globals.ancillaryCollapsedSeriesIndices.indexOf(f) === -1 && k.classList.add("apexcharts-hidden-zero-series"), n.config.legend.showForNullSeries || O.isSeriesNull(f) && n.globals.collapsedSeriesIndices.indexOf(f) === -1 && n.globals.ancillaryCollapsedSeriesIndices.indexOf(f) === -1 && k.classList.add("apexcharts-hidden-null-series"), u.length ? n.globals.seriesGroups.forEach((function(P, M) {
        var I;
        P.includes((I = n.config.series[f]) === null || I === void 0 ? void 0 : I.name) && (n.globals.dom.elLegendWrap.appendChild(u[M]), u[M].appendChild(k));
      })) : n.globals.dom.elLegendWrap.appendChild(k), n.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(n.config.legend.horizontalAlign)), n.globals.dom.elLegendWrap.classList.add("apx-legend-position-" + n.config.legend.position), k.classList.add("apexcharts-legend-series"), k.style.margin = "".concat(n.config.legend.itemMargin.vertical, "px ").concat(n.config.legend.itemMargin.horizontal, "px"), n.globals.dom.elLegendWrap.style.width = n.config.legend.width ? n.config.legend.width + "px" : "", n.globals.dom.elLegendWrap.style.height = n.config.legend.height ? n.config.legend.height + "px" : "", ee.setAttrs(k, { rel: f + 1, seriesName: $.escapeString(i[f]), "data:collapsed": b || x }), (b || x) && k.classList.add("apexcharts-inactive-legend"), n.config.legend.onItemClick.toggleDataSeries || k.classList.add("apexcharts-no-click");
    }, h = d ? i.length - 1 : 0; d ? h >= 0 : h <= i.length - 1; d ? h-- : h++) p(h);
    n.globals.dom.elWrap.addEventListener("click", t.onLegendClick, !0), n.config.legend.onItemHover.highlightDataSeries && n.config.legend.customLegendItems.length === 0 && (n.globals.dom.elWrap.addEventListener("mousemove", t.onLegendHovered, !0), n.globals.dom.elWrap.addEventListener("mouseout", t.onLegendHovered, !0));
  } }, { key: "setLegendWrapXY", value: function(e, t) {
    var n = this.w, o = n.globals.dom.elLegendWrap, i = o.clientHeight, a = 0, s = 0;
    if (n.config.legend.position === "bottom") s = n.globals.svgHeight - Math.min(i, n.globals.svgHeight / 2) - 5;
    else if (n.config.legend.position === "top") {
      var c = new cs(this.ctx), d = c.dimHelpers.getTitleSubtitleCoords("title").height, u = c.dimHelpers.getTitleSubtitleCoords("subtitle").height;
      s = (d > 0 ? d - 10 : 0) + (u > 0 ? u - 10 : 0);
    }
    o.style.position = "absolute", a = a + e + n.config.legend.offsetX, s = s + t + n.config.legend.offsetY, o.style.left = a + "px", o.style.top = s + "px", n.config.legend.position === "right" && (o.style.left = "auto", o.style.right = 25 + n.config.legend.offsetX + "px"), ["width", "height"].forEach((function(p) {
      o.style[p] && (o.style[p] = parseInt(n.config.legend[p], 10) + "px");
    }));
  } }, { key: "legendAlignHorizontal", value: function() {
    var e = this.w;
    e.globals.dom.elLegendWrap.style.right = 0;
    var t = new cs(this.ctx), n = t.dimHelpers.getTitleSubtitleCoords("title"), o = t.dimHelpers.getTitleSubtitleCoords("subtitle"), i = 0;
    e.config.legend.position === "top" && (i = n.height + o.height + e.config.title.margin + e.config.subtitle.margin - 10), this.setLegendWrapXY(20, i);
  } }, { key: "legendAlignVertical", value: function() {
    var e = this.w, t = this.legendHelpers.getLegendDimensions(), n = 0;
    e.config.legend.position === "left" && (n = 20), e.config.legend.position === "right" && (n = e.globals.svgWidth - t.clww - 10), this.setLegendWrapXY(n, 20);
  } }, { key: "onLegendHovered", value: function(e) {
    var t = this.w, n = e.target.classList.contains("apexcharts-legend-series") || e.target.classList.contains("apexcharts-legend-text") || e.target.classList.contains("apexcharts-legend-marker");
    if (t.config.chart.type === "heatmap" || this.isBarsDistributed) {
      if (n) {
        var o = parseInt(e.target.getAttribute("rel"), 10) - 1;
        this.ctx.events.fireEvent("legendHover", [this.ctx, o, this.w]), new mr(this.ctx).highlightRangeInSeries(e, e.target);
      }
    } else !e.target.classList.contains("apexcharts-inactive-legend") && n && new mr(this.ctx).toggleSeriesOnHover(e, e.target);
  } }, { key: "onLegendClick", value: function(e) {
    var t = this.w;
    if (!t.config.legend.customLegendItems.length && (e.target.classList.contains("apexcharts-legend-series") || e.target.classList.contains("apexcharts-legend-text") || e.target.classList.contains("apexcharts-legend-marker"))) {
      var n = parseInt(e.target.getAttribute("rel"), 10) - 1, o = e.target.getAttribute("data:collapsed") === "true", i = this.w.config.chart.events.legendClick;
      typeof i == "function" && i(this.ctx, n, this.w), this.ctx.events.fireEvent("legendClick", [this.ctx, n, this.w]);
      var a = this.w.config.legend.markers.onClick;
      typeof a == "function" && e.target.classList.contains("apexcharts-legend-marker") && (a(this.ctx, n, this.w), this.ctx.events.fireEvent("legendMarkerClick", [this.ctx, n, this.w])), t.config.chart.type !== "treemap" && t.config.chart.type !== "heatmap" && !this.isBarsDistributed && t.config.legend.onItemClick.toggleDataSeries && this.legendHelpers.toggleDataSeries(n, o);
    }
  } }]), r;
})(), Um = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
    var t = this.w;
    this.ev = this.w.config.chart.events, this.selectedClass = "apexcharts-selected", this.localeValues = this.w.globals.locale.toolbar, this.minX = t.globals.minX, this.maxX = t.globals.maxX;
  }
  return ve(r, [{ key: "createToolbar", value: function() {
    var e = this, t = this.w, n = function() {
      return document.createElement("div");
    }, o = n();
    if (o.setAttribute("class", "apexcharts-toolbar"), o.style.top = t.config.chart.toolbar.offsetY + "px", o.style.right = 3 - t.config.chart.toolbar.offsetX + "px", t.globals.dom.elWrap.appendChild(o), this.elZoom = n(), this.elZoomIn = n(), this.elZoomOut = n(), this.elPan = n(), this.elSelection = n(), this.elZoomReset = n(), this.elMenuIcon = n(), this.elMenu = n(), this.elCustomIcons = [], this.t = t.config.chart.toolbar.tools, Array.isArray(this.t.customIcons)) for (var i = 0; i < this.t.customIcons.length; i++) this.elCustomIcons.push(n());
    var a = [], s = function(p, h, f) {
      var m = p.toLowerCase();
      e.t[m] && t.config.chart.zoom.enabled && a.push({ el: h, icon: typeof e.t[m] == "string" ? e.t[m] : f, title: e.localeValues[p], class: "apexcharts-".concat(m, "-icon") });
    };
    s("zoomIn", this.elZoomIn, `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
</svg>
`), s("zoomOut", this.elZoomOut, `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
</svg>
`);
    var c = function(p) {
      e.t[p] && t.config.chart[p].enabled && a.push({ el: p === "zoom" ? e.elZoom : e.elSelection, icon: typeof e.t[p] == "string" ? e.t[p] : p === "zoom" ? `<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
    <path d="M0 0h24v24H0V0z" fill="none"/>
    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>
</svg>` : `<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>
</svg>`, title: e.localeValues[p === "zoom" ? "selectionZoom" : "selection"], class: "apexcharts-".concat(p, "-icon") });
    };
    c("zoom"), c("selection"), this.t.pan && t.config.chart.zoom.enabled && a.push({ el: this.elPan, icon: typeof this.t.pan == "string" ? this.t.pan : `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">
    <defs>
        <path d="M0 0h24v24H0z" id="a"/>
    </defs>
    <clipPath id="b">
        <use overflow="visible" xlink:href="#a"/>
    </clipPath>
    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>
</svg>`, title: this.localeValues.pan, class: "apexcharts-pan-icon" }), s("reset", this.elZoomReset, `<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
</svg>`), this.t.download && a.push({ el: this.elMenuIcon, icon: typeof this.t.download == "string" ? this.t.download : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>', title: this.localeValues.menu, class: "apexcharts-menu-icon" });
    for (var d = 0; d < this.elCustomIcons.length; d++) a.push({ el: this.elCustomIcons[d], icon: this.t.customIcons[d].icon, title: this.t.customIcons[d].title, index: this.t.customIcons[d].index, class: "apexcharts-toolbar-custom-icon " + this.t.customIcons[d].class });
    a.forEach((function(p, h) {
      p.index && $.moveIndexInArray(a, h, p.index);
    }));
    for (var u = 0; u < a.length; u++) ee.setAttrs(a[u].el, { class: a[u].class, title: a[u].title }), a[u].el.innerHTML = a[u].icon, o.appendChild(a[u].el);
    this._createHamburgerMenu(o), t.globals.zoomEnabled ? this.elZoom.classList.add(this.selectedClass) : t.globals.panEnabled ? this.elPan.classList.add(this.selectedClass) : t.globals.selectionEnabled && this.elSelection.classList.add(this.selectedClass), this.addToolbarEventListeners();
  } }, { key: "_createHamburgerMenu", value: function(e) {
    this.elMenuItems = [], e.appendChild(this.elMenu), ee.setAttrs(this.elMenu, { class: "apexcharts-menu" });
    for (var t = [{ name: "exportSVG", title: this.localeValues.exportToSVG }, { name: "exportPNG", title: this.localeValues.exportToPNG }, { name: "exportCSV", title: this.localeValues.exportToCSV }], n = 0; n < t.length; n++) this.elMenuItems.push(document.createElement("div")), this.elMenuItems[n].innerHTML = t[n].title, ee.setAttrs(this.elMenuItems[n], { class: "apexcharts-menu-item ".concat(t[n].name), title: t[n].title }), this.elMenu.appendChild(this.elMenuItems[n]);
  } }, { key: "addToolbarEventListeners", value: function() {
    var e = this;
    this.elZoomReset.addEventListener("click", this.handleZoomReset.bind(this)), this.elSelection.addEventListener("click", this.toggleZoomSelection.bind(this, "selection")), this.elZoom.addEventListener("click", this.toggleZoomSelection.bind(this, "zoom")), this.elZoomIn.addEventListener("click", this.handleZoomIn.bind(this)), this.elZoomOut.addEventListener("click", this.handleZoomOut.bind(this)), this.elPan.addEventListener("click", this.togglePanning.bind(this)), this.elMenuIcon.addEventListener("click", this.toggleMenu.bind(this)), this.elMenuItems.forEach((function(n) {
      n.classList.contains("exportSVG") ? n.addEventListener("click", e.handleDownload.bind(e, "svg")) : n.classList.contains("exportPNG") ? n.addEventListener("click", e.handleDownload.bind(e, "png")) : n.classList.contains("exportCSV") && n.addEventListener("click", e.handleDownload.bind(e, "csv"));
    }));
    for (var t = 0; t < this.t.customIcons.length; t++) this.elCustomIcons[t].addEventListener("click", this.t.customIcons[t].click.bind(this, this.ctx, this.ctx.w));
  } }, { key: "toggleZoomSelection", value: function(e) {
    this.ctx.getSyncedCharts().forEach((function(t) {
      t.ctx.toolbar.toggleOtherControls();
      var n = e === "selection" ? t.ctx.toolbar.elSelection : t.ctx.toolbar.elZoom, o = e === "selection" ? "selectionEnabled" : "zoomEnabled";
      t.w.globals[o] = !t.w.globals[o], n.classList.contains(t.ctx.toolbar.selectedClass) ? n.classList.remove(t.ctx.toolbar.selectedClass) : n.classList.add(t.ctx.toolbar.selectedClass);
    }));
  } }, { key: "getToolbarIconsReference", value: function() {
    var e = this.w;
    this.elZoom || (this.elZoom = e.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")), this.elPan || (this.elPan = e.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")), this.elSelection || (this.elSelection = e.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"));
  } }, { key: "enableZoomPanFromToolbar", value: function(e) {
    this.toggleOtherControls(), e === "pan" ? this.w.globals.panEnabled = !0 : this.w.globals.zoomEnabled = !0;
    var t = e === "pan" ? this.elPan : this.elZoom, n = e === "pan" ? this.elZoom : this.elPan;
    t && t.classList.add(this.selectedClass), n && n.classList.remove(this.selectedClass);
  } }, { key: "togglePanning", value: function() {
    this.ctx.getSyncedCharts().forEach((function(e) {
      e.ctx.toolbar.toggleOtherControls(), e.w.globals.panEnabled = !e.w.globals.panEnabled, e.ctx.toolbar.elPan.classList.contains(e.ctx.toolbar.selectedClass) ? e.ctx.toolbar.elPan.classList.remove(e.ctx.toolbar.selectedClass) : e.ctx.toolbar.elPan.classList.add(e.ctx.toolbar.selectedClass);
    }));
  } }, { key: "toggleOtherControls", value: function() {
    var e = this, t = this.w;
    t.globals.panEnabled = !1, t.globals.zoomEnabled = !1, t.globals.selectionEnabled = !1, this.getToolbarIconsReference(), [this.elPan, this.elSelection, this.elZoom].forEach((function(n) {
      n && n.classList.remove(e.selectedClass);
    }));
  } }, { key: "handleZoomIn", value: function() {
    var e = this.w;
    e.globals.isRangeBar && (this.minX = e.globals.minY, this.maxX = e.globals.maxY);
    var t = (this.minX + this.maxX) / 2, n = (this.minX + t) / 2, o = (this.maxX + t) / 2, i = this._getNewMinXMaxX(n, o);
    e.globals.disableZoomIn || this.zoomUpdateOptions(i.minX, i.maxX);
  } }, { key: "handleZoomOut", value: function() {
    var e = this.w;
    if (e.globals.isRangeBar && (this.minX = e.globals.minY, this.maxX = e.globals.maxY), !(e.config.xaxis.type === "datetime" && new Date(this.minX).getUTCFullYear() < 1e3)) {
      var t = (this.minX + this.maxX) / 2, n = this.minX - (t - this.minX), o = this.maxX - (t - this.maxX), i = this._getNewMinXMaxX(n, o);
      e.globals.disableZoomOut || this.zoomUpdateOptions(i.minX, i.maxX);
    }
  } }, { key: "_getNewMinXMaxX", value: function(e, t) {
    var n = this.w.config.xaxis.convertedCatToNumeric;
    return { minX: n ? Math.floor(e) : e, maxX: n ? Math.floor(t) : t };
  } }, { key: "zoomUpdateOptions", value: function(e, t) {
    var n = this.w;
    if (e !== void 0 || t !== void 0) {
      if (!(n.config.xaxis.convertedCatToNumeric && (e < 1 && (e = 1, t = n.globals.dataPoints), t - e < 2))) {
        var o = { min: e, max: t }, i = this.getBeforeZoomRange(o);
        i && (o = i.xaxis);
        var a = { xaxis: o }, s = $.clone(n.globals.initialConfig.yaxis);
        n.config.chart.group || (a.yaxis = s), this.w.globals.zoomed = !0, this.ctx.updateHelpers._updateOptions(a, !1, this.w.config.chart.animations.dynamicAnimation.enabled), this.zoomCallback(o, s);
      }
    } else this.handleZoomReset();
  } }, { key: "zoomCallback", value: function(e, t) {
    typeof this.ev.zoomed == "function" && (this.ev.zoomed(this.ctx, { xaxis: e, yaxis: t }), this.ctx.events.fireEvent("zoomed", { xaxis: e, yaxis: t }));
  } }, { key: "getBeforeZoomRange", value: function(e, t) {
    var n = null;
    return typeof this.ev.beforeZoom == "function" && (n = this.ev.beforeZoom(this, { xaxis: e, yaxis: t })), n;
  } }, { key: "toggleMenu", value: function() {
    var e = this;
    window.setTimeout((function() {
      e.elMenu.classList.contains("apexcharts-menu-open") ? e.elMenu.classList.remove("apexcharts-menu-open") : e.elMenu.classList.add("apexcharts-menu-open");
    }), 0);
  } }, { key: "handleDownload", value: function(e) {
    var t = this.w, n = new Ei(this.ctx);
    switch (e) {
      case "svg":
        n.exportToSVG(this.ctx);
        break;
      case "png":
        n.exportToPng(this.ctx);
        break;
      case "csv":
        n.exportToCSV({ series: t.config.series, columnDelimiter: t.config.chart.toolbar.export.csv.columnDelimiter });
    }
  } }, { key: "handleZoomReset", value: function(e) {
    this.ctx.getSyncedCharts().forEach((function(t) {
      var n = t.w;
      if (n.globals.lastXAxis.min = n.globals.initialConfig.xaxis.min, n.globals.lastXAxis.max = n.globals.initialConfig.xaxis.max, t.updateHelpers.revertDefaultAxisMinMax(), typeof n.config.chart.events.beforeResetZoom == "function") {
        var o = n.config.chart.events.beforeResetZoom(t, n);
        o && t.updateHelpers.revertDefaultAxisMinMax(o);
      }
      typeof n.config.chart.events.zoomed == "function" && t.ctx.toolbar.zoomCallback({ min: n.config.xaxis.min, max: n.config.xaxis.max }), n.globals.zoomed = !1;
      var i = t.ctx.series.emptyCollapsedSeries($.clone(n.globals.initialSeries));
      t.updateHelpers._updateSeries(i, n.config.chart.animations.dynamicAnimation.enabled);
    }));
  } }, { key: "destroy", value: function() {
    this.elZoom = null, this.elZoomIn = null, this.elZoomOut = null, this.elPan = null, this.elSelection = null, this.elZoomReset = null, this.elMenuIcon = null;
  } }]), r;
})(), XL = (function(r) {
  oa(t, Um);
  var e = na(t);
  function t(n) {
    var o;
    return xe(this, t), (o = e.call(this, n)).ctx = n, o.w = n.w, o.dragged = !1, o.graphics = new ee(o.ctx), o.eventList = ["mousedown", "mouseleave", "mousemove", "touchstart", "touchmove", "mouseup", "touchend", "wheel"], o.clientX = 0, o.clientY = 0, o.startX = 0, o.endX = 0, o.dragX = 0, o.startY = 0, o.endY = 0, o.dragY = 0, o.moveDirection = "none", o.debounceTimer = null, o.debounceDelay = 100, o.wheelDelay = 400, o;
  }
  return ve(t, [{ key: "init", value: function(n) {
    var o = this, i = n.xyRatios, a = this.w, s = this;
    this.xyRatios = i, this.zoomRect = this.graphics.drawRect(0, 0, 0, 0), this.selectionRect = this.graphics.drawRect(0, 0, 0, 0), this.gridRect = a.globals.dom.baseEl.querySelector(".apexcharts-grid"), this.constraints = new St(0, 0, a.globals.gridWidth, a.globals.gridHeight), this.zoomRect.node.classList.add("apexcharts-zoom-rect"), this.selectionRect.node.classList.add("apexcharts-selection-rect"), a.globals.dom.Paper.add(this.zoomRect), a.globals.dom.Paper.add(this.selectionRect), a.config.chart.selection.type === "x" ? this.slDraggableRect = this.selectionRect.draggable({ minX: 0, minY: 0, maxX: a.globals.gridWidth, maxY: a.globals.gridHeight }).on("dragmove.namespace", this.selectionDragging.bind(this, "dragging")) : a.config.chart.selection.type === "y" ? this.slDraggableRect = this.selectionRect.draggable({ minX: 0, maxX: a.globals.gridWidth }).on("dragmove.namespace", this.selectionDragging.bind(this, "dragging")) : this.slDraggableRect = this.selectionRect.draggable().on("dragmove.namespace", this.selectionDragging.bind(this, "dragging")), this.preselectedSelection(), this.hoverArea = a.globals.dom.baseEl.querySelector("".concat(a.globals.chartClass, " .apexcharts-svg")), this.hoverArea.classList.add("apexcharts-zoomable"), this.eventList.forEach((function(c) {
      o.hoverArea.addEventListener(c, s.svgMouseEvents.bind(s, i), { capture: !1, passive: !0 });
    })), a.config.chart.zoom.enabled && a.config.chart.zoom.allowMouseWheelZoom && this.hoverArea.addEventListener("wheel", s.mouseWheelEvent.bind(s), { capture: !1, passive: !1 });
  } }, { key: "destroy", value: function() {
    this.slDraggableRect && (this.slDraggableRect.draggable(!1), this.slDraggableRect.off(), this.selectionRect.off()), this.selectionRect = null, this.zoomRect = null, this.gridRect = null;
  } }, { key: "svgMouseEvents", value: function(n, o) {
    var i = this.w, a = this.ctx.toolbar, s = i.globals.zoomEnabled ? i.config.chart.zoom.type : i.config.chart.selection.type, c = i.config.chart.toolbar.autoSelected;
    if (o.shiftKey ? (this.shiftWasPressed = !0, a.enableZoomPanFromToolbar(c === "pan" ? "zoom" : "pan")) : this.shiftWasPressed && (a.enableZoomPanFromToolbar(c), this.shiftWasPressed = !1), o.target) {
      var d, u = o.target.classList;
      if (o.target.parentNode && o.target.parentNode !== null && (d = o.target.parentNode.classList), !(u.contains("apexcharts-legend-marker") || u.contains("apexcharts-legend-text") || d && d.contains("apexcharts-toolbar"))) {
        if (this.clientX = o.type === "touchmove" || o.type === "touchstart" ? o.touches[0].clientX : o.type === "touchend" ? o.changedTouches[0].clientX : o.clientX, this.clientY = o.type === "touchmove" || o.type === "touchstart" ? o.touches[0].clientY : o.type === "touchend" ? o.changedTouches[0].clientY : o.clientY, o.type === "mousedown" && o.which === 1 || o.type === "touchstart") {
          var p = this.gridRect.getBoundingClientRect();
          this.startX = this.clientX - p.left - i.globals.barPadForNumericAxis, this.startY = this.clientY - p.top, this.dragged = !1, this.w.globals.mousedown = !0;
        }
        (o.type === "mousemove" && o.which === 1 || o.type === "touchmove") && (this.dragged = !0, i.globals.panEnabled ? (i.globals.selection = null, this.w.globals.mousedown && this.panDragging({ context: this, zoomtype: s, xyRatios: n })) : (this.w.globals.mousedown && i.globals.zoomEnabled || this.w.globals.mousedown && i.globals.selectionEnabled) && (this.selection = this.selectionDrawing({ context: this, zoomtype: s }))), o.type !== "mouseup" && o.type !== "touchend" && o.type !== "mouseleave" || this.handleMouseUp({ zoomtype: s }), this.makeSelectionRectDraggable();
      }
    }
  } }, { key: "handleMouseUp", value: function(n) {
    var o, i = n.zoomtype, a = n.isResized, s = this.w, c = (o = this.gridRect) === null || o === void 0 ? void 0 : o.getBoundingClientRect();
    c && (this.w.globals.mousedown || a) && (this.endX = this.clientX - c.left - s.globals.barPadForNumericAxis, this.endY = this.clientY - c.top, this.dragX = Math.abs(this.endX - this.startX), this.dragY = Math.abs(this.endY - this.startY), (s.globals.zoomEnabled || s.globals.selectionEnabled) && this.selectionDrawn({ context: this, zoomtype: i })), s.globals.zoomEnabled && this.hideSelectionRect(this.selectionRect), this.dragged = !1, this.w.globals.mousedown = !1;
  } }, { key: "mouseWheelEvent", value: function(n) {
    var o = this, i = this.w;
    n.preventDefault();
    var a = Date.now();
    a - i.globals.lastWheelExecution > this.wheelDelay && (this.executeMouseWheelZoom(n), i.globals.lastWheelExecution = a), this.debounceTimer && clearTimeout(this.debounceTimer), this.debounceTimer = setTimeout((function() {
      a - i.globals.lastWheelExecution > o.wheelDelay && (o.executeMouseWheelZoom(n), i.globals.lastWheelExecution = a);
    }), this.debounceDelay);
  } }, { key: "executeMouseWheelZoom", value: function(n) {
    var o, i = this.w;
    this.minX = i.globals.isRangeBar ? i.globals.minY : i.globals.minX, this.maxX = i.globals.isRangeBar ? i.globals.maxY : i.globals.maxX;
    var a = (o = this.gridRect) === null || o === void 0 ? void 0 : o.getBoundingClientRect();
    if (a) {
      var s, c, d, u = (n.clientX - a.left) / a.width, p = this.minX, h = this.maxX, f = h - p;
      if (n.deltaY < 0) {
        var m = p + u * f;
        c = m - (s = 0.5 * f) / 2, d = m + s / 2;
      } else c = p - (s = 1.5 * f) / 2, d = h + s / 2;
      if (!i.globals.isRangeBar) {
        c = Math.max(c, i.globals.initialMinX), d = Math.min(d, i.globals.initialMaxX);
        var g = 0.01 * (i.globals.initialMaxX - i.globals.initialMinX);
        if (d - c < g) {
          var b = (c + d) / 2;
          c = b - g / 2, d = b + g / 2;
        }
      }
      var x = this._getNewMinXMaxX(c, d);
      isNaN(x.minX) || isNaN(x.maxX) || this.zoomUpdateOptions(x.minX, x.maxX);
    }
  } }, { key: "makeSelectionRectDraggable", value: function() {
    var n = this, o = this.w;
    if (this.selectionRect) {
      var i = this.selectionRect.node.getBoundingClientRect();
      i.width > 0 && i.height > 0 && (this.selectionRect.select(!1).resize(!1), this.selectionRect.select({ createRot: function() {
      }, updateRot: function() {
      }, createHandle: function(a, s, c, d, u) {
        return u === "l" || u === "r" ? a.circle(8).css({ "stroke-width": 1, stroke: "#333", fill: "#fff" }) : a.circle(0);
      }, updateHandle: function(a, s) {
        return a.center(s[0], s[1]);
      } }).resize().on("resize", (function() {
        var a = o.globals.zoomEnabled ? o.config.chart.zoom.type : o.config.chart.selection.type;
        n.handleMouseUp({ zoomtype: a, isResized: !0 });
      })));
    }
  } }, { key: "preselectedSelection", value: function() {
    var n = this.w, o = this.xyRatios;
    if (!n.globals.zoomEnabled) {
      if (n.globals.selection !== void 0 && n.globals.selection !== null) this.drawSelectionRect(ie(ie({}, n.globals.selection), {}, { translateX: n.globals.translateX, translateY: n.globals.translateY }));
      else if (n.config.chart.selection.xaxis.min !== void 0 && n.config.chart.selection.xaxis.max !== void 0) {
        var i = (n.config.chart.selection.xaxis.min - n.globals.minX) / o.xRatio, a = n.globals.gridWidth - (n.globals.maxX - n.config.chart.selection.xaxis.max) / o.xRatio - i;
        n.globals.isRangeBar && (i = (n.config.chart.selection.xaxis.min - n.globals.yAxisScale[0].niceMin) / o.invertedYRatio, a = (n.config.chart.selection.xaxis.max - n.config.chart.selection.xaxis.min) / o.invertedYRatio);
        var s = { x: i, y: 0, width: a, height: n.globals.gridHeight, translateX: n.globals.translateX, translateY: n.globals.translateY, selectionEnabled: !0 };
        this.drawSelectionRect(s), this.makeSelectionRectDraggable(), typeof n.config.chart.events.selection == "function" && n.config.chart.events.selection(this.ctx, { xaxis: { min: n.config.chart.selection.xaxis.min, max: n.config.chart.selection.xaxis.max }, yaxis: {} });
      }
    }
  } }, { key: "drawSelectionRect", value: function(n) {
    var o = n.x, i = n.y, a = n.width, s = n.height, c = n.translateX, d = c === void 0 ? 0 : c, u = n.translateY, p = u === void 0 ? 0 : u, h = this.w, f = this.zoomRect, m = this.selectionRect;
    if (this.dragged || h.globals.selection !== null) {
      var g = { transform: "translate(" + d + ", " + p + ")" };
      h.globals.zoomEnabled && this.dragged && (a < 0 && (a = 1), f.attr({ x: o, y: i, width: a, height: s, fill: h.config.chart.zoom.zoomedArea.fill.color, "fill-opacity": h.config.chart.zoom.zoomedArea.fill.opacity, stroke: h.config.chart.zoom.zoomedArea.stroke.color, "stroke-width": h.config.chart.zoom.zoomedArea.stroke.width, "stroke-opacity": h.config.chart.zoom.zoomedArea.stroke.opacity }), ee.setAttrs(f.node, g)), h.globals.selectionEnabled && (m.attr({ x: o, y: i, width: a > 0 ? a : 0, height: s > 0 ? s : 0, fill: h.config.chart.selection.fill.color, "fill-opacity": h.config.chart.selection.fill.opacity, stroke: h.config.chart.selection.stroke.color, "stroke-width": h.config.chart.selection.stroke.width, "stroke-dasharray": h.config.chart.selection.stroke.dashArray, "stroke-opacity": h.config.chart.selection.stroke.opacity }), ee.setAttrs(m.node, g));
    }
  } }, { key: "hideSelectionRect", value: function(n) {
    n && n.attr({ x: 0, y: 0, width: 0, height: 0 });
  } }, { key: "selectionDrawing", value: function(n) {
    var o = n.context, i = n.zoomtype, a = this.w, s = o, c = this.gridRect.getBoundingClientRect(), d = s.startX - 1, u = s.startY, p = !1, h = !1, f = s.clientX - c.left - a.globals.barPadForNumericAxis, m = s.clientY - c.top, g = f - d, b = m - u, x = { translateX: a.globals.translateX, translateY: a.globals.translateY };
    return Math.abs(g + d) > a.globals.gridWidth ? g = a.globals.gridWidth - d : f < 0 && (g = d), d > f && (p = !0, g = Math.abs(g)), u > m && (h = !0, b = Math.abs(b)), x = ie(ie({}, x = i === "x" ? { x: p ? d - g : d, y: 0, width: g, height: a.globals.gridHeight } : i === "y" ? { x: 0, y: h ? u - b : u, width: a.globals.gridWidth, height: b } : { x: p ? d - g : d, y: h ? u - b : u, width: g, height: b }), {}, { translateX: a.globals.translateX, translateY: a.globals.translateY }), s.drawSelectionRect(x), s.selectionDragging("resizing"), x;
  } }, { key: "selectionDragging", value: function(n, o) {
    var i = this, a = this.w;
    if (o) {
      o.preventDefault();
      var s = o.detail, c = s.handler, d = s.box, u = d.x, p = d.y;
      u < this.constraints.x && (u = this.constraints.x), p < this.constraints.y && (p = this.constraints.y), d.x2 > this.constraints.x2 && (u = this.constraints.x2 - d.w), d.y2 > this.constraints.y2 && (p = this.constraints.y2 - d.h), c.move(u, p);
      var h = this.xyRatios, f = this.selectionRect, m = 0;
      n === "resizing" && (m = 30);
      var g = function(x) {
        return parseFloat(f.node.getAttribute(x));
      }, b = { x: g("x"), y: g("y"), width: g("width"), height: g("height") };
      a.globals.selection = b, typeof a.config.chart.events.selection == "function" && a.globals.selectionEnabled && (clearTimeout(this.w.globals.selectionResizeTimer), this.w.globals.selectionResizeTimer = window.setTimeout((function() {
        var x, v, y, C, k = i.gridRect.getBoundingClientRect(), T = f.node.getBoundingClientRect();
        a.globals.isRangeBar ? (x = a.globals.yAxisScale[0].niceMin + (T.left - k.left) * h.invertedYRatio, v = a.globals.yAxisScale[0].niceMin + (T.right - k.left) * h.invertedYRatio, y = 0, C = 1) : (x = a.globals.xAxisScale.niceMin + (T.left - k.left) * h.xRatio, v = a.globals.xAxisScale.niceMin + (T.right - k.left) * h.xRatio, y = a.globals.yAxisScale[0].niceMin + (k.bottom - T.bottom) * h.yRatio[0], C = a.globals.yAxisScale[0].niceMax - (T.top - k.top) * h.yRatio[0]);
        var S = { xaxis: { min: x, max: v }, yaxis: { min: y, max: C } };
        a.config.chart.events.selection(i.ctx, S), a.config.chart.brush.enabled && a.config.chart.events.brushScrolled !== void 0 && a.config.chart.events.brushScrolled(i.ctx, S);
      }), m));
    }
  } }, { key: "selectionDrawn", value: function(n) {
    var o, i, a = n.context, s = n.zoomtype, c = this.w, d = a, u = this.xyRatios, p = this.ctx.toolbar, h = c.globals.zoomEnabled ? d.zoomRect.node.getBoundingClientRect() : d.selectionRect.node.getBoundingClientRect(), f = d.gridRect.getBoundingClientRect(), m = h.left - f.left - c.globals.barPadForNumericAxis, g = h.right - f.left - c.globals.barPadForNumericAxis, b = h.top - f.top, x = h.bottom - f.top;
    c.globals.isRangeBar ? (o = c.globals.yAxisScale[0].niceMin + m * u.invertedYRatio, i = c.globals.yAxisScale[0].niceMin + g * u.invertedYRatio) : (o = c.globals.xAxisScale.niceMin + m * u.xRatio, i = c.globals.xAxisScale.niceMin + g * u.xRatio);
    var v = [], y = [];
    if (c.config.yaxis.forEach((function(M, I) {
      var E = c.globals.seriesYAxisMap[I][0], N = c.globals.yAxisScale[I].niceMax - u.yRatio[E] * b, L = c.globals.yAxisScale[I].niceMax - u.yRatio[E] * x;
      v.push(N), y.push(L);
    })), d.dragged && (d.dragX > 10 || d.dragY > 10) && o !== i) {
      if (c.globals.zoomEnabled) {
        var C = $.clone(c.globals.initialConfig.yaxis), k = $.clone(c.globals.initialConfig.xaxis);
        if (c.globals.zoomed = !0, c.config.xaxis.convertedCatToNumeric && (o = Math.floor(o), i = Math.floor(i), o < 1 && (o = 1, i = c.globals.dataPoints), i - o < 2 && (i = o + 1)), s !== "xy" && s !== "x" || (k = { min: o, max: i }), s !== "xy" && s !== "y" || C.forEach((function(M, I) {
          C[I].min = y[I], C[I].max = v[I];
        })), p) {
          var T = p.getBeforeZoomRange(k, C);
          T && (k = T.xaxis ? T.xaxis : k, C = T.yaxis ? T.yaxis : C);
        }
        var S = { xaxis: k };
        c.config.chart.group || (S.yaxis = C), d.ctx.updateHelpers._updateOptions(S, !1, d.w.config.chart.animations.dynamicAnimation.enabled), typeof c.config.chart.events.zoomed == "function" && p.zoomCallback(k, C);
      } else if (c.globals.selectionEnabled) {
        var O, P = null;
        O = { min: o, max: i }, s !== "xy" && s !== "y" || (P = $.clone(c.config.yaxis)).forEach((function(M, I) {
          P[I].min = y[I], P[I].max = v[I];
        })), c.globals.selection = d.selection, typeof c.config.chart.events.selection == "function" && c.config.chart.events.selection(d.ctx, { xaxis: O, yaxis: P });
      }
    }
  } }, { key: "panDragging", value: function(n) {
    var o = n.context, i = this.w, a = o;
    if (i.globals.lastClientPosition.x !== void 0) {
      var s = i.globals.lastClientPosition.x - a.clientX, c = i.globals.lastClientPosition.y - a.clientY;
      Math.abs(s) > Math.abs(c) && s > 0 ? this.moveDirection = "left" : Math.abs(s) > Math.abs(c) && s < 0 ? this.moveDirection = "right" : Math.abs(c) > Math.abs(s) && c > 0 ? this.moveDirection = "up" : Math.abs(c) > Math.abs(s) && c < 0 && (this.moveDirection = "down");
    }
    i.globals.lastClientPosition = { x: a.clientX, y: a.clientY };
    var d = i.globals.isRangeBar ? i.globals.minY : i.globals.minX, u = i.globals.isRangeBar ? i.globals.maxY : i.globals.maxX;
    a.panScrolled(d, u);
  } }, { key: "panScrolled", value: function(n, o) {
    var i = this.w, a = this.xyRatios, s = $.clone(i.globals.initialConfig.yaxis), c = a.xRatio, d = i.globals.minX, u = i.globals.maxX;
    i.globals.isRangeBar && (c = a.invertedYRatio, d = i.globals.minY, u = i.globals.maxY), this.moveDirection === "left" ? (n = d + i.globals.gridWidth / 15 * c, o = u + i.globals.gridWidth / 15 * c) : this.moveDirection === "right" && (n = d - i.globals.gridWidth / 15 * c, o = u - i.globals.gridWidth / 15 * c), i.globals.isRangeBar || (n < i.globals.initialMinX || o > i.globals.initialMaxX) && (n = d, o = u);
    var p = { xaxis: { min: n, max: o } };
    i.config.chart.group || (p.yaxis = s), this.updateScrolledChart(p, n, o);
  } }, { key: "updateScrolledChart", value: function(n, o, i) {
    var a = this.w;
    if (this.ctx.updateHelpers._updateOptions(n, !1, !1), typeof a.config.chart.events.scrolled == "function") {
      var s = { xaxis: { min: o, max: i } };
      a.config.chart.events.scrolled(this.ctx, s), this.ctx.events.fireEvent("scrolled", s);
    }
  } }]), t;
})(), Gm = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx;
  }
  return ve(r, [{ key: "getNearestValues", value: function(e) {
    var t = e.hoverArea, n = e.elGrid, o = e.clientX, i = e.clientY, a = this.w, s = n.getBoundingClientRect(), c = s.width, d = s.height, u = c / (a.globals.dataPoints - 1), p = d / a.globals.dataPoints, h = this.hasBars();
    !a.globals.comboCharts && !h || a.config.xaxis.convertedCatToNumeric || (u = c / a.globals.dataPoints);
    var f = o - s.left - a.globals.barPadForNumericAxis, m = i - s.top;
    f < 0 || m < 0 || f > c || m > d ? (t.classList.remove("hovering-zoom"), t.classList.remove("hovering-pan")) : a.globals.zoomEnabled ? (t.classList.remove("hovering-pan"), t.classList.add("hovering-zoom")) : a.globals.panEnabled && (t.classList.remove("hovering-zoom"), t.classList.add("hovering-pan"));
    var g = Math.round(f / u), b = Math.floor(m / p);
    h && !a.config.xaxis.convertedCatToNumeric && (g = Math.ceil(f / u), g -= 1);
    var x = null, v = null, y = a.globals.seriesXvalues.map((function(O) {
      return O.filter((function(P) {
        return $.isNumber(P);
      }));
    })), C = a.globals.seriesYvalues.map((function(O) {
      return O.filter((function(P) {
        return $.isNumber(P);
      }));
    }));
    if (a.globals.isXNumeric) {
      var k = this.ttCtx.getElGrid().getBoundingClientRect(), T = f * (k.width / c), S = m * (k.height / d);
      x = (v = this.closestInMultiArray(T, S, y, C)).index, g = v.j, x !== null && a.globals.hasNullValues && (y = a.globals.seriesXvalues[x], g = (v = this.closestInArray(T, y)).j);
    }
    return a.globals.capturedSeriesIndex = x === null ? -1 : x, (!g || g < 1) && (g = 0), a.globals.isBarHorizontal ? a.globals.capturedDataPointIndex = b : a.globals.capturedDataPointIndex = g, { capturedSeries: x, j: a.globals.isBarHorizontal ? b : g, hoverX: f, hoverY: m };
  } }, { key: "getFirstActiveXArray", value: function(e) {
    for (var t = this.w, n = 0, o = e.map((function(a, s) {
      return a.length > 0 ? s : -1;
    })), i = 0; i < o.length; i++) if (o[i] !== -1 && t.globals.collapsedSeriesIndices.indexOf(i) === -1 && t.globals.ancillaryCollapsedSeriesIndices.indexOf(i) === -1) {
      n = o[i];
      break;
    }
    return n;
  } }, { key: "closestInMultiArray", value: function(e, t, n, o) {
    for (var i, a = this.w, s = 1 / 0, c = null, d = null, u = 0; u < n.length; u++) if (i = u, a.globals.collapsedSeriesIndices.indexOf(i) === -1 && a.globals.ancillaryCollapsedSeriesIndices.indexOf(i) === -1) for (var p = n[u], h = o[u], f = Math.min(p.length, h.length), m = 0; m < f; m++) {
      var g = e - p[m], b = Math.sqrt(g * g);
      if (!a.globals.allSeriesHasEqualX) {
        var x = t - h[m];
        b = Math.sqrt(g * g + x * x);
      }
      b < s && (s = b, c = u, d = m);
    }
    return { index: c, j: d };
  } }, { key: "closestInArray", value: function(e, t) {
    for (var n = t[0], o = null, i = Math.abs(e - n), a = 0; a < t.length; a++) {
      var s = Math.abs(e - t[a]);
      s < i && (i = s, o = a);
    }
    return { j: o };
  } }, { key: "isXoverlap", value: function(e) {
    var t = [], n = this.w.globals.seriesX.filter((function(i) {
      return i[0] !== void 0;
    }));
    if (n.length > 0) for (var o = 0; o < n.length - 1; o++) n[o][e] !== void 0 && n[o + 1][e] !== void 0 && n[o][e] !== n[o + 1][e] && t.push("unEqual");
    return t.length === 0;
  } }, { key: "isInitialSeriesSameLen", value: function() {
    for (var e = !0, t = this.w.globals.initialSeries, n = 0; n < t.length - 1; n++) if (t[n].data.length !== t[n + 1].data.length) {
      e = !1;
      break;
    }
    return e;
  } }, { key: "getBarsHeight", value: function(e) {
    return Mt(e).reduce((function(t, n) {
      return t + n.getBBox().height;
    }), 0);
  } }, { key: "getElMarkers", value: function(e) {
    return typeof e == "number" ? this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-series-markers-wrap > *")) : this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap > *");
  } }, { key: "getAllMarkers", value: function() {
    var e = this, t = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], n = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");
    n = Mt(n), t && (n = n.filter((function(i) {
      var a = Number(i.getAttribute("data:realIndex"));
      return e.w.globals.collapsedSeriesIndices.indexOf(a) === -1;
    }))), n.sort((function(i, a) {
      var s = Number(i.getAttribute("data:realIndex")), c = Number(a.getAttribute("data:realIndex"));
      return c < s ? 1 : c > s ? -1 : 0;
    }));
    var o = [];
    return n.forEach((function(i) {
      o.push(i.querySelector(".apexcharts-marker"));
    })), o;
  } }, { key: "hasMarkers", value: function(e) {
    return this.getElMarkers(e).length > 0;
  } }, { key: "getPathFromPoint", value: function(e, t) {
    var n = Number(e.getAttribute("cx")), o = Number(e.getAttribute("cy")), i = e.getAttribute("shape");
    return new ee(this.ctx).getMarkerPath(n, o, i, t);
  } }, { key: "getElBars", value: function() {
    return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series");
  } }, { key: "hasBars", value: function() {
    return this.getElBars().length > 0;
  } }, { key: "getHoverMarkerSize", value: function(e) {
    var t = this.w, n = t.config.markers.hover.size;
    return n === void 0 && (n = t.globals.markers.size[e] + t.config.markers.hover.sizeOffset), n;
  } }, { key: "toggleAllTooltipSeriesGroups", value: function(e) {
    var t = this.w, n = this.ttCtx;
    n.allTooltipSeriesGroups.length === 0 && (n.allTooltipSeriesGroups = t.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));
    for (var o = n.allTooltipSeriesGroups, i = 0; i < o.length; i++) e === "enable" ? (o[i].classList.add("apexcharts-active"), o[i].style.display = t.config.tooltip.items.display) : (o[i].classList.remove("apexcharts-active"), o[i].style.display = "none");
  } }]), r;
})(), VL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.ctx = e.ctx, this.ttCtx = e, this.tooltipUtil = new Gm(e);
  }
  return ve(r, [{ key: "drawSeriesTexts", value: function(e) {
    var t = e.shared, n = t === void 0 || t, o = e.ttItems, i = e.i, a = i === void 0 ? 0 : i, s = e.j, c = s === void 0 ? null : s, d = e.y1, u = e.y2, p = e.e, h = this.w;
    h.config.tooltip.custom !== void 0 ? this.handleCustomTooltip({ i: a, j: c, y1: d, y2: u, w: h }) : this.toggleActiveInactiveSeries(n, a);
    var f = this.getValuesToPrint({ i: a, j: c });
    this.printLabels({ i: a, j: c, values: f, ttItems: o, shared: n, e: p });
    var m = this.ttCtx.getElTooltip();
    this.ttCtx.tooltipRect.ttWidth = m.getBoundingClientRect().width, this.ttCtx.tooltipRect.ttHeight = m.getBoundingClientRect().height;
  } }, { key: "printLabels", value: function(e) {
    var t, n = this, o = e.i, i = e.j, a = e.values, s = e.ttItems, c = e.shared, d = e.e, u = this.w, p = [], h = function(k) {
      return u.globals.seriesGoals[k] && u.globals.seriesGoals[k][i] && Array.isArray(u.globals.seriesGoals[k][i]);
    }, f = a.xVal, m = a.zVal, g = a.xAxisTTVal, b = "", x = u.globals.colors[o];
    i !== null && u.config.plotOptions.bar.distributed && (x = u.globals.colors[i]);
    for (var v = function(k, T) {
      var S = n.getFormatters(o);
      b = n.getSeriesName({ fn: S.yLbTitleFormatter, index: o, seriesIndex: o, j: i }), u.config.chart.type === "treemap" && (b = S.yLbTitleFormatter(String(u.config.series[o].data[i].x), { series: u.globals.series, seriesIndex: o, dataPointIndex: i, w: u }));
      var O = u.config.tooltip.inverseOrder ? T : k;
      if (u.globals.axisCharts) {
        var P = function(E) {
          var N, L, z, F;
          return u.globals.isRangeData ? S.yLbFormatter((N = u.globals.seriesRangeStart) === null || N === void 0 || (L = N[E]) === null || L === void 0 ? void 0 : L[i], { series: u.globals.seriesRangeStart, seriesIndex: E, dataPointIndex: i, w: u }) + " - " + S.yLbFormatter((z = u.globals.seriesRangeEnd) === null || z === void 0 || (F = z[E]) === null || F === void 0 ? void 0 : F[i], { series: u.globals.seriesRangeEnd, seriesIndex: E, dataPointIndex: i, w: u }) : S.yLbFormatter(u.globals.series[E][i], { series: u.globals.series, seriesIndex: E, dataPointIndex: i, w: u });
        };
        if (c) S = n.getFormatters(O), b = n.getSeriesName({ fn: S.yLbTitleFormatter, index: O, seriesIndex: o, j: i }), x = u.globals.colors[O], t = P(O), h(O) && (p = u.globals.seriesGoals[O][i].map((function(E) {
          return { attrs: E, val: S.yLbFormatter(E.value, { seriesIndex: O, dataPointIndex: i, w: u }) };
        })));
        else {
          var M, I = d == null || (M = d.target) === null || M === void 0 ? void 0 : M.getAttribute("fill");
          I && (I.indexOf("url") !== -1 ? I.indexOf("Pattern") !== -1 && (x = u.globals.dom.baseEl.querySelector(I.substr(4).slice(0, -1)).childNodes[0].getAttribute("stroke")) : x = I), t = P(o), h(o) && Array.isArray(u.globals.seriesGoals[o][i]) && (p = u.globals.seriesGoals[o][i].map((function(E) {
            return { attrs: E, val: S.yLbFormatter(E.value, { seriesIndex: o, dataPointIndex: i, w: u }) };
          })));
        }
      }
      i === null && (t = S.yLbFormatter(u.globals.series[o], ie(ie({}, u), {}, { seriesIndex: o, dataPointIndex: o }))), n.DOMHandling({ i: o, t: O, j: i, ttItems: s, values: { val: t, goalVals: p, xVal: f, xAxisTTVal: g, zVal: m }, seriesName: b, shared: c, pColor: x });
    }, y = 0, C = u.globals.series.length - 1; y < u.globals.series.length; y++, C--) v(y, C);
  } }, { key: "getFormatters", value: function(e) {
    var t, n = this.w, o = n.globals.yLabelFormatters[e];
    return n.globals.ttVal !== void 0 ? Array.isArray(n.globals.ttVal) ? (o = n.globals.ttVal[e] && n.globals.ttVal[e].formatter, t = n.globals.ttVal[e] && n.globals.ttVal[e].title && n.globals.ttVal[e].title.formatter) : (o = n.globals.ttVal.formatter, typeof n.globals.ttVal.title.formatter == "function" && (t = n.globals.ttVal.title.formatter)) : t = n.config.tooltip.y.title.formatter, typeof o != "function" && (o = n.globals.yLabelFormatters[0] ? n.globals.yLabelFormatters[0] : function(i) {
      return i;
    }), typeof t != "function" && (t = function(i) {
      return i ? i + ": " : "";
    }), { yLbFormatter: o, yLbTitleFormatter: t };
  } }, { key: "getSeriesName", value: function(e) {
    var t = e.fn, n = e.index, o = e.seriesIndex, i = e.j, a = this.w;
    return t(String(a.globals.seriesNames[n]), { series: a.globals.series, seriesIndex: o, dataPointIndex: i, w: a });
  } }, { key: "DOMHandling", value: function(e) {
    e.i;
    var t = e.t, n = e.j, o = e.ttItems, i = e.values, a = e.seriesName, s = e.shared, c = e.pColor, d = this.w, u = this.ttCtx, p = i.val, h = i.goalVals, f = i.xVal, m = i.xAxisTTVal, g = i.zVal, b = null;
    b = o[t].children, d.config.tooltip.fillSeriesColor && (o[t].style.backgroundColor = c, b[0].style.display = "none"), u.showTooltipTitle && (u.tooltipTitle === null && (u.tooltipTitle = d.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")), u.tooltipTitle.innerHTML = f), u.isXAxisTooltipEnabled && (u.xaxisTooltipText.innerHTML = m !== "" ? m : f);
    var x = o[t].querySelector(".apexcharts-tooltip-text-y-label");
    x && (x.innerHTML = a || "");
    var v = o[t].querySelector(".apexcharts-tooltip-text-y-value");
    v && (v.innerHTML = p !== void 0 ? p : ""), b[0] && b[0].classList.contains("apexcharts-tooltip-marker") && (d.config.tooltip.marker.fillColors && Array.isArray(d.config.tooltip.marker.fillColors) && (c = d.config.tooltip.marker.fillColors[t]), d.config.tooltip.fillSeriesColor ? b[0].style.backgroundColor = c : b[0].style.color = c), d.config.tooltip.marker.show || (b[0].style.display = "none");
    var y = o[t].querySelector(".apexcharts-tooltip-text-goals-label"), C = o[t].querySelector(".apexcharts-tooltip-text-goals-value");
    if (h.length && d.globals.seriesGoals[t]) {
      var k = function() {
        var O = "<div>", P = "<div>";
        h.forEach((function(M, I) {
          O += ' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(M.attrs.strokeColor, '; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(M.attrs.name, "</div>"), P += "<div>".concat(M.val, "</div>");
        })), y.innerHTML = O + "</div>", C.innerHTML = P + "</div>";
      };
      s ? d.globals.seriesGoals[t][n] && Array.isArray(d.globals.seriesGoals[t][n]) ? k() : (y.innerHTML = "", C.innerHTML = "") : k();
    } else y.innerHTML = "", C.innerHTML = "";
    if (g !== null && (o[t].querySelector(".apexcharts-tooltip-text-z-label").innerHTML = d.config.tooltip.z.title, o[t].querySelector(".apexcharts-tooltip-text-z-value").innerHTML = g !== void 0 ? g : ""), s && b[0]) {
      if (d.config.tooltip.hideEmptySeries) {
        var T = o[t].querySelector(".apexcharts-tooltip-marker"), S = o[t].querySelector(".apexcharts-tooltip-text");
        parseFloat(p) == 0 ? (T.style.display = "none", S.style.display = "none") : (T.style.display = "block", S.style.display = "block");
      }
      p == null || d.globals.ancillaryCollapsedSeriesIndices.indexOf(t) > -1 || d.globals.collapsedSeriesIndices.indexOf(t) > -1 || Array.isArray(u.tConfig.enabledOnSeries) && u.tConfig.enabledOnSeries.indexOf(t) === -1 ? b[0].parentNode.style.display = "none" : b[0].parentNode.style.display = d.config.tooltip.items.display;
    } else Array.isArray(u.tConfig.enabledOnSeries) && u.tConfig.enabledOnSeries.indexOf(t) === -1 && (b[0].parentNode.style.display = "none");
  } }, { key: "toggleActiveInactiveSeries", value: function(e, t) {
    var n = this.w;
    if (e) this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");
    else {
      this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");
      var o = n.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group-".concat(t));
      o && (o.classList.add("apexcharts-active"), o.style.display = n.config.tooltip.items.display);
    }
  } }, { key: "getValuesToPrint", value: function(e) {
    var t = e.i, n = e.j, o = this.w, i = this.ctx.series.filteredSeriesX(), a = "", s = "", c = null, d = null, u = { series: o.globals.series, seriesIndex: t, dataPointIndex: n, w: o }, p = o.globals.ttZFormatter;
    n === null ? d = o.globals.series[t] : o.globals.isXNumeric && o.config.chart.type !== "treemap" ? (a = i[t][n], i[t].length === 0 && (a = i[this.tooltipUtil.getFirstActiveXArray(i)][n])) : a = new zd(this.ctx).isFormatXY() ? o.config.series[t].data[n] !== void 0 ? o.config.series[t].data[n].x : "" : o.globals.labels[n] !== void 0 ? o.globals.labels[n] : "";
    var h = a;
    return o.globals.isXNumeric && o.config.xaxis.type === "datetime" ? a = new la(this.ctx).xLabelFormat(o.globals.ttKeyFormatter, h, h, { i: void 0, dateFormatter: new Dt(this.ctx).formatDate, w: this.w }) : a = o.globals.isBarHorizontal ? o.globals.yLabelFormatters[0](h, u) : o.globals.xLabelFormatter(h, u), o.config.tooltip.x.formatter !== void 0 && (a = o.globals.ttKeyFormatter(h, u)), o.globals.seriesZ.length > 0 && o.globals.seriesZ[t].length > 0 && (c = p(o.globals.seriesZ[t][n], o)), s = typeof o.config.xaxis.tooltip.formatter == "function" ? o.globals.xaxisTooltipFormatter(h, u) : a, { val: Array.isArray(d) ? d.join(" ") : d, xVal: Array.isArray(a) ? a.join(" ") : a, xAxisTTVal: Array.isArray(s) ? s.join(" ") : s, zVal: c };
  } }, { key: "handleCustomTooltip", value: function(e) {
    var t = e.i, n = e.j, o = e.y1, i = e.y2, a = e.w, s = this.ttCtx.getElTooltip(), c = a.config.tooltip.custom;
    Array.isArray(c) && c[t] && (c = c[t]);
    var d = c({ ctx: this.ctx, series: a.globals.series, seriesIndex: t, dataPointIndex: n, y1: o, y2: i, w: a });
    typeof d == "string" || typeof d == "number" ? s.innerHTML = d : (d instanceof Element || typeof d.nodeName == "string") && (s.innerHTML = "", s.appendChild(d.cloneNode(!0)));
  } }]), r;
})(), qm = (function() {
  function r(e) {
    xe(this, r), this.ttCtx = e, this.ctx = e.ctx, this.w = e.w;
  }
  return ve(r, [{ key: "moveXCrosshairs", value: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = this.ttCtx, o = this.w, i = n.getElXCrosshairs(), a = e - n.xcrosshairsWidth / 2, s = o.globals.labels.slice().length;
    if (t !== null && (a = o.globals.gridWidth / s * t), i === null || o.globals.isBarHorizontal || (i.setAttribute("x", a), i.setAttribute("x1", a), i.setAttribute("x2", a), i.setAttribute("y2", o.globals.gridHeight), i.classList.add("apexcharts-active")), a < 0 && (a = 0), a > o.globals.gridWidth && (a = o.globals.gridWidth), n.isXAxisTooltipEnabled) {
      var c = a;
      o.config.xaxis.crosshairs.width !== "tickWidth" && o.config.xaxis.crosshairs.width !== "barWidth" || (c = a + n.xcrosshairsWidth / 2), this.moveXAxisTooltip(c);
    }
  } }, { key: "moveYCrosshairs", value: function(e) {
    var t = this.ttCtx;
    t.ycrosshairs !== null && ee.setAttrs(t.ycrosshairs, { y1: e, y2: e }), t.ycrosshairsHidden !== null && ee.setAttrs(t.ycrosshairsHidden, { y1: e, y2: e });
  } }, { key: "moveXAxisTooltip", value: function(e) {
    var t = this.w, n = this.ttCtx;
    if (n.xaxisTooltip !== null && n.xcrosshairsWidth !== 0) {
      n.xaxisTooltip.classList.add("apexcharts-active");
      var o = n.xaxisOffY + t.config.xaxis.tooltip.offsetY + t.globals.translateY + 1 + t.config.xaxis.offsetY;
      if (e -= n.xaxisTooltip.getBoundingClientRect().width / 2, !isNaN(e)) {
        e += t.globals.translateX;
        var i;
        i = new ee(this.ctx).getTextRects(n.xaxisTooltipText.innerHTML), n.xaxisTooltipText.style.minWidth = i.width + "px", n.xaxisTooltip.style.left = e + "px", n.xaxisTooltip.style.top = o + "px";
      }
    }
  } }, { key: "moveYAxisTooltip", value: function(e) {
    var t = this.w, n = this.ttCtx;
    n.yaxisTTEls === null && (n.yaxisTTEls = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
    var o = parseInt(n.ycrosshairsHidden.getAttribute("y1"), 10), i = t.globals.translateY + o, a = n.yaxisTTEls[e].getBoundingClientRect(), s = a.height, c = t.globals.translateYAxisX[e] - 2;
    t.config.yaxis[e].opposite && (c -= a.width), i -= s / 2, t.globals.ignoreYAxisIndexes.indexOf(e) === -1 && i > 0 && i < t.globals.gridHeight ? (n.yaxisTTEls[e].classList.add("apexcharts-active"), n.yaxisTTEls[e].style.top = i + "px", n.yaxisTTEls[e].style.left = c + t.config.yaxis[e].tooltip.offsetX + "px") : n.yaxisTTEls[e].classList.remove("apexcharts-active");
  } }, { key: "moveTooltip", value: function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, o = this.w, i = this.ttCtx, a = i.getElTooltip(), s = i.tooltipRect, c = n !== null ? parseFloat(n) : 1, d = parseFloat(e) + c + 5, u = parseFloat(t) + c / 2;
    if (d > o.globals.gridWidth / 2 && (d = d - s.ttWidth - c - 10), d > o.globals.gridWidth - s.ttWidth - 10 && (d = o.globals.gridWidth - s.ttWidth), d < -20 && (d = -20), o.config.tooltip.followCursor) {
      var p = i.getElGrid().getBoundingClientRect();
      (d = i.e.clientX - p.left) > o.globals.gridWidth / 2 && (d -= i.tooltipRect.ttWidth), (u = i.e.clientY + o.globals.translateY - p.top) > o.globals.gridHeight / 2 && (u -= i.tooltipRect.ttHeight);
    } else o.globals.isBarHorizontal || s.ttHeight / 2 + u > o.globals.gridHeight && (u = o.globals.gridHeight - s.ttHeight + o.globals.translateY);
    isNaN(d) || (d += o.globals.translateX, a.style.left = d + "px", a.style.top = u + "px");
  } }, { key: "moveMarkers", value: function(e, t) {
    var n = this.w, o = this.ttCtx;
    if (n.globals.markers.size[e] > 0) for (var i = n.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-marker")), a = 0; a < i.length; a++) parseInt(i[a].getAttribute("rel"), 10) === t && (o.marker.resetPointsSize(), o.marker.enlargeCurrentPoint(t, i[a]));
    else o.marker.resetPointsSize(), this.moveDynamicPointOnHover(t, e);
  } }, { key: "moveDynamicPointOnHover", value: function(e, t) {
    var n, o, i, a, s = this.w, c = this.ttCtx, d = new ee(this.ctx), u = s.globals.pointsArray, p = c.tooltipUtil.getHoverMarkerSize(t), h = s.config.series[t].type;
    if (!h || h !== "column" && h !== "candlestick" && h !== "boxPlot") {
      i = (n = u[t][e]) === null || n === void 0 ? void 0 : n[0], a = ((o = u[t][e]) === null || o === void 0 ? void 0 : o[1]) || 0;
      var f = s.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-series-markers path"));
      if (f && a < s.globals.gridHeight && a > 0) {
        var m = f.getAttribute("shape"), g = d.getMarkerPath(i, a, m, 1.5 * p);
        f.setAttribute("d", g);
      }
      this.moveXCrosshairs(i), c.fixedTooltip || this.moveTooltip(i, a, p);
    }
  } }, { key: "moveDynamicPointsOnHover", value: function(e) {
    var t, n = this.ttCtx, o = n.w, i = 0, a = 0, s = o.globals.pointsArray, c = new mr(this.ctx), d = new ee(this.ctx);
    t = c.getActiveConfigSeriesIndex("asc", ["line", "area", "scatter", "bubble"]);
    var u = n.tooltipUtil.getHoverMarkerSize(t);
    if (s[t] && (i = s[t][e][0], a = s[t][e][1]), !isNaN(i)) {
      var p = n.tooltipUtil.getAllMarkers();
      if (p.length) for (var h = 0; h < o.globals.series.length; h++) {
        var f = s[h];
        if (o.globals.comboCharts && f === void 0 && p.splice(h, 0, null), f && f.length) {
          var m = s[h][e][1], g = void 0;
          p[h].setAttribute("cx", i);
          var b = p[h].getAttribute("shape");
          if (o.config.chart.type === "rangeArea" && !o.globals.comboCharts) {
            var x = e + o.globals.series[h].length;
            g = s[h][x][1], m -= Math.abs(m - g) / 2;
          }
          if (m !== null && !isNaN(m) && m < o.globals.gridHeight + u && m + u > 0) {
            var v = d.getMarkerPath(i, m, b, u);
            p[h].setAttribute("d", v);
          } else p[h].setAttribute("d", "");
        }
      }
      this.moveXCrosshairs(i), n.fixedTooltip || this.moveTooltip(i, a || o.globals.gridHeight, u);
    }
  } }, { key: "moveStickyTooltipOverBars", value: function(e, t) {
    var n = this.w, o = this.ttCtx, i = n.globals.columnSeries ? n.globals.columnSeries.length : n.globals.series.length;
    n.config.chart.stacked && (i = n.globals.barGroups.length);
    var a = i >= 2 && i % 2 == 0 ? Math.floor(i / 2) : Math.floor(i / 2) + 1;
    n.globals.isBarHorizontal && (a = new mr(this.ctx).getActiveConfigSeriesIndex("desc") + 1);
    var s = n.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(a, "'] path[j='").concat(e, "'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(a, "'] path[j='").concat(e, "'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(a, "'] path[j='").concat(e, "'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(a, "'] path[j='").concat(e, "']"));
    s || typeof t != "number" || (s = n.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[data\\:realIndex='".concat(t, "'] path[j='").concat(e, `'],
        .apexcharts-candlestick-series .apexcharts-series[data\\:realIndex='`).concat(t, "'] path[j='").concat(e, `'],
        .apexcharts-boxPlot-series .apexcharts-series[data\\:realIndex='`).concat(t, "'] path[j='").concat(e, `'],
        .apexcharts-rangebar-series .apexcharts-series[data\\:realIndex='`).concat(t, "'] path[j='").concat(e, "']")));
    var c = s ? parseFloat(s.getAttribute("cx")) : 0, d = s ? parseFloat(s.getAttribute("cy")) : 0, u = s ? parseFloat(s.getAttribute("barWidth")) : 0, p = o.getElGrid().getBoundingClientRect(), h = s && (s.classList.contains("apexcharts-candlestick-area") || s.classList.contains("apexcharts-boxPlot-area"));
    n.globals.isXNumeric ? (s && !h && (c -= i % 2 != 0 ? u / 2 : 0), s && h && (c -= u / 2)) : n.globals.isBarHorizontal || (c = o.xAxisTicksPositions[e - 1] + o.dataPointsDividedWidth / 2, isNaN(c) && (c = o.xAxisTicksPositions[e] - o.dataPointsDividedWidth / 2)), n.globals.isBarHorizontal ? d -= o.tooltipRect.ttHeight : n.config.tooltip.followCursor ? d = o.e.clientY - p.top - o.tooltipRect.ttHeight / 2 : d + o.tooltipRect.ttHeight + 15 > n.globals.gridHeight && (d = n.globals.gridHeight), n.globals.isBarHorizontal || this.moveXCrosshairs(c), o.fixedTooltip || this.moveTooltip(c, d || n.globals.gridHeight);
  } }]), r;
})(), UL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx, this.tooltipPosition = new qm(e);
  }
  return ve(r, [{ key: "drawDynamicPoints", value: function() {
    var e = this.w, t = new ee(this.ctx), n = new Io(this.ctx), o = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
    o = Mt(o), e.config.chart.stacked && o.sort((function(p, h) {
      return parseFloat(p.getAttribute("data:realIndex")) - parseFloat(h.getAttribute("data:realIndex"));
    }));
    for (var i = 0; i < o.length; i++) {
      var a = o[i].querySelector(".apexcharts-series-markers-wrap");
      if (a !== null) {
        var s = void 0, c = "apexcharts-marker w".concat((Math.random() + 1).toString(36).substring(4));
        e.config.chart.type !== "line" && e.config.chart.type !== "area" || e.globals.comboCharts || e.config.tooltip.intersect || (c += " no-pointer-events");
        var d = n.getMarkerConfig({ cssClass: c, seriesIndex: Number(a.getAttribute("data:realIndex")) });
        (s = t.drawMarker(0, 0, d)).node.setAttribute("default-marker-size", 0);
        var u = document.createElementNS(e.globals.SVGNS, "g");
        u.classList.add("apexcharts-series-markers"), u.appendChild(s.node), a.appendChild(u);
      }
    }
  } }, { key: "enlargeCurrentPoint", value: function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, i = this.w;
    i.config.chart.type !== "bubble" && this.newPointSize(e, t);
    var a = t.getAttribute("cx"), s = t.getAttribute("cy");
    if (n !== null && o !== null && (a = n, s = o), this.tooltipPosition.moveXCrosshairs(a), !this.fixedTooltip) {
      if (i.config.chart.type === "radar") {
        var c = this.ttCtx.getElGrid().getBoundingClientRect();
        a = this.ttCtx.e.clientX - c.left;
      }
      this.tooltipPosition.moveTooltip(a, s, i.config.markers.hover.size);
    }
  } }, { key: "enlargePoints", value: function(e) {
    for (var t = this.w, n = this, o = this.ttCtx, i = e, a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), s = t.config.markers.hover.size, c = 0; c < a.length; c++) {
      var d = a[c].getAttribute("rel"), u = a[c].getAttribute("index");
      if (s === void 0 && (s = t.globals.markers.size[u] + t.config.markers.hover.sizeOffset), i === parseInt(d, 10)) {
        n.newPointSize(i, a[c]);
        var p = a[c].getAttribute("cx"), h = a[c].getAttribute("cy");
        n.tooltipPosition.moveXCrosshairs(p), o.fixedTooltip || n.tooltipPosition.moveTooltip(p, h, s);
      } else n.oldPointSize(a[c]);
    }
  } }, { key: "newPointSize", value: function(e, t) {
    var n = this.w, o = n.config.markers.hover.size, i = e === 0 ? t.parentNode.firstChild : t.parentNode.lastChild;
    if (i.getAttribute("default-marker-size") !== "0") {
      var a = parseInt(i.getAttribute("index"), 10);
      o === void 0 && (o = n.globals.markers.size[a] + n.config.markers.hover.sizeOffset), o < 0 && (o = 0);
      var s = this.ttCtx.tooltipUtil.getPathFromPoint(t, o);
      t.setAttribute("d", s);
    }
  } }, { key: "oldPointSize", value: function(e) {
    var t = parseFloat(e.getAttribute("default-marker-size")), n = this.ttCtx.tooltipUtil.getPathFromPoint(e, t);
    e.setAttribute("d", n);
  } }, { key: "resetPointsSize", value: function() {
    for (var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), t = 0; t < e.length; t++) {
      var n = parseFloat(e[t].getAttribute("default-marker-size"));
      if ($.isNumber(n) && n > 0) {
        var o = this.ttCtx.tooltipUtil.getPathFromPoint(e[t], n);
        e[t].setAttribute("d", o);
      } else e[t].setAttribute("d", "M0,0");
    }
  } }]), r;
})(), GL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w;
    var t = this.w;
    this.ttCtx = e, this.isVerticalGroupedRangeBar = !t.globals.isBarHorizontal && t.config.chart.type === "rangeBar" && t.config.plotOptions.bar.rangeBarGroupRows;
  }
  return ve(r, [{ key: "getAttr", value: function(e, t) {
    return parseFloat(e.target.getAttribute(t));
  } }, { key: "handleHeatTreeTooltip", value: function(e) {
    var t = e.e, n = e.opt, o = e.x, i = e.y, a = e.type, s = this.ttCtx, c = this.w;
    if (t.target.classList.contains("apexcharts-".concat(a, "-rect"))) {
      var d = this.getAttr(t, "i"), u = this.getAttr(t, "j"), p = this.getAttr(t, "cx"), h = this.getAttr(t, "cy"), f = this.getAttr(t, "width"), m = this.getAttr(t, "height");
      if (s.tooltipLabels.drawSeriesTexts({ ttItems: n.ttItems, i: d, j: u, shared: !1, e: t }), c.globals.capturedSeriesIndex = d, c.globals.capturedDataPointIndex = u, o = p + s.tooltipRect.ttWidth / 2 + f, i = h + s.tooltipRect.ttHeight / 2 - m / 2, s.tooltipPosition.moveXCrosshairs(p + f / 2), o > c.globals.gridWidth / 2 && (o = p - s.tooltipRect.ttWidth / 2 + f), s.w.config.tooltip.followCursor) {
        var g = c.globals.dom.elWrap.getBoundingClientRect();
        o = c.globals.clientX - g.left - (o > c.globals.gridWidth / 2 ? s.tooltipRect.ttWidth : 0), i = c.globals.clientY - g.top - (i > c.globals.gridHeight / 2 ? s.tooltipRect.ttHeight : 0);
      }
    }
    return { x: o, y: i };
  } }, { key: "handleMarkerTooltip", value: function(e) {
    var t, n, o = e.e, i = e.opt, a = e.x, s = e.y, c = this.w, d = this.ttCtx;
    if (o.target.classList.contains("apexcharts-marker")) {
      var u = parseInt(i.paths.getAttribute("cx"), 10), p = parseInt(i.paths.getAttribute("cy"), 10), h = parseFloat(i.paths.getAttribute("val"));
      if (n = parseInt(i.paths.getAttribute("rel"), 10), t = parseInt(i.paths.parentNode.parentNode.parentNode.getAttribute("rel"), 10) - 1, d.intersect) {
        var f = $.findAncestor(i.paths, "apexcharts-series");
        f && (t = parseInt(f.getAttribute("data:realIndex"), 10));
      }
      if (d.tooltipLabels.drawSeriesTexts({ ttItems: i.ttItems, i: t, j: n, shared: !d.showOnIntersect && c.config.tooltip.shared, e: o }), o.type === "mouseup" && d.markerClick(o, t, n), c.globals.capturedSeriesIndex = t, c.globals.capturedDataPointIndex = n, a = u, s = p + c.globals.translateY - 1.4 * d.tooltipRect.ttHeight, d.w.config.tooltip.followCursor) {
        var m = d.getElGrid().getBoundingClientRect();
        s = d.e.clientY + c.globals.translateY - m.top;
      }
      h < 0 && (s = p), d.marker.enlargeCurrentPoint(n, i.paths, a, s);
    }
    return { x: a, y: s };
  } }, { key: "handleBarTooltip", value: function(e) {
    var t, n, o = e.e, i = e.opt, a = this.w, s = this.ttCtx, c = s.getElTooltip(), d = 0, u = 0, p = 0, h = this.getBarTooltipXY({ e: o, opt: i });
    if (h.j !== null || h.barHeight !== 0 || h.barWidth !== 0) {
      t = h.i;
      var f = h.j;
      if (a.globals.capturedSeriesIndex = t, a.globals.capturedDataPointIndex = f, a.globals.isBarHorizontal && s.tooltipUtil.hasBars() || !a.config.tooltip.shared ? (u = h.x, p = h.y, n = Array.isArray(a.config.stroke.width) ? a.config.stroke.width[t] : a.config.stroke.width, d = u) : a.globals.comboCharts || a.config.tooltip.shared || (d /= 2), isNaN(p) && (p = a.globals.svgHeight - s.tooltipRect.ttHeight), parseInt(i.paths.parentNode.getAttribute("data:realIndex"), 10), u + s.tooltipRect.ttWidth > a.globals.gridWidth ? u -= s.tooltipRect.ttWidth : u < 0 && (u = 0), s.w.config.tooltip.followCursor) {
        var m = s.getElGrid().getBoundingClientRect();
        p = s.e.clientY - m.top;
      }
      s.tooltip === null && (s.tooltip = a.globals.dom.baseEl.querySelector(".apexcharts-tooltip")), a.config.tooltip.shared || (a.globals.comboBarCount > 0 ? s.tooltipPosition.moveXCrosshairs(d + n / 2) : s.tooltipPosition.moveXCrosshairs(d)), !s.fixedTooltip && (!a.config.tooltip.shared || a.globals.isBarHorizontal && s.tooltipUtil.hasBars()) && (p = p + a.globals.translateY - s.tooltipRect.ttHeight / 2, c.style.left = u + a.globals.translateX + "px", c.style.top = p + "px");
    }
  } }, { key: "getBarTooltipXY", value: function(e) {
    var t = this, n = e.e, o = e.opt, i = this.w, a = null, s = this.ttCtx, c = 0, d = 0, u = 0, p = 0, h = 0, f = n.target.classList;
    if (f.contains("apexcharts-bar-area") || f.contains("apexcharts-candlestick-area") || f.contains("apexcharts-boxPlot-area") || f.contains("apexcharts-rangebar-area")) {
      var m = n.target, g = m.getBoundingClientRect(), b = o.elGrid.getBoundingClientRect(), x = g.height;
      h = g.height;
      var v = g.width, y = parseInt(m.getAttribute("cx"), 10), C = parseInt(m.getAttribute("cy"), 10);
      p = parseFloat(m.getAttribute("barWidth"));
      var k = n.type === "touchmove" ? n.touches[0].clientX : n.clientX;
      a = parseInt(m.getAttribute("j"), 10), c = parseInt(m.parentNode.getAttribute("rel"), 10) - 1;
      var T = m.getAttribute("data-range-y1"), S = m.getAttribute("data-range-y2");
      i.globals.comboCharts && (c = parseInt(m.parentNode.getAttribute("data:realIndex"), 10));
      var O = function(M) {
        return i.globals.isXNumeric ? y - v / 2 : t.isVerticalGroupedRangeBar ? y + v / 2 : y - s.dataPointsDividedWidth + v / 2;
      }, P = function() {
        return C - s.dataPointsDividedHeight + x / 2 - s.tooltipRect.ttHeight / 2;
      };
      s.tooltipLabels.drawSeriesTexts({ ttItems: o.ttItems, i: c, j: a, y1: T ? parseInt(T, 10) : null, y2: S ? parseInt(S, 10) : null, shared: !s.showOnIntersect && i.config.tooltip.shared, e: n }), i.config.tooltip.followCursor ? i.globals.isBarHorizontal ? (d = k - b.left + 15, u = P()) : (d = O(), u = n.clientY - b.top - s.tooltipRect.ttHeight / 2 - 15) : i.globals.isBarHorizontal ? ((d = y) < s.xyRatios.baseLineInvertedY && (d = y - s.tooltipRect.ttWidth), u = P()) : (d = O(), u = C);
    }
    return { x: d, y: u, barHeight: h, barWidth: p, i: c, j: a };
  } }]), r;
})(), qL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.ttCtx = e;
  }
  return ve(r, [{ key: "drawXaxisTooltip", value: function() {
    var e = this.w, t = this.ttCtx, n = e.config.xaxis.position === "bottom";
    t.xaxisOffY = n ? e.globals.gridHeight + 1 : -e.globals.xAxisHeight - e.config.xaxis.axisTicks.height + 3;
    var o = n ? "apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom" : "apexcharts-xaxistooltip apexcharts-xaxistooltip-top", i = e.globals.dom.elWrap;
    t.isXAxisTooltipEnabled && e.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip") === null && (t.xaxisTooltip = document.createElement("div"), t.xaxisTooltip.setAttribute("class", o + " apexcharts-theme-" + e.config.tooltip.theme), i.appendChild(t.xaxisTooltip), t.xaxisTooltipText = document.createElement("div"), t.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"), t.xaxisTooltipText.style.fontFamily = e.config.xaxis.tooltip.style.fontFamily || e.config.chart.fontFamily, t.xaxisTooltipText.style.fontSize = e.config.xaxis.tooltip.style.fontSize, t.xaxisTooltip.appendChild(t.xaxisTooltipText));
  } }, { key: "drawYaxisTooltip", value: function() {
    for (var e = this.w, t = this.ttCtx, n = 0; n < e.config.yaxis.length; n++) {
      var o = e.config.yaxis[n].opposite || e.config.yaxis[n].crosshairs.opposite;
      t.yaxisOffX = o ? e.globals.gridWidth + 1 : 1;
      var i = "apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(n, o ? " apexcharts-yaxistooltip-right" : " apexcharts-yaxistooltip-left"), a = e.globals.dom.elWrap;
      e.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(n)) === null && (t.yaxisTooltip = document.createElement("div"), t.yaxisTooltip.setAttribute("class", i + " apexcharts-theme-" + e.config.tooltip.theme), a.appendChild(t.yaxisTooltip), n === 0 && (t.yaxisTooltipText = []), t.yaxisTooltipText[n] = document.createElement("div"), t.yaxisTooltipText[n].classList.add("apexcharts-yaxistooltip-text"), t.yaxisTooltip.appendChild(t.yaxisTooltipText[n]));
    }
  } }, { key: "setXCrosshairWidth", value: function() {
    var e = this.w, t = this.ttCtx, n = t.getElXCrosshairs();
    if (t.xcrosshairsWidth = parseInt(e.config.xaxis.crosshairs.width, 10), e.globals.comboCharts) {
      var o = e.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
      if (o !== null && e.config.xaxis.crosshairs.width === "barWidth") {
        var i = parseFloat(o.getAttribute("barWidth"));
        t.xcrosshairsWidth = i;
      } else if (e.config.xaxis.crosshairs.width === "tickWidth") {
        var a = e.globals.labels.length;
        t.xcrosshairsWidth = e.globals.gridWidth / a;
      }
    } else if (e.config.xaxis.crosshairs.width === "tickWidth") {
      var s = e.globals.labels.length;
      t.xcrosshairsWidth = e.globals.gridWidth / s;
    } else if (e.config.xaxis.crosshairs.width === "barWidth") {
      var c = e.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
      if (c !== null) {
        var d = parseFloat(c.getAttribute("barWidth"));
        t.xcrosshairsWidth = d;
      } else t.xcrosshairsWidth = 1;
    }
    e.globals.isBarHorizontal && (t.xcrosshairsWidth = 0), n !== null && t.xcrosshairsWidth > 0 && n.setAttribute("width", t.xcrosshairsWidth);
  } }, { key: "handleYCrosshair", value: function() {
    var e = this.w, t = this.ttCtx;
    t.ycrosshairs = e.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"), t.ycrosshairsHidden = e.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden");
  } }, { key: "drawYaxisTooltipText", value: function(e, t, n) {
    var o = this.ttCtx, i = this.w, a = i.globals, s = a.seriesYAxisMap[e];
    if (o.yaxisTooltips[e] && s.length > 0) {
      var c = a.yLabelFormatters[e], d = o.getElGrid().getBoundingClientRect(), u = s[0], p = 0;
      n.yRatio.length > 1 && (p = u);
      var h = (t - d.top) * n.yRatio[p], f = a.maxYArr[u] - a.minYArr[u], m = a.minYArr[u] + (f - h);
      i.config.yaxis[e].reversed && (m = a.maxYArr[u] - (f - h)), o.tooltipPosition.moveYCrosshairs(t - d.top), o.yaxisTooltipText[e].innerHTML = c(m), o.tooltipPosition.moveYAxisTooltip(e);
    }
  } }]), r;
})(), Dh = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
    var t = this.w;
    this.tConfig = t.config.tooltip, this.tooltipUtil = new Gm(this), this.tooltipLabels = new VL(this), this.tooltipPosition = new qm(this), this.marker = new UL(this), this.intersect = new GL(this), this.axesTooltip = new qL(this), this.showOnIntersect = this.tConfig.intersect, this.showTooltipTitle = this.tConfig.x.show, this.fixedTooltip = this.tConfig.fixed.enabled, this.xaxisTooltip = null, this.yaxisTTEls = null, this.isBarShared = !t.globals.isBarHorizontal && this.tConfig.shared, this.lastHoverTime = Date.now();
  }
  return ve(r, [{ key: "getElTooltip", value: function(e) {
    return e || (e = this), e.w.globals.dom.baseEl ? e.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip") : null;
  } }, { key: "getElXCrosshairs", value: function() {
    return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs");
  } }, { key: "getElGrid", value: function() {
    return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid");
  } }, { key: "drawTooltip", value: function(e) {
    var t = this.w;
    this.xyRatios = e, this.isXAxisTooltipEnabled = t.config.xaxis.tooltip.enabled && t.globals.axisCharts, this.yaxisTooltips = t.config.yaxis.map((function(a, s) {
      return !!(a.show && a.tooltip.enabled && t.globals.axisCharts);
    })), this.allTooltipSeriesGroups = [], t.globals.axisCharts || (this.showTooltipTitle = !1);
    var n = document.createElement("div");
    if (n.classList.add("apexcharts-tooltip"), t.config.tooltip.cssClass && n.classList.add(t.config.tooltip.cssClass), n.classList.add("apexcharts-theme-".concat(this.tConfig.theme || "light")), t.globals.dom.elWrap.appendChild(n), t.globals.axisCharts) {
      this.axesTooltip.drawXaxisTooltip(), this.axesTooltip.drawYaxisTooltip(), this.axesTooltip.setXCrosshairWidth(), this.axesTooltip.handleYCrosshair();
      var o = new Ui(this.ctx);
      this.xAxisTicksPositions = o.getXAxisTicksPositions();
    }
    if (!t.globals.comboCharts && !this.tConfig.intersect && t.config.chart.type !== "rangeBar" || this.tConfig.shared || (this.showOnIntersect = !0), t.config.markers.size !== 0 && t.globals.markers.largestSize !== 0 || this.marker.drawDynamicPoints(this), t.globals.collapsedSeries.length !== t.globals.series.length) {
      this.dataPointsDividedHeight = t.globals.gridHeight / t.globals.dataPoints, this.dataPointsDividedWidth = t.globals.gridWidth / t.globals.dataPoints, this.showTooltipTitle && (this.tooltipTitle = document.createElement("div"), this.tooltipTitle.classList.add("apexcharts-tooltip-title"), this.tooltipTitle.style.fontFamily = this.tConfig.style.fontFamily || t.config.chart.fontFamily, this.tooltipTitle.style.fontSize = this.tConfig.style.fontSize, n.appendChild(this.tooltipTitle));
      var i = t.globals.series.length;
      (t.globals.xyCharts || t.globals.comboCharts) && this.tConfig.shared && (i = this.showOnIntersect ? 1 : t.globals.series.length), this.legendLabels = t.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"), this.ttItems = this.createTTElements(i), this.addSVGEvents();
    }
  } }, { key: "createTTElements", value: function(e) {
    for (var t = this, n = this.w, o = [], i = this.getElTooltip(), a = function(c) {
      var d = document.createElement("div");
      d.classList.add("apexcharts-tooltip-series-group", "apexcharts-tooltip-series-group-".concat(c)), d.style.order = n.config.tooltip.inverseOrder ? e - c : c + 1;
      var u = document.createElement("span");
      u.classList.add("apexcharts-tooltip-marker"), n.config.tooltip.fillSeriesColor ? u.style.backgroundColor = n.globals.colors[c] : u.style.color = n.globals.colors[c];
      var p = n.config.markers.shape, h = p;
      Array.isArray(p) && (h = p[c]), u.setAttribute("shape", h), d.appendChild(u);
      var f = document.createElement("div");
      f.classList.add("apexcharts-tooltip-text"), f.style.fontFamily = t.tConfig.style.fontFamily || n.config.chart.fontFamily, f.style.fontSize = t.tConfig.style.fontSize, ["y", "goals", "z"].forEach((function(m) {
        var g = document.createElement("div");
        g.classList.add("apexcharts-tooltip-".concat(m, "-group"));
        var b = document.createElement("span");
        b.classList.add("apexcharts-tooltip-text-".concat(m, "-label")), g.appendChild(b);
        var x = document.createElement("span");
        x.classList.add("apexcharts-tooltip-text-".concat(m, "-value")), g.appendChild(x), f.appendChild(g);
      })), d.appendChild(f), i.appendChild(d), o.push(d);
    }, s = 0; s < e; s++) a(s);
    return o;
  } }, { key: "addSVGEvents", value: function() {
    var e = this.w, t = e.config.chart.type, n = this.getElTooltip(), o = !(t !== "bar" && t !== "candlestick" && t !== "boxPlot" && t !== "rangeBar"), i = t === "area" || t === "line" || t === "scatter" || t === "bubble" || t === "radar", a = e.globals.dom.Paper.node, s = this.getElGrid();
    s && (this.seriesBound = s.getBoundingClientRect());
    var c, d = [], u = [], p = { hoverArea: a, elGrid: s, tooltipEl: n, tooltipY: d, tooltipX: u, ttItems: this.ttItems };
    if (e.globals.axisCharts && (i ? c = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker") : o ? c = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area") : t !== "heatmap" && t !== "treemap" || (c = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")), c && c.length)) for (var h = 0; h < c.length; h++) d.push(c[h].getAttribute("cy")), u.push(c[h].getAttribute("cx"));
    if (e.globals.xyCharts && !this.showOnIntersect || e.globals.comboCharts && !this.showOnIntersect || o && this.tooltipUtil.hasBars() && this.tConfig.shared) this.addPathsEventListeners([a], p);
    else if (o && !e.globals.comboCharts || i && this.showOnIntersect) this.addDatapointEventsListeners(p);
    else if (!e.globals.axisCharts || t === "heatmap" || t === "treemap") {
      var f = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
      this.addPathsEventListeners(f, p);
    }
    if (this.showOnIntersect) {
      var m = e.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");
      m.length > 0 && this.addPathsEventListeners(m, p), this.tooltipUtil.hasBars() && !this.tConfig.shared && this.addDatapointEventsListeners(p);
    }
  } }, { key: "drawFixedTooltipRect", value: function() {
    var e = this.w, t = this.getElTooltip(), n = t.getBoundingClientRect(), o = n.width + 10, i = n.height + 10, a = this.tConfig.fixed.offsetX, s = this.tConfig.fixed.offsetY, c = this.tConfig.fixed.position.toLowerCase();
    return c.indexOf("right") > -1 && (a = a + e.globals.svgWidth - o + 10), c.indexOf("bottom") > -1 && (s = s + e.globals.svgHeight - i - 10), t.style.left = a + "px", t.style.top = s + "px", { x: a, y: s, ttWidth: o, ttHeight: i };
  } }, { key: "addDatapointEventsListeners", value: function(e) {
    var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");
    this.addPathsEventListeners(t, e);
  } }, { key: "addPathsEventListeners", value: function(e, t) {
    for (var n = this, o = function(a) {
      var s = { paths: e[a], tooltipEl: t.tooltipEl, tooltipY: t.tooltipY, tooltipX: t.tooltipX, elGrid: t.elGrid, hoverArea: t.hoverArea, ttItems: t.ttItems };
      ["mousemove", "mouseup", "touchmove", "mouseout", "touchend"].map((function(c) {
        return e[a].addEventListener(c, n.onSeriesHover.bind(n, s), { capture: !1, passive: !0 });
      }));
    }, i = 0; i < e.length; i++) o(i);
  } }, { key: "onSeriesHover", value: function(e, t) {
    var n = this, o = Date.now() - this.lastHoverTime;
    o >= 20 ? this.seriesHover(e, t) : (clearTimeout(this.seriesHoverTimeout), this.seriesHoverTimeout = setTimeout((function() {
      n.seriesHover(e, t);
    }), 20 - o));
  } }, { key: "seriesHover", value: function(e, t) {
    var n = this;
    this.lastHoverTime = Date.now();
    var o = [], i = this.w;
    i.config.chart.group && (o = this.ctx.getGroupedCharts()), i.globals.axisCharts && (i.globals.minX === -1 / 0 && i.globals.maxX === 1 / 0 || i.globals.dataPoints === 0) || (o.length ? o.forEach((function(a) {
      var s = n.getElTooltip(a), c = { paths: e.paths, tooltipEl: s, tooltipY: e.tooltipY, tooltipX: e.tooltipX, elGrid: e.elGrid, hoverArea: e.hoverArea, ttItems: a.w.globals.tooltip.ttItems };
      a.w.globals.minX === n.w.globals.minX && a.w.globals.maxX === n.w.globals.maxX && a.w.globals.tooltip.seriesHoverByContext({ chartCtx: a, ttCtx: a.w.globals.tooltip, opt: c, e: t });
    })) : this.seriesHoverByContext({ chartCtx: this.ctx, ttCtx: this.w.globals.tooltip, opt: e, e: t }));
  } }, { key: "seriesHoverByContext", value: function(e) {
    var t = e.chartCtx, n = e.ttCtx, o = e.opt, i = e.e, a = t.w, s = this.getElTooltip(t);
    s && (n.tooltipRect = { x: 0, y: 0, ttWidth: s.getBoundingClientRect().width, ttHeight: s.getBoundingClientRect().height }, n.e = i, n.tooltipUtil.hasBars() && !a.globals.comboCharts && !n.isBarShared && this.tConfig.onDatasetHover.highlightDataSeries && new mr(t).toggleSeriesOnHover(i, i.target.parentNode), a.globals.axisCharts ? n.axisChartsTooltips({ e: i, opt: o, tooltipRect: n.tooltipRect }) : n.nonAxisChartsTooltips({ e: i, opt: o, tooltipRect: n.tooltipRect }), n.fixedTooltip && n.drawFixedTooltipRect());
  } }, { key: "axisChartsTooltips", value: function(e) {
    var t, n, o = e.e, i = e.opt, a = this.w, s = i.elGrid.getBoundingClientRect(), c = o.type === "touchmove" ? o.touches[0].clientX : o.clientX, d = o.type === "touchmove" ? o.touches[0].clientY : o.clientY;
    if (this.clientY = d, this.clientX = c, a.globals.capturedSeriesIndex = -1, a.globals.capturedDataPointIndex = -1, d < s.top || d > s.top + s.height) this.handleMouseOut(i);
    else {
      if (Array.isArray(this.tConfig.enabledOnSeries) && !a.config.tooltip.shared) {
        var u = parseInt(i.paths.getAttribute("index"), 10);
        if (this.tConfig.enabledOnSeries.indexOf(u) < 0) return void this.handleMouseOut(i);
      }
      var p = this.getElTooltip(), h = this.getElXCrosshairs(), f = [];
      a.config.chart.group && (f = this.ctx.getSyncedCharts());
      var m = a.globals.xyCharts || a.config.chart.type === "bar" && !a.globals.isBarHorizontal && this.tooltipUtil.hasBars() && this.tConfig.shared || a.globals.comboCharts && this.tooltipUtil.hasBars();
      if (o.type === "mousemove" || o.type === "touchmove" || o.type === "mouseup") {
        if (a.globals.collapsedSeries.length + a.globals.ancillaryCollapsedSeries.length === a.globals.series.length) return;
        h !== null && h.classList.add("apexcharts-active");
        var g = this.yaxisTooltips.filter((function(v) {
          return v === !0;
        }));
        if (this.ycrosshairs !== null && g.length && this.ycrosshairs.classList.add("apexcharts-active"), m && !this.showOnIntersect || f.length > 1) this.handleStickyTooltip(o, c, d, i);
        else if (a.config.chart.type === "heatmap" || a.config.chart.type === "treemap") {
          var b = this.intersect.handleHeatTreeTooltip({ e: o, opt: i, x: t, y: n, type: a.config.chart.type });
          t = b.x, n = b.y, p.style.left = t + "px", p.style.top = n + "px";
        } else this.tooltipUtil.hasBars() && this.intersect.handleBarTooltip({ e: o, opt: i }), this.tooltipUtil.hasMarkers() && this.intersect.handleMarkerTooltip({ e: o, opt: i, x: t, y: n });
        if (this.yaxisTooltips.length) for (var x = 0; x < a.config.yaxis.length; x++) this.axesTooltip.drawYaxisTooltipText(x, d, this.xyRatios);
        a.globals.dom.baseEl.classList.add("apexcharts-tooltip-active"), i.tooltipEl.classList.add("apexcharts-active");
      } else o.type !== "mouseout" && o.type !== "touchend" || this.handleMouseOut(i);
    }
  } }, { key: "nonAxisChartsTooltips", value: function(e) {
    var t = e.e, n = e.opt, o = e.tooltipRect, i = this.w, a = n.paths.getAttribute("rel"), s = this.getElTooltip(), c = i.globals.dom.elWrap.getBoundingClientRect();
    if (t.type === "mousemove" || t.type === "touchmove") {
      i.globals.dom.baseEl.classList.add("apexcharts-tooltip-active"), s.classList.add("apexcharts-active"), this.tooltipLabels.drawSeriesTexts({ ttItems: n.ttItems, i: parseInt(a, 10) - 1, shared: !1 });
      var d = i.globals.clientX - c.left - o.ttWidth / 2, u = i.globals.clientY - c.top - o.ttHeight - 10;
      if (s.style.left = d + "px", s.style.top = u + "px", i.config.legend.tooltipHoverFormatter) {
        var p = a - 1, h = (0, i.config.legend.tooltipHoverFormatter)(this.legendLabels[p].getAttribute("data:default-text"), { seriesIndex: p, dataPointIndex: p, w: i });
        this.legendLabels[p].innerHTML = h;
      }
    } else t.type !== "mouseout" && t.type !== "touchend" || (s.classList.remove("apexcharts-active"), i.globals.dom.baseEl.classList.remove("apexcharts-tooltip-active"), i.config.legend.tooltipHoverFormatter && this.legendLabels.forEach((function(f) {
      var m = f.getAttribute("data:default-text");
      f.innerHTML = decodeURIComponent(m);
    })));
  } }, { key: "handleStickyTooltip", value: function(e, t, n, o) {
    var i = this.w, a = this.tooltipUtil.getNearestValues({ context: this, hoverArea: o.hoverArea, elGrid: o.elGrid, clientX: t, clientY: n }), s = a.j, c = a.capturedSeries;
    i.globals.collapsedSeriesIndices.includes(c) && (c = null);
    var d = o.elGrid.getBoundingClientRect();
    if (a.hoverX < 0 || a.hoverX > d.width) this.handleMouseOut(o);
    else if (c !== null) this.handleStickyCapturedSeries(e, c, o, s);
    else if (this.tooltipUtil.isXoverlap(s) || i.globals.isBarHorizontal) {
      var u = i.globals.series.findIndex((function(p, h) {
        return !i.globals.collapsedSeriesIndices.includes(h);
      }));
      this.create(e, this, u, s, o.ttItems);
    }
  } }, { key: "handleStickyCapturedSeries", value: function(e, t, n, o) {
    var i = this.w;
    if (!this.tConfig.shared && i.globals.series[t][o] === null) return void this.handleMouseOut(n);
    if (i.globals.series[t][o] !== void 0) this.tConfig.shared && this.tooltipUtil.isXoverlap(o) && this.tooltipUtil.isInitialSeriesSameLen() ? this.create(e, this, t, o, n.ttItems) : this.create(e, this, t, o, n.ttItems, !1);
    else if (this.tooltipUtil.isXoverlap(o)) {
      var a = i.globals.series.findIndex((function(s, c) {
        return !i.globals.collapsedSeriesIndices.includes(c);
      }));
      this.create(e, this, a, o, n.ttItems);
    }
  } }, { key: "deactivateHoverFilter", value: function() {
    for (var e = this.w, t = new ee(this.ctx), n = e.globals.dom.Paper.find(".apexcharts-bar-area"), o = 0; o < n.length; o++) t.pathMouseLeave(n[o]);
  } }, { key: "handleMouseOut", value: function(e) {
    var t = this.w, n = this.getElXCrosshairs();
    if (t.globals.dom.baseEl.classList.remove("apexcharts-tooltip-active"), e.tooltipEl.classList.remove("apexcharts-active"), this.deactivateHoverFilter(), t.config.chart.type !== "bubble" && this.marker.resetPointsSize(), n !== null && n.classList.remove("apexcharts-active"), this.ycrosshairs !== null && this.ycrosshairs.classList.remove("apexcharts-active"), this.isXAxisTooltipEnabled && this.xaxisTooltip.classList.remove("apexcharts-active"), this.yaxisTooltips.length) {
      this.yaxisTTEls === null && (this.yaxisTTEls = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
      for (var o = 0; o < this.yaxisTTEls.length; o++) this.yaxisTTEls[o].classList.remove("apexcharts-active");
    }
    t.config.legend.tooltipHoverFormatter && this.legendLabels.forEach((function(i) {
      var a = i.getAttribute("data:default-text");
      i.innerHTML = decodeURIComponent(a);
    }));
  } }, { key: "markerClick", value: function(e, t, n) {
    var o = this.w;
    typeof o.config.chart.events.markerClick == "function" && o.config.chart.events.markerClick(e, this.ctx, { seriesIndex: t, dataPointIndex: n, w: o }), this.ctx.events.fireEvent("markerClick", [e, this.ctx, { seriesIndex: t, dataPointIndex: n, w: o }]);
  } }, { key: "create", value: function(e, t, n, o, i) {
    var a, s, c, d, u, p, h, f, m, g, b, x, v, y, C, k, T = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, S = this.w, O = t;
    e.type === "mouseup" && this.markerClick(e, n, o), T === null && (T = this.tConfig.shared);
    var P = this.tooltipUtil.hasMarkers(n), M = this.tooltipUtil.getElBars(), I = function() {
      S.globals.markers.largestSize > 0 ? O.marker.enlargePoints(o) : O.tooltipPosition.moveDynamicPointsOnHover(o);
    };
    if (S.config.legend.tooltipHoverFormatter) {
      var E = S.config.legend.tooltipHoverFormatter, N = Array.from(this.legendLabels);
      N.forEach((function(Ce) {
        var ne = Ce.getAttribute("data:default-text");
        Ce.innerHTML = decodeURIComponent(ne);
      }));
      for (var L = 0; L < N.length; L++) {
        var z = N[L], F = parseInt(z.getAttribute("i"), 10), B = decodeURIComponent(z.getAttribute("data:default-text")), D = E(B, { seriesIndex: T ? F : n, dataPointIndex: o, w: S });
        if (T) z.innerHTML = S.globals.collapsedSeriesIndices.indexOf(F) < 0 ? D : B;
        else if (z.innerHTML = F === n ? D : B, n === F) break;
      }
    }
    var W = ie(ie({ ttItems: i, i: n, j: o }, ((a = S.globals.seriesRange) === null || a === void 0 || (s = a[n]) === null || s === void 0 || (c = s[o]) === null || c === void 0 || (d = c.y[0]) === null || d === void 0 ? void 0 : d.y1) !== void 0 && { y1: (u = S.globals.seriesRange) === null || u === void 0 || (p = u[n]) === null || p === void 0 || (h = p[o]) === null || h === void 0 || (f = h.y[0]) === null || f === void 0 ? void 0 : f.y1 }), ((m = S.globals.seriesRange) === null || m === void 0 || (g = m[n]) === null || g === void 0 || (b = g[o]) === null || b === void 0 || (x = b.y[0]) === null || x === void 0 ? void 0 : x.y2) !== void 0 && { y2: (v = S.globals.seriesRange) === null || v === void 0 || (y = v[n]) === null || y === void 0 || (C = y[o]) === null || C === void 0 || (k = C.y[0]) === null || k === void 0 ? void 0 : k.y2 });
    if (T) {
      if (O.tooltipLabels.drawSeriesTexts(ie(ie({}, W), {}, { shared: !this.showOnIntersect && this.tConfig.shared })), P) I();
      else if (this.tooltipUtil.hasBars() && (this.barSeriesHeight = this.tooltipUtil.getBarsHeight(M), this.barSeriesHeight > 0)) {
        var G = new ee(this.ctx), re = S.globals.dom.Paper.find(".apexcharts-bar-area[j='".concat(o, "']"));
        this.deactivateHoverFilter(), O.tooltipUtil.getAllMarkers(!0).length && !this.barSeriesHeight && I(), O.tooltipPosition.moveStickyTooltipOverBars(o, n);
        for (var ce = 0; ce < re.length; ce++) G.pathMouseEnter(re[ce]);
      }
    } else O.tooltipLabels.drawSeriesTexts(ie({ shared: !1 }, W)), this.tooltipUtil.hasBars() && O.tooltipPosition.moveStickyTooltipOverBars(o, n), P && O.tooltipPosition.moveMarkers(n, o);
  } }]), r;
})(), KL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.barCtx = e, this.totalFormatter = this.w.config.plotOptions.bar.dataLabels.total.formatter, this.totalFormatter || (this.totalFormatter = this.w.config.dataLabels.formatter);
  }
  return ve(r, [{ key: "handleBarDataLabels", value: function(e) {
    var t, n, o = e.x, i = e.y, a = e.y1, s = e.y2, c = e.i, d = e.j, u = e.realIndex, p = e.columnGroupIndex, h = e.series, f = e.barHeight, m = e.barWidth, g = e.barXPosition, b = e.barYPosition, x = e.visibleSeries, v = this.w, y = new ee(this.barCtx.ctx), C = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[u] : this.barCtx.strokeWidth;
    v.globals.isXNumeric && !v.globals.isBarHorizontal ? (t = o + parseFloat(m * (x + 1)), n = i + parseFloat(f * (x + 1)) - C) : (t = o + parseFloat(m * x), n = i + parseFloat(f * x));
    var k, T = null, S = o, O = i, P = {}, M = v.config.dataLabels, I = this.barCtx.barOptions.dataLabels, E = this.barCtx.barOptions.dataLabels.total;
    b !== void 0 && this.barCtx.isRangeBar && (n = b, O = b), g !== void 0 && this.barCtx.isVerticalGroupedRangeBar && (t = g, S = g);
    var N = M.offsetX, L = M.offsetY, z = { width: 0, height: 0 };
    if (v.config.dataLabels.enabled) {
      var F = v.globals.series[c][d];
      z = y.getTextRects(v.config.dataLabels.formatter ? v.config.dataLabels.formatter(F, ie(ie({}, v), {}, { seriesIndex: c, dataPointIndex: d, w: v })) : v.globals.yLabelFormatters[0](F), parseFloat(M.style.fontSize));
    }
    var B = { x: o, y: i, i: c, j: d, realIndex: u, columnGroupIndex: p, bcx: t, bcy: n, barHeight: f, barWidth: m, textRects: z, strokeWidth: C, dataLabelsX: S, dataLabelsY: O, dataLabelsConfig: M, barDataLabelsConfig: I, barTotalDataLabelsConfig: E, offX: N, offY: L };
    return P = this.barCtx.isHorizontal ? this.calculateBarsDataLabelsPosition(B) : this.calculateColumnsDataLabelsPosition(B), k = this.drawCalculatedDataLabels({ x: P.dataLabelsX, y: P.dataLabelsY, val: this.barCtx.isRangeBar ? [a, s] : v.config.chart.stackType === "100%" ? h[u][d] : v.globals.series[u][d], i: u, j: d, barWidth: m, barHeight: f, textRects: z, dataLabelsConfig: M }), v.config.chart.stacked && E.enabled && (T = this.drawTotalDataLabels({ x: P.totalDataLabelsX, y: P.totalDataLabelsY, barWidth: m, barHeight: f, realIndex: u, textAnchor: P.totalDataLabelsAnchor, val: this.getStackedTotalDataLabel({ realIndex: u, j: d }), dataLabelsConfig: M, barTotalDataLabelsConfig: E })), { dataLabelsPos: P, dataLabels: k, totalDataLabels: T };
  } }, { key: "getStackedTotalDataLabel", value: function(e) {
    var t = e.realIndex, n = e.j, o = this.w, i = this.barCtx.stackedSeriesTotals[n];
    return this.totalFormatter && (i = this.totalFormatter(i, ie(ie({}, o), {}, { seriesIndex: t, dataPointIndex: n, w: o }))), i;
  } }, { key: "calculateColumnsDataLabelsPosition", value: function(e) {
    var t = this, n = this.w, o = e.i, i = e.j, a = e.realIndex;
    e.columnGroupIndex;
    var s, c, d = e.y, u = e.bcx, p = e.barWidth, h = e.barHeight, f = e.textRects, m = e.dataLabelsX, g = e.dataLabelsY, b = e.dataLabelsConfig, x = e.barDataLabelsConfig, v = e.barTotalDataLabelsConfig, y = e.strokeWidth, C = e.offX, k = e.offY, T = u;
    h = Math.abs(h);
    var S = n.config.plotOptions.bar.dataLabels.orientation === "vertical", O = this.barCtx.barHelpers.getZeroValueEncounters({ i: o, j: i }).zeroEncounters;
    u -= y / 2;
    var P = n.globals.gridWidth / n.globals.dataPoints;
    this.barCtx.isVerticalGroupedRangeBar ? m += p / 2 : (m = n.globals.isXNumeric ? u - p / 2 + C : u - P + p / 2 + C, !n.config.chart.stacked && O > 0 && n.config.plotOptions.bar.hideZeroBarsWhenGrouped && (m -= p * O)), S && (m = m + f.height / 2 - y / 2 - 2);
    var M = n.globals.series[o][i] < 0, I = d;
    switch (this.barCtx.isReversed && (I = d + (M ? h : -h)), x.position) {
      case "center":
        g = S ? M ? I - h / 2 + k : I + h / 2 - k : M ? I - h / 2 + f.height / 2 + k : I + h / 2 + f.height / 2 - k;
        break;
      case "bottom":
        g = S ? M ? I - h + k : I + h - k : M ? I - h + f.height + y + k : I + h - f.height / 2 + y - k;
        break;
      case "top":
        g = S ? M ? I + k : I - k : M ? I - f.height / 2 - k : I + f.height + k;
    }
    var E = I;
    if (n.globals.seriesGroups.forEach((function(z) {
      var F;
      (F = t.barCtx[z.join(",")]) === null || F === void 0 || F.prevY.forEach((function(B) {
        E = M ? Math.max(B[i], E) : Math.min(B[i], E);
      }));
    })), this.barCtx.lastActiveBarSerieIndex === a && v.enabled) {
      var N = new ee(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({ realIndex: a, j: i }), b.fontSize);
      s = M ? E - N.height / 2 - k - v.offsetY + 18 : E + N.height + k + v.offsetY - 18;
      var L = P;
      c = T + (n.globals.isXNumeric ? -p * n.globals.barGroups.length / 2 : n.globals.barGroups.length * p / 2 - (n.globals.barGroups.length - 1) * p - L) + v.offsetX;
    }
    return n.config.chart.stacked || (g < 0 ? g = 0 + y : g + f.height / 3 > n.globals.gridHeight && (g = n.globals.gridHeight - y)), { bcx: u, bcy: d, dataLabelsX: m, dataLabelsY: g, totalDataLabelsX: c, totalDataLabelsY: s, totalDataLabelsAnchor: "middle" };
  } }, { key: "calculateBarsDataLabelsPosition", value: function(e) {
    var t = this, n = this.w, o = e.x, i = e.i, a = e.j, s = e.realIndex, c = e.bcy, d = e.barHeight, u = e.barWidth, p = e.textRects, h = e.dataLabelsX, f = e.strokeWidth, m = e.dataLabelsConfig, g = e.barDataLabelsConfig, b = e.barTotalDataLabelsConfig, x = e.offX, v = e.offY, y = n.globals.gridHeight / n.globals.dataPoints, C = this.barCtx.barHelpers.getZeroValueEncounters({ i, j: a }).zeroEncounters;
    u = Math.abs(u);
    var k, T, S = c - (this.barCtx.isRangeBar ? 0 : y) + d / 2 + p.height / 2 + v - 3;
    !n.config.chart.stacked && C > 0 && n.config.plotOptions.bar.hideZeroBarsWhenGrouped && (S -= d * C);
    var O = "start", P = n.globals.series[i][a] < 0, M = o;
    switch (this.barCtx.isReversed && (M = o + (P ? -u : u), O = P ? "start" : "end"), g.position) {
      case "center":
        h = P ? M + u / 2 - x : Math.max(p.width / 2, M - u / 2) + x;
        break;
      case "bottom":
        h = P ? M + u - f - x : M - u + f + x;
        break;
      case "top":
        h = P ? M - f - x : M - f + x;
    }
    var I = M;
    if (n.globals.seriesGroups.forEach((function(N) {
      var L;
      (L = t.barCtx[N.join(",")]) === null || L === void 0 || L.prevX.forEach((function(z) {
        I = P ? Math.min(z[a], I) : Math.max(z[a], I);
      }));
    })), this.barCtx.lastActiveBarSerieIndex === s && b.enabled) {
      var E = new ee(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({ realIndex: s, j: a }), m.fontSize);
      P ? (k = I - f - x - b.offsetX, O = "end") : k = I + x + b.offsetX + (this.barCtx.isReversed ? -(u + f) : f), T = S - p.height / 2 + E.height / 2 + b.offsetY + f, n.globals.barGroups.length > 1 && (T -= n.globals.barGroups.length / 2 * (d / 2));
    }
    return n.config.chart.stacked || (m.textAnchor === "start" ? h - p.width < 0 ? h = P ? p.width + f : f : h + p.width > n.globals.gridWidth && (h = P ? n.globals.gridWidth - f : n.globals.gridWidth - p.width - f) : m.textAnchor === "middle" ? h - p.width / 2 < 0 ? h = p.width / 2 + f : h + p.width / 2 > n.globals.gridWidth && (h = n.globals.gridWidth - p.width / 2 - f) : m.textAnchor === "end" && (h < 1 ? h = p.width + f : h + 1 > n.globals.gridWidth && (h = n.globals.gridWidth - p.width - f))), { bcx: o, bcy: c, dataLabelsX: h, dataLabelsY: S, totalDataLabelsX: k, totalDataLabelsY: T, totalDataLabelsAnchor: O };
  } }, { key: "drawCalculatedDataLabels", value: function(e) {
    var t = e.x, n = e.y, o = e.val, i = e.i, a = e.j, s = e.textRects, c = e.barHeight, d = e.barWidth, u = e.dataLabelsConfig, p = this.w, h = "rotate(0)";
    p.config.plotOptions.bar.dataLabels.orientation === "vertical" && (h = "rotate(-90, ".concat(t, ", ").concat(n, ")"));
    var f = new vo(this.barCtx.ctx), m = new ee(this.barCtx.ctx), g = u.formatter, b = null, x = p.globals.collapsedSeriesIndices.indexOf(i) > -1;
    if (u.enabled && !x) {
      b = m.group({ class: "apexcharts-data-labels", transform: h });
      var v = "";
      o !== void 0 && (v = g(o, ie(ie({}, p), {}, { seriesIndex: i, dataPointIndex: a, w: p }))), !o && p.config.plotOptions.bar.hideZeroBarsWhenGrouped && (v = "");
      var y = p.globals.series[i][a] < 0, C = p.config.plotOptions.bar.dataLabels.position;
      p.config.plotOptions.bar.dataLabels.orientation === "vertical" && (C === "top" && (u.textAnchor = y ? "end" : "start"), C === "center" && (u.textAnchor = "middle"), C === "bottom" && (u.textAnchor = y ? "end" : "start")), this.barCtx.isRangeBar && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && d < m.getTextRects(v, parseFloat(u.style.fontSize)).width && (v = ""), p.config.chart.stacked && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && (this.barCtx.isHorizontal ? s.width / 1.6 > Math.abs(d) && (v = "") : s.height / 1.6 > Math.abs(c) && (v = ""));
      var k = ie({}, u);
      this.barCtx.isHorizontal && o < 0 && (u.textAnchor === "start" ? k.textAnchor = "end" : u.textAnchor === "end" && (k.textAnchor = "start")), f.plotDataLabelsText({ x: t, y: n, text: v, i, j: a, parent: b, dataLabelsConfig: k, alwaysDrawDataLabel: !0, offsetCorrection: !0 });
    }
    return b;
  } }, { key: "drawTotalDataLabels", value: function(e) {
    var t = e.x, n = e.y, o = e.val, i = e.realIndex, a = e.textAnchor, s = e.barTotalDataLabelsConfig;
    this.w;
    var c, d = new ee(this.barCtx.ctx);
    return s.enabled && t !== void 0 && n !== void 0 && this.barCtx.lastActiveBarSerieIndex === i && (c = d.drawText({ x: t, y: n, foreColor: s.style.color, text: o, textAnchor: a, fontFamily: s.style.fontFamily, fontSize: s.style.fontSize, fontWeight: s.style.fontWeight })), c;
  } }]), r;
})(), ZL = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.barCtx = e;
  }
  return ve(r, [{ key: "initVariables", value: function(e) {
    var t = this.w;
    this.barCtx.series = e, this.barCtx.totalItems = 0, this.barCtx.seriesLen = 0, this.barCtx.visibleI = -1, this.barCtx.visibleItems = 1;
    for (var n = 0; n < e.length; n++) if (e[n].length > 0 && (this.barCtx.seriesLen = this.barCtx.seriesLen + 1, this.barCtx.totalItems += e[n].length), t.globals.isXNumeric) for (var o = 0; o < e[n].length; o++) t.globals.seriesX[n][o] > t.globals.minX && t.globals.seriesX[n][o] < t.globals.maxX && this.barCtx.visibleItems++;
    else this.barCtx.visibleItems = t.globals.dataPoints;
    this.arrBorderRadius = this.createBorderRadiusArr(t.globals.series), $.isSafari() && (this.arrBorderRadius = this.arrBorderRadius.map((function(i) {
      return i.map((function(a) {
        return "none";
      }));
    }))), this.barCtx.seriesLen === 0 && (this.barCtx.seriesLen = 1), this.barCtx.zeroSerieses = [], t.globals.comboCharts || this.checkZeroSeries({ series: e });
  } }, { key: "initialPositions", value: function(e) {
    var t, n, o, i, a, s, c, d, u = this.w, p = u.globals.dataPoints;
    this.barCtx.isRangeBar && (p = u.globals.labels.length);
    var h = this.barCtx.seriesLen;
    if (u.config.plotOptions.bar.rangeBarGroupRows && (h = 1), this.barCtx.isHorizontal) a = (o = u.globals.gridHeight / p) / h, u.globals.isXNumeric && (a = (o = u.globals.gridHeight / this.barCtx.totalItems) / this.barCtx.seriesLen), a = a * parseInt(this.barCtx.barOptions.barHeight, 10) / 100, String(this.barCtx.barOptions.barHeight).indexOf("%") === -1 && (a = parseInt(this.barCtx.barOptions.barHeight, 10)), d = this.barCtx.baseLineInvertedY + u.globals.padHorizontal + (this.barCtx.isReversed ? u.globals.gridWidth : 0) - (this.barCtx.isReversed ? 2 * this.barCtx.baseLineInvertedY : 0), this.barCtx.isFunnel && (d = u.globals.gridWidth / 2), n = (o - a * this.barCtx.seriesLen) / 2;
    else {
      if (i = u.globals.gridWidth / this.barCtx.visibleItems, u.config.xaxis.convertedCatToNumeric && (i = u.globals.gridWidth / u.globals.dataPoints), s = i / h * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100, u.globals.isXNumeric) {
        var f = this.barCtx.xRatio;
        u.globals.minXDiff && u.globals.minXDiff !== 0.5 && u.globals.minXDiff / f > 0 && (i = u.globals.minXDiff / f), (s = i / h * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100) < 1 && (s = 1);
      }
      String(this.barCtx.barOptions.columnWidth).indexOf("%") === -1 && (s = parseInt(this.barCtx.barOptions.columnWidth, 10)), c = u.globals.gridHeight - this.barCtx.baseLineY[this.barCtx.translationsIndex] - (this.barCtx.isReversed ? u.globals.gridHeight : 0) + (this.barCtx.isReversed ? 2 * this.barCtx.baseLineY[this.barCtx.translationsIndex] : 0), u.globals.isXNumeric ? t = this.barCtx.getBarXForNumericXAxis({ x: t, j: 0, realIndex: e, barWidth: s }).x : t = u.globals.padHorizontal + $.noExponents(i - s * this.barCtx.seriesLen) / 2;
    }
    return u.globals.barHeight = a, u.globals.barWidth = s, { x: t, y: n, yDivision: o, xDivision: i, barHeight: a, barWidth: s, zeroH: c, zeroW: d };
  } }, { key: "initializeStackedPrevVars", value: function(e) {
    e.w.globals.seriesGroups.forEach((function(t) {
      e[t] || (e[t] = {}), e[t].prevY = [], e[t].prevX = [], e[t].prevYF = [], e[t].prevXF = [], e[t].prevYVal = [], e[t].prevXVal = [];
    }));
  } }, { key: "initializeStackedXYVars", value: function(e) {
    e.w.globals.seriesGroups.forEach((function(t) {
      e[t] || (e[t] = {}), e[t].xArrj = [], e[t].xArrjF = [], e[t].xArrjVal = [], e[t].yArrj = [], e[t].yArrjF = [], e[t].yArrjVal = [];
    }));
  } }, { key: "getPathFillColor", value: function(e, t, n, o) {
    var i, a, s, c, d = this.w, u = this.barCtx.ctx.fill, p = null, h = this.barCtx.barOptions.distributed ? n : t, f = !1;
    return this.barCtx.barOptions.colors.ranges.length > 0 && this.barCtx.barOptions.colors.ranges.map((function(m) {
      e[t][n] >= m.from && e[t][n] <= m.to && (p = m.color, f = !0);
    })), { color: u.fillPath({ seriesNumber: this.barCtx.barOptions.distributed ? h : o, dataPointIndex: n, color: p, value: e[t][n], fillConfig: (i = d.config.series[t].data[n]) === null || i === void 0 ? void 0 : i.fill, fillType: (a = d.config.series[t].data[n]) !== null && a !== void 0 && (s = a.fill) !== null && s !== void 0 && s.type ? (c = d.config.series[t].data[n]) === null || c === void 0 ? void 0 : c.fill.type : Array.isArray(d.config.fill.type) ? d.config.fill.type[o] : d.config.fill.type }), useRangeColor: f };
  } }, { key: "getStrokeWidth", value: function(e, t, n) {
    var o = 0, i = this.w;
    return this.barCtx.series[e][t] === void 0 || this.barCtx.series[e][t] === null || i.config.chart.type === "bar" && !this.barCtx.series[e][t] ? this.barCtx.isNullValue = !0 : this.barCtx.isNullValue = !1, i.config.stroke.show && (this.barCtx.isNullValue || (o = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[n] : this.barCtx.strokeWidth)), o;
  } }, { key: "createBorderRadiusArr", value: function(e) {
    var t, n = this.w, o = !this.w.config.chart.stacked || n.config.plotOptions.bar.borderRadius <= 0, i = e.length, a = 0 | ((t = e[0]) === null || t === void 0 ? void 0 : t.length), s = Array.from({ length: i }, (function() {
      return Array(a).fill(o ? "top" : "none");
    }));
    if (o) return s;
    for (var c = 0; c < a; c++) {
      for (var d = [], u = [], p = 0, h = 0; h < i; h++) {
        var f = e[h][c];
        f > 0 ? (d.push(h), p++) : f < 0 && (u.push(h), p++);
      }
      if (d.length > 0 && u.length === 0) if (d.length === 1) s[d[0]][c] = "both";
      else {
        var m, g = d[0], b = d[d.length - 1], x = Ci(d);
        try {
          for (x.s(); !(m = x.n()).done; ) {
            var v = m.value;
            s[v][c] = v === g ? "bottom" : v === b ? "top" : "none";
          }
        } catch (F) {
          x.e(F);
        } finally {
          x.f();
        }
      }
      else if (u.length > 0 && d.length === 0) if (u.length === 1) s[u[0]][c] = "both";
      else {
        var y, C = Math.max.apply(Math, u), k = Math.min.apply(Math, u), T = Ci(u);
        try {
          for (T.s(); !(y = T.n()).done; ) {
            var S = y.value;
            s[S][c] = S === C ? "bottom" : S === k ? "top" : "none";
          }
        } catch (F) {
          T.e(F);
        } finally {
          T.f();
        }
      }
      else if (d.length > 0 && u.length > 0) {
        var O, P = d[d.length - 1], M = Ci(d);
        try {
          for (M.s(); !(O = M.n()).done; ) {
            var I = O.value;
            s[I][c] = I === P ? "top" : "none";
          }
        } catch (F) {
          M.e(F);
        } finally {
          M.f();
        }
        var E, N = Math.max.apply(Math, u), L = Ci(u);
        try {
          for (L.s(); !(E = L.n()).done; ) {
            var z = E.value;
            s[z][c] = z === N ? "bottom" : "none";
          }
        } catch (F) {
          L.e(F);
        } finally {
          L.f();
        }
      } else p === 1 && (s[d[0] || u[0]][c] = "both");
    }
    return s;
  } }, { key: "barBackground", value: function(e) {
    var t = e.j, n = e.i, o = e.x1, i = e.x2, a = e.y1, s = e.y2, c = e.elSeries, d = this.w, u = new ee(this.barCtx.ctx), p = new mr(this.barCtx.ctx).getActiveConfigSeriesIndex();
    if (this.barCtx.barOptions.colors.backgroundBarColors.length > 0 && p === n) {
      t >= this.barCtx.barOptions.colors.backgroundBarColors.length && (t %= this.barCtx.barOptions.colors.backgroundBarColors.length);
      var h = this.barCtx.barOptions.colors.backgroundBarColors[t], f = u.drawRect(o !== void 0 ? o : 0, a !== void 0 ? a : 0, i !== void 0 ? i : d.globals.gridWidth, s !== void 0 ? s : d.globals.gridHeight, this.barCtx.barOptions.colors.backgroundBarRadius, h, this.barCtx.barOptions.colors.backgroundBarOpacity);
      c.add(f), f.node.classList.add("apexcharts-backgroundBar");
    }
  } }, { key: "getColumnPaths", value: function(e) {
    var t, n = e.barWidth, o = e.barXPosition, i = e.y1, a = e.y2, s = e.strokeWidth, c = e.isReversed, d = e.series, u = e.seriesGroup, p = e.realIndex, h = e.i, f = e.j, m = e.w, g = new ee(this.barCtx.ctx);
    (s = Array.isArray(s) ? s[p] : s) || (s = 0);
    var b = n, x = o;
    (t = m.config.series[p].data[f]) !== null && t !== void 0 && t.columnWidthOffset && (x = o - m.config.series[p].data[f].columnWidthOffset / 2, b = n + m.config.series[p].data[f].columnWidthOffset);
    var v = s / 2, y = x + v, C = x + b - v, k = (d[h][f] >= 0 ? 1 : -1) * (c ? -1 : 1);
    i += 1e-3 - v * k, a += 1e-3 + v * k;
    var T = g.move(y, i), S = g.move(y, i), O = g.line(C, i);
    if (m.globals.previousPaths.length > 0 && (S = this.barCtx.getPreviousPath(p, f, !1)), T = T + g.line(y, a) + g.line(C, a) + O + (m.config.plotOptions.bar.borderRadiusApplication === "around" || this.arrBorderRadius[p][f] === "both" ? " Z" : " z"), S = S + g.line(y, i) + O + O + O + O + O + g.line(y, i) + (m.config.plotOptions.bar.borderRadiusApplication === "around" || this.arrBorderRadius[p][f] === "both" ? " Z" : " z"), this.arrBorderRadius[p][f] !== "none" && (T = g.roundPathCorners(T, m.config.plotOptions.bar.borderRadius)), m.config.chart.stacked) {
      var P = this.barCtx;
      (P = this.barCtx[u]).yArrj.push(a - v * k), P.yArrjF.push(Math.abs(i - a + s * k)), P.yArrjVal.push(this.barCtx.series[h][f]);
    }
    return { pathTo: T, pathFrom: S };
  } }, { key: "getBarpaths", value: function(e) {
    var t, n = e.barYPosition, o = e.barHeight, i = e.x1, a = e.x2, s = e.strokeWidth, c = e.isReversed, d = e.series, u = e.seriesGroup, p = e.realIndex, h = e.i, f = e.j, m = e.w, g = new ee(this.barCtx.ctx);
    (s = Array.isArray(s) ? s[p] : s) || (s = 0);
    var b = n, x = o;
    (t = m.config.series[p].data[f]) !== null && t !== void 0 && t.barHeightOffset && (b = n - m.config.series[p].data[f].barHeightOffset / 2, x = o + m.config.series[p].data[f].barHeightOffset);
    var v = s / 2, y = b + v, C = b + x - v, k = (d[h][f] >= 0 ? 1 : -1) * (c ? -1 : 1);
    i += 1e-3 + v * k, a += 1e-3 - v * k;
    var T = g.move(i, y), S = g.move(i, y);
    m.globals.previousPaths.length > 0 && (S = this.barCtx.getPreviousPath(p, f, !1));
    var O = g.line(i, C);
    if (T = T + g.line(a, y) + g.line(a, C) + O + (m.config.plotOptions.bar.borderRadiusApplication === "around" || this.arrBorderRadius[p][f] === "both" ? " Z" : " z"), S = S + g.line(i, y) + O + O + O + O + O + g.line(i, y) + (m.config.plotOptions.bar.borderRadiusApplication === "around" || this.arrBorderRadius[p][f] === "both" ? " Z" : " z"), this.arrBorderRadius[p][f] !== "none" && (T = g.roundPathCorners(T, m.config.plotOptions.bar.borderRadius)), m.config.chart.stacked) {
      var P = this.barCtx;
      (P = this.barCtx[u]).xArrj.push(a + v * k), P.xArrjF.push(Math.abs(i - a - s * k)), P.xArrjVal.push(this.barCtx.series[h][f]);
    }
    return { pathTo: T, pathFrom: S };
  } }, { key: "checkZeroSeries", value: function(e) {
    for (var t = e.series, n = this.w, o = 0; o < t.length; o++) {
      for (var i = 0, a = 0; a < t[n.globals.maxValsInArrayIndex].length; a++) i += t[o][a];
      i === 0 && this.barCtx.zeroSerieses.push(o);
    }
  } }, { key: "getXForValue", value: function(e, t) {
    var n = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2] ? t : null;
    return e != null && (n = t + e / this.barCtx.invertedYRatio - 2 * (this.barCtx.isReversed ? e / this.barCtx.invertedYRatio : 0)), n;
  } }, { key: "getYForValue", value: function(e, t, n) {
    var o = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3] ? t : null;
    return e != null && (o = t - e / this.barCtx.yRatio[n] + 2 * (this.barCtx.isReversed ? e / this.barCtx.yRatio[n] : 0)), o;
  } }, { key: "getGoalValues", value: function(e, t, n, o, i, a) {
    var s = this, c = this.w, d = [], u = function(f, m) {
      var g;
      d.push((is(g = {}, e, e === "x" ? s.getXForValue(f, t, !1) : s.getYForValue(f, n, a, !1)), is(g, "attrs", m), g));
    };
    if (c.globals.seriesGoals[o] && c.globals.seriesGoals[o][i] && Array.isArray(c.globals.seriesGoals[o][i]) && c.globals.seriesGoals[o][i].forEach((function(f) {
      u(f.value, f);
    })), this.barCtx.barOptions.isDumbbell && c.globals.seriesRange.length) {
      var p = this.barCtx.barOptions.dumbbellColors ? this.barCtx.barOptions.dumbbellColors : c.globals.colors, h = { strokeHeight: e === "x" ? 0 : c.globals.markers.size[o], strokeWidth: e === "x" ? c.globals.markers.size[o] : 0, strokeDashArray: 0, strokeLineCap: "round", strokeColor: Array.isArray(p[o]) ? p[o][0] : p[o] };
      u(c.globals.seriesRangeStart[o][i], h), u(c.globals.seriesRangeEnd[o][i], ie(ie({}, h), {}, { strokeColor: Array.isArray(p[o]) ? p[o][1] : p[o] }));
    }
    return d;
  } }, { key: "drawGoalLine", value: function(e) {
    var t = e.barXPosition, n = e.barYPosition, o = e.goalX, i = e.goalY, a = e.barWidth, s = e.barHeight, c = new ee(this.barCtx.ctx), d = c.group({ className: "apexcharts-bar-goals-groups" });
    d.node.classList.add("apexcharts-element-hidden"), this.barCtx.w.globals.delayedElements.push({ el: d.node }), d.attr("clip-path", "url(#gridRectMarkerMask".concat(this.barCtx.w.globals.cuid, ")"));
    var u = null;
    return this.barCtx.isHorizontal ? Array.isArray(o) && o.forEach((function(p) {
      if (p.x >= -1 && p.x <= c.w.globals.gridWidth + 1) {
        var h = p.attrs.strokeHeight !== void 0 ? p.attrs.strokeHeight : s / 2, f = n + h + s / 2;
        u = c.drawLine(p.x, f - 2 * h, p.x, f, p.attrs.strokeColor ? p.attrs.strokeColor : void 0, p.attrs.strokeDashArray, p.attrs.strokeWidth ? p.attrs.strokeWidth : 2, p.attrs.strokeLineCap), d.add(u);
      }
    })) : Array.isArray(i) && i.forEach((function(p) {
      if (p.y >= -1 && p.y <= c.w.globals.gridHeight + 1) {
        var h = p.attrs.strokeWidth !== void 0 ? p.attrs.strokeWidth : a / 2, f = t + h + a / 2;
        u = c.drawLine(f - 2 * h, p.y, f, p.y, p.attrs.strokeColor ? p.attrs.strokeColor : void 0, p.attrs.strokeDashArray, p.attrs.strokeHeight ? p.attrs.strokeHeight : 2, p.attrs.strokeLineCap), d.add(u);
      }
    })), d;
  } }, { key: "drawBarShadow", value: function(e) {
    var t = e.prevPaths, n = e.currPaths, o = e.color, i = this.w, a = t.x, s = t.x1, c = t.barYPosition, d = n.x, u = n.x1, p = n.barYPosition, h = c + n.barHeight, f = new ee(this.barCtx.ctx), m = new $(), g = f.move(s, h) + f.line(a, h) + f.line(d, p) + f.line(u, p) + f.line(s, h) + (i.config.plotOptions.bar.borderRadiusApplication === "around" || this.arrBorderRadius[realIndex][j] === "both" ? " Z" : " z");
    return f.drawPath({ d: g, fill: m.shadeColor(0.5, $.rgb2hex(o)), stroke: "none", strokeWidth: 0, fillOpacity: 1, classes: "apexcharts-bar-shadow apexcharts-decoration-element" });
  } }, { key: "getZeroValueEncounters", value: function(e) {
    var t, n = e.i, o = e.j, i = this.w, a = 0, s = 0;
    return (i.config.plotOptions.bar.horizontal ? i.globals.series.map((function(c, d) {
      return d;
    })) : ((t = i.globals.columnSeries) === null || t === void 0 ? void 0 : t.i.map((function(c) {
      return c;
    }))) || []).forEach((function(c) {
      var d = i.globals.seriesPercent[c][o];
      d && a++, c < n && d === 0 && s++;
    })), { nonZeroColumns: a, zeroEncounters: s };
  } }, { key: "getGroupIndex", value: function(e) {
    var t = this.w, n = t.globals.seriesGroups.findIndex((function(a) {
      return a.indexOf(t.globals.seriesNames[e]) > -1;
    })), o = this.barCtx.columnGroupIndices, i = o.indexOf(n);
    return i < 0 && (o.push(n), i = o.length - 1), { groupIndex: n, columnGroupIndex: i };
  } }]), r;
})(), yo = (function() {
  function r(e, t) {
    xe(this, r), this.ctx = e, this.w = e.w;
    var n = this.w;
    this.barOptions = n.config.plotOptions.bar, this.isHorizontal = this.barOptions.horizontal, this.strokeWidth = n.config.stroke.width, this.isNullValue = !1, this.isRangeBar = n.globals.seriesRange.length && this.isHorizontal, this.isVerticalGroupedRangeBar = !n.globals.isBarHorizontal && n.globals.seriesRange.length && n.config.plotOptions.bar.rangeBarGroupRows, this.isFunnel = this.barOptions.isFunnel, this.xyRatios = t, this.xyRatios !== null && (this.xRatio = t.xRatio, this.yRatio = t.yRatio, this.invertedXRatio = t.invertedXRatio, this.invertedYRatio = t.invertedYRatio, this.baseLineY = t.baseLineY, this.baseLineInvertedY = t.baseLineInvertedY), this.yaxisIndex = 0, this.translationsIndex = 0, this.seriesLen = 0, this.pathArr = [];
    var o = new mr(this.ctx);
    this.lastActiveBarSerieIndex = o.getActiveConfigSeriesIndex("desc", ["bar", "column"]), this.columnGroupIndices = [];
    var i = o.getBarSeriesIndices(), a = new Tt(this.ctx);
    this.stackedSeriesTotals = a.getStackedSeriesTotals(this.w.config.series.map((function(s, c) {
      return i.indexOf(c) === -1 ? c : -1;
    })).filter((function(s) {
      return s !== -1;
    }))), this.barHelpers = new ZL(this);
  }
  return ve(r, [{ key: "draw", value: function(e, t) {
    var n = this.w, o = new ee(this.ctx), i = new Tt(this.ctx, n);
    e = i.getLogSeries(e), this.series = e, this.yRatio = i.getLogYRatios(this.yRatio), this.barHelpers.initVariables(e);
    var a = o.group({ class: "apexcharts-bar-series apexcharts-plot-series" });
    n.config.dataLabels.enabled && this.totalItems > this.barOptions.dataLabels.maxItems && console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering - ApexCharts");
    for (var s = 0, c = 0; s < e.length; s++, c++) {
      var d, u, p, h, f = void 0, m = void 0, g = [], b = [], x = n.globals.comboCharts ? t[s] : s, v = this.barHelpers.getGroupIndex(x).columnGroupIndex, y = o.group({ class: "apexcharts-series", rel: s + 1, seriesName: $.escapeString(n.globals.seriesNames[x]), "data:realIndex": x });
      this.ctx.series.addCollapsedClassToSeries(y, x), e[s].length > 0 && (this.visibleI = this.visibleI + 1);
      var C = 0, k = 0;
      this.yRatio.length > 1 && (this.yaxisIndex = n.globals.seriesYAxisReverseMap[x], this.translationsIndex = x);
      var T = this.translationsIndex;
      this.isReversed = n.config.yaxis[this.yaxisIndex] && n.config.yaxis[this.yaxisIndex].reversed;
      var S = this.barHelpers.initialPositions(x);
      m = S.y, C = S.barHeight, u = S.yDivision, h = S.zeroW, f = S.x, k = S.barWidth, d = S.xDivision, p = S.zeroH, this.isHorizontal || b.push(f + k / 2);
      var O = o.group({ class: "apexcharts-datalabels", "data:realIndex": x });
      n.globals.delayedElements.push({ el: O.node }), O.node.classList.add("apexcharts-element-hidden");
      var P = o.group({ class: "apexcharts-bar-goals-markers" }), M = o.group({ class: "apexcharts-bar-shadows" });
      n.globals.delayedElements.push({ el: M.node }), M.node.classList.add("apexcharts-element-hidden");
      for (var I = 0; I < e[s].length; I++) {
        var E = this.barHelpers.getStrokeWidth(s, I, x), N = null, L = { indexes: { i: s, j: I, realIndex: x, translationsIndex: T, bc: c }, x: f, y: m, strokeWidth: E, elSeries: y };
        this.isHorizontal ? (N = this.drawBarPaths(ie(ie({}, L), {}, { barHeight: C, zeroW: h, yDivision: u })), k = this.series[s][I] / this.invertedYRatio) : (N = this.drawColumnPaths(ie(ie({}, L), {}, { xDivision: d, barWidth: k, zeroH: p })), C = this.series[s][I] / this.yRatio[T]);
        var z = this.barHelpers.getPathFillColor(e, s, I, x);
        if (this.isFunnel && this.barOptions.isFunnel3d && this.pathArr.length && I > 0) {
          var F, B = this.barHelpers.drawBarShadow({ color: typeof z.color == "string" && ((F = z.color) === null || F === void 0 ? void 0 : F.indexOf("url")) === -1 ? z.color : $.hexToRgba(n.globals.colors[s]), prevPaths: this.pathArr[this.pathArr.length - 1], currPaths: N });
          M.add(B), n.config.chart.dropShadow.enabled && new zt(this.ctx).dropShadow(B, n.config.chart.dropShadow, x);
        }
        this.pathArr.push(N);
        var D = this.barHelpers.drawGoalLine({ barXPosition: N.barXPosition, barYPosition: N.barYPosition, goalX: N.goalX, goalY: N.goalY, barHeight: C, barWidth: k });
        D && P.add(D), m = N.y, f = N.x, I > 0 && b.push(f + k / 2), g.push(m), this.renderSeries(ie(ie({ realIndex: x, pathFill: z.color }, z.useRangeColor ? { lineFill: z.color } : {}), {}, { j: I, i: s, columnGroupIndex: v, pathFrom: N.pathFrom, pathTo: N.pathTo, strokeWidth: E, elSeries: y, x: f, y: m, series: e, barHeight: Math.abs(N.barHeight ? N.barHeight : C), barWidth: Math.abs(N.barWidth ? N.barWidth : k), elDataLabelsWrap: O, elGoalsMarkers: P, elBarShadows: M, visibleSeries: this.visibleI, type: "bar" }));
      }
      n.globals.seriesXvalues[x] = b, n.globals.seriesYvalues[x] = g, a.add(y);
    }
    return a;
  } }, { key: "renderSeries", value: function(e) {
    var t = e.realIndex, n = e.pathFill, o = e.lineFill, i = e.j, a = e.i, s = e.columnGroupIndex, c = e.pathFrom, d = e.pathTo, u = e.strokeWidth, p = e.elSeries, h = e.x, f = e.y, m = e.y1, g = e.y2, b = e.series, x = e.barHeight, v = e.barWidth, y = e.barXPosition, C = e.barYPosition, k = e.elDataLabelsWrap, T = e.elGoalsMarkers, S = e.elBarShadows, O = e.visibleSeries, P = e.type, M = e.classes, I = this.w, E = new ee(this.ctx), N = !1;
    if (!o) {
      var L = typeof I.globals.stroke.colors[t] == "function" ? (function(W) {
        var G, re = I.config.stroke.colors;
        return Array.isArray(re) && re.length > 0 && ((G = re[W]) || (G = ""), typeof G == "function") ? G({ value: I.globals.series[W][i], dataPointIndex: i, w: I }) : G;
      })(t) : I.globals.stroke.colors[t];
      o = this.barOptions.distributed ? I.globals.stroke.colors[i] : L;
    }
    var z = new KL(this).handleBarDataLabels({ x: h, y: f, y1: m, y2: g, i: a, j: i, series: b, realIndex: t, columnGroupIndex: s, barHeight: x, barWidth: v, barXPosition: y, barYPosition: C, visibleSeries: O });
    I.globals.isBarHorizontal || (z.dataLabelsPos.dataLabelsX + Math.max(v, I.globals.barPadForNumericAxis) < 0 || z.dataLabelsPos.dataLabelsX - Math.max(v, I.globals.barPadForNumericAxis) > I.globals.gridWidth) && (N = !0), I.config.series[a].data[i] && I.config.series[a].data[i].strokeColor && (o = I.config.series[a].data[i].strokeColor), this.isNullValue && (n = "none");
    var F = i / I.config.chart.animations.animateGradually.delay * (I.config.chart.animations.speed / I.globals.dataPoints) / 2.4;
    if (!N) {
      var B = E.renderPaths({ i: a, j: i, realIndex: t, pathFrom: c, pathTo: d, stroke: o, strokeWidth: u, strokeLineCap: I.config.stroke.lineCap, fill: n, animationDelay: F, initialSpeed: I.config.chart.animations.speed, dataChangeSpeed: I.config.chart.animations.dynamicAnimation.speed, className: "apexcharts-".concat(P, "-area ").concat(M), chartType: P });
      B.attr("clip-path", "url(#gridRectBarMask".concat(I.globals.cuid, ")"));
      var D = I.config.forecastDataPoints;
      D.count > 0 && i >= I.globals.dataPoints - D.count && (B.node.setAttribute("stroke-dasharray", D.dashArray), B.node.setAttribute("stroke-width", D.strokeWidth), B.node.setAttribute("fill-opacity", D.fillOpacity)), m !== void 0 && g !== void 0 && (B.attr("data-range-y1", m), B.attr("data-range-y2", g)), new zt(this.ctx).setSelectionFilter(B, t, i), p.add(B), B.attr({ cy: z.dataLabelsPos.bcy, cx: z.dataLabelsPos.bcx, j: i, val: I.globals.series[a][i], barHeight: x, barWidth: v }), z.dataLabels !== null && k.add(z.dataLabels), z.totalDataLabels && k.add(z.totalDataLabels), p.add(k), T && p.add(T), S && p.add(S);
    }
    return p;
  } }, { key: "drawBarPaths", value: function(e) {
    var t, n = e.indexes, o = e.barHeight, i = e.strokeWidth, a = e.zeroW, s = e.x, c = e.y, d = e.yDivision, u = e.elSeries, p = this.w, h = n.i, f = n.j;
    if (p.globals.isXNumeric) t = (c = (p.globals.seriesX[h][f] - p.globals.minX) / this.invertedXRatio - o) + o * this.visibleI;
    else if (p.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
      var m = this.barHelpers.getZeroValueEncounters({ i: h, j: f }), g = m.nonZeroColumns, b = m.zeroEncounters;
      g > 0 && (o = this.seriesLen * o / g), t = c + o * this.visibleI, t -= o * b;
    } else t = c + o * this.visibleI;
    this.isFunnel && (a -= (this.barHelpers.getXForValue(this.series[h][f], a) - a) / 2), s = this.barHelpers.getXForValue(this.series[h][f], a);
    var x = this.barHelpers.getBarpaths({ barYPosition: t, barHeight: o, x1: a, x2: s, strokeWidth: i, isReversed: this.isReversed, series: this.series, realIndex: n.realIndex, i: h, j: f, w: p });
    return p.globals.isXNumeric || (c += d), this.barHelpers.barBackground({ j: f, i: h, y1: t - o * this.visibleI, y2: o * this.seriesLen, elSeries: u }), { pathTo: x.pathTo, pathFrom: x.pathFrom, x1: a, x: s, y: c, goalX: this.barHelpers.getGoalValues("x", a, null, h, f), barYPosition: t, barHeight: o };
  } }, { key: "drawColumnPaths", value: function(e) {
    var t, n = e.indexes, o = e.x, i = e.y, a = e.xDivision, s = e.barWidth, c = e.zeroH, d = e.strokeWidth, u = e.elSeries, p = this.w, h = n.realIndex, f = n.translationsIndex, m = n.i, g = n.j, b = n.bc;
    if (p.globals.isXNumeric) {
      var x = this.getBarXForNumericXAxis({ x: o, j: g, realIndex: h, barWidth: s });
      o = x.x, t = x.barXPosition;
    } else if (p.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
      var v = this.barHelpers.getZeroValueEncounters({ i: m, j: g }), y = v.nonZeroColumns, C = v.zeroEncounters;
      y > 0 && (s = this.seriesLen * s / y), t = o + s * this.visibleI, t -= s * C;
    } else t = o + s * this.visibleI;
    i = this.barHelpers.getYForValue(this.series[m][g], c, f);
    var k = this.barHelpers.getColumnPaths({ barXPosition: t, barWidth: s, y1: c, y2: i, strokeWidth: d, isReversed: this.isReversed, series: this.series, realIndex: h, i: m, j: g, w: p });
    return p.globals.isXNumeric || (o += a), this.barHelpers.barBackground({ bc: b, j: g, i: m, x1: t - d / 2 - s * this.visibleI, x2: s * this.seriesLen + d / 2, elSeries: u }), { pathTo: k.pathTo, pathFrom: k.pathFrom, x: o, y: i, goalY: this.barHelpers.getGoalValues("y", null, c, m, g, f), barXPosition: t, barWidth: s };
  } }, { key: "getBarXForNumericXAxis", value: function(e) {
    var t = e.x, n = e.barWidth, o = e.realIndex, i = e.j, a = this.w, s = o;
    return a.globals.seriesX[o].length || (s = a.globals.maxValsInArrayIndex), $.isNumber(a.globals.seriesX[s][i]) && (t = (a.globals.seriesX[s][i] - a.globals.minX) / this.xRatio - n * this.seriesLen / 2), { barXPosition: t + n * this.visibleI, x: t };
  } }, { key: "getPreviousPath", value: function(e, t) {
    for (var n = this.w, o = "M 0 0", i = 0; i < n.globals.previousPaths.length; i++) {
      var a = n.globals.previousPaths[i];
      a.paths && a.paths.length > 0 && parseInt(a.realIndex, 10) === parseInt(e, 10) && n.globals.previousPaths[i].paths[t] !== void 0 && (o = n.globals.previousPaths[i].paths[t].d);
    }
    return o;
  } }]), r;
})(), zh = (function(r) {
  oa(t, yo);
  var e = na(t);
  function t() {
    return xe(this, t), e.apply(this, arguments);
  }
  return ve(t, [{ key: "draw", value: function(n, o) {
    var i = this, a = this.w;
    this.graphics = new ee(this.ctx), this.bar = new yo(this.ctx, this.xyRatios);
    var s = new Tt(this.ctx, a);
    n = s.getLogSeries(n), this.yRatio = s.getLogYRatios(this.yRatio), this.barHelpers.initVariables(n), a.config.chart.stackType === "100%" && (n = a.globals.comboCharts ? o.map((function(m) {
      return a.globals.seriesPercent[m];
    })) : a.globals.seriesPercent.slice()), this.series = n, this.barHelpers.initializeStackedPrevVars(this);
    for (var c = this.graphics.group({ class: "apexcharts-bar-series apexcharts-plot-series" }), d = 0, u = 0, p = function(m, g) {
      var b = void 0, x = void 0, v = void 0, y = void 0, C = a.globals.comboCharts ? o[m] : m, k = i.barHelpers.getGroupIndex(C), T = k.groupIndex, S = k.columnGroupIndex;
      i.groupCtx = i[a.globals.seriesGroups[T]];
      var O = [], P = [], M = 0;
      i.yRatio.length > 1 && (i.yaxisIndex = a.globals.seriesYAxisReverseMap[C][0], M = C), i.isReversed = a.config.yaxis[i.yaxisIndex] && a.config.yaxis[i.yaxisIndex].reversed;
      var I = i.graphics.group({ class: "apexcharts-series", seriesName: $.escapeString(a.globals.seriesNames[C]), rel: m + 1, "data:realIndex": C });
      i.ctx.series.addCollapsedClassToSeries(I, C);
      var E = i.graphics.group({ class: "apexcharts-datalabels", "data:realIndex": C }), N = i.graphics.group({ class: "apexcharts-bar-goals-markers" }), L = 0, z = 0, F = i.initialPositions(d, u, b, x, v, y, M);
      u = F.y, L = F.barHeight, x = F.yDivision, y = F.zeroW, d = F.x, z = F.barWidth, b = F.xDivision, v = F.zeroH, a.globals.barHeight = L, a.globals.barWidth = z, i.barHelpers.initializeStackedXYVars(i), i.groupCtx.prevY.length === 1 && i.groupCtx.prevY[0].every((function(pe) {
        return isNaN(pe);
      })) && (i.groupCtx.prevY[0] = i.groupCtx.prevY[0].map((function() {
        return v;
      })), i.groupCtx.prevYF[0] = i.groupCtx.prevYF[0].map((function() {
        return 0;
      })));
      for (var B = 0; B < a.globals.dataPoints; B++) {
        var D = i.barHelpers.getStrokeWidth(m, B, C), W = { indexes: { i: m, j: B, realIndex: C, translationsIndex: M, bc: g }, strokeWidth: D, x: d, y: u, elSeries: I, columnGroupIndex: S, seriesGroup: a.globals.seriesGroups[T] }, G = null;
        i.isHorizontal ? (G = i.drawStackedBarPaths(ie(ie({}, W), {}, { zeroW: y, barHeight: L, yDivision: x })), z = i.series[m][B] / i.invertedYRatio) : (G = i.drawStackedColumnPaths(ie(ie({}, W), {}, { xDivision: b, barWidth: z, zeroH: v })), L = i.series[m][B] / i.yRatio[M]);
        var re = i.barHelpers.drawGoalLine({ barXPosition: G.barXPosition, barYPosition: G.barYPosition, goalX: G.goalX, goalY: G.goalY, barHeight: L, barWidth: z });
        re && N.add(re), u = G.y, d = G.x, O.push(d), P.push(u);
        var ce = i.barHelpers.getPathFillColor(n, m, B, C), Ce = "", ne = a.globals.isBarHorizontal ? "apexcharts-flip-x" : "apexcharts-flip-y";
        (i.barHelpers.arrBorderRadius[C][B] === "bottom" && a.globals.series[C][B] > 0 || i.barHelpers.arrBorderRadius[C][B] === "top" && a.globals.series[C][B] < 0) && (Ce = ne), I = i.renderSeries(ie(ie({ realIndex: C, pathFill: ce.color }, ce.useRangeColor ? { lineFill: ce.color } : {}), {}, { j: B, i: m, columnGroupIndex: S, pathFrom: G.pathFrom, pathTo: G.pathTo, strokeWidth: D, elSeries: I, x: d, y: u, series: n, barHeight: L, barWidth: z, elDataLabelsWrap: E, elGoalsMarkers: N, type: "bar", visibleSeries: S, classes: Ce }));
      }
      a.globals.seriesXvalues[C] = O, a.globals.seriesYvalues[C] = P, i.groupCtx.prevY.push(i.groupCtx.yArrj), i.groupCtx.prevYF.push(i.groupCtx.yArrjF), i.groupCtx.prevYVal.push(i.groupCtx.yArrjVal), i.groupCtx.prevX.push(i.groupCtx.xArrj), i.groupCtx.prevXF.push(i.groupCtx.xArrjF), i.groupCtx.prevXVal.push(i.groupCtx.xArrjVal), c.add(I);
    }, h = 0, f = 0; h < n.length; h++, f++) p(h, f);
    return c;
  } }, { key: "initialPositions", value: function(n, o, i, a, s, c, d) {
    var u, p, h = this.w;
    if (this.isHorizontal) {
      a = h.globals.gridHeight / h.globals.dataPoints;
      var f = h.config.plotOptions.bar.barHeight;
      u = String(f).indexOf("%") === -1 ? parseInt(f, 10) : a * parseInt(f, 10) / 100, c = h.globals.padHorizontal + (this.isReversed ? h.globals.gridWidth - this.baseLineInvertedY : this.baseLineInvertedY), o = (a - u) / 2;
    } else {
      p = i = h.globals.gridWidth / h.globals.dataPoints;
      var m = h.config.plotOptions.bar.columnWidth;
      h.globals.isXNumeric && h.globals.dataPoints > 1 ? p = (i = h.globals.minXDiff / this.xRatio) * parseInt(this.barOptions.columnWidth, 10) / 100 : String(m).indexOf("%") === -1 ? p = parseInt(m, 10) : p *= parseInt(m, 10) / 100, s = this.isReversed ? this.baseLineY[d] : h.globals.gridHeight - this.baseLineY[d], n = h.globals.padHorizontal + (i - p) / 2;
    }
    var g = h.globals.barGroups.length || 1;
    return { x: n, y: o, yDivision: a, xDivision: i, barHeight: u / g, barWidth: p / g, zeroH: s, zeroW: c };
  } }, { key: "drawStackedBarPaths", value: function(n) {
    for (var o, i = n.indexes, a = n.barHeight, s = n.strokeWidth, c = n.zeroW, d = n.x, u = n.y, p = n.columnGroupIndex, h = n.seriesGroup, f = n.yDivision, m = n.elSeries, g = this.w, b = u + p * a, x = i.i, v = i.j, y = i.realIndex, C = i.translationsIndex, k = 0, T = 0; T < this.groupCtx.prevXF.length; T++) k += this.groupCtx.prevXF[T][v];
    var S = x;
    if (g.config.series[y].name && (S = h.indexOf(g.config.series[y].name)), S > 0) {
      var O = c;
      this.groupCtx.prevXVal[S - 1][v] < 0 ? O = this.series[x][v] >= 0 ? this.groupCtx.prevX[S - 1][v] + k - 2 * (this.isReversed ? k : 0) : this.groupCtx.prevX[S - 1][v] : this.groupCtx.prevXVal[S - 1][v] >= 0 && (O = this.series[x][v] >= 0 ? this.groupCtx.prevX[S - 1][v] : this.groupCtx.prevX[S - 1][v] - k + 2 * (this.isReversed ? k : 0)), o = O;
    } else o = c;
    d = this.series[x][v] === null ? o : o + this.series[x][v] / this.invertedYRatio - 2 * (this.isReversed ? this.series[x][v] / this.invertedYRatio : 0);
    var P = this.barHelpers.getBarpaths({ barYPosition: b, barHeight: a, x1: o, x2: d, strokeWidth: s, isReversed: this.isReversed, series: this.series, realIndex: i.realIndex, seriesGroup: h, i: x, j: v, w: g });
    return this.barHelpers.barBackground({ j: v, i: x, y1: b, y2: a, elSeries: m }), u += f, { pathTo: P.pathTo, pathFrom: P.pathFrom, goalX: this.barHelpers.getGoalValues("x", c, null, x, v, C), barXPosition: o, barYPosition: b, x: d, y: u };
  } }, { key: "drawStackedColumnPaths", value: function(n) {
    var o = n.indexes, i = n.x, a = n.y, s = n.xDivision, c = n.barWidth, d = n.zeroH, u = n.columnGroupIndex, p = n.seriesGroup, h = n.elSeries, f = this.w, m = o.i, g = o.j, b = o.bc, x = o.realIndex, v = o.translationsIndex;
    if (f.globals.isXNumeric) {
      var y = f.globals.seriesX[x][g];
      y || (y = 0), i = (y - f.globals.minX) / this.xRatio - c / 2 * f.globals.barGroups.length;
    }
    for (var C, k = i + u * c, T = 0, S = 0; S < this.groupCtx.prevYF.length; S++) T += isNaN(this.groupCtx.prevYF[S][g]) ? 0 : this.groupCtx.prevYF[S][g];
    var O = m;
    if (p && (O = p.indexOf(f.globals.seriesNames[x])), O > 0 && !f.globals.isXNumeric || O > 0 && f.globals.isXNumeric && f.globals.seriesX[x - 1][g] === f.globals.seriesX[x][g]) {
      var P, M, I, E = Math.min(this.yRatio.length + 1, x + 1);
      if (this.groupCtx.prevY[O - 1] !== void 0 && this.groupCtx.prevY[O - 1].length) for (var N = 1; N < E; N++) {
        var L;
        if (!isNaN((L = this.groupCtx.prevY[O - N]) === null || L === void 0 ? void 0 : L[g])) {
          I = this.groupCtx.prevY[O - N][g];
          break;
        }
      }
      for (var z = 1; z < E; z++) {
        var F, B;
        if (((F = this.groupCtx.prevYVal[O - z]) === null || F === void 0 ? void 0 : F[g]) < 0) {
          M = this.series[m][g] >= 0 ? I - T + 2 * (this.isReversed ? T : 0) : I;
          break;
        }
        if (((B = this.groupCtx.prevYVal[O - z]) === null || B === void 0 ? void 0 : B[g]) >= 0) {
          M = this.series[m][g] >= 0 ? I : I + T - 2 * (this.isReversed ? T : 0);
          break;
        }
      }
      M === void 0 && (M = f.globals.gridHeight), C = (P = this.groupCtx.prevYF[0]) !== null && P !== void 0 && P.every((function(W) {
        return W === 0;
      })) && this.groupCtx.prevYF.slice(1, O).every((function(W) {
        return W.every((function(G) {
          return isNaN(G);
        }));
      })) ? d : M;
    } else C = d;
    a = this.series[m][g] ? C - this.series[m][g] / this.yRatio[v] + 2 * (this.isReversed ? this.series[m][g] / this.yRatio[v] : 0) : C;
    var D = this.barHelpers.getColumnPaths({ barXPosition: k, barWidth: c, y1: C, y2: a, yRatio: this.yRatio[v], strokeWidth: this.strokeWidth, isReversed: this.isReversed, series: this.series, seriesGroup: p, realIndex: o.realIndex, i: m, j: g, w: f });
    return this.barHelpers.barBackground({ bc: b, j: g, i: m, x1: k, x2: c, elSeries: h }), { pathTo: D.pathTo, pathFrom: D.pathFrom, goalY: this.barHelpers.getGoalValues("y", null, d, m, g), barXPosition: k, x: f.globals.isXNumeric ? i : i + s, y: a };
  } }]), t;
})(), Tl = (function(r) {
  oa(t, yo);
  var e = na(t);
  function t() {
    return xe(this, t), e.apply(this, arguments);
  }
  return ve(t, [{ key: "draw", value: function(n, o, i) {
    var a = this, s = this.w, c = new ee(this.ctx), d = s.globals.comboCharts ? o : s.config.chart.type, u = new Pr(this.ctx);
    this.candlestickOptions = this.w.config.plotOptions.candlestick, this.boxOptions = this.w.config.plotOptions.boxPlot, this.isHorizontal = s.config.plotOptions.bar.horizontal, this.isOHLC = this.candlestickOptions && this.candlestickOptions.type === "ohlc";
    var p = new Tt(this.ctx, s);
    n = p.getLogSeries(n), this.series = n, this.yRatio = p.getLogYRatios(this.yRatio), this.barHelpers.initVariables(n);
    for (var h = c.group({ class: "apexcharts-".concat(d, "-series apexcharts-plot-series") }), f = function(g) {
      a.isBoxPlot = s.config.chart.type === "boxPlot" || s.config.series[g].type === "boxPlot";
      var b, x, v, y, C = void 0, k = void 0, T = [], S = [], O = s.globals.comboCharts ? i[g] : g, P = a.barHelpers.getGroupIndex(O).columnGroupIndex, M = c.group({ class: "apexcharts-series", seriesName: $.escapeString(s.globals.seriesNames[O]), rel: g + 1, "data:realIndex": O });
      a.ctx.series.addCollapsedClassToSeries(M, O), n[g].length > 0 && (a.visibleI = a.visibleI + 1);
      var I, E, N = 0;
      a.yRatio.length > 1 && (a.yaxisIndex = s.globals.seriesYAxisReverseMap[O][0], N = O);
      var L = a.barHelpers.initialPositions(O);
      k = L.y, I = L.barHeight, x = L.yDivision, y = L.zeroW, C = L.x, E = L.barWidth, b = L.xDivision, v = L.zeroH, S.push(C + E / 2);
      for (var z = c.group({ class: "apexcharts-datalabels", "data:realIndex": O }), F = c.group({ class: "apexcharts-bar-goals-markers" }), B = function(W) {
        var G = a.barHelpers.getStrokeWidth(g, W, O), re = null, ce = { indexes: { i: g, j: W, realIndex: O, translationsIndex: N }, x: C, y: k, strokeWidth: G, elSeries: M };
        re = a.isHorizontal ? a.drawHorizontalBoxPaths(ie(ie({}, ce), {}, { yDivision: x, barHeight: I, zeroW: y })) : a.drawVerticalBoxPaths(ie(ie({}, ce), {}, { xDivision: b, barWidth: E, zeroH: v })), k = re.y, C = re.x;
        var Ce = a.barHelpers.drawGoalLine({ barXPosition: re.barXPosition, barYPosition: re.barYPosition, goalX: re.goalX, goalY: re.goalY, barHeight: I, barWidth: E });
        Ce && F.add(Ce), W > 0 && S.push(C + E / 2), T.push(k), re.pathTo.forEach((function(ne, pe) {
          var K = !a.isBoxPlot && a.candlestickOptions.wick.useFillColor ? re.color[pe] : s.globals.stroke.colors[g], le = u.fillPath({ seriesNumber: O, dataPointIndex: W, color: re.color[pe], value: n[g][W] });
          a.renderSeries({ realIndex: O, pathFill: le, lineFill: K, j: W, i: g, pathFrom: re.pathFrom, pathTo: ne, strokeWidth: G, elSeries: M, x: C, y: k, series: n, columnGroupIndex: P, barHeight: I, barWidth: E, elDataLabelsWrap: z, elGoalsMarkers: F, visibleSeries: a.visibleI, type: s.config.chart.type });
        }));
      }, D = 0; D < s.globals.dataPoints; D++) B(D);
      s.globals.seriesXvalues[O] = S, s.globals.seriesYvalues[O] = T, h.add(M);
    }, m = 0; m < n.length; m++) f(m);
    return h;
  } }, { key: "drawVerticalBoxPaths", value: function(n) {
    var o = n.indexes, i = n.x;
    n.y;
    var a = n.xDivision, s = n.barWidth, c = n.zeroH, d = n.strokeWidth, u = this.w, p = new ee(this.ctx), h = o.i, f = o.j, m = u.config.plotOptions.candlestick.colors, g = this.boxOptions.colors, b = o.realIndex, x = function(D) {
      return Array.isArray(D) ? D[b] : D;
    }, v = x(m.upward), y = x(m.downward), C = this.yRatio[o.translationsIndex], k = this.getOHLCValue(b, f), T = c, S = c, O = k.o < k.c ? [v] : [y];
    this.isBoxPlot && (O = [x(g.lower), x(g.upper)]);
    var P = Math.min(k.o, k.c), M = Math.max(k.o, k.c), I = k.m;
    u.globals.isXNumeric && (i = (u.globals.seriesX[b][f] - u.globals.minX) / this.xRatio - s / 2);
    var E = i + s * this.visibleI;
    this.series[h][f] === void 0 || this.series[h][f] === null ? (P = c, M = c) : (P = c - P / C, M = c - M / C, T = c - k.h / C, S = c - k.l / C, I = c - k.m / C);
    var N = p.move(E, c), L = p.move(E + s / 2, P);
    if (u.globals.previousPaths.length > 0 && (L = this.getPreviousPath(b, f, !0)), this.isOHLC) {
      var z = E + s / 2, F = c - k.o / C, B = c - k.c / C;
      N = [p.move(z, T) + p.line(z, S) + p.move(z, F) + p.line(E, F) + p.move(z, B) + p.line(E + s, B)];
    } else N = this.isBoxPlot ? [p.move(E, P) + p.line(E + s / 2, P) + p.line(E + s / 2, T) + p.line(E + s / 4, T) + p.line(E + s - s / 4, T) + p.line(E + s / 2, T) + p.line(E + s / 2, P) + p.line(E + s, P) + p.line(E + s, I) + p.line(E, I) + p.line(E, P + d / 2), p.move(E, I) + p.line(E + s, I) + p.line(E + s, M) + p.line(E + s / 2, M) + p.line(E + s / 2, S) + p.line(E + s - s / 4, S) + p.line(E + s / 4, S) + p.line(E + s / 2, S) + p.line(E + s / 2, M) + p.line(E, M) + p.line(E, I) + "z"] : [p.move(E, M) + p.line(E + s / 2, M) + p.line(E + s / 2, T) + p.line(E + s / 2, M) + p.line(E + s, M) + p.line(E + s, P) + p.line(E + s / 2, P) + p.line(E + s / 2, S) + p.line(E + s / 2, P) + p.line(E, P) + p.line(E, M - d / 2)];
    return L += p.move(E, P), u.globals.isXNumeric || (i += a), { pathTo: N, pathFrom: L, x: i, y: M, goalY: this.barHelpers.getGoalValues("y", null, c, h, f, o.translationsIndex), barXPosition: E, color: O };
  } }, { key: "drawHorizontalBoxPaths", value: function(n) {
    var o = n.indexes;
    n.x;
    var i = n.y, a = n.yDivision, s = n.barHeight, c = n.zeroW, d = n.strokeWidth, u = this.w, p = new ee(this.ctx), h = o.i, f = o.j, m = this.boxOptions.colors.lower;
    this.isBoxPlot && (m = [this.boxOptions.colors.lower, this.boxOptions.colors.upper]);
    var g = this.invertedYRatio, b = o.realIndex, x = this.getOHLCValue(b, f), v = c, y = c, C = Math.min(x.o, x.c), k = Math.max(x.o, x.c), T = x.m;
    u.globals.isXNumeric && (i = (u.globals.seriesX[b][f] - u.globals.minX) / this.invertedXRatio - s / 2);
    var S = i + s * this.visibleI;
    this.series[h][f] === void 0 || this.series[h][f] === null ? (C = c, k = c) : (C = c + C / g, k = c + k / g, v = c + x.h / g, y = c + x.l / g, T = c + x.m / g);
    var O = p.move(c, S), P = p.move(C, S + s / 2);
    return u.globals.previousPaths.length > 0 && (P = this.getPreviousPath(b, f, !0)), O = [p.move(C, S) + p.line(C, S + s / 2) + p.line(v, S + s / 2) + p.line(v, S + s / 2 - s / 4) + p.line(v, S + s / 2 + s / 4) + p.line(v, S + s / 2) + p.line(C, S + s / 2) + p.line(C, S + s) + p.line(T, S + s) + p.line(T, S) + p.line(C + d / 2, S), p.move(T, S) + p.line(T, S + s) + p.line(k, S + s) + p.line(k, S + s / 2) + p.line(y, S + s / 2) + p.line(y, S + s - s / 4) + p.line(y, S + s / 4) + p.line(y, S + s / 2) + p.line(k, S + s / 2) + p.line(k, S) + p.line(T, S) + "z"], P += p.move(C, S), u.globals.isXNumeric || (i += a), { pathTo: O, pathFrom: P, x: k, y: i, goalX: this.barHelpers.getGoalValues("x", c, null, h, f), barYPosition: S, color: m };
  } }, { key: "getOHLCValue", value: function(n, o) {
    var i = this.w, a = new Tt(this.ctx, i), s = a.getLogValAtSeriesIndex(i.globals.seriesCandleH[n][o], n), c = a.getLogValAtSeriesIndex(i.globals.seriesCandleO[n][o], n), d = a.getLogValAtSeriesIndex(i.globals.seriesCandleM[n][o], n), u = a.getLogValAtSeriesIndex(i.globals.seriesCandleC[n][o], n), p = a.getLogValAtSeriesIndex(i.globals.seriesCandleL[n][o], n);
    return { o: this.isBoxPlot ? s : c, h: this.isBoxPlot ? c : s, m: d, l: this.isBoxPlot ? u : p, c: this.isBoxPlot ? p : u };
  } }]), t;
})(), Km = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "checkColorRange", value: function() {
    var e = this.w, t = !1, n = e.config.plotOptions[e.config.chart.type];
    return n.colorScale.ranges.length > 0 && n.colorScale.ranges.map((function(o, i) {
      o.from <= 0 && (t = !0);
    })), t;
  } }, { key: "getShadeColor", value: function(e, t, n, o) {
    var i = this.w, a = 1, s = i.config.plotOptions[e].shadeIntensity, c = this.determineColor(e, t, n);
    i.globals.hasNegs || o ? a = i.config.plotOptions[e].reverseNegativeShade ? c.percent < 0 ? c.percent / 100 * (1.25 * s) : (1 - c.percent / 100) * (1.25 * s) : c.percent <= 0 ? 1 - (1 + c.percent / 100) * s : (1 - c.percent / 100) * s : (a = 1 - c.percent / 100, e === "treemap" && (a = (1 - c.percent / 100) * (1.25 * s)));
    var d = c.color, u = new $();
    if (i.config.plotOptions[e].enableShades) if (this.w.config.theme.mode === "dark") {
      var p = u.shadeColor(-1 * a, c.color);
      d = $.hexToRgba($.isColorHex(p) ? p : $.rgb2hex(p), i.config.fill.opacity);
    } else {
      var h = u.shadeColor(a, c.color);
      d = $.hexToRgba($.isColorHex(h) ? h : $.rgb2hex(h), i.config.fill.opacity);
    }
    return { color: d, colorProps: c };
  } }, { key: "determineColor", value: function(e, t, n) {
    var o = this.w, i = o.globals.series[t][n], a = o.config.plotOptions[e], s = a.colorScale.inverse ? n : t;
    a.distributed && o.config.chart.type === "treemap" && (s = n);
    var c = o.globals.colors[s], d = null, u = Math.min.apply(Math, Mt(o.globals.series[t])), p = Math.max.apply(Math, Mt(o.globals.series[t]));
    a.distributed || e !== "heatmap" || (u = o.globals.minY, p = o.globals.maxY), a.colorScale.min !== void 0 && (u = a.colorScale.min < o.globals.minY ? a.colorScale.min : o.globals.minY, p = a.colorScale.max > o.globals.maxY ? a.colorScale.max : o.globals.maxY);
    var h = Math.abs(p) + Math.abs(u), f = 100 * i / (h === 0 ? h - 1e-6 : h);
    return a.colorScale.ranges.length > 0 && a.colorScale.ranges.map((function(m, g) {
      if (i >= m.from && i <= m.to) {
        c = m.color, d = m.foreColor ? m.foreColor : null, u = m.from, p = m.to;
        var b = Math.abs(p) + Math.abs(u);
        f = 100 * i / (b === 0 ? b - 1e-6 : b);
      }
    })), { color: c, foreColor: d, percent: f };
  } }, { key: "calculateDataLabels", value: function(e) {
    var t = e.text, n = e.x, o = e.y, i = e.i, a = e.j, s = e.colorProps, c = e.fontSize, d = this.w.config.dataLabels, u = new ee(this.ctx), p = new vo(this.ctx), h = null;
    if (d.enabled) {
      h = u.group({ class: "apexcharts-data-labels" });
      var f = d.offsetX, m = d.offsetY, g = n + f, b = o + parseFloat(d.style.fontSize) / 3 + m;
      p.plotDataLabelsText({ x: g, y: b, text: t, i, j: a, color: s.foreColor, parent: h, fontSize: c, dataLabelsConfig: d });
    }
    return h;
  } }, { key: "addListeners", value: function(e) {
    var t = new ee(this.ctx);
    e.node.addEventListener("mouseenter", t.pathMouseEnter.bind(this, e)), e.node.addEventListener("mouseleave", t.pathMouseLeave.bind(this, e)), e.node.addEventListener("mousedown", t.pathMouseDown.bind(this, e));
  } }]), r;
})(), JL = (function() {
  function r(e, t) {
    xe(this, r), this.ctx = e, this.w = e.w, this.xRatio = t.xRatio, this.yRatio = t.yRatio, this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.helpers = new Km(e), this.rectRadius = this.w.config.plotOptions.heatmap.radius, this.strokeWidth = this.w.config.stroke.show ? this.w.config.stroke.width : 0;
  }
  return ve(r, [{ key: "draw", value: function(e) {
    var t = this.w, n = new ee(this.ctx), o = n.group({ class: "apexcharts-heatmap" });
    o.attr("clip-path", "url(#gridRectMask".concat(t.globals.cuid, ")"));
    var i = t.globals.gridWidth / t.globals.dataPoints, a = t.globals.gridHeight / t.globals.series.length, s = 0, c = !1;
    this.negRange = this.helpers.checkColorRange();
    var d = e.slice();
    t.config.yaxis[0].reversed && (c = !0, d.reverse());
    for (var u = c ? 0 : d.length - 1; c ? u < d.length : u >= 0; c ? u++ : u--) {
      var p = n.group({ class: "apexcharts-series apexcharts-heatmap-series", seriesName: $.escapeString(t.globals.seriesNames[u]), rel: u + 1, "data:realIndex": u });
      if (this.ctx.series.addCollapsedClassToSeries(p, u), t.config.chart.dropShadow.enabled) {
        var h = t.config.chart.dropShadow;
        new zt(this.ctx).dropShadow(p, h, u);
      }
      for (var f = 0, m = t.config.plotOptions.heatmap.shadeIntensity, g = 0, b = 0; b < t.globals.dataPoints; b++) if (t.globals.seriesX.length && !t.globals.allSeriesHasEqualX && t.globals.minX + t.globals.minXDiff * b < t.globals.seriesX[u][g]) f += i;
      else {
        if (g >= d[u].length) break;
        var x = this.helpers.getShadeColor(t.config.chart.type, u, g, this.negRange), v = x.color, y = x.colorProps;
        t.config.fill.type === "image" && (v = new Pr(this.ctx).fillPath({ seriesNumber: u, dataPointIndex: g, opacity: t.globals.hasNegs ? y.percent < 0 ? 1 - (1 + y.percent / 100) : m + y.percent / 100 : y.percent / 100, patternID: $.randomId(), width: t.config.fill.image.width ? t.config.fill.image.width : i, height: t.config.fill.image.height ? t.config.fill.image.height : a }));
        var C = this.rectRadius, k = n.drawRect(f, s, i, a, C);
        if (k.attr({ cx: f, cy: s }), k.node.classList.add("apexcharts-heatmap-rect"), p.add(k), k.attr({ fill: v, i: u, index: u, j: g, val: e[u][g], "stroke-width": this.strokeWidth, stroke: t.config.plotOptions.heatmap.useFillColorAsStroke ? v : t.globals.stroke.colors[0], color: v }), this.helpers.addListeners(k), t.config.chart.animations.enabled && !t.globals.dataChanged) {
          var T = 1;
          t.globals.resized || (T = t.config.chart.animations.speed), this.animateHeatMap(k, f, s, i, a, T);
        }
        if (t.globals.dataChanged) {
          var S = 1;
          if (this.dynamicAnim.enabled && t.globals.shouldAnimate) {
            S = this.dynamicAnim.speed;
            var O = t.globals.previousPaths[u] && t.globals.previousPaths[u][g] && t.globals.previousPaths[u][g].color;
            O || (O = "rgba(255, 255, 255, 0)"), this.animateHeatColor(k, $.isColorHex(O) ? O : $.rgb2hex(O), $.isColorHex(v) ? v : $.rgb2hex(v), S);
          }
        }
        var P = (0, t.config.dataLabels.formatter)(t.globals.series[u][g], { value: t.globals.series[u][g], seriesIndex: u, dataPointIndex: g, w: t }), M = this.helpers.calculateDataLabels({ text: P, x: f + i / 2, y: s + a / 2, i: u, j: g, colorProps: y, series: d });
        M !== null && p.add(M), f += i, g++;
      }
      s += a, o.add(p);
    }
    var I = t.globals.yAxisScale[0].result.slice();
    return t.config.yaxis[0].reversed ? I.unshift("") : I.push(""), t.globals.yAxisScale[0].result = I, o;
  } }, { key: "animateHeatMap", value: function(e, t, n, o, i, a) {
    var s = new Ro(this.ctx);
    s.animateRect(e, { x: t + o / 2, y: n + i / 2, width: 0, height: 0 }, { x: t, y: n, width: o, height: i }, a, (function() {
      s.animationCompleted(e);
    }));
  } }, { key: "animateHeatColor", value: function(e, t, n, o) {
    e.attr({ fill: t }).animate(o).attr({ fill: n });
  } }]), r;
})(), Zm = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "drawYAxisTexts", value: function(e, t, n, o) {
    var i = this.w, a = i.config.yaxis[0], s = i.globals.yLabelFormatters[0];
    return new ee(this.ctx).drawText({ x: e + a.labels.offsetX, y: t + a.labels.offsetY, text: s(o, n), textAnchor: "middle", fontSize: a.labels.style.fontSize, fontFamily: a.labels.style.fontFamily, foreColor: Array.isArray(a.labels.style.colors) ? a.labels.style.colors[n] : a.labels.style.colors });
  } }]), r;
})(), Jm = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
    var t = this.w;
    this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animBeginArr = [0], this.animDur = 0, this.donutDataLabels = this.w.config.plotOptions.pie.donut.labels, this.lineColorArr = t.globals.stroke.colors !== void 0 ? t.globals.stroke.colors : t.globals.colors, this.defaultSize = Math.min(t.globals.gridWidth, t.globals.gridHeight), this.centerY = this.defaultSize / 2, this.centerX = t.globals.gridWidth / 2, t.config.chart.type === "radialBar" ? this.fullAngle = 360 : this.fullAngle = Math.abs(t.config.plotOptions.pie.endAngle - t.config.plotOptions.pie.startAngle), this.initialAngle = t.config.plotOptions.pie.startAngle % this.fullAngle, t.globals.radialSize = this.defaultSize / 2.05 - t.config.stroke.width - (t.config.chart.sparkline.enabled ? 0 : t.config.chart.dropShadow.blur), this.donutSize = t.globals.radialSize * parseInt(t.config.plotOptions.pie.donut.size, 10) / 100;
    var n = t.config.plotOptions.pie.customScale, o = t.globals.gridWidth / 2, i = t.globals.gridHeight / 2;
    this.translateX = o - o * n, this.translateY = i - i * n, this.dataLabelsGroup = new ee(this.ctx).group({ class: "apexcharts-datalabels-group", transform: "translate(".concat(this.translateX, ", ").concat(this.translateY, ") scale(").concat(n, ")") }), this.maxY = 0, this.sliceLabels = [], this.sliceSizes = [], this.prevSectorAngleArr = [];
  }
  return ve(r, [{ key: "draw", value: function(e) {
    var t = this, n = this.w, o = new ee(this.ctx), i = o.group({ class: "apexcharts-pie" });
    if (n.globals.noData) return i;
    for (var a = 0, s = 0; s < e.length; s++) a += $.negToZero(e[s]);
    var c = [], d = o.group();
    a === 0 && (a = 1e-5), e.forEach((function(y) {
      t.maxY = Math.max(t.maxY, y);
    })), n.config.yaxis[0].max && (this.maxY = n.config.yaxis[0].max), n.config.grid.position === "back" && this.chartType === "polarArea" && this.drawPolarElements(i);
    for (var u = 0; u < e.length; u++) {
      var p = this.fullAngle * $.negToZero(e[u]) / a;
      c.push(p), this.chartType === "polarArea" ? (c[u] = this.fullAngle / e.length, this.sliceSizes.push(n.globals.radialSize * e[u] / this.maxY)) : this.sliceSizes.push(n.globals.radialSize);
    }
    if (n.globals.dataChanged) {
      for (var h, f = 0, m = 0; m < n.globals.previousPaths.length; m++) f += $.negToZero(n.globals.previousPaths[m]);
      for (var g = 0; g < n.globals.previousPaths.length; g++) h = this.fullAngle * $.negToZero(n.globals.previousPaths[g]) / f, this.prevSectorAngleArr.push(h);
    }
    if (this.donutSize < 0 && (this.donutSize = 0), this.chartType === "donut") {
      var b = o.drawCircle(this.donutSize);
      b.attr({ cx: this.centerX, cy: this.centerY, fill: n.config.plotOptions.pie.donut.background ? n.config.plotOptions.pie.donut.background : "transparent" }), d.add(b);
    }
    var x = this.drawArcs(c, e);
    if (this.sliceLabels.forEach((function(y) {
      x.add(y);
    })), d.attr({ transform: "translate(".concat(this.translateX, ", ").concat(this.translateY, ") scale(").concat(n.config.plotOptions.pie.customScale, ")") }), d.add(x), i.add(d), this.donutDataLabels.show) {
      var v = this.renderInnerDataLabels(this.dataLabelsGroup, this.donutDataLabels, { hollowSize: this.donutSize, centerX: this.centerX, centerY: this.centerY, opacity: this.donutDataLabels.show });
      i.add(v);
    }
    return n.config.grid.position === "front" && this.chartType === "polarArea" && this.drawPolarElements(i), i;
  } }, { key: "drawArcs", value: function(e, t) {
    var n = this.w, o = new zt(this.ctx), i = new ee(this.ctx), a = new Pr(this.ctx), s = i.group({ class: "apexcharts-slices" }), c = this.initialAngle, d = this.initialAngle, u = this.initialAngle, p = this.initialAngle;
    this.strokeWidth = n.config.stroke.show ? n.config.stroke.width : 0;
    for (var h = 0; h < e.length; h++) {
      var f = i.group({ class: "apexcharts-series apexcharts-pie-series", seriesName: $.escapeString(n.globals.seriesNames[h]), rel: h + 1, "data:realIndex": h });
      s.add(f), d = p, u = (c = u) + e[h], p = d + this.prevSectorAngleArr[h];
      var m = u < c ? this.fullAngle + u - c : u - c, g = a.fillPath({ seriesNumber: h, size: this.sliceSizes[h], value: t[h] }), b = this.getChangedPath(d, p), x = i.drawPath({ d: b, stroke: Array.isArray(this.lineColorArr) ? this.lineColorArr[h] : this.lineColorArr, strokeWidth: 0, fill: g, fillOpacity: n.config.fill.opacity, classes: "apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(h) });
      if (x.attr({ index: 0, j: h }), o.setSelectionFilter(x, 0, h), n.config.chart.dropShadow.enabled) {
        var v = n.config.chart.dropShadow;
        o.dropShadow(x, v, h);
      }
      this.addListeners(x, this.donutDataLabels), ee.setAttrs(x.node, { "data:angle": m, "data:startAngle": c, "data:strokeWidth": this.strokeWidth, "data:value": t[h] });
      var y = { x: 0, y: 0 };
      this.chartType === "pie" || this.chartType === "polarArea" ? y = $.polarToCartesian(this.centerX, this.centerY, n.globals.radialSize / 1.25 + n.config.plotOptions.pie.dataLabels.offset, (c + m / 2) % this.fullAngle) : this.chartType === "donut" && (y = $.polarToCartesian(this.centerX, this.centerY, (n.globals.radialSize + this.donutSize) / 2 + n.config.plotOptions.pie.dataLabels.offset, (c + m / 2) % this.fullAngle)), f.add(x);
      var C = 0;
      if (!this.initialAnim || n.globals.resized || n.globals.dataChanged ? this.animBeginArr.push(0) : ((C = m / this.fullAngle * n.config.chart.animations.speed) === 0 && (C = 1), this.animDur = C + this.animDur, this.animBeginArr.push(this.animDur)), this.dynamicAnim && n.globals.dataChanged ? this.animatePaths(x, { size: this.sliceSizes[h], endAngle: u, startAngle: c, prevStartAngle: d, prevEndAngle: p, animateStartingPos: !0, i: h, animBeginArr: this.animBeginArr, shouldSetPrevPaths: !0, dur: n.config.chart.animations.dynamicAnimation.speed }) : this.animatePaths(x, { size: this.sliceSizes[h], endAngle: u, startAngle: c, i: h, totalItems: e.length - 1, animBeginArr: this.animBeginArr, dur: C }), n.config.plotOptions.pie.expandOnClick && this.chartType !== "polarArea" && x.node.addEventListener("mouseup", this.pieClicked.bind(this, h)), n.globals.selectedDataPoints[0] !== void 0 && n.globals.selectedDataPoints[0].indexOf(h) > -1 && this.pieClicked(h), n.config.dataLabels.enabled) {
        var k = y.x, T = y.y, S = 100 * m / this.fullAngle + "%";
        if (m !== 0 && n.config.plotOptions.pie.dataLabels.minAngleToShowLabel < e[h]) {
          var O = n.config.dataLabels.formatter;
          O !== void 0 && (S = O(n.globals.seriesPercent[h][0], { seriesIndex: h, w: n }));
          var P = n.globals.dataLabels.style.colors[h], M = i.group({ class: "apexcharts-datalabels" }), I = i.drawText({ x: k, y: T, text: S, textAnchor: "middle", fontSize: n.config.dataLabels.style.fontSize, fontFamily: n.config.dataLabels.style.fontFamily, fontWeight: n.config.dataLabels.style.fontWeight, foreColor: P });
          if (M.add(I), n.config.dataLabels.dropShadow.enabled) {
            var E = n.config.dataLabels.dropShadow;
            o.dropShadow(I, E);
          }
          I.node.classList.add("apexcharts-pie-label"), n.config.chart.animations.animate && n.globals.resized === !1 && (I.node.classList.add("apexcharts-pie-label-delay"), I.node.style.animationDelay = n.config.chart.animations.speed / 940 + "s"), this.sliceLabels.push(M);
        }
      }
    }
    return s;
  } }, { key: "addListeners", value: function(e, t) {
    var n = new ee(this.ctx);
    e.node.addEventListener("mouseenter", n.pathMouseEnter.bind(this, e)), e.node.addEventListener("mouseleave", n.pathMouseLeave.bind(this, e)), e.node.addEventListener("mouseleave", this.revertDataLabelsInner.bind(this, e.node, t)), e.node.addEventListener("mousedown", n.pathMouseDown.bind(this, e)), this.donutDataLabels.total.showAlways || (e.node.addEventListener("mouseenter", this.printDataLabelsInner.bind(this, e.node, t)), e.node.addEventListener("mousedown", this.printDataLabelsInner.bind(this, e.node, t)));
  } }, { key: "animatePaths", value: function(e, t) {
    var n = this.w, o = t.endAngle < t.startAngle ? this.fullAngle + t.endAngle - t.startAngle : t.endAngle - t.startAngle, i = o, a = t.startAngle, s = t.startAngle;
    t.prevStartAngle !== void 0 && t.prevEndAngle !== void 0 && (a = t.prevEndAngle, i = t.prevEndAngle < t.prevStartAngle ? this.fullAngle + t.prevEndAngle - t.prevStartAngle : t.prevEndAngle - t.prevStartAngle), t.i === n.config.series.length - 1 && (o + s > this.fullAngle ? t.endAngle = t.endAngle - (o + s) : o + s < this.fullAngle && (t.endAngle = t.endAngle + (this.fullAngle - (o + s)))), o === this.fullAngle && (o = this.fullAngle - 0.01), this.animateArc(e, a, s, o, i, t);
  } }, { key: "animateArc", value: function(e, t, n, o, i, a) {
    var s, c = this, d = this.w, u = new Ro(this.ctx), p = a.size;
    (isNaN(t) || isNaN(i)) && (t = n, i = o, a.dur = 0);
    var h = o, f = n, m = t < n ? this.fullAngle + t - n : t - n;
    d.globals.dataChanged && a.shouldSetPrevPaths && a.prevEndAngle && (s = c.getPiePath({ me: c, startAngle: a.prevStartAngle, angle: a.prevEndAngle < a.prevStartAngle ? this.fullAngle + a.prevEndAngle - a.prevStartAngle : a.prevEndAngle - a.prevStartAngle, size: p }), e.attr({ d: s })), a.dur !== 0 ? e.animate(a.dur, a.animBeginArr[a.i]).after((function() {
      c.chartType !== "pie" && c.chartType !== "donut" && c.chartType !== "polarArea" || this.animate(d.config.chart.animations.dynamicAnimation.speed).attr({ "stroke-width": c.strokeWidth }), a.i === d.config.series.length - 1 && u.animationCompleted(e);
    })).during((function(g) {
      h = m + (o - m) * g, a.animateStartingPos && (h = i + (o - i) * g, f = t - i + (n - (t - i)) * g), s = c.getPiePath({ me: c, startAngle: f, angle: h, size: p }), e.node.setAttribute("data:pathOrig", s), e.attr({ d: s });
    })) : (s = c.getPiePath({ me: c, startAngle: f, angle: o, size: p }), a.isTrack || (d.globals.animationEnded = !0), e.node.setAttribute("data:pathOrig", s), e.attr({ d: s, "stroke-width": c.strokeWidth }));
  } }, { key: "pieClicked", value: function(e) {
    var t, n = this.w, o = this, i = o.sliceSizes[e] + (n.config.plotOptions.pie.expandOnClick ? 4 : 0), a = n.globals.dom.Paper.findOne(".apexcharts-".concat(o.chartType.toLowerCase(), "-slice-").concat(e));
    if (a.attr("data:pieClicked") !== "true") {
      var s = n.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");
      Array.prototype.forEach.call(s, (function(p) {
        p.setAttribute("data:pieClicked", "false");
        var h = p.getAttribute("data:pathOrig");
        h && p.setAttribute("d", h);
      })), n.globals.capturedDataPointIndex = e, a.attr("data:pieClicked", "true");
      var c = parseInt(a.attr("data:startAngle"), 10), d = parseInt(a.attr("data:angle"), 10);
      t = o.getPiePath({ me: o, startAngle: c, angle: d, size: i }), d !== 360 && a.plot(t);
    } else {
      a.attr({ "data:pieClicked": "false" }), this.revertDataLabelsInner(a.node, this.donutDataLabels);
      var u = a.attr("data:pathOrig");
      a.attr({ d: u });
    }
  } }, { key: "getChangedPath", value: function(e, t) {
    var n = "";
    return this.dynamicAnim && this.w.globals.dataChanged && (n = this.getPiePath({ me: this, startAngle: e, angle: t - e, size: this.size })), n;
  } }, { key: "getPiePath", value: function(e) {
    var t, n = e.me, o = e.startAngle, i = e.angle, a = e.size, s = new ee(this.ctx), c = o, d = Math.PI * (c - 90) / 180, u = i + o;
    Math.ceil(u) >= this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle && (u = this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle - 0.01), Math.ceil(u) > this.fullAngle && (u -= this.fullAngle);
    var p = Math.PI * (u - 90) / 180, h = n.centerX + a * Math.cos(d), f = n.centerY + a * Math.sin(d), m = n.centerX + a * Math.cos(p), g = n.centerY + a * Math.sin(p), b = $.polarToCartesian(n.centerX, n.centerY, n.donutSize, u), x = $.polarToCartesian(n.centerX, n.centerY, n.donutSize, c), v = i > 180 ? 1 : 0, y = ["M", h, f, "A", a, a, 0, v, 1, m, g];
    return t = n.chartType === "donut" ? [].concat(y, ["L", b.x, b.y, "A", n.donutSize, n.donutSize, 0, v, 0, x.x, x.y, "L", h, f, "z"]).join(" ") : n.chartType === "pie" || n.chartType === "polarArea" ? [].concat(y, ["L", n.centerX, n.centerY, "L", h, f]).join(" ") : [].concat(y).join(" "), s.roundPathCorners(t, 2 * this.strokeWidth);
  } }, { key: "drawPolarElements", value: function(e) {
    var t = this.w, n = new Xm(this.ctx), o = new ee(this.ctx), i = new Zm(this.ctx), a = o.group(), s = o.group(), c = n.niceScale(0, Math.ceil(this.maxY), 0), d = c.result.reverse(), u = c.result.length;
    this.maxY = c.niceMax;
    for (var p = t.globals.radialSize, h = p / (u - 1), f = 0; f < u - 1; f++) {
      var m = o.drawCircle(p);
      if (m.attr({ cx: this.centerX, cy: this.centerY, fill: "none", "stroke-width": t.config.plotOptions.polarArea.rings.strokeWidth, stroke: t.config.plotOptions.polarArea.rings.strokeColor }), t.config.yaxis[0].show) {
        var g = i.drawYAxisTexts(this.centerX, this.centerY - p + parseInt(t.config.yaxis[0].labels.style.fontSize, 10) / 2, f, d[f]);
        s.add(g);
      }
      a.add(m), p -= h;
    }
    this.drawSpokes(e), e.add(a), e.add(s);
  } }, { key: "renderInnerDataLabels", value: function(e, t, n) {
    var o = this.w, i = new ee(this.ctx), a = t.total.show;
    e.node.innerHTML = "", e.node.style.opacity = n.opacity;
    var s, c, d = n.centerX, u = this.donutDataLabels.total.label ? n.centerY : n.centerY - n.centerY / 6;
    s = t.name.color === void 0 ? o.globals.colors[0] : t.name.color;
    var p = t.name.fontSize, h = t.name.fontFamily, f = t.name.fontWeight;
    c = t.value.color === void 0 ? o.config.chart.foreColor : t.value.color;
    var m = t.value.formatter, g = "", b = "";
    if (a ? (s = t.total.color, p = t.total.fontSize, h = t.total.fontFamily, f = t.total.fontWeight, b = this.donutDataLabels.total.label ? t.total.label : "", g = t.total.formatter(o)) : o.globals.series.length === 1 && (g = m(o.globals.series[0], o), b = o.globals.seriesNames[0]), b && (b = t.name.formatter(b, t.total.show, o)), t.name.show) {
      var x = i.drawText({ x: d, y: u + parseFloat(t.name.offsetY), text: b, textAnchor: "middle", foreColor: s, fontSize: p, fontWeight: f, fontFamily: h });
      x.node.classList.add("apexcharts-datalabel-label"), e.add(x);
    }
    if (t.value.show) {
      var v = t.name.show ? parseFloat(t.value.offsetY) + 16 : t.value.offsetY, y = i.drawText({ x: d, y: u + v, text: g, textAnchor: "middle", foreColor: c, fontWeight: t.value.fontWeight, fontSize: t.value.fontSize, fontFamily: t.value.fontFamily });
      y.node.classList.add("apexcharts-datalabel-value"), e.add(y);
    }
    return e;
  } }, { key: "printInnerLabels", value: function(e, t, n, o) {
    var i, a = this.w;
    o ? i = e.name.color === void 0 ? a.globals.colors[parseInt(o.parentNode.getAttribute("rel"), 10) - 1] : e.name.color : a.globals.series.length > 1 && e.total.show && (i = e.total.color);
    var s = a.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"), c = a.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");
    n = (0, e.value.formatter)(n, a), o || typeof e.total.formatter != "function" || (n = e.total.formatter(a));
    var d = t === e.total.label;
    t = this.donutDataLabels.total.label ? e.name.formatter(t, d, a) : "", s !== null && (s.textContent = t), c !== null && (c.textContent = n), s !== null && (s.style.fill = i);
  } }, { key: "printDataLabelsInner", value: function(e, t) {
    var n = this.w, o = e.getAttribute("data:value"), i = n.globals.seriesNames[parseInt(e.parentNode.getAttribute("rel"), 10) - 1];
    n.globals.series.length > 1 && this.printInnerLabels(t, i, o, e);
    var a = n.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");
    a !== null && (a.style.opacity = 1);
  } }, { key: "drawSpokes", value: function(e) {
    var t = this, n = this.w, o = new ee(this.ctx), i = n.config.plotOptions.polarArea.spokes;
    if (i.strokeWidth !== 0) {
      for (var a = [], s = 360 / n.globals.series.length, c = 0; c < n.globals.series.length; c++) a.push($.polarToCartesian(this.centerX, this.centerY, n.globals.radialSize, n.config.plotOptions.pie.startAngle + s * c));
      a.forEach((function(d, u) {
        var p = o.drawLine(d.x, d.y, t.centerX, t.centerY, Array.isArray(i.connectorColors) ? i.connectorColors[u] : i.connectorColors);
        e.add(p);
      }));
    }
  } }, { key: "revertDataLabelsInner", value: function() {
    var e = this.w;
    if (this.donutDataLabels.show) {
      var t = e.globals.dom.Paper.findOne(".apexcharts-datalabels-group"), n = this.renderInnerDataLabels(t, this.donutDataLabels, { hollowSize: this.donutSize, centerX: this.centerX, centerY: this.centerY, opacity: this.donutDataLabels.show });
      e.globals.dom.Paper.findOne(".apexcharts-radialbar, .apexcharts-pie").add(n);
    }
  } }]), r;
})(), QL = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animDur = 0;
    var t = this.w;
    this.graphics = new ee(this.ctx), this.lineColorArr = t.globals.stroke.colors !== void 0 ? t.globals.stroke.colors : t.globals.colors, this.defaultSize = t.globals.svgHeight < t.globals.svgWidth ? t.globals.gridHeight : t.globals.gridWidth, this.isLog = t.config.yaxis[0].logarithmic, this.logBase = t.config.yaxis[0].logBase, this.coreUtils = new Tt(this.ctx), this.maxValue = this.isLog ? this.coreUtils.getLogVal(this.logBase, t.globals.maxY, 0) : t.globals.maxY, this.minValue = this.isLog ? this.coreUtils.getLogVal(this.logBase, this.w.globals.minY, 0) : t.globals.minY, this.polygons = t.config.plotOptions.radar.polygons, this.strokeWidth = t.config.stroke.show ? t.config.stroke.width : 0, this.size = this.defaultSize / 2.1 - this.strokeWidth - t.config.chart.dropShadow.blur, t.config.xaxis.labels.show && (this.size = this.size - t.globals.xAxisLabelsWidth / 1.75), t.config.plotOptions.radar.size !== void 0 && (this.size = t.config.plotOptions.radar.size), this.dataRadiusOfPercent = [], this.dataRadius = [], this.angleArr = [], this.yaxisLabelsTextsPos = [];
  }
  return ve(r, [{ key: "draw", value: function(e) {
    var t = this, n = this.w, o = new Pr(this.ctx), i = [], a = new vo(this.ctx);
    e.length && (this.dataPointsLen = e[n.globals.maxValsInArrayIndex].length), this.disAngle = 2 * Math.PI / this.dataPointsLen;
    var s = n.globals.gridWidth / 2, c = n.globals.gridHeight / 2, d = s + n.config.plotOptions.radar.offsetX, u = c + n.config.plotOptions.radar.offsetY, p = this.graphics.group({ class: "apexcharts-radar-series apexcharts-plot-series", transform: "translate(".concat(d || 0, ", ").concat(u || 0, ")") }), h = [], f = null, m = null;
    if (this.yaxisLabels = this.graphics.group({ class: "apexcharts-yaxis" }), e.forEach((function(b, x) {
      var v = b.length === n.globals.dataPoints, y = t.graphics.group().attr({ class: "apexcharts-series", "data:longestSeries": v, seriesName: $.escapeString(n.globals.seriesNames[x]), rel: x + 1, "data:realIndex": x });
      t.dataRadiusOfPercent[x] = [], t.dataRadius[x] = [], t.angleArr[x] = [], b.forEach((function(N, L) {
        var z = Math.abs(t.maxValue - t.minValue);
        N -= t.minValue, t.isLog && (N = t.coreUtils.getLogVal(t.logBase, N, 0)), t.dataRadiusOfPercent[x][L] = N / z, t.dataRadius[x][L] = t.dataRadiusOfPercent[x][L] * t.size, t.angleArr[x][L] = L * t.disAngle;
      })), h = t.getDataPointsPos(t.dataRadius[x], t.angleArr[x]);
      var C = t.createPaths(h, { x: 0, y: 0 });
      f = t.graphics.group({ class: "apexcharts-series-markers-wrap apexcharts-element-hidden" }), m = t.graphics.group({ class: "apexcharts-datalabels", "data:realIndex": x }), n.globals.delayedElements.push({ el: f.node, index: x });
      var k = { i: x, realIndex: x, animationDelay: x, initialSpeed: n.config.chart.animations.speed, dataChangeSpeed: n.config.chart.animations.dynamicAnimation.speed, className: "apexcharts-radar", shouldClipToGrid: !1, bindEventsOnPaths: !1, stroke: n.globals.stroke.colors[x], strokeLineCap: n.config.stroke.lineCap }, T = null;
      n.globals.previousPaths.length > 0 && (T = t.getPreviousPath(x));
      for (var S = 0; S < C.linePathsTo.length; S++) {
        var O = t.graphics.renderPaths(ie(ie({}, k), {}, { pathFrom: T === null ? C.linePathsFrom[S] : T, pathTo: C.linePathsTo[S], strokeWidth: Array.isArray(t.strokeWidth) ? t.strokeWidth[x] : t.strokeWidth, fill: "none", drawShadow: !1 }));
        y.add(O);
        var P = o.fillPath({ seriesNumber: x }), M = t.graphics.renderPaths(ie(ie({}, k), {}, { pathFrom: T === null ? C.areaPathsFrom[S] : T, pathTo: C.areaPathsTo[S], strokeWidth: 0, fill: P, drawShadow: !1 }));
        if (n.config.chart.dropShadow.enabled) {
          var I = new zt(t.ctx), E = n.config.chart.dropShadow;
          I.dropShadow(M, Object.assign({}, E, { noUserSpaceOnUse: !0 }), x);
        }
        y.add(M);
      }
      b.forEach((function(N, L) {
        var z = new Io(t.ctx).getMarkerConfig({ cssClass: "apexcharts-marker", seriesIndex: x, dataPointIndex: L }), F = t.graphics.drawMarker(h[L].x, h[L].y, z);
        F.attr("rel", L), F.attr("j", L), F.attr("index", x), F.node.setAttribute("default-marker-size", z.pSize);
        var B = t.graphics.group({ class: "apexcharts-series-markers" });
        B && B.add(F), f.add(B), y.add(f);
        var D = n.config.dataLabels;
        if (D.enabled) {
          var W = D.formatter(n.globals.series[x][L], { seriesIndex: x, dataPointIndex: L, w: n });
          a.plotDataLabelsText({ x: h[L].x, y: h[L].y, text: W, textAnchor: "middle", i: x, j: x, parent: m, offsetCorrection: !1, dataLabelsConfig: ie({}, D) });
        }
        y.add(m);
      })), i.push(y);
    })), this.drawPolygons({ parent: p }), n.config.xaxis.labels.show) {
      var g = this.drawXAxisTexts();
      p.add(g);
    }
    return i.forEach((function(b) {
      p.add(b);
    })), p.add(this.yaxisLabels), p;
  } }, { key: "drawPolygons", value: function(e) {
    for (var t = this, n = this.w, o = e.parent, i = new Zm(this.ctx), a = n.globals.yAxisScale[0].result.reverse(), s = a.length, c = [], d = this.size / (s - 1), u = 0; u < s; u++) c[u] = d * u;
    c.reverse();
    var p = [], h = [];
    c.forEach((function(f, m) {
      var g = $.getPolygonPos(f, t.dataPointsLen), b = "";
      g.forEach((function(x, v) {
        if (m === 0) {
          var y = t.graphics.drawLine(x.x, x.y, 0, 0, Array.isArray(t.polygons.connectorColors) ? t.polygons.connectorColors[v] : t.polygons.connectorColors);
          h.push(y);
        }
        v === 0 && t.yaxisLabelsTextsPos.push({ x: x.x, y: x.y }), b += x.x + "," + x.y + " ";
      })), p.push(b);
    })), p.forEach((function(f, m) {
      var g = t.polygons.strokeColors, b = t.polygons.strokeWidth, x = t.graphics.drawPolygon(f, Array.isArray(g) ? g[m] : g, Array.isArray(b) ? b[m] : b, n.globals.radarPolygons.fill.colors[m]);
      o.add(x);
    })), h.forEach((function(f) {
      o.add(f);
    })), n.config.yaxis[0].show && this.yaxisLabelsTextsPos.forEach((function(f, m) {
      var g = i.drawYAxisTexts(f.x, f.y, m, a[m]);
      t.yaxisLabels.add(g);
    }));
  } }, { key: "drawXAxisTexts", value: function() {
    var e = this, t = this.w, n = t.config.xaxis.labels, o = this.graphics.group({ class: "apexcharts-xaxis" }), i = $.getPolygonPos(this.size, this.dataPointsLen);
    return t.globals.labels.forEach((function(a, s) {
      var c = t.config.xaxis.labels.formatter, d = new vo(e.ctx);
      if (i[s]) {
        var u = e.getTextPos(i[s], e.size), p = c(a, { seriesIndex: -1, dataPointIndex: s, w: t });
        d.plotDataLabelsText({ x: u.newX, y: u.newY, text: p, textAnchor: u.textAnchor, i: s, j: s, parent: o, className: "apexcharts-xaxis-label", color: Array.isArray(n.style.colors) && n.style.colors[s] ? n.style.colors[s] : "#a8a8a8", dataLabelsConfig: ie({ textAnchor: u.textAnchor, dropShadow: { enabled: !1 } }, n), offsetCorrection: !1 }).on("click", (function(h) {
          if (typeof t.config.chart.events.xAxisLabelClick == "function") {
            var f = Object.assign({}, t, { labelIndex: s });
            t.config.chart.events.xAxisLabelClick(h, e.ctx, f);
          }
        }));
      }
    })), o;
  } }, { key: "createPaths", value: function(e, t) {
    var n = this, o = [], i = [], a = [], s = [];
    if (e.length) {
      i = [this.graphics.move(t.x, t.y)], s = [this.graphics.move(t.x, t.y)];
      var c = this.graphics.move(e[0].x, e[0].y), d = this.graphics.move(e[0].x, e[0].y);
      e.forEach((function(u, p) {
        c += n.graphics.line(u.x, u.y), d += n.graphics.line(u.x, u.y), p === e.length - 1 && (c += "Z", d += "Z");
      })), o.push(c), a.push(d);
    }
    return { linePathsFrom: i, linePathsTo: o, areaPathsFrom: s, areaPathsTo: a };
  } }, { key: "getTextPos", value: function(e, t) {
    var n = "middle", o = e.x, i = e.y;
    return Math.abs(e.x) >= 10 ? e.x > 0 ? (n = "start", o += 10) : e.x < 0 && (n = "end", o -= 10) : n = "middle", Math.abs(e.y) >= t - 10 && (e.y < 0 ? i -= 10 : e.y > 0 && (i += 10)), { textAnchor: n, newX: o, newY: i };
  } }, { key: "getPreviousPath", value: function(e) {
    for (var t = this.w, n = null, o = 0; o < t.globals.previousPaths.length; o++) {
      var i = t.globals.previousPaths[o];
      i.paths.length > 0 && parseInt(i.realIndex, 10) === parseInt(e, 10) && t.globals.previousPaths[o].paths[0] !== void 0 && (n = t.globals.previousPaths[o].paths[0].d);
    }
    return n;
  } }, { key: "getDataPointsPos", value: function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.dataPointsLen;
    e = e || [], t = t || [];
    for (var o = [], i = 0; i < n; i++) {
      var a = {};
      a.x = e[i] * Math.sin(t[i]), a.y = -e[i] * Math.cos(t[i]), o.push(a);
    }
    return o;
  } }]), r;
})(), ej = (function(r) {
  oa(t, Jm);
  var e = na(t);
  function t(n) {
    var o;
    xe(this, t), (o = e.call(this, n)).ctx = n, o.w = n.w, o.animBeginArr = [0], o.animDur = 0;
    var i = o.w;
    return o.startAngle = i.config.plotOptions.radialBar.startAngle, o.endAngle = i.config.plotOptions.radialBar.endAngle, o.totalAngle = Math.abs(i.config.plotOptions.radialBar.endAngle - i.config.plotOptions.radialBar.startAngle), o.trackStartAngle = i.config.plotOptions.radialBar.track.startAngle, o.trackEndAngle = i.config.plotOptions.radialBar.track.endAngle, o.barLabels = o.w.config.plotOptions.radialBar.barLabels, o.donutDataLabels = o.w.config.plotOptions.radialBar.dataLabels, o.radialDataLabels = o.donutDataLabels, o.trackStartAngle || (o.trackStartAngle = o.startAngle), o.trackEndAngle || (o.trackEndAngle = o.endAngle), o.endAngle === 360 && (o.endAngle = 359.99), o.margin = parseInt(i.config.plotOptions.radialBar.track.margin, 10), o.onBarLabelClick = o.onBarLabelClick.bind(dm(o)), o;
  }
  return ve(t, [{ key: "draw", value: function(n) {
    var o = this.w, i = new ee(this.ctx), a = i.group({ class: "apexcharts-radialbar" });
    if (o.globals.noData) return a;
    var s = i.group(), c = this.defaultSize / 2, d = o.globals.gridWidth / 2, u = this.defaultSize / 2.05;
    o.config.chart.sparkline.enabled || (u = u - o.config.stroke.width - o.config.chart.dropShadow.blur);
    var p = o.globals.fill.colors;
    if (o.config.plotOptions.radialBar.track.show) {
      var h = this.drawTracks({ size: u, centerX: d, centerY: c, colorArr: p, series: n });
      s.add(h);
    }
    var f = this.drawArcs({ size: u, centerX: d, centerY: c, colorArr: p, series: n }), m = 360;
    o.config.plotOptions.radialBar.startAngle < 0 && (m = this.totalAngle);
    var g = (360 - m) / 360;
    if (o.globals.radialSize = u - u * g, this.radialDataLabels.value.show) {
      var b = Math.max(this.radialDataLabels.value.offsetY, this.radialDataLabels.name.offsetY);
      o.globals.radialSize += b * g;
    }
    return s.add(f.g), o.config.plotOptions.radialBar.hollow.position === "front" && (f.g.add(f.elHollow), f.dataLabels && f.g.add(f.dataLabels)), a.add(s), a;
  } }, { key: "drawTracks", value: function(n) {
    var o = this.w, i = new ee(this.ctx), a = i.group({ class: "apexcharts-tracks" }), s = new zt(this.ctx), c = new Pr(this.ctx), d = this.getStrokeWidth(n);
    n.size = n.size - d / 2;
    for (var u = 0; u < n.series.length; u++) {
      var p = i.group({ class: "apexcharts-radialbar-track apexcharts-track" });
      a.add(p), p.attr({ rel: u + 1 }), n.size = n.size - d - this.margin;
      var h = o.config.plotOptions.radialBar.track, f = c.fillPath({ seriesNumber: 0, size: n.size, fillColors: Array.isArray(h.background) ? h.background[u] : h.background, solid: !0 }), m = this.trackStartAngle, g = this.trackEndAngle;
      Math.abs(g) + Math.abs(m) >= 360 && (g = 360 - Math.abs(this.startAngle) - 0.1);
      var b = i.drawPath({ d: "", stroke: f, strokeWidth: d * parseInt(h.strokeWidth, 10) / 100, fill: "none", strokeOpacity: h.opacity, classes: "apexcharts-radialbar-area" });
      if (h.dropShadow.enabled) {
        var x = h.dropShadow;
        s.dropShadow(b, x);
      }
      p.add(b), b.attr("id", "apexcharts-radialbarTrack-" + u), this.animatePaths(b, { centerX: n.centerX, centerY: n.centerY, endAngle: g, startAngle: m, size: n.size, i: u, totalItems: 2, animBeginArr: 0, dur: 0, isTrack: !0 });
    }
    return a;
  } }, { key: "drawArcs", value: function(n) {
    var o = this.w, i = new ee(this.ctx), a = new Pr(this.ctx), s = new zt(this.ctx), c = i.group(), d = this.getStrokeWidth(n);
    n.size = n.size - d / 2;
    var u = o.config.plotOptions.radialBar.hollow.background, p = n.size - d * n.series.length - this.margin * n.series.length - d * parseInt(o.config.plotOptions.radialBar.track.strokeWidth, 10) / 100 / 2, h = p - o.config.plotOptions.radialBar.hollow.margin;
    o.config.plotOptions.radialBar.hollow.image !== void 0 && (u = this.drawHollowImage(n, c, p, u));
    var f = this.drawHollow({ size: h, centerX: n.centerX, centerY: n.centerY, fill: u || "transparent" });
    if (o.config.plotOptions.radialBar.hollow.dropShadow.enabled) {
      var m = o.config.plotOptions.radialBar.hollow.dropShadow;
      s.dropShadow(f, m);
    }
    var g = 1;
    !this.radialDataLabels.total.show && o.globals.series.length > 1 && (g = 0);
    var b = null;
    if (this.radialDataLabels.show) {
      var x = o.globals.dom.Paper.findOne(".apexcharts-datalabels-group");
      b = this.renderInnerDataLabels(x, this.radialDataLabels, { hollowSize: p, centerX: n.centerX, centerY: n.centerY, opacity: g });
    }
    o.config.plotOptions.radialBar.hollow.position === "back" && (c.add(f), b && c.add(b));
    var v = !1;
    o.config.plotOptions.radialBar.inverseOrder && (v = !0);
    for (var y = v ? n.series.length - 1 : 0; v ? y >= 0 : y < n.series.length; v ? y-- : y++) {
      var C = i.group({ class: "apexcharts-series apexcharts-radial-series", seriesName: $.escapeString(o.globals.seriesNames[y]) });
      c.add(C), C.attr({ rel: y + 1, "data:realIndex": y }), this.ctx.series.addCollapsedClassToSeries(C, y), n.size = n.size - d - this.margin;
      var k = a.fillPath({ seriesNumber: y, size: n.size, value: n.series[y] }), T = this.startAngle, S = void 0, O = $.negToZero(n.series[y] > 100 ? 100 : n.series[y]) / 100, P = Math.round(this.totalAngle * O) + this.startAngle, M = void 0;
      o.globals.dataChanged && (S = this.startAngle, M = Math.round(this.totalAngle * $.negToZero(o.globals.previousPaths[y]) / 100) + S), Math.abs(P) + Math.abs(T) > 360 && (P -= 0.01), Math.abs(M) + Math.abs(S) > 360 && (M -= 0.01);
      var I = P - T, E = Array.isArray(o.config.stroke.dashArray) ? o.config.stroke.dashArray[y] : o.config.stroke.dashArray, N = i.drawPath({ d: "", stroke: k, strokeWidth: d, fill: "none", fillOpacity: o.config.fill.opacity, classes: "apexcharts-radialbar-area apexcharts-radialbar-slice-" + y, strokeDashArray: E });
      if (ee.setAttrs(N.node, { "data:angle": I, "data:value": n.series[y] }), o.config.chart.dropShadow.enabled) {
        var L = o.config.chart.dropShadow;
        s.dropShadow(N, L, y);
      }
      if (s.setSelectionFilter(N, 0, y), this.addListeners(N, this.radialDataLabels), C.add(N), N.attr({ index: 0, j: y }), this.barLabels.enabled) {
        var z = $.polarToCartesian(n.centerX, n.centerY, n.size, T), F = this.barLabels.formatter(o.globals.seriesNames[y], { seriesIndex: y, w: o }), B = ["apexcharts-radialbar-label"];
        this.barLabels.onClick || B.push("apexcharts-no-click");
        var D = this.barLabels.useSeriesColors ? o.globals.colors[y] : o.config.chart.foreColor;
        D || (D = o.config.chart.foreColor);
        var W = z.x + this.barLabels.offsetX, G = z.y + this.barLabels.offsetY, re = i.drawText({ x: W, y: G, text: F, textAnchor: "end", dominantBaseline: "middle", fontFamily: this.barLabels.fontFamily, fontWeight: this.barLabels.fontWeight, fontSize: this.barLabels.fontSize, foreColor: D, cssClass: B.join(" ") });
        re.on("click", this.onBarLabelClick), re.attr({ rel: y + 1 }), T !== 0 && re.attr({ "transform-origin": "".concat(W, " ").concat(G), transform: "rotate(".concat(T, " 0 0)") }), C.add(re);
      }
      var ce = 0;
      !this.initialAnim || o.globals.resized || o.globals.dataChanged || (ce = o.config.chart.animations.speed), o.globals.dataChanged && (ce = o.config.chart.animations.dynamicAnimation.speed), this.animDur = ce / (1.2 * n.series.length) + this.animDur, this.animBeginArr.push(this.animDur), this.animatePaths(N, { centerX: n.centerX, centerY: n.centerY, endAngle: P, startAngle: T, prevEndAngle: M, prevStartAngle: S, size: n.size, i: y, totalItems: 2, animBeginArr: this.animBeginArr, dur: ce, shouldSetPrevPaths: !0 });
    }
    return { g: c, elHollow: f, dataLabels: b };
  } }, { key: "drawHollow", value: function(n) {
    var o = new ee(this.ctx).drawCircle(2 * n.size);
    return o.attr({ class: "apexcharts-radialbar-hollow", cx: n.centerX, cy: n.centerY, r: n.size, fill: n.fill }), o;
  } }, { key: "drawHollowImage", value: function(n, o, i, a) {
    var s = this.w, c = new Pr(this.ctx), d = $.randomId(), u = s.config.plotOptions.radialBar.hollow.image;
    if (s.config.plotOptions.radialBar.hollow.imageClipped) c.clippedImgArea({ width: i, height: i, image: u, patternID: "pattern".concat(s.globals.cuid).concat(d) }), a = "url(#pattern".concat(s.globals.cuid).concat(d, ")");
    else {
      var p = s.config.plotOptions.radialBar.hollow.imageWidth, h = s.config.plotOptions.radialBar.hollow.imageHeight;
      if (p === void 0 && h === void 0) {
        var f = s.globals.dom.Paper.image(u, (function(g) {
          this.move(n.centerX - g.width / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, n.centerY - g.height / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY);
        }));
        o.add(f);
      } else {
        var m = s.globals.dom.Paper.image(u, (function(g) {
          this.move(n.centerX - p / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, n.centerY - h / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY), this.size(p, h);
        }));
        o.add(m);
      }
    }
    return a;
  } }, { key: "getStrokeWidth", value: function(n) {
    var o = this.w;
    return n.size * (100 - parseInt(o.config.plotOptions.radialBar.hollow.size, 10)) / 100 / (n.series.length + 1) - this.margin;
  } }, { key: "onBarLabelClick", value: function(n) {
    var o = parseInt(n.target.getAttribute("rel"), 10) - 1, i = this.barLabels.onClick, a = this.w;
    i && i(a.globals.seriesNames[o], { w: a, seriesIndex: o });
  } }]), t;
})(), tj = (function(r) {
  oa(t, yo);
  var e = na(t);
  function t() {
    return xe(this, t), e.apply(this, arguments);
  }
  return ve(t, [{ key: "draw", value: function(n, o) {
    var i = this.w, a = new ee(this.ctx);
    this.rangeBarOptions = this.w.config.plotOptions.rangeBar, this.series = n, this.seriesRangeStart = i.globals.seriesRangeStart, this.seriesRangeEnd = i.globals.seriesRangeEnd, this.barHelpers.initVariables(n);
    for (var s = a.group({ class: "apexcharts-rangebar-series apexcharts-plot-series" }), c = 0; c < n.length; c++) {
      var d, u, p, h, f = void 0, m = void 0, g = i.globals.comboCharts ? o[c] : c, b = this.barHelpers.getGroupIndex(g).columnGroupIndex, x = a.group({ class: "apexcharts-series", seriesName: $.escapeString(i.globals.seriesNames[g]), rel: c + 1, "data:realIndex": g });
      this.ctx.series.addCollapsedClassToSeries(x, g), n[c].length > 0 && (this.visibleI = this.visibleI + 1);
      var v = 0, y = 0, C = 0;
      this.yRatio.length > 1 && (this.yaxisIndex = i.globals.seriesYAxisReverseMap[g][0], C = g);
      var k = this.barHelpers.initialPositions(g);
      m = k.y, h = k.zeroW, f = k.x, y = k.barWidth, v = k.barHeight, d = k.xDivision, u = k.yDivision, p = k.zeroH;
      for (var T = a.group({ class: "apexcharts-datalabels", "data:realIndex": g }), S = a.group({ class: "apexcharts-rangebar-goals-markers" }), O = 0; O < i.globals.dataPoints; O++) {
        var P = this.barHelpers.getStrokeWidth(c, O, g), M = this.seriesRangeStart[c][O], I = this.seriesRangeEnd[c][O], E = null, N = null, L = null, z = { x: f, y: m, strokeWidth: P, elSeries: x }, F = this.seriesLen;
        if (i.config.plotOptions.bar.rangeBarGroupRows && (F = 1), i.config.series[c].data[O] === void 0) break;
        if (this.isHorizontal) {
          L = m + v * this.visibleI;
          var B = (u - v * F) / 2;
          if (i.config.series[c].data[O].x) {
            var D = this.detectOverlappingBars({ i: c, j: O, barYPosition: L, srty: B, barHeight: v, yDivision: u, initPositions: k });
            v = D.barHeight, L = D.barYPosition;
          }
          y = (E = this.drawRangeBarPaths(ie({ indexes: { i: c, j: O, realIndex: g }, barHeight: v, barYPosition: L, zeroW: h, yDivision: u, y1: M, y2: I }, z))).barWidth;
        } else {
          i.globals.isXNumeric && (f = (i.globals.seriesX[c][O] - i.globals.minX) / this.xRatio - y / 2), N = f + y * this.visibleI;
          var W = (d - y * F) / 2;
          if (i.config.series[c].data[O].x) {
            var G = this.detectOverlappingBars({ i: c, j: O, barXPosition: N, srtx: W, barWidth: y, xDivision: d, initPositions: k });
            y = G.barWidth, N = G.barXPosition;
          }
          v = (E = this.drawRangeColumnPaths(ie({ indexes: { i: c, j: O, realIndex: g, translationsIndex: C }, barWidth: y, barXPosition: N, zeroH: p, xDivision: d }, z))).barHeight;
        }
        var re = this.barHelpers.drawGoalLine({ barXPosition: E.barXPosition, barYPosition: L, goalX: E.goalX, goalY: E.goalY, barHeight: v, barWidth: y });
        re && S.add(re), m = E.y, f = E.x;
        var ce = this.barHelpers.getPathFillColor(n, c, O, g);
        this.renderSeries({ realIndex: g, pathFill: ce.color, lineFill: ce.useRangeColor ? ce.color : i.globals.stroke.colors[g], j: O, i: c, x: f, y: m, y1: M, y2: I, pathFrom: E.pathFrom, pathTo: E.pathTo, strokeWidth: P, elSeries: x, series: n, barHeight: v, barWidth: y, barXPosition: N, barYPosition: L, columnGroupIndex: b, elDataLabelsWrap: T, elGoalsMarkers: S, visibleSeries: this.visibleI, type: "rangebar" });
      }
      s.add(x);
    }
    return s;
  } }, { key: "detectOverlappingBars", value: function(n) {
    var o = n.i, i = n.j, a = n.barYPosition, s = n.barXPosition, c = n.srty, d = n.srtx, u = n.barHeight, p = n.barWidth, h = n.yDivision, f = n.xDivision, m = n.initPositions, g = this.w, b = [], x = g.config.series[o].data[i].rangeName, v = g.config.series[o].data[i].x, y = Array.isArray(v) ? v.join(" ") : v, C = g.globals.labels.map((function(T) {
      return Array.isArray(T) ? T.join(" ") : T;
    })).indexOf(y), k = g.globals.seriesRange[o].findIndex((function(T) {
      return T.x === y && T.overlaps.length > 0;
    }));
    return this.isHorizontal ? (a = g.config.plotOptions.bar.rangeBarGroupRows ? c + h * C : c + u * this.visibleI + h * C, k > -1 && !g.config.plotOptions.bar.rangeBarOverlap && (b = g.globals.seriesRange[o][k].overlaps).indexOf(x) > -1 && (a = (u = m.barHeight / b.length) * this.visibleI + h * (100 - parseInt(this.barOptions.barHeight, 10)) / 100 / 2 + u * (this.visibleI + b.indexOf(x)) + h * C)) : (C > -1 && !g.globals.timescaleLabels.length && (s = g.config.plotOptions.bar.rangeBarGroupRows ? d + f * C : d + p * this.visibleI + f * C), k > -1 && !g.config.plotOptions.bar.rangeBarOverlap && (b = g.globals.seriesRange[o][k].overlaps).indexOf(x) > -1 && (s = (p = m.barWidth / b.length) * this.visibleI + f * (100 - parseInt(this.barOptions.barWidth, 10)) / 100 / 2 + p * (this.visibleI + b.indexOf(x)) + f * C)), { barYPosition: a, barXPosition: s, barHeight: u, barWidth: p };
  } }, { key: "drawRangeColumnPaths", value: function(n) {
    var o = n.indexes, i = n.x, a = n.xDivision, s = n.barWidth, c = n.barXPosition, d = n.zeroH, u = this.w, p = o.i, h = o.j, f = o.realIndex, m = o.translationsIndex, g = this.yRatio[m], b = this.getRangeValue(f, h), x = Math.min(b.start, b.end), v = Math.max(b.start, b.end);
    this.series[p][h] === void 0 || this.series[p][h] === null ? x = d : (x = d - x / g, v = d - v / g);
    var y = Math.abs(v - x), C = this.barHelpers.getColumnPaths({ barXPosition: c, barWidth: s, y1: x, y2: v, strokeWidth: this.strokeWidth, series: this.seriesRangeEnd, realIndex: f, i: f, j: h, w: u });
    if (u.globals.isXNumeric) {
      var k = this.getBarXForNumericXAxis({ x: i, j: h, realIndex: f, barWidth: s });
      i = k.x, c = k.barXPosition;
    } else i += a;
    return { pathTo: C.pathTo, pathFrom: C.pathFrom, barHeight: y, x: i, y: b.start < 0 && b.end < 0 ? x : v, goalY: this.barHelpers.getGoalValues("y", null, d, p, h, m), barXPosition: c };
  } }, { key: "preventBarOverflow", value: function(n) {
    var o = this.w;
    return n < 0 && (n = 0), n > o.globals.gridWidth && (n = o.globals.gridWidth), n;
  } }, { key: "drawRangeBarPaths", value: function(n) {
    var o = n.indexes, i = n.y, a = n.y1, s = n.y2, c = n.yDivision, d = n.barHeight, u = n.barYPosition, p = n.zeroW, h = this.w, f = o.realIndex, m = o.j, g = this.preventBarOverflow(p + a / this.invertedYRatio), b = this.preventBarOverflow(p + s / this.invertedYRatio), x = this.getRangeValue(f, m), v = Math.abs(b - g), y = this.barHelpers.getBarpaths({ barYPosition: u, barHeight: d, x1: g, x2: b, strokeWidth: this.strokeWidth, series: this.seriesRangeEnd, i: f, realIndex: f, j: m, w: h });
    return h.globals.isXNumeric || (i += c), { pathTo: y.pathTo, pathFrom: y.pathFrom, barWidth: v, x: x.start < 0 && x.end < 0 ? g : b, goalX: this.barHelpers.getGoalValues("x", p, null, f, m), y: i };
  } }, { key: "getRangeValue", value: function(n, o) {
    var i = this.w;
    return { start: i.globals.seriesRangeStart[n][o], end: i.globals.seriesRangeEnd[n][o] };
  } }]), t;
})(), rj = (function() {
  function r(e) {
    xe(this, r), this.w = e.w, this.lineCtx = e;
  }
  return ve(r, [{ key: "sameValueSeriesFix", value: function(e, t) {
    var n = this.w;
    if ((n.config.fill.type === "gradient" || n.config.fill.type[e] === "gradient") && new Tt(this.lineCtx.ctx, n).seriesHaveSameValues(e)) {
      var o = t[e].slice();
      o[o.length - 1] = o[o.length - 1] + 1e-6, t[e] = o;
    }
    return t;
  } }, { key: "calculatePoints", value: function(e) {
    var t = e.series, n = e.realIndex, o = e.x, i = e.y, a = e.i, s = e.j, c = e.prevY, d = this.w, u = [], p = [], h = this.lineCtx.categoryAxisCorrection + d.config.markers.offsetX;
    return d.globals.isXNumeric && (h = (d.globals.seriesX[n][0] - d.globals.minX) / this.lineCtx.xRatio + d.config.markers.offsetX), s === 0 && (u.push(h), p.push($.isNumber(t[a][0]) ? c + d.config.markers.offsetY : null)), u.push(o + d.config.markers.offsetX), p.push($.isNumber(t[a][s + 1]) ? i + d.config.markers.offsetY : null), { x: u, y: p };
  } }, { key: "checkPreviousPaths", value: function(e) {
    for (var t = e.pathFromLine, n = e.pathFromArea, o = e.realIndex, i = this.w, a = 0; a < i.globals.previousPaths.length; a++) {
      var s = i.globals.previousPaths[a];
      (s.type === "line" || s.type === "area") && s.paths.length > 0 && parseInt(s.realIndex, 10) === parseInt(o, 10) && (s.type === "line" ? (this.lineCtx.appendPathFrom = !1, t = i.globals.previousPaths[a].paths[0].d) : s.type === "area" && (this.lineCtx.appendPathFrom = !1, n = i.globals.previousPaths[a].paths[0].d, i.config.stroke.show && i.globals.previousPaths[a].paths[1] && (t = i.globals.previousPaths[a].paths[1].d)));
    }
    return { pathFromLine: t, pathFromArea: n };
  } }, { key: "determineFirstPrevY", value: function(e) {
    var t, n, o, i = e.i, a = e.realIndex, s = e.series, c = e.prevY, d = e.lineYPosition, u = e.translationsIndex, p = this.w, h = p.config.chart.stacked && !p.globals.comboCharts || p.config.chart.stacked && p.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || ((t = this.w.config.series[a]) === null || t === void 0 ? void 0 : t.type) === "bar" || ((n = this.w.config.series[a]) === null || n === void 0 ? void 0 : n.type) === "column");
    if (((o = s[i]) === null || o === void 0 ? void 0 : o[0]) !== void 0) c = (d = h && i > 0 ? this.lineCtx.prevSeriesY[i - 1][0] : this.lineCtx.zeroY) - s[i][0] / this.lineCtx.yRatio[u] + 2 * (this.lineCtx.isReversed ? s[i][0] / this.lineCtx.yRatio[u] : 0);
    else if (h && i > 0 && s[i][0] === void 0) {
      for (var f = i - 1; f >= 0; f--) if (s[f][0] !== null && s[f][0] !== void 0) {
        c = d = this.lineCtx.prevSeriesY[f][0];
        break;
      }
    }
    return { prevY: c, lineYPosition: d };
  } }]), r;
})(), nj = function(r) {
  for (var e, t, n, o, i = (function(u) {
    for (var p = [], h = u[0], f = u[1], m = p[0] = Al(h, f), g = 1, b = u.length - 1; g < b; g++) h = f, f = u[g + 1], p[g] = 0.5 * (m + (m = Al(h, f)));
    return p[g] = m, p;
  })(r), a = r.length - 1, s = [], c = 0; c < a; c++) n = Al(r[c], r[c + 1]), Math.abs(n) < 1e-6 ? i[c] = i[c + 1] = 0 : (o = (e = i[c] / n) * e + (t = i[c + 1] / n) * t) > 9 && (o = 3 * n / Math.sqrt(o), i[c] = o * e, i[c + 1] = o * t);
  for (var d = 0; d <= a; d++) o = (r[Math.min(a, d + 1)][0] - r[Math.max(0, d - 1)][0]) / (6 * (1 + i[d] * i[d])), s.push([o || 0, i[d] * o || 0]);
  return s;
}, oj = function(r) {
  var e = nj(r), t = r[1], n = r[0], o = [], i = e[1], a = e[0];
  o.push(n, [n[0] + a[0], n[1] + a[1], t[0] - i[0], t[1] - i[1], t[0], t[1]]);
  for (var s = 2, c = e.length; s < c; s++) {
    var d = r[s], u = e[s];
    o.push([d[0] - u[0], d[1] - u[1], d[0], d[1]]);
  }
  return o;
}, ij = function(r, e, t) {
  var n = r.slice(e, t);
  if (e) {
    if (t - e > 1 && n[1].length < 6) {
      var o = n[0].length;
      n[1] = [2 * n[0][o - 2] - n[0][o - 4], 2 * n[0][o - 1] - n[0][o - 3]].concat(n[1]);
    }
    n[0] = n[0].slice(-2);
  }
  return n;
};
function Al(r, e) {
  return (e[1] - r[1]) / (e[0] - r[0]);
}
var Ol = (function() {
  function r(e, t, n) {
    xe(this, r), this.ctx = e, this.w = e.w, this.xyRatios = t, this.pointsChart = !(this.w.config.chart.type !== "bubble" && this.w.config.chart.type !== "scatter") || n, this.scatter = new Wm(this.ctx), this.noNegatives = this.w.globals.minX === Number.MAX_VALUE, this.lineHelpers = new rj(this), this.markers = new Io(this.ctx), this.prevSeriesY = [], this.categoryAxisCorrection = 0, this.yaxisIndex = 0;
  }
  return ve(r, [{ key: "draw", value: function(e, t, n, o) {
    var i, a = this.w, s = new ee(this.ctx), c = a.globals.comboCharts ? t : a.config.chart.type, d = s.group({ class: "apexcharts-".concat(c, "-series apexcharts-plot-series") }), u = new Tt(this.ctx, a);
    this.yRatio = this.xyRatios.yRatio, this.zRatio = this.xyRatios.zRatio, this.xRatio = this.xyRatios.xRatio, this.baseLineY = this.xyRatios.baseLineY, e = u.getLogSeries(e), this.yRatio = u.getLogYRatios(this.yRatio), this.prevSeriesY = [];
    for (var p = [], h = 0; h < e.length; h++) {
      e = this.lineHelpers.sameValueSeriesFix(h, e);
      var f = a.globals.comboCharts ? n[h] : h, m = this.yRatio.length > 1 ? f : 0;
      this._initSerieVariables(e, h, f);
      var g = [], b = [], x = [], v = a.globals.padHorizontal + this.categoryAxisCorrection;
      this.ctx.series.addCollapsedClassToSeries(this.elSeries, f), a.globals.isXNumeric && a.globals.seriesX.length > 0 && (v = (a.globals.seriesX[f][0] - a.globals.minX) / this.xRatio), x.push(v);
      var y, C = v, k = void 0, T = C, S = this.zeroY, O = this.zeroY;
      S = this.lineHelpers.determineFirstPrevY({ i: h, realIndex: f, series: e, prevY: S, lineYPosition: 0, translationsIndex: m }).prevY, a.config.stroke.curve === "monotoneCubic" && e[h][0] === null ? g.push(null) : g.push(S), y = S, c === "rangeArea" && (k = O = this.lineHelpers.determineFirstPrevY({ i: h, realIndex: f, series: o, prevY: O, lineYPosition: 0, translationsIndex: m }).prevY, b.push(g[0] !== null ? O : null));
      var P = this._calculatePathsFrom({ type: c, series: e, i: h, realIndex: f, translationsIndex: m, prevX: T, prevY: S, prevY2: O }), M = [g[0]], I = [b[0]], E = { type: c, series: e, realIndex: f, translationsIndex: m, i: h, x: v, y: 1, pX: C, pY: y, pathsFrom: P, linePaths: [], areaPaths: [], seriesIndex: n, lineYPosition: 0, xArrj: x, yArrj: g, y2Arrj: b, seriesRangeEnd: o }, N = this._iterateOverDataPoints(ie(ie({}, E), {}, { iterations: c === "rangeArea" ? e[h].length - 1 : void 0, isRangeStart: !0 }));
      if (c === "rangeArea") {
        for (var L = this._calculatePathsFrom({ series: o, i: h, realIndex: f, prevX: T, prevY: O }), z = this._iterateOverDataPoints(ie(ie({}, E), {}, { series: o, xArrj: [v], yArrj: M, y2Arrj: I, pY: k, areaPaths: N.areaPaths, pathsFrom: L, iterations: o[h].length - 1, isRangeStart: !1 })), F = N.linePaths.length / 2, B = 0; B < F; B++) N.linePaths[B] = z.linePaths[B + F] + N.linePaths[B];
        N.linePaths.splice(F), N.pathFromLine = z.pathFromLine + N.pathFromLine;
      } else N.pathFromArea += "z";
      this._handlePaths({ type: c, realIndex: f, i: h, paths: N }), this.elSeries.add(this.elPointsMain), this.elSeries.add(this.elDataLabelsWrap), p.push(this.elSeries);
    }
    if (((i = a.config.series[0]) === null || i === void 0 ? void 0 : i.zIndex) !== void 0 && p.sort((function(G, re) {
      return Number(G.node.getAttribute("zIndex")) - Number(re.node.getAttribute("zIndex"));
    })), a.config.chart.stacked) for (var D = p.length - 1; D >= 0; D--) d.add(p[D]);
    else for (var W = 0; W < p.length; W++) d.add(p[W]);
    return d;
  } }, { key: "_initSerieVariables", value: function(e, t, n) {
    var o = this.w, i = new ee(this.ctx);
    this.xDivision = o.globals.gridWidth / (o.globals.dataPoints - (o.config.xaxis.tickPlacement === "on" ? 1 : 0)), this.strokeWidth = Array.isArray(o.config.stroke.width) ? o.config.stroke.width[n] : o.config.stroke.width;
    var a = 0;
    if (this.yRatio.length > 1 && (this.yaxisIndex = o.globals.seriesYAxisReverseMap[n], a = n), this.isReversed = o.config.yaxis[this.yaxisIndex] && o.config.yaxis[this.yaxisIndex].reversed, this.zeroY = o.globals.gridHeight - this.baseLineY[a] - (this.isReversed ? o.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[a] : 0), this.areaBottomY = this.zeroY, (this.zeroY > o.globals.gridHeight || o.config.plotOptions.area.fillTo === "end") && (this.areaBottomY = o.globals.gridHeight), this.categoryAxisCorrection = this.xDivision / 2, this.elSeries = i.group({ class: "apexcharts-series", zIndex: o.config.series[n].zIndex !== void 0 ? o.config.series[n].zIndex : n, seriesName: $.escapeString(o.globals.seriesNames[n]) }), this.elPointsMain = i.group({ class: "apexcharts-series-markers-wrap", "data:realIndex": n }), o.globals.hasNullValues) {
      var s = this.markers.plotChartMarkers({ pointsPos: { x: [0], y: [o.globals.gridHeight + o.globals.markers.largestSize] }, seriesIndex: t, j: 0, pSize: 0.1, alwaysDrawMarker: !0, isVirtualPoint: !0 });
      s !== null && this.elPointsMain.add(s);
    }
    this.elDataLabelsWrap = i.group({ class: "apexcharts-datalabels", "data:realIndex": n });
    var c = e[t].length === o.globals.dataPoints;
    this.elSeries.attr({ "data:longestSeries": c, rel: t + 1, "data:realIndex": n }), this.appendPathFrom = !0;
  } }, { key: "_calculatePathsFrom", value: function(e) {
    var t, n, o, i, a = e.type, s = e.series, c = e.i, d = e.realIndex, u = e.translationsIndex, p = e.prevX, h = e.prevY, f = e.prevY2, m = this.w, g = new ee(this.ctx);
    if (s[c][0] === null) {
      for (var b = 0; b < s[c].length; b++) if (s[c][b] !== null) {
        p = this.xDivision * b, h = this.zeroY - s[c][b] / this.yRatio[u], t = g.move(p, h), n = g.move(p, this.areaBottomY);
        break;
      }
    } else t = g.move(p, h), a === "rangeArea" && (t = g.move(p, f) + g.line(p, h)), n = g.move(p, this.areaBottomY) + g.line(p, h);
    if (o = g.move(0, this.areaBottomY) + g.line(0, this.areaBottomY), i = g.move(0, this.areaBottomY) + g.line(0, this.areaBottomY), m.globals.previousPaths.length > 0) {
      var x = this.lineHelpers.checkPreviousPaths({ pathFromLine: o, pathFromArea: i, realIndex: d });
      o = x.pathFromLine, i = x.pathFromArea;
    }
    return { prevX: p, prevY: h, linePath: t, areaPath: n, pathFromLine: o, pathFromArea: i };
  } }, { key: "_handlePaths", value: function(e) {
    var t = e.type, n = e.realIndex, o = e.i, i = e.paths, a = this.w, s = new ee(this.ctx), c = new Pr(this.ctx);
    this.prevSeriesY.push(i.yArrj), a.globals.seriesXvalues[n] = i.xArrj, a.globals.seriesYvalues[n] = i.yArrj;
    var d = a.config.forecastDataPoints;
    if (d.count > 0 && t !== "rangeArea") {
      var u = a.globals.seriesXvalues[n][a.globals.seriesXvalues[n].length - d.count - 1], p = s.drawRect(u, 0, a.globals.gridWidth, a.globals.gridHeight, 0);
      a.globals.dom.elForecastMask.appendChild(p.node);
      var h = s.drawRect(0, 0, u, a.globals.gridHeight, 0);
      a.globals.dom.elNonForecastMask.appendChild(h.node);
    }
    this.pointsChart || a.globals.delayedElements.push({ el: this.elPointsMain.node, index: n });
    var f = { i: o, realIndex: n, animationDelay: o, initialSpeed: a.config.chart.animations.speed, dataChangeSpeed: a.config.chart.animations.dynamicAnimation.speed, className: "apexcharts-".concat(t) };
    if (t === "area") for (var m = c.fillPath({ seriesNumber: n }), g = 0; g < i.areaPaths.length; g++) {
      var b = s.renderPaths(ie(ie({}, f), {}, { pathFrom: i.pathFromArea, pathTo: i.areaPaths[g], stroke: "none", strokeWidth: 0, strokeLineCap: null, fill: m }));
      this.elSeries.add(b);
    }
    if (a.config.stroke.show && !this.pointsChart) {
      var x = null;
      if (t === "line") x = c.fillPath({ seriesNumber: n, i: o });
      else if (a.config.stroke.fill.type === "solid") x = a.globals.stroke.colors[n];
      else {
        var v = a.config.fill;
        a.config.fill = a.config.stroke.fill, x = c.fillPath({ seriesNumber: n, i: o }), a.config.fill = v;
      }
      for (var y = 0; y < i.linePaths.length; y++) {
        var C = x;
        t === "rangeArea" && (C = c.fillPath({ seriesNumber: n }));
        var k = ie(ie({}, f), {}, { pathFrom: i.pathFromLine, pathTo: i.linePaths[y], stroke: x, strokeWidth: this.strokeWidth, strokeLineCap: a.config.stroke.lineCap, fill: t === "rangeArea" ? C : "none" }), T = s.renderPaths(k);
        if (this.elSeries.add(T), T.attr("fill-rule", "evenodd"), d.count > 0 && t !== "rangeArea") {
          var S = s.renderPaths(k);
          S.node.setAttribute("stroke-dasharray", d.dashArray), d.strokeWidth && S.node.setAttribute("stroke-width", d.strokeWidth), this.elSeries.add(S), S.attr("clip-path", "url(#forecastMask".concat(a.globals.cuid, ")")), T.attr("clip-path", "url(#nonForecastMask".concat(a.globals.cuid, ")"));
        }
      }
    }
  } }, { key: "_iterateOverDataPoints", value: function(e) {
    var t, n, o = this, i = e.type, a = e.series, s = e.iterations, c = e.realIndex, d = e.translationsIndex, u = e.i, p = e.x, h = e.y, f = e.pX, m = e.pY, g = e.pathsFrom, b = e.linePaths, x = e.areaPaths, v = e.seriesIndex, y = e.lineYPosition, C = e.xArrj, k = e.yArrj, T = e.y2Arrj, S = e.isRangeStart, O = e.seriesRangeEnd, P = this.w, M = new ee(this.ctx), I = this.yRatio, E = g.prevY, N = g.linePath, L = g.areaPath, z = g.pathFromLine, F = g.pathFromArea, B = $.isNumber(P.globals.minYArr[c]) ? P.globals.minYArr[c] : P.globals.minY;
    s || (s = P.globals.dataPoints > 1 ? P.globals.dataPoints - 1 : P.globals.dataPoints);
    var D = function(se, Re) {
      return Re - se / I[d] + 2 * (o.isReversed ? se / I[d] : 0);
    }, W = h, G = P.config.chart.stacked && !P.globals.comboCharts || P.config.chart.stacked && P.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || ((t = this.w.config.series[c]) === null || t === void 0 ? void 0 : t.type) === "bar" || ((n = this.w.config.series[c]) === null || n === void 0 ? void 0 : n.type) === "column"), re = P.config.stroke.curve;
    Array.isArray(re) && (re = Array.isArray(v) ? re[v[u]] : re[u]);
    for (var ce, Ce = 0, ne = 0; ne < s && a[u].length !== 0; ne++) {
      var pe = a[u][ne + 1] === void 0 || a[u][ne + 1] === null;
      if (P.globals.isXNumeric) {
        var K = P.globals.seriesX[c][ne + 1];
        P.globals.seriesX[c][ne + 1] === void 0 && (K = P.globals.seriesX[c][s - 1]), p = (K - P.globals.minX) / this.xRatio;
      } else p += this.xDivision;
      G ? u > 0 && P.globals.collapsedSeries.length < P.config.series.length - 1 ? y = this.prevSeriesY[(function(se) {
        for (var Re = se; Re > 0; Re--) {
          if (!(P.globals.collapsedSeriesIndices.indexOf(v?.[Re] || Re) > -1)) return Re;
          Re--;
        }
        return 0;
      })(u - 1)][ne + 1] : y = this.zeroY : y = this.zeroY, pe ? h = D(B, y) : (h = D(a[u][ne + 1], y), i === "rangeArea" && (W = D(O[u][ne + 1], y))), C.push(a[u][ne + 1] === null ? null : p), !pe || P.config.stroke.curve !== "smooth" && P.config.stroke.curve !== "monotoneCubic" ? (k.push(h), T.push(W)) : (k.push(null), T.push(null));
      var le = this.lineHelpers.calculatePoints({ series: a, x: p, y: h, realIndex: c, i: u, j: ne, prevY: E }), Q = this._createPaths({ type: i, series: a, i: u, realIndex: c, j: ne, x: p, y: h, y2: W, xArrj: C, yArrj: k, y2Arrj: T, pX: f, pY: m, pathState: Ce, segmentStartX: ce, linePath: N, areaPath: L, linePaths: b, areaPaths: x, curve: re, isRangeStart: S });
      x = Q.areaPaths, b = Q.linePaths, f = Q.pX, m = Q.pY, Ce = Q.pathState, ce = Q.segmentStartX, L = Q.areaPath, N = Q.linePath, !this.appendPathFrom || P.globals.hasNullValues || re === "monotoneCubic" && i === "rangeArea" || (z += M.line(p, this.areaBottomY), F += M.line(p, this.areaBottomY)), this.handleNullDataPoints(a, le, u, ne, c), this._handleMarkersAndLabels({ type: i, pointsPos: le, i: u, j: ne, realIndex: c, isRangeStart: S });
    }
    return { yArrj: k, xArrj: C, pathFromArea: F, areaPaths: x, pathFromLine: z, linePaths: b, linePath: N, areaPath: L };
  } }, { key: "_handleMarkersAndLabels", value: function(e) {
    var t = e.type, n = e.pointsPos, o = e.isRangeStart, i = e.i, a = e.j, s = e.realIndex, c = this.w, d = new vo(this.ctx);
    if (this.pointsChart) this.scatter.draw(this.elSeries, a, { realIndex: s, pointsPos: n, zRatio: this.zRatio, elParent: this.elPointsMain });
    else {
      c.globals.series[i].length > 1 && this.elPointsMain.node.classList.add("apexcharts-element-hidden");
      var u = this.markers.plotChartMarkers({ pointsPos: n, seriesIndex: s, j: a + 1 });
      u !== null && this.elPointsMain.add(u);
    }
    var p = d.drawDataLabel({ type: t, isRangeStart: o, pos: n, i: s, j: a + 1 });
    p !== null && this.elDataLabelsWrap.add(p);
  } }, { key: "_createPaths", value: function(e) {
    var t = e.type, n = e.series, o = e.i;
    e.realIndex;
    var i, a = e.j, s = e.x, c = e.y, d = e.xArrj, u = e.yArrj, p = e.y2, h = e.y2Arrj, f = e.pX, m = e.pY, g = e.pathState, b = e.segmentStartX, x = e.linePath, v = e.areaPath, y = e.linePaths, C = e.areaPaths, k = e.curve, T = e.isRangeStart, S = new ee(this.ctx), O = this.areaBottomY, P = t === "rangeArea", M = t === "rangeArea" && T;
    switch (k) {
      case "monotoneCubic":
        var I = T ? u : h;
        switch (g) {
          case 0:
            if (I[a + 1] === null) break;
            g = 1;
          case 1:
            if (!(P ? d.length === n[o].length : a === n[o].length - 2)) break;
          case 2:
            var E = T ? d : d.slice().reverse(), N = T ? I : I.slice().reverse(), L = (i = N, E.map((function(K, le) {
              return [K, i[le]];
            })).filter((function(K) {
              return K[1] !== null;
            }))), z = L.length > 1 ? oj(L) : L, F = [];
            P && (M ? C = L : F = C.reverse());
            var B = 0, D = 0;
            if ((function(K, le) {
              for (var Q = (function(Ne) {
                var ke = [], Oe = 0;
                return Ne.forEach((function(Te) {
                  Te !== null ? Oe++ : Oe > 0 && (ke.push(Oe), Oe = 0);
                })), Oe > 0 && ke.push(Oe), ke;
              })(K), se = [], Re = 0, be = 0; Re < Q.length; be += Q[Re++]) se[Re] = ij(le, be, be + Q[Re]);
              return se;
            })(N, z).forEach((function(K) {
              B++;
              var le = (function(Re) {
                for (var be = "", Ne = 0; Ne < Re.length; Ne++) {
                  var ke = Re[Ne], Oe = ke.length;
                  Oe > 4 ? (be += "C".concat(ke[0], ", ").concat(ke[1]), be += ", ".concat(ke[2], ", ").concat(ke[3]), be += ", ".concat(ke[4], ", ").concat(ke[5])) : Oe > 2 && (be += "S".concat(ke[0], ", ").concat(ke[1]), be += ", ".concat(ke[2], ", ").concat(ke[3]));
                }
                return be;
              })(K), Q = D, se = (D += K.length) - 1;
              M ? x = S.move(L[Q][0], L[Q][1]) + le : P ? x = S.move(F[Q][0], F[Q][1]) + S.line(L[Q][0], L[Q][1]) + le + S.line(F[se][0], F[se][1]) : (x = S.move(L[Q][0], L[Q][1]) + le, v = x + S.line(L[se][0], O) + S.line(L[Q][0], O) + "z", C.push(v)), y.push(x);
            })), P && B > 1 && !M) {
              var W = y.slice(B).reverse();
              y.splice(B), W.forEach((function(K) {
                return y.push(K);
              }));
            }
            g = 0;
        }
        break;
      case "smooth":
        var G = 0.35 * (s - f);
        if (n[o][a] === null) g = 0;
        else switch (g) {
          case 0:
            if (b = f, x = M ? S.move(f, h[a]) + S.line(f, m) : S.move(f, m), v = S.move(f, m), n[o][a + 1] === null || n[o][a + 1] === void 0) {
              y.push(x), C.push(v);
              break;
            }
            if (g = 1, a < n[o].length - 2) {
              var re = S.curve(f + G, m, s - G, c, s, c);
              x += re, v += re;
              break;
            }
          case 1:
            if (n[o][a + 1] === null) x += M ? S.line(f, p) : S.move(f, m), v += S.line(f, O) + S.line(b, O) + "z", y.push(x), C.push(v), g = -1;
            else {
              var ce = S.curve(f + G, m, s - G, c, s, c);
              x += ce, v += ce, a >= n[o].length - 2 && (M && (x += S.curve(s, c, s, c, s, p) + S.move(s, p)), v += S.curve(s, c, s, c, s, O) + S.line(b, O) + "z", y.push(x), C.push(v), g = -1);
            }
        }
        f = s, m = c;
        break;
      default:
        var Ce = function(K, le, Q) {
          var se = [];
          switch (K) {
            case "stepline":
              se = S.line(le, null, "H") + S.line(null, Q, "V");
              break;
            case "linestep":
              se = S.line(null, Q, "V") + S.line(le, null, "H");
              break;
            case "straight":
              se = S.line(le, Q);
          }
          return se;
        };
        if (n[o][a] === null) g = 0;
        else switch (g) {
          case 0:
            if (b = f, x = M ? S.move(f, h[a]) + S.line(f, m) : S.move(f, m), v = S.move(f, m), n[o][a + 1] === null || n[o][a + 1] === void 0) {
              y.push(x), C.push(v);
              break;
            }
            if (g = 1, a < n[o].length - 2) {
              var ne = Ce(k, s, c);
              x += ne, v += ne;
              break;
            }
          case 1:
            if (n[o][a + 1] === null) x += M ? S.line(f, p) : S.move(f, m), v += S.line(f, O) + S.line(b, O) + "z", y.push(x), C.push(v), g = -1;
            else {
              var pe = Ce(k, s, c);
              x += pe, v += pe, a >= n[o].length - 2 && (M && (x += S.line(s, p)), v += S.line(s, O) + S.line(b, O) + "z", y.push(x), C.push(v), g = -1);
            }
        }
        f = s, m = c;
    }
    return { linePaths: y, areaPaths: C, pX: f, pY: m, pathState: g, segmentStartX: b, linePath: x, areaPath: v };
  } }, { key: "handleNullDataPoints", value: function(e, t, n, o, i) {
    var a = this.w;
    if (e[n][o] === null && a.config.markers.showNullDataPoints || e[n].length === 1) {
      var s = this.strokeWidth - a.config.markers.strokeWidth / 2;
      s > 0 || (s = 0);
      var c = this.markers.plotChartMarkers({ pointsPos: t, seriesIndex: i, j: o + 1, pSize: s, alwaysDrawMarker: !0 });
      c !== null && this.elPointsMain.add(c);
    }
  } }]), r;
})();
window.TreemapSquared = {}, window.TreemapSquared.generate = /* @__PURE__ */ (function() {
  function r(s, c, d, u) {
    this.xoffset = s, this.yoffset = c, this.height = u, this.width = d, this.shortestEdge = function() {
      return Math.min(this.height, this.width);
    }, this.getCoordinates = function(p) {
      var h, f = [], m = this.xoffset, g = this.yoffset, b = i(p) / this.height, x = i(p) / this.width;
      if (this.width >= this.height) for (h = 0; h < p.length; h++) f.push([m, g, m + b, g + p[h] / b]), g += p[h] / b;
      else for (h = 0; h < p.length; h++) f.push([m, g, m + p[h] / x, g + x]), m += p[h] / x;
      return f;
    }, this.cutArea = function(p) {
      var h;
      if (this.width >= this.height) {
        var f = p / this.height, m = this.width - f;
        h = new r(this.xoffset + f, this.yoffset, m, this.height);
      } else {
        var g = p / this.width, b = this.height - g;
        h = new r(this.xoffset, this.yoffset + g, this.width, b);
      }
      return h;
    };
  }
  function e(s, c, d, u, p) {
    u = u === void 0 ? 0 : u, p = p === void 0 ? 0 : p;
    var h = t((function(f, m) {
      var g, b = [], x = m / i(f);
      for (g = 0; g < f.length; g++) b[g] = f[g] * x;
      return b;
    })(s, c * d), [], new r(u, p, c, d), []);
    return (function(f) {
      var m, g, b = [];
      for (m = 0; m < f.length; m++) for (g = 0; g < f[m].length; g++) b.push(f[m][g]);
      return b;
    })(h);
  }
  function t(s, c, d, u) {
    var p, h, f;
    if (s.length !== 0) return p = d.shortestEdge(), (function(m, g, b) {
      var x;
      if (m.length === 0) return !0;
      (x = m.slice()).push(g);
      var v = n(m, b), y = n(x, b);
      return v >= y;
    })(c, h = s[0], p) ? (c.push(h), t(s.slice(1), c, d, u)) : (f = d.cutArea(i(c), u), u.push(d.getCoordinates(c)), t(s, [], f, u)), u;
    u.push(d.getCoordinates(c));
  }
  function n(s, c) {
    var d = Math.min.apply(Math, s), u = Math.max.apply(Math, s), p = i(s);
    return Math.max(Math.pow(c, 2) * u / Math.pow(p, 2), Math.pow(p, 2) / (Math.pow(c, 2) * d));
  }
  function o(s) {
    return s && s.constructor === Array;
  }
  function i(s) {
    var c, d = 0;
    for (c = 0; c < s.length; c++) d += s[c];
    return d;
  }
  function a(s) {
    var c, d = 0;
    if (o(s[0])) for (c = 0; c < s.length; c++) d += a(s[c]);
    else d = i(s);
    return d;
  }
  return function s(c, d, u, p, h) {
    p = p === void 0 ? 0 : p, h = h === void 0 ? 0 : h;
    var f, m, g = [], b = [];
    if (o(c[0])) {
      for (m = 0; m < c.length; m++) g[m] = a(c[m]);
      for (f = e(g, d, u, p, h), m = 0; m < c.length; m++) b.push(s(c[m], f[m][2] - f[m][0], f[m][3] - f[m][1], f[m][0], f[m][1]));
    } else b = e(c, d, u, p, h);
    return b;
  };
})();
var aj = (function() {
  function r(e, t) {
    xe(this, r), this.ctx = e, this.w = e.w, this.strokeWidth = this.w.config.stroke.width, this.helpers = new Km(e), this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.labels = [];
  }
  return ve(r, [{ key: "draw", value: function(e) {
    var t = this, n = this.w, o = new ee(this.ctx), i = new Pr(this.ctx), a = o.group({ class: "apexcharts-treemap" });
    if (n.globals.noData) return a;
    var s = [];
    return e.forEach((function(c) {
      var d = c.map((function(u) {
        return Math.abs(u);
      }));
      s.push(d);
    })), this.negRange = this.helpers.checkColorRange(), n.config.series.forEach((function(c, d) {
      c.data.forEach((function(u) {
        Array.isArray(t.labels[d]) || (t.labels[d] = []), t.labels[d].push(u.x);
      }));
    })), window.TreemapSquared.generate(s, n.globals.gridWidth, n.globals.gridHeight).forEach((function(c, d) {
      var u = o.group({ class: "apexcharts-series apexcharts-treemap-series", seriesName: $.escapeString(n.globals.seriesNames[d]), rel: d + 1, "data:realIndex": d });
      if (n.config.chart.dropShadow.enabled) {
        var p = n.config.chart.dropShadow;
        new zt(t.ctx).dropShadow(a, p, d);
      }
      var h = o.group({ class: "apexcharts-data-labels" }), f = { xMin: 1 / 0, yMin: 1 / 0, xMax: -1 / 0, yMax: -1 / 0 };
      c.forEach((function(z, F) {
        var B = z[0], D = z[1], W = z[2], G = z[3];
        f.xMin = Math.min(f.xMin, B), f.yMin = Math.min(f.yMin, D), f.xMax = Math.max(f.xMax, W), f.yMax = Math.max(f.yMax, G);
        var re = t.helpers.getShadeColor(n.config.chart.type, d, F, t.negRange), ce = re.color, Ce = i.fillPath({ color: ce, seriesNumber: d, dataPointIndex: F }), ne = o.drawRect(B, D, W - B, G - D, n.config.plotOptions.treemap.borderRadius, "#fff", 1, t.strokeWidth, n.config.plotOptions.treemap.useFillColorAsStroke ? ce : n.globals.stroke.colors[d]);
        ne.attr({ cx: B, cy: D, index: d, i: d, j: F, width: W - B, height: G - D, fill: Ce }), ne.node.classList.add("apexcharts-treemap-rect"), t.helpers.addListeners(ne);
        var pe = { x: B + (W - B) / 2, y: D + (G - D) / 2, width: 0, height: 0 }, K = { x: B, y: D, width: W - B, height: G - D };
        if (n.config.chart.animations.enabled && !n.globals.dataChanged) {
          var le = 1;
          n.globals.resized || (le = n.config.chart.animations.speed), t.animateTreemap(ne, pe, K, le);
        }
        if (n.globals.dataChanged) {
          var Q = 1;
          t.dynamicAnim.enabled && n.globals.shouldAnimate && (Q = t.dynamicAnim.speed, n.globals.previousPaths[d] && n.globals.previousPaths[d][F] && n.globals.previousPaths[d][F].rect && (pe = n.globals.previousPaths[d][F].rect), t.animateTreemap(ne, pe, K, Q));
        }
        var se = t.getFontSize(z), Re = n.config.dataLabels.formatter(t.labels[d][F], { value: n.globals.series[d][F], seriesIndex: d, dataPointIndex: F, w: n });
        n.config.plotOptions.treemap.dataLabels.format === "truncate" && (se = parseInt(n.config.dataLabels.style.fontSize, 10), Re = t.truncateLabels(Re, se, B, D, W, G));
        var be = null;
        n.globals.series[d][F] && (be = t.helpers.calculateDataLabels({ text: Re, x: (B + W) / 2, y: (D + G) / 2 + t.strokeWidth / 2 + se / 3, i: d, j: F, colorProps: re, fontSize: se, series: e })), n.config.dataLabels.enabled && be && t.rotateToFitLabel(be, se, Re, B, D, W, G), u.add(ne), be !== null && u.add(be);
      }));
      var m = n.config.plotOptions.treemap.seriesTitle;
      if (n.config.series.length > 1 && m && m.show) {
        var g = n.config.series[d].name || "";
        if (g && f.xMin < 1 / 0 && f.yMin < 1 / 0) {
          var b = m.offsetX, x = m.offsetY, v = m.borderColor, y = m.borderWidth, C = m.borderRadius, k = m.style, T = k.color || n.config.chart.foreColor, S = { left: k.padding.left, right: k.padding.right, top: k.padding.top, bottom: k.padding.bottom }, O = o.getTextRects(g, k.fontSize, k.fontFamily), P = O.width + S.left + S.right, M = O.height + S.top + S.bottom, I = f.xMin + (b || 0), E = f.yMin + (x || 0), N = o.drawRect(I, E, P, M, C, k.background, 1, y, v), L = o.drawText({ x: I + S.left, y: E + S.top + 0.75 * O.height, text: g, fontSize: k.fontSize, fontFamily: k.fontFamily, fontWeight: k.fontWeight, foreColor: T, cssClass: k.cssClass || "" });
          u.add(N), u.add(L);
        }
      }
      u.add(h), a.add(u);
    })), a;
  } }, { key: "getFontSize", value: function(e) {
    var t = this.w, n = (function o(i) {
      var a, s = 0;
      if (Array.isArray(i[0])) for (a = 0; a < i.length; a++) s += o(i[a]);
      else for (a = 0; a < i.length; a++) s += i[a].length;
      return s;
    })(this.labels) / (function o(i) {
      var a, s = 0;
      if (Array.isArray(i[0])) for (a = 0; a < i.length; a++) s += o(i[a]);
      else for (a = 0; a < i.length; a++) s += 1;
      return s;
    })(this.labels);
    return (function(o, i) {
      var a = o * i, s = Math.pow(a, 0.5);
      return Math.min(s / n, parseInt(t.config.dataLabels.style.fontSize, 10));
    })(e[2] - e[0], e[3] - e[1]);
  } }, { key: "rotateToFitLabel", value: function(e, t, n, o, i, a, s) {
    var c = new ee(this.ctx), d = c.getTextRects(n, t);
    if (d.width + this.w.config.stroke.width + 5 > a - o && d.width <= s - i) {
      var u = c.rotateAroundCenter(e.node);
      e.node.setAttribute("transform", "rotate(-90 ".concat(u.x, " ").concat(u.y, ") translate(").concat(d.height / 3, ")"));
    }
  } }, { key: "truncateLabels", value: function(e, t, n, o, i, a) {
    var s = new ee(this.ctx), c = s.getTextRects(e, t).width + this.w.config.stroke.width + 5 > i - n && a - o > i - n ? a - o : i - n, d = s.getTextBasedOnMaxWidth({ text: e, maxWidth: c, fontSize: t });
    return e.length !== d.length && c / t < 5 ? "" : d;
  } }, { key: "animateTreemap", value: function(e, t, n, o) {
    var i = new Ro(this.ctx);
    i.animateRect(e, t, n, o, (function() {
      i.animationCompleted(e);
    }));
  } }]), r;
})(), Qm = 86400, sj = 10 / Qm, lj = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w, this.timeScaleArray = [], this.utc = this.w.config.xaxis.labels.datetimeUTC;
  }
  return ve(r, [{ key: "calculateTimeScaleTicks", value: function(e, t) {
    var n = this, o = this.w;
    if (o.globals.allSeriesCollapsed) return o.globals.labels = [], o.globals.timescaleLabels = [], [];
    var i = new Dt(this.ctx), a = (t - e) / 864e5;
    this.determineInterval(a), o.globals.disableZoomIn = !1, o.globals.disableZoomOut = !1, a < sj ? o.globals.disableZoomIn = !0 : a > 5e4 && (o.globals.disableZoomOut = !0);
    var s = i.getTimeUnitsfromTimestamp(e, t, this.utc), c = o.globals.gridWidth / a, d = c / 24, u = d / 60, p = u / 60, h = Math.floor(24 * a), f = Math.floor(1440 * a), m = Math.floor(a * Qm), g = Math.floor(a), b = Math.floor(a / 30), x = Math.floor(a / 365), v = { minMillisecond: s.minMillisecond, minSecond: s.minSecond, minMinute: s.minMinute, minHour: s.minHour, minDate: s.minDate, minMonth: s.minMonth, minYear: s.minYear }, y = { firstVal: v, currentMillisecond: v.minMillisecond, currentSecond: v.minSecond, currentMinute: v.minMinute, currentHour: v.minHour, currentMonthDate: v.minDate, currentDate: v.minDate, currentMonth: v.minMonth, currentYear: v.minYear, daysWidthOnXAxis: c, hoursWidthOnXAxis: d, minutesWidthOnXAxis: u, secondsWidthOnXAxis: p, numberOfSeconds: m, numberOfMinutes: f, numberOfHours: h, numberOfDays: g, numberOfMonths: b, numberOfYears: x };
    switch (this.tickInterval) {
      case "years":
        this.generateYearScale(y);
        break;
      case "months":
      case "half_year":
        this.generateMonthScale(y);
        break;
      case "months_days":
      case "months_fortnight":
      case "days":
      case "week_days":
        this.generateDayScale(y);
        break;
      case "hours":
        this.generateHourScale(y);
        break;
      case "minutes_fives":
      case "minutes":
        this.generateMinuteScale(y);
        break;
      case "seconds_tens":
      case "seconds_fives":
      case "seconds":
        this.generateSecondScale(y);
    }
    var C = this.timeScaleArray.map((function(k) {
      var T = { position: k.position, unit: k.unit, year: k.year, day: k.day ? k.day : 1, hour: k.hour ? k.hour : 0, month: k.month + 1 };
      return k.unit === "month" ? ie(ie({}, T), {}, { day: 1, value: k.value + 1 }) : k.unit === "day" || k.unit === "hour" ? ie(ie({}, T), {}, { value: k.value }) : k.unit === "minute" ? ie(ie({}, T), {}, { value: k.value, minute: k.value }) : k.unit === "second" ? ie(ie({}, T), {}, { value: k.value, minute: k.minute, second: k.second }) : k;
    }));
    return C.filter((function(k) {
      var T = 1, S = Math.ceil(o.globals.gridWidth / 120), O = k.value;
      o.config.xaxis.tickAmount !== void 0 && (S = o.config.xaxis.tickAmount), C.length > S && (T = Math.floor(C.length / S));
      var P = !1, M = !1;
      switch (n.tickInterval) {
        case "years":
          k.unit === "year" && (P = !0);
          break;
        case "half_year":
          T = 7, k.unit === "year" && (P = !0);
          break;
        case "months":
          T = 1, k.unit === "year" && (P = !0);
          break;
        case "months_fortnight":
          T = 15, k.unit !== "year" && k.unit !== "month" || (P = !0), O === 30 && (M = !0);
          break;
        case "months_days":
          T = 10, k.unit === "month" && (P = !0), O === 30 && (M = !0);
          break;
        case "week_days":
          T = 8, k.unit === "month" && (P = !0);
          break;
        case "days":
          T = 1, k.unit === "month" && (P = !0);
          break;
        case "hours":
          k.unit === "day" && (P = !0);
          break;
        case "minutes_fives":
        case "seconds_fives":
          O % 5 != 0 && (M = !0);
          break;
        case "seconds_tens":
          O % 10 != 0 && (M = !0);
      }
      if (n.tickInterval === "hours" || n.tickInterval === "minutes_fives" || n.tickInterval === "seconds_tens" || n.tickInterval === "seconds_fives") {
        if (!M) return !0;
      } else if ((O % T == 0 || P) && !M) return !0;
    }));
  } }, { key: "recalcDimensionsBasedOnFormat", value: function(e, t) {
    var n = this.w, o = this.formatDates(e), i = this.removeOverlappingTS(o);
    n.globals.timescaleLabels = i.slice(), new cs(this.ctx).plotCoords();
  } }, { key: "determineInterval", value: function(e) {
    var t = 24 * e, n = 60 * t;
    switch (!0) {
      case e / 365 > 5:
        this.tickInterval = "years";
        break;
      case e > 800:
        this.tickInterval = "half_year";
        break;
      case e > 180:
        this.tickInterval = "months";
        break;
      case e > 90:
        this.tickInterval = "months_fortnight";
        break;
      case e > 60:
        this.tickInterval = "months_days";
        break;
      case e > 30:
        this.tickInterval = "week_days";
        break;
      case e > 2:
        this.tickInterval = "days";
        break;
      case t > 2.4:
        this.tickInterval = "hours";
        break;
      case n > 15:
        this.tickInterval = "minutes_fives";
        break;
      case n > 5:
        this.tickInterval = "minutes";
        break;
      case n > 1:
        this.tickInterval = "seconds_tens";
        break;
      case 60 * n > 20:
        this.tickInterval = "seconds_fives";
        break;
      default:
        this.tickInterval = "seconds";
    }
  } }, { key: "generateYearScale", value: function(e) {
    var t = e.firstVal, n = e.currentMonth, o = e.currentYear, i = e.daysWidthOnXAxis, a = e.numberOfYears, s = t.minYear, c = 0, d = new Dt(this.ctx), u = "year";
    if (t.minDate > 1 || t.minMonth > 0) {
      var p = d.determineRemainingDaysOfYear(t.minYear, t.minMonth, t.minDate);
      c = (d.determineDaysOfYear(t.minYear) - p + 1) * i, s = t.minYear + 1, this.timeScaleArray.push({ position: c, value: s, unit: u, year: s, month: $.monthMod(n + 1) });
    } else t.minDate === 1 && t.minMonth === 0 && this.timeScaleArray.push({ position: c, value: s, unit: u, year: o, month: $.monthMod(n + 1) });
    for (var h = s, f = c, m = 0; m < a; m++) h++, f = d.determineDaysOfYear(h - 1) * i + f, this.timeScaleArray.push({ position: f, value: h, unit: u, year: h, month: 1 });
  } }, { key: "generateMonthScale", value: function(e) {
    var t = e.firstVal, n = e.currentMonthDate, o = e.currentMonth, i = e.currentYear, a = e.daysWidthOnXAxis, s = e.numberOfMonths, c = o, d = 0, u = new Dt(this.ctx), p = "month", h = 0;
    if (t.minDate > 1) {
      d = (u.determineDaysOfMonths(o + 1, t.minYear) - n + 1) * a, c = $.monthMod(o + 1);
      var f = i + h, m = $.monthMod(c), g = c;
      c === 0 && (p = "year", g = f, m = 1, f += h += 1), this.timeScaleArray.push({ position: d, value: g, unit: p, year: f, month: m });
    } else this.timeScaleArray.push({ position: d, value: c, unit: p, year: i, month: $.monthMod(o) });
    for (var b = c + 1, x = d, v = 0, y = 1; v < s; v++, y++) {
      (b = $.monthMod(b)) === 0 ? (p = "year", h += 1) : p = "month";
      var C = this._getYear(i, b, h);
      x = u.determineDaysOfMonths(b, C) * a + x;
      var k = b === 0 ? C : b;
      this.timeScaleArray.push({ position: x, value: k, unit: p, year: C, month: b === 0 ? 1 : b }), b++;
    }
  } }, { key: "generateDayScale", value: function(e) {
    var t = e.firstVal, n = e.currentMonth, o = e.currentYear, i = e.hoursWidthOnXAxis, a = e.numberOfDays, s = new Dt(this.ctx), c = "day", d = t.minDate + 1, u = d, p = function(y, C, k) {
      return y > s.determineDaysOfMonths(C + 1, k) && (u = 1, c = "month", f = C += 1), C;
    }, h = (24 - t.minHour) * i, f = d, m = p(u, n, o);
    t.minHour === 0 && t.minDate === 1 ? (h = 0, f = $.monthMod(t.minMonth), c = "month", u = t.minDate) : t.minDate !== 1 && t.minHour === 0 && t.minMinute === 0 && (h = 0, d = t.minDate, f = d, m = p(u = d, n, o), f !== 1 && (c = "day")), this.timeScaleArray.push({ position: h, value: f, unit: c, year: this._getYear(o, m, 0), month: $.monthMod(m), day: u });
    for (var g = h, b = 0; b < a; b++) {
      c = "day", m = p(u += 1, m, this._getYear(o, m, 0));
      var x = this._getYear(o, m, 0);
      g = 24 * i + g;
      var v = u === 1 ? $.monthMod(m) : u;
      this.timeScaleArray.push({ position: g, value: v, unit: c, year: x, month: $.monthMod(m), day: v });
    }
  } }, { key: "generateHourScale", value: function(e) {
    var t = e.firstVal, n = e.currentDate, o = e.currentMonth, i = e.currentYear, a = e.minutesWidthOnXAxis, s = e.numberOfHours, c = new Dt(this.ctx), d = "hour", u = function(T, S) {
      return T > c.determineDaysOfMonths(S + 1, i) && (b = 1, S += 1), { month: S, date: b };
    }, p = function(T, S) {
      return T > c.determineDaysOfMonths(S + 1, i) ? S += 1 : S;
    }, h = 60 - (t.minMinute + t.minSecond / 60), f = h * a, m = t.minHour + 1, g = m;
    h === 60 && (f = 0, g = m = t.minHour);
    var b = n;
    g >= 24 && (g = 0, d = "day", m = b += 1);
    var x = u(b, o).month;
    x = p(b, x), m > 31 && (m = b = 1), this.timeScaleArray.push({ position: f, value: m, unit: d, day: b, hour: g, year: i, month: $.monthMod(x) }), g++;
    for (var v = f, y = 0; y < s; y++) {
      d = "hour", g >= 24 && (g = 0, d = "day", x = u(b += 1, x).month, x = p(b, x));
      var C = this._getYear(i, x, 0);
      v = 60 * a + v;
      var k = g === 0 ? b : g;
      this.timeScaleArray.push({ position: v, value: k, unit: d, hour: g, day: b, year: C, month: $.monthMod(x) }), g++;
    }
  } }, { key: "generateMinuteScale", value: function(e) {
    for (var t = e.currentMillisecond, n = e.currentSecond, o = e.currentMinute, i = e.currentHour, a = e.currentDate, s = e.currentMonth, c = e.currentYear, d = e.minutesWidthOnXAxis, u = e.secondsWidthOnXAxis, p = e.numberOfMinutes, h = o + 1, f = a, m = s, g = c, b = i, x = (60 - n - t / 1e3) * u, v = 0; v < p; v++) h >= 60 && (h = 0, (b += 1) === 24 && (b = 0)), this.timeScaleArray.push({ position: x, value: h, unit: "minute", hour: b, minute: h, day: f, year: this._getYear(g, m, 0), month: $.monthMod(m) }), x += d, h++;
  } }, { key: "generateSecondScale", value: function(e) {
    for (var t = e.currentMillisecond, n = e.currentSecond, o = e.currentMinute, i = e.currentHour, a = e.currentDate, s = e.currentMonth, c = e.currentYear, d = e.secondsWidthOnXAxis, u = e.numberOfSeconds, p = n + 1, h = o, f = a, m = s, g = c, b = i, x = (1e3 - t) / 1e3 * d, v = 0; v < u; v++) p >= 60 && (p = 0, ++h >= 60 && (h = 0, ++b === 24 && (b = 0))), this.timeScaleArray.push({ position: x, value: p, unit: "second", hour: b, minute: h, second: p, day: f, year: this._getYear(g, m, 0), month: $.monthMod(m) }), x += d, p++;
  } }, { key: "createRawDateString", value: function(e, t) {
    var n = e.year;
    return e.month === 0 && (e.month = 1), n += "-" + ("0" + e.month.toString()).slice(-2), e.unit === "day" ? n += e.unit === "day" ? "-" + ("0" + t).slice(-2) : "-01" : n += "-" + ("0" + (e.day ? e.day : "1")).slice(-2), e.unit === "hour" ? n += e.unit === "hour" ? "T" + ("0" + t).slice(-2) : "T00" : n += "T" + ("0" + (e.hour ? e.hour : "0")).slice(-2), e.unit === "minute" ? n += ":" + ("0" + t).slice(-2) : n += ":" + (e.minute ? ("0" + e.minute).slice(-2) : "00"), e.unit === "second" ? n += ":" + ("0" + t).slice(-2) : n += ":00", this.utc && (n += ".000Z"), n;
  } }, { key: "formatDates", value: function(e) {
    var t = this, n = this.w;
    return e.map((function(o) {
      var i = o.value.toString(), a = new Dt(t.ctx), s = t.createRawDateString(o, i), c = a.getDate(a.parseDate(s));
      if (t.utc || (c = a.getDate(a.parseDateWithTimezone(s))), n.config.xaxis.labels.format === void 0) {
        var d = "dd MMM", u = n.config.xaxis.labels.datetimeFormatter;
        o.unit === "year" && (d = u.year), o.unit === "month" && (d = u.month), o.unit === "day" && (d = u.day), o.unit === "hour" && (d = u.hour), o.unit === "minute" && (d = u.minute), o.unit === "second" && (d = u.second), i = a.formatDate(c, d);
      } else i = a.formatDate(c, n.config.xaxis.labels.format);
      return { dateString: s, position: o.position, value: i, unit: o.unit, year: o.year, month: o.month };
    }));
  } }, { key: "removeOverlappingTS", value: function(e) {
    var t, n = this, o = new ee(this.ctx), i = !1;
    e.length > 0 && e[0].value && e.every((function(c) {
      return c.value.length === e[0].value.length;
    })) && (i = !0, t = o.getTextRects(e[0].value).width);
    var a = 0, s = e.map((function(c, d) {
      if (d > 0 && n.w.config.xaxis.labels.hideOverlappingLabels) {
        var u = i ? t : o.getTextRects(e[a].value).width, p = e[a].position;
        return c.position > p + u + 10 ? (a = d, c) : null;
      }
      return c;
    }));
    return s = s.filter((function(c) {
      return c !== null;
    }));
  } }, { key: "_getYear", value: function(e, t, n) {
    return e + Math.floor(t / 12) + n;
  } }]), r;
})(), cj = (function() {
  function r(e, t) {
    xe(this, r), this.ctx = t, this.w = t.w, this.el = e;
  }
  return ve(r, [{ key: "setupElements", value: function() {
    var e = this.w, t = e.globals, n = e.config, o = n.chart.type;
    t.axisCharts = ["line", "area", "bar", "rangeBar", "rangeArea", "candlestick", "boxPlot", "scatter", "bubble", "radar", "heatmap", "treemap"].includes(o), t.xyCharts = ["line", "area", "bar", "rangeBar", "rangeArea", "candlestick", "boxPlot", "scatter", "bubble"].includes(o), t.isBarHorizontal = ["bar", "rangeBar", "boxPlot"].includes(o) && n.plotOptions.bar.horizontal, t.chartClass = ".apexcharts".concat(t.chartID), t.dom.baseEl = this.el, t.dom.elWrap = document.createElement("div"), ee.setAttrs(t.dom.elWrap, { id: t.chartClass.substring(1), class: "apexcharts-canvas ".concat(t.chartClass.substring(1)) }), this.el.appendChild(t.dom.elWrap), t.dom.Paper = window.SVG().addTo(t.dom.elWrap), t.dom.Paper.attr({ class: "apexcharts-svg", "xmlns:data": "ApexChartsNS", transform: "translate(".concat(n.chart.offsetX, ", ").concat(n.chart.offsetY, ")") }), t.dom.Paper.node.style.background = n.theme.mode !== "dark" || n.chart.background ? n.theme.mode !== "light" || n.chart.background ? n.chart.background : "#fff" : "#343A3F", this.setSVGDimensions(), t.dom.elLegendForeign = document.createElementNS(t.SVGNS, "foreignObject"), ee.setAttrs(t.dom.elLegendForeign, { x: 0, y: 0, width: t.svgWidth, height: t.svgHeight }), t.dom.elLegendWrap = document.createElement("div"), t.dom.elLegendWrap.classList.add("apexcharts-legend"), t.dom.elWrap.appendChild(t.dom.elLegendWrap), t.dom.Paper.node.appendChild(t.dom.elLegendForeign), t.dom.elGraphical = t.dom.Paper.group().attr({ class: "apexcharts-inner apexcharts-graphical" }), t.dom.elDefs = t.dom.Paper.defs(), t.dom.Paper.add(t.dom.elGraphical), t.dom.elGraphical.add(t.dom.elDefs);
  } }, { key: "plotChartType", value: function(e, t) {
    var n = this.w, o = this.ctx, i = n.config, a = n.globals, s = { line: { series: [], i: [] }, area: { series: [], i: [] }, scatter: { series: [], i: [] }, bubble: { series: [], i: [] }, bar: { series: [], i: [] }, candlestick: { series: [], i: [] }, boxPlot: { series: [], i: [] }, rangeBar: { series: [], i: [] }, rangeArea: { series: [], seriesRangeEnd: [], i: [] } }, c = i.chart.type || "line", d = null, u = 0;
    a.series.forEach((function(T, S) {
      var O, P, M = ((O = e[S]) === null || O === void 0 ? void 0 : O.type) === "column" ? "bar" : ((P = e[S]) === null || P === void 0 ? void 0 : P.type) || (c === "column" ? "bar" : c);
      s[M] ? (M === "rangeArea" ? (s[M].series.push(a.seriesRangeStart[S]), s[M].seriesRangeEnd.push(a.seriesRangeEnd[S])) : s[M].series.push(T), s[M].i.push(S), M === "bar" && (n.globals.columnSeries = s.bar)) : ["heatmap", "treemap", "pie", "donut", "polarArea", "radialBar", "radar"].includes(M) ? d = M : console.warn("You have specified an unrecognized series type (".concat(M, ").")), c !== M && M !== "scatter" && u++;
    })), u > 0 && (d && console.warn("Chart or series type ".concat(d, " cannot appear with other chart or series types.")), s.bar.series.length > 0 && i.plotOptions.bar.horizontal && (u -= s.bar.series.length, s.bar = { series: [], i: [] }, n.globals.columnSeries = { series: [], i: [] }, console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"))), a.comboCharts || (a.comboCharts = u > 0);
    var p = new Ol(o, t), h = new Tl(o, t);
    o.pie = new Jm(o);
    var f = new ej(o);
    o.rangeBar = new tj(o, t);
    var m = new QL(o), g = [];
    if (a.comboCharts) {
      var b, x, v = new Tt(o);
      if (s.area.series.length > 0 && (b = g).push.apply(b, Mt(v.drawSeriesByGroup(s.area, a.areaGroups, "area", p))), s.bar.series.length > 0) if (i.chart.stacked) {
        var y = new zh(o, t);
        g.push(y.draw(s.bar.series, s.bar.i));
      } else o.bar = new yo(o, t), g.push(o.bar.draw(s.bar.series, s.bar.i));
      if (s.rangeArea.series.length > 0 && g.push(p.draw(s.rangeArea.series, "rangeArea", s.rangeArea.i, s.rangeArea.seriesRangeEnd)), s.line.series.length > 0 && (x = g).push.apply(x, Mt(v.drawSeriesByGroup(s.line, a.lineGroups, "line", p))), s.candlestick.series.length > 0 && g.push(h.draw(s.candlestick.series, "candlestick", s.candlestick.i)), s.boxPlot.series.length > 0 && g.push(h.draw(s.boxPlot.series, "boxPlot", s.boxPlot.i)), s.rangeBar.series.length > 0 && g.push(o.rangeBar.draw(s.rangeBar.series, s.rangeBar.i)), s.scatter.series.length > 0) {
        var C = new Ol(o, t, !0);
        g.push(C.draw(s.scatter.series, "scatter", s.scatter.i));
      }
      if (s.bubble.series.length > 0) {
        var k = new Ol(o, t, !0);
        g.push(k.draw(s.bubble.series, "bubble", s.bubble.i));
      }
    } else switch (i.chart.type) {
      case "line":
        g = p.draw(a.series, "line");
        break;
      case "area":
        g = p.draw(a.series, "area");
        break;
      case "bar":
        i.chart.stacked ? g = new zh(o, t).draw(a.series) : (o.bar = new yo(o, t), g = o.bar.draw(a.series));
        break;
      case "candlestick":
        g = new Tl(o, t).draw(a.series, "candlestick");
        break;
      case "boxPlot":
        g = new Tl(o, t).draw(a.series, i.chart.type);
        break;
      case "rangeBar":
        g = o.rangeBar.draw(a.series);
        break;
      case "rangeArea":
        g = p.draw(a.seriesRangeStart, "rangeArea", void 0, a.seriesRangeEnd);
        break;
      case "heatmap":
        g = new JL(o, t).draw(a.series);
        break;
      case "treemap":
        g = new aj(o, t).draw(a.series);
        break;
      case "pie":
      case "donut":
      case "polarArea":
        g = o.pie.draw(a.series);
        break;
      case "radialBar":
        g = f.draw(a.series);
        break;
      case "radar":
        g = m.draw(a.series);
        break;
      default:
        g = p.draw(a.series);
    }
    return g;
  } }, { key: "setSVGDimensions", value: function() {
    var e = this.w, t = e.globals, n = e.config;
    n.chart.width = n.chart.width || "100%", n.chart.height = n.chart.height || "auto", t.svgWidth = n.chart.width, t.svgHeight = n.chart.height;
    var o = $.getDimensions(this.el), i = n.chart.width.toString().split(/[0-9]+/g).pop();
    i === "%" ? $.isNumber(o[0]) && (o[0].width === 0 && (o = $.getDimensions(this.el.parentNode)), t.svgWidth = o[0] * parseInt(n.chart.width, 10) / 100) : i !== "px" && i !== "" || (t.svgWidth = parseInt(n.chart.width, 10));
    var a = String(n.chart.height).toString().split(/[0-9]+/g).pop();
    if (t.svgHeight !== "auto" && t.svgHeight !== "") if (a === "%") {
      var s = $.getDimensions(this.el.parentNode);
      t.svgHeight = s[1] * parseInt(n.chart.height, 10) / 100;
    } else t.svgHeight = parseInt(n.chart.height, 10);
    else t.svgHeight = t.axisCharts ? t.svgWidth / 1.61 : t.svgWidth / 1.2;
    if (t.svgWidth = Math.max(t.svgWidth, 0), t.svgHeight = Math.max(t.svgHeight, 0), ee.setAttrs(t.dom.Paper.node, { width: t.svgWidth, height: t.svgHeight }), a !== "%") {
      var c = n.chart.sparkline.enabled ? 0 : t.axisCharts ? n.chart.parentHeightOffset : 0;
      t.dom.Paper.node.parentNode.parentNode.style.minHeight = "".concat(t.svgHeight + c, "px");
    }
    t.dom.elWrap.style.width = "".concat(t.svgWidth, "px"), t.dom.elWrap.style.height = "".concat(t.svgHeight, "px");
  } }, { key: "shiftGraphPosition", value: function() {
    var e = this.w.globals, t = e.translateY, n = e.translateX;
    ee.setAttrs(e.dom.elGraphical.node, { transform: "translate(".concat(n, ", ").concat(t, ")") });
  } }, { key: "resizeNonAxisCharts", value: function() {
    var e = this.w, t = e.globals, n = 0, o = e.config.chart.sparkline.enabled ? 1 : 15;
    o += e.config.grid.padding.bottom, ["top", "bottom"].includes(e.config.legend.position) && e.config.legend.show && !e.config.legend.floating && (n = new Vm(this.ctx).legendHelpers.getLegendDimensions().clwh + 7);
    var i = e.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"), a = 2.05 * e.globals.radialSize;
    if (i && !e.config.chart.sparkline.enabled && e.config.plotOptions.radialBar.startAngle !== 0) {
      var s = $.getBoundingClientRect(i);
      a = s.bottom;
      var c = s.bottom - s.top;
      a = Math.max(2.05 * e.globals.radialSize, c);
    }
    var d = Math.ceil(a + t.translateY + n + o);
    t.dom.elLegendForeign && t.dom.elLegendForeign.setAttribute("height", d), e.config.chart.height && String(e.config.chart.height).includes("%") || (t.dom.elWrap.style.height = "".concat(d, "px"), ee.setAttrs(t.dom.Paper.node, { height: d }), t.dom.Paper.node.parentNode.parentNode.style.minHeight = "".concat(d, "px"));
  } }, { key: "coreCalculations", value: function() {
    new mc(this.ctx).init();
  } }, { key: "resetGlobals", value: function() {
    var e = this, t = function() {
      return e.w.config.series.map((function() {
        return [];
      }));
    }, n = new $m(), o = this.w.globals, i = { dataWasParsed: o.dataWasParsed, originalSeries: o.originalSeries };
    n.initGlobalVars(o), o.seriesXvalues = t(), o.seriesYvalues = t(), i.dataWasParsed && (o.dataWasParsed = i.dataWasParsed, o.originalSeries = i.originalSeries);
  } }, { key: "isMultipleY", value: function() {
    return !!(Array.isArray(this.w.config.yaxis) && this.w.config.yaxis.length > 1) && (this.w.globals.isMultipleYAxis = !0, !0);
  } }, { key: "xySettings", value: function() {
    var e = this.w, t = null;
    if (e.globals.axisCharts) {
      if (e.config.xaxis.crosshairs.position === "back" && new bc(this.ctx).drawXCrosshairs(), e.config.yaxis[0].crosshairs.position === "back" && new bc(this.ctx).drawYCrosshairs(), e.config.xaxis.type === "datetime" && e.config.xaxis.labels.formatter === void 0) {
        this.ctx.timeScale = new lj(this.ctx);
        var n = [];
        isFinite(e.globals.minX) && isFinite(e.globals.maxX) && !e.globals.isBarHorizontal ? n = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minX, e.globals.maxX) : e.globals.isBarHorizontal && (n = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minY, e.globals.maxY)), this.ctx.timeScale.recalcDimensionsBasedOnFormat(n);
      }
      t = new Tt(this.ctx).getCalculatedRatios();
    }
    return t;
  } }, { key: "updateSourceChart", value: function(e) {
    this.ctx.w.globals.selection = void 0, this.ctx.updateHelpers._updateOptions({ chart: { selection: { xaxis: { min: e.w.globals.minX, max: e.w.globals.maxX } } } }, !1, !1);
  } }, { key: "setupBrushHandler", value: function() {
    var e = this, t = this.ctx, n = this.w;
    if (n.config.chart.brush.enabled && typeof n.config.chart.events.selection != "function") {
      var o = Array.isArray(n.config.chart.brush.targets) ? n.config.chart.brush.targets : [n.config.chart.brush.target];
      o.forEach((function(i) {
        var a = t.constructor.getChartByID(i);
        a.w.globals.brushSource = e.ctx, typeof a.w.config.chart.events.zoomed != "function" && (a.w.config.chart.events.zoomed = function() {
          return e.updateSourceChart(a);
        }), typeof a.w.config.chart.events.scrolled != "function" && (a.w.config.chart.events.scrolled = function() {
          return e.updateSourceChart(a);
        });
      })), n.config.chart.events.selection = function(i, a) {
        o.forEach((function(s) {
          t.constructor.getChartByID(s).ctx.updateHelpers._updateOptions({ xaxis: { min: a.xaxis.min, max: a.xaxis.max } }, !1, !1, !1, !1);
        }));
      };
    }
  } }]), r;
})(), dj = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "_updateOptions", value: function(e) {
    var t = this, n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], o = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], i = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], a = arguments.length > 4 && arguments[4] !== void 0 && arguments[4];
    return new Promise((function(s) {
      var c = [t.ctx];
      i && (c = t.ctx.getSyncedCharts()), t.ctx.w.globals.isExecCalled && (c = [t.ctx], t.ctx.w.globals.isExecCalled = !1), c.forEach((function(d, u) {
        var p = d.w;
        if (p.globals.shouldAnimate = o, n || (p.globals.resized = !0, p.globals.dataChanged = !0, o && d.series.getPreviousPaths()), e && Vt(e) === "object" && (d.config = new Vi(e), e = Tt.extendArrayProps(d.config, e, p), d.w.globals.chartID !== t.ctx.w.globals.chartID && delete e.series, p.config = $.extend(p.config, e), a && (p.globals.lastXAxis = e.xaxis ? $.clone(e.xaxis) : [], p.globals.lastYAxis = e.yaxis ? $.clone(e.yaxis) : [], p.globals.initialConfig = $.extend({}, p.config), p.globals.initialSeries = $.clone(p.config.series), e.series))) {
          for (var h = 0; h < p.globals.collapsedSeriesIndices.length; h++) {
            var f = p.config.series[p.globals.collapsedSeriesIndices[h]];
            p.globals.collapsedSeries[h].data = p.globals.axisCharts ? f.data.slice() : f;
          }
          for (var m = 0; m < p.globals.ancillaryCollapsedSeriesIndices.length; m++) {
            var g = p.config.series[p.globals.ancillaryCollapsedSeriesIndices[m]];
            p.globals.ancillaryCollapsedSeries[m].data = p.globals.axisCharts ? g.data.slice() : g;
          }
          d.series.emptyCollapsedSeries(p.config.series);
        }
        return d.update(e).then((function() {
          u === c.length - 1 && s(d);
        }));
      }));
    }));
  } }, { key: "_updateSeries", value: function(e, t) {
    var n = this, o = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
    return new Promise((function(i) {
      var a = n.w;
      return a.globals.shouldAnimate = t, a.globals.dataChanged = !0, t && n.ctx.series.getPreviousPaths(), n.ctx.data.resetParsingFlags(), n.ctx.data.parseData(e), o && (a.globals.initialConfig.series = $.clone(a.config.series), a.globals.initialSeries = $.clone(a.config.series)), n.ctx.update().then((function() {
        i(n.ctx);
      }));
    }));
  } }, { key: "_extendSeries", value: function(e, t) {
    var n = this.w, o = n.config.series[t];
    return ie(ie({}, n.config.series[t]), {}, { name: e.name ? e.name : o?.name, color: e.color ? e.color : o?.color, type: e.type ? e.type : o?.type, group: e.group ? e.group : o?.group, hidden: e.hidden !== void 0 ? e.hidden : o?.hidden, data: e.data ? e.data : o?.data, zIndex: e.zIndex !== void 0 ? e.zIndex : t });
  } }, { key: "toggleDataPointSelection", value: function(e, t) {
    var n = this.w, o = null, i = ".apexcharts-series[data\\:realIndex='".concat(e, "']");
    return n.globals.axisCharts ? o = n.globals.dom.Paper.findOne("".concat(i, " path[j='").concat(t, "'], ").concat(i, " circle[j='").concat(t, "'], ").concat(i, " rect[j='").concat(t, "']")) : t === void 0 && (o = n.globals.dom.Paper.findOne("".concat(i, " path[j='").concat(e, "']")), n.config.chart.type !== "pie" && n.config.chart.type !== "polarArea" && n.config.chart.type !== "donut" || this.ctx.pie.pieClicked(e)), o ? (new ee(this.ctx).pathMouseDown(o, null), o.node ? o.node : null) : (console.warn("toggleDataPointSelection: Element not found"), null);
  } }, { key: "forceXAxisUpdate", value: function(e) {
    var t = this.w;
    if (["min", "max"].forEach((function(o) {
      e.xaxis[o] !== void 0 && (t.config.xaxis[o] = e.xaxis[o], t.globals.lastXAxis[o] = e.xaxis[o]);
    })), e.xaxis.categories && e.xaxis.categories.length && (t.config.xaxis.categories = e.xaxis.categories), t.config.xaxis.convertedCatToNumeric) {
      var n = new Xi(e);
      e = n.convertCatToNumericXaxis(e, this.ctx);
    }
    return e;
  } }, { key: "forceYAxisUpdate", value: function(e) {
    return e.chart && e.chart.stacked && e.chart.stackType === "100%" && (Array.isArray(e.yaxis) ? e.yaxis.forEach((function(t, n) {
      e.yaxis[n].min = 0, e.yaxis[n].max = 100;
    })) : (e.yaxis.min = 0, e.yaxis.max = 100)), e;
  } }, { key: "revertDefaultAxisMinMax", value: function(e) {
    var t = this, n = this.w, o = n.globals.lastXAxis, i = n.globals.lastYAxis;
    e && e.xaxis && (o = e.xaxis), e && e.yaxis && (i = e.yaxis), n.config.xaxis.min = o.min, n.config.xaxis.max = o.max;
    var a = function(s) {
      i[s] !== void 0 && (n.config.yaxis[s].min = i[s].min, n.config.yaxis[s].max = i[s].max);
    };
    n.config.yaxis.map((function(s, c) {
      n.globals.zoomed || i[c] !== void 0 ? a(c) : t.ctx.opts.yaxis[c] !== void 0 && (s.min = t.ctx.opts.yaxis[c].min, s.max = t.ctx.opts.yaxis[c].max);
    }));
  } }]), r;
})();
(function() {
  function r() {
    for (var i = arguments.length > 0 && arguments[0] !== p ? arguments[0] : [], a = arguments.length > 1 ? arguments[1] : p, s = arguments.length > 2 ? arguments[2] : p, c = arguments.length > 3 ? arguments[3] : p, d = arguments.length > 4 ? arguments[4] : p, u = arguments.length > 5 ? arguments[5] : p, p = arguments.length > 6 ? arguments[6] : p, h = i.slice(a, s || p), f = c.slice(d, u || p), m = 0, g = { pos: [0, 0], start: [0, 0] }, b = { pos: [0, 0], start: [0, 0] }; h[m] = e.call(g, h[m]), f[m] = e.call(b, f[m]), h[m][0] != f[m][0] || h[m][0] == "M" || h[m][0] == "A" && (h[m][4] != f[m][4] || h[m][5] != f[m][5]) ? (Array.prototype.splice.apply(h, [m, 1].concat(n.call(g, h[m]))), Array.prototype.splice.apply(f, [m, 1].concat(n.call(b, f[m])))) : (h[m] = t.call(g, h[m]), f[m] = t.call(b, f[m])), !(++m == h.length && m == f.length); )
      m == h.length && h.push(["C", g.pos[0], g.pos[1], g.pos[0], g.pos[1], g.pos[0], g.pos[1]]), m == f.length && f.push(["C", b.pos[0], b.pos[1], b.pos[0], b.pos[1], b.pos[0], b.pos[1]]);
    return { start: h, dest: f };
  }
  function e(i) {
    switch (i[0]) {
      case "z":
      case "Z":
        i[0] = "L", i[1] = this.start[0], i[2] = this.start[1];
        break;
      case "H":
        i[0] = "L", i[2] = this.pos[1];
        break;
      case "V":
        i[0] = "L", i[2] = i[1], i[1] = this.pos[0];
        break;
      case "T":
        i[0] = "Q", i[3] = i[1], i[4] = i[2], i[1] = this.reflection[1], i[2] = this.reflection[0];
        break;
      case "S":
        i[0] = "C", i[6] = i[4], i[5] = i[3], i[4] = i[2], i[3] = i[1], i[2] = this.reflection[1], i[1] = this.reflection[0];
    }
    return i;
  }
  function t(i) {
    var a = i.length;
    return this.pos = [i[a - 2], i[a - 1]], "SCQT".indexOf(i[0]) != -1 && (this.reflection = [2 * this.pos[0] - i[a - 4], 2 * this.pos[1] - i[a - 3]]), i;
  }
  function n(i) {
    var a = [i];
    switch (i[0]) {
      case "M":
        return this.pos = this.start = [i[1], i[2]], a;
      case "L":
        i[5] = i[3] = i[1], i[6] = i[4] = i[2], i[1] = this.pos[0], i[2] = this.pos[1];
        break;
      case "Q":
        i[6] = i[4], i[5] = i[3], i[4] = 1 * i[4] / 3 + 2 * i[2] / 3, i[3] = 1 * i[3] / 3 + 2 * i[1] / 3, i[2] = 1 * this.pos[1] / 3 + 2 * i[2] / 3, i[1] = 1 * this.pos[0] / 3 + 2 * i[1] / 3;
        break;
      case "A":
        a = (function(s, c) {
          var d, u, p, h, f, m, g, b, x, v, y, C, k, T, S, O, P, M, I, E, N, L, z, F, B, D, W = Math.abs(c[1]), G = Math.abs(c[2]), re = c[3] % 360, ce = c[4], Ce = c[5], ne = c[6], pe = c[7], K = new nt(s), le = new nt(ne, pe), Q = [];
          if (W === 0 || G === 0 || K.x === le.x && K.y === le.y) return [["C", K.x, K.y, le.x, le.y, le.x, le.y]];
          for (d = new nt((K.x - le.x) / 2, (K.y - le.y) / 2).transform(new Ee().rotate(re)), u = d.x * d.x / (W * W) + d.y * d.y / (G * G), u > 1 && (W *= u = Math.sqrt(u), G *= u), p = new Ee().rotate(re).scale(1 / W, 1 / G).rotate(-re), K = K.transform(p), le = le.transform(p), h = [le.x - K.x, le.y - K.y], m = h[0] * h[0] + h[1] * h[1], f = Math.sqrt(m), h[0] /= f, h[1] /= f, g = m < 4 ? Math.sqrt(1 - m / 4) : 0, ce === Ce && (g *= -1), b = new nt((le.x + K.x) / 2 + g * -h[1], (le.y + K.y) / 2 + g * h[0]), x = new nt(K.x - b.x, K.y - b.y), v = new nt(le.x - b.x, le.y - b.y), y = Math.acos(x.x / Math.sqrt(x.x * x.x + x.y * x.y)), x.y < 0 && (y *= -1), C = Math.acos(v.x / Math.sqrt(v.x * v.x + v.y * v.y)), v.y < 0 && (C *= -1), Ce && y > C && (C += 2 * Math.PI), !Ce && y < C && (C -= 2 * Math.PI), T = Math.ceil(2 * Math.abs(y - C) / Math.PI), O = [], P = y, k = (C - y) / T, S = 4 * Math.tan(k / 4) / 3, N = 0; N <= T; N++) I = Math.cos(P), M = Math.sin(P), E = new nt(b.x + I, b.y + M), O[N] = [new nt(E.x + S * M, E.y - S * I), E, new nt(E.x - S * M, E.y + S * I)], P += k;
          for (O[0][0] = O[0][1].clone(), O[O.length - 1][2] = O[O.length - 1][1].clone(), p = new Ee().rotate(re).scale(W, G).rotate(-re), N = 0, L = O.length; N < L; N++) O[N][0] = O[N][0].transform(p), O[N][1] = O[N][1].transform(p), O[N][2] = O[N][2].transform(p);
          for (N = 1, L = O.length; N < L; N++) z = (E = O[N - 1][2]).x, F = E.y, B = (E = O[N][0]).x, D = E.y, ne = (E = O[N][1]).x, pe = E.y, Q.push(["C", z, F, B, D, ne, pe]);
          return Q;
        })(this.pos, i), i = a[0];
    }
    return i[0] = "C", this.pos = [i[5], i[6]], this.reflection = [2 * i[5] - i[3], 2 * i[6] - i[4]], a;
  }
  function o() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], a = arguments.length > 1 ? arguments[1] : void 0;
    if (a === !1) return !1;
    for (var s = a, c = i.length; s < c; ++s) if (i[s][0] == "M") return s;
    return !1;
  }
  Le(Ar, { morph: function(i, a, s, c, d) {
    for (var u = this.parse(i), p = this.parse(a), h = 0, f = 0, m = !1, g = !1; h !== !1 || f !== !1; ) {
      var b;
      m = o(u, h !== !1 && h + 1), g = o(p, f !== !1 && f + 1), h === !1 && (h = (b = new Ar(x.start).bbox()).height == 0 || b.width == 0 ? u.push(u[0]) - 1 : u.push(["M", b.x + b.width / 2, b.y + b.height / 2]) - 1), f === !1 && (f = (b = new Ar(x.dest).bbox()).height == 0 || b.width == 0 ? p.push(p[0]) - 1 : p.push(["M", b.x + b.width / 2, b.y + b.height / 2]) - 1);
      var x = r(u, h, m, p, f, g);
      u = u.slice(0, h).concat(x.start, m === !1 ? [] : u.slice(m)), p = p.slice(0, f).concat(x.dest, g === !1 ? [] : p.slice(g)), h = m !== !1 && h + x.start.length, f = g !== !1 && f + x.dest.length;
    }
    this._array = u, this.destination = new Ar(), this.destination._array = p;
    var v = this.fromArray(u.map((function(y, C) {
      var k = p[C].map((function(T, S) {
        return S === 0 ? T : c.step(y[S], p[C][S], s, d[C], d);
      }));
      return k;
    })));
    return v;
  } });
})();
const Bh = (r) => (r.changedTouches && (r = r.changedTouches[0]), { x: r.clientX, y: r.clientY });
class uj {
  constructor(e) {
    e.remember("_draggable", this), this.el = e, this.drag = this.drag.bind(this), this.startDrag = this.startDrag.bind(this), this.endDrag = this.endDrag.bind(this);
  }
  init(e) {
    e ? (this.el.on("mousedown.drag", this.startDrag), this.el.on("touchstart.drag", this.startDrag, { passive: !1 })) : (this.el.off("mousedown.drag"), this.el.off("touchstart.drag"));
  }
  startDrag(e) {
    const t = !e.type.indexOf("mouse");
    if (t && e.which !== 1 && e.buttons !== 0 || this.el.dispatch("beforedrag", { event: e, handler: this }).defaultPrevented) return;
    e.preventDefault(), e.stopPropagation(), this.init(!1), this.box = this.el.bbox(), this.lastClick = this.el.point(Bh(e));
    const n = (t ? "mouseup" : "touchend") + ".drag";
    Wr(window, (t ? "mousemove" : "touchmove") + ".drag", this.drag, this, { passive: !1 }), Wr(window, n, this.endDrag, this, { passive: !1 }), this.el.fire("dragstart", { event: e, handler: this, box: this.box });
  }
  drag(e) {
    const { box: t, lastClick: n } = this, o = this.el.point(Bh(e)), i = o.x - n.x, a = o.y - n.y;
    if (!i && !a) return t;
    const s = t.x + i, c = t.y + a;
    this.box = new St(s, c, t.w, t.h), this.lastClick = o, this.el.dispatch("dragmove", { event: e, handler: this, box: this.box }).defaultPrevented || this.move(s, c);
  }
  move(e, t) {
    this.el.type === "svg" ? sn.prototype.move.call(this.el, e, t) : this.el.move(e, t);
  }
  endDrag(e) {
    this.drag(e), this.el.fire("dragend", { event: e, handler: this, box: this.box }), fr(window, "mousemove.drag"), fr(window, "touchmove.drag"), fr(window, "mouseup.drag"), fr(window, "touchend.drag"), this.init(!0);
  }
}
function xc(r, e, t, n = null) {
  return function(o) {
    o.preventDefault(), o.stopPropagation();
    var i = o.pageX || o.touches[0].pageX, a = o.pageY || o.touches[0].pageY;
    e.fire(r, { x: i, y: a, event: o, index: n, points: t });
  };
}
function vc([r, e], { a: t, b: n, c: o, d: i, e: a, f: s }) {
  return [r * t + e * o + a, r * n + e * i + s];
}
Le(Bt, { draggable(r = !0) {
  return (this.remember("_draggable") || new uj(this)).init(r), this;
} });
let eb = class {
  constructor(r) {
    this.el = r, r.remember("_selectHandler", this), this.selection = new sn(), this.order = ["lt", "t", "rt", "r", "rb", "b", "lb", "l", "rot"], this.mutationHandler = this.mutationHandler.bind(this);
    const e = ia();
    this.observer = new e.MutationObserver(this.mutationHandler);
  }
  init(r) {
    this.createHandle = r.createHandle || this.createHandleFn, this.createRot = r.createRot || this.createRotFn, this.updateHandle = r.updateHandle || this.updateHandleFn, this.updateRot = r.updateRot || this.updateRotFn, this.el.root().put(this.selection), this.updatePoints(), this.createSelection(), this.createResizeHandles(), this.updateResizeHandles(), this.createRotationHandle(), this.updateRotationHandle(), this.observer.observe(this.el.node, { attributes: !0 });
  }
  active(r, e) {
    if (!r) return this.selection.clear().remove(), void this.observer.disconnect();
    this.init(e);
  }
  createSelection() {
    this.selection.polygon(this.handlePoints).addClass("svg_select_shape");
  }
  updateSelection() {
    this.selection.get(0).plot(this.handlePoints);
  }
  createResizeHandles() {
    this.handlePoints.forEach(((r, e, t) => {
      const n = this.order[e];
      this.createHandle.call(this, this.selection, r, e, t, n), this.selection.get(e + 1).addClass("svg_select_handle svg_select_handle_" + n).on("mousedown.selection touchstart.selection", xc(n, this.el, this.handlePoints, e));
    }));
  }
  createHandleFn(r) {
    r.polyline();
  }
  updateHandleFn(r, e, t, n) {
    const o = n.at(t - 1), i = n[(t + 1) % n.length], a = e, s = [a[0] - o[0], a[1] - o[1]], c = [a[0] - i[0], a[1] - i[1]], d = Math.sqrt(s[0] * s[0] + s[1] * s[1]), u = Math.sqrt(c[0] * c[0] + c[1] * c[1]), p = [s[0] / d, s[1] / d], h = [c[0] / u, c[1] / u], f = [a[0] - 10 * p[0], a[1] - 10 * p[1]], m = [a[0] - 10 * h[0], a[1] - 10 * h[1]];
    r.plot([f, a, m]);
  }
  updateResizeHandles() {
    this.handlePoints.forEach(((r, e, t) => {
      const n = this.order[e];
      this.updateHandle.call(this, this.selection.get(e + 1), r, e, t, n);
    }));
  }
  createRotFn(r) {
    r.line(), r.circle(5);
  }
  getPoint(r) {
    return this.handlePoints[this.order.indexOf(r)];
  }
  getPointHandle(r) {
    return this.selection.get(this.order.indexOf(r) + 1);
  }
  updateRotFn(r, e) {
    const t = this.getPoint("t");
    r.get(0).plot(t[0], t[1], e[0], e[1]), r.get(1).center(e[0], e[1]);
  }
  createRotationHandle() {
    const r = this.selection.group().addClass("svg_select_handle_rot").on("mousedown.selection touchstart.selection", xc("rot", this.el, this.handlePoints));
    this.createRot.call(this, r);
  }
  updateRotationHandle() {
    const r = this.selection.findOne("g.svg_select_handle_rot");
    this.updateRot(r, this.rotationPoint, this.handlePoints);
  }
  updatePoints() {
    const r = this.el.bbox(), e = this.el.parent().screenCTM().inverseO().multiplyO(this.el.screenCTM());
    this.handlePoints = this.getHandlePoints(r).map(((t) => vc(t, e))), this.rotationPoint = vc(this.getRotationPoint(r), e);
  }
  getHandlePoints({ x: r, x2: e, y: t, y2: n, cx: o, cy: i } = this.el.bbox()) {
    return [[r, t], [o, t], [e, t], [e, i], [e, n], [o, n], [r, n], [r, i]];
  }
  getRotationPoint({ y: r, cx: e } = this.el.bbox()) {
    return [e, r - 20];
  }
  mutationHandler() {
    this.updatePoints(), this.updateSelection(), this.updateResizeHandles(), this.updateRotationHandle();
  }
};
const Fh = (r) => function(e = !0, t = {}) {
  typeof e == "object" && (t = e, e = !0);
  let n = this.remember("_" + r.name);
  return n || (e.prototype instanceof eb ? (n = new e(this), e = !0) : n = new r(this), this.remember("_" + r.name, n)), n.active(e, t), this;
};
function yc(r, e, t, n = null) {
  return function(o) {
    o.preventDefault(), o.stopPropagation();
    var i = o.pageX || o.touches[0].pageX, a = o.pageY || o.touches[0].pageY;
    e.fire(r, { x: i, y: a, event: o, index: n, points: t });
  };
}
function wc([r, e], { a: t, b: n, c: o, d: i, e: a, f: s }) {
  return [r * t + e * o + a, r * n + e * i + s];
}
Le(Bt, { select: Fh(eb) }), Le([Mn, En, Pn], { pointSelect: Fh(class {
  constructor(r) {
    this.el = r, r.remember("_pointSelectHandler", this), this.selection = new sn(), this.order = ["lt", "t", "rt", "r", "rb", "b", "lb", "l", "rot"], this.mutationHandler = this.mutationHandler.bind(this);
    const e = ia();
    this.observer = new e.MutationObserver(this.mutationHandler);
  }
  init(r) {
    this.createHandle = r.createHandle || this.createHandleFn, this.updateHandle = r.updateHandle || this.updateHandleFn, this.el.root().put(this.selection), this.updatePoints(), this.createSelection(), this.createPointHandles(), this.updatePointHandles(), this.observer.observe(this.el.node, { attributes: !0 });
  }
  active(r, e) {
    if (!r) return this.selection.clear().remove(), void this.observer.disconnect();
    this.init(e);
  }
  createSelection() {
    this.selection.polygon(this.points).addClass("svg_select_shape_pointSelect");
  }
  updateSelection() {
    this.selection.get(0).plot(this.points);
  }
  createPointHandles() {
    this.points.forEach(((r, e, t) => {
      this.createHandle.call(this, this.selection, r, e, t), this.selection.get(e + 1).addClass("svg_select_handle_point").on("mousedown.selection touchstart.selection", xc("point", this.el, this.points, e));
    }));
  }
  createHandleFn(r) {
    r.circle(5);
  }
  updateHandleFn(r, e) {
    r.center(e[0], e[1]);
  }
  updatePointHandles() {
    this.points.forEach(((r, e, t) => {
      this.updateHandle.call(this, this.selection.get(e + 1), r, e, t);
    }));
  }
  updatePoints() {
    const r = this.el.parent().screenCTM().inverseO().multiplyO(this.el.screenCTM());
    this.points = this.el.array().map(((e) => vc(e, r)));
  }
  mutationHandler() {
    this.updatePoints(), this.updateSelection(), this.updatePointHandles();
  }
}) });
class tb {
  constructor(e) {
    this.el = e, e.remember("_selectHandler", this), this.selection = new sn(), this.order = ["lt", "t", "rt", "r", "rb", "b", "lb", "l", "rot"], this.mutationHandler = this.mutationHandler.bind(this);
    const t = ia();
    this.observer = new t.MutationObserver(this.mutationHandler);
  }
  init(e) {
    this.createHandle = e.createHandle || this.createHandleFn, this.createRot = e.createRot || this.createRotFn, this.updateHandle = e.updateHandle || this.updateHandleFn, this.updateRot = e.updateRot || this.updateRotFn, this.el.root().put(this.selection), this.updatePoints(), this.createSelection(), this.createResizeHandles(), this.updateResizeHandles(), this.createRotationHandle(), this.updateRotationHandle(), this.observer.observe(this.el.node, { attributes: !0 });
  }
  active(e, t) {
    if (!e) return this.selection.clear().remove(), void this.observer.disconnect();
    this.init(t);
  }
  createSelection() {
    this.selection.polygon(this.handlePoints).addClass("svg_select_shape");
  }
  updateSelection() {
    this.selection.get(0).plot(this.handlePoints);
  }
  createResizeHandles() {
    this.handlePoints.forEach(((e, t, n) => {
      const o = this.order[t];
      this.createHandle.call(this, this.selection, e, t, n, o), this.selection.get(t + 1).addClass("svg_select_handle svg_select_handle_" + o).on("mousedown.selection touchstart.selection", yc(o, this.el, this.handlePoints, t));
    }));
  }
  createHandleFn(e) {
    e.polyline();
  }
  updateHandleFn(e, t, n, o) {
    const i = o.at(n - 1), a = o[(n + 1) % o.length], s = t, c = [s[0] - i[0], s[1] - i[1]], d = [s[0] - a[0], s[1] - a[1]], u = Math.sqrt(c[0] * c[0] + c[1] * c[1]), p = Math.sqrt(d[0] * d[0] + d[1] * d[1]), h = [c[0] / u, c[1] / u], f = [d[0] / p, d[1] / p], m = [s[0] - 10 * h[0], s[1] - 10 * h[1]], g = [s[0] - 10 * f[0], s[1] - 10 * f[1]];
    e.plot([m, s, g]);
  }
  updateResizeHandles() {
    this.handlePoints.forEach(((e, t, n) => {
      const o = this.order[t];
      this.updateHandle.call(this, this.selection.get(t + 1), e, t, n, o);
    }));
  }
  createRotFn(e) {
    e.line(), e.circle(5);
  }
  getPoint(e) {
    return this.handlePoints[this.order.indexOf(e)];
  }
  getPointHandle(e) {
    return this.selection.get(this.order.indexOf(e) + 1);
  }
  updateRotFn(e, t) {
    const n = this.getPoint("t");
    e.get(0).plot(n[0], n[1], t[0], t[1]), e.get(1).center(t[0], t[1]);
  }
  createRotationHandle() {
    const e = this.selection.group().addClass("svg_select_handle_rot").on("mousedown.selection touchstart.selection", yc("rot", this.el, this.handlePoints));
    this.createRot.call(this, e);
  }
  updateRotationHandle() {
    const e = this.selection.findOne("g.svg_select_handle_rot");
    this.updateRot(e, this.rotationPoint, this.handlePoints);
  }
  updatePoints() {
    const e = this.el.bbox(), t = this.el.parent().screenCTM().inverseO().multiplyO(this.el.screenCTM());
    this.handlePoints = this.getHandlePoints(e).map(((n) => wc(n, t))), this.rotationPoint = wc(this.getRotationPoint(e), t);
  }
  getHandlePoints({ x: e, x2: t, y: n, y2: o, cx: i, cy: a } = this.el.bbox()) {
    return [[e, n], [i, n], [t, n], [t, a], [t, o], [i, o], [e, o], [e, a]];
  }
  getRotationPoint({ y: e, cx: t } = this.el.bbox()) {
    return [t, e - 20];
  }
  mutationHandler() {
    this.updatePoints(), this.updateSelection(), this.updateResizeHandles(), this.updateRotationHandle();
  }
}
const _h = (r) => function(e = !0, t = {}) {
  typeof e == "object" && (t = e, e = !0);
  let n = this.remember("_" + r.name);
  return n || (e.prototype instanceof tb ? (n = new e(this), e = !0) : n = new r(this), this.remember("_" + r.name, n)), n.active(e, t), this;
};
Le(Bt, { select: _h(tb) }), Le([Mn, En, Pn], { pointSelect: _h(class {
  constructor(r) {
    this.el = r, r.remember("_pointSelectHandler", this), this.selection = new sn(), this.order = ["lt", "t", "rt", "r", "rb", "b", "lb", "l", "rot"], this.mutationHandler = this.mutationHandler.bind(this);
    const e = ia();
    this.observer = new e.MutationObserver(this.mutationHandler);
  }
  init(r) {
    this.createHandle = r.createHandle || this.createHandleFn, this.updateHandle = r.updateHandle || this.updateHandleFn, this.el.root().put(this.selection), this.updatePoints(), this.createSelection(), this.createPointHandles(), this.updatePointHandles(), this.observer.observe(this.el.node, { attributes: !0 });
  }
  active(r, e) {
    if (!r) return this.selection.clear().remove(), void this.observer.disconnect();
    this.init(e);
  }
  createSelection() {
    this.selection.polygon(this.points).addClass("svg_select_shape_pointSelect");
  }
  updateSelection() {
    this.selection.get(0).plot(this.points);
  }
  createPointHandles() {
    this.points.forEach(((r, e, t) => {
      this.createHandle.call(this, this.selection, r, e, t), this.selection.get(e + 1).addClass("svg_select_handle_point").on("mousedown.selection touchstart.selection", yc("point", this.el, this.points, e));
    }));
  }
  createHandleFn(r) {
    r.circle(5);
  }
  updateHandleFn(r, e) {
    r.center(e[0], e[1]);
  }
  updatePointHandles() {
    this.points.forEach(((r, e, t) => {
      this.updateHandle.call(this, this.selection.get(e + 1), r, e, t);
    }));
  }
  updatePoints() {
    const r = this.el.parent().screenCTM().inverseO().multiplyO(this.el.screenCTM());
    this.points = this.el.array().map(((e) => wc(e, r)));
  }
  mutationHandler() {
    this.updatePoints(), this.updateSelection(), this.updatePointHandles();
  }
}) });
const Ra = (r) => (r.changedTouches && (r = r.changedTouches[0]), { x: r.clientX, y: r.clientY }), $h = (r) => {
  let e = 1 / 0, t = 1 / 0, n = -1 / 0, o = -1 / 0;
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    e = Math.min(e, a[0]), t = Math.min(t, a[1]), n = Math.max(n, a[0]), o = Math.max(o, a[1]);
  }
  return new St(e, t, n - e, o - t);
};
class Wh {
  constructor(e) {
    this.el = e, e.remember("_ResizeHandler", this), this.lastCoordinates = null, this.eventType = "", this.lastEvent = null, this.handleResize = this.handleResize.bind(this), this.resize = this.resize.bind(this), this.endResize = this.endResize.bind(this), this.rotate = this.rotate.bind(this), this.movePoint = this.movePoint.bind(this);
  }
  active(e, t) {
    this.preserveAspectRatio = t.preserveAspectRatio ?? !1, this.aroundCenter = t.aroundCenter ?? !1, this.grid = t.grid ?? 0, this.degree = t.degree ?? 0, this.el.off(".resize"), e && (this.el.on(["lt.resize", "rt.resize", "rb.resize", "lb.resize", "t.resize", "r.resize", "b.resize", "l.resize", "rot.resize", "point.resize"], this.handleResize), this.lastEvent && (this.eventType === "rot" ? this.rotate(this.lastEvent) : this.eventType === "point" ? this.movePoint(this.lastEvent) : this.resize(this.lastEvent)));
  }
  handleResize(e) {
    this.eventType = e.type;
    const { event: t, index: n, points: o } = e.detail, i = !t.type.indexOf("mouse");
    if (i && (t.which || t.buttons) !== 1 || this.el.dispatch("beforeresize", { event: e, handler: this }).defaultPrevented) return;
    this.box = this.el.bbox(), this.startPoint = this.el.point(Ra(t)), this.index = n, this.points = o.slice();
    const a = (i ? "mousemove" : "touchmove") + ".resize", s = (i ? "mouseup" : "touchcancel.resize touchend") + ".resize";
    e.type === "point" ? Wr(window, a, this.movePoint) : e.type === "rot" ? Wr(window, a, this.rotate) : Wr(window, a, this.resize), Wr(window, s, this.endResize);
  }
  resize(e) {
    this.lastEvent = e;
    const t = this.snapToGrid(this.el.point(Ra(e)));
    let n = t.x - this.startPoint.x, o = t.y - this.startPoint.y;
    this.preserveAspectRatio && this.aroundCenter && (n *= 2, o *= 2);
    const i = this.box.x + n, a = this.box.y + o, s = this.box.x2 + n, c = this.box.y2 + o;
    let d = new St(this.box);
    if (this.eventType.includes("l") && (d.x = Math.min(i, this.box.x2), d.x2 = Math.max(i, this.box.x2)), this.eventType.includes("r") && (d.x = Math.min(s, this.box.x), d.x2 = Math.max(s, this.box.x)), this.eventType.includes("t") && (d.y = Math.min(a, this.box.y2), d.y2 = Math.max(a, this.box.y2)), this.eventType.includes("b") && (d.y = Math.min(c, this.box.y), d.y2 = Math.max(c, this.box.y)), d.width = d.x2 - d.x, d.height = d.y2 - d.y, this.preserveAspectRatio) {
      const u = d.width / this.box.width, p = d.height / this.box.height, h = ["lt", "t", "rt", "r", "rb", "b", "lb", "l"], f = (h.indexOf(this.eventType) + 4) % h.length, m = this.aroundCenter ? [this.box.cx, this.box.cy] : this.points[f];
      let g = this.eventType.includes("t") || this.eventType.includes("b") ? p : u;
      g = this.eventType.length === 2 ? Math.max(u, p) : g, d = (function(b, x, v) {
        const y = [[b.x, b.y], [b.x + b.width, b.y], [b.x + b.width, b.y + b.height], [b.x, b.y + b.height]].map((([C, k]) => {
          const T = C - x[0], S = (k - x[1]) * v;
          return [T * v + x[0], S + x[1]];
        }));
        return $h(y);
      })(this.box, m, g);
    }
    this.el.dispatch("resize", { box: new St(d), angle: 0, eventType: this.eventType, event: e, handler: this }).defaultPrevented || this.el.size(d.width, d.height).move(d.x, d.y);
  }
  movePoint(e) {
    this.lastEvent = e;
    const { x: t, y: n } = this.snapToGrid(this.el.point(Ra(e))), o = this.el.array().slice();
    o[this.index] = [t, n], this.el.dispatch("resize", { box: $h(o), angle: 0, eventType: this.eventType, event: e, handler: this }).defaultPrevented || this.el.plot(o);
  }
  rotate(e) {
    this.lastEvent = e;
    const t = this.startPoint, n = this.el.point(Ra(e)), { cx: o, cy: i } = this.box, a = t.x - o, s = t.y - i, c = n.x - o, d = n.y - i, u = Math.sqrt(a * a + s * s) * Math.sqrt(c * c + d * d);
    if (u === 0) return;
    let p = Math.acos((a * c + s * d) / u) / Math.PI * 180;
    if (!p) return;
    n.x < t.x && (p = -p);
    const h = new Ee(this.el), { x: f, y: m } = new nt(o, i).transformO(h), { rotate: g } = h.decompose(), b = this.snapToAngle(g + p) - g;
    this.el.dispatch("resize", { box: this.box, angle: b, eventType: this.eventType, event: e, handler: this }).defaultPrevented || this.el.transform(h.rotateO(b, f, m));
  }
  endResize(e) {
    this.eventType !== "rot" && this.eventType !== "point" && this.resize(e), this.lastEvent = null, this.eventType = "", fr(window, "mousemove.resize touchmove.resize"), fr(window, "mouseup.resize touchend.resize");
  }
  snapToGrid(e) {
    return this.grid && (e.x = Math.round(e.x / this.grid) * this.grid, e.y = Math.round(e.y / this.grid) * this.grid), e;
  }
  snapToAngle(e) {
    return this.degree && (e = Math.round(e / this.degree) * this.degree), e;
  }
}
Le(Bt, { resize: function(r = !0, e = {}) {
  typeof r == "object" && (e = r, r = !0);
  let t = this.remember("_ResizeHandler");
  return t || (r.prototype instanceof Wh ? (t = new r(this), r = !0) : t = new Wh(this), this.remember("_resizeHandler", t)), t.active(r, e), this;
} }), window.SVG === void 0 && (window.SVG = AL), window.Apex === void 0 && (window.Apex = {});
var Hh = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "initModules", value: function() {
    this.ctx.publicMethods = ["updateOptions", "updateSeries", "appendData", "appendSeries", "isSeriesHidden", "highlightSeries", "toggleSeries", "showSeries", "hideSeries", "setLocale", "resetSeries", "zoomX", "toggleDataPointSelection", "dataURI", "exportToCSV", "addXaxisAnnotation", "addYaxisAnnotation", "addPointAnnotation", "clearAnnotations", "removeAnnotation", "paper", "destroy"], this.ctx.eventList = ["click", "mousedown", "mousemove", "mouseleave", "touchstart", "touchmove", "touchleave", "mouseup", "touchend"], this.ctx.animations = new Ro(this.ctx), this.ctx.axes = new DL(this.ctx), this.ctx.core = new cj(this.ctx.el, this.ctx), this.ctx.config = new Vi({}), this.ctx.data = new zd(this.ctx), this.ctx.grid = new Ym(this.ctx), this.ctx.graphics = new ee(this.ctx), this.ctx.coreUtils = new Tt(this.ctx), this.ctx.crosshairs = new bc(this.ctx), this.ctx.events = new LL(this.ctx), this.ctx.exports = new Ei(this.ctx), this.ctx.fill = new Pr(this.ctx), this.ctx.localization = new jL(this.ctx), this.ctx.options = new An(), this.ctx.responsive = new zL(this.ctx), this.ctx.series = new mr(this.ctx), this.ctx.theme = new BL(this.ctx), this.ctx.formatters = new la(this.ctx), this.ctx.titleSubtitle = new FL(this.ctx), this.ctx.legend = new Vm(this.ctx), this.ctx.toolbar = new Um(this.ctx), this.ctx.tooltip = new Dh(this.ctx), this.ctx.dimensions = new cs(this.ctx), this.ctx.updateHelpers = new dj(this.ctx), this.ctx.zoomPanSelection = new XL(this.ctx), this.ctx.w.globals.tooltip = new Dh(this.ctx);
  } }]), r;
})(), Yh = (function() {
  function r(e) {
    xe(this, r), this.ctx = e, this.w = e.w;
  }
  return ve(r, [{ key: "clear", value: function(e) {
    var t = e.isUpdating;
    this.ctx.zoomPanSelection && this.ctx.zoomPanSelection.destroy(), this.ctx.toolbar && this.ctx.toolbar.destroy(), this.ctx.animations = null, this.ctx.axes = null, this.ctx.annotations = null, this.ctx.core = null, this.ctx.data = null, this.ctx.grid = null, this.ctx.series = null, this.ctx.responsive = null, this.ctx.theme = null, this.ctx.formatters = null, this.ctx.titleSubtitle = null, this.ctx.legend = null, this.ctx.dimensions = null, this.ctx.options = null, this.ctx.crosshairs = null, this.ctx.zoomPanSelection = null, this.ctx.updateHelpers = null, this.ctx.toolbar = null, this.ctx.localization = null, this.ctx.w.globals.tooltip = null, this.clearDomElements({ isUpdating: t });
  } }, { key: "killSVG", value: function(e) {
    e.each((function() {
      this.removeClass("*"), this.off();
    }), !0), e.clear();
  } }, { key: "clearDomElements", value: function(e) {
    var t = this, n = e.isUpdating, o = this.w.globals.dom.Paper.node;
    o.parentNode && o.parentNode.parentNode && !n && (o.parentNode.parentNode.style.minHeight = "unset");
    var i = this.w.globals.dom.baseEl;
    i && this.ctx.eventList.forEach((function(s) {
      i.removeEventListener(s, t.ctx.events.documentEvent);
    }));
    var a = this.w.globals.dom;
    if (this.ctx.el !== null) for (; this.ctx.el.firstChild; ) this.ctx.el.removeChild(this.ctx.el.firstChild);
    this.killSVG(a.Paper), a.Paper.remove(), a.elWrap = null, a.elGraphical = null, a.elLegendWrap = null, a.elLegendForeign = null, a.baseEl = null, a.elGridRect = null, a.elGridRectMask = null, a.elGridRectBarMask = null, a.elGridRectMarkerMask = null, a.elForecastMask = null, a.elNonForecastMask = null, a.elDefs = null;
  } }]), r;
})(), Rl = /* @__PURE__ */ new WeakMap(), pj = (function() {
  function r(e, t) {
    xe(this, r), this.opts = t, this.ctx = this, this.w = new NL(t).init(), this.el = e, this.w.globals.cuid = $.randomId(), this.w.globals.chartID = this.w.config.chart.id ? $.escapeString(this.w.config.chart.id) : this.w.globals.cuid, new Hh(this).initModules(), this.lastUpdateOptions = null, this.create = $.bind(this.create, this), this.windowResizeHandler = this._windowResizeHandler.bind(this), this.parentResizeHandler = this._parentResizeCallback.bind(this);
  }
  return ve(r, [{ key: "render", value: function() {
    var e = this;
    return new Promise((function(t, n) {
      if ($.elementExists(e.el)) {
        Apex._chartInstances === void 0 && (Apex._chartInstances = []), e.w.config.chart.id && Apex._chartInstances.push({ id: e.w.globals.chartID, group: e.w.config.chart.group, chart: e }), e.setLocale(e.w.config.chart.defaultLocale);
        var o = e.w.config.chart.events.beforeMount;
        typeof o == "function" && o(e, e.w), e.events.fireEvent("beforeMount", [e, e.w]), window.addEventListener("resize", e.windowResizeHandler), (function(h, f) {
          var m = !1;
          if (h.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
            var g = h.getBoundingClientRect();
            h.style.display !== "none" && g.width !== 0 || (m = !0);
          }
          var b = new ResizeObserver((function(x) {
            m && f.call(h, x), m = !0;
          }));
          h.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Array.from(h.children).forEach((function(x) {
            return b.observe(x);
          })) : b.observe(h), Rl.set(f, b);
        })(e.el.parentNode, e.parentResizeHandler);
        var i = e.el.getRootNode && e.el.getRootNode(), a = $.is("ShadowRoot", i), s = e.el.ownerDocument, c = a ? i.getElementById("apexcharts-css") : s.getElementById("apexcharts-css");
        if (!c) {
          var d;
          (c = document.createElement("style")).id = "apexcharts-css", c.textContent = `@keyframes opaque {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

@keyframes resizeanim {

  0%,
  to {
    opacity: 0
  }
}

.apexcharts-canvas {
  position: relative;
  direction: ltr !important;
  user-select: none
}

.apexcharts-canvas ::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px
}

.apexcharts-canvas ::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .5);
  box-shadow: 0 0 1px rgba(255, 255, 255, .5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5)
}

.apexcharts-inner {
  position: relative
}

.apexcharts-text tspan {
  font-family: inherit
}

rect.legend-mouseover-inactive,
.legend-mouseover-inactive rect,
.legend-mouseover-inactive path,
.legend-mouseover-inactive circle,
.legend-mouseover-inactive line,
.legend-mouseover-inactive text.apexcharts-yaxis-title-text,
.legend-mouseover-inactive text.apexcharts-yaxis-label {
  transition: .15s ease all;
  opacity: .2
}

.apexcharts-legend-text {
  padding-left: 15px;
  margin-left: -15px;
}

.apexcharts-series-collapsed {
  opacity: 0
}

.apexcharts-tooltip {
  border-radius: 5px;
  box-shadow: 2px 2px 6px -4px #999;
  cursor: default;
  font-size: 14px;
  left: 62px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  z-index: 12;
  transition: .15s ease all
}

.apexcharts-tooltip.apexcharts-active {
  opacity: 1;
  transition: .15s ease all
}

.apexcharts-tooltip.apexcharts-theme-light {
  border: 1px solid #e3e3e3;
  background: rgba(255, 255, 255, .96)
}

.apexcharts-tooltip.apexcharts-theme-dark {
  color: #fff;
  background: rgba(30, 30, 30, .8)
}

.apexcharts-tooltip * {
  font-family: inherit
}

.apexcharts-tooltip-title {
  padding: 6px;
  font-size: 15px;
  margin-bottom: 4px
}

.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {
  background: #eceff1;
  border-bottom: 1px solid #ddd
}

.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {
  background: rgba(0, 0, 0, .7);
  border-bottom: 1px solid #333
}

.apexcharts-tooltip-text-goals-value,
.apexcharts-tooltip-text-y-value,
.apexcharts-tooltip-text-z-value {
  display: inline-block;
  margin-left: 5px;
  font-weight: 600
}

.apexcharts-tooltip-text-goals-label:empty,
.apexcharts-tooltip-text-goals-value:empty,
.apexcharts-tooltip-text-y-label:empty,
.apexcharts-tooltip-text-y-value:empty,
.apexcharts-tooltip-text-z-value:empty,
.apexcharts-tooltip-title:empty {
  display: none
}

.apexcharts-tooltip-text-goals-label,
.apexcharts-tooltip-text-goals-value {
  padding: 6px 0 5px
}

.apexcharts-tooltip-goals-group,
.apexcharts-tooltip-text-goals-label,
.apexcharts-tooltip-text-goals-value {
  display: flex
}

.apexcharts-tooltip-text-goals-label:not(:empty),
.apexcharts-tooltip-text-goals-value:not(:empty) {
  margin-top: -6px
}

.apexcharts-tooltip-marker {
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
  margin-right: 4px;
  text-align: center;
  vertical-align: middle;
  color: inherit;
}

.apexcharts-tooltip-marker::before {
  content: "";
  display: inline-block;
  width: 100%;
  text-align: center;
  color: currentcolor;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  font-size: 26px;
  font-family: Arial, Helvetica, sans-serif;
  line-height: 14px;
  font-weight: 900;
}

.apexcharts-tooltip-marker[shape="circle"]::before {
  content: "\\25CF";
}

.apexcharts-tooltip-marker[shape="square"]::before,
.apexcharts-tooltip-marker[shape="rect"]::before {
  content: "\\25A0";
  transform: translate(-1px, -2px);
}

.apexcharts-tooltip-marker[shape="line"]::before {
  content: "\\2500";
}

.apexcharts-tooltip-marker[shape="diamond"]::before {
  content: "\\25C6";
  font-size: 28px;
}

.apexcharts-tooltip-marker[shape="triangle"]::before {
  content: "\\25B2";
  font-size: 22px;
}

.apexcharts-tooltip-marker[shape="cross"]::before {
  content: "\\2715";
  font-size: 18px;
}

.apexcharts-tooltip-marker[shape="plus"]::before {
  content: "\\2715";
  transform: rotate(45deg) translate(-1px, -1px);
  font-size: 18px;
}

.apexcharts-tooltip-marker[shape="star"]::before {
  content: "\\2605";
  font-size: 18px;
}

.apexcharts-tooltip-marker[shape="sparkle"]::before {
  content: "\\2726";
  font-size: 20px;
}

.apexcharts-tooltip-series-group {
  padding: 0 10px;
  display: none;
  text-align: left;
  justify-content: left;
  align-items: center
}

.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {
  opacity: 1
}

.apexcharts-tooltip-series-group.apexcharts-active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 4px
}

.apexcharts-tooltip-y-group {
  padding: 6px 0 5px
}

.apexcharts-custom-tooltip,
.apexcharts-tooltip-box {
  padding: 4px 8px
}

.apexcharts-tooltip-boxPlot {
  display: flex;
  flex-direction: column-reverse
}

.apexcharts-tooltip-box>div {
  margin: 4px 0
}

.apexcharts-tooltip-box span.value {
  font-weight: 700
}

.apexcharts-tooltip-rangebar {
  padding: 5px 8px
}

.apexcharts-tooltip-rangebar .category {
  font-weight: 600;
  color: #777
}

.apexcharts-tooltip-rangebar .series-name {
  font-weight: 700;
  display: block;
  margin-bottom: 5px
}

.apexcharts-xaxistooltip,
.apexcharts-yaxistooltip {
  opacity: 0;
  pointer-events: none;
  color: #373d3f;
  font-size: 13px;
  text-align: center;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
  background: #eceff1;
  border: 1px solid #90a4ae
}

.apexcharts-xaxistooltip {
  padding: 9px 10px;
  transition: .15s ease all
}

.apexcharts-xaxistooltip.apexcharts-theme-dark {
  background: rgba(0, 0, 0, .7);
  border: 1px solid rgba(0, 0, 0, .5);
  color: #fff
}

.apexcharts-xaxistooltip:after,
.apexcharts-xaxistooltip:before {
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none
}

.apexcharts-xaxistooltip:after {
  border-color: transparent;
  border-width: 6px;
  margin-left: -6px
}

.apexcharts-xaxistooltip:before {
  border-color: transparent;
  border-width: 7px;
  margin-left: -7px
}

.apexcharts-xaxistooltip-bottom:after,
.apexcharts-xaxistooltip-bottom:before {
  bottom: 100%
}

.apexcharts-xaxistooltip-top:after,
.apexcharts-xaxistooltip-top:before {
  top: 100%
}

.apexcharts-xaxistooltip-bottom:after {
  border-bottom-color: #eceff1
}

.apexcharts-xaxistooltip-bottom:before {
  border-bottom-color: #90a4ae
}

.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after,
.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {
  border-bottom-color: rgba(0, 0, 0, .5)
}

.apexcharts-xaxistooltip-top:after {
  border-top-color: #eceff1
}

.apexcharts-xaxistooltip-top:before {
  border-top-color: #90a4ae
}

.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after,
.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {
  border-top-color: rgba(0, 0, 0, .5)
}

.apexcharts-xaxistooltip.apexcharts-active {
  opacity: 1;
  transition: .15s ease all
}

.apexcharts-yaxistooltip {
  padding: 4px 10px
}

.apexcharts-yaxistooltip.apexcharts-theme-dark {
  background: rgba(0, 0, 0, .7);
  border: 1px solid rgba(0, 0, 0, .5);
  color: #fff
}

.apexcharts-yaxistooltip:after,
.apexcharts-yaxistooltip:before {
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none
}

.apexcharts-yaxistooltip:after {
  border-color: transparent;
  border-width: 6px;
  margin-top: -6px
}

.apexcharts-yaxistooltip:before {
  border-color: transparent;
  border-width: 7px;
  margin-top: -7px
}

.apexcharts-yaxistooltip-left:after,
.apexcharts-yaxistooltip-left:before {
  left: 100%
}

.apexcharts-yaxistooltip-right:after,
.apexcharts-yaxistooltip-right:before {
  right: 100%
}

.apexcharts-yaxistooltip-left:after {
  border-left-color: #eceff1
}

.apexcharts-yaxistooltip-left:before {
  border-left-color: #90a4ae
}

.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after,
.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {
  border-left-color: rgba(0, 0, 0, .5)
}

.apexcharts-yaxistooltip-right:after {
  border-right-color: #eceff1
}

.apexcharts-yaxistooltip-right:before {
  border-right-color: #90a4ae
}

.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after,
.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {
  border-right-color: rgba(0, 0, 0, .5)
}

.apexcharts-yaxistooltip.apexcharts-active {
  opacity: 1
}

.apexcharts-yaxistooltip-hidden {
  display: none
}

.apexcharts-xcrosshairs,
.apexcharts-ycrosshairs {
  pointer-events: none;
  opacity: 0;
  transition: .15s ease all
}

.apexcharts-xcrosshairs.apexcharts-active,
.apexcharts-ycrosshairs.apexcharts-active {
  opacity: 1;
  transition: .15s ease all
}

.apexcharts-ycrosshairs-hidden {
  opacity: 0
}

.apexcharts-selection-rect {
  cursor: move
}

.svg_select_shape {
  stroke-width: 1;
  stroke-dasharray: 10 10;
  stroke: black;
  stroke-opacity: 0.1;
  pointer-events: none;
  fill: none;
}

.svg_select_handle {
  stroke-width: 3;
  stroke: black;
  fill: none;
}

.svg_select_handle_r {
  cursor: e-resize;
}

.svg_select_handle_l {
  cursor: w-resize;
}

.apexcharts-svg.apexcharts-zoomable.hovering-zoom {
  cursor: crosshair
}

.apexcharts-svg.apexcharts-zoomable.hovering-pan {
  cursor: move
}

.apexcharts-menu-icon,
.apexcharts-pan-icon,
.apexcharts-reset-icon,
.apexcharts-selection-icon,
.apexcharts-toolbar-custom-icon,
.apexcharts-zoom-icon,
.apexcharts-zoomin-icon,
.apexcharts-zoomout-icon {
  cursor: pointer;
  width: 20px;
  height: 20px;
  line-height: 24px;
  color: #6e8192;
  text-align: center
}

.apexcharts-menu-icon svg,
.apexcharts-reset-icon svg,
.apexcharts-zoom-icon svg,
.apexcharts-zoomin-icon svg,
.apexcharts-zoomout-icon svg {
  fill: #6e8192
}

.apexcharts-selection-icon svg {
  fill: #444;
  transform: scale(.76)
}

.apexcharts-theme-dark .apexcharts-menu-icon svg,
.apexcharts-theme-dark .apexcharts-pan-icon svg,
.apexcharts-theme-dark .apexcharts-reset-icon svg,
.apexcharts-theme-dark .apexcharts-selection-icon svg,
.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg,
.apexcharts-theme-dark .apexcharts-zoom-icon svg,
.apexcharts-theme-dark .apexcharts-zoomin-icon svg,
.apexcharts-theme-dark .apexcharts-zoomout-icon svg {
  fill: #f3f4f5
}

.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg,
.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,
.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {
  fill: #008ffb
}

.apexcharts-theme-light .apexcharts-menu-icon:hover svg,
.apexcharts-theme-light .apexcharts-reset-icon:hover svg,
.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,
.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,
.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,
.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {
  fill: #333
}

.apexcharts-menu-icon,
.apexcharts-selection-icon {
  position: relative
}

.apexcharts-reset-icon {
  margin-left: 5px
}

.apexcharts-menu-icon,
.apexcharts-reset-icon,
.apexcharts-zoom-icon {
  transform: scale(.85)
}

.apexcharts-zoomin-icon,
.apexcharts-zoomout-icon {
  transform: scale(.7)
}

.apexcharts-zoomout-icon {
  margin-right: 3px
}

.apexcharts-pan-icon {
  transform: scale(.62);
  position: relative;
  left: 1px;
  top: 0
}

.apexcharts-pan-icon svg {
  fill: #fff;
  stroke: #6e8192;
  stroke-width: 2
}

.apexcharts-pan-icon.apexcharts-selected svg {
  stroke: #008ffb
}

.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {
  stroke: #333
}

.apexcharts-toolbar {
  position: absolute;
  z-index: 11;
  max-width: 176px;
  text-align: right;
  border-radius: 3px;
  padding: 0 6px 2px;
  display: flex;
  justify-content: space-between;
  align-items: center
}

.apexcharts-menu {
  background: #fff;
  position: absolute;
  top: 100%;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 3px;
  right: 10px;
  opacity: 0;
  min-width: 110px;
  transition: .15s ease all;
  pointer-events: none
}

.apexcharts-menu.apexcharts-menu-open {
  opacity: 1;
  pointer-events: all;
  transition: .15s ease all
}

.apexcharts-menu-item {
  padding: 6px 7px;
  font-size: 12px;
  cursor: pointer
}

.apexcharts-theme-light .apexcharts-menu-item:hover {
  background: #eee
}

.apexcharts-theme-dark .apexcharts-menu {
  background: rgba(0, 0, 0, .7);
  color: #fff
}

@media screen and (min-width:768px) {
  .apexcharts-canvas:hover .apexcharts-toolbar {
    opacity: 1
  }
}

.apexcharts-canvas .apexcharts-element-hidden,
.apexcharts-datalabel.apexcharts-element-hidden,
.apexcharts-hide .apexcharts-series-points {
  opacity: 0;
}

.apexcharts-hidden-element-shown {
  opacity: 1;
  transition: 0.25s ease all;
}

.apexcharts-datalabel,
.apexcharts-datalabel-label,
.apexcharts-datalabel-value,
.apexcharts-datalabels,
.apexcharts-pie-label {
  cursor: default;
  pointer-events: none
}

.apexcharts-pie-label-delay {
  opacity: 0;
  animation-name: opaque;
  animation-duration: .3s;
  animation-fill-mode: forwards;
  animation-timing-function: ease
}

.apexcharts-radialbar-label {
  cursor: pointer;
}

.apexcharts-annotation-rect,
.apexcharts-area-series .apexcharts-area,
.apexcharts-gridline,
.apexcharts-line,
.apexcharts-point-annotation-label,
.apexcharts-radar-series path:not(.apexcharts-marker),
.apexcharts-radar-series polygon,
.apexcharts-toolbar svg,
.apexcharts-tooltip .apexcharts-marker,
.apexcharts-xaxis-annotation-label,
.apexcharts-yaxis-annotation-label,
.apexcharts-zoom-rect,
.no-pointer-events {
  pointer-events: none
}

.apexcharts-tooltip-active .apexcharts-marker {
  transition: .15s ease all
}

.apexcharts-radar-series .apexcharts-yaxis {
  pointer-events: none;
}

.resize-triggers {
  animation: 1ms resizeanim;
  visibility: hidden;
  opacity: 0;
  height: 100%;
  width: 100%;
  overflow: hidden
}

.contract-trigger:before,
.resize-triggers,
.resize-triggers>div {
  content: " ";
  display: block;
  position: absolute;
  top: 0;
  left: 0
}

.resize-triggers>div {
  height: 100%;
  width: 100%;
  background: #eee;
  overflow: auto
}

.contract-trigger:before {
  overflow: hidden;
  width: 200%;
  height: 200%
}

.apexcharts-bar-goals-markers {
  pointer-events: none
}

.apexcharts-bar-shadows {
  pointer-events: none
}

.apexcharts-rangebar-goals-markers {
  pointer-events: none
}

.apexcharts-disable-transitions * {
  transition: none !important;
}`;
          var u = ((d = e.opts.chart) === null || d === void 0 ? void 0 : d.nonce) || e.w.config.chart.nonce;
          u && c.setAttribute("nonce", u), a ? i.prepend(c) : e.w.config.chart.injectStyleSheet !== !1 && s.head.appendChild(c);
        }
        var p = e.create(e.w.config.series, {});
        if (!p) return t(e);
        e.mount(p).then((function() {
          typeof e.w.config.chart.events.mounted == "function" && e.w.config.chart.events.mounted(e, e.w), e.events.fireEvent("mounted", [e, e.w]), t(p);
        })).catch((function(h) {
          n(h);
        }));
      } else n(new Error("Element not found"));
    }));
  } }, { key: "create", value: function(e, t) {
    var n = this, o = this.w;
    new Hh(this).initModules();
    var i = this.w.globals;
    if (i.noData = !1, i.animationEnded = !1, !$.elementExists(this.el) || (this.responsive.checkResponsiveConfig(t), o.config.xaxis.convertedCatToNumeric && new Xi(o.config).convertCatToNumericXaxis(o.config, this.ctx), this.core.setupElements(), o.config.chart.type === "treemap" && (o.config.grid.show = !1, o.config.yaxis[0].show = !1), i.svgWidth === 0)) return i.animationEnded = !0, null;
    var a = e;
    e.forEach((function(h, f) {
      h.hidden && (a = n.legend.legendHelpers.getSeriesAfterCollapsing({ realIndex: f }));
    }));
    var s = Tt.checkComboSeries(a, o.config.chart.type);
    i.comboCharts = s.comboCharts, i.comboBarCount = s.comboBarCount;
    var c = a.every((function(h) {
      return h.data && h.data.length === 0;
    }));
    (a.length === 0 || c && i.collapsedSeries.length < 1) && this.series.handleNoData(), this.events.setupEventHandlers(), this.data.parseData(a), this.theme.init(), new Io(this).setGlobalMarkerSize(), this.formatters.setLabelFormatters(), this.titleSubtitle.draw(), i.noData && i.collapsedSeries.length !== i.series.length && !o.config.legend.showForSingleSeries || this.legend.init(), this.series.hasAllSeriesEqualX(), i.axisCharts && (this.core.coreCalculations(), o.config.xaxis.type !== "category" && this.formatters.setLabelFormatters(), this.ctx.toolbar.minX = o.globals.minX, this.ctx.toolbar.maxX = o.globals.maxX), this.formatters.heatmapLabelFormatters(), new Tt(this).getLargestMarkerSize(), this.dimensions.plotCoords();
    var d = this.core.xySettings();
    this.grid.createGridMask();
    var u = this.core.plotChartType(a, d), p = new vo(this);
    return p.bringForward(), o.config.dataLabels.background.enabled && p.dataLabelsBackground(), this.core.shiftGraphPosition(), o.globals.dataPoints > 50 && o.globals.dom.elWrap.classList.add("apexcharts-disable-transitions"), { elGraph: u, xyRatios: d, dimensions: { plot: { left: o.globals.translateX, top: o.globals.translateY, width: o.globals.gridWidth, height: o.globals.gridHeight } } };
  } }, { key: "mount", value: function() {
    var e = this, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, n = this, o = n.w;
    return new Promise((function(i, a) {
      if (n.el === null) return a(new Error("Not enough data to display or target element not found"));
      (t === null || o.globals.allSeriesCollapsed) && n.series.handleNoData(), n.grid = new Ym(n);
      var s, c, d = n.grid.drawGrid();
      if (n.annotations = new IL(n), n.annotations.drawImageAnnos(), n.annotations.drawTextAnnos(), o.config.grid.position === "back" && (d && o.globals.dom.elGraphical.add(d.el), d != null && (s = d.elGridBorders) !== null && s !== void 0 && s.node && o.globals.dom.elGraphical.add(d.elGridBorders)), Array.isArray(t.elGraph)) for (var u = 0; u < t.elGraph.length; u++) o.globals.dom.elGraphical.add(t.elGraph[u]);
      else o.globals.dom.elGraphical.add(t.elGraph);
      o.config.grid.position === "front" && (d && o.globals.dom.elGraphical.add(d.el), d != null && (c = d.elGridBorders) !== null && c !== void 0 && c.node && o.globals.dom.elGraphical.add(d.elGridBorders)), o.config.xaxis.crosshairs.position === "front" && n.crosshairs.drawXCrosshairs(), o.config.yaxis[0].crosshairs.position === "front" && n.crosshairs.drawYCrosshairs(), o.config.chart.type !== "treemap" && n.axes.drawAxis(o.config.chart.type, d);
      var p = new Ui(e.ctx, d), h = new Bd(e.ctx, d);
      if (d !== null && (p.xAxisLabelCorrections(d.xAxisTickWidth), h.setYAxisTextAlignments(), o.config.yaxis.map((function(m, g) {
        o.globals.ignoreYAxisIndexes.indexOf(g) === -1 && h.yAxisTitleRotate(g, m.opposite);
      }))), n.annotations.drawAxesAnnotations(), !o.globals.noData) {
        if (o.config.tooltip.enabled && !o.globals.noData && n.w.globals.tooltip.drawTooltip(t.xyRatios), o.globals.axisCharts && (o.globals.isXNumeric || o.config.xaxis.convertedCatToNumeric || o.globals.isRangeBar)) (o.config.chart.zoom.enabled || o.config.chart.selection && o.config.chart.selection.enabled || o.config.chart.pan && o.config.chart.pan.enabled) && n.zoomPanSelection.init({ xyRatios: t.xyRatios });
        else {
          var f = o.config.chart.toolbar.tools;
          ["zoom", "zoomin", "zoomout", "selection", "pan", "reset"].forEach((function(m) {
            f[m] = !1;
          }));
        }
        o.config.chart.toolbar.show && !o.globals.allSeriesCollapsed && n.toolbar.createToolbar();
      }
      o.globals.memory.methodsToExec.length > 0 && o.globals.memory.methodsToExec.forEach((function(m) {
        m.method(m.params, !1, m.context);
      })), o.globals.axisCharts || o.globals.noData || n.core.resizeNonAxisCharts(), i(n);
    }));
  } }, { key: "destroy", value: function() {
    window.removeEventListener("resize", this.windowResizeHandler), (function(t, n) {
      var o = Rl.get(n);
      o && (o.disconnect(), Rl.delete(n));
    })(this.el.parentNode, this.parentResizeHandler);
    var e = this.w.config.chart.id;
    e && Apex._chartInstances.forEach((function(t, n) {
      t.id === $.escapeString(e) && Apex._chartInstances.splice(n, 1);
    })), new Yh(this.ctx).clear({ isUpdating: !1 });
  } }, { key: "updateOptions", value: function(e) {
    var t = this, n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], o = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], i = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3], a = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4], s = this.w;
    return s.globals.selection = void 0, this.lastUpdateOptions && JSON.stringify(this.lastUpdateOptions) === JSON.stringify(e) ? this : (e.series && (this.data.resetParsingFlags(), this.series.resetSeries(!1, !0, !1), e.series.length && e.series[0].data && (e.series = e.series.map((function(c, d) {
      return t.updateHelpers._extendSeries(c, d);
    }))), this.updateHelpers.revertDefaultAxisMinMax()), e.xaxis && (e = this.updateHelpers.forceXAxisUpdate(e)), e.yaxis && (e = this.updateHelpers.forceYAxisUpdate(e)), s.globals.collapsedSeriesIndices.length > 0 && this.series.clearPreviousPaths(), e.theme && (e = this.theme.updateThemeOptions(e)), this.updateHelpers._updateOptions(e, n, o, i, a));
  } }, { key: "updateSeries", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], n = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
    return this.data.resetParsingFlags(), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(e, t, n);
  } }, { key: "appendSeries", value: function(e) {
    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], n = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2];
    this.data.resetParsingFlags();
    var o = this.w.config.series.slice();
    return o.push(e), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(o, t, n);
  } }, { key: "appendData", value: function(e) {
    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], n = this;
    n.data.resetParsingFlags(), n.w.globals.dataChanged = !0, n.series.getPreviousPaths();
    for (var o = n.w.config.series.slice(), i = 0; i < o.length; i++) if (e[i] !== null && e[i] !== void 0) for (var a = 0; a < e[i].data.length; a++) o[i].data.push(e[i].data[a]);
    return n.w.config.series = o, t && (n.w.globals.initialSeries = $.clone(n.w.config.series)), this.update();
  } }, { key: "update", value: function(e) {
    var t = this;
    return new Promise((function(n, o) {
      if (t.lastUpdateOptions && JSON.stringify(t.lastUpdateOptions) === JSON.stringify(e)) return n(t);
      t.lastUpdateOptions = $.clone(e), new Yh(t.ctx).clear({ isUpdating: !0 });
      var i = t.create(t.w.config.series, e);
      if (!i) return n(t);
      t.mount(i).then((function() {
        typeof t.w.config.chart.events.updated == "function" && t.w.config.chart.events.updated(t, t.w), t.events.fireEvent("updated", [t, t.w]), t.w.globals.isDirty = !0, n(t);
      })).catch((function(a) {
        o(a);
      }));
    }));
  } }, { key: "getSyncedCharts", value: function() {
    var e = this.getGroupedCharts(), t = [this];
    return e.length && (t = [], e.forEach((function(n) {
      t.push(n);
    }))), t;
  } }, { key: "getGroupedCharts", value: function() {
    var e = this;
    return Apex._chartInstances.filter((function(t) {
      if (t.group) return !0;
    })).map((function(t) {
      return e.w.config.chart.group === t.group ? t.chart : e;
    }));
  } }, { key: "toggleSeries", value: function(e) {
    return this.series.toggleSeries(e);
  } }, { key: "highlightSeriesOnLegendHover", value: function(e, t) {
    return this.series.toggleSeriesOnHover(e, t);
  } }, { key: "showSeries", value: function(e) {
    this.series.showSeries(e);
  } }, { key: "hideSeries", value: function(e) {
    this.series.hideSeries(e);
  } }, { key: "highlightSeries", value: function(e) {
    this.series.highlightSeries(e);
  } }, { key: "isSeriesHidden", value: function(e) {
    this.series.isSeriesHidden(e);
  } }, { key: "resetSeries", value: function() {
    var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0], t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
    this.series.resetSeries(e, t);
  } }, { key: "addEventListener", value: function(e, t) {
    this.events.addEventListener(e, t);
  } }, { key: "removeEventListener", value: function(e, t) {
    this.events.removeEventListener(e, t);
  } }, { key: "addXaxisAnnotation", value: function(e) {
    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, o = this;
    n && (o = n), o.annotations.addXaxisAnnotationExternal(e, t, o);
  } }, { key: "addYaxisAnnotation", value: function(e) {
    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, o = this;
    n && (o = n), o.annotations.addYaxisAnnotationExternal(e, t, o);
  } }, { key: "addPointAnnotation", value: function(e) {
    var t = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, o = this;
    n && (o = n), o.annotations.addPointAnnotationExternal(e, t, o);
  } }, { key: "clearAnnotations", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0, t = this;
    e && (t = e), t.annotations.clearAnnotations(t);
  } }, { key: "removeAnnotation", value: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0, n = this;
    t && (n = t), n.annotations.removeAnnotation(n, e);
  } }, { key: "getChartArea", value: function() {
    return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner");
  } }, { key: "getSeriesTotalXRange", value: function(e, t) {
    return this.coreUtils.getSeriesTotalsXRange(e, t);
  } }, { key: "getHighestValueInSeries", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new mc(this.ctx).getMinYMaxY(e).highestY;
  } }, { key: "getLowestValueInSeries", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new mc(this.ctx).getMinYMaxY(e).lowestY;
  } }, { key: "getSeriesTotal", value: function() {
    return this.w.globals.seriesTotals;
  } }, { key: "toggleDataPointSelection", value: function(e, t) {
    return this.updateHelpers.toggleDataPointSelection(e, t);
  } }, { key: "zoomX", value: function(e, t) {
    this.ctx.toolbar.zoomUpdateOptions(e, t);
  } }, { key: "setLocale", value: function(e) {
    this.localization.setCurrentLocaleValues(e);
  } }, { key: "dataURI", value: function(e) {
    return new Ei(this.ctx).dataURI(e);
  } }, { key: "getSvgString", value: function(e) {
    return new Ei(this.ctx).getSvgString(e);
  } }, { key: "exportToCSV", value: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return new Ei(this.ctx).exportToCSV(e);
  } }, { key: "paper", value: function() {
    return this.w.globals.dom.Paper;
  } }, { key: "_parentResizeCallback", value: function() {
    this.w.globals.animationEnded && this.w.config.chart.redrawOnParentResize && this._windowResize();
  } }, { key: "_windowResize", value: function() {
    var e = this;
    clearTimeout(this.w.globals.resizeTimer), this.w.globals.resizeTimer = window.setTimeout((function() {
      e.w.globals.resized = !0, e.w.globals.dataChanged = !1, e.ctx.update();
    }), 150);
  } }, { key: "_windowResizeHandler", value: function() {
    var e = this.w.config.chart.redrawOnWindowResize;
    typeof e == "function" && (e = e()), e && this._windowResize();
  } }], [{ key: "getChartByID", value: function(e) {
    var t = $.escapeString(e);
    if (Apex._chartInstances) {
      var n = Apex._chartInstances.filter((function(o) {
        return o.id === t;
      }))[0];
      return n && n.chart;
    }
  } }, { key: "initOnLoad", value: function() {
    for (var e = document.querySelectorAll("[data-apexcharts]"), t = 0; t < e.length; t++)
      new r(e[t], JSON.parse(e[t].getAttribute("data-options"))).render();
  } }, { key: "exec", value: function(e, t) {
    var n = this.getChartByID(e);
    if (n) {
      n.w.globals.isExecCalled = !0;
      var o = null;
      if (n.publicMethods.indexOf(t) !== -1) {
        for (var i = arguments.length, a = new Array(i > 2 ? i - 2 : 0), s = 2; s < i; s++) a[s - 2] = arguments[s];
        o = n[t].apply(n, a);
      }
      return o;
    }
  } }, { key: "merge", value: function(e, t) {
    return $.extend(e, t);
  } }, { key: "getThemePalettes", value: function() {
    return { palette1: ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0"], palette2: ["#3F51B5", "#03A9F4", "#4CAF50", "#F9CE1D", "#FF9800"], palette3: ["#33B2DF", "#546E7A", "#D4526E", "#13D8AA", "#A5978B"], palette4: ["#4ECDC4", "#C7F464", "#81D4FA", "#FD6A6A", "#546E7A"], palette5: ["#2B908F", "#F9A3A4", "#90EE7E", "#FA4443", "#69D2E7"], palette6: ["#449DD1", "#F86624", "#EA3546", "#662E9B", "#C5D86D"], palette7: ["#D7263D", "#1B998B", "#2E294E", "#F46036", "#E2C044"], palette8: ["#662E9B", "#F86624", "#F9C80E", "#EA3546", "#43BCCD"], palette9: ["#5C4742", "#A5978B", "#8D5B4C", "#5A2A27", "#C4BBAF"], palette10: ["#A300D6", "#7D02EB", "#5653FE", "#2983FF", "#00B1F2"] };
  } }]), r;
})();
function hj(r, e, t) {
  return (e = (function(n) {
    var o = (function(i, a) {
      if (typeof i != "object" || !i) return i;
      var s = i[Symbol.toPrimitive];
      if (s !== void 0) {
        var c = s.call(i, a);
        if (typeof c != "object") return c;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (a === "string" ? String : Number)(i);
    })(n, "string");
    return typeof o == "symbol" ? o : o + "";
  })(e)) in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
function Cc() {
  return Cc = Object.assign ? Object.assign.bind() : function(r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }, Cc.apply(null, arguments);
}
function Xh(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter((function(o) {
      return Object.getOwnPropertyDescriptor(r, o).enumerable;
    }))), t.push.apply(t, n);
  }
  return t;
}
function rb(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Xh(Object(t), !0).forEach((function(n) {
      hj(r, n, t[n]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Xh(Object(t)).forEach((function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    }));
  }
  return r;
}
function Gi(r) {
  return Gi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Gi(r);
}
var fj = ["type", "width", "height", "series", "options", "chartRef"];
function Pl(r) {
  return r && Gi(r) === "object" && !Array.isArray(r);
}
function nb(r, e) {
  var t = rb({}, r);
  return Pl(r) && Pl(e) && Object.keys(e).forEach((function(n) {
    Pl(e[n]) ? t[n] = n in r ? nb(r[n], e[n]) : e[n] : t[n] = e[n];
  })), t;
}
function kc(r, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new WeakSet();
  if (r === e) return !0;
  if (Gi(r) !== "object" || r === null || Gi(e) !== "object" || e === null) return !1;
  if (t.has(r) || t.has(e)) return !0;
  t.add(r), t.add(e);
  var n = Object.keys(r), o = Object.keys(e);
  if (n.length !== o.length) return !1;
  for (var i = 0, a = n; i < a.length; i++) {
    var s = a[i];
    if (!o.includes(s) || !kc(r[s], e[s], t)) return !1;
  }
  return !0;
}
var gj = ["type", "series", "options", "width", "height", "chartRef"];
function ob(r) {
  var e = r.type, t = e === void 0 ? "line" : e, n = r.width, o = n === void 0 ? "100%" : n, i = r.height, a = i === void 0 ? "auto" : i, s = r.series, c = r.options, d = r.chartRef, u = (function(y, C) {
    if (y == null) return {};
    var k, T, S = (function(P, M) {
      if (P == null) return {};
      var I = {};
      for (var E in P) if ({}.hasOwnProperty.call(P, E)) {
        if (M.includes(E)) continue;
        I[E] = P[E];
      }
      return I;
    })(y, C);
    if (Object.getOwnPropertySymbols) {
      var O = Object.getOwnPropertySymbols(y);
      for (T = 0; T < O.length; T++) k = O[T], C.includes(k) || {}.propertyIsEnumerable.call(y, k) && (S[k] = y[k]);
    }
    return S;
  })(r, fj), p = Ea(null), h = Ea(null), f = Ea(null), m = d || f, g = function() {
    return nb(c, { chart: { type: t, height: a, width: o }, series: s });
  };
  $a((function() {
    return m.current = new pj(p.current, g()), m.current.render(), h.current = c, function() {
      m.current && typeof m.current.destroy == "function" && m.current.destroy();
    };
  }), []), $a((function() {
    if (m.current && m.current.w) {
      var y = !kc(m.current.w.config.series, s), C = !kc(h.current, c) || a !== m.current.opts.chart.height || o !== m.current.opts.chart.width;
      (y || C) && (y ? C ? m.current.updateOptions(g()) : m.current.updateSeries(s) : m.current.updateOptions(g())), h.current = c;
    }
  }), [c, s, a, o]);
  var b, x, v = (b = gj, x = rb({}, u), b.forEach((function(y) {
    delete x[y];
  })), x);
  return hr.createElement("div", Cc({ ref: p }, v));
}
ob.propTypes = { type: l.string.isRequired, series: l.array.isRequired, options: l.object.isRequired, width: l.oneOfType([l.string, l.number]), height: l.oneOfType([l.string, l.number]), chartRef: l.shape({ current: l.any }) };
const Kj = ({
  percentage: r,
  getLabel: e = (n) => `${n}`,
  height: t = 140
}) => {
  const o = {
    chart: {
      type: "radialBar"
    },
    plotOptions: {
      radialBar: {
        startAngle: 0,
        endAngle: 360,
        hollow: {
          margin: 0,
          size: "50%",
          background: "#fff",
          image: void 0,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front"
        },
        track: {
          background: "rgba(0, 0, 0, 0.10)",
          strokeWidth: "100%",
          margin: 0
        },
        dataLabels: {
          show: !0,
          name: { show: !1 },
          value: {
            offsetY: 5,
            formatter: (i) => i <= 40 ? "Low" : e(i),
            color: yi.palette.grey[900],
            fontSize: "14px",
            fontWeight: 600,
            show: !0
          }
        }
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        colorStops: [
          { opacity: 1, offset: 20, color: "#4CCFB1" },
          { opacity: 1, offset: 100, color: "#DD2B7C" }
        ],
        inverseColors: !0,
        opacityFrom: 1,
        opacityTo: 1
      }
    },
    stroke: {
      lineCap: "round"
    },
    labels: []
  };
  return /* @__PURE__ */ w.jsx(
    ob,
    {
      options: o,
      series: [r],
      className: "pie-wrapper",
      type: "radialBar",
      height: t
    }
  );
};
function Zj(r, e) {
  return je(r, e);
}
export {
  Dj as Accordion,
  Gj as Alert,
  sy as AppBar,
  Sw as Avatar,
  Ep as Badge,
  Cj as BadgedTitle,
  kj as Block,
  zj as BlockCard,
  Tr as BlockType,
  Vp as BlocksView,
  at as Box,
  Jw as Breadcrumbs,
  Vr as Button,
  Xg as Card,
  g1 as CardActionArea,
  y1 as CardContent,
  R1 as CardHeader,
  j1 as CardMedia,
  Pj as Checkbox,
  Yg as Chip,
  Mj as ChipWithInput,
  iC as CircularProgress,
  Bi as ClickAwayListener,
  jc as Collapse,
  Sj as CollapsibleTable,
  sC as Container,
  Ej as CreatableDropDown,
  uC as CssBaseline,
  Ij as DateRangePicker,
  jI as DateRangePickerComponent,
  FC as Dialog,
  YC as DialogActions,
  ZC as DialogContent,
  tk as DialogTitle,
  qc as Divider,
  bk as Drawer,
  Xj as EditableButton,
  Vc as Fade,
  Nj as FocusedInput,
  Ch as FormBlocksView,
  Xf as FormControlLabel,
  Hj as FormError,
  Vf as FormGroup,
  Vj as FormInOutBlock,
  WE as GotoIcon,
  it as Grid,
  _i as Grow,
  Fj as Header,
  jt as IconButton,
  Oj as InOutBlock,
  wd as InfoIcon,
  Aj as InfoTooltip,
  Qc as Input,
  ed as InputLabel,
  HI as Label,
  RS as LinearProgress,
  DS as Link,
  rd as List,
  Zf as ListItem,
  id as Menu,
  mo as MenuItem,
  eg as MenuList,
  Yj as MoreVertMenu,
  ff as MuiAccordion,
  gf as MuiAccordionDetails,
  xf as MuiAccordionSummary,
  yf as MuiAlert,
  wf as MuiAlertTitle,
  zw as MuiBadge,
  c1 as MuiCard,
  _f as MuiCheckbox,
  od as MuiPopover,
  ud as MuiTable,
  Uj as Pagination,
  Wt as Paper,
  Kj as PieIndicator,
  Bj as Popover,
  Ji as Popper,
  lA as Radio,
  pA as RadioGroup,
  Wj as RightSidebar,
  Lj as SearchBoxWithOptions,
  XI as SearchInput,
  KI as Select,
  uh as SelectItem,
  IA as Skeleton,
  Wf as Slide,
  Zc as Stack,
  eD as StyledEngineProvider,
  UA as Switch,
  JA as Tab,
  _j as TabButton,
  vR as TabContext,
  wR as TabList,
  AR as TabPanel,
  Rj as Table,
  pd as TableBody,
  Fn as TableCell,
  hd as TableContainer,
  fd as TableHead,
  mg as TablePagination,
  xo as TableRow,
  eR as TableSortLabel,
  vg as Tabs,
  jj as TagsInput,
  fh as TextEditor,
  Is as TextInput,
  zx as ThemeProvider,
  qj as ToggleButton,
  $j as ToolButton,
  pg as Toolbar,
  Es as Tooltip,
  Zg as TrashIcon,
  cm as TrashIconButton,
  We as Typography,
  Xb as alpha,
  wj as createStyles,
  Zj as makeStyles,
  H as styled,
  yi as theme,
  yE as useColorStyles,
  Tj as useFontStyles,
  wE as useLayoutStyles,
  $b as useMediaQuery,
  yr as useTheme,
  $g as withStyles
};
//# sourceMappingURL=botco-library.js.map
